(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("three"));
	else if(typeof define === 'function' && define.amd)
		define("OldSchoolSDK", ["three"], factory);
	else if(typeof exports === 'object')
		exports["OldSchoolSDK"] = factory(require("three"));
	else
		root["OldSchoolSDK"] = factory(root["three"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9604__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 9252:
/***/ ((module) => {

module.exports = function chebyshev(a, b) {
  var farthest = 0
  var dimensions = Math.max(a.length, b.length)
  for (var i = 0; i < dimensions; i++) {
    var distance = Math.abs((b[i] || 0) - (a[i] || 0))
    if (distance > farthest) {
      farthest = distance
    }
  }
  return farthest
}


/***/ }),

/***/ 6799:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

const validators_1 = __webpack_require__(6049);
function componentToHex(c) {
    const hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}
function rgbaToHex(color) {
    const r = Math.floor(color.r * color.a);
    const g = Math.floor(color.g * color.a);
    const b = Math.floor(color.b * color.a);
    return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
}
class Color {
    constructor(r, g, b, a = 1) {
        validators_1.validateAlphaValue(a);
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    toRGBString() {
        return `rgb(${Math.floor(this.r * this.a)},${Math.floor(this.g * this.a)},${Math.floor(this.b * this.a)})`;
    }
    toRGBAString() {
        return `rgba(${this.r},${this.g},${this.b},${this.a})`;
    }
    toHexString() {
        return rgbaToHex(this);
    }
}
module.exports = Color;


/***/ }),

/***/ 349:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

const Color = __webpack_require__(6799);
const validators_1 = __webpack_require__(6049);
function hexToRgb(hex, alpha) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result) {
        return new Color(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16), alpha);
    }
    else {
        throw new Error(`${hex} is not a valid hex value.`);
    }
}
class ColorScale {
    constructor(min, max, colorStops, alpha = 1) {
        validators_1.validateMinMaxValues(min, max);
        validators_1.validateColorStops(colorStops);
        validators_1.validateAlphaValue(alpha);
        this.min = min;
        this.max = max;
        this.alpha = alpha;
        this.colorStops = colorStops.map((colorStop) => hexToRgb(colorStop, alpha));
    }
    getColor(value) {
        const numOfColorStops = this.colorStops.length;
        if (value < this.min)
            return this.colorStops[0];
        if (value > this.max)
            return this.colorStops[numOfColorStops - 1];
        const range = this.max - this.min;
        let weight = (value - this.min) / range;
        const colorStopIndex = Math.max(Math.ceil(weight * (numOfColorStops - 1)), 1);
        const minColor = this.colorStops[colorStopIndex - 1];
        const maxColor = this.colorStops[colorStopIndex];
        weight = weight * (numOfColorStops - 1) - (colorStopIndex - 1);
        const r = Math.floor(weight * maxColor.r + (1 - weight) * minColor.r);
        const g = Math.floor(weight * maxColor.g + (1 - weight) * minColor.g);
        const b = Math.floor(weight * maxColor.b + (1 - weight) * minColor.b);
        return new Color(r, g, b, this.alpha);
    }
}
module.exports = ColorScale;


/***/ }),

/***/ 5416:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

const ColorScale = __webpack_require__(349);
module.exports = ColorScale;


/***/ }),

/***/ 6049:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateAlphaValue = exports.validateColorStops = exports.validateMinMaxValues = void 0;
function validateMinMaxValues(min, max) {
    if (min === max) {
        throw new Error('The minimum value cannot be equal to the maximum value.');
    }
    else if (min > max) {
        throw new Error('The minimum value must be less than the maximum value.');
    }
}
exports.validateMinMaxValues = validateMinMaxValues;
function validateColorStops(colorStops) {
    if (colorStops.length < 2) {
        throw new Error('At least two colors must be provided.');
    }
}
exports.validateColorStops = validateColorStops;
function validateAlphaValue(alpha) {
    if (alpha < 0 || alpha > 1) {
        throw new Error('The alpha value must be between 0 and 1.');
    }
}
exports.validateAlphaValue = validateAlphaValue;


/***/ }),

/***/ 2543:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 4655:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ew: () => (/* binding */ SEMANTIC_POSE_MAP),
/* harmony export */   fc: () => (/* binding */ CACHE_ASSETS),
/* harmony export */   ke: () => (/* binding */ CACHE_SOUND_EFFECT_IDS)
/* harmony export */ });
var CACHE_ASSETS = {
    npcs: {},
    regions: {},
    models: {},
    spotAnims: {
        scytheNorth: { id: 506 },
        scytheEast: { id: 1172 },
        scytheSouth: { id: 478 },
        scytheWest: { id: 1231 },
        tumekensShadowProjectile: { id: 2126 },
        tumekensShadowAttack: { id: 2125 },
        venatorBowProjectile: { id: 2291 },
        venatorBowAttack: { id: 2289 },
        venatorBowRicochetProjectile: { id: 2007 },
    },
    playerAnimations: {
        idle: { id: 808 },
        walk: { id: 819 },
        run: { id: 824 },
        walkBack: { id: 820 },
        strafeLeft: { id: 822 },
        strafeRight: { id: 821 },
        fireBow: { id: 426 },
        fireBlowpipe: { id: 5061 },
        throwChinchompa: { id: 7618 },
        scytheIdle: { id: 8057 },
        scytheSwing: { id: 8056 },
        swordSlash: { id: 390 },
        eat: { id: 829 },
        dying: { id: 836 },
        castSpell: { id: 711 },
        dragonClawsAttack: { id: 7514 },
        tumekensShadowIdle: { id: 9494 },
        tumekensShadowWalk: { id: 1703 },
        tumekensShadowRun: { id: 1707 },
        tumekensShadowAttack: { id: 9493 },
        godswordIdle: { id: 7053 },
        godswordWalk: { id: 7052 },
        godswordRun: { id: 7043 },
        godswordSlash: { id: 7045 },
        saradominGodswordSpecial: { id: 7640 },
        venatorBowIdle: { id: 9857 },
        venatorBowWalk: { id: 9859 },
        venatorBowRun: { id: 9860 },
        venatorBowAttack: { id: 9858 },
        zombieAxeSlash: { id: 7004 },
        zombieAxeCrush: { id: 3852 },
    },
    items: {
        saradominGodsword: { id: 11806 },
        fireCape: { id: 6570 },
        blueMoonHelm: { id: 29019 },
        blueMoonChestplate: { id: 29013 },
        blueMoonTassets: { id: 29016 },
        eternalBoots: { id: 13235 },
        amuletOfBloodFury: { id: 24780 },
        radasBlessing4: { id: 22947 },
        blueMoonSpear: { id: 28988 },
        rangingPotion: { id: 2444 },
        prayerRegenerationPotion: { id: 30125 },
        ahrimsRobeTop: { id: 4712 },
        ahrimsRobeSkirt: { id: 4714 },
        amuletOfFury: { id: 6585 },
        amuletOfRancour: { id: 29801 },
        ancestralRobeBottom: { id: 21024 },
        ancestralRobeTop: { id: 21021 },
        ancientStaff: { id: 4675 },
        armadylBrew: { id: 31650 },
        araneaBoots: { id: 29806 },
        armadylChainskirt: { id: 11830 },
        armadylChestplate: { id: 11828 },
        avasAccumulator: { id: 10499 },
        avasAssembler: { id: 22109 },
        barrowsGloves: { id: 7462 },
        bastionPotion: { id: 22461 },
        blackDhideBody: { id: 2503 },
        blackDhideChaps: { id: 2497 },
        blackDhideVambraces: { id: 2491 },
        crystalBody: { id: 23975 },
        crystalHelm: { id: 23971 },
        crystalLegs: { id: 23979 },
        crystalShield: { id: 23991 },
        dagonhaiRobeTop: { id: 24291 },
        devoutBoots: { id: 22954 },
        diamondBoltsE: { id: 9243 },
        dizanasQuiver: { id: 28951 },
        dragonDefender: { id: 12954 },
        guthixRobeTop: { id: 10462 },
        holyBlessing: { id: 20220 },
        justiciarChestguard: { id: 22327 },
        justiciarFaceguard: { id: 22326 },
        justiciarLegguards: { id: 22328 },
        magesBook: { id: 6889 },
        masoriBodyF: { id: 27238 },
        masoriChapsF: { id: 27241 },
        masoriMaskF: { id: 27235 },
        necklaceOfAnguish: { id: 19547 },
        necklaceOfRupture: { id: 19547 },
        occultNecklace: { id: 12002 },
        pegasianBoots: { id: 13237 },
        rangerBoots: { id: 2577 },
        berserkerRingI: { id: 11773 },
        ringOfEndurance: { id: 24736 },
        venatorRing: { id: 28310 },
        ringOfSufferingI: { id: 19710 },
        robinHoodHat: { id: 2581 },
        rubyBoltsE: { id: 9242 },
        runeCrossbow: { id: 9185 },
        runeKiteshield: { id: 1201 },
        saradominCoif: { id: 10390 },
        saradominDhideBody: { id: 10386 },
        saradominDhideBoots: { id: 19933 },
        saradominChaps: { id: 10388 },
        slayerHelmetI: { id: 11865 },
        zaryteVambraces: { id: 26235 },
        abyssalTentacle: { id: 12006 },
        kodaiWand: { id: 21006 },
        torvaFullHelm: { id: 26382 },
        amuletOfTorture: { id: 19553 },
        infernalCape: { id: 21295 },
        torvaPlatebody: { id: 26384 },
        torvaPlatelegs: { id: 26386 },
        primordialBoots: { id: 13239 },
        ferociousGloves: { id: 22981 },
        ultorRing: { id: 25485 },
        dragonArrows: { id: 11212 },
        seekingDragonArrows: { id: 11212 },
        scytheOfVitur: { id: 22325 },
        twistedBow: { id: 20997 },
        toxicBlowpipe: { id: 12926 },
        blackChinchompa: { id: 11959 },
        bowOfFaerdhinen: { id: 25865 },
        noxiousHalberd: { id: 29796 },
        zombieAxe: { id: 28810 },
        bladeOfSaeldor: { id: 23995 },
        dragonClaws: { id: 13652 },
        avernicDefender: { id: 22322 },
        avernicTreadsMax: { id: 31097 },
        oathplateHelm: { id: 30750 },
        oathplateChest: { id: 30753 },
        oathplateLegs: { id: 30756 },
        saradominBrew: { id: 6685 },
        staminaPotion: { id: 12625 },
        superCombatPotion: { id: 12695 },
        superRestore: { id: 3024 },
        eyeOfAyak: { id: 31113 },
        conflictionGauntlets: { id: 31106 },
        tumekensShadow: { id: 27275 },
        venatorBow: { id: 27612 },
    },
    objects: {},
    sounds: {
        equipBackpack: { id: 3284 },
        equipAxe: { id: 2229 },
        equipElementalStaff: { id: 2230 },
        equipBanner: { id: 2231 },
        equipBattleaxe: { id: 2232 },
        equipBlunt: { id: 2233 },
        equipBody: { id: 2234 },
        equipBolt: { id: 2235 },
        equipHands: { id: 2236 },
        equipFeet: { id: 2237 },
        equipFun: { id: 2238 },
        equipMetalBody: { id: 2239 },
        equipHelmet: { id: 2240 },
        equipLeather: { id: 2241 },
        equipLegs: { id: 2242 },
        equipMetalLegs: { id: 2243 },
        equipRanged: { id: 2244 },
        equipShield: { id: 2245 },
        equipSpiked: { id: 2246 },
        equipStaff: { id: 2247 },
        equipSword: { id: 2248 },
        equipWhip: { id: 2249 },
        equipWood: { id: 2250 },
        bloodBarrageImpact: { id: 102 },
        bloodBarrageCast: { id: 106 },
        iceBarrageImpact: { id: 168 },
        iceBarrageCast: { id: 171 },
        chinchompaImpact: { id: 360 },
        blowpipeSpecial: { id: 800 },
        bowOfFaerdhinenAttack: { id: 1352 },
        meleeAttack: { id: 2524 },
        baxeCrush: { id: 2497 },
        blowpipeAttack: { id: 2696 },
        twistedBowAttack: { id: 2702 },
        chinchompaAttack: { id: 2706 },
        dragonClawsSpecialFirst: { id: 4138 },
        dragonClawsAttack: { id: 4139 },
        dragonClawsSpecialSecond: { id: 4140 },
        dragonClawsSpecialThird: { id: 4141 },
        prayerDeactivated: { id: 2663 },
        piety: { id: 3825 },
        rigour: { id: 2685 },
        augury: { id: 2670 },
        tumekensShadowAttack: { id: 6410 },
        venatorBowAttack: { id: 6797 },
        venatorBowRicochetFirst: { id: 6672 },
        venatorBowRicochetSecond: { id: 6735 },
    },
};
var CACHE_SOUND_EFFECT_IDS = Object.values(CACHE_ASSETS.sounds).map(function (_a) {
    var id = _a.id;
    return id;
});
/** Map the internal PlayerAnimationIndices values to cache animation entries. */
var SEMANTIC_POSE_MAP = {
    0: CACHE_ASSETS.playerAnimations.idle,
    1: CACHE_ASSETS.playerAnimations.walk,
    2: CACHE_ASSETS.playerAnimations.run,
    3: CACHE_ASSETS.playerAnimations.walkBack,
    4: CACHE_ASSETS.playerAnimations.strafeLeft,
    5: CACHE_ASSETS.playerAnimations.strafeRight,
    6: CACHE_ASSETS.playerAnimations.fireBow,
    7: CACHE_ASSETS.playerAnimations.fireBlowpipe,
    8: CACHE_ASSETS.playerAnimations.throwChinchompa,
    9: CACHE_ASSETS.playerAnimations.scytheIdle,
    10: CACHE_ASSETS.playerAnimations.scytheSwing,
    11: CACHE_ASSETS.playerAnimations.swordSlash,
    12: CACHE_ASSETS.playerAnimations.eat,
    13: CACHE_ASSETS.playerAnimations.dying,
    14: CACHE_ASSETS.playerAnimations.castSpell,
    15: CACHE_ASSETS.playerAnimations.dragonClawsAttack,
    16: CACHE_ASSETS.playerAnimations.tumekensShadowIdle,
    17: CACHE_ASSETS.playerAnimations.tumekensShadowWalk,
    18: CACHE_ASSETS.playerAnimations.tumekensShadowRun,
    19: CACHE_ASSETS.playerAnimations.tumekensShadowAttack,
    20: CACHE_ASSETS.playerAnimations.venatorBowIdle,
    21: CACHE_ASSETS.playerAnimations.venatorBowWalk,
    22: CACHE_ASSETS.playerAnimations.venatorBowRun,
    23: CACHE_ASSETS.playerAnimations.venatorBowAttack,
    24: CACHE_ASSETS.playerAnimations.zombieAxeSlash,
    25: CACHE_ASSETS.playerAnimations.zombieAxeCrush,
};


/***/ }),

/***/ 3648:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  O0: () => (/* reexport */ CACHE_RENDER_BUNDLE_SCHEMA_VERSION),
  Pm: () => (/* reexport */ CACHE_RENDER_PAYLOAD_MAGIC),
  o1: () => (/* reexport */ CACHE_RENDER_PAYLOAD_VERSION),
  QR: () => (/* reexport */ crc32),
  Yt: () => (/* reexport */ isCacheRenderBundleManifest)
});

;// CONCATENATED MODULE: ./src/cache-render-format/manifest.ts
/** Browser- and Node-neutral contract for a compiled cache-render bundle. */
var CACHE_RENDER_BUNDLE_SCHEMA_VERSION = 3;
/** Structural validation shared by the asset writer and browser loader. */
function isCacheRenderBundleManifest(value) {
    if (!value || value.schemaVersion !== CACHE_RENDER_BUNDLE_SCHEMA_VERSION || typeof value.bundleVersion !== "string" ||
        !value.cache || typeof value.cache.revision !== "number" || typeof value.cache.source !== "string" ||
        typeof value.cache.contentHash !== "string" || !value.assets || !value.references)
        return false;
    if (Object.values(value.assets).some(function (asset) { return !asset || typeof asset.file !== "string" || !/^[a-f0-9]{8}$/i.test(asset.crc32); }))
        return false;
    if (value.soundEffects !== undefined && (!value.soundEffects || typeof value.soundEffects.file !== "string" || !/^[a-f0-9]{8}$/i.test(value.soundEffects.crc32)))
        return false;
    if (value.spotAnims !== undefined && (!value.spotAnims || typeof value.spotAnims !== "object" || Object.values(value.spotAnims).some(function (id) { return typeof id !== "string"; })))
        return false;
    if (value.sharedAssets !== undefined && (!value.sharedAssets || typeof value.sharedAssets !== "object" || (value.sharedAssets.playerAnimations !== undefined && typeof value.sharedAssets.playerAnimations !== "string")))
        return false;
    return value.scenes === undefined || (typeof value.scenes === "object" && Object.values(value.scenes).every(function (scene) {
        var _a;
        return scene && Number.isInteger(scene.regionId) && (scene.placements === undefined || Array.isArray(scene.placements)) && scene.compiledAssets && typeof scene.compiledAssets === "object" &&
            (scene.compiledAssets.terrain === undefined || typeof scene.compiledAssets.terrain === "string") &&
            (scene.compiledAssets.opaque === undefined || typeof scene.compiledAssets.opaque === "string") &&
            (scene.compiledAssets.transparent === undefined || typeof scene.compiledAssets.transparent === "string") &&
            (scene.mirrorY === undefined || typeof scene.mirrorY === "boolean") &&
            (scene.width === undefined || (Number.isInteger(scene.width) && scene.width > 0)) &&
            (scene.height === undefined || (Number.isInteger(scene.height) && scene.height > 0)) &&
            ((_a = scene.placements) !== null && _a !== void 0 ? _a : []).every(function (placement) { return placement && typeof placement.assetId === "string" && Number.isFinite(placement.x) && Number.isFinite(placement.y) && Number.isFinite(placement.plane) &&
                (placement.width === undefined || (Number.isFinite(placement.width) && placement.width > 0)) &&
                (placement.height === undefined || (Number.isFinite(placement.height) && placement.height > 0)); });
    }));
}

;// CONCATENATED MODULE: ./src/cache-render-format/payload.ts
/** Shared JSON payload contract stored inside an OSRB binary asset. */
var CACHE_RENDER_PAYLOAD_MAGIC = "OSRB";
var CACHE_RENDER_PAYLOAD_VERSION = 2;

;// CONCATENATED MODULE: ./src/cache-render-format/crc32.ts
var CRC32_TABLE = new Uint32Array(256);
for (var index = 0; index < CRC32_TABLE.length; index++) {
    var value = index;
    for (var bit = 0; bit < 8; bit++) {
        value = value & 1 ? 0xedb88320 ^ (value >>> 1) : value >>> 1;
    }
    CRC32_TABLE[index] = value >>> 0;
}
/** Return the standard CRC-32 checksum as eight lowercase hexadecimal digits. */
function crc32(bytes) {
    var value = 0xffffffff;
    for (var index = 0; index < bytes.length; index++) {
        value = CRC32_TABLE[(value ^ bytes[index]) & 0xff] ^ (value >>> 8);
    }
    return ((value ^ 0xffffffff) >>> 0).toString(16).padStart(8, "0");
}

;// CONCATENATED MODULE: ./src/cache-render-format/index.ts





/***/ }),

/***/ 613:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LoadoutRegistry: () => (/* binding */ LoadoutRegistry)
/* harmony export */ });
/* harmony import */ var _equipment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7876);
/* harmony import */ var _items__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2202);
/* harmony import */ var _weapons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1618);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



// Construct the supported item classes once so unresolved loadout IDs can be
// resolved to the same name and inventory image used by gameplay.
var itemConstructors = Object.values(__assign(__assign(__assign({}, _equipment__WEBPACK_IMPORTED_MODULE_0__), _items__WEBPACK_IMPORTED_MODULE_1__), _weapons__WEBPACK_IMPORTED_MODULE_2__));
var loadoutItems = itemConstructors
    .map(function (ItemType) { return new ItemType(); })
    .filter(function (item) { return typeof item.cacheItemId === "number"; });
/** Static item registry used to resolve Loadout item IDs for UI and tooling. */
var LoadoutRegistry = new Map();
// Some items share a cache ID (e.g. seeking dragon arrows reuse dragon arrows' model); the first
// registered item keeps the ID so it resolves to the base item.
loadoutItems.forEach(function (item) {
    if (!LoadoutRegistry.has(item.cacheItemId))
        LoadoutRegistry.set(item.cacheItemId, item);
});


/***/ }),

/***/ 754:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: () => (/* binding */ TileMarker)
/* harmony export */ });
/* harmony import */ var _sdk_Entity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1184);
/* harmony import */ var _sdk_Collision__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5843);
/* harmony import */ var _sdk_Settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8406);
/* harmony import */ var _sdk_LineOfSight__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8499);
/* harmony import */ var _sdk_EntityName__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5275);
/* harmony import */ var _sdk_rendering_TileMarkerModel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2175);

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var TileMarker = /** @class */ (function (_super) {
    __extends(TileMarker, _super);
    function TileMarker(region, location, color, size, saveable) {
        if (size === void 0) { size = 1; }
        if (saveable === void 0) { saveable = true; }
        var _this = _super.call(this, region, location) || this;
        _this._color = "#00FF00";
        _this._size = 1;
        _this.saveable = true;
        _this._color = color;
        _this._size = size;
        _this.saveable = saveable;
        if (saveable) {
            TileMarker.saveableMarkers.push(_this);
        }
        return _this;
    }
    TileMarker.onSetColor = function (color) {
        // saveable tile markers change color
        TileMarker.saveableMarkers.forEach(function (marker) {
            marker._color = color;
        });
    };
    TileMarker.loadAll = function (region) {
        if (_sdk_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.tile_markers) {
            _sdk_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.tile_markers
                .map(function (location) {
                return new TileMarker(region, location, _sdk_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.tileMarkerColor);
            })
                .forEach(function (tileMarker) {
                region.addEntity(tileMarker);
            });
        }
    };
    TileMarker.prototype.entityName = function () {
        return _sdk_EntityName__WEBPACK_IMPORTED_MODULE_4__/* .EntityNames */ .C.TILE_MARKER;
    };
    Object.defineProperty(TileMarker.prototype, "collisionType", {
        get: function () {
            return _sdk_Collision__WEBPACK_IMPORTED_MODULE_1__/* .CollisionType */ .B.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TileMarker.prototype, "lineOfSight", {
        get: function () {
            return _sdk_LineOfSight__WEBPACK_IMPORTED_MODULE_3__/* .LineOfSightMask */ .Z.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TileMarker.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TileMarker.prototype, "color", {
        get: function () {
            return this._color;
        },
        enumerable: false,
        configurable: true
    });
    TileMarker.prototype.draw = function () {
        this.region.context.save();
        this.region.context.globalAlpha *= 0.5;
        this.region.context.lineWidth = 2;
        this.region.context.strokeStyle = this.color;
        this.region.context.strokeRect(this.location.x * _sdk_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.tileSize, (this.location.y - this.size + 1) * _sdk_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.tileSize, this.size * _sdk_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.tileSize, this.size * _sdk_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.tileSize);
        this.region.context.restore();
    };
    TileMarker.prototype.create3dModel = function () {
        return _sdk_rendering_TileMarkerModel__WEBPACK_IMPORTED_MODULE_5__/* .TileMarkerModel */ .U.forRenderable(this);
    };
    TileMarker.saveableMarkers = [];
    return TileMarker;
}(_sdk_Entity__WEBPACK_IMPORTED_MODULE_0__/* .Entity */ .w));



/***/ }),

/***/ 7876:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AhrimsRobeskirt: () => (/* reexport */ AhrimsRobeskirt),
  AhrimsRobetop: () => (/* reexport */ AhrimsRobetop),
  AmuletOfBloodFury: () => (/* reexport */ AmuletOfBloodFury),
  AmuletOfFury: () => (/* reexport */ AmuletOfFury),
  AmuletOfRancour: () => (/* reexport */ AmuletOfRancour),
  AmuletOfTorture: () => (/* reexport */ AmuletOfTorture),
  AncestralRobebottom: () => (/* reexport */ AncestralRobebottom),
  AncestralRobetop: () => (/* reexport */ AncestralRobetop),
  AraneaBoots: () => (/* reexport */ AraneaBoots),
  ArmadylChainskirt: () => (/* reexport */ ArmadylChainskirt),
  ArmadylChestplate: () => (/* reexport */ ArmadylChestplate),
  AvasAccumulator: () => (/* reexport */ AvasAccumulator),
  AvasAssembler: () => (/* reexport */ AvasAssembler),
  AvernicDefender: () => (/* reexport */ AvernicDefender),
  AvernicTreadsMax: () => (/* reexport */ AvernicTreadsMax),
  BarrowsGloves: () => (/* reexport */ BarrowsGloves),
  BerserkerRing_i: () => (/* reexport */ BerserkerRing_i),
  BlackDhideBody: () => (/* reexport */ BlackDhideBody),
  BlackDhideChaps: () => (/* reexport */ BlackDhideChaps),
  BlackDhideVambraces: () => (/* reexport */ BlackDhideVambraces),
  BlueMoonChestplate: () => (/* reexport */ BlueMoonChestplate),
  BlueMoonHelm: () => (/* reexport */ BlueMoonHelm),
  BlueMoonTassets: () => (/* reexport */ BlueMoonTassets),
  ConflictionGauntlets: () => (/* reexport */ ConflictionGauntlets),
  CrystalBody: () => (/* reexport */ CrystalBody),
  CrystalHelm: () => (/* reexport */ CrystalHelm),
  CrystalLegs: () => (/* reexport */ CrystalLegs),
  CrystalShield: () => (/* reexport */ CrystalShield),
  DagonhaiRobeTop: () => (/* reexport */ DagonhaiRobeTop),
  DevoutBoots: () => (/* reexport */ DevoutBoots),
  DiamondBoltsE: () => (/* reexport */ DiamondBoltsE),
  DizanasQuiver: () => (/* reexport */ DizanasQuiver),
  DragonArrows: () => (/* reexport */ DragonArrows),
  DragonDefender: () => (/* reexport */ DragonDefender),
  EternalBoots: () => (/* reexport */ EternalBoots),
  FerociousGloves: () => (/* reexport */ FerociousGloves),
  FireCape: () => (/* reexport */ FireCape),
  GuthixRobeTop: () => (/* reexport */ GuthixRobeTop),
  HolyBlessing: () => (/* reexport */ HolyBlessing),
  InfernalCape: () => (/* reexport */ InfernalCape),
  JusticiarChestguard: () => (/* reexport */ JusticiarChestguard),
  JusticiarFaceguard: () => (/* reexport */ JusticiarFaceguard),
  JusticiarLegguards: () => (/* reexport */ JusticiarLegguards),
  MagesBook: () => (/* reexport */ MagesBook),
  MasoriBodyF: () => (/* reexport */ MasoriBodyF),
  MasoriChapsF: () => (/* reexport */ MasoriChapsF),
  MasoriMaskF: () => (/* reexport */ MasoriMaskF),
  NecklaceOfAnguish: () => (/* reexport */ NecklaceOfAnguish),
  NecklaceOfRupture: () => (/* reexport */ NecklaceOfRupture),
  OathplateChest: () => (/* reexport */ OathplateChest),
  OathplateHelm: () => (/* reexport */ OathplateHelm),
  OathplateLegs: () => (/* reexport */ OathplateLegs),
  OccultNecklace: () => (/* reexport */ OccultNecklace),
  PegasianBoots: () => (/* reexport */ PegasianBoots),
  PrimordialBoots: () => (/* reexport */ PrimordialBoots),
  RadasBlessing4: () => (/* reexport */ RadasBlessing4),
  RangerBoots: () => (/* reexport */ RangerBoots),
  RingOfEndurance: () => (/* reexport */ RingOfEndurance),
  RingOfSufferingImbued: () => (/* reexport */ RingOfSufferingImbued),
  RobinHoodHat: () => (/* reexport */ RobinHoodHat),
  RubyBoltsE: () => (/* reexport */ RubyBoltsE),
  RuneCrossbow: () => (/* reexport */ RuneCrossbow),
  RuneKiteshield: () => (/* reexport */ RuneKiteshield),
  SaradominBody: () => (/* reexport */ SaradominBody),
  SaradominChaps: () => (/* reexport */ SaradominChaps),
  SaradominCoif: () => (/* reexport */ SaradominCoif),
  SaradominDhideBoots: () => (/* reexport */ SaradominDhideBoots),
  SeekingDragonArrows: () => (/* reexport */ SeekingDragonArrows),
  SlayerHelmet: () => (/* reexport */ SlayerHelmet),
  TorvaFullhelm: () => (/* reexport */ TorvaFullhelm),
  TorvaPlatebody: () => (/* reexport */ TorvaPlatebody),
  TorvaPlatelegs: () => (/* reexport */ TorvaPlatelegs),
  UltorRing: () => (/* reexport */ UltorRing),
  VenatorRing: () => (/* reexport */ VenatorRing),
  ZaryteVambraces: () => (/* reexport */ ZaryteVambraces)
});

;// CONCATENATED MODULE: ./src/assets/images/equipment/Ahrims_robeskirt.png
const Ahrims_robeskirt_namespaceObject = __webpack_require__.p + "2cc60d9e1e0b8de9345f.png";
// EXTERNAL MODULE: ./src/sdk/gear/Legs.ts
var Legs = __webpack_require__(2802);
// EXTERNAL MODULE: ./src/sdk/ItemName.ts
var ItemName = __webpack_require__(243);
// EXTERNAL MODULE: ./src/sdk/utils/ImageLoader.ts
var ImageLoader = __webpack_require__(2987);
// EXTERNAL MODULE: ./src/assets/CacheAssets.ts
var CacheAssets = __webpack_require__(4655);
;// CONCATENATED MODULE: ./src/content/equipment/AhrimsRobeskirt.ts
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AhrimsRobeskirt = /** @class */ (function (_super) {
    __extends(AhrimsRobeskirt, _super);
    function AhrimsRobeskirt() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 22,
                range: -7,
            },
            defence: {
                stab: 33,
                slash: 30,
                crush: 36,
                magic: 22,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AhrimsRobeskirt.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.ahrimsRobeSkirt.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AhrimsRobeskirt.prototype, "inventoryImage", {
        get: function () {
            return Ahrims_robeskirt_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AhrimsRobeskirt.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.AHRIMS_ROBESKIRT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AhrimsRobeskirt.prototype, "weight", {
        get: function () {
            return 11.339;
        },
        enumerable: false,
        configurable: true
    });
    return AhrimsRobeskirt;
}(Legs/* Legs */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ahrims_robetop.png
const Ahrims_robetop_namespaceObject = __webpack_require__.p + "a59308eae87975037074.png";
// EXTERNAL MODULE: ./src/sdk/gear/Chest.ts
var Chest = __webpack_require__(7718);
;// CONCATENATED MODULE: ./src/content/equipment/AhrimsRobetop.ts
var AhrimsRobetop_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AhrimsRobetop = /** @class */ (function (_super) {
    AhrimsRobetop_extends(AhrimsRobetop, _super);
    function AhrimsRobetop() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: +22,
                range: -7,
            },
            defence: {
                stab: 33,
                slash: 30,
                crush: 36,
                magic: 22,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AhrimsRobetop.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.ahrimsRobeTop.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AhrimsRobetop.prototype, "inventoryImage", {
        get: function () {
            return Ahrims_robetop_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AhrimsRobetop.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.AHRIMS_ROBETOP;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AhrimsRobetop.prototype, "weight", {
        get: function () {
            return 4.535;
        },
        enumerable: false,
        configurable: true
    });
    return AhrimsRobetop;
}(Chest/* Chest */.k));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Amulet_of_fury.png
const Amulet_of_fury_namespaceObject = __webpack_require__.p + "b1672300ee81b1c66a12.png";
// EXTERNAL MODULE: ./src/sdk/gear/Necklace.ts
var Necklace = __webpack_require__(4295);
;// CONCATENATED MODULE: ./src/content/equipment/AmuletOfFury.ts
var AmuletOfFury_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AmuletOfFury = /** @class */ (function (_super) {
    AmuletOfFury_extends(AmuletOfFury, _super);
    function AmuletOfFury() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 10,
                slash: 10,
                crush: 10,
                magic: 10,
                range: 10,
            },
            defence: {
                stab: 15,
                slash: 15,
                crush: 15,
                magic: 15,
                range: 15,
            },
            other: {
                meleeStrength: 8,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 5,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AmuletOfFury.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.amuletOfFury.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfFury.prototype, "inventoryImage", {
        get: function () {
            return Amulet_of_fury_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfFury.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.AMULET_OF_FURY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfFury.prototype, "weight", {
        get: function () {
            return 0.01;
        },
        enumerable: false,
        configurable: true
    });
    return AmuletOfFury;
}(Necklace/* Necklace */.T));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Amulet_of_torture.png
const Amulet_of_torture_namespaceObject = __webpack_require__.p + "6d26b6d46c50ae336d08.png";
;// CONCATENATED MODULE: ./src/content/equipment/AmuletOfTorture.ts
var AmuletOfTorture_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AmuletOfTorture = /** @class */ (function (_super) {
    AmuletOfTorture_extends(AmuletOfTorture, _super);
    function AmuletOfTorture() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 15,
                slash: 15,
                crush: 15,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 10,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AmuletOfTorture.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.amuletOfTorture.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfTorture.prototype, "inventoryImage", {
        get: function () {
            return Amulet_of_torture_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfTorture.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.AMULET_OF_TORTURE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfTorture.prototype, "weight", {
        get: function () {
            return 0.01;
        },
        enumerable: false,
        configurable: true
    });
    return AmuletOfTorture;
}(Necklace/* Necklace */.T));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Amulet_of_rancour.png
const Amulet_of_rancour_namespaceObject = __webpack_require__.p + "47d9dbb3595cd1eed6b4.png";
;// CONCATENATED MODULE: ./src/content/equipment/AmuletOfRancour.ts
var AmuletOfRancour_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AmuletOfRancour = /** @class */ (function (_super) {
    AmuletOfRancour_extends(AmuletOfRancour, _super);
    function AmuletOfRancour() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: { stab: 25, slash: 25, crush: 25, magic: -6, range: -8 },
            defence: { stab: 0, slash: 0, crush: 0, magic: 0, range: 0 },
            other: { meleeStrength: 12, rangedStrength: 0, magicDamage: 0, prayer: 2 },
            targetSpecific: { undead: 0, slayer: 0 },
        };
        return _this;
    }
    Object.defineProperty(AmuletOfRancour.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.amuletOfRancour.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfRancour.prototype, "inventoryImage", {
        get: function () {
            return Amulet_of_rancour_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfRancour.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.AMULET_OF_RANCOUR;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfRancour.prototype, "weight", {
        get: function () {
            return 0.012;
        },
        enumerable: false,
        configurable: true
    });
    return AmuletOfRancour;
}(Necklace/* Necklace */.T));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ancestral_robe_bottom.png
const Ancestral_robe_bottom_namespaceObject = __webpack_require__.p + "71516c473c20a432a5d5.png";
;// CONCATENATED MODULE: ./src/content/equipment/AncestralRobebottom.ts
var AncestralRobebottom_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AncestralRobebottom = /** @class */ (function (_super) {
    AncestralRobebottom_extends(AncestralRobebottom, _super);
    function AncestralRobebottom() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 26,
                range: -7,
            },
            defence: {
                stab: 27,
                slash: 24,
                crush: 30,
                magic: 20,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0.02,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AncestralRobebottom.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.ancestralRobeBottom.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncestralRobebottom.prototype, "inventoryImage", {
        get: function () {
            return Ancestral_robe_bottom_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncestralRobebottom.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ANCESTRAL_ROBEBOTTOM;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncestralRobebottom.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    return AncestralRobebottom;
}(Legs/* Legs */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ancestral_robe_top.png
const Ancestral_robe_top_namespaceObject = __webpack_require__.p + "cac83f53c6d604ae3a44.png";
;// CONCATENATED MODULE: ./src/content/equipment/AncestralRobetop.ts
var AncestralRobetop_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AncestralRobetop = /** @class */ (function (_super) {
    AncestralRobetop_extends(AncestralRobetop, _super);
    function AncestralRobetop() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 35,
                range: -8,
            },
            defence: {
                stab: 42,
                slash: 31,
                crush: 51,
                magic: 28,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0.02,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AncestralRobetop.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.ancestralRobeTop.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncestralRobetop.prototype, "inventoryImage", {
        get: function () {
            return Ancestral_robe_top_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncestralRobetop.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ANCESTRAL_ROBETOP;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncestralRobetop.prototype, "weight", {
        get: function () {
            return 2.721;
        },
        enumerable: false,
        configurable: true
    });
    return AncestralRobetop;
}(Chest/* Chest */.k));


// EXTERNAL MODULE: ./src/sdk/gear/Feet.ts
var Feet = __webpack_require__(9775);
;// CONCATENATED MODULE: ./src/assets/images/equipment/Aranea_boots.png
const Aranea_boots_namespaceObject = __webpack_require__.p + "42739c9075f8e83e7c9d.png";
;// CONCATENATED MODULE: ./src/content/equipment/AraneaBoots.ts
var AraneaBoots_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AraneaBoots = /** @class */ (function (_super) {
    AraneaBoots_extends(AraneaBoots, _super);
    function AraneaBoots() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 5,
                range: 6,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 4,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AraneaBoots.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.araneaBoots.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AraneaBoots.prototype, "inventoryImage", {
        get: function () {
            return Aranea_boots_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AraneaBoots.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ARANEA_BOOTS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AraneaBoots.prototype, "weight", {
        get: function () {
            return 1.0;
        },
        enumerable: false,
        configurable: true
    });
    return AraneaBoots;
}(Feet/* Feet */.v));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Armadyl_chainskirt.png
const Armadyl_chainskirt_namespaceObject = __webpack_require__.p + "2b0c6187b019dba49e07.png";
;// CONCATENATED MODULE: ./src/content/equipment/ArmadylChainskirt.ts
var ArmadylChainskirt_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ArmadylChainskirt = /** @class */ (function (_super) {
    ArmadylChainskirt_extends(ArmadylChainskirt, _super);
    function ArmadylChainskirt() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: -6,
                slash: -6,
                crush: -6,
                magic: -10,
                range: 20,
            },
            defence: {
                stab: 32,
                slash: 26,
                crush: 34,
                magic: 40,
                range: 33,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(ArmadylChainskirt.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.armadylChainskirt.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylChainskirt.prototype, "inventoryImage", {
        get: function () {
            return Armadyl_chainskirt_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylChainskirt.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ARMADYL_CHAINSKIRT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylChainskirt.prototype, "weight", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ArmadylChainskirt;
}(Legs/* Legs */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Armadyl_chestplate.png
const Armadyl_chestplate_namespaceObject = __webpack_require__.p + "2feaa80335ebe5b0f03e.png";
;// CONCATENATED MODULE: ./src/content/equipment/ArmadylChestplate.ts
var ArmadylChestplate_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ArmadylChestplate = /** @class */ (function (_super) {
    ArmadylChestplate_extends(ArmadylChestplate, _super);
    function ArmadylChestplate() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: -7,
                slash: -7,
                crush: -7,
                magic: -15,
                range: 33,
            },
            defence: {
                stab: 56,
                slash: 48,
                crush: 61,
                magic: 70,
                range: 57,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(ArmadylChestplate.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.armadylChestplate.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylChestplate.prototype, "inventoryImage", {
        get: function () {
            return Armadyl_chestplate_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylChestplate.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ARMADYL_CHESTPLATE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylChestplate.prototype, "weight", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return ArmadylChestplate;
}(Chest/* Chest */.k));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Avas_accumulator.png
const Avas_accumulator_namespaceObject = __webpack_require__.p + "6d9bbe438a8a346dc8cb.png";
// EXTERNAL MODULE: ./src/sdk/gear/Cape.ts
var Cape = __webpack_require__(1040);
;// CONCATENATED MODULE: ./src/content/equipment/AvasAccumulator.ts
var AvasAccumulator_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AvasAccumulator = /** @class */ (function (_super) {
    AvasAccumulator_extends(AvasAccumulator, _super);
    function AvasAccumulator() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 4,
            },
            defence: {
                stab: 0,
                slash: 1,
                crush: 0,
                magic: 4,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AvasAccumulator.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipBackpack.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAccumulator.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.avasAccumulator.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAccumulator.prototype, "inventoryImage", {
        get: function () {
            return Avas_accumulator_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAccumulator.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.AVAS_ACCUMULATOR;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAccumulator.prototype, "weight", {
        get: function () {
            return 4.535;
        },
        enumerable: false,
        configurable: true
    });
    return AvasAccumulator;
}(Cape/* Cape */.Q));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Avas_assembler.png
const Avas_assembler_namespaceObject = __webpack_require__.p + "c0ba96057ff35545dbff.png";
;// CONCATENATED MODULE: ./src/content/equipment/AvasAssembler.ts
var AvasAssembler_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AvasAssembler = /** @class */ (function (_super) {
    AvasAssembler_extends(AvasAssembler, _super);
    function AvasAssembler() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 8,
            },
            defence: {
                stab: 1,
                slash: 1,
                crush: 1,
                magic: 8,
                range: 2,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 2,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AvasAssembler.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipBackpack.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAssembler.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.avasAssembler.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAssembler.prototype, "inventoryImage", {
        get: function () {
            return Avas_assembler_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAssembler.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.AVAS_ASSEMBLER;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvasAssembler.prototype, "weight", {
        get: function () {
            return 5.896;
        },
        enumerable: false,
        configurable: true
    });
    return AvasAssembler;
}(Cape/* Cape */.Q));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Avernic_defender.png
const Avernic_defender_namespaceObject = __webpack_require__.p + "5871953a1548bdf96ca4.png";
// EXTERNAL MODULE: ./src/sdk/gear/Offhand.ts
var Offhand = __webpack_require__(7211);
;// CONCATENATED MODULE: ./src/content/equipment/AvernicDefender.ts
var AvernicDefender_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AvernicDefender = /** @class */ (function (_super) {
    AvernicDefender_extends(AvernicDefender, _super);
    function AvernicDefender() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 30,
                slash: 29,
                crush: 28,
                magic: -5,
                range: -4,
            },
            defence: {
                stab: 30,
                slash: 29,
                crush: 28,
                magic: -5,
                range: -4,
            },
            other: {
                meleeStrength: 8,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AvernicDefender.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.avernicDefender.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvernicDefender.prototype, "inventoryImage", {
        get: function () {
            return Avernic_defender_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvernicDefender.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.AVERNIC_DEFENDER;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvernicDefender.prototype, "weight", {
        get: function () {
            return 0.453;
        },
        enumerable: false,
        configurable: true
    });
    return AvernicDefender;
}(Offhand/* Offhand */.f));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Avernic_treads_(max).png
const Avernic_treads_max_namespaceObject = __webpack_require__.p + "0df28a5ada37f11b11de.png";
;// CONCATENATED MODULE: ./src/content/equipment/AvernicTreadsMax.ts
var AvernicTreadsMax_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AvernicTreadsMax = /** @class */ (function (_super) {
    AvernicTreadsMax_extends(AvernicTreadsMax, _super);
    function AvernicTreadsMax() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: { stab: 5, slash: 5, crush: 5, magic: 11, range: 15 },
            defence: { stab: 21, slash: 25, crush: 25, magic: 10, range: 10 },
            other: { meleeStrength: 6, rangedStrength: 3, magicDamage: 0.02, prayer: 0 },
            targetSpecific: { undead: 0, slayer: 0 },
        };
        return _this;
    }
    Object.defineProperty(AvernicTreadsMax.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.avernicTreadsMax.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvernicTreadsMax.prototype, "inventoryImage", {
        get: function () {
            return Avernic_treads_max_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvernicTreadsMax.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.AVERNIC_TREADS_MAX;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvernicTreadsMax.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    return AvernicTreadsMax;
}(Feet/* Feet */.v));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Barrows_gloves.png
const Barrows_gloves_namespaceObject = __webpack_require__.p + "09e747f4e8a7fe133858.png";
// EXTERNAL MODULE: ./src/sdk/gear/Gloves.ts
var Gloves = __webpack_require__(1629);
;// CONCATENATED MODULE: ./src/content/equipment/BarrowsGloves.ts
var BarrowsGloves_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var BarrowsGloves = /** @class */ (function (_super) {
    BarrowsGloves_extends(BarrowsGloves, _super);
    function BarrowsGloves() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 12,
                slash: 12,
                crush: 12,
                magic: 6,
                range: 12,
            },
            defence: {
                stab: 12,
                slash: 12,
                crush: 12,
                magic: 6,
                range: 12,
            },
            other: {
                meleeStrength: 12,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BarrowsGloves.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.barrowsGloves.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarrowsGloves.prototype, "inventoryImage", {
        get: function () {
            return Barrows_gloves_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarrowsGloves.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BARROWS_GLOVES;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarrowsGloves.prototype, "weight", {
        get: function () {
            return 0.226;
        },
        enumerable: false,
        configurable: true
    });
    return BarrowsGloves;
}(Gloves/* Gloves */.L));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Berserker_ring_(i).png
const Berserker_ring_i_namespaceObject = __webpack_require__.p + "e3a92c32d33fd3474266.png";
// EXTERNAL MODULE: ./src/sdk/gear/Ring.ts
var Ring = __webpack_require__(5941);
;// CONCATENATED MODULE: ./src/content/equipment/BerserkerRing_i.ts
var BerserkerRing_i_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var BerserkerRing_i = /** @class */ (function (_super) {
    BerserkerRing_i_extends(BerserkerRing_i, _super);
    function BerserkerRing_i() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 8,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BerserkerRing_i.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.berserkerRingI.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BerserkerRing_i.prototype, "inventoryImage", {
        get: function () {
            return Berserker_ring_i_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BerserkerRing_i.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BERSERKER_RING_I;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BerserkerRing_i.prototype, "weight", {
        get: function () {
            return 0.004;
        },
        enumerable: false,
        configurable: true
    });
    return BerserkerRing_i;
}(Ring/* Ring */.J));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Black_d'hide_body.png
const Black_d_hide_body_namespaceObject = __webpack_require__.p + "62e1a2ab01a8006886eb.png";
;// CONCATENATED MODULE: ./src/content/equipment/BlackDhideBody.ts
var BlackDhideBody_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var BlackDhideBody = /** @class */ (function (_super) {
    BlackDhideBody_extends(BlackDhideBody, _super);
    function BlackDhideBody() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -15,
                range: 30,
            },
            defence: {
                stab: 55,
                slash: 47,
                crush: 60,
                magic: 50,
                range: 55,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BlackDhideBody.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.blackDhideBody.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideBody.prototype, "inventoryImage", {
        get: function () {
            return Black_d_hide_body_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideBody.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BLACK_D_HIDE_BODY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideBody.prototype, "weight", {
        get: function () {
            return 6.803;
        },
        enumerable: false,
        configurable: true
    });
    return BlackDhideBody;
}(Chest/* Chest */.k));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Black_d'hide_chaps.png
const Black_d_hide_chaps_namespaceObject = __webpack_require__.p + "8ac1d10b4dafe8f651b8.png";
;// CONCATENATED MODULE: ./src/content/equipment/BlackDhideChaps.ts
var BlackDhideChaps_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var BlackDhideChaps = /** @class */ (function (_super) {
    BlackDhideChaps_extends(BlackDhideChaps, _super);
    function BlackDhideChaps() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: 17,
            },
            defence: {
                stab: 31,
                slash: 25,
                crush: 33,
                magic: 28,
                range: 31,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BlackDhideChaps.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.blackDhideChaps.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideChaps.prototype, "inventoryImage", {
        get: function () {
            return Black_d_hide_chaps_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideChaps.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BLACK_D_HIDE_CHAPS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideChaps.prototype, "weight", {
        get: function () {
            return 5.443;
        },
        enumerable: false,
        configurable: true
    });
    return BlackDhideChaps;
}(Legs/* Legs */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Black_d'hide_vambraces.png
const Black_d_hide_vambraces_namespaceObject = __webpack_require__.p + "d98b753d6facf4353c79.png";
;// CONCATENATED MODULE: ./src/content/equipment/BlackDhideVambraces.ts
var BlackDhideVambraces_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var BlackDhideVambraces = /** @class */ (function (_super) {
    BlackDhideVambraces_extends(BlackDhideVambraces, _super);
    function BlackDhideVambraces() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: 11,
            },
            defence: {
                stab: 6,
                slash: 5,
                crush: 7,
                magic: 8,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BlackDhideVambraces.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.blackDhideVambraces.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideVambraces.prototype, "inventoryImage", {
        get: function () {
            return Black_d_hide_vambraces_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideVambraces.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BLACK_D_HIDE_VAMBRACES;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackDhideVambraces.prototype, "weight", {
        get: function () {
            return 0.283;
        },
        enumerable: false,
        configurable: true
    });
    return BlackDhideVambraces;
}(Gloves/* Gloves */.L));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Crystal_body.png
const Crystal_body_namespaceObject = __webpack_require__.p + "be7aae7b71a022d6099a.png";
;// CONCATENATED MODULE: ./src/content/equipment/CrystalBody.ts
var CrystalBody_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CrystalBody = /** @class */ (function (_super) {
    CrystalBody_extends(CrystalBody, _super);
    function CrystalBody() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -18,
                range: 31,
            },
            defence: {
                stab: 46,
                slash: 38,
                crush: 48,
                magic: 44,
                range: 68,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 3,
                crystalAccuracy: 0.15,
                crystalDamage: 0.075,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(CrystalBody.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.crystalBody.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalBody.prototype, "inventoryImage", {
        get: function () {
            return Crystal_body_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalBody.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.CRYSTAL_BODY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalBody.prototype, "weight", {
        get: function () {
            return 2;
        },
        enumerable: false,
        configurable: true
    });
    return CrystalBody;
}(Chest/* Chest */.k));


// EXTERNAL MODULE: ./src/sdk/gear/Helmet.ts
var Helmet = __webpack_require__(2282);
;// CONCATENATED MODULE: ./src/assets/images/equipment/Crystal_helm.png
const Crystal_helm_namespaceObject = __webpack_require__.p + "9fda6ee6355df1ff1cd5.png";
;// CONCATENATED MODULE: ./src/content/equipment/CrystalHelm.ts
var CrystalHelm_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CrystalHelm = /** @class */ (function (_super) {
    CrystalHelm_extends(CrystalHelm, _super);
    function CrystalHelm() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: 9,
            },
            defence: {
                stab: 12,
                slash: 8,
                crush: 14,
                magic: 10,
                range: 18,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
                crystalAccuracy: 0.05,
                crystalDamage: 0.025,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(CrystalHelm.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.crystalHelm.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalHelm.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.CRYSTAL_HELM;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalHelm.prototype, "weight", {
        get: function () {
            return 0.5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalHelm.prototype, "inventoryImage", {
        get: function () {
            return Crystal_helm_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return CrystalHelm;
}(Helmet/* Helmet */.m));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Crystal_legs.png
const Crystal_legs_namespaceObject = __webpack_require__.p + "aff1e233dc0085b88760.png";
;// CONCATENATED MODULE: ./src/content/equipment/CrystalLegs.ts
var CrystalLegs_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CrystalLegs = /** @class */ (function (_super) {
    CrystalLegs_extends(CrystalLegs, _super);
    function CrystalLegs() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -12,
                range: 18,
            },
            defence: {
                stab: 26,
                slash: 21,
                crush: 30,
                magic: 34,
                range: 38,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
                crystalAccuracy: 0.1,
                crystalDamage: 0.05,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(CrystalLegs.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.crystalLegs.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalLegs.prototype, "inventoryImage", {
        get: function () {
            return Crystal_legs_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalLegs.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.CRYSTAL_LEGS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalLegs.prototype, "weight", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return CrystalLegs;
}(Legs/* Legs */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Crystal_shield.png
const Crystal_shield_namespaceObject = __webpack_require__.p + "fb0e4ae148289f189947.png";
;// CONCATENATED MODULE: ./src/content/equipment/CrystalShield.ts
var CrystalShield_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CrystalShield = /** @class */ (function (_super) {
    CrystalShield_extends(CrystalShield, _super);
    function CrystalShield() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: -10,
            },
            defence: {
                stab: 51,
                slash: 54,
                crush: 53,
                magic: 0,
                range: 80,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(CrystalShield.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.crystalShield.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalShield.prototype, "inventoryImage", {
        get: function () {
            return Crystal_shield_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalShield.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.CRYSTAL_SHIELD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrystalShield.prototype, "weight", {
        get: function () {
            return 2.721;
        },
        enumerable: false,
        configurable: true
    });
    return CrystalShield;
}(Offhand/* Offhand */.f));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Dagon'hai_robe_top.png
const Dagon_hai_robe_top_namespaceObject = __webpack_require__.p + "57d9dee7f04bf2ad3f99.png";
;// CONCATENATED MODULE: ./src/content/equipment/DagonhaiRobeTop.ts
var DagonhaiRobeTop_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var DagonhaiRobeTop = /** @class */ (function (_super) {
    DagonhaiRobeTop_extends(DagonhaiRobeTop, _super);
    function DagonhaiRobeTop() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 25,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 21,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(DagonhaiRobeTop.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.dagonhaiRobeTop.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DagonhaiRobeTop.prototype, "inventoryImage", {
        get: function () {
            return Dagon_hai_robe_top_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DagonhaiRobeTop.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.DAGON_HAI_ROBE_TOP;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DagonhaiRobeTop.prototype, "weight", {
        get: function () {
            return 2.267;
        },
        enumerable: false,
        configurable: true
    });
    return DagonhaiRobeTop;
}(Chest/* Chest */.k));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Devout_boots.png
const Devout_boots_namespaceObject = __webpack_require__.p + "49dbc5a6dc3c8483321d.png";
;// CONCATENATED MODULE: ./src/content/equipment/DevoutBoots.ts
var DevoutBoots_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var DevoutBoots = /** @class */ (function (_super) {
    DevoutBoots_extends(DevoutBoots, _super);
    function DevoutBoots() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 5,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(DevoutBoots.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.devoutBoots.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DevoutBoots.prototype, "inventoryImage", {
        get: function () {
            return Devout_boots_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DevoutBoots.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.HOLY_BLESSING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DevoutBoots.prototype, "weight", {
        get: function () {
            return 0.5;
        },
        enumerable: false,
        configurable: true
    });
    return DevoutBoots;
}(Feet/* Feet */.v));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Diamond_bolts_e_5.png
const Diamond_bolts_e_5_namespaceObject = __webpack_require__.p + "fce26b202f2728d673f0.png";
// EXTERNAL MODULE: ./src/sdk/gear/Ammo.ts
var Ammo = __webpack_require__(1977);
;// CONCATENATED MODULE: ./src/content/equipment/DiamondBoltsE.ts
var DiamondBoltsE_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var DiamondBoltsE = /** @class */ (function (_super) {
    DiamondBoltsE_extends(DiamondBoltsE, _super);
    function DiamondBoltsE() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 105,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(DiamondBoltsE.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipBolt.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiamondBoltsE.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.diamondBoltsE.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiamondBoltsE.prototype, "inventoryImage", {
        get: function () {
            return Diamond_bolts_e_5_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiamondBoltsE.prototype, "weight", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiamondBoltsE.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.DIAMOND_BOLTS_E;
        },
        enumerable: false,
        configurable: true
    });
    return DiamondBoltsE;
}(Ammo/* Ammo */.d));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Dizana's_quiver.png
const Dizana_s_quiver_namespaceObject = __webpack_require__.p + "1d7154d5998b78d5ff03.png";
// EXTERNAL MODULE: ./src/sdk/Equipment.ts
var Equipment = __webpack_require__(3107);
// EXTERNAL MODULE: ./src/sdk/weapons/RangedWeapon.ts
var RangedWeapon = __webpack_require__(2022);
;// CONCATENATED MODULE: ./src/content/equipment/DizanasQuiver.ts
var DizanasQuiver_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var DizanasQuiver = /** @class */ (function (_super) {
    DizanasQuiver_extends(DizanasQuiver, _super);
    function DizanasQuiver() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 18,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 3,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(DizanasQuiver.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipBackpack.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DizanasQuiver.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.dizanasQuiver.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DizanasQuiver.prototype, "inventoryImage", {
        get: function () {
            return Dizana_s_quiver_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DizanasQuiver.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.DIZANAS_QUIVER;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DizanasQuiver.prototype, "weight", {
        get: function () {
            return 0.453;
        },
        enumerable: false,
        configurable: true
    });
    DizanasQuiver.prototype.updateBonuses = function (gear) {
        var weapon = gear.find(function (item) { return (item === null || item === void 0 ? void 0 : item.type) === Equipment/* EquipmentTypes */.WA.WEAPON; });
        if (!weapon || !(weapon instanceof RangedWeapon/* RangedWeapon */.I)) {
            this.bonuses.other.rangedStrength = 3;
            return;
        }
        if (weapon.compatibleAmmo().includes(ItemName/* ItemName */.P.DRAGON_ARROWS)) {
            this.bonuses.other.rangedStrength = 4;
        }
        else {
            this.bonuses.other.rangedStrength = 3;
        }
    };
    return DizanasQuiver;
}(Cape/* Cape */.Q));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Dragon_arrow_5.png
const Dragon_arrow_5_namespaceObject = __webpack_require__.p + "28cf0a2a68f651babc1a.png";
;// CONCATENATED MODULE: ./src/content/equipment/DragonArrows.ts
var DragonArrows_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var DragonArrows = /** @class */ (function (_super) {
    DragonArrows_extends(DragonArrows, _super);
    function DragonArrows() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 60,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(DragonArrows.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipWood.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonArrows.prototype, "cacheItemId", {
        // Dragon arrows have no character mesh; the cache item ID is still explicit.
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.dragonArrows.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonArrows.prototype, "inventoryImage", {
        get: function () {
            return Dragon_arrow_5_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonArrows.prototype, "weight", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonArrows.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.DRAGON_ARROWS;
        },
        enumerable: false,
        configurable: true
    });
    return DragonArrows;
}(Ammo/* Ammo */.d));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Seeking_dragon_arrow.png
const Seeking_dragon_arrow_namespaceObject = __webpack_require__.p + "a5373933300324e0970f.png";
;// CONCATENATED MODULE: ./src/content/equipment/SeekingDragonArrows.ts
var SeekingDragonArrows_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/** Seeking dragon arrows. The passive minimum-hit effect is intentionally not simulated. */
var SeekingDragonArrows = /** @class */ (function (_super) {
    SeekingDragonArrows_extends(SeekingDragonArrows, _super);
    function SeekingDragonArrows() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: { stab: 0, slash: 0, crush: 0, magic: 0, range: 20 },
            defence: { stab: 0, slash: 0, crush: 0, magic: 0, range: 0 },
            other: { meleeStrength: 0, rangedStrength: 60, magicDamage: 0, prayer: 0 },
            targetSpecific: { undead: 0, slayer: 0 },
        };
        return _this;
    }
    Object.defineProperty(SeekingDragonArrows.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipWood.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeekingDragonArrows.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.seekingDragonArrows.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeekingDragonArrows.prototype, "inventoryImage", {
        get: function () {
            return Seeking_dragon_arrow_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeekingDragonArrows.prototype, "weight", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeekingDragonArrows.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.SEEKING_DRAGON_ARROWS;
        },
        enumerable: false,
        configurable: true
    });
    return SeekingDragonArrows;
}(Ammo/* Ammo */.d));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Dragon_defender.png
const Dragon_defender_namespaceObject = __webpack_require__.p + "ce1b15dc91ad79f45b92.png";
;// CONCATENATED MODULE: ./src/content/equipment/DragonDefender.ts
var DragonDefender_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var DragonDefender = /** @class */ (function (_super) {
    DragonDefender_extends(DragonDefender, _super);
    function DragonDefender() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 25,
                slash: 24,
                crush: 23,
                magic: -3,
                range: -2,
            },
            defence: {
                stab: 25,
                slash: 24,
                crush: 23,
                magic: -3,
                range: -2,
            },
            other: {
                meleeStrength: 6,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(DragonDefender.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.dragonDefender.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonDefender.prototype, "inventoryImage", {
        get: function () {
            return Dragon_defender_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonDefender.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.DRAGON_DEFENDER;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonDefender.prototype, "weight", {
        get: function () {
            return 0.453;
        },
        enumerable: false,
        configurable: true
    });
    return DragonDefender;
}(Offhand/* Offhand */.f));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ferocious_gloves.png
const Ferocious_gloves_namespaceObject = __webpack_require__.p + "0865ae07961873a2ceb3.png";
;// CONCATENATED MODULE: ./src/content/equipment/FerociousGloves.ts
var FerociousGloves_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var FerociousGloves = /** @class */ (function (_super) {
    FerociousGloves_extends(FerociousGloves, _super);
    function FerociousGloves() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 16,
                slash: 16,
                crush: 16,
                magic: -16,
                range: -16,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 6,
                range: 0,
            },
            other: {
                meleeStrength: 14,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(FerociousGloves.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.ferociousGloves.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FerociousGloves.prototype, "inventoryImage", {
        get: function () {
            return Ferocious_gloves_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FerociousGloves.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.FEROCIOUS_GLOVES;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FerociousGloves.prototype, "weight", {
        get: function () {
            return 0.226;
        },
        enumerable: false,
        configurable: true
    });
    return FerociousGloves;
}(Gloves/* Gloves */.L));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Guthix_robe_top.png
const Guthix_robe_top_namespaceObject = __webpack_require__.p + "e464a8a0832f7e88745c.png";
;// CONCATENATED MODULE: ./src/content/equipment/GuthixRobeTop.ts
var GuthixRobeTop_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var GuthixRobeTop = /** @class */ (function (_super) {
    GuthixRobeTop_extends(GuthixRobeTop, _super);
    function GuthixRobeTop() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 4,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 4,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 6,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(GuthixRobeTop.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.guthixRobeTop.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuthixRobeTop.prototype, "inventoryImage", {
        get: function () {
            return Guthix_robe_top_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuthixRobeTop.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.GUTHIX_ROBE_TOP;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuthixRobeTop.prototype, "weight", {
        get: function () {
            return 1.8;
        },
        enumerable: false,
        configurable: true
    });
    return GuthixRobeTop;
}(Chest/* Chest */.k));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Holy_blessing.png
const Holy_blessing_namespaceObject = __webpack_require__.p + "aa4f3594b16acd852a6d.png";
;// CONCATENATED MODULE: ./src/content/equipment/HolyBlessing.ts
var HolyBlessing_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var HolyBlessing = /** @class */ (function (_super) {
    HolyBlessing_extends(HolyBlessing, _super);
    function HolyBlessing() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(HolyBlessing.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.holyBlessing.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HolyBlessing.prototype, "inventoryImage", {
        get: function () {
            return Holy_blessing_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HolyBlessing.prototype, "weight", {
        get: function () {
            return 0.51;
        },
        enumerable: false,
        configurable: true
    });
    HolyBlessing.prototype.ammoType = function () {
        return Ammo/* AmmoType */.T.BLESSING;
    };
    return HolyBlessing;
}(Ammo/* Ammo */.d));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Infernal_cape.png
const Infernal_cape_namespaceObject = __webpack_require__.p + "727de56aa689bbba637d.png";
;// CONCATENATED MODULE: ./src/content/equipment/InfernalCape.ts
var InfernalCape_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var InfernalCape = /** @class */ (function (_super) {
    InfernalCape_extends(InfernalCape, _super);
    function InfernalCape() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 4,
                slash: 4,
                crush: 4,
                magic: 1,
                range: 1,
            },
            defence: {
                stab: 12,
                slash: 12,
                crush: 12,
                magic: 12,
                range: 12,
            },
            other: {
                meleeStrength: 8,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(InfernalCape.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.infernalCape.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InfernalCape.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.INFERNAL_CAPE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InfernalCape.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InfernalCape.prototype, "inventoryImage", {
        get: function () {
            return Infernal_cape_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return InfernalCape;
}(Cape/* Cape */.Q));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Justiciar_chestguard.png
const Justiciar_chestguard_namespaceObject = __webpack_require__.p + "98ec70c4ca4cd1cec982.png";
// EXTERNAL MODULE: ./src/sdk/SetEffect.ts
var SetEffect = __webpack_require__(8350);
;// CONCATENATED MODULE: ./src/content/seteffects/JusticiarSetEffect.ts
var JusticiarSetEffect_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var JusticiarSetEffect = /** @class */ (function (_super) {
    JusticiarSetEffect_extends(JusticiarSetEffect, _super);
    function JusticiarSetEffect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JusticiarSetEffect.effectName = function () {
        return SetEffect/* SetEffectTypes */.F.JUSTICIAR;
    };
    JusticiarSetEffect.itemsInSet = function () {
        return [ItemName/* ItemName */.P.JUSTICIAR_FACEGUARD, ItemName/* ItemName */.P.JUSTICIAR_CHESTGUARD, ItemName/* ItemName */.P.JUSTICIAR_LEGGUARDS];
    };
    return JusticiarSetEffect;
}(SetEffect/* SetEffect */.u));


;// CONCATENATED MODULE: ./src/content/equipment/JusticiarChestguard.ts
var JusticiarChestguard_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var JusticiarChestguard = /** @class */ (function (_super) {
    JusticiarChestguard_extends(JusticiarChestguard, _super);
    function JusticiarChestguard() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -40,
                range: -20,
            },
            defence: {
                stab: 132,
                slash: 130,
                crush: 117,
                magic: -16,
                range: 142,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 4,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(JusticiarChestguard.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.justiciarChestguard.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarChestguard.prototype, "equipmentSetEffect", {
        get: function () {
            return JusticiarSetEffect;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarChestguard.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.JUSTICIAR_CHESTGUARD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarChestguard.prototype, "weight", {
        get: function () {
            return 9.979;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarChestguard.prototype, "inventoryImage", {
        get: function () {
            return Justiciar_chestguard_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return JusticiarChestguard;
}(Chest/* Chest */.k));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Justiciar_faceguard.png
const Justiciar_faceguard_namespaceObject = __webpack_require__.p + "4f5483683adcf33e249a.png";
;// CONCATENATED MODULE: ./src/content/equipment/JusticiarFaceguard.ts
var JusticiarFaceguard_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var JusticiarFaceguard = /** @class */ (function (_super) {
    JusticiarFaceguard_extends(JusticiarFaceguard, _super);
    function JusticiarFaceguard() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -6,
                range: -2,
            },
            defence: {
                stab: 60,
                slash: 63,
                crush: 59,
                magic: -6,
                range: 67,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(JusticiarFaceguard.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.justiciarFaceguard.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarFaceguard.prototype, "equipmentSetEffect", {
        get: function () {
            return JusticiarSetEffect;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarFaceguard.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.JUSTICIAR_FACEGUARD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarFaceguard.prototype, "weight", {
        get: function () {
            return 2.721;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarFaceguard.prototype, "inventoryImage", {
        get: function () {
            return Justiciar_faceguard_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return JusticiarFaceguard;
}(Helmet/* Helmet */.m));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Justiciar_legguards.png
const Justiciar_legguards_namespaceObject = __webpack_require__.p + "c2d796ca3c1347642af9.png";
;// CONCATENATED MODULE: ./src/content/equipment/JusticiarLegguards.ts
var JusticiarLegguards_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var JusticiarLegguards = /** @class */ (function (_super) {
    JusticiarLegguards_extends(JusticiarLegguards, _super);
    function JusticiarLegguards() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -31,
                range: -17,
            },
            defence: {
                stab: 95,
                slash: 92,
                crush: 93,
                magic: -14,
                range: 102,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 4,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(JusticiarLegguards.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.justiciarLegguards.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarLegguards.prototype, "equipmentSetEffect", {
        get: function () {
            return JusticiarSetEffect;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarLegguards.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.JUSTICIAR_LEGGUARDS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarLegguards.prototype, "weight", {
        get: function () {
            return 9.071;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JusticiarLegguards.prototype, "inventoryImage", {
        get: function () {
            return Justiciar_legguards_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return JusticiarLegguards;
}(Legs/* Legs */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Mages_book.png
const Mages_book_namespaceObject = __webpack_require__.p + "a901d504b1dd52279a73.png";
;// CONCATENATED MODULE: ./src/content/equipment/MagesBook.ts
var MagesBook_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var MagesBook = /** @class */ (function (_super) {
    MagesBook_extends(MagesBook, _super);
    function MagesBook() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 15,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 15,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(MagesBook.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.magesBook.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MagesBook.prototype, "inventoryImage", {
        get: function () {
            return Mages_book_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MagesBook.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.MAGES_BOOK;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MagesBook.prototype, "weight", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return MagesBook;
}(Offhand/* Offhand */.f));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Masori_body_(f).png
const Masori_body_f_namespaceObject = __webpack_require__.p + "6a92d9b862390ef9febb.png";
;// CONCATENATED MODULE: ./src/content/equipment/MasoriBodyF.ts
var MasoriBodyF_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var MasoriBodyF = /** @class */ (function (_super) {
    MasoriBodyF_extends(MasoriBodyF, _super);
    function MasoriBodyF() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -4,
                range: 43,
            },
            defence: {
                stab: 59,
                slash: 52,
                crush: 64,
                magic: 74,
                range: 60,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 4,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(MasoriBodyF.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.masoriBodyF.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriBodyF.prototype, "inventoryImage", {
        get: function () {
            return Masori_body_f_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriBodyF.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.MASORI_BODY_F;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriBodyF.prototype, "weight", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    return MasoriBodyF;
}(Chest/* Chest */.k));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Masori_chaps_(f).png
const Masori_chaps_f_namespaceObject = __webpack_require__.p + "1e49a7aea5615fefcab7.png";
;// CONCATENATED MODULE: ./src/content/equipment/MasoriChapsF.ts
var MasoriChapsF_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var MasoriChapsF = /** @class */ (function (_super) {
    MasoriChapsF_extends(MasoriChapsF, _super);
    function MasoriChapsF() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -2,
                range: 27,
            },
            defence: {
                stab: 35,
                slash: 30,
                crush: 39,
                magic: 46,
                range: 37,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 2,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(MasoriChapsF.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.masoriChapsF.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriChapsF.prototype, "inventoryImage", {
        get: function () {
            return Masori_chaps_f_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriChapsF.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.MASORI_CHAPS_F;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriChapsF.prototype, "weight", {
        get: function () {
            return 8.5;
        },
        enumerable: false,
        configurable: true
    });
    return MasoriChapsF;
}(Legs/* Legs */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Masori_mask_(f).png
const Masori_mask_f_namespaceObject = __webpack_require__.p + "d83225d1a874c411570e.png";
;// CONCATENATED MODULE: ./src/content/equipment/MasoriMaskF.ts
var MasoriMaskF_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var MasoriMaskF = /** @class */ (function (_super) {
    MasoriMaskF_extends(MasoriMaskF, _super);
    function MasoriMaskF() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -1,
                range: 12,
            },
            defence: {
                stab: 8,
                slash: 10,
                crush: 12,
                magic: 12,
                range: 9,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 2,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(MasoriMaskF.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.masoriMaskF.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriMaskF.prototype, "inventoryImage", {
        get: function () {
            return Masori_mask_f_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriMaskF.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.MASORI_MASK_F;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MasoriMaskF.prototype, "weight", {
        get: function () {
            return 1.5;
        },
        enumerable: false,
        configurable: true
    });
    return MasoriMaskF;
}(Helmet/* Helmet */.m));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Necklace_of_anguish.png
const Necklace_of_anguish_namespaceObject = __webpack_require__.p + "43f1b1b98ea920f194d1.png";
;// CONCATENATED MODULE: ./src/content/equipment/NecklaceOfAnguish.ts
var NecklaceOfAnguish_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var NecklaceOfAnguish = /** @class */ (function (_super) {
    NecklaceOfAnguish_extends(NecklaceOfAnguish, _super);
    function NecklaceOfAnguish() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 15,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 5,
                magicDamage: 0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(NecklaceOfAnguish.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.necklaceOfAnguish.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NecklaceOfAnguish.prototype, "inventoryImage", {
        get: function () {
            return Necklace_of_anguish_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NecklaceOfAnguish.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.NECKLACE_OF_ANGUISH;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NecklaceOfAnguish.prototype, "weight", {
        get: function () {
            return 0.01;
        },
        enumerable: false,
        configurable: true
    });
    return NecklaceOfAnguish;
}(Necklace/* Necklace */.T));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Necklace_of_rupture.png
const Necklace_of_rupture_namespaceObject = __webpack_require__.p + "0bcd207f10faf5eeac2d.png";
;// CONCATENATED MODULE: ./src/content/equipment/NecklaceOfRupture.ts
var NecklaceOfRupture_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var NecklaceOfRupture = /** @class */ (function (_super) {
    NecklaceOfRupture_extends(NecklaceOfRupture, _super);
    function NecklaceOfRupture() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: { stab: 0, slash: 0, crush: 0, magic: 0, range: 20 },
            defence: { stab: 0, slash: 0, crush: 0, magic: 0, range: 0 },
            other: { meleeStrength: 0, rangedStrength: 8, magicDamage: 0, prayer: 3 },
            targetSpecific: { undead: 0, slayer: 0 },
        };
        return _this;
    }
    Object.defineProperty(NecklaceOfRupture.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.necklaceOfRupture.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NecklaceOfRupture.prototype, "inventoryImage", {
        get: function () { return Necklace_of_rupture_namespaceObject; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NecklaceOfRupture.prototype, "itemName", {
        get: function () { return ItemName/* ItemName */.P.NECKLACE_OF_RUPTURE; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NecklaceOfRupture.prototype, "weight", {
        get: function () { return 0.01; },
        enumerable: false,
        configurable: true
    });
    return NecklaceOfRupture;
}(Necklace/* Necklace */.T));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Occult_necklace.png
const Occult_necklace_namespaceObject = __webpack_require__.p + "19f8d58df7e42cee725b.png";
;// CONCATENATED MODULE: ./src/content/equipment/OccultNecklace.ts
var OccultNecklace_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var OccultNecklace = /** @class */ (function (_super) {
    OccultNecklace_extends(OccultNecklace, _super);
    function OccultNecklace() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 12,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0.05,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(OccultNecklace.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.occultNecklace.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OccultNecklace.prototype, "inventoryImage", {
        get: function () {
            return Occult_necklace_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OccultNecklace.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.OCCULT_NECKLACE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OccultNecklace.prototype, "weight", {
        get: function () {
            return 0.005;
        },
        enumerable: false,
        configurable: true
    });
    return OccultNecklace;
}(Necklace/* Necklace */.T));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Pegasian_boots.png
const Pegasian_boots_namespaceObject = __webpack_require__.p + "42501411e063b25bdcc9.png";
;// CONCATENATED MODULE: ./src/content/equipment/PegasianBoots.ts
var PegasianBoots_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var PegasianBoots = /** @class */ (function (_super) {
    PegasianBoots_extends(PegasianBoots, _super);
    function PegasianBoots() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -12,
                range: 12,
            },
            defence: {
                stab: 5,
                slash: 5,
                crush: 5,
                magic: 5,
                range: 5,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(PegasianBoots.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.pegasianBoots.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PegasianBoots.prototype, "inventoryImage", {
        get: function () {
            return Pegasian_boots_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PegasianBoots.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.PEGASIAN_BOOTS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PegasianBoots.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    return PegasianBoots;
}(Feet/* Feet */.v));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Primordial_boots.png
const Primordial_boots_namespaceObject = __webpack_require__.p + "224afeb7d3861e1e3aa2.png";
;// CONCATENATED MODULE: ./src/content/equipment/PrimordialBoots.ts
var PrimordialBoots_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var PrimordialBoots = /** @class */ (function (_super) {
    PrimordialBoots_extends(PrimordialBoots, _super);
    function PrimordialBoots() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 2,
                slash: 2,
                crush: 2,
                magic: -14,
                range: -1,
            },
            defence: {
                stab: 22,
                slash: 22,
                crush: 22,
                magic: 5,
                range: 5,
            },
            other: {
                meleeStrength: 5,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(PrimordialBoots.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.primordialBoots.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrimordialBoots.prototype, "inventoryImage", {
        get: function () {
            return Primordial_boots_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrimordialBoots.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.PRIMORDIAL_BOOTS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrimordialBoots.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    return PrimordialBoots;
}(Feet/* Feet */.v));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ranger_boots.png
const Ranger_boots_namespaceObject = __webpack_require__.p + "9329bdf2582d40ebd2c8.png";
;// CONCATENATED MODULE: ./src/content/equipment/RangerBoots.ts
var RangerBoots_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var RangerBoots = /** @class */ (function (_super) {
    RangerBoots_extends(RangerBoots, _super);
    function RangerBoots() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 10,
                range: 8,
            },
            defence: {
                stab: 2,
                slash: 3,
                crush: 4,
                magic: 2,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RangerBoots.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.rangerBoots.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RangerBoots.prototype, "inventoryImage", {
        get: function () {
            return Ranger_boots_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RangerBoots.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.RANGER_BOOTS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RangerBoots.prototype, "weight", {
        get: function () {
            return 0.283;
        },
        enumerable: false,
        configurable: true
    });
    return RangerBoots;
}(Feet/* Feet */.v));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ring_of_endurance.png
const Ring_of_endurance_namespaceObject = __webpack_require__.p + "890056edc0dd633a51a6.png";
;// CONCATENATED MODULE: ./src/content/equipment/RingOfEndurance.ts
var RingOfEndurance_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var RingOfEndurance = /** @class */ (function (_super) {
    RingOfEndurance_extends(RingOfEndurance, _super);
    function RingOfEndurance() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RingOfEndurance.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.ringOfEndurance.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingOfEndurance.prototype, "inventoryImage", {
        get: function () {
            return Ring_of_endurance_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingOfEndurance.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.RING_OF_ENDURANCE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingOfEndurance.prototype, "weight", {
        get: function () {
            return 0.006;
        },
        enumerable: false,
        configurable: true
    });
    return RingOfEndurance;
}(Ring/* Ring */.J));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Venator_ring.png
const Venator_ring_namespaceObject = __webpack_require__.p + "458471ae38ecdb2321b4.png";
;// CONCATENATED MODULE: ./src/content/equipment/VenatorRing.ts
var VenatorRing_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/** Venator ring. Its passive effects are intentionally not simulated. */
var VenatorRing = /** @class */ (function (_super) {
    VenatorRing_extends(VenatorRing, _super);
    function VenatorRing() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: { stab: 0, slash: 0, crush: 0, magic: 0, range: 10 },
            defence: { stab: 0, slash: 0, crush: 0, magic: 0, range: 0 },
            other: { meleeStrength: 0, rangedStrength: 2, magicDamage: 0, prayer: 2 },
            targetSpecific: { undead: 0, slayer: 0 },
        };
        return _this;
    }
    Object.defineProperty(VenatorRing.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.venatorRing.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorRing.prototype, "inventoryImage", {
        get: function () { return Venator_ring_namespaceObject; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorRing.prototype, "itemName", {
        get: function () { return ItemName/* ItemName */.P.VENATOR_RING; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorRing.prototype, "weight", {
        get: function () { return 0.01; },
        enumerable: false,
        configurable: true
    });
    return VenatorRing;
}(Ring/* Ring */.J));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ring_of_suffering_imbued.png
const Ring_of_suffering_imbued_namespaceObject = __webpack_require__.p + "94d4d466cc96a524a1a4.png";
;// CONCATENATED MODULE: ./src/content/equipment/RingOfSufferingImbued.ts
var RingOfSufferingImbued_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var RingOfSufferingImbued = /** @class */ (function (_super) {
    RingOfSufferingImbued_extends(RingOfSufferingImbued, _super);
    function RingOfSufferingImbued() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 20,
                slash: 20,
                crush: 20,
                magic: 20,
                range: 20,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 4,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RingOfSufferingImbued.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.ringOfSufferingI.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingOfSufferingImbued.prototype, "inventoryImage", {
        get: function () {
            return Ring_of_suffering_imbued_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingOfSufferingImbued.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.RING_OF_SUFFERING_I;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingOfSufferingImbued.prototype, "weight", {
        get: function () {
            return 0.006;
        },
        enumerable: false,
        configurable: true
    });
    return RingOfSufferingImbued;
}(Ring/* Ring */.J));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Robin_hood_hat.png
const Robin_hood_hat_namespaceObject = __webpack_require__.p + "264b9330fb34193ae334.png";
;// CONCATENATED MODULE: ./src/content/equipment/RobinHoodHat.ts
var RobinHoodHat_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var RobinHoodHat = /** @class */ (function (_super) {
    RobinHoodHat_extends(RobinHoodHat, _super);
    function RobinHoodHat() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: 8,
            },
            defence: {
                stab: 4,
                slash: 6,
                crush: 8,
                magic: 4,
                range: 4,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RobinHoodHat.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.robinHoodHat.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RobinHoodHat.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ROBIN_HOOD_HAT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RobinHoodHat.prototype, "weight", {
        get: function () {
            return 0.283;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RobinHoodHat.prototype, "inventoryImage", {
        get: function () {
            return Robin_hood_hat_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return RobinHoodHat;
}(Helmet/* Helmet */.m));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ruby_bolts_e_5.png
const Ruby_bolts_e_5_namespaceObject = __webpack_require__.p + "db177c42bc396af883a7.png";
;// CONCATENATED MODULE: ./src/content/equipment/RubyBoltsE.ts
var RubyBoltsE_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var RubyBoltsE = /** @class */ (function (_super) {
    RubyBoltsE_extends(RubyBoltsE, _super);
    function RubyBoltsE() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 103,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RubyBoltsE.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipBolt.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RubyBoltsE.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.rubyBoltsE.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RubyBoltsE.prototype, "inventoryImage", {
        get: function () {
            return Ruby_bolts_e_5_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RubyBoltsE.prototype, "weight", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RubyBoltsE.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.RUBY_BOLTS_E;
        },
        enumerable: false,
        configurable: true
    });
    return RubyBoltsE;
}(Ammo/* Ammo */.d));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Rune_crossbow.png
const Rune_crossbow_namespaceObject = __webpack_require__.p + "1a26adebd3caaa134cf7.png";
// EXTERNAL MODULE: ./src/sdk/AttackStylesController.ts + 27 modules
var AttackStylesController = __webpack_require__(186);
// EXTERNAL MODULE: ./src/sdk/weapons/Projectile.ts
var Projectile = __webpack_require__(2402);
// EXTERNAL MODULE: ./src/sdk/Random.ts
var Random = __webpack_require__(7212);
;// CONCATENATED MODULE: ./src/content/equipment/RuneCrossbow.ts

var RuneCrossbow_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var RuneCrossbow = /** @class */ (function (_super) {
    RuneCrossbow_extends(RuneCrossbow, _super);
    function RuneCrossbow() {
        var _this = _super.call(this) || this;
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 90,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 20,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RuneCrossbow.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.runeCrossbow.id;
        },
        enumerable: false,
        configurable: true
    });
    RuneCrossbow.prototype.compatibleAmmo = function () {
        return [ItemName/* ItemName */.P.RUBY_BOLTS_E, ItemName/* ItemName */.P.DIAMOND_BOLTS_E];
    };
    RuneCrossbow.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.RAPID, AttackStylesController/* AttackStyle */.aF.LONGRANGE];
    };
    RuneCrossbow.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.CROSSBOW;
    };
    RuneCrossbow.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.RAPID;
    };
    Object.defineProperty(RuneCrossbow.prototype, "weight", {
        get: function () {
            return 6;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneCrossbow.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.RUNE_CROSSBOW;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneCrossbow.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneCrossbow.prototype, "attackRange", {
        get: function () {
            if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.LONGRANGE) {
                return 9;
            }
            return 7;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneCrossbow.prototype, "attackSpeed", {
        get: function () {
            if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.LONGRANGE) {
                return 6;
            }
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneCrossbow.prototype, "inventoryImage", {
        get: function () {
            return Rune_crossbow_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    RuneCrossbow.prototype.rollDamage = function (from, to, bonuses) {
        if (from.equipment.ammo &&
            from.equipment.ammo.itemName === ItemName/* ItemName */.P.RUBY_BOLTS_E &&
            Random/* Random */.o.get() < 0.066 &&
            from.currentStats.hitpoint - Math.floor(from.currentStats.hitpoint * 0.1) > 0) {
            this.damage = to.currentStats.hitpoint * 0.2;
            from.addProjectile(new Projectile/* Projectile */.c6(this, Math.floor(from.currentStats.hitpoint * 0.1), from, from, "rubyboltspec", {
                reduceDelay: 15,
            }));
        }
        else if (from.equipment.ammo &&
            from.equipment.ammo.itemName === ItemName/* ItemName */.P.DIAMOND_BOLTS_E &&
            Random/* Random */.o.get() < 0.11) {
            this.damage = this._calculateHitDamage(from, to, bonuses);
        }
        else if (from.equipment.ammo) {
            _super.prototype.rollDamage.call(this, from, to, bonuses);
        }
        else {
            this.damage = -1;
        }
    };
    return RuneCrossbow;
}(RangedWeapon/* RangedWeapon */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Rune_kiteshield.png
const Rune_kiteshield_namespaceObject = __webpack_require__.p + "3f05ba4439d416e69eeb.png";
;// CONCATENATED MODULE: ./src/content/equipment/RuneKiteshield.ts
var RuneKiteshield_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var RuneKiteshield = /** @class */ (function (_super) {
    RuneKiteshield_extends(RuneKiteshield, _super);
    function RuneKiteshield() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -8,
                range: -3,
            },
            defence: {
                stab: 44,
                slash: 48,
                crush: 46,
                magic: -1,
                range: 46,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RuneKiteshield.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.runeKiteshield.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneKiteshield.prototype, "inventoryImage", {
        get: function () {
            return Rune_kiteshield_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneKiteshield.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.RUNE_KITESHIELD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuneKiteshield.prototype, "weight", {
        get: function () {
            return 5.443;
        },
        enumerable: false,
        configurable: true
    });
    return RuneKiteshield;
}(Offhand/* Offhand */.f));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Saradomin_d'hide_body.png
const Saradomin_d_hide_body_namespaceObject = __webpack_require__.p + "a2157c65b24180833483.png";
;// CONCATENATED MODULE: ./src/content/equipment/SaradominBody.ts
var SaradominBody_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var SaradominBody = /** @class */ (function (_super) {
    SaradominBody_extends(SaradominBody, _super);
    function SaradominBody() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -15,
                range: 30,
            },
            defence: {
                stab: 55,
                slash: 47,
                crush: 60,
                magic: 50,
                range: 55,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(SaradominBody.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.saradominDhideBody.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominBody.prototype, "inventoryImage", {
        get: function () {
            return Saradomin_d_hide_body_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominBody.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.SARADOMIN_D_HIDE_BODY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominBody.prototype, "weight", {
        get: function () {
            return 6;
        },
        enumerable: false,
        configurable: true
    });
    return SaradominBody;
}(Chest/* Chest */.k));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Saradomin_chaps.png
const Saradomin_chaps_namespaceObject = __webpack_require__.p + "fa0df6d30ba889e9d0fd.png";
;// CONCATENATED MODULE: ./src/content/equipment/SaradominChaps.ts
var SaradominChaps_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var SaradominChaps = /** @class */ (function (_super) {
    SaradominChaps_extends(SaradominChaps, _super);
    function SaradominChaps() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: 17,
            },
            defence: {
                stab: 31,
                slash: 25,
                crush: 33,
                magic: 28,
                range: 31,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(SaradominChaps.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.saradominChaps.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominChaps.prototype, "inventoryImage", {
        get: function () {
            return Saradomin_chaps_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominChaps.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.SARADOMIN_D_HIDE_CHAPS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominChaps.prototype, "weight", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    return SaradominChaps;
}(Legs/* Legs */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Saradomin_coif.png
const Saradomin_coif_namespaceObject = __webpack_require__.p + "faadf937db7f869441d1.png";
;// CONCATENATED MODULE: ./src/content/equipment/SaradominCoif.ts
var SaradominCoif_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var SaradominCoif = /** @class */ (function (_super) {
    SaradominCoif_extends(SaradominCoif, _super);
    function SaradominCoif() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -1,
                range: 7,
            },
            defence: {
                stab: 4,
                slash: 7,
                crush: 10,
                magic: 4,
                range: 8,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(SaradominCoif.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.saradominCoif.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominCoif.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.SARADOMIN_COIF;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominCoif.prototype, "weight", {
        get: function () {
            return 0.9;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominCoif.prototype, "inventoryImage", {
        get: function () {
            return Saradomin_coif_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return SaradominCoif;
}(Helmet/* Helmet */.m));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Saradomin_d'hide_boots.png
const Saradomin_d_hide_boots_namespaceObject = __webpack_require__.p + "c664deaa02cd04f05e50.png";
;// CONCATENATED MODULE: ./src/content/equipment/SaradominDhideBoots.ts
var SaradominDhideBoots_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var SaradominDhideBoots = /** @class */ (function (_super) {
    SaradominDhideBoots_extends(SaradominDhideBoots, _super);
    function SaradominDhideBoots() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -10,
                range: 7,
            },
            defence: {
                stab: 4,
                slash: 4,
                crush: 4,
                magic: 4,
                range: 43,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(SaradominDhideBoots.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.saradominDhideBoots.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominDhideBoots.prototype, "inventoryImage", {
        get: function () {
            return Saradomin_d_hide_boots_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominDhideBoots.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.SARADOMIN_D_HIDE_BOOTS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominDhideBoots.prototype, "weight", {
        get: function () {
            return 1.4;
        },
        enumerable: false,
        configurable: true
    });
    return SaradominDhideBoots;
}(Feet/* Feet */.v));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Slayer_helmet_imbued.png
const Slayer_helmet_imbued_namespaceObject = __webpack_require__.p + "8e4333a69302dacf6ddb.png";
;// CONCATENATED MODULE: ./src/content/equipment/SlayerHelmet.ts
var SlayerHelmet_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var SlayerHelmet = /** @class */ (function (_super) {
    SlayerHelmet_extends(SlayerHelmet, _super);
    function SlayerHelmet() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 3,
                range: 3,
            },
            defence: {
                stab: 30,
                slash: 32,
                crush: 27,
                magic: 10,
                range: 30,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(SlayerHelmet.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.slayerHelmetI.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SlayerHelmet.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.SLAYER_HELMET_I;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SlayerHelmet.prototype, "weight", {
        get: function () {
            return 2.267;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SlayerHelmet.prototype, "inventoryImage", {
        get: function () {
            return Slayer_helmet_imbued_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return SlayerHelmet;
}(Helmet/* Helmet */.m));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Torva_full_helm.png
const Torva_full_helm_namespaceObject = __webpack_require__.p + "fb3a28ae5f0e22557c22.png";
;// CONCATENATED MODULE: ./src/content/equipment/TorvaFullhelm.ts
var TorvaFullhelm_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var TorvaFullhelm = /** @class */ (function (_super) {
    TorvaFullhelm_extends(TorvaFullhelm, _super);
    function TorvaFullhelm() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -5,
                range: -5,
            },
            defence: {
                stab: 59,
                slash: 60,
                crush: 62,
                magic: -2,
                range: 57,
            },
            other: {
                meleeStrength: 8,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(TorvaFullhelm.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.torvaFullHelm.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaFullhelm.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.TORVA_FULL_HELM;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaFullhelm.prototype, "weight", {
        get: function () {
            return 2.721;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaFullhelm.prototype, "inventoryImage", {
        get: function () {
            return Torva_full_helm_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return TorvaFullhelm;
}(Helmet/* Helmet */.m));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Torva_platebody.png
const Torva_platebody_namespaceObject = __webpack_require__.p + "8aea30662351c7f44539.png";
;// CONCATENATED MODULE: ./src/content/equipment/TorvaPlatebody.ts
var TorvaPlatebody_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var TorvaPlatebody = /** @class */ (function (_super) {
    TorvaPlatebody_extends(TorvaPlatebody, _super);
    function TorvaPlatebody() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -18,
                range: -14,
            },
            defence: {
                stab: 117,
                slash: 111,
                crush: 117,
                magic: -11,
                range: 142,
            },
            other: {
                meleeStrength: 6,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(TorvaPlatebody.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.torvaPlatebody.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaPlatebody.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.TORVA_PLATEBODY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaPlatebody.prototype, "weight", {
        get: function () {
            return 9.979;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaPlatebody.prototype, "inventoryImage", {
        get: function () {
            return Torva_platebody_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return TorvaPlatebody;
}(Chest/* Chest */.k));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Torva_platelegs.png
const Torva_platelegs_namespaceObject = __webpack_require__.p + "63d41a914ed6fb1ae456.png";
;// CONCATENATED MODULE: ./src/content/equipment/TorvaPlatelegs.ts
var TorvaPlatelegs_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var TorvaPlatelegs = /** @class */ (function (_super) {
    TorvaPlatelegs_extends(TorvaPlatelegs, _super);
    function TorvaPlatelegs() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: -24,
                range: -11,
            },
            defence: {
                stab: 87,
                slash: 78,
                crush: 79,
                magic: -9,
                range: 102,
            },
            other: {
                meleeStrength: 4,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(TorvaPlatelegs.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.torvaPlatelegs.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaPlatelegs.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.TORVA_PLATELEGS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaPlatelegs.prototype, "weight", {
        get: function () {
            return 9.071;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TorvaPlatelegs.prototype, "inventoryImage", {
        get: function () {
            return Torva_platelegs_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return TorvaPlatelegs;
}(Legs/* Legs */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Oathplate_helm.png
const Oathplate_helm_namespaceObject = __webpack_require__.p + "73cebe2ca19da64ff87b.png";
;// CONCATENATED MODULE: ./src/content/equipment/OathplateHelm.ts
var OathplateHelm_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var OathplateHelm = /** @class */ (function (_super) {
    OathplateHelm_extends(OathplateHelm, _super);
    function OathplateHelm() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: { stab: 0, slash: 10, crush: 0, magic: -2, range: -7 },
            defence: { stab: 50, slash: 72, crush: 45, magic: 0, range: 50 },
            other: { meleeStrength: 6, rangedStrength: 0, magicDamage: 0, prayer: 0 },
            targetSpecific: { undead: 0, slayer: 0 },
        };
        return _this;
    }
    Object.defineProperty(OathplateHelm.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.oathplateHelm.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OathplateHelm.prototype, "inventoryImage", {
        get: function () {
            return Oathplate_helm_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OathplateHelm.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.OATHPLATE_HELM;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OathplateHelm.prototype, "weight", {
        get: function () {
            return 2.721;
        },
        enumerable: false,
        configurable: true
    });
    return OathplateHelm;
}(Helmet/* Helmet */.m));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Oathplate_chest.png
const Oathplate_chest_namespaceObject = __webpack_require__.p + "4849c71077c0b59f0a42.png";
;// CONCATENATED MODULE: ./src/content/equipment/OathplateChest.ts
var OathplateChest_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/** The OSRS item is named "Oathplate chest"; it occupies the body slot. */
var OathplateChest = /** @class */ (function (_super) {
    OathplateChest_extends(OathplateChest, _super);
    function OathplateChest() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: { stab: 0, slash: 16, crush: 0, magic: -16, range: -18 },
            defence: { stab: 105, slash: 128, crush: 100, magic: -5, range: 112 },
            other: { meleeStrength: 4, rangedStrength: 0, magicDamage: 0, prayer: 0 },
            targetSpecific: { undead: 0, slayer: 0 },
        };
        return _this;
    }
    Object.defineProperty(OathplateChest.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.oathplateChest.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OathplateChest.prototype, "inventoryImage", {
        get: function () {
            return Oathplate_chest_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OathplateChest.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.OATHPLATE_CHEST;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OathplateChest.prototype, "weight", {
        get: function () {
            return 9.979;
        },
        enumerable: false,
        configurable: true
    });
    return OathplateChest;
}(Chest/* Chest */.k));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Oathplate_legs.png
const Oathplate_legs_namespaceObject = __webpack_require__.p + "cbc7cded6a15f5a8c5d3.png";
;// CONCATENATED MODULE: ./src/content/equipment/OathplateLegs.ts
var OathplateLegs_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var OathplateLegs = /** @class */ (function (_super) {
    OathplateLegs_extends(OathplateLegs, _super);
    function OathplateLegs() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: { stab: 0, slash: 12, crush: 0, magic: -12, range: -14 },
            defence: { stab: 75, slash: 100, crush: 73, magic: -3, range: 81 },
            other: { meleeStrength: 2, rangedStrength: 0, magicDamage: 0, prayer: 0 },
            targetSpecific: { undead: 0, slayer: 0 },
        };
        return _this;
    }
    Object.defineProperty(OathplateLegs.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.oathplateLegs.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OathplateLegs.prototype, "inventoryImage", {
        get: function () {
            return Oathplate_legs_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OathplateLegs.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.OATHPLATE_LEGS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OathplateLegs.prototype, "weight", {
        get: function () {
            return 9.071;
        },
        enumerable: false,
        configurable: true
    });
    return OathplateLegs;
}(Legs/* Legs */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ultor_ring.png
const Ultor_ring_namespaceObject = __webpack_require__.p + "e15c2dcd7da909808905.png";
;// CONCATENATED MODULE: ./src/content/equipment/UltorRing.ts
var UltorRing_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var UltorRing = /** @class */ (function (_super) {
    UltorRing_extends(UltorRing, _super);
    function UltorRing() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 12,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(UltorRing.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.ultorRing.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UltorRing.prototype, "inventoryImage", {
        get: function () {
            return Ultor_ring_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UltorRing.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ULTOR_RING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UltorRing.prototype, "weight", {
        get: function () {
            return 0.012;
        },
        enumerable: false,
        configurable: true
    });
    return UltorRing;
}(Ring/* Ring */.J));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Zaryte_vambraces.png
const Zaryte_vambraces_namespaceObject = __webpack_require__.p + "8a9b26ff4e684d18c31c.png";
;// CONCATENATED MODULE: ./src/content/equipment/ZaryteVambraces.ts
var ZaryteVambraces_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var ZaryteVambraces = /** @class */ (function (_super) {
    ZaryteVambraces_extends(ZaryteVambraces, _super);
    function ZaryteVambraces() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: -8,
                slash: -8,
                crush: -8,
                magic: 0,
                range: 18,
            },
            defence: {
                stab: 8,
                slash: 8,
                crush: 8,
                magic: 5,
                range: 8,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 2,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(ZaryteVambraces.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.zaryteVambraces.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZaryteVambraces.prototype, "inventoryImage", {
        get: function () {
            return Zaryte_vambraces_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZaryteVambraces.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ZARYTE_VAMBRACES;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZaryteVambraces.prototype, "weight", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ZaryteVambraces;
}(Gloves/* Gloves */.L));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Confliction_gauntlets.png
const Confliction_gauntlets_namespaceObject = __webpack_require__.p + "4b01b188a35919eb4450.png";
;// CONCATENATED MODULE: ./src/content/equipment/ConflictionGauntlets.ts
var ConflictionGauntlets_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/** Raw equipment bonuses for the confliction gauntlets.
 *
 * The gauntlets' missed-hit accuracy reroll is intentionally not modelled;
 * this class only describes their item stats and cache model.
 */
var ConflictionGauntlets = /** @class */ (function (_super) {
    ConflictionGauntlets_extends(ConflictionGauntlets, _super);
    function ConflictionGauntlets() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 20,
                range: -4,
            },
            defence: {
                stab: 15,
                slash: 18,
                crush: 7,
                magic: 5,
                range: 5,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0.07,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(ConflictionGauntlets.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.conflictionGauntlets.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConflictionGauntlets.prototype, "inventoryImage", {
        get: function () {
            return Confliction_gauntlets_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConflictionGauntlets.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.CONFLICTION_GAUNTLETS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConflictionGauntlets.prototype, "weight", {
        get: function () {
            return 0.226;
        },
        enumerable: false,
        configurable: true
    });
    return ConflictionGauntlets;
}(Gloves/* Gloves */.L));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Blue_moon_helm.png
const Blue_moon_helm_namespaceObject = __webpack_require__.p + "59fd7be03e8e692d05c1.png";
;// CONCATENATED MODULE: ./src/content/equipment/BlueMoonHelm.ts
var BlueMoonHelm_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var BlueMoonHelm = /** @class */ (function (_super) {
    BlueMoonHelm_extends(BlueMoonHelm, _super);
    function BlueMoonHelm() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 6,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 10,
                magic: 6,
                range: 0,
            },
            other: {
                meleeStrength: 3,
                rangedStrength: 0,
                magicDamage: 0.01,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BlueMoonHelm.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.blueMoonHelm.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonHelm.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BLUE_MOON_HELM;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonHelm.prototype, "weight", {
        get: function () {
            return 0.453;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonHelm.prototype, "inventoryImage", {
        get: function () {
            return Blue_moon_helm_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return BlueMoonHelm;
}(Helmet/* Helmet */.m));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Blue_moon_chestplate.png
const Blue_moon_chestplate_namespaceObject = __webpack_require__.p + "eadbf5beaa5d4b498231.png";
;// CONCATENATED MODULE: ./src/content/equipment/BlueMoonChestplate.ts
var BlueMoonChestplate_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var BlueMoonChestplate = /** @class */ (function (_super) {
    BlueMoonChestplate_extends(BlueMoonChestplate, _super);
    function BlueMoonChestplate() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 30,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 51,
                magic: 28,
                range: 0,
            },
            other: {
                meleeStrength: 2,
                rangedStrength: 0,
                magicDamage: 0.01,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BlueMoonChestplate.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.blueMoonChestplate.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonChestplate.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BLUE_MOON_CHESTPLATE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonChestplate.prototype, "weight", {
        get: function () {
            return 3.175;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonChestplate.prototype, "inventoryImage", {
        get: function () {
            return Blue_moon_chestplate_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return BlueMoonChestplate;
}(Chest/* Chest */.k));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Blue_moon_tassets.png
const Blue_moon_tassets_namespaceObject = __webpack_require__.p + "22ad109fcd7fd567def7.png";
;// CONCATENATED MODULE: ./src/content/equipment/BlueMoonTassets.ts
var BlueMoonTassets_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var BlueMoonTassets = /** @class */ (function (_super) {
    BlueMoonTassets_extends(BlueMoonTassets, _super);
    function BlueMoonTassets() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 22,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 23,
                magic: 32,
                range: 0,
            },
            other: {
                meleeStrength: 1,
                rangedStrength: 0,
                magicDamage: 0.01,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BlueMoonTassets.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.blueMoonTassets.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonTassets.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BLUE_MOON_TASSETS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonTassets.prototype, "weight", {
        get: function () {
            return 1.36;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonTassets.prototype, "inventoryImage", {
        get: function () {
            return Blue_moon_tassets_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return BlueMoonTassets;
}(Legs/* Legs */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Eternal_boots.png
const Eternal_boots_namespaceObject = __webpack_require__.p + "6457a2358cd8a2fa112c.png";
;// CONCATENATED MODULE: ./src/content/equipment/EternalBoots.ts
var EternalBoots_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EternalBoots = /** @class */ (function (_super) {
    EternalBoots_extends(EternalBoots, _super);
    function EternalBoots() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 8,
                range: 0,
            },
            defence: {
                stab: 5,
                slash: 5,
                crush: 5,
                magic: 8,
                range: 5,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0.01,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(EternalBoots.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.eternalBoots.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EternalBoots.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ETERNAL_BOOTS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EternalBoots.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EternalBoots.prototype, "inventoryImage", {
        get: function () {
            return Eternal_boots_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return EternalBoots;
}(Feet/* Feet */.v));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Amulet_of_blood_fury.png
const Amulet_of_blood_fury_namespaceObject = __webpack_require__.p + "3fe4be429e52af09ea82.png";
;// CONCATENATED MODULE: ./src/content/equipment/AmuletOfBloodFury.ts
var AmuletOfBloodFury_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var AmuletOfBloodFury = /** @class */ (function (_super) {
    AmuletOfBloodFury_extends(AmuletOfBloodFury, _super);
    function AmuletOfBloodFury() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 10,
                slash: 10,
                crush: 10,
                magic: 10,
                range: 10,
            },
            defence: {
                stab: 15,
                slash: 15,
                crush: 15,
                magic: 15,
                range: 15,
            },
            other: {
                meleeStrength: 8,
                rangedStrength: 0,
                magicDamage: 0.0,
                prayer: 5,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AmuletOfBloodFury.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.amuletOfBloodFury.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfBloodFury.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.AMULET_OF_BLOOD_FURY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfBloodFury.prototype, "weight", {
        get: function () {
            return 0.02;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmuletOfBloodFury.prototype, "inventoryImage", {
        get: function () {
            return Amulet_of_blood_fury_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return AmuletOfBloodFury;
}(Necklace/* Necklace */.T));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Radas_blessing_4.png
const Radas_blessing_4_namespaceObject = __webpack_require__.p + "46911bd8fbd7cca0f719.png";
;// CONCATENATED MODULE: ./src/content/equipment/RadasBlessing4.ts
var RadasBlessing4_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var RadasBlessing4 = /** @class */ (function (_super) {
    RadasBlessing4_extends(RadasBlessing4, _super);
    function RadasBlessing4() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0.0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(RadasBlessing4.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.radasBlessing4.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RadasBlessing4.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.RADAS_BLESSING_4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RadasBlessing4.prototype, "weight", {
        get: function () {
            return 0.453;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RadasBlessing4.prototype, "inventoryImage", {
        get: function () {
            return Radas_blessing_4_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    RadasBlessing4.prototype.ammoType = function () {
        return Ammo/* AmmoType */.T.BLESSING;
    };
    return RadasBlessing4;
}(Ammo/* Ammo */.d));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Fire_cape.png
const Fire_cape_namespaceObject = __webpack_require__.p + "90d4aa489e6628d2916b.png";
;// CONCATENATED MODULE: ./src/content/equipment/FireCape.ts
var FireCape_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var FireCape = /** @class */ (function (_super) {
    FireCape_extends(FireCape, _super);
    function FireCape() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.bonuses = {
            attack: {
                stab: 1,
                slash: 1,
                crush: 1,
                magic: 1,
                range: 1,
            },
            defence: {
                stab: 11,
                slash: 11,
                crush: 11,
                magic: 11,
                range: 11,
            },
            other: {
                meleeStrength: 4,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(FireCape.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.fireCape.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FireCape.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.FIRE_CAPE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FireCape.prototype, "weight", {
        get: function () {
            return 0.453;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FireCape.prototype, "inventoryImage", {
        get: function () {
            return Fire_cape_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return FireCape;
}(Cape/* Cape */.Q));


;// CONCATENATED MODULE: ./src/content/equipment/index.ts
// generated using Generate Index https://marketplace.visualstudio.com/items?itemName=JayFong.generate-index
// @index('./*.ts', f => `export { ${f.name} } from './${f.name}';`)













































































/***/ }),

/***/ 2202:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ArmadylBrew: () => (/* reexport */ ArmadylBrew),
  BastionPotion: () => (/* reexport */ BastionPotion),
  Karambwan: () => (/* reexport */ Karambwan),
  PrayerRegenerationPotion: () => (/* reexport */ PrayerRegenerationPotion),
  RangingPotion: () => (/* reexport */ RangingPotion),
  SaradominBrew: () => (/* reexport */ SaradominBrew),
  Shark: () => (/* reexport */ Shark),
  StaminaPotion: () => (/* reexport */ StaminaPotion),
  SuperCombatPotion: () => (/* reexport */ SuperCombatPotion),
  SuperRestore: () => (/* reexport */ SuperRestore)
});

;// CONCATENATED MODULE: ./src/assets/images/potions/Bastion_potion_1.png
const Bastion_potion_1_namespaceObject = __webpack_require__.p + "636af55bf883f8ae8c0b.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Bastion_potion_2.png
const Bastion_potion_2_namespaceObject = __webpack_require__.p + "e5792ad36f5016aa44a6.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Bastion_potion_3.png
const Bastion_potion_3_namespaceObject = __webpack_require__.p + "0f9949a5d8115814d9c7.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Bastion_potion_4.png
const Bastion_potion_4_namespaceObject = __webpack_require__.p + "13c4b13062891ea6eb45.png";
// EXTERNAL MODULE: ./src/assets/images/potions/Vial.png
var Vial = __webpack_require__(155);
// EXTERNAL MODULE: ./src/assets/CacheAssets.ts
var CacheAssets = __webpack_require__(4655);
// EXTERNAL MODULE: ./src/sdk/ItemName.ts
var ItemName = __webpack_require__(243);
// EXTERNAL MODULE: ./src/sdk/gear/Potion.ts + 1 modules
var Potion = __webpack_require__(6338);
// EXTERNAL MODULE: ./src/sdk/utils/ImageLoader.ts
var ImageLoader = __webpack_require__(2987);
;// CONCATENATED MODULE: ./src/content/items/BastionPotion.ts
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var BastionPotion = /** @class */ (function (_super) {
    __extends(BastionPotion, _super);
    function BastionPotion(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader/* ImageLoader */.$.createImage(Bastion_potion_1_namespaceObject);
        _this.twoDose = ImageLoader/* ImageLoader */.$.createImage(Bastion_potion_2_namespaceObject);
        _this.threeDose = ImageLoader/* ImageLoader */.$.createImage(Bastion_potion_3_namespaceObject);
        _this.fourDose = ImageLoader/* ImageLoader */.$.createImage(Bastion_potion_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(BastionPotion.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.bastionPotion.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BastionPotion.prototype, "weight", {
        get: function () {
            if (this.doses === 4) {
                return 0.134;
            }
            return 0.03; // Yep, lol
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BastionPotion.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4) {
                return Bastion_potion_4_namespaceObject;
            }
            else if (this.doses === 3) {
                return Bastion_potion_3_namespaceObject;
            }
            else if (this.doses === 2) {
                return Bastion_potion_2_namespaceObject;
            }
            else if (this.doses === 1) {
                return Bastion_potion_1_namespaceObject;
            }
            return Vial;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BastionPotion.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BASTION_POTION;
        },
        enumerable: false,
        configurable: true
    });
    BastionPotion.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        var rangedBoost = Math.floor(player.stats.range * 0.1) + 4;
        player.currentStats.range += rangedBoost;
        player.currentStats.range = Math.min(player.currentStats.range, player.stats.range + rangedBoost);
        var defenceBoost = Math.floor(player.stats.defence * 0.15) + 5;
        player.currentStats.defence += defenceBoost;
        player.currentStats.defence = Math.min(player.currentStats.defence, player.stats.defence + defenceBoost);
    };
    BastionPotion.prototype.updateInventorySprite = function () {
        if (this.doses === 4) {
            this.inventorySprite = this.fourDose;
        }
        else if (this.doses === 3) {
            this.inventorySprite = this.threeDose;
        }
        else if (this.doses === 2) {
            this.inventorySprite = this.twoDose;
        }
        else if (this.doses === 1) {
            this.inventorySprite = this.oneDose;
        }
        else {
            this.inventorySprite = this.vial;
        }
    };
    return BastionPotion;
}(Potion/* Potion */.E));


;// CONCATENATED MODULE: ./src/assets/images/potions/Cooked_karambwan.png
const Cooked_karambwan_namespaceObject = __webpack_require__.p + "dc6865db7096d28466a1.png";
// EXTERNAL MODULE: ./src/sdk/gear/Food.ts
var Food = __webpack_require__(7719);
;// CONCATENATED MODULE: ./src/content/items/Karambwan.ts
var Karambwan_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Karambwan = /** @class */ (function (_super) {
    Karambwan_extends(Karambwan, _super);
    function Karambwan() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.healAmount = 18;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(Cooked_karambwan_namespaceObject);
        return _this;
    }
    Object.defineProperty(Karambwan.prototype, "inventoryImage", {
        get: function () {
            return Cooked_karambwan_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Karambwan.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.KARAMBWAN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Karambwan.prototype, "weight", {
        get: function () {
            return 0.65;
        },
        enumerable: false,
        configurable: true
    });
    Karambwan.prototype.inventoryLeftClick = function (player) {
        player.eats.eatComboFood(this);
    };
    return Karambwan;
}(Food/* Food */.N));


;// CONCATENATED MODULE: ./src/assets/images/potions/Saradomin_brew_1.png
const Saradomin_brew_1_namespaceObject = __webpack_require__.p + "6d301986630e5cd961a3.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Saradomin_brew_2.png
const Saradomin_brew_2_namespaceObject = __webpack_require__.p + "07bda9025bed6f655105.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Saradomin_brew_3.png
const Saradomin_brew_3_namespaceObject = __webpack_require__.p + "ec6a5f708194be82511e.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Saradomin_brew_4.png
const Saradomin_brew_4_namespaceObject = __webpack_require__.p + "a576a0f0be7654477a6a.png";
;// CONCATENATED MODULE: ./src/content/items/SaradominBrew.ts
var SaradominBrew_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var SaradominBrew = /** @class */ (function (_super) {
    SaradominBrew_extends(SaradominBrew, _super);
    function SaradominBrew(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader/* ImageLoader */.$.createImage(Saradomin_brew_1_namespaceObject);
        _this.twoDose = ImageLoader/* ImageLoader */.$.createImage(Saradomin_brew_2_namespaceObject);
        _this.threeDose = ImageLoader/* ImageLoader */.$.createImage(Saradomin_brew_3_namespaceObject);
        _this.fourDose = ImageLoader/* ImageLoader */.$.createImage(Saradomin_brew_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(SaradominBrew.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.saradominBrew.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominBrew.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4) {
                return Saradomin_brew_4_namespaceObject;
            }
            else if (this.doses === 3) {
                return Saradomin_brew_3_namespaceObject;
            }
            else if (this.doses === 2) {
                return Saradomin_brew_2_namespaceObject;
            }
            else if (this.doses === 1) {
                return Saradomin_brew_1_namespaceObject;
            }
            return Vial;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominBrew.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.SARADOMIN_BREW;
        },
        enumerable: false,
        configurable: true
    });
    SaradominBrew.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        var healAmount = Math.floor(player.stats.hitpoint * 0.15) + 2;
        player.currentStats.hitpoint += healAmount;
        player.currentStats.hitpoint = Math.max(1, Math.min(player.currentStats.hitpoint, player.stats.hitpoint + healAmount));
        var defenceBoost = Math.floor(player.currentStats.defence * 0.2) + 2;
        var maxDefenceBoost = Math.floor(player.stats.defence * 0.2) + 2;
        player.currentStats.defence += defenceBoost;
        player.currentStats.defence = Math.max(1, Math.min(player.currentStats.defence, player.stats.defence + maxDefenceBoost));
        var attackNerf = Math.floor(player.currentStats.attack * 0.1) + 2;
        player.currentStats.attack -= attackNerf;
        player.currentStats.attack = Math.max(1, Math.min(player.currentStats.attack, player.stats.attack + attackNerf));
        var strengthNerf = Math.floor(player.currentStats.strength * 0.1) + 2;
        player.currentStats.strength -= strengthNerf;
        player.currentStats.strength = Math.max(1, Math.min(player.currentStats.strength, player.stats.strength + strengthNerf));
        var rangeNerf = Math.floor(player.currentStats.range * 0.1) + 2;
        player.currentStats.range -= rangeNerf;
        player.currentStats.range = Math.max(1, Math.min(player.currentStats.range, player.stats.range + rangeNerf));
        var magicNerf = Math.floor(player.currentStats.magic * 0.1) + 2;
        player.currentStats.magic -= magicNerf;
        player.currentStats.magic = Math.max(1, Math.min(player.currentStats.magic, player.stats.magic + magicNerf));
    };
    SaradominBrew.prototype.updateInventorySprite = function () {
        if (this.doses === 4) {
            this.inventorySprite = this.fourDose;
        }
        else if (this.doses === 3) {
            this.inventorySprite = this.threeDose;
        }
        else if (this.doses === 2) {
            this.inventorySprite = this.twoDose;
        }
        else if (this.doses === 1) {
            this.inventorySprite = this.oneDose;
        }
        else {
            this.inventorySprite = this.vial;
        }
    };
    return SaradominBrew;
}(Potion/* Potion */.E));


;// CONCATENATED MODULE: ./src/assets/images/potions/Shark.png
const Shark_namespaceObject = __webpack_require__.p + "5fd9b1d13620db82a7ba.png";
;// CONCATENATED MODULE: ./src/content/items/Shark.ts
var Shark_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Shark = /** @class */ (function (_super) {
    Shark_extends(Shark, _super);
    function Shark() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.healAmount = 20;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(Shark_namespaceObject);
        return _this;
    }
    Object.defineProperty(Shark.prototype, "inventoryImage", {
        get: function () {
            return Shark_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Shark.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.SHARK;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Shark.prototype, "weight", {
        get: function () {
            return 0.65;
        },
        enumerable: false,
        configurable: true
    });
    return Shark;
}(Food/* Food */.N));


;// CONCATENATED MODULE: ./src/assets/images/potions/Stamina_potion_1.png
const Stamina_potion_1_namespaceObject = __webpack_require__.p + "fb99098de0399de96dc7.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Stamina_potion_2.png
const Stamina_potion_2_namespaceObject = __webpack_require__.p + "aadc9ce4a625f6c0b93a.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Stamina_potion_3.png
const Stamina_potion_3_namespaceObject = __webpack_require__.p + "6ca719b61b657e86ba8f.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Stamina_potion_4.png
const Stamina_potion_4_namespaceObject = __webpack_require__.p + "d0a151c232cc32080774.png";
;// CONCATENATED MODULE: ./src/content/items/StaminaPotion.ts
var StaminaPotion_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var StaminaPotion = /** @class */ (function (_super) {
    StaminaPotion_extends(StaminaPotion, _super);
    function StaminaPotion(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader/* ImageLoader */.$.createImage(Stamina_potion_1_namespaceObject);
        _this.twoDose = ImageLoader/* ImageLoader */.$.createImage(Stamina_potion_2_namespaceObject);
        _this.threeDose = ImageLoader/* ImageLoader */.$.createImage(Stamina_potion_3_namespaceObject);
        _this.fourDose = ImageLoader/* ImageLoader */.$.createImage(Stamina_potion_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(StaminaPotion.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.staminaPotion.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaminaPotion.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4) {
                return Stamina_potion_4_namespaceObject;
            }
            else if (this.doses === 3) {
                return Stamina_potion_3_namespaceObject;
            }
            else if (this.doses === 2) {
                return Stamina_potion_2_namespaceObject;
            }
            else if (this.doses === 1) {
                return Stamina_potion_1_namespaceObject;
            }
            return Vial;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaminaPotion.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.STAMINA_POTION;
        },
        enumerable: false,
        configurable: true
    });
    StaminaPotion.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        player.effects.stamina = 200; // 2 minutes = 200 ticks
        player.currentStats.run += 2000;
        player.currentStats.run = Math.min(Math.max(player.currentStats.run, 0), 10000);
    };
    StaminaPotion.prototype.updateInventorySprite = function () {
        if (this.doses === 4) {
            this.inventorySprite = this.fourDose;
        }
        else if (this.doses === 3) {
            this.inventorySprite = this.threeDose;
        }
        else if (this.doses === 2) {
            this.inventorySprite = this.twoDose;
        }
        else if (this.doses === 1) {
            this.inventorySprite = this.oneDose;
        }
        else {
            this.inventorySprite = this.vial;
        }
    };
    return StaminaPotion;
}(Potion/* Potion */.E));


;// CONCATENATED MODULE: ./src/assets/images/potions/Super_combat_potion_1.png
const Super_combat_potion_1_namespaceObject = __webpack_require__.p + "b6f74412d077c073d2b6.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Super_combat_potion_2.png
const Super_combat_potion_2_namespaceObject = __webpack_require__.p + "336099951e549fed3760.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Super_combat_potion_3.png
const Super_combat_potion_3_namespaceObject = __webpack_require__.p + "4879c086e7bbb593b315.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Super_combat_potion_4.png
const Super_combat_potion_4_namespaceObject = __webpack_require__.p + "8fcc0e9f8e481a8e2bbb.png";
;// CONCATENATED MODULE: ./src/content/items/SuperCombatPotion.ts
var SuperCombatPotion_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var SuperCombatPotion = /** @class */ (function (_super) {
    SuperCombatPotion_extends(SuperCombatPotion, _super);
    function SuperCombatPotion(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader/* ImageLoader */.$.createImage(Super_combat_potion_1_namespaceObject);
        _this.twoDose = ImageLoader/* ImageLoader */.$.createImage(Super_combat_potion_2_namespaceObject);
        _this.threeDose = ImageLoader/* ImageLoader */.$.createImage(Super_combat_potion_3_namespaceObject);
        _this.fourDose = ImageLoader/* ImageLoader */.$.createImage(Super_combat_potion_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(SuperCombatPotion.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.superCombatPotion.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperCombatPotion.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4) {
                return Super_combat_potion_4_namespaceObject;
            }
            else if (this.doses === 3) {
                return Super_combat_potion_3_namespaceObject;
            }
            else if (this.doses === 2) {
                return Super_combat_potion_2_namespaceObject;
            }
            else if (this.doses === 1) {
                return Super_combat_potion_1_namespaceObject;
            }
            return Vial;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperCombatPotion.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.SUPER_COMBAT_POTION;
        },
        enumerable: false,
        configurable: true
    });
    SuperCombatPotion.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        var boost = function (stat) {
            var boost = Math.floor(player.stats[stat] * 0.15) + 5;
            player.currentStats[stat] += boost;
            player.currentStats[stat] = Math.min(player.currentStats[stat], player.stats[stat] + boost);
        };
        boost('strength');
        boost('attack');
        boost('defence');
    };
    SuperCombatPotion.prototype.updateInventorySprite = function () {
        if (this.doses === 4) {
            this.inventorySprite = this.fourDose;
        }
        else if (this.doses === 3) {
            this.inventorySprite = this.threeDose;
        }
        else if (this.doses === 2) {
            this.inventorySprite = this.twoDose;
        }
        else if (this.doses === 1) {
            this.inventorySprite = this.oneDose;
        }
        else {
            this.inventorySprite = this.vial;
        }
    };
    return SuperCombatPotion;
}(Potion/* Potion */.E));


;// CONCATENATED MODULE: ./src/assets/images/potions/Super_restore_1.png
const Super_restore_1_namespaceObject = __webpack_require__.p + "892a956fd6bf47c01da2.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Super_restore_2.png
const Super_restore_2_namespaceObject = __webpack_require__.p + "80698cf160e1397c6584.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Super_restore_3.png
const Super_restore_3_namespaceObject = __webpack_require__.p + "f133e18ee4792571230f.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Super_restore_4.png
const Super_restore_4_namespaceObject = __webpack_require__.p + "25999282f61594e19650.png";
;// CONCATENATED MODULE: ./src/content/items/SuperRestore.ts
var SuperRestore_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var SuperRestore = /** @class */ (function (_super) {
    SuperRestore_extends(SuperRestore, _super);
    function SuperRestore(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader/* ImageLoader */.$.createImage(Super_restore_1_namespaceObject);
        _this.twoDose = ImageLoader/* ImageLoader */.$.createImage(Super_restore_2_namespaceObject);
        _this.threeDose = ImageLoader/* ImageLoader */.$.createImage(Super_restore_3_namespaceObject);
        _this.fourDose = ImageLoader/* ImageLoader */.$.createImage(Super_restore_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(SuperRestore.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.superRestore.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperRestore.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4) {
                return Super_restore_4_namespaceObject;
            }
            else if (this.doses === 3) {
                return Super_restore_3_namespaceObject;
            }
            else if (this.doses === 2) {
                return Super_restore_2_namespaceObject;
            }
            else if (this.doses === 1) {
                return Super_restore_1_namespaceObject;
            }
            return Vial;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperRestore.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.SUPER_RESTORE;
        },
        enumerable: false,
        configurable: true
    });
    SuperRestore.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        var prayerBonus = Math.floor(player.stats.prayer * 0.27) + 8;
        player.currentStats.prayer += prayerBonus;
        player.currentStats.prayer = Math.min(player.currentStats.prayer, player.stats.prayer);
        if (player.currentStats.attack < player.stats.attack) {
            var attackBonus = Math.floor(player.stats.attack * 0.25) + 8;
            player.currentStats.attack += attackBonus;
            player.currentStats.attack = Math.min(player.currentStats.attack, player.stats.attack);
        }
        if (player.currentStats.strength < player.stats.strength) {
            var strengthBonus = Math.floor(player.stats.strength * 0.25) + 8;
            player.currentStats.strength += strengthBonus;
            player.currentStats.strength = Math.min(player.currentStats.strength, player.stats.strength);
        }
        if (player.currentStats.range < player.stats.range) {
            var rangeBonus = Math.floor(player.stats.range * 0.25) + 8;
            player.currentStats.range += rangeBonus;
            player.currentStats.range = Math.min(player.currentStats.range, player.stats.range);
        }
        if (player.currentStats.magic < player.stats.magic) {
            var magicBonus = Math.floor(player.stats.magic * 0.25) + 8;
            player.currentStats.magic += magicBonus;
            player.currentStats.magic = Math.min(player.currentStats.magic, player.stats.magic);
        }
        if (player.currentStats.defence < player.stats.defence) {
            var defenceBonus = Math.floor(player.stats.defence * 0.25) + 8;
            player.currentStats.defence += defenceBonus;
            player.currentStats.defence = Math.min(player.currentStats.defence, player.stats.defence);
        }
    };
    SuperRestore.prototype.updateInventorySprite = function () {
        if (this.doses === 4) {
            this.inventorySprite = this.fourDose;
        }
        else if (this.doses === 3) {
            this.inventorySprite = this.threeDose;
        }
        else if (this.doses === 2) {
            this.inventorySprite = this.twoDose;
        }
        else if (this.doses === 1) {
            this.inventorySprite = this.oneDose;
        }
        else {
            this.inventorySprite = this.vial;
        }
    };
    return SuperRestore;
}(Potion/* Potion */.E));


;// CONCATENATED MODULE: ./src/assets/images/potions/Armadyl_brew_1.png
const Armadyl_brew_1_namespaceObject = __webpack_require__.p + "556daa8e3734f8ff14e5.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Armadyl_brew_2.png
const Armadyl_brew_2_namespaceObject = __webpack_require__.p + "73744d0cc0e531f2eb47.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Armadyl_brew_3.png
const Armadyl_brew_3_namespaceObject = __webpack_require__.p + "d47816cf4d4c455af6ae.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Armadyl_brew_4.png
const Armadyl_brew_4_namespaceObject = __webpack_require__.p + "78e351b84968d46b498a.png";
;// CONCATENATED MODULE: ./src/content/items/ArmadylBrew.ts
var ArmadylBrew_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var ArmadylBrew = /** @class */ (function (_super) {
    ArmadylBrew_extends(ArmadylBrew, _super);
    function ArmadylBrew(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader/* ImageLoader */.$.createImage(Armadyl_brew_1_namespaceObject);
        _this.twoDose = ImageLoader/* ImageLoader */.$.createImage(Armadyl_brew_2_namespaceObject);
        _this.threeDose = ImageLoader/* ImageLoader */.$.createImage(Armadyl_brew_3_namespaceObject);
        _this.fourDose = ImageLoader/* ImageLoader */.$.createImage(Armadyl_brew_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(ArmadylBrew.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.armadylBrew.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylBrew.prototype, "weight", {
        get: function () {
            if (this.doses === 4) {
                return 0.035;
            }
            return 0.03;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylBrew.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4) {
                return Armadyl_brew_4_namespaceObject;
            }
            else if (this.doses === 3) {
                return Armadyl_brew_3_namespaceObject;
            }
            else if (this.doses === 2) {
                return Armadyl_brew_2_namespaceObject;
            }
            else if (this.doses === 1) {
                return Armadyl_brew_1_namespaceObject;
            }
            return Vial;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArmadylBrew.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.Armadyl_BREW;
        },
        enumerable: false,
        configurable: true
    });
    ArmadylBrew.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        var healAmount = Math.floor(player.stats.hitpoint * 0.1) + 2;
        player.currentStats.hitpoint += healAmount;
        player.currentStats.hitpoint = Math.max(1, Math.min(player.currentStats.hitpoint, player.stats.hitpoint + healAmount));
        var rangedBoost = Math.floor(player.stats.range * 0.1) + 4;
        var maxRangedBoost = Math.floor(player.stats.range * 0.1) + 4;
        player.currentStats.range += rangedBoost;
        player.currentStats.range = Math.max(1, Math.min(player.currentStats.range, player.stats.range + maxRangedBoost));
        var defenceNerf = Math.floor(player.currentStats.defence * 0.1) + 2;
        player.currentStats.defence -= defenceNerf;
        player.currentStats.defence = Math.max(1, Math.min(player.currentStats.defence, player.stats.defence + defenceNerf));
        var attackNerf = Math.floor(player.currentStats.attack * 0.1) + 2;
        player.currentStats.attack -= attackNerf;
        player.currentStats.attack = Math.max(1, Math.min(player.currentStats.attack, player.stats.attack + attackNerf));
        var strengthNerf = Math.floor(player.currentStats.strength * 0.1) + 2;
        player.currentStats.strength -= strengthNerf;
        player.currentStats.strength = Math.max(1, Math.min(player.currentStats.strength, player.stats.strength + strengthNerf));
        var magicNerf = Math.floor(player.currentStats.magic * 0.1) + 2;
        player.currentStats.magic -= magicNerf;
        player.currentStats.magic = Math.max(1, Math.min(player.currentStats.magic, player.stats.magic + magicNerf));
    };
    ArmadylBrew.prototype.updateInventorySprite = function () {
        if (this.doses === 4) {
            this.inventorySprite = this.fourDose;
        }
        else if (this.doses === 3) {
            this.inventorySprite = this.threeDose;
        }
        else if (this.doses === 2) {
            this.inventorySprite = this.twoDose;
        }
        else if (this.doses === 1) {
            this.inventorySprite = this.oneDose;
        }
        else {
            this.inventorySprite = this.vial;
        }
    };
    return ArmadylBrew;
}(Potion/* Potion */.E));


;// CONCATENATED MODULE: ./src/assets/images/potions/Ranging_potion_1.png
const Ranging_potion_1_namespaceObject = __webpack_require__.p + "4bacd92f5e290f747c19.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Ranging_potion_2.png
const Ranging_potion_2_namespaceObject = __webpack_require__.p + "0c6288e8c21a2cae1647.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Ranging_potion_3.png
const Ranging_potion_3_namespaceObject = __webpack_require__.p + "d73c5608bdd22cc62a33.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Ranging_potion_4.png
const Ranging_potion_4_namespaceObject = __webpack_require__.p + "818f84f1313e1b95513f.png";
;// CONCATENATED MODULE: ./src/content/items/RangingPotion.ts
var RangingPotion_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var RangingPotion = /** @class */ (function (_super) {
    RangingPotion_extends(RangingPotion, _super);
    function RangingPotion(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader/* ImageLoader */.$.createImage(Ranging_potion_1_namespaceObject);
        _this.twoDose = ImageLoader/* ImageLoader */.$.createImage(Ranging_potion_2_namespaceObject);
        _this.threeDose = ImageLoader/* ImageLoader */.$.createImage(Ranging_potion_3_namespaceObject);
        _this.fourDose = ImageLoader/* ImageLoader */.$.createImage(Ranging_potion_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(RangingPotion.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.rangingPotion.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RangingPotion.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4)
                return Ranging_potion_4_namespaceObject;
            if (this.doses === 3)
                return Ranging_potion_3_namespaceObject;
            if (this.doses === 2)
                return Ranging_potion_2_namespaceObject;
            if (this.doses === 1)
                return Ranging_potion_1_namespaceObject;
            return Vial;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RangingPotion.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.RANGING_POTION;
        },
        enumerable: false,
        configurable: true
    });
    RangingPotion.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        // +4 + 10% Ranged
        var boost = Math.floor(player.stats.range * 0.1) + 4;
        player.currentStats.range = Math.min(player.currentStats.range + boost, player.stats.range + boost);
    };
    RangingPotion.prototype.updateInventorySprite = function () {
        if (this.doses === 4)
            this.inventorySprite = this.fourDose;
        else if (this.doses === 3)
            this.inventorySprite = this.threeDose;
        else if (this.doses === 2)
            this.inventorySprite = this.twoDose;
        else if (this.doses === 1)
            this.inventorySprite = this.oneDose;
        else
            this.inventorySprite = this.vial;
    };
    return RangingPotion;
}(Potion/* Potion */.E));


;// CONCATENATED MODULE: ./src/assets/images/potions/Prayer_regeneration_potion_1.png
const Prayer_regeneration_potion_1_namespaceObject = __webpack_require__.p + "1a1ad4fd47fe8a8cf542.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Prayer_regeneration_potion_2.png
const Prayer_regeneration_potion_2_namespaceObject = __webpack_require__.p + "edcc5bd417cb75d96d3a.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Prayer_regeneration_potion_3.png
const Prayer_regeneration_potion_3_namespaceObject = __webpack_require__.p + "2d6f791ed408eaa6a0f1.png";
;// CONCATENATED MODULE: ./src/assets/images/potions/Prayer_regeneration_potion_4.png
const Prayer_regeneration_potion_4_namespaceObject = __webpack_require__.p + "8989355daae6c9c008d2.png";
;// CONCATENATED MODULE: ./src/content/items/PrayerRegenerationPotion.ts
var PrayerRegenerationPotion_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var PrayerRegenerationPotion = /** @class */ (function (_super) {
    PrayerRegenerationPotion_extends(PrayerRegenerationPotion, _super);
    function PrayerRegenerationPotion(doses) {
        if (doses === void 0) { doses = 4; }
        var _this = _super.call(this) || this;
        _this.oneDose = ImageLoader/* ImageLoader */.$.createImage(Prayer_regeneration_potion_1_namespaceObject);
        _this.twoDose = ImageLoader/* ImageLoader */.$.createImage(Prayer_regeneration_potion_2_namespaceObject);
        _this.threeDose = ImageLoader/* ImageLoader */.$.createImage(Prayer_regeneration_potion_3_namespaceObject);
        _this.fourDose = ImageLoader/* ImageLoader */.$.createImage(Prayer_regeneration_potion_4_namespaceObject);
        _this.doses = doses;
        _this.updateInventorySprite();
        return _this;
    }
    Object.defineProperty(PrayerRegenerationPotion.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.prayerRegenerationPotion.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrayerRegenerationPotion.prototype, "inventoryImage", {
        get: function () {
            if (this.doses === 4)
                return Prayer_regeneration_potion_4_namespaceObject;
            if (this.doses === 3)
                return Prayer_regeneration_potion_3_namespaceObject;
            if (this.doses === 2)
                return Prayer_regeneration_potion_2_namespaceObject;
            if (this.doses === 1)
                return Prayer_regeneration_potion_1_namespaceObject;
            return Vial;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrayerRegenerationPotion.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.PRAYER_REGENERATION_POTION;
        },
        enumerable: false,
        configurable: true
    });
    PrayerRegenerationPotion.prototype.drink = function (player) {
        _super.prototype.drink.call(this, player);
        // 1 Prayer point every 12 ticks for 8 minutes (800 ticks).
        player.effects.prayerRegeneration = 800;
    };
    PrayerRegenerationPotion.prototype.updateInventorySprite = function () {
        if (this.doses === 4)
            this.inventorySprite = this.fourDose;
        else if (this.doses === 3)
            this.inventorySprite = this.threeDose;
        else if (this.doses === 2)
            this.inventorySprite = this.twoDose;
        else if (this.doses === 1)
            this.inventorySprite = this.oneDose;
        else
            this.inventorySprite = this.vial;
    };
    return PrayerRegenerationPotion;
}(Potion/* Potion */.E));


;// CONCATENATED MODULE: ./src/content/items/index.ts
// generated using Generate Index https://marketplace.visualstudio.com/items?itemName=JayFong.generate-index
// @index('./*.ts', f => `export { ${f.name} } from './${f.name}';`)












/***/ }),

/***/ 1618:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AbyssalTentacle: () => (/* reexport */ AbyssalTentacle),
  AncientStaff: () => (/* reexport */ AncientStaff),
  BlackChinchompa: () => (/* reexport */ BlackChinchompa),
  BladeOfSaeldor: () => (/* reexport */ BladeOfSaeldor),
  Blowpipe: () => (/* reexport */ Blowpipe),
  BlueMoonSpear: () => (/* reexport */ BlueMoonSpear),
  BowOfFaerdhinen: () => (/* reexport */ BowOfFaerdhinen),
  DragonClaws: () => (/* reexport */ DragonClaws),
  EyeOfAyak: () => (/* reexport */ EyeOfAyak),
  KodaiWand: () => (/* reexport */ KodaiWand),
  NoxiousHalberd: () => (/* reexport */ NoxiousHalberd),
  SaradominGodsword: () => (/* reexport */ SaradominGodsword),
  ScytheOfVitur: () => (/* reexport */ ScytheOfVitur),
  TumekensShadow: () => (/* reexport */ TumekensShadow),
  TwistedBow: () => (/* reexport */ TwistedBow),
  VenatorBow: () => (/* reexport */ VenatorBow),
  ZombieAxe: () => (/* reexport */ ZombieAxe)
});

;// CONCATENATED MODULE: ./src/assets/images/weapons/Abyssal_tentacle.png
const Abyssal_tentacle_namespaceObject = __webpack_require__.p + "983ddf8a5ba4154010b7.png";
// EXTERNAL MODULE: ./src/sdk/AttackStylesController.ts + 27 modules
var AttackStylesController = __webpack_require__(186);
// EXTERNAL MODULE: ./src/sdk/ItemName.ts
var ItemName = __webpack_require__(243);
// EXTERNAL MODULE: ./src/sdk/rendering/GLTFAnimationConstants.ts
var GLTFAnimationConstants = __webpack_require__(1708);
// EXTERNAL MODULE: ./src/sdk/utils/SoundCache.ts
var SoundCache = __webpack_require__(6018);
// EXTERNAL MODULE: ./src/sdk/weapons/MeleeWeapon.ts
var MeleeWeapon = __webpack_require__(8109);
// EXTERNAL MODULE: ./src/sdk/audio/CacheSoundEffects.ts + 1 modules
var CacheSoundEffects = __webpack_require__(5432);
// EXTERNAL MODULE: ./src/assets/CacheAssets.ts
var CacheAssets = __webpack_require__(4655);
;// CONCATENATED MODULE: ./src/content/weapons/AbyssalTentacle.ts
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var AbyssalTentacle = /** @class */ (function (_super) {
    __extends(AbyssalTentacle, _super);
    function AbyssalTentacle() {
        var _this = _super.call(this) || this;
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 90,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 86,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AbyssalTentacle.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipWhip.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbyssalTentacle.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.abyssalTentacle.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbyssalTentacle.prototype, "weight", {
        get: function () {
            return 0.453;
        },
        enumerable: false,
        configurable: true
    });
    AbyssalTentacle.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.CONTROLLED, AttackStylesController/* AttackStyle */.aF.DEFENSIVE];
    };
    AbyssalTentacle.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.SLASHSWORD;
    };
    AbyssalTentacle.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.CONTROLLED;
    };
    Object.defineProperty(AbyssalTentacle.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ABYSSAL_TENTACLE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbyssalTentacle.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    AbyssalTentacle.prototype.hasSpecialAttack = function () {
        return true;
    };
    Object.defineProperty(AbyssalTentacle.prototype, "attackRange", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbyssalTentacle.prototype, "attackSpeed", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbyssalTentacle.prototype, "inventoryImage", {
        get: function () {
            return Abyssal_tentacle_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbyssalTentacle.prototype, "attackAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.SwordSlash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbyssalTentacle.prototype, "idleAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.Idle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbyssalTentacle.prototype, "attackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.meleeAttack.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    return AbyssalTentacle;
}(MeleeWeapon/* MeleeWeapon */.d));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Ancient_staff.png
const Ancient_staff_namespaceObject = __webpack_require__.p + "d024f094c1755b6c5a08.png";
// EXTERNAL MODULE: ./src/sdk/weapons/BloodBarrageSpell.ts
var BloodBarrageSpell = __webpack_require__(8603);
;// CONCATENATED MODULE: ./src/content/weapons/AncientStaff.ts

var AncientStaff_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var AncientStaff = /** @class */ (function (_super) {
    AncientStaff_extends(AncientStaff, _super);
    function AncientStaff() {
        var _this = _super.call(this) || this;
        _this.autocastSpell = new BloodBarrageSpell/* BloodBarrageSpell */.h();
        _this.bonuses = {
            attack: {
                stab: 10,
                slash: -1,
                crush: 40,
                magic: 15,
                range: 0,
            },
            defence: {
                stab: 2,
                slash: 3,
                crush: 1,
                magic: 15,
                range: 0,
            },
            other: {
                meleeStrength: 50,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: -1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(AncientStaff.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipStaff.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientStaff.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.ancientStaff.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientStaff.prototype, "weight", {
        get: function () {
            return 2.267;
        },
        enumerable: false,
        configurable: true
    });
    AncientStaff.prototype.attack = function (from, to, bonuses) {
        if (bonuses === void 0) { bonuses = {}; }
        if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.AUTOCAST) {
            if (from.isPlayer) {
                this.autocastSpell.cast(from, to);
                return true;
            }
        }
        return _super.prototype.attack.call(this, from, to, bonuses);
    };
    AncientStaff.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.AGGRESSIVECRUSH, AttackStylesController/* AttackStyle */.aF.DEFENSIVE, AttackStylesController/* AttackStyle */.aF.AUTOCAST];
    };
    AncientStaff.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.STAFF;
    };
    AncientStaff.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.AUTOCAST;
    };
    Object.defineProperty(AncientStaff.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ANCIENT_STAFF;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientStaff.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    AncientStaff.prototype.hasSpecialAttack = function () {
        return false;
    };
    Object.defineProperty(AncientStaff.prototype, "attackRange", {
        get: function () {
            if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.AUTOCAST) {
                return 10;
            }
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientStaff.prototype, "attackSpeed", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientStaff.prototype, "inventoryImage", {
        get: function () {
            return Ancient_staff_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return AncientStaff;
}(MeleeWeapon/* MeleeWeapon */.d));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Black_chinchompa.png
const Black_chinchompa_namespaceObject = __webpack_require__.p + "5c47f1bf32c8560a8368.png";
// EXTERNAL MODULE: ./src/sdk/weapons/RangedWeapon.ts
var RangedWeapon = __webpack_require__(2022);
// EXTERNAL MODULE: ./src/sdk/Pathing.ts
var Pathing = __webpack_require__(5454);
;// CONCATENATED MODULE: ./src/content/weapons/BlackChinchompa.ts

var BlackChinchompa_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};









var BlackChinchompa = /** @class */ (function (_super) {
    BlackChinchompa_extends(BlackChinchompa, _super);
    function BlackChinchompa() {
        var _this = _super.call(this) || this;
        _this.maxConcurrentHits = 9;
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 80,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 30,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BlackChinchompa.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.blackChinchompa.id; },
        enumerable: false,
        configurable: true
    });
    // same as toxic blowpipe and other thrown weapon
    BlackChinchompa.prototype.calculateHitDelay = function (distance) {
        return Math.floor(distance / 6) + 1;
    };
    BlackChinchompa.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.SHORT_FUSE, AttackStylesController/* AttackStyle */.aF.MEDIUM_FUSE, AttackStylesController/* AttackStyle */.aF.LONG_FUSE];
    };
    BlackChinchompa.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.CHINCHOMPA;
    };
    BlackChinchompa.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.MEDIUM_FUSE;
    };
    Object.defineProperty(BlackChinchompa.prototype, "attackSpeed", {
        get: function () {
            if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.MEDIUM_FUSE) {
                return 3;
            }
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "weight", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BLACK_CHINCHOMPA;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "attackRange", {
        get: function () {
            if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.LONG_FUSE) {
                return 10;
            }
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "inventoryImage", {
        get: function () {
            return Black_chinchompa_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "attackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.chinchompaAttack.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "attackLandingSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.chinchompaImpact.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlackChinchompa.prototype, "aoe", {
        get: function () {
            return [
                { x: 0, y: 0 },
                { x: -1, y: -1 },
                { x: -1, y: 0 },
                { x: -1, y: 1 },
                { x: 0, y: -1 },
                { x: 0, y: 1 },
                { x: 1, y: -1 },
                { x: 1, y: 0 },
                { x: 1, y: 1 },
            ];
        },
        enumerable: false,
        configurable: true
    });
    BlackChinchompa.prototype.attack = function (from, to, bonuses, options) {
        var _this = this;
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        if (this.aoe.length) {
            var alreadyCastedOn_1 = [to];
            var initialResult = _super.prototype.attack.call(this, from, to, bonuses, options);
            if (initialResult) {
                this.aoe.forEach(function (point) {
                    Pathing/* Pathing */.G.mobsAtAoeOffset(from.region, to, point).forEach(function (mob) {
                        if (alreadyCastedOn_1.length > _this.maxConcurrentHits) {
                            return;
                        }
                        if (alreadyCastedOn_1.indexOf(mob) > -1) {
                            return;
                        }
                        alreadyCastedOn_1.push(mob);
                        // HACK: chin gets massive accuracy bonus if main roll hits
                        from.bonuses.attack.range += 100000;
                        _super.prototype.attack.call(_this, from, mob, bonuses, __assign(__assign({}, options), { visuals: __assign(__assign({}, options.visuals), { hidden: true }) }));
                        from.bonuses.attack.range -= 100000;
                    });
                });
            }
            return initialResult;
        }
        else {
            return _super.prototype.attack.call(this, from, to, bonuses, options);
        }
    };
    Object.defineProperty(BlackChinchompa.prototype, "attackAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.ThrowChinchompa;
        },
        enumerable: false,
        configurable: true
    });
    return BlackChinchompa;
}(RangedWeapon/* RangedWeapon */.I));


;// CONCATENATED MODULE: ./src/assets/images/weapons/Blade_of_saeldor.png
const Blade_of_saeldor_namespaceObject = __webpack_require__.p + "a301225fcfef86c6e1eb.png";
;// CONCATENATED MODULE: ./src/content/weapons/BladeOfSaeldor.ts
var BladeOfSaeldor_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var BladeOfSaeldor = /** @class */ (function (_super) {
    BladeOfSaeldor_extends(BladeOfSaeldor, _super);
    function BladeOfSaeldor() {
        var _this = _super.call(this) || this;
        _this.bonuses = {
            attack: {
                stab: 55,
                slash: 100,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 93,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BladeOfSaeldor.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.bladeOfSaeldor.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    BladeOfSaeldor.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH, AttackStylesController/* AttackStyle */.aF.STAB, AttackStylesController/* AttackStyle */.aF.DEFENSIVE];
    };
    BladeOfSaeldor.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.SLASHSWORD;
    };
    BladeOfSaeldor.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH;
    };
    Object.defineProperty(BladeOfSaeldor.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BLADE_OF_SAELDOR;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    BladeOfSaeldor.prototype.hasSpecialAttack = function () {
        return false;
    };
    Object.defineProperty(BladeOfSaeldor.prototype, "attackRange", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "attackSpeed", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "inventoryImage", {
        get: function () {
            return Blade_of_saeldor_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "attackAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.SwordSlash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "idleAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.Idle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BladeOfSaeldor.prototype, "attackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.meleeAttack.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    return BladeOfSaeldor;
}(MeleeWeapon/* MeleeWeapon */.d));


;// CONCATENATED MODULE: ./src/assets/images/weapons/blowpipe.png
const blowpipe_namespaceObject = __webpack_require__.p + "8c5cdb0e15f1a0d457b5.png";
// EXTERNAL MODULE: ./src/sdk/weapons/Projectile.ts
var Projectile = __webpack_require__(2402);
// EXTERNAL MODULE: ./src/sdk/utils/Assets.ts
var Assets = __webpack_require__(8648);
;// CONCATENATED MODULE: ./src/content/weapons/Blowpipe.ts

var Blowpipe_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Blowpipe_assign = (undefined && undefined.__assign) || function () {
    Blowpipe_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Blowpipe_assign.apply(this, arguments);
};










var Blowpipe = /** @class */ (function (_super) {
    Blowpipe_extends(Blowpipe, _super);
    function Blowpipe() {
        var _this = _super.call(this, {
            visuals: {
                modelScale: 1 / 128,
                startCycleOffset: 30,
                verticalOffset: -0.75,
                motionInterpolator: new Projectile/* ArcProjectileMotionInterpolator */.dD(0.5),
            },
        }) || this;
        _this.ProjectileModel = Assets/* Assets */.s.getAssetUrl("models/dragon_dart.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 30,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 20 + 28,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        SoundCache/* SoundCache */.U.preload(_this.attackSound.src);
        return _this;
    }
    Object.defineProperty(Blowpipe.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipStaff.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.toxicBlowpipe.id;
        },
        enumerable: false,
        configurable: true
    });
    Blowpipe.prototype.calculateHitDelay = function (distance) {
        return Math.floor(distance / 6) + 1;
    };
    Blowpipe.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.RAPID, AttackStylesController/* AttackStyle */.aF.LONGRANGE];
    };
    Blowpipe.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.THROWN;
    };
    Blowpipe.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.RAPID;
    };
    Object.defineProperty(Blowpipe.prototype, "attackRange", {
        get: function () {
            if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.LONGRANGE) {
                return 7;
            }
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "attackSpeed", {
        get: function () {
            if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.LONGRANGE) {
                return 3;
            }
            return 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "weight", {
        get: function () {
            return 0.5;
        },
        enumerable: false,
        configurable: true
    });
    Blowpipe.prototype.specialAttack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        _super.prototype.specialAttack.call(this, from, to, bonuses, options);
        bonuses.isSpecialAttack = true;
        // BP special attack takes an extra tick to land
        var didAttack = _super.prototype.attack.call(this, from, to, bonuses, Blowpipe_assign(Blowpipe_assign({}, options), { reduceDelay: -1, visuals: {
                hitEarlyCycleOffset: 30,
                startCycleOffset: 30,
                projectileSound: this.specialAttackSound,
            } }));
        var healAttackerBy = Math.floor(this.damageRoll / 2);
        from.currentStats.hitpoint += healAttackerBy;
        from.currentStats.hitpoint = Math.min(from.currentStats.hitpoint, from.stats.hitpoint);
        return didAttack;
    };
    Blowpipe.prototype._damageMultiplier = function (from, to, bonuses) {
        if (bonuses.isSpecialAttack) {
            return 1.5;
        }
        return 1;
    };
    Blowpipe.prototype._accuracyMultiplier = function (from, to, bonuses) {
        if (bonuses.isSpecialAttack) {
            return 2;
        }
        return 1;
    };
    Object.defineProperty(Blowpipe.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.TOXIC_BLOWPIPE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Blowpipe.prototype.hasSpecialAttack = function () {
        return true;
    };
    Object.defineProperty(Blowpipe.prototype, "inventoryImage", {
        get: function () {
            return blowpipe_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "attackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.blowpipeAttack.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "specialAttackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.blowpipeSpecial.id), 0.5);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "attackAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.FireBlowpipe;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Blowpipe.prototype, "projectileModel", {
        get: function () {
            return this.ProjectileModel;
        },
        enumerable: false,
        configurable: true
    });
    return Blowpipe;
}(RangedWeapon/* RangedWeapon */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Dragon_claws.png
const Dragon_claws_namespaceObject = __webpack_require__.p + "3d926cfad40d1ccc592f.png";
// EXTERNAL MODULE: ./src/sdk/Random.ts
var Random = __webpack_require__(7212);
;// CONCATENATED MODULE: ./src/content/weapons/DragonClaws.ts
var DragonClaws_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DragonClaws_assign = (undefined && undefined.__assign) || function () {
    DragonClaws_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return DragonClaws_assign.apply(this, arguments);
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};









var NORMAL_ATTACK_SOUND_ID = CacheAssets/* CACHE_ASSETS */.fc.sounds.dragonClawsAttack.id;
var SPECIAL_ATTACK_SOUND_ID = CacheAssets/* CACHE_ASSETS */.fc.sounds.dragonClawsSpecialFirst.id;
var CLIENT_CYCLE_MS = 20;
var SPECIAL_ATTACK_SOUNDS = [
    { id: SPECIAL_ATTACK_SOUND_ID, delayCycles: 10 },
    { id: CacheAssets/* CACHE_ASSETS */.fc.sounds.dragonClawsSpecialSecond.id, delayCycles: 30 },
    { id: CacheAssets/* CACHE_ASSETS */.fc.sounds.dragonClawsSpecialThird.id, delayCycles: 42 },
    { id: CacheAssets/* CACHE_ASSETS */.fc.sounds.dragonClawsSpecialThird.id, delayCycles: 60 },
];
var SOUND_VOLUME = 0.1;
var DragonClaws = /** @class */ (function (_super) {
    DragonClaws_extends(DragonClaws, _super);
    function DragonClaws() {
        var _this = _super.call(this) || this;
        __spreadArray([NORMAL_ATTACK_SOUND_ID], SPECIAL_ATTACK_SOUNDS.map(function (_a) {
            var id = _a.id;
            return id;
        }), true).forEach(function (id) { return SoundCache/* SoundCache */.U.preload((0,CacheSoundEffects/* cacheSound */.cp)(id)); });
        _this.bonuses = {
            attack: { stab: 41, slash: 57, crush: -4, magic: -4, range: 0 },
            defence: { stab: 13, slash: 26, crush: 7, magic: -4, range: 0 },
            other: { meleeStrength: 56, rangedStrength: 0, magicDamage: 0, prayer: 0 },
            targetSpecific: { undead: 0, slayer: 0 },
        };
        return _this;
    }
    Object.defineProperty(DragonClaws.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipFun.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonClaws.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.dragonClaws.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonClaws.prototype, "weight", {
        get: function () {
            return 0.453;
        },
        enumerable: false,
        configurable: true
    });
    DragonClaws.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH, AttackStylesController/* AttackStyle */.aF.STAB, AttackStylesController/* AttackStyle */.aF.DEFENSIVE];
    };
    DragonClaws.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.SLASHSWORD;
    };
    DragonClaws.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH;
    };
    Object.defineProperty(DragonClaws.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.DRAGON_CLAWS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonClaws.prototype, "attackRange", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonClaws.prototype, "attackSpeed", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonClaws.prototype, "inventoryImage", {
        get: function () {
            return Dragon_claws_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonClaws.prototype, "attackAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.SwordSlash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonClaws.prototype, "specialAttackAnimationId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.playerAnimations.dragonClawsAttack.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonClaws.prototype, "idleAnimationId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.playerAnimations.idle.id;
        },
        enumerable: false,
        configurable: true
    });
    DragonClaws.prototype.hasSpecialAttack = function () {
        return true;
    };
    /** Slice and Dice: four accuracy rolls, then a linked four-hit damage split. */
    DragonClaws.prototype.specialAttack = function (from, to, bonuses, options) {
        var _this = this;
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        bonuses.attackStyle = "slash";
        bonuses.styleBonus = bonuses.styleBonus || 0;
        bonuses.voidMultiplier = bonuses.voidMultiplier || 1;
        bonuses.gearMeleeMultiplier = bonuses.gearMeleeMultiplier || 1;
        bonuses.overallMultiplier = bonuses.overallMultiplier || 1;
        this._calculatePrayerEffects(from, to, bonuses);
        var protectedFromMelee = this.isBlockable(from, to, bonuses);
        var rollModifiers = to.incomingAttackRollModifiers({ attacker: from, weapon: this, bonuses: bonuses });
        var firstSuccessfulHit = -1;
        if (!protectedFromMelee) {
            var hitChance = this._hitChance(from, to, bonuses);
            for (var hit = 0; hit < 4; hit++) {
                if (rollModifiers.guaranteedHit || Random/* Random */.o.get() <= hitChance) {
                    firstSuccessfulHit = hit;
                    break;
                }
            }
        }
        var maxHit = this._maxHit(from, to, bonuses);
        var rollBetween = function (minimum, maximum) {
            var min = Math.max(0, Math.floor(minimum));
            var max = Math.max(min, Math.floor(maximum));
            return rollModifiers.maxDamage ? max : min + Math.floor(Random/* Random */.o.get() * (max - min + 1));
        };
        var hits;
        if (firstSuccessfulHit === 0) {
            var first = rollBetween(maxHit / 2, maxHit - 1);
            var second = Math.floor(first / 2);
            var third = Math.floor(second / 2);
            hits = [first, second, third, third + 1];
        }
        else if (firstSuccessfulHit === 1) {
            var second = rollBetween((3 * maxHit) / 8, (7 * maxHit) / 8);
            var third = Math.floor(second / 2);
            hits = [0, second, third, third + 1];
        }
        else if (firstSuccessfulHit === 2) {
            var third = rollBetween(maxHit / 4, (3 * maxHit) / 4);
            hits = [0, 0, third, third + 1];
        }
        else if (firstSuccessfulHit === 3) {
            hits = [0, 0, 0, rollBetween(maxHit / 4, (5 * maxHit) / 4)];
        }
        else if (Random/* Random */.o.get() < 2 / 3) {
            var patterns = [
                [1, 1, 0, 0],
                [0, 0, 1, 1],
                [1, 0, 1, 0],
                [0, 1, 0, 1],
            ];
            hits = patterns[Math.floor(Random/* Random */.o.get() * patterns.length)];
        }
        else {
            hits = [0, 0, 0, 0];
        }
        hits.forEach(function (damage, hit) {
            _this.damageRoll = damage;
            _this.damage = damage;
            _this.grantXp(from, to);
            _this.registerProjectile(from, to, bonuses, DragonClaws_assign(DragonClaws_assign({}, options), { consumeTargetMaxDamageRoll: rollModifiers.maxDamage && rollModifiers.consumeAfterDamage, sound: null, setDelay: hit < 2 ? 1 : 2 }));
        });
        SPECIAL_ATTACK_SOUNDS.forEach(function (_a) {
            var id = _a.id, delayCycles = _a.delayCycles;
            setTimeout(function () { return SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(id), SOUND_VOLUME)); }, delayCycles * CLIENT_CYCLE_MS);
        });
        this.lastHitHit = firstSuccessfulHit >= 0;
        return true;
    };
    Object.defineProperty(DragonClaws.prototype, "specialAttackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(SPECIAL_ATTACK_SOUND_ID), SOUND_VOLUME);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonClaws.prototype, "attackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(NORMAL_ATTACK_SOUND_ID), SOUND_VOLUME);
        },
        enumerable: false,
        configurable: true
    });
    return DragonClaws;
}(MeleeWeapon/* MeleeWeapon */.d));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Bow_of_faerdhinen.png
const Bow_of_faerdhinen_namespaceObject = __webpack_require__.p + "8395f74e86249d12c9b1.png";
;// CONCATENATED MODULE: ./src/content/weapons/BowOfFaerdhinen.ts

var BowOfFaerdhinen_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var BowOfFaerdhinen = /** @class */ (function (_super) {
    BowOfFaerdhinen_extends(BowOfFaerdhinen, _super);
    function BowOfFaerdhinen() {
        var _this = _super.call(this) || this;
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 128,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 106,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BowOfFaerdhinen.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipFun.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.bowOfFaerdhinen.id; },
        enumerable: false,
        configurable: true
    });
    BowOfFaerdhinen.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.RAPID, AttackStylesController/* AttackStyle */.aF.LONGRANGE];
    };
    BowOfFaerdhinen.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.BOW;
    };
    BowOfFaerdhinen.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.RAPID;
    };
    Object.defineProperty(BowOfFaerdhinen.prototype, "attackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.bowOfFaerdhinenAttack.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "attackSpeed", {
        get: function () {
            if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.LONGRANGE) {
                return 5;
            }
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "weight", {
        get: function () {
            return 1.5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BOWFA;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "attackRange", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BowOfFaerdhinen.prototype, "inventoryImage", {
        get: function () {
            return Bow_of_faerdhinen_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    BowOfFaerdhinen.prototype._accuracyMultiplier = function (from, to, bonuses) {
        return from.bonuses.other.crystalAccuracy || 1;
    };
    BowOfFaerdhinen.prototype._damageMultiplier = function (from, to, bonuses) {
        return from.bonuses.other.crystalDamage || 1;
    };
    Object.defineProperty(BowOfFaerdhinen.prototype, "attackAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.FireBow;
        },
        enumerable: false,
        configurable: true
    });
    return BowOfFaerdhinen;
}(RangedWeapon/* RangedWeapon */.I));


;// CONCATENATED MODULE: ./src/assets/images/equipment/Kodai_wand.png
const Kodai_wand_namespaceObject = __webpack_require__.p + "4d6670d0c42d9d3e1d79.png";
;// CONCATENATED MODULE: ./src/content/weapons/KodaiWand.ts

var KodaiWand_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var KodaiWand = /** @class */ (function (_super) {
    KodaiWand_extends(KodaiWand, _super);
    function KodaiWand() {
        var _this = _super.call(this) || this;
        _this.autocastSpell = new BloodBarrageSpell/* BloodBarrageSpell */.h();
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 28,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 3,
                crush: 3,
                magic: 20,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0.15,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(KodaiWand.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipStaff.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KodaiWand.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.kodaiWand.id;
        },
        enumerable: false,
        configurable: true
    });
    KodaiWand.prototype.attack = function (from, to, bonuses) {
        if (bonuses === void 0) { bonuses = {}; }
        if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.AUTOCAST) {
            if (from.isPlayer) {
                this.autocastSpell.cast(from, to);
                return true;
            }
        }
        return _super.prototype.attack.call(this, from, to, bonuses);
    };
    KodaiWand.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.AGGRESSIVECRUSH, AttackStylesController/* AttackStyle */.aF.DEFENSIVE, AttackStylesController/* AttackStyle */.aF.AUTOCAST];
    };
    KodaiWand.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.STAFF;
    };
    KodaiWand.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.AUTOCAST;
    };
    Object.defineProperty(KodaiWand.prototype, "weight", {
        get: function () {
            return 0.198;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KodaiWand.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.KODAI_WAND;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KodaiWand.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    KodaiWand.prototype.hasSpecialAttack = function () {
        return false;
    };
    Object.defineProperty(KodaiWand.prototype, "attackRange", {
        get: function () {
            if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.AUTOCAST) {
                return 10;
            }
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KodaiWand.prototype, "attackSpeed", {
        get: function () {
            if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.AUTOCAST) {
                return 5;
            }
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KodaiWand.prototype, "inventoryImage", {
        get: function () {
            return Kodai_wand_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return KodaiWand;
}(MeleeWeapon/* MeleeWeapon */.d));


;// CONCATENATED MODULE: ./src/assets/images/weapons/Noxious_halberd.png
const Noxious_halberd_namespaceObject = __webpack_require__.p + "2a09947428a8aa0a26b1.png";
;// CONCATENATED MODULE: ./src/content/weapons/NoxiousHalberd.ts
var NoxiousHalberd_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var NoxiousHalberd = /** @class */ (function (_super) {
    NoxiousHalberd_extends(NoxiousHalberd, _super);
    function NoxiousHalberd() {
        var _this = _super.call(this) || this;
        _this.bonuses = {
            attack: {
                stab: 80,
                slash: 132,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 142,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(NoxiousHalberd.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipStaff.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NoxiousHalberd.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.noxiousHalberd.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NoxiousHalberd.prototype, "weight", {
        get: function () {
            return 2.721;
        },
        enumerable: false,
        configurable: true
    });
    NoxiousHalberd.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.STAB, AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH, AttackStylesController/* AttackStyle */.aF.DEFENSIVE];
    };
    NoxiousHalberd.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.POLEARM;
    };
    NoxiousHalberd.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH;
    };
    Object.defineProperty(NoxiousHalberd.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.NOXIOUS_HALBERD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NoxiousHalberd.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    NoxiousHalberd.prototype.hasSpecialAttack = function () {
        return true;
    };
    Object.defineProperty(NoxiousHalberd.prototype, "attackRange", {
        get: function () {
            return 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NoxiousHalberd.prototype, "attackSpeed", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NoxiousHalberd.prototype, "inventoryImage", {
        get: function () {
            return Noxious_halberd_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NoxiousHalberd.prototype, "attackAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.ScytheSwing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NoxiousHalberd.prototype, "idleAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.ScytheIdle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NoxiousHalberd.prototype, "attackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.meleeAttack.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    return NoxiousHalberd;
}(MeleeWeapon/* MeleeWeapon */.d));


;// CONCATENATED MODULE: ./src/assets/images/weapons/scytheOfVitur.png
const scytheOfVitur_namespaceObject = __webpack_require__.p + "670ddc4f152a60d91516.png";
// EXTERNAL MODULE: ./src/sdk/Collision.ts
var Collision = __webpack_require__(5843);
// EXTERNAL MODULE: ./src/sdk/Player.ts + 2 modules
var Player = __webpack_require__(2431);
// EXTERNAL MODULE: ./src/sdk/GraphicsObject.ts
var GraphicsObject = __webpack_require__(7245);
;// CONCATENATED MODULE: ./src/content/weapons/ScytheOfVitur.ts
var ScytheOfVitur_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ScytheOfVitur_assign = (undefined && undefined.__assign) || function () {
    ScytheOfVitur_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ScytheOfVitur_assign.apply(this, arguments);
};











var EXTRA_HIT_LOCATIONS = [
    [
        [-1, -1],
        [1, -1],
    ],
    [
        [1, 1],
        [1, -1],
    ],
    [
        [-1, 1],
        [1, 1],
    ],
    [
        [-1, 1],
        [-1, -1],
    ], // West
];
var ScytheOfVitur = /** @class */ (function (_super) {
    ScytheOfVitur_extends(ScytheOfVitur, _super);
    function ScytheOfVitur() {
        var _this = _super.call(this) || this;
        _this.bonuses = {
            attack: {
                stab: 70,
                slash: 125,
                crush: 30,
                magic: -6,
                range: 0,
            },
            defence: {
                stab: -2,
                slash: 8,
                crush: 10,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 75,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(ScytheOfVitur.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.scytheOfVitur.id; },
        enumerable: false,
        configurable: true
    });
    ScytheOfVitur.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.REAP, AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH, AttackStylesController/* AttackStyle */.aF.AGGRESSIVECRUSH, AttackStylesController/* AttackStyle */.aF.DEFENSIVE];
    };
    ScytheOfVitur.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.SCYTHE;
    };
    ScytheOfVitur.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH;
    };
    Object.defineProperty(ScytheOfVitur.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.SCYTHE_OF_VITUR;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScytheOfVitur.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    ScytheOfVitur.prototype.hasSpecialAttack = function () {
        return false;
    };
    Object.defineProperty(ScytheOfVitur.prototype, "weight", {
        get: function () {
            return 3.175;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScytheOfVitur.prototype, "attackRange", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScytheOfVitur.prototype, "attackSpeed", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScytheOfVitur.prototype, "inventoryImage", {
        get: function () {
            return scytheOfVitur_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    ScytheOfVitur.prototype.attack = function (from, to, bonuses) {
        var _this = this;
        var region = from.region;
        // As there is no concept of player direction yet, we dynamically calculate this based on the relative location of
        // the attacker.
        // Find the closest tile on the npc to us.
        var targetTile = to.getClosestTileTo(from.location.x, from.location.y);
        var dx = from.location.x - targetTile[0];
        var dy = from.location.y - targetTile[1];
        var direction;
        if (dx < 0) {
            direction = 1; // East
        }
        else if (dx > 0) {
            direction = 3; // West
        }
        else if (dy < 0) {
            direction = 2; // South
        }
        else {
            direction = 0; // North
        }
        if (from instanceof Player/* Player */.a) {
            var spotAnimByDirection = [
                CacheAssets/* CACHE_ASSETS */.fc.spotAnims.scytheNorth.id,
                CacheAssets/* CACHE_ASSETS */.fc.spotAnims.scytheEast.id,
                CacheAssets/* CACHE_ASSETS */.fc.spotAnims.scytheSouth.id,
                CacheAssets/* CACHE_ASSETS */.fc.spotAnims.scytheWest.id,
            ];
            var offsetByDirection = [{ x: 0, y: -1 }, { x: 1, y: 0 }, { x: 0, y: 1 }, { x: -1, y: 0 }];
            var offset = offsetByDirection[direction];
            region.addEntity(new GraphicsObject/* GraphicsObject */.H(region, { x: from.location.x + offset.x, y: from.location.y + offset.y }, spotAnimByDirection[direction], { height: 0.49 + 96 / 128, delay: 20, recolor: { "960": 0xffffff } }));
        }
        // Full damage attack, but each subsequent hit does half of the last.
        var multiplier = 1.0;
        _super.prototype.attack.call(this, from, to, bonuses);
        EXTRA_HIT_LOCATIONS[direction].forEach(function (hit) {
            var xx = from.location.x + hit[0];
            var yy = from.location.y + hit[1];
            var collision = Collision/* Collision */.F.collidesWithAnyMobs(region, xx, yy, from.size);
            multiplier *= 0.5;
            var extraHitBonuses = ScytheOfVitur_assign(ScytheOfVitur_assign({}, bonuses), { overallMultiplier: multiplier });
            if (collision) {
                _super.prototype.attack.call(_this, from, collision, extraHitBonuses, { hitSound: null });
            }
            else {
                _super.prototype.attack.call(_this, from, to, extraHitBonuses, { hitSound: null });
            }
        });
        return true;
    };
    Object.defineProperty(ScytheOfVitur.prototype, "attackAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.ScytheSwing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScytheOfVitur.prototype, "idleAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.ScytheIdle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScytheOfVitur.prototype, "attackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.meleeAttack.id), 0.05);
        },
        enumerable: false,
        configurable: true
    });
    return ScytheOfVitur;
}(MeleeWeapon/* MeleeWeapon */.d));


;// CONCATENATED MODULE: ./src/assets/images/weapons/twistedBow.png
const twistedBow_namespaceObject = __webpack_require__.p + "b2079f07ece4024ef387.png";
;// CONCATENATED MODULE: ./src/content/weapons/TwistedBow.ts

var TwistedBow_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var TwistedBow = /** @class */ (function (_super) {
    TwistedBow_extends(TwistedBow, _super);
    function TwistedBow(geno) {
        if (geno === void 0) { geno = false; }
        var _this = _super.call(this, {
            visuals: {
                modelScale: 1 / 128,
                startCycleOffset: 30,
                hitEarlyCycleOffset: 30,
                verticalOffset: -0.75,
                motionInterpolator: new Projectile/* ArcProjectileMotionInterpolator */.dD(1),
            },
        }) || this;
        _this.ProjectileModel = Assets/* Assets */.s.getAssetUrl("models/dragon_arrow.glb");
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: geno ? 10000 : 70,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: geno ? 80 : 20,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        SoundCache/* SoundCache */.U.preload(_this.attackSound.src);
        return _this;
    }
    Object.defineProperty(TwistedBow.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.twistedBow.id; },
        enumerable: false,
        configurable: true
    });
    TwistedBow.prototype.compatibleAmmo = function () {
        return [ItemName/* ItemName */.P.DRAGON_ARROWS, ItemName/* ItemName */.P.SEEKING_DRAGON_ARROWS];
    };
    TwistedBow.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.RAPID, AttackStylesController/* AttackStyle */.aF.LONGRANGE];
    };
    TwistedBow.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.BOW;
    };
    TwistedBow.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.RAPID;
    };
    Object.defineProperty(TwistedBow.prototype, "attackSpeed", {
        get: function () {
            if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.LONGRANGE) {
                return 6;
            }
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "attackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.twistedBowAttack.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "weight", {
        get: function () {
            return 1.814;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.TWISTED_BOW;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "attackRange", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "inventoryImage", {
        get: function () {
            return twistedBow_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    TwistedBow.prototype._accuracyMultiplier = function (from, to, bonuses) {
        var magic = Math.min(Math.max(to.currentStats.magic, to.bonuses.attack.magic), 250);
        var multiplier = (140 + ((10 * 3 * magic) / 10 - 10) / 100 - Math.pow((3 * magic) / 10 - 100, 2) / 100) / 100;
        return Math.min(1.4, Math.max(0, multiplier));
    };
    TwistedBow.prototype._damageMultiplier = function (from, to, bonuses) {
        var magic = Math.min(Math.max(to.currentStats.magic, to.bonuses.attack.magic), 250);
        var multiplier = (250 + ((10 * 3 * magic) / 10 - 14) / 100 - Math.pow((3 * magic) / 10 - 140, 2) / 100) / 100;
        return Math.min(2.5, Math.max(0, multiplier));
    };
    Object.defineProperty(TwistedBow.prototype, "attackAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.FireBow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TwistedBow.prototype, "projectileModel", {
        get: function () {
            return this.ProjectileModel;
        },
        enumerable: false,
        configurable: true
    });
    return TwistedBow;
}(RangedWeapon/* RangedWeapon */.I));


;// CONCATENATED MODULE: ./src/assets/images/weapons/Eye_of_Ayak.png
const Eye_of_Ayak_namespaceObject = __webpack_require__.p + "fb2fb7b413eeb3f9abb4.png";
// EXTERNAL MODULE: ./src/sdk/weapons/PoweredStaff.ts
var PoweredStaff = __webpack_require__(3555);
;// CONCATENATED MODULE: ./src/content/weapons/EyeOfAyak.ts

var EyeOfAyak_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var EyeOfAyak = /** @class */ (function (_super) {
    EyeOfAyak_extends(EyeOfAyak, _super);
    function EyeOfAyak() {
        var _this = 
        // The exact cache projectile graphic and client-cycle offsets still need
        // identifying. Until then, use the SDK's neutral magic projectile instead
        // of borrowing an unrelated weapon's effect.
        _super.call(this, { visuals: { color: "#7d57c2" } }) || this;
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 30,
                range: 0,
            },
            defence: {
                stab: 1,
                slash: 5,
                crush: 5,
                magic: 10,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 2,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(EyeOfAyak.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.eyeOfAyak.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EyeOfAyak.prototype, "attackSpeed", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EyeOfAyak.prototype, "weight", {
        get: function () {
            return 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EyeOfAyak.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.EYE_OF_AYAK;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EyeOfAyak.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EyeOfAyak.prototype, "inventoryImage", {
        get: function () {
            return Eye_of_Ayak_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EyeOfAyak.prototype, "attackAnimationId", {
        get: function () {
            // TODO: replace with the Eye of Ayak's exact casting sequence once known.
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.CastSpell;
        },
        enumerable: false,
        configurable: true
    });
    EyeOfAyak.prototype.poweredSpellMaxHit = function (magicLevel) {
        return Math.floor(magicLevel / 3) - 6;
    };
    return EyeOfAyak;
}(PoweredStaff/* PoweredStaff */.P));


;// CONCATENATED MODULE: ./src/assets/images/weapons/Tumekens_shadow.png
const Tumekens_shadow_namespaceObject = __webpack_require__.p + "06ebc99889c4c2fcde70.png";
;// CONCATENATED MODULE: ./src/content/weapons/TumekensShadow.ts
var TumekensShadow_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var TUMEKEN_MULTIPLIER = 3;
var TumekensShadow = /** @class */ (function (_super) {
    TumekensShadow_extends(TumekensShadow, _super);
    function TumekensShadow() {
        var _this = _super.call(this, {
            visuals: {
                spotAnim: { id: CacheAssets/* CACHE_ASSETS */.fc.spotAnims.tumekensShadowProjectile.id },
                startCycleOffset: 30,
                verticalOffset: 2.0,
            },
        }) || this;
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 35,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 20,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(TumekensShadow.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.tumekensShadow.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TumekensShadow.prototype, "weight", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TumekensShadow.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.TUMEKENS_SHADOW;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TumekensShadow.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TumekensShadow.prototype, "baseAttackRange", {
        /** Accurate attacks reach 8 tiles and Longrange reaches 10. */
        get: function () {
            return 8;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TumekensShadow.prototype, "attackSpeed", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TumekensShadow.prototype, "attackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.tumekensShadowAttack.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TumekensShadow.prototype, "inventoryImage", {
        get: function () {
            return Tumekens_shadow_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TumekensShadow.prototype, "idleAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.TumekensShadowIdle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TumekensShadow.prototype, "walkAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.TumekensShadowWalk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TumekensShadow.prototype, "runAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.TumekensShadowRun;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TumekensShadow.prototype, "attackAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.TumekensShadowAttack;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TumekensShadow.prototype, "attackSpotAnim", {
        get: function () {
            return { id: CacheAssets/* CACHE_ASSETS */.fc.spotAnims.tumekensShadowAttack.id };
        },
        enumerable: false,
        configurable: true
    });
    TumekensShadow.prototype.poweredSpellMaxHit = function (magicLevel) {
        return Math.floor(magicLevel / 3 + 1);
    };
    TumekensShadow.prototype._equipmentBonus = function (from, to, bonuses) {
        return from.bonuses.attack.magic * TUMEKEN_MULTIPLIER;
    };
    TumekensShadow.prototype._magicDamageBonusMultiplier = function (from, to, bonuses) {
        return (from.bonuses.other.magicDamage - 1.0) * TUMEKEN_MULTIPLIER + 1.0;
    };
    return TumekensShadow;
}(PoweredStaff/* PoweredStaff */.P));


;// CONCATENATED MODULE: ./src/assets/images/weapons/Venator_bow.png
const Venator_bow_namespaceObject = __webpack_require__.p + "27557ace65bde2a34a93.png";
// EXTERNAL MODULE: ./src/sdk/Mob.ts
var Mob = __webpack_require__(5397);
// EXTERNAL MODULE: ./src/sdk/LineOfSight.ts
var LineOfSight = __webpack_require__(8499);
// EXTERNAL MODULE: ./src/sdk/utils/Chunk.ts
var Chunk = __webpack_require__(5164);
;// CONCATENATED MODULE: ./src/content/weapons/VenatorBounce.ts


var BOUNCE_RADIUS = 2;
var TARGET_TILE_RADIUS = 3;
var isInRadius = function (_a, _b, radius) {
    var x = _a[0], y = _a[1];
    var targetX = _b[0], targetY = _b[1];
    return Math.abs(x - targetX) <= radius && Math.abs(y - targetY) <= radius;
};
function getVenatorCenterTile(x, y, size) {
    if (!Number.isInteger(size) || size < 1) {
        throw new Error("Unsupported NPC size ".concat(size));
    }
    // Size two is the one exception: the game uses the south-west anchor tile.
    if (size === 2)
        return [x, y];
    // Odd-sized NPCs use their geometric centre. For even sizes >= 4 this is
    // the north-east tile of the inner 2x2 square.
    var offset = Math.floor(size / 2);
    return [x + offset, y - offset];
}
function getAllTiles(x, y, size) {
    var tiles = [];
    for (var dx = 0; dx < size; dx++) {
        for (var dy = 0; dy < size; dy++)
            tiles.push([x + dx, y - dy]);
    }
    return tiles;
}
function getClosestTile(_a, targetX, targetY, targetSize) {
    var x = _a[0], y = _a[1];
    return [
        Math.max(targetX, Math.min(targetX + targetSize - 1, x)),
        Math.max(targetY - targetSize + 1, Math.min(targetY, y)),
    ];
}
function canVenatorBounce(sourceX, sourceY, sourceSize, targetX, targetY, targetSize, hasLineOfSight) {
    if (hasLineOfSight === void 0) { hasLineOfSight = function () { return true; }; }
    var sourceCenter = getVenatorCenterTile(sourceX, sourceY, sourceSize);
    var targetCenter = getVenatorCenterTile(targetX, targetY, targetSize);
    var sourceScanTiles = sourceSize % 2 === 1
        ? [sourceCenter]
        : getAllTiles(sourceX, sourceY, sourceSize);
    var targetTiles = getAllTiles(targetX, targetY, targetSize);
    var targetClosestTile = getClosestTile(sourceCenter, targetX, targetY, targetSize);
    return sourceScanTiles.some(function (tile) { return isInRadius(tile, targetCenter, BOUNCE_RADIUS); })
        && targetTiles.some(function (tile) { return isInRadius(sourceCenter, tile, TARGET_TILE_RADIUS); })
        && ((sourceCenter[0] === targetClosestTile[0] && sourceCenter[1] === targetClosestTile[1])
            || hasLineOfSight(sourceCenter, targetClosestTile));
}
function canVenatorBounceBetween(source, target) {
    if (source.region !== target.region)
        return false;
    return canVenatorBounce(source.location.x, source.location.y, source.size, target.location.x, target.location.y, target.size, function (_a, _b) {
        var fromX = _a[0], fromY = _a[1];
        var toX = _b[0], toY = _b[1];
        return LineOfSight/* LineOfSight */.V.hasLineOfSight(source.region, fromX, fromY, toX, toY, 1, TARGET_TILE_RADIUS, false);
    });
}
function getNextVenatorBounceTarget(source) {
    for (var _i = 0, _a = Chunk/* ChunkUtils */.N.priorityGridOrder(source.chunkPosition); _i < _a.length; _i++) {
        var chunk = _a[_i];
        for (var _b = 0, _c = source.region.getNpcsInChunk(chunk.x, chunk.y); _b < _c.length; _b++) {
            var candidate = _c[_b];
            if (candidate === source || candidate.isDying() || candidate.currentStats.hitpoint <= 0)
                continue;
            // TODO: Exclude NPCs which already have lethal damage queued once the
            // engine exposes that state reliably.
            if (candidate.canBeAttacked() && canVenatorBounceBetween(source, candidate))
                return candidate;
        }
    }
    return null;
}

;// CONCATENATED MODULE: ./src/content/weapons/VenatorBow.ts
var VenatorBow_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var VenatorBow_assign = (undefined && undefined.__assign) || function () {
    VenatorBow_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return VenatorBow_assign.apply(this, arguments);
};











var PRIMARY_END_CYCLE = 15;
var FIRST_BOUNCE_END_CYCLE = 30;
var SECOND_BOUNCE_END_CYCLE = 45;
var BOUNCE_DAMAGE_MULTIPLIER = 0.66;
/** Charged Venator bow, including its two-target ricochet passive. */
var VenatorBow = /** @class */ (function (_super) {
    VenatorBow_extends(VenatorBow, _super);
    function VenatorBow() {
        var _this = _super.call(this, {
            visuals: {
                spotAnim: { id: CacheAssets/* CACHE_ASSETS */.fc.spotAnims.venatorBowProjectile.id },
            },
        }) || this;
        _this.bonuses = {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 90,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 25,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(VenatorBow.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.venatorBow.id;
        },
        enumerable: false,
        configurable: true
    });
    VenatorBow.prototype.attack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        var didAttack = _super.prototype.attack.call(this, from, to, bonuses, (0,Projectile/* mergeProjectileOptions */.K7)(options, {
            setDelay: 1,
            visuals: { endCycleOffset: PRIMARY_END_CYCLE },
        }));
        if (!didAttack || !(to instanceof Mob/* Mob */.B))
            return didAttack;
        var firstBounce = getNextVenatorBounceTarget(to);
        if (!firstBounce)
            return didAttack;
        this.queueBounce(from, to, firstBounce, bonuses, options, 1, PRIMARY_END_CYCLE, FIRST_BOUNCE_END_CYCLE, CacheAssets/* CACHE_ASSETS */.fc.sounds.venatorBowRicochetFirst.id);
        var secondBounce = getNextVenatorBounceTarget(firstBounce);
        if (secondBounce) {
            this.queueBounce(from, firstBounce, secondBounce, bonuses, options, 2, FIRST_BOUNCE_END_CYCLE, SECOND_BOUNCE_END_CYCLE, CacheAssets/* CACHE_ASSETS */.fc.sounds.venatorBowRicochetSecond.id);
        }
        return didAttack;
    };
    VenatorBow.prototype.queueBounce = function (attacker, visualSource, target, primaryBonuses, primaryOptions, damageDelay, startCycleOffset, endCycleOffset, soundId) {
        var _a;
        var visualProjectile = new Projectile/* Projectile */.c6(this, 0, visualSource, target, "range", {
            visuals: {
                spotAnim: { id: CacheAssets/* CACHE_ASSETS */.fc.spotAnims.venatorBowRicochetProjectile.id },
                startCycleOffset: startCycleOffset,
                endCycleOffset: endCycleOffset,
            },
        });
        visualSource.region.addProjectileGraphic(visualProjectile.graphic);
        _super.prototype.attack.call(this, attacker, target, VenatorBow_assign(VenatorBow_assign({}, primaryBonuses), { overallMultiplier: ((_a = primaryBonuses.overallMultiplier) !== null && _a !== void 0 ? _a : 1) * BOUNCE_DAMAGE_MULTIPLIER }), (0,Projectile/* mergeProjectileOptions */.K7)(primaryOptions, {
            setDelay: damageDelay,
            sound: new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(soundId), 0.1),
            visuals: { hidden: true },
        }));
    };
    VenatorBow.prototype.compatibleAmmo = function () {
        return [ItemName/* ItemName */.P.DRAGON_ARROWS, ItemName/* ItemName */.P.SEEKING_DRAGON_ARROWS];
    };
    VenatorBow.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.RAPID, AttackStylesController/* AttackStyle */.aF.LONGRANGE];
    };
    VenatorBow.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.BOW;
    };
    VenatorBow.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.RAPID;
    };
    Object.defineProperty(VenatorBow.prototype, "attackSpeed", {
        get: function () {
            return this.attackStyle() === AttackStylesController/* AttackStyle */.aF.RAPID ? 4 : 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorBow.prototype, "attackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.venatorBowAttack.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorBow.prototype, "attackRange", {
        get: function () {
            return this.attackStyle() === AttackStylesController/* AttackStyle */.aF.LONGRANGE ? 8 : 6;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorBow.prototype, "weight", {
        get: function () {
            return 4.5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorBow.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.VENATOR_BOW;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorBow.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorBow.prototype, "inventoryImage", {
        get: function () {
            return Venator_bow_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorBow.prototype, "attackAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.VenatorBowAttack;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorBow.prototype, "idleAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.VenatorBowIdle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorBow.prototype, "walkAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.VenatorBowWalk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorBow.prototype, "runAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.VenatorBowRun;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VenatorBow.prototype, "attackSpotAnim", {
        get: function () {
            return { id: CacheAssets/* CACHE_ASSETS */.fc.spotAnims.venatorBowAttack.id };
        },
        enumerable: false,
        configurable: true
    });
    return VenatorBow;
}(RangedWeapon/* RangedWeapon */.I));


;// CONCATENATED MODULE: ./src/assets/images/weapons/Zombie_axe.png
const Zombie_axe_namespaceObject = __webpack_require__.p + "337ec8415e5ceb71db05.png";
// EXTERNAL MODULE: ./src/sdk/Unit.ts + 3 modules
var Unit = __webpack_require__(3016);
;// CONCATENATED MODULE: ./src/content/weapons/ZombieAxe.ts
var ZombieAxe_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ZombieAxe_assign = (undefined && undefined.__assign) || function () {
    ZombieAxe_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ZombieAxe_assign.apply(this, arguments);
};









var ZombieAxe = /** @class */ (function (_super) {
    ZombieAxe_extends(ZombieAxe, _super);
    function ZombieAxe() {
        var _this = _super.call(this) || this;
        _this.bonuses = {
            attack: {
                stab: -3,
                slash: 105,
                crush: 90,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: -1,
                slash: 0,
                crush: 0,
                magic: 0,
                range: -1,
            },
            other: {
                meleeStrength: 107,
                rangedStrength: 0,
                magicDamage: 0,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(ZombieAxe.prototype, "cacheItemId", {
        get: function () { return CacheAssets/* CACHE_ASSETS */.fc.items.zombieAxe.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZombieAxe.prototype, "weight", {
        get: function () {
            return 2.721;
        },
        enumerable: false,
        configurable: true
    });
    ZombieAxe.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH, AttackStylesController/* AttackStyle */.aF.AGGRESSIVECRUSH, AttackStylesController/* AttackStyle */.aF.DEFENSIVE];
    };
    ZombieAxe.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.AXE;
    };
    ZombieAxe.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH;
    };
    Object.defineProperty(ZombieAxe.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ZOMBIE_AXE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZombieAxe.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ZombieAxe.prototype.hasSpecialAttack = function () {
        return false;
    };
    Object.defineProperty(ZombieAxe.prototype, "attackRange", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZombieAxe.prototype, "attackSpeed", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZombieAxe.prototype, "inventoryImage", {
        get: function () {
            return Zombie_axe_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    ZombieAxe.prototype.attack = function (from, to, bonuses, options) {
        var _a;
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        return _super.prototype.attack.call(this, from, to, ZombieAxe_assign(ZombieAxe_assign({}, bonuses), { attackStyle: (_a = bonuses.attackStyle) !== null && _a !== void 0 ? _a : (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.AGGRESSIVECRUSH ? "crush" : "slash") }), options);
    };
    ZombieAxe.prototype._attackLevel = function (from, to, bonuses) {
        return _super.prototype._attackLevel.call(this, from, to, ZombieAxe_assign(ZombieAxe_assign({}, bonuses), { styleBonus: from.type === Unit/* UnitTypes */.eK.PLAYER && this.attackStyle() === AttackStylesController/* AttackStyle */.aF.ACCURATE ? 3 : 0 }));
    };
    ZombieAxe.prototype._defenceLevel = function (from, to, bonuses) {
        return _super.prototype._defenceLevel.call(this, from, to, ZombieAxe_assign(ZombieAxe_assign({}, bonuses), { styleBonus: this.attackStyle() === AttackStylesController/* AttackStyle */.aF.DEFENSIVE ? 3 : 0 }));
    };
    Object.defineProperty(ZombieAxe.prototype, "attackAnimationId", {
        get: function () {
            return this.attackStyle() === AttackStylesController/* AttackStyle */.aF.AGGRESSIVECRUSH
                ? GLTFAnimationConstants/* PlayerAnimationIndices */.L.ZombieAxeCrush
                : GLTFAnimationConstants/* PlayerAnimationIndices */.L.ZombieAxeSlash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZombieAxe.prototype, "idleAnimationId", {
        get: function () {
            // User-confirmed pose: cache sequence 808 (the shared idle animation).
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.Idle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ZombieAxe.prototype, "attackSound", {
        get: function () {
            // Slash retains the generic melee fallback until its sound is confirmed.
            var soundId = this.attackStyle() === AttackStylesController/* AttackStyle */.aF.AGGRESSIVECRUSH
                ? CacheAssets/* CACHE_ASSETS */.fc.sounds.baxeCrush.id
                : CacheAssets/* CACHE_ASSETS */.fc.sounds.meleeAttack.id;
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(soundId), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    return ZombieAxe;
}(MeleeWeapon/* MeleeWeapon */.d));


;// CONCATENATED MODULE: ./src/assets/images/weapons/Blue_moon_spear.png
const Blue_moon_spear_namespaceObject = __webpack_require__.p + "75a1af06b94784a909fe.png";
;// CONCATENATED MODULE: ./src/content/weapons/BlueMoonSpear.ts
var BlueMoonSpear_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






/** Blue Moon spear: a 5-tick spear that can autocast (here: Blood Barrage, 10 tiles). */
var BlueMoonSpear = /** @class */ (function (_super) {
    BlueMoonSpear_extends(BlueMoonSpear, _super);
    function BlueMoonSpear() {
        var _this = _super.call(this) || this;
        _this.autocastSpell = new BloodBarrageSpell/* BloodBarrageSpell */.h();
        _this.bonuses = {
            attack: {
                stab: 70,
                slash: 62,
                crush: 62,
                magic: 30,
                range: 0,
            },
            defence: {
                stab: 2,
                slash: 3,
                crush: 1,
                magic: 15,
                range: 0,
            },
            other: {
                meleeStrength: 71,
                rangedStrength: 0,
                magicDamage: 0.05,
                prayer: 0,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
        return _this;
    }
    Object.defineProperty(BlueMoonSpear.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipStaff.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonSpear.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.blueMoonSpear.id;
        },
        enumerable: false,
        configurable: true
    });
    BlueMoonSpear.prototype.attack = function (from, to, bonuses) {
        if (bonuses === void 0) { bonuses = {}; }
        if (this.attackStyle() === AttackStylesController/* AttackStyle */.aF.AUTOCAST && from.isPlayer) {
            this.autocastSpell.cast(from, to);
            return true;
        }
        return _super.prototype.attack.call(this, from, to, bonuses);
    };
    BlueMoonSpear.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH, AttackStylesController/* AttackStyle */.aF.DEFENSIVE, AttackStylesController/* AttackStyle */.aF.AUTOCAST];
    };
    BlueMoonSpear.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.STAFF;
    };
    BlueMoonSpear.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.AUTOCAST;
    };
    Object.defineProperty(BlueMoonSpear.prototype, "weight", {
        get: function () {
            return 3.0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonSpear.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.BLUE_MOON_SPEAR;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonSpear.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    BlueMoonSpear.prototype.hasSpecialAttack = function () {
        return false;
    };
    Object.defineProperty(BlueMoonSpear.prototype, "attackRange", {
        get: function () {
            return this.attackStyle() === AttackStylesController/* AttackStyle */.aF.AUTOCAST ? 10 : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonSpear.prototype, "attackSpeed", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlueMoonSpear.prototype, "inventoryImage", {
        get: function () {
            return Blue_moon_spear_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return BlueMoonSpear;
}(MeleeWeapon/* MeleeWeapon */.d));


;// CONCATENATED MODULE: ./src/assets/images/weapons/Saradomin_godsword.png
const Saradomin_godsword_namespaceObject = __webpack_require__.p + "84f4eb52d2fe4b91699e.png";
;// CONCATENATED MODULE: ./src/content/weapons/SaradominGodsword.ts
var SaradominGodsword_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var SaradominGodsword_assign = (undefined && undefined.__assign) || function () {
    SaradominGodsword_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return SaradominGodsword_assign.apply(this, arguments);
};






/** Saradomin godsword: 6-tick two-handed slash weapon with the Healing Blade special. */
var SaradominGodsword = /** @class */ (function (_super) {
    SaradominGodsword_extends(SaradominGodsword, _super);
    function SaradominGodsword() {
        var _this = _super.call(this) || this;
        _this.bonuses = {
            attack: { stab: 0, slash: 132, crush: 80, magic: 0, range: 0 },
            defence: { stab: 0, slash: 0, crush: 0, magic: 0, range: 0 },
            other: { meleeStrength: 132, rangedStrength: 0, magicDamage: 0, prayer: 8 },
            targetSpecific: { undead: 0, slayer: 0 },
        };
        return _this;
    }
    Object.defineProperty(SaradominGodsword.prototype, "equipSoundId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.sounds.equipSword.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominGodsword.prototype, "cacheItemId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.items.saradominGodsword.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominGodsword.prototype, "weight", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    SaradominGodsword.prototype.attackStyles = function () {
        return [AttackStylesController/* AttackStyle */.aF.ACCURATE, AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH, AttackStylesController/* AttackStyle */.aF.DEFENSIVE];
    };
    SaradominGodsword.prototype.attackStyleCategory = function () {
        return AttackStylesController/* AttackStyleTypes */.F5.SLASHSWORD;
    };
    SaradominGodsword.prototype.defaultStyle = function () {
        return AttackStylesController/* AttackStyle */.aF.AGGRESSIVESLASH;
    };
    Object.defineProperty(SaradominGodsword.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.SARADOMIN_GODSWORD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominGodsword.prototype, "isTwoHander", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominGodsword.prototype, "attackRange", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominGodsword.prototype, "attackSpeed", {
        get: function () {
            return 6;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominGodsword.prototype, "inventoryImage", {
        get: function () {
            return Saradomin_godsword_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominGodsword.prototype, "attackAnimationId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.playerAnimations.godswordSlash.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominGodsword.prototype, "specialAttackAnimationId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.playerAnimations.saradominGodswordSpecial.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominGodsword.prototype, "idleAnimationId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.playerAnimations.godswordIdle.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominGodsword.prototype, "walkAnimationId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.playerAnimations.godswordWalk.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SaradominGodsword.prototype, "runAnimationId", {
        get: function () {
            return CacheAssets/* CACHE_ASSETS */.fc.playerAnimations.godswordRun.id;
        },
        enumerable: false,
        configurable: true
    });
    SaradominGodsword.prototype.hasSpecialAttack = function () {
        return true;
    };
    /**
     * Healing Blade (50% energy): +10% max hit, doubled accuracy; on a successful hit heals 50% and
     * restores 25% Prayer of the damage dealt (rounded up, minimum 10 Hitpoints / 5 Prayer).
     */
    SaradominGodsword.prototype.specialAttack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        bonuses.attackStyle = "slash";
        bonuses.styleBonus = bonuses.styleBonus || 0;
        bonuses.voidMultiplier = bonuses.voidMultiplier || 1;
        bonuses.gearMeleeMultiplier = bonuses.gearMeleeMultiplier || 1;
        bonuses.overallMultiplier = bonuses.overallMultiplier || 1;
        this._calculatePrayerEffects(from, to, bonuses);
        var rollModifiers = to.incomingAttackRollModifiers({ attacker: from, weapon: this, bonuses: bonuses });
        // Doubling the attack roll, expressed on the hit chance this engine exposes.
        var hitChance = Math.min(1, this._hitChance(from, to, bonuses) * 2);
        var hit = !this.isBlockable(from, to, bonuses) && (rollModifiers.guaranteedHit || Random/* Random */.o.get() <= hitChance);
        var maxHit = Math.floor(this._maxHit(from, to, bonuses) * 1.1);
        var damage = hit ? (rollModifiers.maxDamage ? maxHit : Math.floor(Random/* Random */.o.get() * (maxHit + 1))) : 0;
        this.damageRoll = damage;
        this.damage = damage;
        this.grantXp(from, to);
        this.registerProjectile(from, to, bonuses, SaradominGodsword_assign(SaradominGodsword_assign({}, options), { consumeTargetMaxDamageRoll: rollModifiers.maxDamage && rollModifiers.consumeAfterDamage, setDelay: 1 }));
        if (hit) {
            var heal = Math.max(10, Math.ceil(damage / 2));
            var prayer = Math.max(5, Math.ceil(damage / 4));
            from.currentStats.hitpoint = Math.min(from.stats.hitpoint, from.currentStats.hitpoint + heal);
            from.currentStats.prayer = Math.min(from.stats.prayer, from.currentStats.prayer + prayer);
        }
        this.lastHitHit = hit;
        return true;
    };
    return SaradominGodsword;
}(MeleeWeapon/* MeleeWeapon */.d));


;// CONCATENATED MODULE: ./src/content/weapons/index.ts
// generated using Generate Index https://marketplace.visualstudio.com/items?itemName=JayFong.generate-index
// @index('./*.ts', f => `export { ${f.name} } from './${f.name}';`)



















/***/ }),

/***/ 186:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  aF: () => (/* binding */ AttackStyle),
  F5: () => (/* binding */ AttackStyleTypes),
  D2: () => (/* binding */ AttackStylesController)
});

// EXTERNAL MODULE: ./src/sdk/utils/ImageLoader.ts
var ImageLoader = __webpack_require__(2987);
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/bow/accurate.png
const accurate_namespaceObject = __webpack_require__.p + "4ad955e3e08acdaebae5.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/bow/rapid.png
const rapid_namespaceObject = __webpack_require__.p + "b8fb2b682edcd2fd0f31.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/bow/longrange.png
const longrange_namespaceObject = __webpack_require__.p + "e89453914d6c939f248d.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/crossbows/accurate.png
const crossbows_accurate_namespaceObject = __webpack_require__.p + "61b23f64d3fe3ef0365f.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/crossbows/rapid.png
const crossbows_rapid_namespaceObject = __webpack_require__.p + "20ee1c00b1bad640f19c.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/crossbows/longrange.png
const crossbows_longrange_namespaceObject = __webpack_require__.p + "c0a2958faf3bbda91647.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/thrown/accurate.png
const thrown_accurate_namespaceObject = __webpack_require__.p + "52ecbb297eb6cb51d0d9.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/thrown/rapid.png
const thrown_rapid_namespaceObject = __webpack_require__.p + "56cc6ecbe7ace0122258.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/thrown/longrange.png
const thrown_longrange_namespaceObject = __webpack_require__.p + "1efea757d1b5335efe5d.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/staff/accurate.png
const staff_accurate_namespaceObject = __webpack_require__.p + "b14ef7443e26e4d5ee77.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/staff/aggressive.png
const aggressive_namespaceObject = __webpack_require__.p + "d330ac570b8787c5ed3c.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/staff/defensive.png
const defensive_namespaceObject = __webpack_require__.p + "925bf3a7692ef36f18ec.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/scythe/accurate.png
const scythe_accurate_namespaceObject = __webpack_require__.p + "0b96802520c114a99283.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/scythe/aggressiveslash.png
const aggressiveslash_namespaceObject = __webpack_require__.p + "46f97131f3c070803132.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/scythe/aggressivecrush.png
const aggressivecrush_namespaceObject = __webpack_require__.p + "74bae84163e8f31e48e2.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/scythe/defensive.png
const scythe_defensive_namespaceObject = __webpack_require__.p + "af4b3e185fc815a9ff04.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/chinchompas/short.png
const short_namespaceObject = __webpack_require__.p + "af0254e0a8460e2b048f.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/chinchompas/medium.png
const medium_namespaceObject = __webpack_require__.p + "226b0622b3a4dc1e37e7.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/chinchompas/long.png
const long_namespaceObject = __webpack_require__.p + "840747bbf1378388e397.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/swords/chop.png
const chop_namespaceObject = __webpack_require__.p + "bd4a0d8d88e478fd2f7d.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/swords/slash.png
const slash_namespaceObject = __webpack_require__.p + "8e1229e08828b015ee01.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/swords/lunge.png
const lunge_namespaceObject = __webpack_require__.p + "f2bf0e6cf3af145fcf7b.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/swords/block.png
const block_namespaceObject = __webpack_require__.p + "5615e73134324ee99e5c.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/attackstyles/axe/style_axe_chop.png
const style_axe_chop_namespaceObject = __webpack_require__.p + "d485b13f076b970cc9b6.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/attackstyles/axe/style_axe_hack.png
const style_axe_hack_namespaceObject = __webpack_require__.p + "f1bc5f2eb94a0390220e.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/attackstyles/axe/style_axe_smash.png
const style_axe_smash_namespaceObject = __webpack_require__.p + "a5b1b951e4a50fdf98f6.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/attackstyles/axe/style_axe_block.png
const style_axe_block_namespaceObject = __webpack_require__.p + "c44c552fb20677a3792d.png";
// EXTERNAL MODULE: ./src/sdk/XpDrop.ts
var XpDrop = __webpack_require__(3422);
;// CONCATENATED MODULE: ./src/sdk/AttackStylesController.ts

var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;





























//https://oldschool.runescape.wiki/w/Weapons/Types
var AttackStyleTypes;
(function (AttackStyleTypes) {
    AttackStyleTypes["CROSSBOW"] = "CROSSBOW";
    AttackStyleTypes["BOW"] = "BOW";
    AttackStyleTypes["CHINCHOMPA"] = "CHINCOMPA";
    AttackStyleTypes["GUN"] = "GUN";
    AttackStyleTypes["THROWN"] = "THROWN";
    AttackStyleTypes["BLADEDSTAFF"] = "BLADEDSTAFF";
    AttackStyleTypes["POWEREDSTAFF"] = "POWEREDSTAFF";
    AttackStyleTypes["STAFF"] = "STAFF";
    AttackStyleTypes["SALAMANDER"] = "SALAMANDER";
    AttackStyleTypes["TWOHANDSWORD"] = "TWOHANDSWORD";
    AttackStyleTypes["AXE"] = "AXE";
    AttackStyleTypes["BANNER"] = "BANNER";
    AttackStyleTypes["BLUNT"] = "BLUNT";
    AttackStyleTypes["BLUDGEON"] = "BLUDGEON";
    AttackStyleTypes["BULWARK"] = "BULWARK";
    AttackStyleTypes["CLAW"] = "CLAW";
    AttackStyleTypes["PICKAXE"] = "PICKAXE";
    AttackStyleTypes["POLEARM"] = "POLEARM";
    AttackStyleTypes["POLESTAFF"] = "POLESTAFF";
    AttackStyleTypes["SCYTHE"] = "SCYTHE";
    AttackStyleTypes["SLASHSWORD"] = "SLASHSWORD";
    AttackStyleTypes["SPEAR"] = "SPEAR";
    AttackStyleTypes["SPIKEDWEAPON"] = "SPIKEDWEAPON";
    AttackStyleTypes["STABSWORD"] = "STABSWORD";
    AttackStyleTypes["UNARMED"] = "UNARMED";
    AttackStyleTypes["WHIP"] = "WHIP";
})(AttackStyleTypes || (AttackStyleTypes = {}));
var AttackStyle;
(function (AttackStyle) {
    AttackStyle["ACCURATE"] = "ACCURATE";
    AttackStyle["RAPID"] = "RAPID";
    AttackStyle["LONGRANGE"] = "LONGRANGE";
    AttackStyle["REAP"] = "REAP";
    AttackStyle["AGGRESSIVECRUSH"] = "AGGRESSIVE (CRUSH)";
    AttackStyle["AGGRESSIVESLASH"] = "AGGRESSIVE (SLASH)";
    AttackStyle["STAB"] = "STAB";
    AttackStyle["DEFENSIVE"] = "DEFENSIVE";
    AttackStyle["CONTROLLED"] = "CONTROLLED";
    AttackStyle["AUTOCAST"] = "AUTOCAST";
    AttackStyle["SHORT_FUSE"] = "SHORT_FUSE";
    AttackStyle["MEDIUM_FUSE"] = "MEDIUM_FUSE";
    AttackStyle["LONG_FUSE"] = "LONG_FUSE";
})(AttackStyle || (AttackStyle = {}));
// xp multiplier constants
var DEFENCE_2 = { skill: "defence", multiplier: 2 };
var HITPOINTS_133 = { skill: "hitpoint", multiplier: 1.33 };
var MELEE_ACCURATE = [{ skill: "attack", multiplier: 4 }, HITPOINTS_133];
var MELEE_AGGRESSIVE = [{ skill: "strength", multiplier: 4 }, HITPOINTS_133];
var MELEE_DEFENSIVE = [{ skill: "defence", multiplier: 4 }, HITPOINTS_133];
var MELEE_CONTROLLED = [
    { skill: "attack", multiplier: 1.33 },
    { skill: "strength", multiplier: 1.33 },
    { skill: "defence", multiplier: 1.33 },
    HITPOINTS_133,
];
var RANGE_ACCURATE = [{ skill: "range", multiplier: 4 }, HITPOINTS_133];
var RANGE_RAPID = [{ skill: "range", multiplier: 4 }, HITPOINTS_133];
var RANGE_LONGRANGE = [{ skill: "range", multiplier: 2 }, DEFENCE_2, HITPOINTS_133];
// This badly needs a refactor to classify each styles by parent style
var AttackStylesController = /** @class */ (function () {
    function AttackStylesController() {
        this.stylesMap = {};
    }
    AttackStylesController.prototype.getAttackStyleForType = function (type, weapon) {
        if (!this.stylesMap[type]) {
            this.stylesMap[type] = weapon.defaultStyle();
        }
        return this.stylesMap[type];
    };
    AttackStylesController.prototype.setWeaponAttackStyle = function (weapon, newStyle) {
        this.stylesMap[weapon.attackStyleCategory()] = newStyle;
    };
    AttackStylesController.prototype.getWeaponAttackStyle = function (weapon) {
        return this.stylesMap[weapon.attackStyleCategory()];
    };
    AttackStylesController.prototype.getWeaponXpDrops = function (style, damage, npcMultiplier, category) {
        var xpTypes = category === AttackStyleTypes.AXE && style === AttackStyle.ACCURATE
            ? MELEE_ACCURATE
            : AttackStylesController.attackStyleXpType[style];
        return xpTypes.map(function (_a) {
            var skill = _a.skill, skillMultiplier = _a.multiplier;
            return new XpDrop/* XpDrop */.i(skill, damage * skillMultiplier * npcMultiplier, damage);
        });
    };
    AttackStylesController.prototype.getWeaponStrengthBonus = function (style) {
        var _a;
        return (_a = AttackStylesController.attackStyleStrengthBonus[style]) !== null && _a !== void 0 ? _a : 0;
    };
    AttackStylesController.attackStyleImageMap = (_a = {},
        _a[AttackStyleTypes.CROSSBOW] = (_b = {},
            _b[AttackStyle.ACCURATE] = ImageLoader/* ImageLoader */.$.createImage(crossbows_accurate_namespaceObject),
            _b[AttackStyle.RAPID] = ImageLoader/* ImageLoader */.$.createImage(crossbows_rapid_namespaceObject),
            _b[AttackStyle.LONGRANGE] = ImageLoader/* ImageLoader */.$.createImage(crossbows_longrange_namespaceObject),
            _b),
        _a[AttackStyleTypes.BOW] = (_c = {},
            _c[AttackStyle.ACCURATE] = ImageLoader/* ImageLoader */.$.createImage(accurate_namespaceObject),
            _c[AttackStyle.RAPID] = ImageLoader/* ImageLoader */.$.createImage(rapid_namespaceObject),
            _c[AttackStyle.LONGRANGE] = ImageLoader/* ImageLoader */.$.createImage(longrange_namespaceObject),
            _c),
        _a[AttackStyleTypes.STAFF] = (_d = {},
            _d[AttackStyle.ACCURATE] = ImageLoader/* ImageLoader */.$.createImage(staff_accurate_namespaceObject),
            _d[AttackStyle.AGGRESSIVECRUSH] = ImageLoader/* ImageLoader */.$.createImage(aggressive_namespaceObject),
            _d[AttackStyle.DEFENSIVE] = ImageLoader/* ImageLoader */.$.createImage(defensive_namespaceObject),
            _d[AttackStyle.AUTOCAST] = ImageLoader/* ImageLoader */.$.createImage(defensive_namespaceObject),
            _d),
        _a[AttackStyleTypes.THROWN] = (_e = {},
            _e[AttackStyle.ACCURATE] = ImageLoader/* ImageLoader */.$.createImage(thrown_accurate_namespaceObject),
            _e[AttackStyle.RAPID] = ImageLoader/* ImageLoader */.$.createImage(thrown_rapid_namespaceObject),
            _e[AttackStyle.LONGRANGE] = ImageLoader/* ImageLoader */.$.createImage(thrown_longrange_namespaceObject),
            _e),
        _a[AttackStyleTypes.SCYTHE] = (_f = {},
            _f[AttackStyle.REAP] = ImageLoader/* ImageLoader */.$.createImage(scythe_accurate_namespaceObject),
            _f[AttackStyle.AGGRESSIVESLASH] = ImageLoader/* ImageLoader */.$.createImage(aggressiveslash_namespaceObject),
            _f[AttackStyle.AGGRESSIVECRUSH] = ImageLoader/* ImageLoader */.$.createImage(aggressivecrush_namespaceObject),
            _f[AttackStyle.DEFENSIVE] = ImageLoader/* ImageLoader */.$.createImage(scythe_defensive_namespaceObject),
            _f),
        _a[AttackStyleTypes.AXE] = (_g = {},
            _g[AttackStyle.ACCURATE] = ImageLoader/* ImageLoader */.$.createImage(style_axe_chop_namespaceObject),
            _g[AttackStyle.AGGRESSIVESLASH] = ImageLoader/* ImageLoader */.$.createImage(style_axe_hack_namespaceObject),
            _g[AttackStyle.AGGRESSIVECRUSH] = ImageLoader/* ImageLoader */.$.createImage(style_axe_smash_namespaceObject),
            _g[AttackStyle.DEFENSIVE] = ImageLoader/* ImageLoader */.$.createImage(style_axe_block_namespaceObject),
            _g),
        _a[AttackStyleTypes.SLASHSWORD] = (_h = {},
            _h[AttackStyle.ACCURATE] = ImageLoader/* ImageLoader */.$.createImage(chop_namespaceObject),
            _h[AttackStyle.AGGRESSIVESLASH] = ImageLoader/* ImageLoader */.$.createImage(slash_namespaceObject),
            _h[AttackStyle.STAB] = ImageLoader/* ImageLoader */.$.createImage(lunge_namespaceObject),
            _h[AttackStyle.DEFENSIVE] = ImageLoader/* ImageLoader */.$.createImage(block_namespaceObject),
            _h),
        _a[AttackStyleTypes.CHINCHOMPA] = (_j = {},
            _j[AttackStyle.SHORT_FUSE] = ImageLoader/* ImageLoader */.$.createImage(short_namespaceObject),
            _j[AttackStyle.MEDIUM_FUSE] = ImageLoader/* ImageLoader */.$.createImage(medium_namespaceObject),
            _j[AttackStyle.LONG_FUSE] = ImageLoader/* ImageLoader */.$.createImage(long_namespaceObject),
            _j),
        _a[AttackStyleTypes.POWEREDSTAFF] = (_k = {},
            _k[AttackStyle.ACCURATE] = ImageLoader/* ImageLoader */.$.createImage(staff_accurate_namespaceObject),
            _k[AttackStyle.LONGRANGE] = ImageLoader/* ImageLoader */.$.createImage(defensive_namespaceObject),
            _k),
        _a);
    AttackStylesController.attackStyleXpType = (_l = {},
        _l[AttackStyle.ACCURATE] = RANGE_ACCURATE,
        _l[AttackStyle.RAPID] = RANGE_RAPID,
        _l[AttackStyle.LONGRANGE] = RANGE_LONGRANGE,
        _l[AttackStyle.REAP] = MELEE_ACCURATE,
        _l[AttackStyle.AGGRESSIVECRUSH] = MELEE_AGGRESSIVE,
        _l[AttackStyle.AGGRESSIVESLASH] = MELEE_AGGRESSIVE,
        // TODO: add different defensives for different weapons
        _l[AttackStyle.DEFENSIVE] = MELEE_DEFENSIVE,
        _l[AttackStyle.STAB] = MELEE_CONTROLLED,
        _l[AttackStyle.CONTROLLED] = MELEE_CONTROLLED,
        _l[AttackStyle.AUTOCAST] = [{ skill: "magic", multiplier: 2 }, HITPOINTS_133],
        // TODO: AUTOCAST_DEFENSIVE
        _l[AttackStyle.SHORT_FUSE] = RANGE_ACCURATE,
        _l[AttackStyle.MEDIUM_FUSE] = RANGE_RAPID,
        _l[AttackStyle.LONG_FUSE] = RANGE_LONGRANGE,
        _l);
    AttackStylesController.attackStyleStrengthBonus = (_m = {},
        // aggressive = 3
        _m[AttackStyle.AGGRESSIVECRUSH] = 3,
        _m[AttackStyle.AGGRESSIVESLASH] = 3,
        // controlled = 1
        _m[AttackStyle.CONTROLLED] = 1,
        _m[AttackStyle.STAB] = 1,
        _m);
    AttackStylesController.controller = new AttackStylesController();
    return AttackStylesController;
}());



/***/ }),

/***/ 165:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: () => (/* binding */ BasePrayer),
/* harmony export */   u: () => (/* binding */ PrayerGroups)
/* harmony export */ });
/* harmony import */ var _utils_ImageLoader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2987);


var PrayerGroups;
(function (PrayerGroups) {
    PrayerGroups["OVERHEADS"] = "overheads";
    PrayerGroups["DEFENCE"] = "defence";
    PrayerGroups["STRENGTH"] = "strength";
    PrayerGroups["ACCURACY"] = "accuracy";
    PrayerGroups["RANGE"] = "range";
    PrayerGroups["HEARTS"] = "hearts";
    PrayerGroups["PROTECTITEM"] = "protectitem";
    PrayerGroups["PRESERVE"] = "preserve";
})(PrayerGroups || (PrayerGroups = {}));
var BasePrayer = /** @class */ (function () {
    function BasePrayer() {
        this.isActive = false; // server-side
        this.isLit = false; // client-side
        this.nextActiveState = null; // enqueued server-side
        this.willPlayOnSound = false;
        this.willPlayOffSound = false;
        this.disabledTicks = 0;
        this.deactivate();
    }
    BasePrayer.prototype.levelRequirement = function () {
        return 99;
    };
    BasePrayer.prototype.tick = function () {
        if (this.disabledTicks > 0) {
            this.disabledTicks--;
            this.isActive = false;
            this.isLit = false;
            this.nextActiveState = null;
            return;
        }
        if (this.nextActiveState !== null) {
            this.isActive = this.nextActiveState;
            this.isLit = this.isActive;
            this.nextActiveState = null;
        }
    };
    BasePrayer.prototype.drainRate = function () {
        throw new Error("prayer does not have proper drain rate");
    };
    // currently only used for overheads
    BasePrayer.prototype.feature = function () {
        return "";
    };
    Object.defineProperty(BasePrayer.prototype, "name", {
        get: function () {
            return "Protect from Magic";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePrayer.prototype, "groups", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    /** Currently only used by Quick-Prayers. */
    BasePrayer.prototype.activate = function (player) {
        if (this.disabledTicks > 0) {
            this.playOffSound();
            return;
        }
        if (player.stats.prayer < this.levelRequirement()) {
            return;
        }
        if (!this.isActive || this.nextActiveState === false)
            this.willPlayOnSound = true;
        this.nextActiveState = true;
        this.handleConflicts(player);
    };
    /**
     * Preserve the combined toggle operation for programmatic callers. Prayer
     * controls split these operations across the client and server timelines.
     */
    BasePrayer.prototype.toggle = function (player) {
        if (this.toggleClient(player))
            this.toggleServer(player);
    };
    /** Update the locally displayed prayer state when the client handles a click. */
    BasePrayer.prototype.toggleClient = function (player) {
        if (this.disabledTicks > 0) {
            this.playOffSound();
            return false;
        }
        if (player.stats.prayer < this.levelRequirement()) {
            return false;
        }
        if (this.isLit) {
            this.isLit = false;
            this.willPlayOffSound = true;
        }
        else {
            this.isLit = true;
            this.willPlayOnSound = true;
        }
        return true;
    };
    /** Apply a received prayer toggle to the authoritative server-side state. */
    BasePrayer.prototype.toggleServer = function (player) {
        if (this.disabledTicks > 0) {
            this.isLit = this.isActive;
            this.playOffSound();
            return;
        }
        if (player.stats.prayer < this.levelRequirement()) {
            this.isLit = this.isActive;
            return;
        }
        var activeState = this.nextActiveState == null ? this.isActive : this.nextActiveState;
        this.nextActiveState = !activeState;
        this.handleConflicts(player);
    };
    BasePrayer.prototype.handleConflicts = function (player) {
        var _this = this;
        var conflictingPrayers = player.prayerController.prayers
            .filter(function (it) { return it !== _this && _this.groups.some(function (group) { return it === null || it === void 0 ? void 0 : it.groups.includes(group); }); });
        conflictingPrayers.forEach(function (prayer) {
            prayer.nextActiveState = false;
        });
    };
    BasePrayer.prototype.deactivate = function () {
        if (this.isActive || this.nextActiveState)
            this.willPlayOffSound = true;
        this.nextActiveState = false;
    };
    BasePrayer.prototype.disableForTicks = function (ticks) {
        this.disabledTicks = Math.max(this.disabledTicks, ticks);
        this.isActive = false;
        this.isLit = false;
        this.nextActiveState = null;
        this.willPlayOffSound = true;
    };
    BasePrayer.prototype.isOverhead = function () {
        return false;
    };
    BasePrayer.prototype.overheadImageReference = function () {
        return "";
    };
    BasePrayer.prototype.overheadImage = function () {
        if (!this.cachedImage && this.overheadImageReference()) {
            this.cachedImage = _utils_ImageLoader__WEBPACK_IMPORTED_MODULE_0__/* .ImageLoader */ .$.createImage(this.overheadImageReference());
            return null;
        }
        return this.cachedImage;
    };
    BasePrayer.prototype.playOffSound = function () {
        // Override me
    };
    BasePrayer.prototype.playOnSound = function () {
        // Override me
    };
    return BasePrayer;
}());



/***/ }),

/***/ 5843:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: () => (/* binding */ CollisionType),
/* harmony export */   F: () => (/* binding */ Collision)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2543);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Pathing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5454);


var CollisionType;
(function (CollisionType) {
    CollisionType[CollisionType["NONE"] = 0] = "NONE";
    CollisionType[CollisionType["BLOCK_MOVEMENT"] = 1] = "BLOCK_MOVEMENT";
})(CollisionType || (CollisionType = {}));
var Collision = /** @class */ (function () {
    function Collision() {
    }
    Collision.collisionMath = function (x, y, s, x2, y2, s2) {
        return !(x > x2 + s2 - 1 || x + s - 1 < x2 || y - s + 1 > y2 || y < y2 - s2 + 1);
    };
    // include the outer boundary - used for precision checks with perceivedLocation
    Collision.collisionMathInclusive = function (x, y, s, x2, y2, s2) {
        return !(x > x2 + s2 || x + s - 1 < x2 || y - s > y2 || y < y2 - s2 + 1);
    };
    // Mob collision
    Collision.collidesWithMob = function (region, x, y, s, mob) {
        return Collision.collisionMath(x, y, s, mob.location.x, mob.location.y, mob.size);
    };
    Collision.collidesWithAnyMobs = function (region, x, y, s, mobToAvoid) {
        if (mobToAvoid === void 0) { mobToAvoid = null; }
        for (var i = 0; i < region.mobs.length; i++) {
            if (region.mobs[i] === mobToAvoid) {
                continue;
            }
            var collidedWithSpecificMob = Collision.collidesWithMob(region, x, y, s, region.mobs[i]);
            if (collidedWithSpecificMob && region.mobs[i].consumesSpace) {
                return region.mobs[i];
            }
        }
        return null;
    };
    // Entity collision
    // Same as above but only returns entities with collision enabled.
    Collision.collideableEntitiesAtPoint = function (region, x, y, s) {
        return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.filter)(_Pathing__WEBPACK_IMPORTED_MODULE_1__/* .Pathing */ .G.entitiesAtPoint(region, x, y, s), function (entity) { return entity.collisionType != CollisionType.NONE; });
    };
    Collision.collidesWithAnyEntities = function (region, x, y, s) {
        for (var i = 0; i < region.entities.length; i++) {
            var entity = region.entities[i];
            if (entity.collisionType != CollisionType.NONE &&
                Collision.collisionMath(x, y, s, entity.location.x, entity.location.y, entity.size)) {
                return true;
            }
        }
        return false;
    };
    Collision.collidesWithAnyLoSBlockingEntities = function (region, x, y, s) {
        for (var i = 0; i < region.entities.length; i++) {
            var entity = region.entities[i];
            if (Collision.collisionMath(x, y, s, entity.location.x, entity.location.y, entity.size)) {
                return entity.lineOfSight;
            }
        }
        return null;
    };
    Collision.collidesWithAnyMobsAtPerceivedDisplayLocation = function (region, x, y, tickPercent) {
        var mobs = [];
        for (var i = 0; i < region.mobs.length; i++) {
            var collidedWithSpecificMob = Collision.collidesWithUnitAtPerceivedDisplayLocation(x, y, tickPercent, region.mobs[i]);
            if (collidedWithSpecificMob) {
                mobs.push(region.mobs[i]);
            }
        }
        return mobs;
    };
    Collision.collidesWithUnitAtPerceivedDisplayLocation = function (x, y, tickPercent, unit) {
        var _a = unit.getPerceivedLocation(tickPercent), perceivedX = _a.x, perceivedY = _a.y;
        // WTF
        return Collision.collisionMathInclusive(x, y, 1.0, perceivedX, perceivedY, unit.size);
    };
    Collision.collidesWithAnyPlayersAtPerceivedDisplayLocation = function (region, x, y, tickPercent) {
        var players = [];
        for (var i = 0; i < region.players.length; i++) {
            var collidedWithSpecificPlayer = Collision.collidesWithUnitAtPerceivedDisplayLocation(x, y, tickPercent, region.players[i]);
            if (collidedWithSpecificPlayer) {
                players.push(region.players[i]);
            }
        }
        return players;
    };
    return Collision;
}());



/***/ }),

/***/ 8239:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: () => (/* binding */ DelayedAction)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2543);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

var DelayedAction = /** @class */ (function () {
    function DelayedAction(action, delay) {
        this.action = action;
        this.delay = delay + 1;
        this.identifier = Math.random() * 1000000;
    }
    DelayedAction.reset = function () {
        this.delayedActions = [];
        this.delayedNpcActions = [];
    };
    /**
     * Register a delayed action to be called in the middle of a tick (after npc actions, before player actions).
     * Use this if you need an action that reads from an NPC and writes to a player in the same tick.
     */
    DelayedAction.registerDelayedNpcAction = function (delayedAction) {
        DelayedAction.delayedNpcActions.push(delayedAction);
        return delayedAction.identifier;
    };
    /**
     * Register a delayed action to be called at the end of the tick (after player action)
     */
    DelayedAction.registerDelayedAction = function (delayedAction) {
        DelayedAction.delayedActions.push(delayedAction);
        return delayedAction.identifier;
    };
    DelayedAction.afterNpcTick = function () {
        var executedActions = [];
        DelayedAction.delayedNpcActions.forEach(function (delayedAction) {
            delayedAction.delay--;
            if (delayedAction.delay === 0) {
                delayedAction.action();
                executedActions.push(delayedAction);
            }
        });
        executedActions.forEach(function (executedActions) {
            (0,lodash__WEBPACK_IMPORTED_MODULE_0__.remove)(DelayedAction.delayedNpcActions, executedActions);
        });
    };
    DelayedAction.tick = function () {
        var executedActions = [];
        DelayedAction.delayedActions.forEach(function (delayedAction) {
            delayedAction.delay--;
            if (delayedAction.delay === 0) {
                delayedAction.action();
                executedActions.push(delayedAction);
            }
        });
        executedActions.forEach(function (executedActions) {
            (0,lodash__WEBPACK_IMPORTED_MODULE_0__.remove)(DelayedAction.delayedActions, executedActions);
        });
    };
    // actions to be played after npc action (before players)
    DelayedAction.delayedNpcActions = [];
    // actions to be played after player action
    DelayedAction.delayedActions = [];
    return DelayedAction;
}());



/***/ }),

/***/ 681:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: () => (/* binding */ Eating)
/* harmony export */ });

var Eating = /** @class */ (function () {
    function Eating() {
        this.foodDelay = 0;
        this.potionDelay = 0;
        this.comboDelay = 0;
    }
    Eating.prototype.tickFood = function (player) {
        this.foodDelay--;
        this.potionDelay--;
        this.comboDelay--;
        if (this.currentFood) {
            this.currentFood.eat(player);
            player.attackDelay += 3;
            this.currentFood = null;
        }
        if (this.currentPotion) {
            this.currentPotion.drink(player);
            this.currentPotion = null;
        }
        if (this.currentComboFood) {
            this.currentComboFood.eat(player);
            player.attackDelay += 3;
            this.currentComboFood = null;
        }
    };
    Eating.prototype.canEatFood = function () {
        return this.foodDelay <= 0;
    };
    Eating.prototype.canDrinkPotion = function () {
        return this.potionDelay <= 0;
    };
    Eating.prototype.canEatComboFood = function () {
        return this.comboDelay <= 0;
    };
    // The weird way that the lower tiers also eat the higher tiers forces the behavior of food -> potion -> karambwan
    Eating.prototype.eatFood = function (food) {
        if (!this.canEatFood()) {
            return;
        }
        this.currentFood = food || null;
        this.foodDelay = 3;
        if (this.currentFood) {
            this.currentFood.consumeItem(this.player);
        }
    };
    Eating.prototype.drinkPotion = function (potion) {
        if (!this.canDrinkPotion()) {
            return false;
        }
        this.currentPotion = potion || null;
        this.foodDelay = 3;
        this.potionDelay = 3;
        if (this.currentPotion) {
            this.currentPotion.doses--;
        }
        return true;
    };
    Eating.prototype.eatComboFood = function (karambwan) {
        if (!this.canEatComboFood()) {
            return;
        }
        this.foodDelay = 3;
        this.potionDelay = 3;
        this.currentComboFood = karambwan || null;
        this.comboDelay = 3;
        if (this.currentComboFood) {
            this.currentComboFood.consumeItem(this.player);
        }
    };
    return Eating;
}());



/***/ }),

/***/ 1184:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   w: () => (/* binding */ Entity)
/* harmony export */ });
/* harmony import */ var _Settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8406);
/* harmony import */ var _Unit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3016);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2543);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Collision__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5843);
/* harmony import */ var _LineOfSight__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8499);
/* harmony import */ var _Renderable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(427);

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






var Entity = /** @class */ (function (_super) {
    __extends(Entity, _super);
    function Entity(region, location) {
        var _this = _super.call(this) || this;
        _this.dying = -1;
        _this.location = location;
        _this.region = region;
        return _this;
    }
    Object.defineProperty(Entity.prototype, "serialNumber", {
        get: function () {
            if (!this._serialNumber) {
                this._serialNumber = String(Math.random());
            }
            return this._serialNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Entity.prototype, "selectable", {
        // entities are not selectable by default
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Entity.prototype.shouldDestroy = function () {
        return this.dying === 0;
    };
    Object.defineProperty(Entity.prototype, "size", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Entity.prototype.isDying = function () {
        return this.dying > 0;
    };
    Object.defineProperty(Entity.prototype, "collisionType", {
        get: function () {
            return _Collision__WEBPACK_IMPORTED_MODULE_3__/* .CollisionType */ .B.BLOCK_MOVEMENT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Entity.prototype, "lineOfSight", {
        get: function () {
            return _LineOfSight__WEBPACK_IMPORTED_MODULE_4__/* .LineOfSightMask */ .Z.FULL_MASK;
        },
        enumerable: false,
        configurable: true
    });
    // Returns true if this game object is on the specified tile.
    Entity.prototype.isOnTile = function (x, y) {
        return (x >= this.location.x &&
            x <= this.location.x + this.size &&
            y <= this.location.y &&
            y >= this.location.y - this.size);
    };
    // Returns the closest tile on this mob to the specified point.
    Entity.prototype.getClosestTileTo = function (x, y) {
        // We simply clamp the target point to our own boundary box.
        return [
            (0,lodash__WEBPACK_IMPORTED_MODULE_2__.clamp)(x, this.location.x, this.location.x + this.size - 1),
            (0,lodash__WEBPACK_IMPORTED_MODULE_2__.clamp)(y, this.location.y - this.size + 1, this.location.y),
        ];
    };
    Entity.prototype.entityName = function () {
        return null;
    };
    Entity.prototype.getPerceivedLocation = function (tickPercent) {
        return __assign(__assign({}, this.location), { z: 0 });
    };
    Entity.prototype.getPerceivedRotation = function () {
        return 0;
    };
    Entity.prototype.getTrueLocation = function () {
        return this.location;
    };
    Object.defineProperty(Entity.prototype, "color", {
        get: function () {
            return "#000073";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Entity.prototype, "type", {
        get: function () {
            // Kind of odd that Units live inside the unit class, but this isn't a unit
            return _Unit__WEBPACK_IMPORTED_MODULE_1__/* .UnitTypes */ .eK.ENTITY;
        },
        enumerable: false,
        configurable: true
    });
    Entity.prototype.tick = function () {
        // Override me
    };
    Entity.prototype.drawUILayer = function (tickPercent, projector, context, scale) {
        // Override me
    };
    Entity.prototype.draw = function (tickPercent, context) {
        context.fillStyle = "#000073";
        context.fillRect(this.location.x * _Settings__WEBPACK_IMPORTED_MODULE_0__/* .Settings */ .w.tileSize, (this.location.y - this.size + 1) * _Settings__WEBPACK_IMPORTED_MODULE_0__/* .Settings */ .w.tileSize, this.size * _Settings__WEBPACK_IMPORTED_MODULE_0__/* .Settings */ .w.tileSize, this.size * _Settings__WEBPACK_IMPORTED_MODULE_0__/* .Settings */ .w.tileSize);
    };
    Object.defineProperty(Entity.prototype, "animationIndex", {
        get: function () {
            return -1;
        },
        enumerable: false,
        configurable: true
    });
    return Entity;
}(_Renderable__WEBPACK_IMPORTED_MODULE_5__/* .Renderable */ .l));



/***/ }),

/***/ 5275:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: () => (/* binding */ EntityNames)
/* harmony export */ });

var EntityNames;
(function (EntityNames) {
    EntityNames["TILE_MARKER"] = "Tile Marker";
    EntityNames["INFERNO_SHIELD"] = "Inferno Shield";
    EntityNames["TZ_KAL_ZUK"] = "TzKal-Zuk";
    EntityNames["JAL_XIL"] = "Jal-Xil";
    EntityNames["JAL_ZEK"] = "Jal-Zek";
    EntityNames["YT_HUR_KOT"] = "Yt-HurKot";
    EntityNames["JAL_TOK_JAD"] = "JalTok-Jad";
    EntityNames["JAL_NIB"] = "Jal-Nib";
    EntityNames["JAL_MEJ_RAJ"] = "Jal-MejRah";
    EntityNames["JAL_MEJ_JAK"] = "Jal-MejJak";
    EntityNames["JAL_IM_KOT"] = "Jal-ImKot";
    EntityNames["JAL_AK_REK_XIL"] = "Jal-AkRek-Xil";
    EntityNames["JAL_AK_REK_MEJ"] = "Jal-AkRek-Mej";
    EntityNames["JAL_AK_REK_KET"] = "Jal-AkRek-Ket";
    EntityNames["JAL_AK"] = "Jal-Ak";
    EntityNames["PILLAR"] = "Pillar";
    EntityNames["SOL_HEREDIT"] = "Sol Heredit";
})(EntityNames || (EntityNames = {}));


/***/ }),

/***/ 3107:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $i: () => (/* binding */ Equipment),
/* harmony export */   Fm: () => (/* binding */ EQUIPMENT_TYPE_TO_SLOT),
/* harmony export */   WA: () => (/* binding */ EquipmentTypes)
/* harmony export */ });
/* harmony import */ var _Item__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2376);
/* harmony import */ var _DelayedAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8239);
/* harmony import */ var _audio_CacheSoundEffects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5432);
/* harmony import */ var _utils_SoundCache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6018);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;




var EquipmentTypes;
(function (EquipmentTypes) {
    EquipmentTypes["HELMET"] = "helmet";
    EquipmentTypes["CHEST"] = "chest";
    EquipmentTypes["LEGS"] = "legs";
    EquipmentTypes["FEET"] = "feet";
    EquipmentTypes["GLOVES"] = "gloves";
    EquipmentTypes["WEAPON"] = "weapon";
    EquipmentTypes["OFFHAND"] = "offhand";
    EquipmentTypes["AMMO"] = "ammo";
    EquipmentTypes["BACK"] = "back";
    EquipmentTypes["NECK"] = "neck";
    EquipmentTypes["RING"] = "ring";
})(EquipmentTypes || (EquipmentTypes = {}));
// maybe we ought to rename the values instead?
var EQUIPMENT_TYPE_TO_SLOT = (_a = {},
    _a[EquipmentTypes.HELMET] = 'helmet',
    _a[EquipmentTypes.CHEST] = "chest",
    _a[EquipmentTypes.LEGS] = "legs",
    _a[EquipmentTypes.FEET] = "feet",
    _a[EquipmentTypes.GLOVES] = "gloves",
    _a[EquipmentTypes.WEAPON] = "weapon",
    _a[EquipmentTypes.OFFHAND] = "offhand",
    _a[EquipmentTypes.AMMO] = "ammo",
    _a[EquipmentTypes.BACK] = "cape",
    _a[EquipmentTypes.NECK] = "necklace",
    _a[EquipmentTypes.RING] = "ring",
    _a);
var Equipment = /** @class */ (function (_super) {
    __extends(Equipment, _super);
    function Equipment() {
        var _this = _super.call(this) || this;
        _this.defaultAction = "Equip";
        _this.setStats();
        return _this;
    }
    Object.defineProperty(Equipment.prototype, "hasInventoryLeftClick", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Equipment.prototype.inventoryLeftClick = function (player) {
        var currentItem = this.currentEquipment(player) || null;
        var openInventorySlots = player.openInventorySlots();
        openInventorySlots.unshift(player.inventory.indexOf(this));
        this.assignToPlayer(player);
        player.inventory[openInventorySlots.shift()] = currentItem;
        player.equipmentChanged();
        this.scheduleEquipmentSound();
    };
    Object.defineProperty(Equipment.prototype, "equipSoundId", {
        /** Cache sound effect to play when this item is equipped, or null for silence. */
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Equip actions are processed on a world tick. Keep the sound on that same
     * tick boundary instead of playing directly from the browser click handler.
     */
    Equipment.prototype.scheduleEquipmentSound = function () {
        if (this.equipSoundId === null) {
            return;
        }
        var sound = new _utils_SoundCache__WEBPACK_IMPORTED_MODULE_3__/* .Sound */ .A((0,_audio_CacheSoundEffects__WEBPACK_IMPORTED_MODULE_2__/* .cacheSound */ .cp)(this.equipSoundId), 0.1);
        _DelayedAction__WEBPACK_IMPORTED_MODULE_1__/* .DelayedAction */ .T.registerDelayedAction(new _DelayedAction__WEBPACK_IMPORTED_MODULE_1__/* .DelayedAction */ .T(function () { return _utils_SoundCache__WEBPACK_IMPORTED_MODULE_3__/* .SoundCache */ .U.play(sound); }, 0));
    };
    Object.defineProperty(Equipment.prototype, "equipmentSetEffect", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Equipment.prototype.setStats = function () {
        // throw new Error('stats must be set, none were found')
    };
    Equipment.prototype.currentEquipment = function (player) {
        return null;
    };
    Equipment.prototype.assignToPlayer = function (player) {
        throw new Error("not able to assign to unit equipment");
    };
    Equipment.prototype.unassignToPlayer = function (player) {
        throw new Error("not able to unassign to unit equipment");
    };
    Equipment.prototype.unequip = function (player) {
        var openInventorySlots = player.openInventorySlots();
        if (openInventorySlots.length === 0) {
            return;
        }
        this.unassignToPlayer(player);
        player.equipmentChanged();
        player.inventory[openInventorySlots.shift()] = this;
        this.scheduleEquipmentSound();
    };
    Object.defineProperty(Equipment.prototype, "type", {
        get: function () {
            throw new Error("equipment must have a type");
        },
        enumerable: false,
        configurable: true
    });
    Equipment.prototype.updateBonuses = function (gear) {
        // update bonuses based on other items that have been equipped
    };
    Object.defineProperty(Equipment.prototype, "attackAnimationId", {
        /**
         * index of animation to use for attacks if possible
         */
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    return Equipment;
}(_Item__WEBPACK_IMPORTED_MODULE_0__/* .Item */ .q));



/***/ }),

/***/ 7245:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: () => (/* binding */ GraphicsObject)
/* harmony export */ });
/* harmony import */ var _Collision__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5843);
/* harmony import */ var _Entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1184);
/* harmony import */ var _LineOfSight__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8499);
/* harmony import */ var _rendering_CacheRenderInstancedModel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6956);
/* harmony import */ var _rendering_CacheRenderReference__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7757);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





/**
 * A standalone, one-shot world instance of a cache spot-animation definition.
 *
 * This mirrors the client's GraphicsObject: the spotanim ID supplies its model,
 * sequence, scale, and cache rotation, while the spawn supplies world placement,
 * height, and delay. The entity removes itself when the sequence finishes.
 */
var GraphicsObject = /** @class */ (function (_super) {
    __extends(GraphicsObject, _super);
    function GraphicsObject(region, location, spotAnimId, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, region, location) || this;
        _this.spotAnimId = spotAnimId;
        _this.options = options;
        _this.finished = false;
        return _this;
    }
    Object.defineProperty(GraphicsObject.prototype, "collisionType", {
        get: function () { return _Collision__WEBPACK_IMPORTED_MODULE_0__/* .CollisionType */ .B.NONE; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphicsObject.prototype, "lineOfSight", {
        get: function () { return _LineOfSight__WEBPACK_IMPORTED_MODULE_2__/* .LineOfSightMask */ .Z.NONE; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphicsObject.prototype, "drawOutline", {
        get: function () { return false; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphicsObject.prototype, "color", {
        get: function () { return "#ffffff"; },
        enumerable: false,
        configurable: true
    });
    GraphicsObject.prototype.shouldDestroy = function () { return this.finished; };
    GraphicsObject.prototype.create3dModel = function () {
        var _this = this;
        return _rendering_CacheRenderInstancedModel__WEBPACK_IMPORTED_MODULE_3__/* .CacheRenderInstancedModel */ .H.forRenderable(this, _rendering_CacheRenderReference__WEBPACK_IMPORTED_MODULE_4__/* .CacheRenderReferences */ .P.spotAnim([__assign({ id: this.spotAnimId }, this.options)]), { onSpotAnimComplete: function () {
                _this.finished = true;
                // Region cleanup removes entities whose dying counter reaches zero.
                _this.dying = 0;
            } });
    };
    // GraphicsObjects are cache-rendered effects and have no 2D fallback tile.
    GraphicsObject.prototype.draw = function () { };
    return GraphicsObject;
}(_Entity__WEBPACK_IMPORTED_MODULE_1__/* .Entity */ .w));



/***/ }),

/***/ 4103:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: () => (/* binding */ InputController)
/* harmony export */ });
/* harmony import */ var _Settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8406);
/* harmony import */ var _Replay__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7036);


var MAX_QUEUED_ACTIONS = 8;
/**
 * Controller to manage delayed inputs (due to input lag and/or tick timers)
 */
var InputController = /** @class */ (function () {
    function InputController() {
        this.inputDelay = null;
        this.clientActions = [];
        this.queuedActions = [];
        /** Called at the start of every world tick, before queued inputs are applied (used by replays). */
        this.beforeTick = null;
    }
    /**
     * Queue an input to be sampled by the next 20 ms client tick.
     *
     * Prayer controls use this to keep browser event timing separate from both
     * the client-side lit state and the server-side active state.
     */
    InputController.prototype.queueClientAction = function (fn) {
        this.clientActions.push(fn);
    };
    InputController.prototype.onClientTick = function () {
        var actions = this.clientActions;
        this.clientActions = [];
        actions.forEach(function (action) { return action(); });
    };
    /**
     * Queue an input for the next world tick. `describe` is evaluated when the input is applied and
     * returns a serialisable description of it, so it can be recorded for replays.
     */
    InputController.prototype.queueAction = function (fn, describe) {
        var _this = this;
        /*if (this.inputDelay) {
          clearTimeout(this.inputDelay);
        }*/
        if (this.queuedActions.length >= MAX_QUEUED_ACTIONS) {
            return;
        }
        this.inputDelay = setTimeout(function () {
            _this.queuedActions.push({ fn: fn, describe: describe });
        }, _Settings__WEBPACK_IMPORTED_MODULE_0__/* .Settings */ .w.inputDelay);
    };
    InputController.prototype.onWorldTick = function (tick) {
        var _a;
        if (tick === void 0) { tick = 0; }
        (_a = this.beforeTick) === null || _a === void 0 ? void 0 : _a.call(this, tick);
        var actions = this.flushQueuedActions();
        actions.forEach(function (_a) {
            var _b;
            var fn = _a.fn, describe = _a.describe;
            _Replay__WEBPACK_IMPORTED_MODULE_1__/* .ReplayLog */ .s.recordQueued((_b = describe === null || describe === void 0 ? void 0 : describe()) !== null && _b !== void 0 ? _b : null);
            fn();
        });
    };
    InputController.prototype.flushQueuedActions = function () {
        var actions = this.queuedActions;
        this.queuedActions = [];
        return actions;
    };
    InputController.controller = new InputController();
    return InputController;
}());



/***/ }),

/***/ 8825:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: () => (/* binding */ Interpolation)
/* harmony export */ });
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Interpolation = /** @class */ (function () {
    function Interpolation() {
    }
    /** Advance a visual position towards the first step in an actor's path queue. */
    Interpolation.resolvePath = function (location, path, baseMovementSpeed, movementSpeed, catchUpMovementSpeed) {
        if (movementSpeed === void 0) { movementSpeed = baseMovementSpeed; }
        if (path.length === 0) {
            return { location: __assign({}, location), reachedStep: false };
        }
        var _a = path[0], nextX = _a.x, nextY = _a.y, run = _a.run;
        var resolvedMovementSpeed = movementSpeed;
        if (path.length > 3)
            resolvedMovementSpeed = baseMovementSpeed * 2;
        else if (path.length > 2)
            resolvedMovementSpeed = baseMovementSpeed * 1.5;
        if (catchUpMovementSpeed !== undefined) {
            resolvedMovementSpeed = Math.max(resolvedMovementSpeed, catchUpMovementSpeed);
        }
        if (run)
            resolvedMovementSpeed *= 2;
        var x = location.x, y = location.y;
        if (Math.abs(x - nextX) > 2 || Math.abs(y - nextY) > 2) {
            x = nextX;
            y = nextY;
        }
        else if (x !== nextX || y !== nextY) {
            var arrivalEpsilon = 1e-9;
            if (x < nextX) {
                x = nextX - x <= resolvedMovementSpeed + arrivalEpsilon ? nextX : x + resolvedMovementSpeed;
            }
            else if (x > nextX) {
                x = x - nextX <= resolvedMovementSpeed + arrivalEpsilon ? nextX : x - resolvedMovementSpeed;
            }
            if (y < nextY) {
                y = nextY - y <= resolvedMovementSpeed + arrivalEpsilon ? nextY : y + resolvedMovementSpeed;
            }
            else if (y > nextY) {
                y = y - nextY <= resolvedMovementSpeed + arrivalEpsilon ? nextY : y - resolvedMovementSpeed;
            }
        }
        return {
            location: { x: x, y: y },
            reachedStep: x === nextX && y === nextY,
        };
    };
    return Interpolation;
}());



/***/ }),

/***/ 2376:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   q: () => (/* binding */ Item)
/* harmony export */ });
var Item = /** @class */ (function () {
    function Item() {
        this.defaultAction = "Use";
    }
    Object.defineProperty(Item.prototype, "serialNumber", {
        get: function () {
            if (!this._serialNumber) {
                this._serialNumber = String(Math.random());
            }
            return this._serialNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "hasInventoryLeftClick", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Item.prototype.inventoryLeftClick = function (player) {
        // Override me
    };
    Item.prototype.contextActions = function (player) {
        var _this = this;
        // use
        // drop
        // examine
        var options = [
            {
                text: [
                    { text: "Drop ", fillStyle: "white" },
                    { text: this.itemName, fillStyle: "#FF911F" },
                ],
                action: function () {
                    player.region.addGroundItem(player, _this, player.location.x, player.location.y);
                    _this.consumeItem(player);
                },
            },
            {
                text: [
                    { text: "Examine ", fillStyle: "white" },
                    { text: this.itemName, fillStyle: "#FF911F" },
                ],
                action: function () {
                    // TODO: Examine feature
                },
            },
        ];
        if (this.defaultAction) {
            options.unshift({
                text: [
                    { text: this.defaultAction + " ", fillStyle: "white" },
                    { text: this.itemName, fillStyle: "#FF911F" },
                ],
                action: function () {
                    _this.inventoryLeftClick(player);
                },
            });
        }
        return options;
    };
    Object.defineProperty(Item.prototype, "itemName", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "cacheItemId", {
        /** OSRS cache item definition ID used by the cache-render bundle (male model for now). */
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Item.prototype, "weight", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Item.prototype.inventoryPosition = function (player) {
        return player.inventory
            .map(function (item) {
            if (!item) {
                return null;
            }
            return item.serialNumber;
        })
            .indexOf(this.serialNumber);
    };
    Item.prototype.consumeItem = function (player) {
        player.inventory[this.inventoryPosition(player)] = null;
    };
    Object.defineProperty(Item.prototype, "inventoryImage", {
        get: function () {
            return "";
        },
        enumerable: false,
        configurable: true
    });
    return Item;
}());



/***/ }),

/***/ 243:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P: () => (/* binding */ ItemName)
/* harmony export */ });
var ItemName;
(function (ItemName) {
    ItemName["SARADOMIN_GODSWORD"] = "Saradomin godsword";
    ItemName["FIRE_CAPE"] = "Fire cape";
    ItemName["BLUE_MOON_HELM"] = "Blue Moon helm";
    ItemName["BLUE_MOON_CHESTPLATE"] = "Blue Moon chestplate";
    ItemName["BLUE_MOON_TASSETS"] = "Blue Moon tassets";
    ItemName["ETERNAL_BOOTS"] = "Eternal boots";
    ItemName["AMULET_OF_BLOOD_FURY"] = "Amulet of blood fury";
    ItemName["RADAS_BLESSING_4"] = "Rada's blessing 4";
    ItemName["BLUE_MOON_SPEAR"] = "Blue Moon spear";
    ItemName["RANGING_POTION"] = "Ranging potion";
    ItemName["PRAYER_REGENERATION_POTION"] = "Prayer regeneration potion";
    ItemName["BLOOD_BARRAGE"] = "Blood Barrage";
    ItemName["ICE_BARRAGE"] = "Ice Barrage";
    ItemName["AHRIMS_ROBETOP"] = "Ahrim's robetop";
    ItemName["AHRIMS_ROBESKIRT"] = "Ahrim's robeskirt";
    ItemName["ANCESTRAL_ROBEBOTTOM"] = "Ancestral Robe bottom";
    ItemName["ANCESTRAL_ROBETOP"] = "Ancestral Robe top";
    ItemName["ANCIENT_STAFF"] = "Ancient staff";
    ItemName["Armadyl_BREW"] = "Armadyl brew";
    ItemName["ARMADYL_CHAINSKIRT"] = "Armadyl Chainskirt";
    ItemName["ARMADYL_CHESTPLATE"] = "Armadyl Chestplate";
    ItemName["AVAS_ACCUMULATOR"] = "Ava's accumulator";
    ItemName["AVAS_ASSEMBLER"] = "Avas Assembler";
    ItemName["BARROWS_GLOVES"] = "Barrows Gloves";
    ItemName["BASTION_POTION"] = "Bastion Potion";
    ItemName["BLACK_D_HIDE_BODY"] = "Black d'hide body";
    ItemName["BLACK_D_HIDE_CHAPS"] = "Black d'hide chaps";
    ItemName["BLACK_D_HIDE_VAMBRACES"] = "Black d'hide vambraces";
    ItemName["BLACK_CHINCHOMPA"] = "Black chinchompa";
    ItemName["BOWFA"] = "Bow of faerdhinen";
    ItemName["CRYSTAL_BODY"] = "Crystal Body";
    ItemName["CRYSTAL_HELM"] = "Crystal Helm";
    ItemName["CRYSTAL_LEGS"] = "Crystal Legs";
    ItemName["CRYSTAL_SHIELD"] = "Crystal Shield";
    ItemName["DAGON_HAI_ROBE_TOP"] = "Dagon'hai robe top";
    ItemName["DEVOUT_BOOTS"] = "Devout Boots";
    ItemName["DIAMOND_BOLTS_E"] = "Diamond bolts (e)";
    ItemName["DRAGON_ARROWS"] = "Dragon arrow";
    ItemName["SEEKING_DRAGON_ARROWS"] = "Seeking dragon arrow";
    ItemName["DRAGON_CLAWS"] = "Dragon claws";
    ItemName["GUTHIX_ROBE_TOP"] = "Guthix robe top";
    ItemName["HOLY_BLESSING"] = "Holy Blessing";
    ItemName["JUSTICIAR_CHESTGUARD"] = "Justiciar Chestguard";
    ItemName["JUSTICIAR_FACEGUARD"] = "Justiciar Faceguard";
    ItemName["JUSTICIAR_LEGGUARDS"] = "Justiciar Legguards";
    ItemName["KARAMBWAN"] = "Karambwan";
    ItemName["KODAI_WAND"] = "Kodai Wand";
    ItemName["MAGES_BOOK"] = "Mage's Book";
    ItemName["NECKLACE_OF_ANGUISH"] = "Necklace of Anguish";
    ItemName["NECKLACE_OF_RUPTURE"] = "Necklace of rupture";
    ItemName["OCCULT_NECKLACE"] = "Occult necklace";
    ItemName["PEGASIAN_BOOTS"] = "Pegasian Boots";
    ItemName["RANGER_BOOTS"] = "Ranger boots";
    ItemName["RING_OF_ENDURANCE"] = "Ring of Endurance";
    ItemName["VENATOR_RING"] = "Venator ring";
    ItemName["RING_OF_SUFFERING_I"] = "Ring of Suffering (i)";
    ItemName["ROBIN_HOOD_HAT"] = "Robin hood hat";
    ItemName["RUBY_BOLTS_E"] = "Ruby bolts (e)";
    ItemName["RUNE_CROSSBOW"] = "Rune Crossbow";
    ItemName["RUNE_KITESHIELD"] = "Rune kiteshield";
    ItemName["SARADOMIN_BREW"] = "Saradomin Brew";
    ItemName["SARADOMIN_COIF"] = "Saradomin coif";
    ItemName["SARADOMIN_D_HIDE_BODY"] = "Saradomin d'hide body";
    ItemName["SARADOMIN_D_HIDE_BOOTS"] = "Saradomin d'hide boots";
    ItemName["SARADOMIN_D_HIDE_CHAPS"] = "Saradomin chaps";
    ItemName["SCYTHE_OF_VITUR"] = "Scythe of Vitur";
    ItemName["SHARK"] = "Shark";
    ItemName["SLAYER_HELMET_I"] = "Slayer helm (i)";
    ItemName["STAMINA_POTION"] = "Stamina Potion";
    ItemName["SUPER_RESTORE"] = "Super Restore";
    ItemName["TOXIC_BLOWPIPE"] = "Toxic Blowpipe";
    ItemName["TWISTED_BOW"] = "Twisted Bow";
    ItemName["ZARYTE_VAMBRACES"] = "Zaryte Vambraces";
    ItemName["MASORI_CHAPS_F"] = "Masori chaps (f)";
    ItemName["MASORI_BODY_F"] = "Masori body (f)";
    ItemName["MASORI_MASK_F"] = "Masori mask (f)";
    ItemName["DIZANAS_QUIVER"] = "Dizana's Quiver";
    ItemName["TORVA_PLATEBODY"] = "Torva platebody";
    ItemName["TORVA_PLATELEGS"] = "Torva platelegs";
    ItemName["TORVA_FULL_HELM"] = "Torva full helm";
    ItemName["AMULET_OF_FURY"] = "Amulet of Fury";
    ItemName["AMULET_OF_TORTURE"] = "Amulet of torture";
    ItemName["AMULET_OF_RANCOUR"] = "Amulet of rancour";
    ItemName["PRIMORDIAL_BOOTS"] = "Primordial boots";
    ItemName["FEROCIOUS_GLOVES"] = "Ferocious gloves";
    ItemName["INFERNAL_CAPE"] = "Infernal cape";
    ItemName["SUPER_COMBAT_POTION"] = "Super combat potion";
    ItemName["ZOMBIE_AXE"] = "Zombie axe";
    ItemName["BLADE_OF_SAELDOR"] = "Blade of saeldor";
    ItemName["NOXIOUS_HALBERD"] = "Noxious halberd";
    ItemName["AVERNIC_DEFENDER"] = "Avernic defender";
    ItemName["AVERNIC_TREADS_MAX"] = "Avernic treads (max)";
    ItemName["BERSERKER_RING_I"] = "Berserker ring (i)";
    ItemName["ULTOR_RING"] = "Ultor ring";
    ItemName["ARANEA_BOOTS"] = "Aranea boots";
    ItemName["ABYSSAL_TENTACLE"] = "Abyssal tentacle";
    ItemName["DRAGON_DEFENDER"] = "Dragon defender";
    ItemName["OATHPLATE_HELM"] = "Oathplate helm";
    ItemName["OATHPLATE_CHEST"] = "Oathplate chest";
    ItemName["OATHPLATE_LEGS"] = "Oathplate legs";
    ItemName["EYE_OF_AYAK"] = "Eye of Ayak";
    ItemName["CONFLICTION_GAUNTLETS"] = "Confliction gauntlets";
    ItemName["TUMEKENS_SHADOW"] = "Tumeken's shadow";
    ItemName["VENATOR_BOW"] = "Venator bow";
})(ItemName || (ItemName = {}));


/***/ }),

/***/ 8499:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V: () => (/* binding */ LineOfSight),
/* harmony export */   Z: () => (/* binding */ LineOfSightMask)
/* harmony export */ });
/* harmony import */ var _Settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8406);
/* harmony import */ var _Location__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4176);
/* harmony import */ var _Collision__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5843);




/*
 Basically, this entire file is lifted and modified to be as coherent as possible.
 This algorithm makes no sense and is copy pasta'd between basically every trainer.
 I have no clue how it works. I think Woox made a video that helps people understand it.
 https://www.youtube.com/watch?v=vnyNLXTwjCE
*/
var LineOfSightMask;
(function (LineOfSightMask) {
    LineOfSightMask[LineOfSightMask["NONE"] = 0] = "NONE";
    LineOfSightMask[LineOfSightMask["FULL_MASK"] = 131072] = "FULL_MASK";
    LineOfSightMask[LineOfSightMask["EAST_MASK"] = 4096] = "EAST_MASK";
    LineOfSightMask[LineOfSightMask["WEST_MASK"] = 65536] = "WEST_MASK";
    LineOfSightMask[LineOfSightMask["NORTH_MASK"] = 1024] = "NORTH_MASK";
    LineOfSightMask[LineOfSightMask["SOUTH_MASK"] = 16384] = "SOUTH_MASK";
})(LineOfSightMask || (LineOfSightMask = {}));
var LineOfSight = /** @class */ (function () {
    function LineOfSight() {
    }
    LineOfSight.drawLOS = function (region, x, y, s, r, c, isNPC) {
        region.context.globalAlpha = 0.4;
        region.context.fillStyle = c;
        for (var x2 = -r; x2 < r + 1; x2++) {
            for (var y2 = -r; y2 < r + 1; y2++) {
                if (LineOfSight.hasLineOfSight(region, x, y, x + x2, y + y2, s, r, isNPC)) {
                    region.context.fillRect((x + x2) * _Settings__WEBPACK_IMPORTED_MODULE_0__/* .Settings */ .w.tileSize, (y + y2) * _Settings__WEBPACK_IMPORTED_MODULE_0__/* .Settings */ .w.tileSize, _Settings__WEBPACK_IMPORTED_MODULE_0__/* .Settings */ .w.tileSize, _Settings__WEBPACK_IMPORTED_MODULE_0__/* .Settings */ .w.tileSize);
                }
            }
        }
        region.context.globalAlpha = 1;
    };
    LineOfSight.mobHasLineOfSightOfPlayer = function (region, player, x, y, s, r, isNPC) {
        if (r === void 0) { r = 1; }
        if (isNPC === void 0) { isNPC = true; }
        return LineOfSight.hasLineOfSight(region, x, y, player.location.x, player.location.y, s, r, isNPC);
    };
    LineOfSight.playerHasLineOfSightOfMob = function (region, x, y, mob, r) {
        if (r === void 0) { r = 1; }
        var mobPoint = _Location__WEBPACK_IMPORTED_MODULE_1__/* .LocationUtils */ .J.closestPointTo(x, y, mob);
        return LineOfSight.hasLineOfSight(region, x, y, mobPoint.x, mobPoint.y, 1, r, false);
    };
    LineOfSight.mobHasLineOfSightToMob = function (region, mob1, mob2, r) {
        if (r === void 0) { r = 1; }
        var mob1Point = _Location__WEBPACK_IMPORTED_MODULE_1__/* .LocationUtils */ .J.closestPointTo(mob1.location.x, mob1.location.y, mob2);
        var mob2Point = _Location__WEBPACK_IMPORTED_MODULE_1__/* .LocationUtils */ .J.closestPointTo(mob2.location.x, mob2.location.y, mob1);
        return LineOfSight.hasLineOfSight(region, mob1Point.x, mob1Point.y, mob2Point.x, mob2Point.y, 1, r, false);
    };
    LineOfSight.hasLineOfSight = function (region, x1, y1, x2, y2, s, r, isNPC) {
        if (s === void 0) { s = 1; }
        if (r === void 0) { r = 1; }
        if (isNPC === void 0) { isNPC = false; }
        var dx = x2 - x1;
        var dy = y2 - y1;
        if (_Collision__WEBPACK_IMPORTED_MODULE_2__/* .Collision */ .F.collidesWithAnyLoSBlockingEntities(region, x1, y1, 1) ||
            _Collision__WEBPACK_IMPORTED_MODULE_2__/* .Collision */ .F.collidesWithAnyLoSBlockingEntities(region, x2, y2, 1) ||
            _Collision__WEBPACK_IMPORTED_MODULE_2__/* .Collision */ .F.collisionMath(x1, y1, s, x2, y2, 1)) {
            return false;
        }
        // assume range 1 is melee
        if (r === 1) {
            return (dx < s && dx >= 0 && (dy === 1 || dy === -s)) || (dy > -s && dy <= 0 && (dx === -1 || dx === s));
        }
        if (isNPC) {
            var tx = Math.max(x1, Math.min(x1 + s - 1, x2));
            var ty = Math.max(y1 - s + 1, Math.min(y1, y2));
            return LineOfSight.hasLineOfSight(region, x2, y2, tx, ty, 1, r, false);
        }
        var dxAbs = Math.abs(dx);
        var dyAbs = Math.abs(dy);
        if (dxAbs > r || dyAbs > r) {
            return false;
        }
        if (dxAbs > dyAbs) {
            var xTile = x1;
            var y = (y1 << 16) + 0x8000;
            var slope = Math.trunc((dy << 16) / dxAbs); // Integer division
            var xInc = void 0;
            var xMask = void 0;
            var yMask = void 0;
            if (dx > 0) {
                xInc = 1;
                xMask = LineOfSightMask.WEST_MASK | LineOfSightMask.FULL_MASK;
            }
            else {
                xInc = -1;
                xMask = LineOfSightMask.EAST_MASK | LineOfSightMask.FULL_MASK;
            }
            if (dy < 0) {
                y -= 1; // For correct rounding
                yMask = LineOfSightMask.NORTH_MASK | LineOfSightMask.FULL_MASK;
            }
            else {
                yMask = LineOfSightMask.SOUTH_MASK | LineOfSightMask.FULL_MASK;
            }
            while (xTile !== x2) {
                xTile += xInc;
                var yTile = y >>> 16;
                if ((_Collision__WEBPACK_IMPORTED_MODULE_2__/* .Collision */ .F.collidesWithAnyLoSBlockingEntities(region, xTile, yTile, 1) & xMask) !== 0) {
                    return false;
                }
                y += slope;
                var newYTile = y >>> 16;
                if (newYTile !== yTile &&
                    (_Collision__WEBPACK_IMPORTED_MODULE_2__/* .Collision */ .F.collidesWithAnyLoSBlockingEntities(region, xTile, newYTile, 1) & yMask) !== 0) {
                    return false;
                }
            }
        }
        else {
            var yTile = y1;
            var x = (x1 << 16) + 0x8000;
            var slope = Math.trunc((dx << 16) / dyAbs); // Integer division
            var yInc = void 0;
            var yMask = void 0;
            if (dy > 0) {
                yInc = 1;
                yMask = LineOfSightMask.SOUTH_MASK | LineOfSightMask.FULL_MASK;
            }
            else {
                yInc = -1;
                yMask = LineOfSightMask.NORTH_MASK | LineOfSightMask.FULL_MASK;
            }
            var xMask = void 0;
            if (dx < 0) {
                x -= 1; // For correct rounding
                xMask = LineOfSightMask.EAST_MASK | LineOfSightMask.FULL_MASK;
            }
            else {
                xMask = LineOfSightMask.WEST_MASK | LineOfSightMask.FULL_MASK;
            }
            while (yTile !== y2) {
                yTile += yInc;
                var xTile = x >>> 16;
                if ((_Collision__WEBPACK_IMPORTED_MODULE_2__/* .Collision */ .F.collidesWithAnyLoSBlockingEntities(region, xTile, yTile, 1) & yMask) !== 0) {
                    return false;
                }
                x += slope;
                var newXTile = x >>> 16;
                if (newXTile !== xTile &&
                    (_Collision__WEBPACK_IMPORTED_MODULE_2__/* .Collision */ .F.collidesWithAnyLoSBlockingEntities(region, newXTile, yTile, 1) & xMask) !== 0) {
                    return false;
                }
            }
        }
        return true;
    };
    return LineOfSight;
}());



/***/ }),

/***/ 4176:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   J: () => (/* binding */ LocationUtils)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2543);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

var LocationUtils = /** @class */ (function () {
    function LocationUtils() {
    }
    LocationUtils.closestPointTo = function (x, y, mob) {
        var corners = [];
        for (var xx = 0; xx < mob.size; xx++) {
            for (var yy = 0; yy < mob.size; yy++) {
                corners.push({
                    x: mob.location.x + xx,
                    y: mob.location.y - yy,
                });
            }
        }
        return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.minBy)(corners, function (point) { return LocationUtils.dist(x, y, point.x, point.y); });
    };
    LocationUtils.dist = function (x, y, x2, y2) {
        return Math.sqrt(Math.pow(x2 - x, 2) + Math.pow(y2 - y, 2));
    };
    LocationUtils.angle = function (x, y, x2, y2) {
        return Math.atan2(y2 - y, x2 - x);
    };
    return LocationUtils;
}());



/***/ }),

/***/ 5397:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: () => (/* binding */ Mob),
/* harmony export */   V: () => (/* binding */ AttackIndicators)
/* harmony export */ });
/* harmony import */ var _Replay__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7036);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2543);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8406);
/* harmony import */ var _LineOfSight__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8499);
/* harmony import */ var _Pathing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5454);
/* harmony import */ var _gear_Weapon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6103);
/* harmony import */ var _Unit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3016);
/* harmony import */ var _Collision__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5843);
/* harmony import */ var _Random__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7212);
/* harmony import */ var _rendering_CanvasSpriteModel__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5870);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4103);
/* harmony import */ var _Trainer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6374);

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};












var AttackIndicators;
(function (AttackIndicators) {
    AttackIndicators[AttackIndicators["NONE"] = 0] = "NONE";
    AttackIndicators[AttackIndicators["HIT"] = 1] = "HIT";
    AttackIndicators[AttackIndicators["BLOCKED"] = 2] = "BLOCKED";
    AttackIndicators[AttackIndicators["SCAN"] = 3] = "SCAN";
})(AttackIndicators || (AttackIndicators = {}));
var Mob = /** @class */ (function (_super) {
    __extends(Mob, _super);
    function Mob(region, location, options) {
        var _this = _super.call(this, region, location, options) || this;
        _this.mobId = Mob.mobIdTracker++;
        _this.hasResurrected = false;
        _this.removableWithRightClick = false;
        return _this;
    }
    Object.defineProperty(Mob.prototype, "type", {
        get: function () {
            return _Unit__WEBPACK_IMPORTED_MODULE_6__/* .UnitTypes */ .eK.MOB;
        },
        enumerable: false,
        configurable: true
    });
    Mob.prototype.canBeAttacked = function () {
        return true;
    };
    Mob.prototype.setStats = function () {
        // non boosted numbers
        this.stats = {
            attack: 99,
            strength: 99,
            defence: 99,
            range: 99,
            magic: 99,
            hitpoint: 99,
        };
        // with boosts
        this.currentStats = {
            attack: 99,
            strength: 99,
            defence: 99,
            range: 99,
            magic: 99,
            hitpoint: 99,
        };
    };
    Object.defineProperty(Mob.prototype, "bonuses", {
        get: function () {
            return {
                attack: {
                    stab: 0,
                    slash: 0,
                    crush: 0,
                    magic: 0,
                    range: 0,
                },
                defence: {
                    stab: 0,
                    slash: 0,
                    crush: 0,
                    magic: 0,
                    range: 0,
                },
                other: {
                    meleeStrength: 0,
                    rangedStrength: 0,
                    magicDamage: 0,
                    prayer: 0,
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @returns the next location to move to
     */
    Mob.prototype.getNextMovementStep = function () {
        var dx = this.location.x + Math.sign(this.aggro.location.x - this.location.x);
        var dy = this.location.y + Math.sign(this.aggro.location.y - this.location.y);
        if (_Collision__WEBPACK_IMPORTED_MODULE_7__/* .Collision */ .F.collisionMath(this.location.x, this.location.y, this.size, this.aggro.location.x, this.aggro.location.y, 1)) {
            // Random movement if player is under the mob.
            if (_Random__WEBPACK_IMPORTED_MODULE_8__/* .Random */ .o.get() < 0.5) {
                dy = this.location.y;
                if (_Random__WEBPACK_IMPORTED_MODULE_8__/* .Random */ .o.get() < 0.5) {
                    dx = this.location.x + 1;
                }
                else {
                    dx = this.location.x - 1;
                }
            }
            else {
                dx = this.location.x;
                if (_Random__WEBPACK_IMPORTED_MODULE_8__/* .Random */ .o.get() < 0.5) {
                    dy = this.location.y + 1;
                }
                else {
                    dy = this.location.y - 1;
                }
            }
        }
        else if (_Collision__WEBPACK_IMPORTED_MODULE_7__/* .Collision */ .F.collisionMath(dx, dy, this.size, this.aggro.location.x, this.aggro.location.y, 1)) {
            // allows corner safespotting
            dy = this.location.y;
        }
        if (this.attackDelay > this.attackSpeed) {
            // No movement right after melee dig. 8 ticks after the dig it should be able to move again.
            dx = this.location.x;
            dy = this.location.y;
        }
        return { dx: dx, dy: dy };
    };
    Mob.prototype.timerStep = function () {
        if (this.dying === 0)
            return;
        this.age--;
        if (this.age > 0) {
            // Spawn-delayed NPCs advance their attack clock, but do not yet consume
            // their initial freeze/stun. Their queue still receives incoming hits.
            this.attackDelay--;
            return;
        }
        _super.prototype.timerStep.call(this);
    };
    Mob.prototype.isRedXStalled = function () {
        var _a;
        return ((_a = this.aggro) === null || _a === void 0 ? void 0 : _a.type) === _Unit__WEBPACK_IMPORTED_MODULE_6__/* .UnitTypes */ .eK.PLAYER
            && this.aggro.aggro === this
            && _Collision__WEBPACK_IMPORTED_MODULE_7__/* .Collision */ .F.collisionMath(this.location.x, this.location.y, this.size, this.aggro.location.x, this.aggro.location.y, 1);
    };
    Mob.prototype.movementStep = function () {
        var _this = this;
        if (this.dying === 0 || this.currentStats.hitpoint <= 0) {
            return;
        }
        if (this.age > 0) {
            return;
        }
        var moved = false;
        this.setHasLOS();
        // Red-x prevents the overlapping NPC from entering its movement cycle at
        // all.
        if (this.canMove() && this.aggro && !this.isRedXStalled()) {
            // NPC clipping flags persist between ticks. Only an NPC which is trying
            // to move clears its old footprint, and it claims its resulting
            // footprint even when the attempted movement is blocked.
            if (this.consumesSpace) {
                this.region.clearTileCollisionFlags(this.location.x, this.location.y, this.size);
            }
            var previousLocation = __assign({}, this.location);
            var _a = this.getNextMovementStep(), dx = _a.dx, dy = _a.dy;
            var xOff = dx - this.location.x;
            var yOff = this.location.y - dy;
            var xTiles = this.getXMovementTiles(xOff, yOff);
            var yTiles = this.getYMovementTiles(xOff, yOff);
            var xSpace = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.every)(xTiles.map(function (location) {
                return _Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.canTileBePathedTo(_this.region, location.x, location.y, 1, _this.consumesSpace);
            }), Boolean);
            var ySpace = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.every)(yTiles.map(function (location) {
                return _Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.canTileBePathedTo(_this.region, location.x, location.y, 1, _this.consumesSpace);
            }), Boolean);
            // The client allows NPCs larger than one tile to cut a diagonal corner
            // as long as their destination footprint is clear. Only 1x1 NPCs must
            // also be able to occupy both adjacent cardinal tiles.
            var movingDiagonally = xOff !== 0 && yOff !== 0;
            var both = movingDiagonally && this.size > 1
                ? _Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.canTileBePathedTo(this.region, dx, dy, this.size, this.consumesSpace)
                : xSpace && ySpace;
            // if (this.mobName() === EntityName.JAL_AK){
            //   this.tcc =  xTiles; //xTiles.concat(yTiles);
            // }
            if (!both) {
                xTiles = this.getXMovementTiles(xOff, 0);
                xSpace = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.every)(xTiles.map(function (location) {
                    return _Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.canTileBePathedTo(_this.region, location.x, location.y, 1, _this.consumesSpace);
                }), Boolean);
                if (!xSpace) {
                    yTiles = this.getYMovementTiles(0, yOff);
                    ySpace = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.every)(yTiles.map(function (location) {
                        return _Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.canTileBePathedTo(_this.region, location.x, location.y, 1, _this.consumesSpace);
                    }), Boolean);
                }
            }
            if (both) {
                this.location.x = dx;
                this.location.y = dy;
            }
            else if (xSpace) {
                this.location.x = dx;
            }
            else if (ySpace) {
                this.location.y = dy;
            }
            if (this.consumesSpace) {
                this.region.setTileCollisionFlags(this.location.x, this.location.y, this.size);
            }
            if (this.location.x !== previousLocation.x || this.location.y !== previousLocation.y) {
                var movedMoreThanOneTile = Math.max(Math.abs(this.location.x - previousLocation.x), Math.abs(this.location.y - previousLocation.y)) > 1;
                this.visualPath.push(__assign(__assign({}, this.location), { run: this.canRun && movedMoreThanOneTile }));
                this.visualMovementActive = true;
                moved = true;
            }
        }
        if (!moved && this.visualPath.length === 0) {
            // bit of a hack, but if we moved this tick, prevent the animation from switching to 'idle' when the queue is now empty (stops it from flicking to
            // idle anim every tick).
            this.visualMovementActive = false;
        }
    };
    Object.defineProperty(Mob.prototype, "canRun", {
        /** Whether this mob may visually cover two tiles during one game tick. */
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Mob.prototype.getXMovementTiles = function (xOff, yOff) {
        var start = yOff === -1 ? -1 : 0;
        var end = yOff === 1 ? this.size + 1 : this.size;
        var xTiles = [];
        if (xOff === -1) {
            for (var i = start; i < end; i++) {
                xTiles.push({
                    x: this.location.x - 1,
                    y: this.location.y - i,
                });
            }
        }
        else if (xOff === 1) {
            for (var i = start; i < end; i++) {
                xTiles.push({
                    x: this.location.x + this.size,
                    y: this.location.y - i,
                });
            }
        }
        return xTiles;
    };
    Mob.prototype.getYMovementTiles = function (xOff, yOff) {
        var start = xOff === -1 ? -1 : 0;
        var end = xOff === 1 ? this.size + 1 : this.size;
        var yTiles = [];
        if (yOff === -1) {
            // south
            for (var i = start; i < end; i++) {
                yTiles.push({
                    x: this.location.x + i,
                    y: this.location.y + 1,
                });
            }
        }
        else if (yOff === 1) {
            // north
            for (var i = start; i < end; i++) {
                yTiles.push({
                    x: this.location.x + i,
                    y: this.location.y - this.size,
                });
            }
        }
        return yTiles;
    };
    // todo: Rename this possibly? it returns the attack style if it's possible
    Mob.prototype.canMeleeIfClose = function () {
        return "";
    };
    Mob.prototype.attackStep = function () {
        _super.prototype.attackStep.call(this);
        if (this.age > 0) {
            return;
        }
        if (this.dying === 0) {
            return;
        }
        this.attackIfPossible();
        this.detectDeath();
    };
    Mob.prototype.attackStyleForNewAttack = function () {
        return "slash";
    };
    Mob.prototype.attackIfPossible = function () {
        this.hadLOS = this.hasLOS;
        this.setHasLOS();
        if (!this.aggro || this.canAttack() === false) {
            return;
        }
        this.attackStyle = this.attackStyleForNewAttack();
        var weaponIsAreaAttack = this.weapons[this.attackStyle].isAreaAttack;
        var isUnderAggro = false;
        if (!weaponIsAreaAttack) {
            isUnderAggro = _Collision__WEBPACK_IMPORTED_MODULE_7__/* .Collision */ .F.collisionMath(this.location.x, this.location.y, this.size, this.aggro.location.x, this.aggro.location.y, 1);
        }
        this.attackFeedback = AttackIndicators.NONE;
        if (!isUnderAggro && this.hasLOS && this.attackDelay <= 0) {
            this.attack() && this.didAttack();
        }
    };
    Mob.prototype.magicMaxHit = function () {
        return 0;
    };
    Mob.prototype.attack = function () {
        if (this.aggro.dying >= 0) {
            return false;
        }
        if (this.canMeleeIfClose() && _gear_Weapon__WEBPACK_IMPORTED_MODULE_5__/* .Weapon */ .R.isMeleeAttackStyle(this.attackStyle) === false) {
            if (this.isWithinMeleeRange() && _Random__WEBPACK_IMPORTED_MODULE_8__/* .Random */ .o.get() < 0.5) {
                this.attackStyle = this.canMeleeIfClose();
            }
        }
        if (this.weapons[this.attackStyle].isBlockable(this, this.aggro, {
            attackStyle: this.attackStyle,
        })) {
            this.attackFeedback = AttackIndicators.BLOCKED;
        }
        else {
            this.attackFeedback = AttackIndicators.HIT;
        }
        this.weapons[this.attackStyle].attack(this, this.aggro /* hack */, {
            attackStyle: this.attackStyle,
            magicBaseSpellDamage: this.magicMaxHit(),
        });
        return true;
    };
    Mob.prototype.visible = function () {
        var hiddenWhileDying = _Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.hideDeadNpcs && this.dying >= 0;
        return this.region.world.getReadyTimer <= 0 && !hiddenWhileDying && !this.deathAnimationFinished;
    };
    Object.defineProperty(Mob.prototype, "combatLevel", {
        get: function () {
            return 99;
        },
        enumerable: false,
        configurable: true
    });
    Mob.prototype.contextActions = function (region, x, y) {
        var _this = this;
        var actions = [
            {
                text: [
                    { text: "Attack ", fillStyle: "white" },
                    { text: this.mobName(), fillStyle: "yellow" },
                    {
                        text: " (level ".concat(this.combatLevel, ")"),
                        fillStyle: _Trainer__WEBPACK_IMPORTED_MODULE_11__/* .Trainer */ .c.player.combatLevelColor(this),
                    },
                ],
                action: function () {
                    _Trainer__WEBPACK_IMPORTED_MODULE_11__/* .Trainer */ .c.clickController.redClick();
                    _Input__WEBPACK_IMPORTED_MODULE_10__/* .InputController */ .f.controller.queueAction(function () { return _Trainer__WEBPACK_IMPORTED_MODULE_11__/* .Trainer */ .c.clickController.playerAttackClick(_this); }, function () { return ({ kind: "attackMob", mob: _Replay__WEBPACK_IMPORTED_MODULE_0__/* .ReplayLog */ .s.mobIndex(_this) }); });
                },
            },
        ];
        // hack hack hack
        if (this.removableWithRightClick) {
            actions.push({
                text: [
                    { text: "Remove ", fillStyle: "white" },
                    { text: this.mobName(), fillStyle: "yellow" },
                    {
                        text: " (level ".concat(this.combatLevel, ")"),
                        fillStyle: _Trainer__WEBPACK_IMPORTED_MODULE_11__/* .Trainer */ .c.player.combatLevelColor(this),
                    },
                ],
                action: function () {
                    _this.region.removeMob(_this);
                },
            });
        }
        return actions;
    };
    Mob.prototype.drawOverTile = function (tickPercent, context, scale) {
        // Override me
    };
    Mob.prototype.drawUnderTile = function (tickPercent, context, scale) {
        context.fillStyle = "#00000000";
        if (_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.displayFeedback) {
            if (this.dying > -1) {
                context.fillStyle = "#964B0073";
            }
            else if (this.attackFeedback === AttackIndicators.BLOCKED) {
                context.fillStyle = "#00FF0073";
            }
            else if (this.attackFeedback === AttackIndicators.HIT) {
                context.fillStyle = "#FF000073";
            }
            else if (this.attackFeedback === AttackIndicators.SCAN) {
                context.fillStyle = "#FFFF0073";
            }
            else if (this.hasLOS) {
                context.fillStyle = "#FF730073";
            }
            else {
                context.fillStyle = this.color;
            }
        }
        // Draw mob
        context.fillRect(-(this.size * scale) / 2, -(this.size * scale) / 2, this.size * scale, this.size * scale);
    };
    Mob.prototype.draw = function (tickPercent, context, offset, scale, drawUnderTile) {
        if (!this.visible())
            return;
        _super.prototype.draw.call(this, tickPercent, context, offset, scale, drawUnderTile);
        if (_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.displayMobLoS) {
            _LineOfSight__WEBPACK_IMPORTED_MODULE_3__/* .LineOfSight */ .V.drawLOS(this.region, this.location.x, this.location.y, this.size, this.attackRange, "#FF000055", this.type === _Unit__WEBPACK_IMPORTED_MODULE_6__/* .UnitTypes */ .eK.MOB);
        }
        var perceivedX = offset.x;
        var perceivedY = offset.y;
        context.save();
        context.translate(perceivedX * scale + (this.size * scale) / 2, (perceivedY - this.size + 1) * scale + (this.size * scale) / 2);
        if (drawUnderTile) {
            this.drawUnderTile(tickPercent, context, scale);
        }
        var currentImage = this.unitImage;
        if (_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.rotated === "south") {
            context.rotate(Math.PI);
        }
        if (_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.rotated === "south") {
            context.scale(-1, 1);
        }
        context.save();
        if (this.shouldShowAttackAnimation()) {
            this.attackAnimation(tickPercent, context);
        }
        if (currentImage) {
            context.drawImage(currentImage, -(this.size * scale) / 2, -(this.size * scale) / 2, this.size * scale, this.size * scale);
        }
        context.restore();
        if (_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.rotated === "south") {
            context.scale(-1, 1);
        }
        this.drawOverTile(tickPercent, context, scale);
        if (this.aggro) {
            var unit = this.aggro;
            if (_LineOfSight__WEBPACK_IMPORTED_MODULE_3__/* .LineOfSight */ .V.playerHasLineOfSightOfMob(this.region, this.aggro.location.x, this.aggro.location.y, this, unit.attackRange)) {
                context.strokeStyle = "#00FF0073";
                context.lineWidth = 1;
                context.strokeRect(-(this.size * scale) / 2, -(this.size * scale) / 2, this.size * scale, this.size * scale);
            }
        }
        context.restore();
        if (!this.tcc) {
            return;
        }
        // if (this.mobName() !== EntityName.JAL_AK) {
        //   return;
        // }
        // if (this.mobId !== 4) {
        //   return;
        // }
        /*this.tcc.forEach((location: Location) => {
          context.fillStyle = "#00FF0073";
          context.fillRect(location.x * scale, location.y * scale, scale, scale);
        });*/
    };
    Mob.prototype.drawUILayer = function (tickPercent, projector, context, scale) {
        if (!this.visible() || !projector.visible)
            return;
        if (_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.chunkDebug) {
            var priority = this.region.getNpcChunkPriority(this);
            if (priority !== null) {
                var debugPosition = projector.atHeight(projector.logicalHeight * 0.5);
                context.save();
                context.translate(debugPosition.x, debugPosition.y);
                if (_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.rotated === "south")
                    context.rotate(Math.PI);
                context.font = "20px OSRS";
                context.textAlign = "center";
                context.textBaseline = "middle";
                context.lineWidth = 3;
                context.strokeStyle = "black";
                context.strokeText(String(priority), 0, 0);
                context.fillStyle = "white";
                context.fillText(String(priority), 0, 0);
                context.restore();
            }
        }
        var overheadPosition = projector.atHeight(projector.logicalHeight);
        context.save();
        context.translate(overheadPosition.x, overheadPosition.y);
        if (_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.rotated === "south") {
            context.rotate(Math.PI);
        }
        this.drawHPBar(context, scale, 0);
        this.drawOverheadText(context, scale);
        this.drawOverheadPrayers(context, scale);
        context.restore();
        var hitsplatPosition = projector.atHeight(projector.logicalHeight * 0.5);
        context.save();
        context.translate(hitsplatPosition.x, hitsplatPosition.y);
        if (_Settings__WEBPACK_IMPORTED_MODULE_2__/* .Settings */ .w.rotated === "south")
            context.rotate(Math.PI);
        this.drawHitsplats(context, scale);
        context.restore();
    };
    Mob.prototype.create3dModel = function () {
        return _rendering_CanvasSpriteModel__WEBPACK_IMPORTED_MODULE_9__/* .CanvasSpriteModel */ .X.forRenderable(this);
    };
    Object.defineProperty(Mob.prototype, "color", {
        get: function () {
            return "#FF0000";
        },
        enumerable: false,
        configurable: true
    });
    Mob.mobIdTracker = 0;
    return Mob;
}(_Unit__WEBPACK_IMPORTED_MODULE_6__/* .Unit */ .Nf));



/***/ }),

/***/ 5454:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G: () => (/* binding */ Pathing)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2543);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Location__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4176);
/* harmony import */ var _Collision__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5843);




var Pathing = /** @class */ (function () {
    function Pathing() {
    }
    Pathing.entitiesAtPoint = function (region, x, y, s) {
        var entities = [];
        for (var i = 0; i < region.entities.length; i++) {
            if (_Collision__WEBPACK_IMPORTED_MODULE_2__/* .Collision */ .F.collisionMath(x, y, s, region.entities[i].location.x, region.entities[i].location.y, region.entities[i].size)) {
                entities.push(region.entities[i]);
            }
        }
        return entities;
    };
    // TODO: Make this more like entitiesAtPoint
    Pathing.mobsAtAoeOffset = function (region, mob, point) {
        var mobs = [];
        for (var i = 0; i < region.mobs.length; i++) {
            var collidedWithSpecificMob = region.mobs[i].location.x === point.x + mob.location.x &&
                region.mobs[i].location.y === point.y + mob.location.y;
            if (collidedWithSpecificMob) {
                mobs.push(region.mobs[i]);
            }
        }
        return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.sortBy)(mobs, function (m) { return mob !== m; });
    };
    // Core pathing
    Pathing.linearInterpolation = function (x, y, a) {
        return (y - x) * a + x;
    };
    // TODO: Remove these
    Pathing.dist = function (x, y, x2, y2) {
        return _Location__WEBPACK_IMPORTED_MODULE_1__/* .LocationUtils */ .J.dist(x, y, x2, y2);
    };
    Pathing.angle = function (x, y, x2, y2) {
        return _Location__WEBPACK_IMPORTED_MODULE_1__/* .LocationUtils */ .J.angle(x, y, x2, y2);
    };
    Pathing.canTileBePathedTo = function (region, x, y, s, checkTileCollisionFlags) {
        if (checkTileCollisionFlags === void 0) { checkTileCollisionFlags = false; }
        var clearOfEntities = !_Collision__WEBPACK_IMPORTED_MODULE_2__/* .Collision */ .F.collidesWithAnyEntities(region, x, y, s);
        return clearOfEntities && (!checkTileCollisionFlags || !region.hasTileCollisionFlags(x, y, s));
    };
    /**
     *
     * @param region
     * @param startPoint
     * @param endPoints array of valid end points. the first should be the SW tile.
     * @returns
     */
    Pathing.constructPaths = function (region, _a, endPoints) {
        var _b;
        var x = _a.x, y = _a.y;
        var unpathableEndPoints = endPoints.filter(function (location) { return !Pathing.canTileBePathedTo(region, location.x, location.y, 1); });
        if (unpathableEndPoints.length === endPoints.length) {
            // no pathable end points
            return {
                destination: null,
                path: [],
            };
        }
        var pathableEndPoints = endPoints.filter(function (location) {
            return Pathing.canTileBePathedTo(region, location.x, location.y, 1);
        });
        var pathX = x;
        var pathY = y;
        var nodes = [{ x: x, y: y, parent: null }];
        // The order of possible directions in this array determines if the player moves first straight or diagonaly
        // https://oldschool.runescape.wiki/w/Pathfinding#Determining_the_target_tile
        var directions = [
            { x: -1, y: 0 },
            { x: 1, y: 0 },
            { x: 0, y: 1 },
            { x: 0, y: -1 },
            { x: -1, y: 1 },
            { x: 1, y: 1 },
            { x: -1, y: -1 },
            { x: 1, y: -1 }, // ne
        ];
        var currentDistance = 0;
        // Djikstra search for the optimal route
        var explored = {};
        // initialise first node
        explored[pathX] = {};
        explored[pathX][pathY] = { x: pathX, y: pathY, parent: null, pathLength: 0 };
        var minExploredX = pathX;
        var minExploredY = pathY;
        var maxExploredX = pathX;
        var maxExploredY = pathY;
        var _loop_1 = function () {
            var parentNode = nodes.shift();
            var matchedDestinations = pathableEndPoints.filter(function (d) { return d.x === parentNode.x && d.y === parentNode.y; });
            for (var _i = 0, matchedDestinations_1 = matchedDestinations; _i < matchedDestinations_1.length; _i++) {
                var matchedDestination = matchedDestinations_1[_i];
                var path = [];
                var parent_1 = parentNode;
                while (parent_1) {
                    path.push({ x: parent_1.x, y: parent_1.y });
                    parent_1 = parent_1.parent;
                }
                return { value: { destination: matchedDestination, path: path } };
            }
            currentDistance = ((_b = (explored[parentNode.x] || {})[parentNode.y]) === null || _b === void 0 ? void 0 : _b.pathLength) || 0;
            for (var i = 0; i < directions.length; i++) {
                var iDirection = directions[i];
                pathX = parentNode.x + iDirection.x;
                pathY = parentNode.y + iDirection.y;
                if (!Pathing.canTileBePathedTo(region, pathX, pathY, 1)) {
                    // Destination is not a valid square
                    continue;
                }
                if (i >= 4) {
                    // Check neighbouring squares for diagonal moves
                    var neighbourX = parentNode.x;
                    var neighbourY = parentNode.y + iDirection.y;
                    if (!Pathing.canTileBePathedTo(region, neighbourX, neighbourY, 1)) {
                        continue;
                    }
                    neighbourX = parentNode.x + iDirection.x;
                    neighbourY = parentNode.y;
                    if (!Pathing.canTileBePathedTo(region, neighbourX, neighbourY, 1)) {
                        continue;
                    }
                }
                if (!(pathX in explored)) {
                    explored[pathX] = {};
                    if (pathX < minExploredX) {
                        minExploredX = pathX;
                    }
                    if (pathX > maxExploredX) {
                        maxExploredX = pathX;
                    }
                }
                if (pathY in explored[pathX]) {
                    continue;
                }
                else {
                    explored[pathX][pathY] = {
                        x: pathX,
                        y: pathY,
                        parent: parentNode,
                        pathLength: currentDistance + 1,
                    };
                    if (pathY < minExploredY) {
                        minExploredY = pathY;
                    }
                    if (pathY > maxExploredY) {
                        maxExploredY = pathY;
                    }
                }
                nodes.push({ x: pathX, y: pathY, parent: parentNode });
            }
        };
        while (nodes.length !== 0 && nodes.length < 1000) {
            var state_1 = _loop_1();
            if (typeof state_1 === "object")
                return state_1.value;
        }
        // No path found yet.
        // Find a backup tile within a 21x21 grid of the SW tile of the selection that:
        // - has path length less than 100
        // - has the shortest path distance
        // - has target tile as close as possible in Euclidean distance to the nearest requested tile
        var swTile = endPoints[0];
        var minX = Math.max(minExploredX, swTile.x - 10);
        var minY = Math.max(minExploredY, swTile.y - 10);
        var maxX = Math.max(maxExploredX, swTile.x + 10);
        var maxY = Math.max(maxExploredY, swTile.y + 10);
        var bestBackupTile = null;
        //let minEuclideanDistance = Pathing.dist(swTile.x, swTile.y, startPoint.x, startPoint.y);
        var minEuclideanDistance = Number.MAX_VALUE; // Pathing.dist(swTile.x, swTile.y, startPoint.x, startPoint.y);
        var minPathLength = 100;
        var _loop_2 = function (x_1) {
            if (!(x_1 in explored)) {
                return "continue";
            }
            var _loop_3 = function (y_1) {
                if (!(y_1 in explored[x_1])) {
                    return "continue";
                }
                var pathLength = explored[x_1][y_1].pathLength;
                endPoints.forEach(function (endPoint) {
                    var dist = Pathing.dist(x_1, y_1, endPoint.x, endPoint.y);
                    if (dist < minEuclideanDistance || (dist === minEuclideanDistance && pathLength < minPathLength)) {
                        bestBackupTile = { x: x_1, y: y_1 };
                        minPathLength = pathLength;
                        minEuclideanDistance = dist;
                    }
                });
            };
            for (var y_1 = minY; y_1 <= maxY; ++y_1) {
                _loop_3(y_1);
            }
        };
        for (var x_1 = minX; x_1 <= maxX; ++x_1) {
            _loop_2(x_1);
        }
        // No LoS - path to best backup tile
        if (bestBackupTile) {
            // unwind the path
            var path = [];
            var node = explored[bestBackupTile.x][bestBackupTile.y];
            while (node) {
                path.push({ x: node.x, y: node.y });
                node = node.parent;
            }
            return {
                destination: bestBackupTile,
                path: path,
            };
        }
        // no backup tile found
        return {
            destination: null,
            path: [],
        };
    };
    Pathing.path = function (region, startPoint, endPoint, speed, seeking) {
        var x, y;
        var pathResult = Pathing.constructPaths(region, startPoint, [endPoint]);
        var path = pathResult.path;
        if (path.length === 0) {
            return { x: startPoint.x, y: startPoint.y, path: [] };
        }
        if (seeking && _Collision__WEBPACK_IMPORTED_MODULE_2__/* .Collision */ .F.collidesWithMob(region, path[0].x, path[0].y, 1, seeking)) {
            path.shift();
        }
        if (path.length === 0) {
            return {
                x: startPoint.x,
                y: startPoint.y,
                path: [],
            };
        }
        if (path.length <= speed) {
            // Step to the destination
            x = path[0].x;
            y = path[0].y;
        }
        else {
            // Move two steps forward
            x = path[path.length - speed - 1].x;
            y = path[path.length - speed - 1].y;
        }
        var destination = path[0];
        path.reverse();
        return { x: x, y: y, path: path.slice(1, 3), destination: destination };
    };
    return Pathing;
}());



/***/ }),

/***/ 2431:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  a: () => (/* binding */ Player)
});

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(2543);
// EXTERNAL MODULE: ./src/sdk/Collision.ts
var Collision = __webpack_require__(5843);
// EXTERNAL MODULE: ./src/sdk/Eating.ts
var Eating = __webpack_require__(681);
// EXTERNAL MODULE: ./src/sdk/gear/Ammo.ts
var Ammo = __webpack_require__(1977);
// EXTERNAL MODULE: ./src/sdk/ItemName.ts
var ItemName = __webpack_require__(243);
// EXTERNAL MODULE: ./src/sdk/LineOfSight.ts
var LineOfSight = __webpack_require__(8499);
// EXTERNAL MODULE: ./src/sdk/Pathing.ts
var Pathing = __webpack_require__(5454);
// EXTERNAL MODULE: ./src/sdk/PlayerRegenTimers.ts
var PlayerRegenTimers = __webpack_require__(1167);
// EXTERNAL MODULE: ./src/sdk/PrayerController.ts + 41 modules
var PrayerController = __webpack_require__(4590);
// EXTERNAL MODULE: ./src/sdk/Settings.ts
var Settings = __webpack_require__(8406);
// EXTERNAL MODULE: ./src/sdk/Unit.ts + 3 modules
var Unit = __webpack_require__(3016);
// EXTERNAL MODULE: ./src/sdk/utils/SoundCache.ts
var SoundCache = __webpack_require__(6018);
// EXTERNAL MODULE: ./src/sdk/XpDropController.ts + 1 modules
var XpDropController = __webpack_require__(4133);
;// CONCATENATED MODULE: ./src/assets/sounds/hit.ogg
const hit_namespaceObject = __webpack_require__.p + "74571561a471dca69251.ogg";
;// CONCATENATED MODULE: ./src/assets/sounds/human_hit_513.ogg
const human_hit_513_namespaceObject = __webpack_require__.p + "6352a171f1cca4c45fb0.ogg";
// EXTERNAL MODULE: ./src/content/TileMarker.ts
var TileMarker = __webpack_require__(754);
// EXTERNAL MODULE: ./src/sdk/rendering/GLTFAnimationConstants.ts
var GLTFAnimationConstants = __webpack_require__(1708);
// EXTERNAL MODULE: ./src/sdk/rendering/CacheRenderModel.ts + 1 modules
var CacheRenderModel = __webpack_require__(3752);
// EXTERNAL MODULE: ./src/sdk/rendering/CacheRenderReference.ts
var CacheRenderReference = __webpack_require__(7757);
// EXTERNAL MODULE: ./src/sdk/Trainer.ts
var Trainer = __webpack_require__(6374);
;// CONCATENATED MODULE: ./src/sdk/Player.ts

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




















/* eslint-disable @typescript-eslint/no-explicit-any */
var PlayerEffects = /** @class */ (function () {
    function PlayerEffects() {
        this.poisoned = 0;
        this.venomed = 0;
        this.stamina = 0;
        /** Ticks left on a prayer regeneration potion (restores 1 Prayer every 12 ticks). */
        this.prayerRegeneration = 0;
    }
    return PlayerEffects;
}());
// player can rotate this many JAUs per client tick
// Player turn speed in the 2048-unit orientation space.
var PLAYER_ROTATION_RATE_JAU = 64;
var JAU_PER_RADIAN = 512;
var ROTATION_RADIANS_PER_CLIENT_TICK = PLAYER_ROTATION_RATE_JAU / JAU_PER_RADIAN;
var ENABLE_POSITION_DEBUG = false;
var Player = /** @class */ (function (_super) {
    __extends(Player, _super);
    function Player(region, location, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, region, location, options) || this;
        _this.xpDrops = [];
        _this.running = true;
        /** Ctrl+click: the current walk uses the opposite of the run setting (walk while running). */
        _this.invertRunForMove = false;
        _this.cachedBonuses = null;
        _this.useSpecialAttack = false;
        _this.effects = new PlayerEffects();
        _this.regenTimer = new PlayerRegenTimers/* PlayerRegenTimer */._(_this);
        _this.autocastDelay = 0;
        _this.manualCastHasTarget = false;
        _this.eats = new Eating/* Eating */.B();
        _this.seekingItem = null;
        _this.clickMarker = null;
        _this.aggroMarker = null;
        _this.pathMarkers = [];
        _this.currentPoseAnimation = GLTFAnimationConstants/* PlayerAnimationIndices */.L.Idle;
        /** Added to the weapon or spell range, e.g. negative for the Colosseum's Myopia modifier. */
        _this.attackRangeModifier = 0;
        // Rotation Code
        _this.restingAngle = 0;
        _this.lastTravelAngle = 0;
        _this.nextAngle = 0;
        _this._angle = 0;
        _this.rotationFromAngle = 0;
        _this.rotationTimestamp = 0;
        _this.rotationDirection = 1;
        _this.destinationLocation = location;
        _this.pathTargetLocation = location;
        _this.equipmentChanged();
        _this.clearXpDrops();
        _this.autoRetaliate = false;
        _this.eats.player = _this;
        _this.setUnitOptions(options);
        _this.prayerController = new PrayerController/* PrayerController */.U(_this);
        return _this;
    }
    Object.defineProperty(Player.prototype, "runningThisMove", {
        get: function () {
            if (!this.invertRunForMove)
                return this.running;
            // Ctrl+click with run off only runs if there is energy to run with.
            return !this.running && this.currentStats.run > 0;
        },
        enumerable: false,
        configurable: true
    });
    Player.prototype.contextActions = function (region, x, y) {
        var _this = this;
        return _super.prototype.contextActions.call(this, region, x, y).concat([
            {
                text: [
                    { text: "Attack ", fillStyle: "white" },
                    { text: "Player", fillStyle: "yellow" },
                    {
                        text: " (level ".concat(this.combatLevel, ")"),
                        fillStyle: Trainer/* Trainer */.c.player.combatLevelColor(this),
                    },
                ],
                action: function () {
                    Trainer/* Trainer */.c.clickController.redClick();
                    Trainer/* Trainer */.c.player.setAggro(_this);
                },
            },
        ]);
    };
    Player.prototype.setUnitOptions = function (options) {
        this.equipment = options.equipment || {};
        this.inventory = options.inventory || new Array(28).fill(null);
        this.equipmentChanged();
    };
    Player.prototype.interruptCombat = function () {
        this.invertRunForMove = false;
        // Cancelling an attack while stationary should not reset facing to the
        // travel/resting heading. Preserve the last target-facing angle first.
        if (this.aggro) {
            var targetAngle = this.getTargetAngle();
            this.restingAngle = targetAngle;
            this.nextAngle = targetAngle;
        }
        this.setAggro(null);
    };
    Object.defineProperty(Player.prototype, "color", {
        get: function () {
            return "#00FF00";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "height", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "isPlayer", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "attackRange", {
        get: function () {
            var range = 1;
            if (this.manualSpellCastSelection) {
                range = this.manualSpellCastSelection.attackRange;
            }
            else if (this.equipment.weapon) {
                range = this.equipment.weapon.attackRange;
            }
            // Melee range is never reduced below one tile.
            return range <= 1 ? range : Math.max(1, range + this.attackRangeModifier);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "attackSpeed", {
        get: function () {
            if (this.manualSpellCastSelection) {
                return this.manualSpellCastSelection.attackSpeed;
            }
            if (this.equipment.weapon) {
                return this.equipment.weapon.attackSpeed;
            }
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Player.prototype.openInventorySlots = function () {
        var openSpots = [];
        for (var i = 0; i < 28; i++) {
            if (!this.inventory[i]) {
                openSpots.push(i);
            }
        }
        return openSpots;
    };
    Player.prototype.swapItemPositions = function (pos1, pos2) {
        var _a, _b;
        // positions can be negative if an item is destroyed due to consuming it on the same tick
        var temp = (_a = this.inventory[pos1]) !== null && _a !== void 0 ? _a : null;
        this.inventory[pos1] = (_b = this.inventory[pos2]) !== null && _b !== void 0 ? _b : null;
        this.inventory[pos2] = temp;
    };
    Player.prototype.equipmentChanged = function () {
        var _this = this;
        this.interruptCombat();
        this.clearSpotAnim("weapon-attack");
        var gear = [
            this.equipment.weapon,
            this.equipment.offhand,
            this.equipment.helmet,
            this.equipment.necklace,
            this.equipment.chest,
            this.equipment.legs,
            this.equipment.feet,
            this.equipment.gloves,
            this.equipment.ring,
            this.equipment.cape,
        ];
        if (this.equipment.weapon &&
            this.equipment.ammo &&
            this.equipment.weapon.compatibleAmmo().includes(this.equipment.ammo.itemName)) {
            gear.push(this.equipment.ammo);
        }
        else if (this.equipment.ammo && this.equipment.ammo.ammoType() == Ammo/* AmmoType */.T.BLESSING) {
            gear.push(this.equipment.ammo);
        }
        // updated gear bonuses
        this.cachedBonuses = Unit/* Unit */.Nf.emptyBonuses();
        gear.forEach(function (g) {
            if (g && g.bonuses) {
                g.updateBonuses(gear);
                _this.cachedBonuses = Unit/* Unit */.Nf.mergeEquipmentBonuses(_this.cachedBonuses, g.bonuses);
            }
        });
        // update set effects
        var allSetEffects = [];
        gear.forEach(function (equipment) {
            if (equipment && equipment.equipmentSetEffect) {
                allSetEffects.push(equipment.equipmentSetEffect);
            }
        });
        var completeSetEffects = [];
        (0,lodash.uniq)(allSetEffects).forEach(function (setEffect) {
            var itemsInSet = setEffect.itemsInSet();
            var setItemsEquipped = 0;
            (0,lodash.find)(itemsInSet, function (itemName) {
                gear.forEach(function (equipment) {
                    if (!equipment) {
                        return;
                    }
                    if (itemName === equipment.itemName) {
                        setItemsEquipped++;
                    }
                });
            });
            if (itemsInSet.length === setItemsEquipped) {
                completeSetEffects.push(setEffect);
            }
        });
        this.setEffects = completeSetEffects;
        if (this.visualPath.length === 0) {
            this.currentPoseAnimation = this.getIdlePoseId();
        }
        this.invalidateModel();
    };
    Object.defineProperty(Player.prototype, "bonuses", {
        get: function () {
            return this.cachedBonuses;
        },
        enumerable: false,
        configurable: true
    });
    Player.prototype.setStats = function () {
        // non boosted numbers
        this.stats = Settings/* Settings */.w.player_stats;
        // with boosts
        this.currentStats = JSON.parse(JSON.stringify(Settings/* Settings */.w.player_stats));
    };
    Object.defineProperty(Player.prototype, "weight", {
        get: function () {
            var gear = [
                this.equipment.weapon,
                this.equipment.offhand,
                this.equipment.helmet,
                this.equipment.necklace,
                this.equipment.chest,
                this.equipment.legs,
                this.equipment.feet,
                this.equipment.gloves,
                this.equipment.ring,
                this.equipment.cape,
                this.equipment.ammo,
            ];
            gear = gear.concat(this.inventory);
            gear = (0,lodash.filter)(gear);
            var kgs = Math.max(Math.min(64, (0,lodash.sumBy)(gear, "weight")), 0);
            return kgs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "prayerDrainResistance", {
        get: function () {
            // https://oldschool.runescape.wiki/w/Prayer#Prayer_drain_mechanics
            return 2 * this.bonuses.other.prayer + 60;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "type", {
        get: function () {
            return Unit/* UnitTypes */.eK.PLAYER;
        },
        enumerable: false,
        configurable: true
    });
    Player.prototype.clearXpDrops = function () {
        this.xpDrops.length = 0;
    };
    Player.prototype.grantXp = function (xpDrop) {
        this.xpDrops.push(xpDrop);
    };
    Player.prototype.sendXpToController = function () {
        if (!XpDropController/* XpDropController */.O.controller) {
            return;
        }
        if (this !== Trainer/* Trainer */.c.player) {
            return;
        }
        var aggregated = {};
        this.xpDrops.forEach(function (_a) {
            var skill = _a.skill, xp = _a.xp, damage = _a.damage;
            if (!aggregated[skill])
                aggregated[skill] = { skill: skill, xp: 0, damage: 0 };
            aggregated[skill].xp += xp;
            aggregated[skill].damage += damage || 0;
        });
        Object.values(aggregated).forEach(function (drop) {
            XpDropController/* XpDropController */.O.controller.registerXpDrop(drop);
        });
        this.clearXpDrops();
    };
    Player.prototype.moveTo = function (x, y, invertRun) {
        var _this = this;
        if (invertRun === void 0) { invertRun = false; }
        this.interruptCombat();
        this.invertRunForMove = invertRun;
        this.manualSpellCastSelection = null;
        this.pathTargetLocation = null;
        var clickedOnEntities = Collision/* Collision */.F.collideableEntitiesAtPoint(this.region, x, y, 1);
        if (clickedOnEntities.length) {
            // Clicked on an entity, scan around to find the best spot to actually path to
            var clickedOnEntity = clickedOnEntities[0];
            var maxDist = Math.ceil(clickedOnEntity.size / 2);
            var bestDistances = [];
            var bestDistance = 9999;
            for (var yOff = -maxDist; yOff < maxDist; yOff++) {
                for (var xOff = -maxDist; xOff < maxDist; xOff++) {
                    var potentialX = x + xOff;
                    var potentialY = y + yOff;
                    var e = Collision/* Collision */.F.collideableEntitiesAtPoint(this.region, potentialX, potentialY, 1);
                    if (e.length === 0) {
                        var distance = Pathing/* Pathing */.G.dist(potentialX, potentialY, x, y);
                        if (distance <= bestDistance) {
                            if (bestDistances[0] && bestDistances[0].bestDistance > distance) {
                                bestDistance = distance;
                                bestDistances = [];
                            }
                            bestDistances.push({
                                x: potentialX,
                                y: potentialY,
                                bestDistance: bestDistance,
                            });
                        }
                    }
                }
            }
            var winner = (0,lodash.minBy)(bestDistances, function (distance) {
                return Pathing/* Pathing */.G.dist(distance.x, distance.y, _this.location.x, _this.location.y);
            });
            if (winner) {
                this.destinationLocation = { x: winner.x, y: winner.y };
            }
        }
        else {
            this.destinationLocation = { x: x, y: y };
        }
    };
    Player.prototype.attack = function () {
        if (this.manualSpellCastSelection) {
            var target = this.aggro;
            this.manualSpellCastSelection.cast(this, target);
            this.manualSpellCastSelection = null;
            this.interruptCombat();
            this.destinationLocation = this.location;
        }
        else {
            // use equipped weapon
            if (this.equipment.weapon) {
                if (this.equipment.weapon.hasSpecialAttack() && this.useSpecialAttack) {
                    if (this.currentStats.specialAttack >= this.equipment.weapon.specialAttackDrain()) {
                        var didSpecialAttack = this.equipment.weapon.specialAttack(this, this.aggro /* hack */);
                        if (didSpecialAttack) {
                            this.currentStats.specialAttack -= this.equipment.weapon.specialAttackDrain();
                            this.regenTimer.specUsed();
                        }
                        return didSpecialAttack;
                    }
                    this.useSpecialAttack = false;
                }
                else {
                    var bonuses = {};
                    if (this.equipment.helmet && this.equipment.helmet.itemName === ItemName/* ItemName */.P.SLAYER_HELMET_I) {
                        bonuses.gearMeleeMultiplier = 7 / 6;
                        bonuses.gearRangeMultiplier = 1.15;
                        bonuses.gearMageMultiplier = 1.15;
                    }
                    return this.equipment.weapon.attack(this, this.aggro /* hack */, bonuses);
                }
            }
            else {
                return false;
            }
        }
        return true;
    };
    Player.prototype.didAttack = function () {
        var weapon = this.equipment.weapon;
        var usedSpecialAttack = this.useSpecialAttack && (weapon === null || weapon === void 0 ? void 0 : weapon.hasSpecialAttack());
        _super.prototype.didAttack.call(this, usedSpecialAttack ? weapon === null || weapon === void 0 ? void 0 : weapon.specialAttackAnimationId : undefined);
        this.useSpecialAttack = false;
    };
    Player.prototype.activatePrayers = function () {
        this.overhead = this.prayerController.overhead();
        this.prayerController.prayers.forEach(function (prayer) {
            if (prayer.willPlayOffSound)
                prayer.playOffSound();
            if (prayer.willPlayOnSound)
                prayer.playOnSound();
            prayer.willPlayOffSound = false;
            prayer.willPlayOnSound = false;
        });
    };
    Player.prototype.setAggro = function (mob) {
        _super.prototype.setAggro.call(this, mob);
        if (this.manualSpellCastSelection && mob != null) {
            this.manualCastHasTarget = true;
        }
        else {
            this.manualCastHasTarget = false;
        }
        this.aggro = mob;
        this.seekingItem = null;
    };
    Player.prototype.setSeekingItem = function (item) {
        this.interruptCombat();
        this.seekingItem = item;
    };
    Player.prototype.determineDestination = function () {
        var _this = this;
        var _a;
        if (this.aggro) {
            if (this.aggro.dying > -1) {
                this.destinationLocation = this.location;
                return;
            }
            var isUnderAggrodMob = Collision/* Collision */.F.collisionMath(this.location.x, this.location.y, 1, this.aggro.location.x, this.aggro.location.y, this.aggro.size);
            this.setHasLOS();
            if (isUnderAggrodMob || !this.hasLOS) {
                var seekingTiles_1 = [];
                // "When clicking on an npc, object, or player, the requested tiles will be all tiles"
                // "within melee range of the npc, object, or player."
                // Start at the south-west tile so constructPaths can use it as the centre of its fallback search.
                var aggroSize = this.aggro.size;
                (0,lodash.range)(0, aggroSize).forEach(function (xx) {
                    [-1, _this.aggro.size].forEach(function (yy) {
                        // Don't path into an unpathable object.
                        var px = _this.aggro.location.x + xx;
                        var py = _this.aggro.location.y - yy;
                        if (!Collision/* Collision */.F.collidesWithAnyEntities(_this.region, px, py, 1)) {
                            seekingTiles_1.push({
                                x: px,
                                y: py,
                            });
                        }
                    });
                });
                (0,lodash.range)(0, aggroSize).forEach(function (yy) {
                    [-1, _this.aggro.size].forEach(function (xx) {
                        // Don't path into an unpathable object.
                        var px = _this.aggro.location.x + xx;
                        var py = _this.aggro.location.y - yy;
                        if (!Collision/* Collision */.F.collidesWithAnyEntities(_this.region, px, py, 1)) {
                            seekingTiles_1.push({
                                x: px,
                                y: py,
                            });
                        }
                    });
                });
                // Create paths to all npc tiles
                var path = Pathing/* Pathing */.G.constructPaths(this.region, this.location, seekingTiles_1);
                this.destinationLocation = (_a = path.destination) !== null && _a !== void 0 ? _a : this.location;
            }
            else {
                // stop moving
                this.destinationLocation = this.location;
            }
        }
        else if (this.seekingItem) {
            this.destinationLocation = this.seekingItem.groundLocation;
        }
    };
    Player.prototype.getIdlePoseId = function () {
        return this.equipment.weapon ? this.equipment.weapon.idleAnimationId : GLTFAnimationConstants/* PlayerAnimationIndices */.L.Idle;
    };
    Player.prototype.getWalkPoseId = function () {
        return this.equipment.weapon ? this.equipment.weapon.walkAnimationId : GLTFAnimationConstants/* PlayerAnimationIndices */.L.Walk;
    };
    Player.prototype.getRunPoseId = function () {
        return this.equipment.weapon ? this.equipment.weapon.runAnimationId : GLTFAnimationConstants/* PlayerAnimationIndices */.L.Run;
    };
    Player.prototype.getWalkBackPoseId = function () {
        return this.equipment.weapon ? this.equipment.weapon.walkBackAnimationId : GLTFAnimationConstants/* PlayerAnimationIndices */.L.WalkBack;
    };
    Player.prototype.getStrafeLeftPoseId = function () {
        return this.equipment.weapon ? this.equipment.weapon.strafeLeftAnimationId : GLTFAnimationConstants/* PlayerAnimationIndices */.L.StrafeLeft;
    };
    Player.prototype.getStrafeRightPoseId = function () {
        return this.equipment.weapon ? this.equipment.weapon.strafeRightAnimationId : GLTFAnimationConstants/* PlayerAnimationIndices */.L.StrafeRight;
    };
    // WARNING: client ticks do NOT happen in line with render or logic ticks. Do not use this for anything other than
    // visual logic.
    // Movement synchronisation details: docs/PLAYER_MOVEMENT_SYNC.md
    Player.prototype.clientTick = function (tickPercent, tickTimestamp) {
        if (tickTimestamp === void 0) { tickTimestamp = window.performance.now(); }
        var currentAngle = this._angle;
        this.rotationFromAngle = this._angle;
        this.rotationTimestamp = tickTimestamp;
        var angleDelta = ((this.nextAngle - this._angle + Math.PI * 3) % (Math.PI * 2)) - Math.PI;
        if (Math.abs(Math.abs(angleDelta) - Math.PI) < 1e-6)
            angleDelta = this.rotationDirection * Math.PI;
        else if (Math.abs(angleDelta) > 1e-6)
            this.rotationDirection = Math.sign(angleDelta);
        if (Math.abs(angleDelta) <= ROTATION_RADIANS_PER_CLIENT_TICK)
            this._angle = this.nextAngle;
        else
            this._angle += Math.sign(angleDelta) * ROTATION_RADIANS_PER_CLIENT_TICK;
        if (this.visualPath.length === 0) {
            this.currentPoseAnimation = this.getIdlePoseId();
            return;
        }
        var _a = this.visualPath[0], nextX = _a.x, nextY = _a.y, run = _a.run;
        if (this.perceivedLocation.x !== nextX || this.perceivedLocation.y !== nextY) {
            this.lastTravelAngle = -Pathing/* Pathing */.G.angle(this.perceivedLocation.x, this.perceivedLocation.y, nextX, nextY);
        }
        var baseMovementSpeed = 1 / (Settings/* Settings */.w.tickMs / 20);
        var movementSpeed = baseMovementSpeed;
        this.currentPoseAnimation = this.getWalkPoseId();
        var usingForwardMovementPose = true;
        var canRotate = true;
        var movementAngleDelta = ((this.lastTravelAngle - currentAngle + Math.PI * 3) % (Math.PI * 2)) - Math.PI;
        if (Math.abs(Math.abs(movementAngleDelta) - Math.PI) < 1e-6)
            movementAngleDelta = Math.PI;
        if (Math.abs(movementAngleDelta) > 1e-6 && canRotate) {
            if (ENABLE_POSITION_DEBUG)
                console.log("must rotate", this.visualPath.length, run);
            // Only apply turn turn slowdown when the player has no interaction target.
            if (!this.aggro) {
                movementSpeed = baseMovementSpeed / 2;
            }
            var lateralThreshold = Math.PI / 4;
            // Directional movement poses
            var thresholdEpsilon = 1e-6;
            if (movementAngleDelta > lateralThreshold + thresholdEpsilon && movementAngleDelta < (Math.PI * 3) / 4) {
                this.currentPoseAnimation = this.getStrafeRightPoseId();
                usingForwardMovementPose = false;
            }
            else if (movementAngleDelta < -lateralThreshold - thresholdEpsilon && movementAngleDelta > (-Math.PI * 3) / 4) {
                this.currentPoseAnimation = this.getStrafeLeftPoseId();
                usingForwardMovementPose = false;
            }
            else if (Math.abs(movementAngleDelta) >= (Math.PI * 3) / 4) {
                this.currentPoseAnimation = this.getWalkBackPoseId();
                usingForwardMovementPose = false;
            }
        }
        if (usingForwardMovementPose && run) {
            this.currentPoseAnimation = this.getRunPoseId();
        }
        var reachedStep = this.advanceVisualPath(baseMovementSpeed, movementSpeed, tickTimestamp);
        if (reachedStep) {
            if (ENABLE_POSITION_DEBUG) {
                var headTile = this.pathMarkers.shift();
                this.region.removeEntity(headTile);
            }
            if (this.visualPath.length === 0) {
                this.currentPoseAnimation = this.getIdlePoseId();
                this.restingAngle = this.lastTravelAngle;
                if (!this.aggro)
                    this.nextAngle = this.restingAngle;
            }
            else {
                this.nextAngle = this.getTargetAngle();
            }
        }
    };
    Player.prototype.moveTowardsDestination = function () {
        var _a;
        var _this = this;
        this.nextAngle = this.getTargetAngle();
        // Check if player will move this tick and at what speed
        var willMoveThisTick = this.destinationLocation &&
            (this.location.x !== this.destinationLocation.x || this.location.y !== this.destinationLocation.y);
        // Pre-calculate the movement to determine actual speed used
        var actualMovementSpeed = 1; // default to walk
        if (willMoveThisTick) {
            var speed_1 = this.runningThisMove ? 2 : 1;
            var path_1 = Pathing/* Pathing */.G.path(this.region, this.location, this.destinationLocation, speed_1, this.aggro).path;
            // Actual movement speed is how many tiles we'll move this tick
            if (path_1.length >= 2) {
                actualMovementSpeed = 2; // Actually running (moving 2 tiles)
            }
            else if (path_1.length === 1) {
                actualMovementSpeed = 1; // Actually walking (moving 1 tile)
            }
        }
        // Energy only drains when ACTUALLY running (moving 2 tiles this tick)
        if (this.runningThisMove && willMoveThisTick && actualMovementSpeed === 2) {
            // New energy drain formula: ⌊60 + 67 * clamp[0,64](weight) / 64⌋ * (1 - agility / 300)
            var clampedWeight = Math.min(Math.max(0, this.weight), 64);
            var baseReduction = Math.floor(60 + (67 * clampedWeight) / 64);
            var agilityMultiplier = 1 - this.currentStats.agility / 300;
            var runReduction = Math.floor(baseReduction * agilityMultiplier);
            var actualReduction = runReduction;
            if (this.effects.stamina) {
                actualReduction = Math.floor(0.3 * runReduction);
            }
            else if (this.equipment.ring && this.equipment.ring.itemName === ItemName/* ItemName */.P.RING_OF_ENDURANCE) {
                actualReduction = Math.floor(0.85 * runReduction);
            }
            this.currentStats.run -= actualReduction;
        }
        else {
            // New energy recovery formula: ⌊agility / 10⌋ + 15
            var recovery = Math.floor(this.currentStats.agility / 10) + 15;
            this.currentStats.run += recovery;
        }
        this.currentStats.run = Math.min(Math.max(this.currentStats.run, 0), 10000);
        if (this.currentStats.run === 0) {
            this.running = false;
        }
        // Tick down stamina
        this.effects.stamina--;
        this.effects.stamina = Math.min(Math.max(this.effects.stamina, 0), 200);
        if (this.effects.prayerRegeneration > 0) {
            this.effects.prayerRegeneration--;
            if (this.effects.prayerRegeneration % 12 === 0) {
                this.currentStats.prayer = Math.min(this.stats.prayer, this.currentStats.prayer + 1);
            }
        }
        // Path to next position if not already there.
        if (!this.destinationLocation ||
            (this.location.x === this.destinationLocation.x && this.location.y === this.destinationLocation.y)) {
            this.pathTargetLocation = null;
            return;
        }
        var speed = this.runningThisMove ? 2 : 1;
        var _b = Pathing/* Pathing */.G.path(this.region, this.location, this.destinationLocation, speed, this.aggro), path = _b.path, destination = _b.destination;
        this.pathTargetLocation = destination;
        if (!path.length || !destination) {
            return;
        }
        if (this.consumesSpace) {
            this.region.clearTileCollisionFlags(this.location.x, this.location.y, this.size);
        }
        if (path.length < speed) {
            // Step to the destination
            this.location = path[path.length - 1];
        }
        else {
            // Move one or two steps forward
            this.location = path[speed - 1];
        }
        // Keep every tile step. The cache client's pathLength counts steps, and
        // its 6/8-unit catch-up speeds depend on that count. Collapsing a straight
        // two-tile run into one corner made the model fall progressively behind
        // the authoritative true tile.
        // Walking advances one authoritative tile per server tick; running may
        // advance two. Do not enqueue the second look-ahead tile for a walker or
        // the visual queue grows faster than the true tile and falls behind.
        var visualSteps = path.slice(0, this.runningThisMove ? 2 : 1);
        if (this.consumesSpace) {
            visualSteps.forEach(function (_a) {
                var x = _a.x, y = _a.y;
                return _this.region.clearTileCollisionFlags(x, y, _this.size);
            });
            this.region.setTileCollisionFlags(this.location.x, this.location.y, this.size);
        }
        var newTiles = visualSteps.map(function (pos) { return (__assign(__assign({}, pos), { run: _this.runningThisMove && path.length >= 2 })); });
        if (ENABLE_POSITION_DEBUG) {
            newTiles.forEach(function (tile) {
                var marker = new ClickMarker(_this.region, tile, "#FF0000");
                _this.pathMarkers.push(marker);
                _this.region.addEntity(marker);
            });
        }
        (_a = this.visualPath).push.apply(_a, newTiles);
        this.nextAngle = this.getTargetAngle();
    };
    Player.prototype.takeSeekingItem = function () {
        if (this.seekingItem) {
            if (this.seekingItem.groundLocation.x === this.location.x) {
                if (this.seekingItem.groundLocation.y === this.location.y) {
                    // Verify player is close. Apparently we need to have the player keep track of this item
                    this.region.removeGroundItem(this.seekingItem, this.location.x, this.location.y);
                    var slots = this.openInventorySlots();
                    if (slots.length) {
                        var slot = slots[0];
                        this.inventory[slot] = this.seekingItem;
                    }
                    this.seekingItem = null;
                }
            }
        }
    };
    Player.prototype.dead = function () {
        _super.prototype.dead.call(this);
        this.perceivedLocation = this.location;
        this.destinationLocation = this.location;
    };
    Player.prototype.getPerceivedRotation = function (tickPercent) {
        // https://gist.github.com/shaunlebron/8832585
        function shortAngleDist(a0, a1) {
            var da = (a1 - a0) % (Math.PI * 2);
            return ((2 * da) % (Math.PI * 2)) - da;
        }
        //
        var alpha = Math.min(1, Math.max(0, (window.performance.now() - this.rotationTimestamp) / 20));
        var delta = ((this._angle - this.rotationFromAngle + Math.PI * 3) % (Math.PI * 2)) - Math.PI;
        return this.rotationFromAngle + delta * alpha;
    };
    Player.prototype.getTargetAngle = function () {
        var _a, _b, _c;
        if (this.aggro) {
            // Facing follows the same interpolated positions that are rendered. In
            // particular, do not mix the player's visual position with the target's
            // authoritative tile; that produces transient wrong-facing angles while
            // either actor is moving.
            var tickPercent = (_c = (_b = (_a = this.region) === null || _a === void 0 ? void 0 : _a.world) === null || _b === void 0 ? void 0 : _b.tickPercent) !== null && _c !== void 0 ? _c : 1;
            var perceivedLocation = this.getPerceivedLocation(tickPercent);
            var targetLocation = this.aggro.getPerceivedLocation(tickPercent);
            var angle = Pathing/* Pathing */.G.angle(perceivedLocation.x + this.size / 2, perceivedLocation.y - this.size / 2, targetLocation.x + this.aggro.size / 2, targetLocation.y - this.aggro.size / 2);
            return -angle;
        }
        if (this.visualPath.length > 0) {
            var angle = Pathing/* Pathing */.G.angle(this.perceivedLocation.x, this.perceivedLocation.y, this.visualPath[0].x, this.visualPath[0].y);
            return -angle;
        }
        return this.restingAngle;
    };
    Player.prototype.movementStep = function () {
        if (this.dying > -1 || this.currentStats.hitpoint <= 0) {
            return;
        }
        this.activatePrayers();
        this.takeSeekingItem();
        if (!this.isFrozen()) {
            this.determineDestination();
            this.moveTowardsDestination();
        }
        this.updatePathMarker();
    };
    Player.prototype.removeClickMarker = function () {
        if (!this.clickMarker) {
            return;
        }
        this.clickMarker.remove();
        this.region.removeEntity(this.clickMarker);
        this.clickMarker = null;
    };
    Player.prototype.showTargetMarker = function (location) {
        if (!this.clickMarker) {
            this.clickMarker = new ClickMarker(this.region, location);
            this.region.addEntity(this.clickMarker);
        }
        else {
            this.clickMarker.location = location;
        }
    };
    Player.prototype.updatePathMarker = function () {
        if (!this.pathTargetLocation) {
            this.removeClickMarker();
            return;
        }
        if (this.clickMarker &&
            this.location.x === this.pathTargetLocation.x &&
            this.location.y === this.pathTargetLocation.y) {
            this.removeClickMarker();
        }
        else if (!this.clickMarker) {
            this.showTargetMarker(this.pathTargetLocation);
        }
        else {
            this.clickMarker.location = this.pathTargetLocation;
        }
    };
    Player.prototype.hitSound = function (damaged) {
        return damaged ? new SoundCache/* Sound */.A(human_hit_513_namespaceObject, 0.1) : new SoundCache/* Sound */.A(hit_namespaceObject, 0.15);
    };
    Player.prototype.damageTaken = function () {
        this.prayerController.checkRedemption(this);
    };
    Player.prototype.pretick = function () {
        this.prayerController.tick(this);
    };
    Player.prototype.timerStep = function () {
        var _a;
        if (((_a = this.region.world) === null || _a === void 0 ? void 0 : _a.getReadyTimer) > 0) {
            // GET READY consumes the movement lock without advancing combat clocks.
            this.frozen--;
            return;
        }
        _super.prototype.timerStep.call(this);
    };
    Player.prototype.attackStep = function () {
        _super.prototype.attackStep.call(this);
        this.detectDeath();
        if (this.dying > -1) {
            return;
        }
        this.clearXpDrops();
        // clear aggro if target is nulled (e.g. healers on zuk after tag)
        if (this.aggro && this.aggro.isNulled) {
            this.aggro = null;
        }
        this.attackIfPossible();
        this.eats.tickFood(this);
        this.regenTimer.regen();
        this.sendXpToController();
    };
    Player.prototype.attackIfPossible = function () {
        if (this.canAttack() === false) {
            return;
        }
        if (this.aggro) {
            this.setHasLOS();
            if (this.hasLOS && this.attackDelay <= 0 && this.aggro.isDying() === false) {
                this.attack() && this.didAttack();
            }
            else if (this.manualSpellCastSelection &&
                this.manualCastHasTarget &&
                this.hasLOS &&
                this.attackDelay <= 0 &&
                this.aggro.dying == this.aggro.deathAnimationLength) {
                // Phantom/ghost barrage
                this.attack() && this.didAttack();
            }
            // After allowing ghost barrage, unset aggro if enemy is dead
            if (this.aggro && this.aggro.isDying()) {
                this.interruptCombat();
            }
        }
    };
    Player.prototype.draw = function (tickPercent) {
        // this.region.context.fillStyle = '#FFFF00'
        // this.region.context.fillRect(
        //   26 * Settings.tileSize,
        //   24 * Settings.tileSize,
        //   6 * Settings.tileSize,
        //   12 * Settings.tileSize
        // // 26 - 32 x
        // // 24 - 36 y
        // )
        if (Settings/* Settings */.w.displayPlayerLoS) {
            LineOfSight/* LineOfSight */.V.drawLOS(this.region, this.location.x, this.location.y, this.size, this.attackRange, "#00FF0055", this.type === Unit/* UnitTypes */.eK.MOB);
        }
        this.region.context.save();
        var perceivedLocation = this.getPerceivedLocation(tickPercent);
        var perceivedX = perceivedLocation.x;
        var perceivedY = perceivedLocation.y;
        // Perceived location
        if (this.dying === -1) {
            this.region.context.globalAlpha = 0.7;
            this.region.context.fillStyle = "#FFFF00";
            this.region.context.fillRect(perceivedX * Settings/* Settings */.w.tileSize, perceivedY * Settings/* Settings */.w.tileSize, Settings/* Settings */.w.tileSize, Settings/* Settings */.w.tileSize);
            this.region.context.globalAlpha = 1;
        }
        // Draw player on true tile
        this.region.context.fillStyle = "#ffffff73";
        // feedback for when you shoot
        if (this.shouldShowAttackAnimation()) {
            this.region.context.fillStyle = "#00FFFF";
        }
        if (this.dying > -1) {
            this.region.context.fillStyle = "#000";
        }
        this.region.context.strokeStyle = "#FFFFFF73";
        this.region.context.lineWidth = 3;
        this.region.context.fillRect(this.location.x * Settings/* Settings */.w.tileSize, this.location.y * Settings/* Settings */.w.tileSize, Settings/* Settings */.w.tileSize, Settings/* Settings */.w.tileSize);
        // Destination location
        if (Settings/* Settings */.w.targetTileEnabled) {
            this.region.context.globalAlpha = 0.5;
            this.region.context.strokeStyle = Settings/* Settings */.w.targetTileColor;
            this.region.context.lineWidth = 3;
            this.region.context.strokeRect(this.destinationLocation.x * Settings/* Settings */.w.tileSize, this.destinationLocation.y * Settings/* Settings */.w.tileSize, Settings/* Settings */.w.tileSize, Settings/* Settings */.w.tileSize);
            this.region.context.globalAlpha = 1;
        }
        this.region.context.restore();
        return { x: perceivedX, y: perceivedY };
    };
    Player.prototype.drawUILayer = function (tickPercent, projector, context, scale) {
        if (this.dying > -1 || !projector.visible) {
            return;
        }
        var overheadPosition = projector.atHeight(projector.logicalHeight);
        context.save();
        context.translate(overheadPosition.x, overheadPosition.y);
        if (Settings/* Settings */.w.rotated === "south") {
            context.rotate(Math.PI);
        }
        this.drawHPBar(context, scale, 0);
        this.drawOverheadPrayers(context, scale);
        context.restore();
        var hitsplatPosition = projector.atHeight(projector.logicalHeight * 0.5);
        context.save();
        context.translate(hitsplatPosition.x, hitsplatPosition.y);
        if (Settings/* Settings */.w.rotated === "south")
            context.rotate(Math.PI);
        this.drawHitsplats(context, scale);
        context.restore();
    };
    Player.prototype.create3dModel = function () {
        return CacheRenderModel/* CacheRenderModel */.q.forRenderable(this, CacheRenderReference/* CacheRenderReferences */.P.player([
            this.equipment.helmet,
            this.equipment.necklace,
            this.equipment.cape,
            this.equipment.chest,
            this.equipment.legs,
            this.equipment.feet,
            this.equipment.gloves,
            this.equipment.ring,
            this.equipment.ammo,
            this.equipment.weapon,
            this.equipment.offhand,
        ]
            .filter(function (e) { return !!e; })
            .map(function (e) { var _a; return (_a = e.cacheItemId) !== null && _a !== void 0 ? _a : e.itemName; }), {
            idle: this.getIdlePoseId(),
            walk: this.getWalkPoseId(),
            run: this.getRunPoseId()
        }));
    };
    Object.defineProperty(Player.prototype, "animationIndex", {
        get: function () {
            return this.currentPoseAnimation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "shouldBlendAnimationWithPose", {
        get: function () {
            return this.visualPath.length > 0
                || this.perceivedLocation.x !== this.location.x
                || this.perceivedLocation.y !== this.location.y;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "drawOutline", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "attackAnimationId", {
        get: function () {
            var _a;
            return (_a = this.equipment.weapon) === null || _a === void 0 ? void 0 : _a.attackAnimationId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "canBlendAttackAnimation", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "deathAnimationLength", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Player.prototype, "deathAnimationId", {
        get: function () {
            return GLTFAnimationConstants/* PlayerAnimationIndices */.L.Dying;
        },
        enumerable: false,
        configurable: true
    });
    return Player;
}(Unit/* Unit */.Nf));

var ClickMarker = /** @class */ (function (_super) {
    __extends(ClickMarker, _super);
    function ClickMarker(region, location, color) {
        var _this = _super.call(this, region, location, color !== null && color !== void 0 ? color : Settings/* Settings */.w.targetTileColor, 1, false) || this;
        _this.targetMarker = color === undefined;
        return _this;
    }
    Object.defineProperty(ClickMarker.prototype, "color", {
        get: function () {
            return this.targetMarker ? Settings/* Settings */.w.targetTileColor : this._color;
        },
        enumerable: false,
        configurable: true
    });
    ClickMarker.prototype.visible = function (tickPercent) {
        return !this.targetMarker || Settings/* Settings */.w.targetTileEnabled;
    };
    ClickMarker.prototype.draw = function () {
        if (this.targetMarker && !Settings/* Settings */.w.targetTileEnabled)
            return;
        _super.prototype.draw.call(this);
    };
    ClickMarker.prototype.remove = function () {
        this.dying = 0;
    };
    return ClickMarker;
}(TileMarker/* TileMarker */.l));


/***/ }),

/***/ 1167:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: () => (/* binding */ PlayerRegenTimer)
/* harmony export */ });

var PlayerRegenTimer = /** @class */ (function () {
    function PlayerRegenTimer(player) {
        this.player = player;
        this.spec = 50;
        this.hitpoint = 100;
    }
    PlayerRegenTimer.prototype.specUsed = function () {
        if (this.spec <= 0) {
            this.spec = 50;
        }
    };
    PlayerRegenTimer.prototype.regen = function () {
        this.specRegen();
        this.hitpointRegen();
    };
    PlayerRegenTimer.prototype.specRegen = function () {
        this.spec--;
        if (this.spec === 0) {
            this.spec = 50;
            this.player.currentStats.specialAttack += 10;
            this.player.currentStats.specialAttack = Math.min(100, this.player.currentStats.specialAttack);
        }
    };
    PlayerRegenTimer.prototype.hitpointRegen = function () {
        this.hitpoint--;
        if (this.hitpoint === 0) {
            this.hitpoint = 100;
            var currentHp = this.player.currentStats.hitpoint;
            var lvlHp = this.player.stats.hitpoint;
            var diff = currentHp === lvlHp ? 0 : currentHp > lvlHp ? -1 : 1;
            this.player.currentStats.hitpoint += diff;
        }
    };
    return PlayerRegenTimer;
}());



/***/ }),

/***/ 2455:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: () => (/* binding */ SerializePlayerStats),
/* harmony export */   Q: () => (/* binding */ DeserializePlayerStats)
/* harmony export */ });

function SerializePlayerStats(stats) {
    return JSON.stringify(stats);
}
function DeserializePlayerStats(serializedStats) {
    var stats = JSON.parse(serializedStats) || {};
    stats.attack = stats.attack || 99;
    stats.strength = stats.strength || 99;
    stats.defence = stats.defence || 99;
    stats.range = stats.range || 99;
    stats.magic = stats.magic || 99;
    stats.hitpoint = stats.hitpoint || 99;
    stats.agility = stats.agility || 99;
    stats.prayer = stats.prayer || 99;
    stats.run = stats.run || 10000;
    stats.specialAttack = stats.specialAttack || 100;
    return stats;
}


/***/ }),

/***/ 4590:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  U: () => (/* binding */ PrayerController)
});

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(2543);
// EXTERNAL MODULE: ./src/sdk/BasePrayer.ts
var BasePrayer = __webpack_require__(165);
// EXTERNAL MODULE: ./src/sdk/Settings.ts
var Settings = __webpack_require__(8406);
// EXTERNAL MODULE: ./src/sdk/audio/CacheSoundEffects.ts + 1 modules
var CacheSoundEffects = __webpack_require__(5432);
// EXTERNAL MODULE: ./src/assets/CacheAssets.ts
var CacheAssets = __webpack_require__(4655);
// EXTERNAL MODULE: ./src/sdk/utils/SoundCache.ts
var SoundCache = __webpack_require__(6018);
;// CONCATENATED MODULE: ./src/content/prayers/Augury.ts

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Augury = /** @class */ (function (_super) {
    __extends(Augury, _super);
    function Augury() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Augury.prototype, "name", {
        get: function () {
            return "Augury";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Augury.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY, BasePrayer/* PrayerGroups */.u.STRENGTH, BasePrayer/* PrayerGroups */.u.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    Augury.prototype.levelRequirement = function () {
        return 77;
    };
    Augury.prototype.isOverhead = function () {
        return false;
    };
    Augury.prototype.feature = function () {
        return "offensiveMagic";
    };
    Augury.prototype.drainRate = function () {
        return 24;
    };
    Augury.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.augury.id), 0.1));
        }
    };
    Augury.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.prayerDeactivated.id), 0.1));
        }
    };
    return Augury;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/BurstOfStrength.ts

var BurstOfStrength_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var BurstOfStrength = /** @class */ (function (_super) {
    BurstOfStrength_extends(BurstOfStrength, _super);
    function BurstOfStrength() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BurstOfStrength.prototype, "name", {
        get: function () {
            return "Burst of Strength";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BurstOfStrength.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    BurstOfStrength.prototype.levelRequirement = function () {
        return 4;
    };
    BurstOfStrength.prototype.drainRate = function () {
        return 3;
    };
    BurstOfStrength.prototype.isOverhead = function () {
        return false;
    };
    BurstOfStrength.prototype.feature = function () {
        return "offensiveStrength";
    };
    BurstOfStrength.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    BurstOfStrength.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return BurstOfStrength;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/Chivalry.ts

var Chivalry_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Chivalry = /** @class */ (function (_super) {
    Chivalry_extends(Chivalry, _super);
    function Chivalry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Chivalry.prototype, "name", {
        get: function () {
            return "Chivalry";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Chivalry.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY, BasePrayer/* PrayerGroups */.u.STRENGTH, BasePrayer/* PrayerGroups */.u.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    Chivalry.prototype.levelRequirement = function () {
        return 60;
    };
    Chivalry.prototype.drainRate = function () {
        return 24;
    };
    Chivalry.prototype.isOverhead = function () {
        return false;
    };
    Chivalry.prototype.feature = function () {
        return "offensiveAttack";
    };
    Chivalry.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    Chivalry.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Chivalry;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/ClarityOfThought.ts

var ClarityOfThought_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ClarityOfThought = /** @class */ (function (_super) {
    ClarityOfThought_extends(ClarityOfThought, _super);
    function ClarityOfThought() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ClarityOfThought.prototype, "name", {
        get: function () {
            return "Clarity of Thought";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClarityOfThought.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY];
        },
        enumerable: false,
        configurable: true
    });
    ClarityOfThought.prototype.levelRequirement = function () {
        return 7;
    };
    ClarityOfThought.prototype.drainRate = function () {
        return 3;
    };
    ClarityOfThought.prototype.isOverhead = function () {
        return false;
    };
    ClarityOfThought.prototype.feature = function () {
        return "offensiveAttack";
    };
    ClarityOfThought.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    ClarityOfThought.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return ClarityOfThought;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/EagleEye.ts

var EagleEye_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var EagleEye = /** @class */ (function (_super) {
    EagleEye_extends(EagleEye, _super);
    function EagleEye() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EagleEye.prototype, "name", {
        get: function () {
            return "Eagle Eye";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EagleEye.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY, BasePrayer/* PrayerGroups */.u.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    EagleEye.prototype.levelRequirement = function () {
        return 44;
    };
    EagleEye.prototype.drainRate = function () {
        return 12;
    };
    EagleEye.prototype.isOverhead = function () {
        return false;
    };
    EagleEye.prototype.feature = function () {
        return "offensiveRange";
    };
    EagleEye.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    EagleEye.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return EagleEye;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/HawkEye.ts

var HawkEye_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var HawkEye = /** @class */ (function (_super) {
    HawkEye_extends(HawkEye, _super);
    function HawkEye() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HawkEye.prototype, "name", {
        get: function () {
            return "Hawk Eye";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HawkEye.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY, BasePrayer/* PrayerGroups */.u.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    HawkEye.prototype.levelRequirement = function () {
        return 26;
    };
    HawkEye.prototype.drainRate = function () {
        return 6;
    };
    HawkEye.prototype.isOverhead = function () {
        return false;
    };
    HawkEye.prototype.feature = function () {
        return "offensiveRange";
    };
    HawkEye.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    HawkEye.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return HawkEye;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/ImprovedReflexes.ts

var ImprovedReflexes_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ImprovedReflexes = /** @class */ (function (_super) {
    ImprovedReflexes_extends(ImprovedReflexes, _super);
    function ImprovedReflexes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ImprovedReflexes.prototype, "name", {
        get: function () {
            return "Improved Reflexes";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImprovedReflexes.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY];
        },
        enumerable: false,
        configurable: true
    });
    ImprovedReflexes.prototype.levelRequirement = function () {
        return 16;
    };
    ImprovedReflexes.prototype.drainRate = function () {
        return 6;
    };
    ImprovedReflexes.prototype.isOverhead = function () {
        return false;
    };
    ImprovedReflexes.prototype.feature = function () {
        return "offensiveAttack";
    };
    ImprovedReflexes.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    ImprovedReflexes.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return ImprovedReflexes;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/IncredibleReflexes.ts

var IncredibleReflexes_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var IncredibleReflexes = /** @class */ (function (_super) {
    IncredibleReflexes_extends(IncredibleReflexes, _super);
    function IncredibleReflexes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(IncredibleReflexes.prototype, "name", {
        get: function () {
            return "Incredible Reflexes";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IncredibleReflexes.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY];
        },
        enumerable: false,
        configurable: true
    });
    IncredibleReflexes.prototype.levelRequirement = function () {
        return 34;
    };
    IncredibleReflexes.prototype.drainRate = function () {
        return 12;
    };
    IncredibleReflexes.prototype.isOverhead = function () {
        return false;
    };
    IncredibleReflexes.prototype.feature = function () {
        return "offensiveAttack";
    };
    IncredibleReflexes.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    IncredibleReflexes.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return IncredibleReflexes;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/MysticLore.ts

var MysticLore_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var MysticLore = /** @class */ (function (_super) {
    MysticLore_extends(MysticLore, _super);
    function MysticLore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MysticLore.prototype, "name", {
        get: function () {
            return "Mystic Lore";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MysticLore.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY, BasePrayer/* PrayerGroups */.u.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    MysticLore.prototype.levelRequirement = function () {
        return 27;
    };
    MysticLore.prototype.drainRate = function () {
        return 6;
    };
    MysticLore.prototype.isOverhead = function () {
        return false;
    };
    MysticLore.prototype.feature = function () {
        return "offensiveMagic";
    };
    MysticLore.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    MysticLore.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return MysticLore;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/MysticMight.ts

var MysticMight_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var MysticMight = /** @class */ (function (_super) {
    MysticMight_extends(MysticMight, _super);
    function MysticMight() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MysticMight.prototype, "name", {
        get: function () {
            return "Mystic Might";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MysticMight.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY, BasePrayer/* PrayerGroups */.u.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    MysticMight.prototype.levelRequirement = function () {
        return 45;
    };
    MysticMight.prototype.drainRate = function () {
        return 12;
    };
    MysticMight.prototype.isOverhead = function () {
        return false;
    };
    MysticMight.prototype.feature = function () {
        return "offensiveMagic";
    };
    MysticMight.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    MysticMight.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return MysticMight;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/MysticWill.ts

var MysticWill_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var MysticWill = /** @class */ (function (_super) {
    MysticWill_extends(MysticWill, _super);
    function MysticWill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MysticWill.prototype, "name", {
        get: function () {
            return "Mystic Will";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MysticWill.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY, BasePrayer/* PrayerGroups */.u.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    MysticWill.prototype.levelRequirement = function () {
        return 9;
    };
    MysticWill.prototype.drainRate = function () {
        return 3;
    };
    MysticWill.prototype.isOverhead = function () {
        return false;
    };
    MysticWill.prototype.feature = function () {
        return "offensiveMagic";
    };
    MysticWill.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    MysticWill.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return MysticWill;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/Piety.ts

var Piety_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Piety = /** @class */ (function (_super) {
    Piety_extends(Piety, _super);
    function Piety() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Piety.prototype, "name", {
        get: function () {
            return "Piety";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Piety.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY, BasePrayer/* PrayerGroups */.u.STRENGTH, BasePrayer/* PrayerGroups */.u.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    Piety.prototype.levelRequirement = function () {
        return 70;
    };
    Piety.prototype.drainRate = function () {
        return 24;
    };
    Piety.prototype.isOverhead = function () {
        return false;
    };
    Piety.prototype.feature = function () {
        return "offensiveAttack";
    };
    Piety.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.piety.id), 0.1));
        }
    };
    Piety.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.prayerDeactivated.id), 0.1));
        }
    };
    return Piety;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/Preserve.ts

var Preserve_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Preserve = /** @class */ (function (_super) {
    Preserve_extends(Preserve, _super);
    function Preserve() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Preserve.prototype, "name", {
        get: function () {
            return "Preserve";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Preserve.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.PRESERVE]; // TODO: Incorrect
        },
        enumerable: false,
        configurable: true
    });
    Preserve.prototype.levelRequirement = function () {
        return 100;
    };
    Preserve.prototype.drainRate = function () {
        return 2;
    };
    Preserve.prototype.isOverhead = function () {
        return false;
    };
    Preserve.prototype.feature = function () {
        return "preserve";
    };
    Preserve.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    Preserve.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Preserve;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/ProtectItem.ts

var ProtectItem_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ProtectItem = /** @class */ (function (_super) {
    ProtectItem_extends(ProtectItem, _super);
    function ProtectItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ProtectItem.prototype, "name", {
        get: function () {
            return "Protect Item";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProtectItem.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.PROTECTITEM]; // TODO: Incorrect
        },
        enumerable: false,
        configurable: true
    });
    ProtectItem.prototype.levelRequirement = function () {
        return 100;
    };
    ProtectItem.prototype.drainRate = function () {
        return 2;
    };
    ProtectItem.prototype.isOverhead = function () {
        return false;
    };
    ProtectItem.prototype.feature = function () {
        return "";
    };
    ProtectItem.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    ProtectItem.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return ProtectItem;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/assets/images/prayers/mageOver.png
const mageOver_namespaceObject = __webpack_require__.p + "fe99a91eeb128d8be1d2.png";
;// CONCATENATED MODULE: ./src/assets/sounds/mageOn.ogg
const mageOn_namespaceObject = __webpack_require__.p + "4eefe1a9d512bc7e3c96.ogg";
;// CONCATENATED MODULE: ./src/assets/sounds/mageOff.ogg
const mageOff_namespaceObject = __webpack_require__.p + "1a5aebbf6442ec2dfbc1.ogg";
;// CONCATENATED MODULE: ./src/content/prayers/ProtectMage.ts

var ProtectMage_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ProtectMage = /** @class */ (function (_super) {
    ProtectMage_extends(ProtectMage, _super);
    function ProtectMage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ProtectMage.prototype, "name", {
        get: function () {
            return "Protect from Magic";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProtectMage.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.OVERHEADS];
        },
        enumerable: false,
        configurable: true
    });
    ProtectMage.prototype.levelRequirement = function () {
        return 37;
    };
    ProtectMage.prototype.drainRate = function () {
        return 12;
    };
    ProtectMage.prototype.isOverhead = function () {
        return true;
    };
    ProtectMage.prototype.overheadImageReference = function () {
        return mageOver_namespaceObject;
    };
    ProtectMage.prototype.feature = function () {
        return "magic";
    };
    ProtectMage.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A(mageOn_namespaceObject, 0.35));
        }
    };
    ProtectMage.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A(mageOff_namespaceObject, 0.35));
        }
    };
    return ProtectMage;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/assets/images/prayers/meleeOver.png
const meleeOver_namespaceObject = __webpack_require__.p + "5ad83928ec6982dee94a.png";
;// CONCATENATED MODULE: ./src/assets/sounds/meleeOn.ogg
const meleeOn_namespaceObject = __webpack_require__.p + "3b71db031396f30042b1.ogg";
;// CONCATENATED MODULE: ./src/assets/sounds/meleeOff.ogg
const meleeOff_namespaceObject = __webpack_require__.p + "395ac1a9baa2026f2788.ogg";
;// CONCATENATED MODULE: ./src/content/prayers/ProtectMelee.ts

var ProtectMelee_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ProtectMelee = /** @class */ (function (_super) {
    ProtectMelee_extends(ProtectMelee, _super);
    function ProtectMelee() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ProtectMelee.prototype, "name", {
        get: function () {
            return "Protect from Melee";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProtectMelee.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.OVERHEADS];
        },
        enumerable: false,
        configurable: true
    });
    ProtectMelee.prototype.levelRequirement = function () {
        return 43;
    };
    ProtectMelee.prototype.drainRate = function () {
        return 12;
    };
    ProtectMelee.prototype.isOverhead = function () {
        return true;
    };
    ProtectMelee.prototype.overheadImageReference = function () {
        return meleeOver_namespaceObject;
    };
    ProtectMelee.prototype.feature = function () {
        return "melee";
    };
    ProtectMelee.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A(meleeOn_namespaceObject, 0.35));
        }
    };
    ProtectMelee.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A(meleeOff_namespaceObject, 0.35));
        }
    };
    return ProtectMelee;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/assets/images/prayers/rangeOver.png
const rangeOver_namespaceObject = __webpack_require__.p + "60ca147bb4530f1e23d6.png";
;// CONCATENATED MODULE: ./src/assets/sounds/rangeOn.ogg
const rangeOn_namespaceObject = __webpack_require__.p + "a4704be277145aa0de86.ogg";
;// CONCATENATED MODULE: ./src/assets/sounds/rangeOff.ogg
const rangeOff_namespaceObject = __webpack_require__.p + "459103be09726a92da33.ogg";
;// CONCATENATED MODULE: ./src/content/prayers/ProtectRange.ts

var ProtectRange_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var ProtectRange = /** @class */ (function (_super) {
    ProtectRange_extends(ProtectRange, _super);
    function ProtectRange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ProtectRange.prototype, "name", {
        get: function () {
            return "Protect from Range";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProtectRange.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.OVERHEADS];
        },
        enumerable: false,
        configurable: true
    });
    ProtectRange.prototype.levelRequirement = function () {
        return 34;
    };
    ProtectRange.prototype.drainRate = function () {
        return 12;
    };
    ProtectRange.prototype.isOverhead = function () {
        return true;
    };
    ProtectRange.prototype.overheadImageReference = function () {
        return rangeOver_namespaceObject;
    };
    ProtectRange.prototype.feature = function () {
        return "range";
    };
    ProtectRange.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A(rangeOn_namespaceObject, 0.35));
        }
    };
    ProtectRange.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A(rangeOff_namespaceObject, 0.35));
        }
    };
    return ProtectRange;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/RapidHeal.ts

var RapidHeal_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var RapidHeal = /** @class */ (function (_super) {
    RapidHeal_extends(RapidHeal, _super);
    function RapidHeal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RapidHeal.prototype, "name", {
        get: function () {
            return "Rapid Heal";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RapidHeal.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.HEARTS];
        },
        enumerable: false,
        configurable: true
    });
    RapidHeal.prototype.levelRequirement = function () {
        return 100;
    };
    RapidHeal.prototype.drainRate = function () {
        return 2;
    };
    RapidHeal.prototype.isOverhead = function () {
        return false;
    };
    RapidHeal.prototype.feature = function () {
        return "";
    };
    RapidHeal.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    RapidHeal.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return RapidHeal;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/RapidRestore.ts

var RapidRestore_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var RapidRestore = /** @class */ (function (_super) {
    RapidRestore_extends(RapidRestore, _super);
    function RapidRestore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RapidRestore.prototype, "name", {
        get: function () {
            return "Rapid Restore";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RapidRestore.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.HEARTS];
        },
        enumerable: false,
        configurable: true
    });
    RapidRestore.prototype.levelRequirement = function () {
        return 100;
    };
    RapidRestore.prototype.drainRate = function () {
        return 1;
    };
    RapidRestore.prototype.isOverhead = function () {
        return false;
    };
    RapidRestore.prototype.feature = function () {
        return "";
    };
    RapidRestore.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    RapidRestore.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return RapidRestore;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/assets/images/prayers/redemptionOver.png
const redemptionOver_namespaceObject = __webpack_require__.p + "0cf6744ec00b154c280f.png";
;// CONCATENATED MODULE: ./src/assets/sounds/redemption_2680.ogg
const redemption_2680_namespaceObject = __webpack_require__.p + "4c087a446f624d411fda.ogg";
;// CONCATENATED MODULE: ./src/content/prayers/Redemption.ts

var Redemption_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Redemption = /** @class */ (function (_super) {
    Redemption_extends(Redemption, _super);
    function Redemption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Redemption.prototype, "name", {
        get: function () {
            return "Redemption";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Redemption.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.OVERHEADS];
        },
        enumerable: false,
        configurable: true
    });
    Redemption.prototype.levelRequirement = function () {
        return 49;
    };
    Redemption.prototype.drainRate = function () {
        return 6;
    };
    Redemption.prototype.isOverhead = function () {
        return true;
    };
    Redemption.prototype.overheadImageReference = function () {
        return redemptionOver_namespaceObject;
    };
    Redemption.prototype.feature = function () {
        return "redemption";
    };
    Redemption.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            new Audio(redemption_2680_namespaceObject).play();
        }
    };
    Redemption.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Redemption;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/Retribution.ts

var Retribution_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Retribution = /** @class */ (function (_super) {
    Retribution_extends(Retribution, _super);
    function Retribution() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Retribution.prototype, "name", {
        get: function () {
            return "Retribution";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Retribution.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.OVERHEADS]; // TODO: Incorrect
        },
        enumerable: false,
        configurable: true
    });
    Retribution.prototype.levelRequirement = function () {
        return 100;
    };
    Retribution.prototype.drainRate = function () {
        return 3;
    };
    Retribution.prototype.isOverhead = function () {
        return false;
    };
    Retribution.prototype.feature = function () {
        return "";
    };
    Retribution.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    Retribution.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Retribution;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/Rigour.ts

var Rigour_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Rigour = /** @class */ (function (_super) {
    Rigour_extends(Rigour, _super);
    function Rigour() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Rigour.prototype, "name", {
        get: function () {
            return "Rigour";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rigour.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY, BasePrayer/* PrayerGroups */.u.STRENGTH, BasePrayer/* PrayerGroups */.u.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    Rigour.prototype.levelRequirement = function () {
        return 74;
    };
    Rigour.prototype.drainRate = function () {
        return 24;
    };
    Rigour.prototype.isOverhead = function () {
        return false;
    };
    Rigour.prototype.feature = function () {
        return "offensiveRange";
    };
    Rigour.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.rigour.id), 0.1));
        }
    };
    Rigour.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.prayerDeactivated.id), 0.1));
        }
    };
    return Rigour;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/RockSkin.ts

var RockSkin_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var RockSkin = /** @class */ (function (_super) {
    RockSkin_extends(RockSkin, _super);
    function RockSkin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RockSkin.prototype, "name", {
        get: function () {
            return "Rock Skin";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RockSkin.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    RockSkin.prototype.levelRequirement = function () {
        return 10;
    };
    RockSkin.prototype.drainRate = function () {
        return 6;
    };
    RockSkin.prototype.isOverhead = function () {
        return false;
    };
    RockSkin.prototype.feature = function () {
        return "defensive";
    };
    RockSkin.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    RockSkin.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return RockSkin;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/SharpEye.ts

var SharpEye_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var SharpEye = /** @class */ (function (_super) {
    SharpEye_extends(SharpEye, _super);
    function SharpEye() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SharpEye.prototype, "name", {
        get: function () {
            return "Sharp Eye";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SharpEye.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.ACCURACY, BasePrayer/* PrayerGroups */.u.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    SharpEye.prototype.levelRequirement = function () {
        return 8;
    };
    SharpEye.prototype.drainRate = function () {
        return 3;
    };
    SharpEye.prototype.isOverhead = function () {
        return false;
    };
    SharpEye.prototype.feature = function () {
        return "offensiveRange";
    };
    SharpEye.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    SharpEye.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return SharpEye;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/Smite.ts

var Smite_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Smite = /** @class */ (function (_super) {
    Smite_extends(Smite, _super);
    function Smite() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Smite.prototype, "name", {
        get: function () {
            return "Smite";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Smite.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.OVERHEADS];
        },
        enumerable: false,
        configurable: true
    });
    Smite.prototype.levelRequirement = function () {
        return 100;
    };
    Smite.prototype.drainRate = function () {
        return 18;
    };
    Smite.prototype.isOverhead = function () {
        return false;
    };
    Smite.prototype.feature = function () {
        return "smite";
    };
    Smite.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    Smite.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return Smite;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/SteelSkin.ts

var SteelSkin_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var SteelSkin = /** @class */ (function (_super) {
    SteelSkin_extends(SteelSkin, _super);
    function SteelSkin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SteelSkin.prototype, "name", {
        get: function () {
            return "Steel Skin";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SteelSkin.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    SteelSkin.prototype.levelRequirement = function () {
        return 28;
    };
    SteelSkin.prototype.drainRate = function () {
        return 12;
    };
    SteelSkin.prototype.isOverhead = function () {
        return false;
    };
    SteelSkin.prototype.feature = function () {
        return "defensive";
    };
    SteelSkin.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    SteelSkin.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return SteelSkin;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/SuperhumanStrength.ts

var SuperhumanStrength_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var SuperhumanStrength = /** @class */ (function (_super) {
    SuperhumanStrength_extends(SuperhumanStrength, _super);
    function SuperhumanStrength() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SuperhumanStrength.prototype, "name", {
        get: function () {
            return "Superhuman Strength";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperhumanStrength.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    SuperhumanStrength.prototype.levelRequirement = function () {
        return 13;
    };
    SuperhumanStrength.prototype.drainRate = function () {
        return 6;
    };
    SuperhumanStrength.prototype.isOverhead = function () {
        return false;
    };
    SuperhumanStrength.prototype.feature = function () {
        return "offensiveStrength";
    };
    SuperhumanStrength.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    SuperhumanStrength.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return SuperhumanStrength;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/ThickSkin.ts

var ThickSkin_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ThickSkin = /** @class */ (function (_super) {
    ThickSkin_extends(ThickSkin, _super);
    function ThickSkin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ThickSkin.prototype, "name", {
        get: function () {
            return "Thick Skin";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThickSkin.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.DEFENCE];
        },
        enumerable: false,
        configurable: true
    });
    ThickSkin.prototype.levelRequirement = function () {
        return 1;
    };
    ThickSkin.prototype.drainRate = function () {
        return 3;
    };
    ThickSkin.prototype.isOverhead = function () {
        return false;
    };
    ThickSkin.prototype.feature = function () {
        return "defensive";
    };
    ThickSkin.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    ThickSkin.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return ThickSkin;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/content/prayers/UltimateStrength.ts

var UltimateStrength_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var UltimateStrength = /** @class */ (function (_super) {
    UltimateStrength_extends(UltimateStrength, _super);
    function UltimateStrength() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(UltimateStrength.prototype, "name", {
        get: function () {
            return "Ultimate Strength";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UltimateStrength.prototype, "groups", {
        get: function () {
            return [BasePrayer/* PrayerGroups */.u.STRENGTH];
        },
        enumerable: false,
        configurable: true
    });
    UltimateStrength.prototype.levelRequirement = function () {
        return 31;
    };
    UltimateStrength.prototype.drainRate = function () {
        return 12;
    };
    UltimateStrength.prototype.isOverhead = function () {
        return false;
    };
    UltimateStrength.prototype.feature = function () {
        return "offensiveStrength";
    };
    UltimateStrength.prototype.playOnSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OnSound).play();
        }
    };
    UltimateStrength.prototype.playOffSound = function () {
        if (Settings/* Settings */.w.playsAudio) {
            // new Audio(OffSound).play();
        }
    };
    return UltimateStrength;
}(BasePrayer/* BasePrayer */.B));


;// CONCATENATED MODULE: ./src/assets/sounds/redemption_heal_2681.ogg
const redemption_heal_2681_namespaceObject = __webpack_require__.p + "05799b199fc83cccd25d.ogg";
;// CONCATENATED MODULE: ./src/sdk/PrayerController.ts

































var PrayerController = /** @class */ (function () {
    function PrayerController(player) {
        this.drainCounter = 0;
        this.prayers = [
            new ThickSkin(),
            new BurstOfStrength(),
            new ClarityOfThought(),
            new SharpEye(),
            new MysticWill(),
            new RockSkin(),
            new SuperhumanStrength(),
            new ImprovedReflexes(),
            new RapidRestore(),
            new RapidHeal(),
            new ProtectItem(),
            new HawkEye(),
            new MysticLore(),
            new SteelSkin(),
            new UltimateStrength(),
            new IncredibleReflexes(),
            new ProtectMage(),
            new ProtectRange(),
            new ProtectMelee(),
            new EagleEye(),
            new MysticMight(),
            new Retribution(),
            new Redemption(),
            new Smite(),
            new Preserve(),
            new Chivalry(),
            new Piety(),
            new Rigour(),
            new Augury(),
        ];
        this.player = player;
    }
    PrayerController.prototype.tick = function (player) {
        // "transfer" prayers from client to "server"
        this.prayers.forEach(function (prayer) { return prayer.tick(); });
        // calc prayer drain
        var prayerDrainThisTick = this.drainRate();
        this.drainCounter += prayerDrainThisTick;
        while (this.drainCounter > this.player.prayerDrainResistance) {
            this.player.currentStats.prayer--;
            this.drainCounter -= this.player.prayerDrainResistance;
        }
        // deactivate prayers when out of prayer
        if (this.player.currentStats.prayer <= 0) {
            this.deactivateAll(player);
        }
    };
    PrayerController.prototype.deactivateAll = function (player) {
        this.activePrayers().forEach(function (prayer) { return prayer.deactivate(); });
        this.player.currentStats.prayer = 0;
    };
    PrayerController.prototype.disableProtectionPrayersForTicks = function (ticks) {
        var _this = this;
        ["Protect from Magic", "Protect from Range", "Protect from Melee"].forEach(function (name) {
            _this.findPrayerByName(name).disableForTicks(ticks);
        });
    };
    PrayerController.prototype.checkRedemption = function (player) {
        if (this.isPrayerActiveByName("Redemption") &&
            this.player.currentStats.hitpoint > 0 &&
            this.player.currentStats.hitpoint <= Math.floor(this.player.stats.hitpoint / 10)) {
            this.deactivateAll(player);
            player.currentStats.hitpoint += Math.floor(player.stats.prayer / 4);
            if (Settings/* Settings */.w.playsAudio) {
                new Audio(redemption_heal_2681_namespaceObject).play();
            }
        }
    };
    PrayerController.prototype.drainRate = function () {
        return this.activePrayers().reduce(function (a, b) { return a + b.drainRate(); }, 0);
    };
    PrayerController.prototype.findPrayerByName = function (name) {
        return (0,lodash.find)(this.prayers, function (prayer) { return prayer.name === name; });
    };
    PrayerController.prototype.isPrayerActiveByName = function (name) {
        return (0,lodash.find)(this.activePrayers(), function (prayer) { return prayer.name === name; });
    };
    PrayerController.prototype.activePrayers = function () {
        return (0,lodash.filter)(this.prayers, function (prayer) { return prayer.isActive; });
    };
    PrayerController.prototype.matchFeature = function (feature) {
        return (0,lodash.find)(this.activePrayers(), function (prayer) { return prayer.feature() === feature; });
    };
    PrayerController.prototype.matchGroup = function (group) {
        return (0,lodash.find)(this.activePrayers(), function (prayer) { return prayer.groups.includes(group); });
    };
    PrayerController.prototype.overhead = function () {
        return (0,lodash.find)(this.activePrayers(), function (prayer) { return (0,lodash.intersection)(prayer.groups, [BasePrayer/* PrayerGroups */.u.OVERHEADS]).length; });
    };
    return PrayerController;
}());



/***/ }),

/***/ 7212:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   o: () => (/* binding */ Random)
/* harmony export */ });
var Random = /** @class */ (function () {
    function Random() {
    }
    Random.setRandom = function (fn) {
        Random.randomFn = fn;
    };
    Random.reset = function () {
        Random.memory = 0;
        Random.callCount = 0;
    };
    Random.get = function () {
        this.callCount++;
        return Random.randomFn();
    };
    Random.memory = 0;
    Random.callCount = 0;
    Random.randomFn = function () { return Math.random(); };
    return Random;
}());



/***/ }),

/***/ 427:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: () => (/* binding */ Renderable)
/* harmony export */ });
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var NIL_OFFSET = [{ x: 0, y: 0, z: 0 }];
var Renderable = /** @class */ (function () {
    function Renderable() {
        this._selected = false;
        this.cachedModel = null;
        this.animationChangeListener = null;
        // in case the animation is set before animationChangeListener is set
        this.queuedAnimationId = -1;
        /**
         * NPC-indicator style tile highlight (like RuneLite's NPC Indicators "tile" mode). When set, the
         * true tile is drawn in this colour while `Renderable.tileHighlightsEnabled` is on.
         */
        this.highlightColor = null;
    }
    /**
     * return the pitch angle of this renderable in radians, i.e. how up/down it is pointing
     * 0 is flat, increasing is up, decreasing is down
     */
    Renderable.prototype.getPerceivedPitch = function (tickPercent) {
        return 0;
    };
    /**
     * allow offsetting the components of a multi-model renderable
     */
    Renderable.prototype.getPerceivedOffsets = function (tickPercent) {
        return NIL_OFFSET;
    };
    Object.defineProperty(Renderable.prototype, "drawOutline", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "outlineRenderOrder", {
        // If null, render normally in the scene. Otherwise sets the renderOrder which can
        // draw it above over elements in the scene, and other lines with lower renderOrder.
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "drawTrueTile", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "shouldBlendAnimationWithPose", {
        /** Whether a currently playing action should compose with the pose now. */
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "trueTileRenderOrder", {
        // If null, use the default ground-overlay priority. Otherwise sets the renderOrder
        // above other ground overlays with lower render orders.
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "height", {
        get: function () {
            return this.size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "logicalHeight", {
        /**
         * Height above the actor origin used to anchor overhead UI in 3d.
         *
         * This is separate from height because gameplay also uses height for model
         * dimensions and projectile trajectories. Cache-backed actors can override
         * it with the logical/model height used by the game client.
         */
        get: function () {
            return this.height;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "clickboxHeight", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "clickboxRadius", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "colorHex", {
        get: function () {
            return parseInt(this.color.replace("#", ""), 16);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Renderable.prototype, "selectable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Renderable.prototype.visible = function (tickPercent) {
        return true;
    };
    Object.defineProperty(Renderable.prototype, "selected", {
        get: function () {
            return this._selected;
        },
        set: function (selected) {
            this._selected = selected;
        },
        enumerable: false,
        configurable: true
    });
    Renderable.prototype.drawUILayer = function (tickPercent, projector, context, scale) {
        // Override me
    };
    // draw in 2d mode
    Renderable.prototype.draw = function (tickPercent, context, offset, scale, drawUnderTile) {
        if (offset === void 0) { offset = { x: 0, y: 0 }; }
        if (scale === void 0) { scale = 20; }
        if (drawUnderTile === void 0) { drawUnderTile = true; }
        // Override me
    };
    /**
     * Return a new model for this renderable in 3d mode. it will be associated with the Renderable and destroyed when the renderable is
     * destroyed.
     */
    Renderable.prototype.create3dModel = function () {
        return null;
    };
    Renderable.prototype.get3dModel = function () {
        var _a;
        return (_a = this.cachedModel) !== null && _a !== void 0 ? _a : this.create3dModel();
    };
    Renderable.prototype.playAnimation = function (index, blend) {
        if (blend === void 0) { blend = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.animationChangeListener) {
                    return [2 /*return*/, this.animationChangeListener.animationChanged(index, blend)];
                }
                else {
                    this.queuedAnimationId = index;
                }
                return [2 /*return*/];
            });
        });
    };
    /** Cache sequence behavior for an animation, when supplied by the active renderer. */
    Renderable.prototype.getAnimationMetadata = function (index) {
        var _a, _b;
        return (_b = (_a = this.animationChangeListener) === null || _a === void 0 ? void 0 : _a.getAnimationMetadata) === null || _b === void 0 ? void 0 : _b.call(_a, index);
    };
    /** Cache sequence behavior for the currently playing one-shot animation. */
    Renderable.prototype.getActiveAnimationMetadata = function () {
        var _a, _b;
        return (_b = (_a = this.animationChangeListener) === null || _a === void 0 ? void 0 : _a.getActiveAnimationMetadata) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    Renderable.prototype.setAnimationListener = function (listener) {
        this.animationChangeListener = listener;
        if (this.queuedAnimationId >= 0) {
            listener.animationChanged(this.queuedAnimationId, false);
            this.queuedAnimationId = -1;
        }
    };
    Renderable.prototype.notifySpotAnimChanged = function (spotAnims) {
        var _a, _b;
        (_b = (_a = this.animationChangeListener) === null || _a === void 0 ? void 0 : _a.spotAnimChanged) === null || _b === void 0 ? void 0 : _b.call(_a, spotAnims);
    };
    Object.defineProperty(Renderable.prototype, "spotAnims", {
        /** Spotanims currently attached to this renderable. */
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Renderable.prototype.clearAnimationListener = function () {
        this.animationChangeListener = null;
    };
    Renderable.prototype.invalidateModel = function () {
        this.cachedModel = null;
        if (this.animationChangeListener) {
            this.animationChangeListener.modelChanged();
        }
    };
    Renderable.prototype.preload = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Create an offscreen version of the model so that loading it is faster next time.
                        this.cachedModel = this.create3dModel();
                        if (!this.cachedModel) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.cachedModel.preload()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Renderable.tileHighlightsEnabled = true;
    return Renderable;
}());



/***/ }),

/***/ 7036:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ ReplayLog)
/* harmony export */ });

var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var ReplayLog = /** @class */ (function () {
    function ReplayLog() {
    }
    ReplayLog.setRecorder = function (recorder) {
        ReplayLog.recorder = recorder;
    };
    /** An input applied by the queue flush at the start of the tick currently being processed. */
    ReplayLog.recordQueued = function (action) {
        var _a;
        if (action)
            (_a = ReplayLog.recorder) === null || _a === void 0 ? void 0 : _a.call(ReplayLog, action, "thisTick");
    };
    /** An input that changed state between ticks; it takes effect from the next tick. */
    ReplayLog.recordImmediate = function (action) {
        var _a;
        (_a = ReplayLog.recorder) === null || _a === void 0 ? void 0 : _a.call(ReplayLog, action, "nextTick");
    };
    ReplayLog.registerCustom = function (name, handler) {
        ReplayLog.customHandlers[name] = handler;
    };
    /** Index of a mob in the order a replay will see it at the same point in the same tick. */
    ReplayLog.mobIndex = function (mob) {
        return __spreadArray(__spreadArray([], mob.region.mobs, true), mob.region.newMobs, true).indexOf(mob);
    };
    ReplayLog.recorder = null;
    ReplayLog.customHandlers = {};
    return ReplayLog;
}());



/***/ }),

/***/ 8350:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: () => (/* binding */ SetEffectTypes),
/* harmony export */   u: () => (/* binding */ SetEffect)
/* harmony export */ });
var SetEffectTypes;
(function (SetEffectTypes) {
    SetEffectTypes["JUSTICIAR"] = "JUSTICIAR";
})(SetEffectTypes || (SetEffectTypes = {}));
var SetEffect = /** @class */ (function () {
    function SetEffect() {
    }
    SetEffect.effectName = function () {
        return "";
    };
    SetEffect.itemsInSet = function () {
        return [];
    };
    return SetEffect;
}());



/***/ }),

/***/ 8406:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   o: () => (/* binding */ SETTINGS_STORAGE_KEY),
/* harmony export */   w: () => (/* binding */ Settings)
/* harmony export */ });
/* harmony import */ var _PlayerStats__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2455);
/* harmony import */ var _SettingsStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1609);

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var WASD = ["w", "a", "s", "d"];
var SETTINGS_STORAGE_KEY = "osrs-sdk:settings";
var Settings = /** @class */ (function () {
    function Settings() {
    }
    Object.defineProperty(Settings, "tileSize", {
        get: function () {
            return Settings._tileSize * Settings.zoomScale;
        },
        enumerable: false,
        configurable: true
    });
    Settings.subscribe = function (listener) {
        return settingsStore.subscribe(listener);
    };
    Settings.getSnapshot = function () {
        return settingsStore.getSnapshot();
    };
    Settings.set = function (patch) {
        Settings.applyState(__assign(__assign({}, Settings.toState()), patch));
        Settings.persistToStorage();
        return Settings.getSnapshot();
    };
    Settings.notifyChanged = function () {
        settingsStore.replace(Settings.toState(), false);
    };
    Settings.setMenuVisible = function (visible) {
        Settings.menuVisible = visible;
        Settings.notifyChanged();
    };
    Settings.checkWasd = function () {
        var result = WASD.includes(Settings.inventory_key) ||
            WASD.includes(Settings.equipment_key) ||
            WASD.includes(Settings.combat_key) ||
            WASD.includes(Settings.prayer_key);
        Settings.isUsingWasdKeybind = result;
        return result;
    };
    Settings.mobileCheck = function () {
        if (Settings._isMobileResult !== null)
            return Settings._isMobileResult;
        Settings._isMobileResult = /Mobi/.test(navigator.userAgent);
        return Settings._isMobileResult;
    };
    Settings.persistToStorage = function () {
        Settings.checkWasd();
        settingsStore.replace(Settings.toState());
    };
    /** Retained for source compatibility with trainers that read ad-hoc keys. */
    Settings.read = function (key, defaultValue) {
        var val = window.localStorage.getItem(key);
        return val === null ? defaultValue : val;
    };
    Settings.readFromStorage = function () {
        Settings.minimapScale = Settings.mobileCheck() ? 0.65 : 1;
        Settings.controlPanelScale = Settings.mobileCheck() ? 0.9 : 1.5;
        Settings.applyState(settingsStore.load());
        if (Settings.mobileCheck()) {
            Settings.playsAudio = false;
            Settings.playsAreaAudio = false;
        }
        if (Settings.use3dView)
            Settings.rotated = "north";
        Settings.checkWasd();
        Settings.notifyChanged();
    };
    Settings.applyState = function (state) {
        Object.assign(Settings, state);
    };
    Settings.toState = function () {
        return {
            antiDrag: Settings.antiDrag,
            chunkDebug: Settings.chunkDebug,
            tileCollisionDebug: Settings.tileCollisionDebug,
            relaxCameraPitch: Settings.relaxCameraPitch,
            combat_key: Settings.combat_key,
            displayFeedback: Settings.displayFeedback,
            displayBossHealthBar: Settings.displayBossHealthBar,
            displayClickboxes: Settings.displayClickboxes,
            displayMobLoS: Settings.displayMobLoS,
            displayPlayerLoS: Settings.displayPlayerLoS,
            displayXpDrops: Settings.displayXpDrops,
            equipment_key: Settings.equipment_key,
            fixedMode: Settings.fixedMode,
            entityIndicatorColor: Settings.entityIndicatorColor,
            entityIndicatorEnabled: Settings.entityIndicatorEnabled,
            inputDelay: Settings.inputDelay,
            inventory_key: Settings.inventory_key,
            loadout: Settings.loadout,
            customLoadout: Settings.customLoadout,
            lockPOV: Settings.lockPOV,
            maxUiScale: Settings.maxUiScale,
            menuVisible: Settings.menuVisible,
            metronome: Settings.metronome,
            northPillar: Settings.northPillar,
            onTask: Settings.onTask,
            player_stats: Settings.player_stats,
            playsAreaAudio: Settings.playsAreaAudio,
            playsAudio: Settings.playsAudio,
            prayer_key: Settings.prayer_key,
            renderFps: Settings.renderFps,
            rotated: Settings.rotated,
            smoothCacheAnimations: Settings.smoothCacheAnimations,
            southPillar: Settings.southPillar,
            spellbook_key: Settings.spellbook_key,
            tile_markers: Settings.tile_markers,
            tileMarkerColor: Settings.tileMarkerColor,
            targetTileColor: Settings.targetTileColor,
            targetTileEnabled: Settings.targetTileEnabled,
            trueTileColor: Settings.trueTileColor,
            trueTileEnabled: Settings.trueTileEnabled,
            hoveredTileColor: Settings.hoveredTileColor,
            hoveredTileEnabled: Settings.hoveredTileEnabled,
            hideDeadNpcs: Settings.hideDeadNpcs,
            use3dView: Settings.use3dView,
            westPillar: Settings.westPillar,
            zoomScale: Settings.zoomScale,
        };
    };
    Settings.zoomScale = 1;
    Settings.tickMs = 600;
    Settings.renderFps = 60;
    Settings.smoothCacheAnimations = true;
    Settings.inputDelay = 0;
    Settings.displayBossHealthBar = true;
    Settings.displayClickboxes = false;
    Settings.chunkDebug = false;
    Settings.tileCollisionDebug = false;
    Settings.fixedMode = true;
    Settings.hideDeadNpcs = false;
    Settings.is_keybinding = false;
    Settings.southPillar = true;
    Settings.westPillar = true;
    Settings.northPillar = true;
    Settings.displayPlayerLoS = false;
    Settings.displayMobLoS = false;
    Settings.showPredictedHit = true;
    Settings._isMobileResult = null;
    Settings.use3dView = true;
    Settings.isUsingWasdKeybind = Settings.checkWasd();
    return Settings;
}());

function createDefaults() {
    var mobile = Settings.mobileCheck();
    return {
        antiDrag: 5,
        chunkDebug: false,
        tileCollisionDebug: false,
        relaxCameraPitch: false,
        combat_key: "F5",
        displayFeedback: true,
        displayBossHealthBar: true,
        displayClickboxes: false,
        displayMobLoS: false,
        displayPlayerLoS: false,
        displayXpDrops: true,
        equipment_key: "F1",
        fixedMode: true,
        entityIndicatorColor: "#FFFFFF",
        entityIndicatorEnabled: true,
        inputDelay: 0,
        inventory_key: "F4",
        loadout: "max_tbow_speed",
        customLoadout: null,
        lockPOV: false,
        maxUiScale: 1,
        menuVisible: !mobile,
        metronome: false,
        northPillar: true,
        onTask: false,
        player_stats: (0,_PlayerStats__WEBPACK_IMPORTED_MODULE_1__/* .DeserializePlayerStats */ .Q)(null),
        playsAreaAudio: false,
        playsAudio: false,
        prayer_key: "F3",
        renderFps: 60,
        rotated: "south",
        smoothCacheAnimations: true,
        southPillar: true,
        spellbook_key: "F2",
        tile_markers: null,
        tileMarkerColor: "#FF0000",
        targetTileColor: "#FFFFFF",
        targetTileEnabled: false,
        trueTileColor: "#00FFFF",
        trueTileEnabled: true,
        hoveredTileColor: "#E2D723",
        hoveredTileEnabled: true,
        hideDeadNpcs: false,
        use3dView: true,
        westPillar: true,
        zoomScale: 1,
    };
}
// Legacy code. Should be removed in a few months - lets say after december 2026
function legacyBoolean(key, defaultValue) {
    var value = window.localStorage.getItem(key);
    return value === null ? defaultValue : value === "true";
}
var legacyStorage = {
    load: function (defaults) {
        var _a, _b;
        var menuVisible = window.localStorage.getItem("menuVisible");
        return {
            antiDrag: parseInt((_a = window.localStorage.getItem("antiDrag")) !== null && _a !== void 0 ? _a : "5"),
            chunkDebug: defaults.chunkDebug,
            tileCollisionDebug: defaults.tileCollisionDebug,
            relaxCameraPitch: defaults.relaxCameraPitch,
            combat_key: window.localStorage.getItem("combat_key") || defaults.combat_key,
            displayFeedback: window.localStorage.getItem("displayFeedback") !== "false",
            displayBossHealthBar: defaults.displayBossHealthBar,
            displayClickboxes: defaults.displayClickboxes,
            displayMobLoS: legacyBoolean("displayMobLoS", false),
            displayPlayerLoS: legacyBoolean("displayPlayerLoS", false),
            displayXpDrops: window.localStorage.getItem("displayXpDrops") !== "false",
            equipment_key: window.localStorage.getItem("equipment_key") || defaults.equipment_key,
            fixedMode: defaults.fixedMode,
            entityIndicatorColor: defaults.entityIndicatorColor,
            entityIndicatorEnabled: defaults.entityIndicatorEnabled,
            inputDelay: parseInt((_b = window.localStorage.getItem("inputDelay")) !== null && _b !== void 0 ? _b : "0"),
            inventory_key: window.localStorage.getItem("inventory_key") || defaults.inventory_key,
            loadout: window.localStorage.getItem("loadout") || defaults.loadout,
            customLoadout: defaults.customLoadout,
            lockPOV: false,
            maxUiScale: parseFloat(window.localStorage.getItem("maxUiScale")) || 1,
            menuVisible: menuVisible === "true" ? true : menuVisible === "false" ? false : defaults.menuVisible,
            metronome: legacyBoolean("metronome", false),
            northPillar: window.localStorage.getItem("northPillar") !== "false",
            onTask: legacyBoolean("onTask", false),
            player_stats: (0,_PlayerStats__WEBPACK_IMPORTED_MODULE_1__/* .DeserializePlayerStats */ .Q)(window.localStorage.getItem("stats")),
            playsAreaAudio: legacyBoolean("playsAreaAudio", false),
            playsAudio: legacyBoolean("playsAudio", false),
            prayer_key: window.localStorage.getItem("prayer_key") || defaults.prayer_key,
            renderFps: parseInt(window.localStorage.getItem("renderFps") || "60", 10) || 60,
            rotated: window.localStorage.getItem("rotated") || defaults.rotated,
            smoothCacheAnimations: window.localStorage.getItem("smoothCacheAnimations") !== "false",
            southPillar: window.localStorage.getItem("southPillar") !== "false",
            spellbook_key: window.localStorage.getItem("spellbook_key") || defaults.spellbook_key,
            tile_markers: JSON.parse(window.localStorage.getItem("tile_markers")),
            tileMarkerColor: window.localStorage.getItem("tileMarkerColor") || defaults.tileMarkerColor,
            targetTileColor: defaults.targetTileColor,
            targetTileEnabled: defaults.targetTileEnabled,
            trueTileColor: defaults.trueTileColor,
            trueTileEnabled: defaults.trueTileEnabled,
            hoveredTileColor: defaults.hoveredTileColor,
            hoveredTileEnabled: defaults.hoveredTileEnabled,
            hideDeadNpcs: defaults.hideDeadNpcs,
            use3dView: window.localStorage.getItem("use3dView") !== "false",
            westPillar: window.localStorage.getItem("westPillar") !== "false",
            zoomScale: parseFloat(window.localStorage.getItem("zoomScale")) || 1,
        };
    },
    save: function () {
        // Legacy keys are read once and deliberately left untouched.
    },
};
var jsonStorage = (0,_SettingsStore__WEBPACK_IMPORTED_MODULE_0__/* .createJsonSettingsStorage */ .HC)(SETTINGS_STORAGE_KEY, 1);
var migratingStorage = {
    load: function (defaults) {
        if (window.localStorage.getItem(SETTINGS_STORAGE_KEY) !== null) {
            return jsonStorage.load(defaults);
        }
        var migrated = legacyStorage.load(defaults);
        jsonStorage.save(migrated);
        return migrated;
    },
    save: function (settings) {
        jsonStorage.save(settings);
    },
};
var settingsStore = (0,_SettingsStore__WEBPACK_IMPORTED_MODULE_0__/* .createSettingsStore */ .JG)({
    defaults: createDefaults,
    storage: migratingStorage,
});


/***/ }),

/***/ 1609:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HC: () => (/* binding */ createJsonSettingsStorage),
/* harmony export */   JG: () => (/* binding */ createSettingsStore),
/* harmony export */   rV: () => (/* binding */ SettingsStore)
/* harmony export */ });
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var SettingsStore = /** @class */ (function () {
    function SettingsStore(options) {
        var _this = this;
        var _a;
        this.listeners = new Set();
        this.getSnapshot = function () { return _this.snapshot; };
        this.subscribe = function (listener) {
            _this.listeners.add(listener);
            return function () {
                _this.listeners.delete(listener);
            };
        };
        this.defaults = options.defaults;
        this.storage = (_a = options.storage) !== null && _a !== void 0 ? _a : (options.storageKey
            ? createJsonSettingsStorage(options.storageKey, options.version, options.migrate)
            : undefined);
        this.snapshot = this.freeze(this.createDefaults());
    }
    SettingsStore.prototype.load = function () {
        var _a, _b;
        var defaults = this.createDefaults();
        this.replace((_b = (_a = this.storage) === null || _a === void 0 ? void 0 : _a.load(defaults)) !== null && _b !== void 0 ? _b : defaults, false);
        return this.snapshot;
    };
    SettingsStore.prototype.set = function (patch, persist) {
        if (persist === void 0) { persist = true; }
        this.replace(__assign(__assign({}, this.snapshot), patch), persist);
        return this.snapshot;
    };
    SettingsStore.prototype.update = function (updater, persist) {
        if (persist === void 0) { persist = true; }
        return this.set(updater(this.snapshot), persist);
    };
    SettingsStore.prototype.replace = function (settings, persist) {
        var _a;
        if (persist === void 0) { persist = true; }
        // Settings objects outlive individual SDK releases in localStorage and
        // callers can also replace a store with a partial runtime object. Keep
        // every snapshot schema-complete so controlled React inputs never receive
        // undefined after having rendered a default value.
        var defaults = this.createDefaults();
        var normalized = __assign(__assign({}, defaults), settings);
        Object.keys(normalized).forEach(function (key) {
            if (normalized[key] === undefined) {
                normalized[key] = defaults[key];
            }
        });
        this.snapshot = this.freeze(normalized);
        if (persist)
            (_a = this.storage) === null || _a === void 0 ? void 0 : _a.save(this.snapshot);
        this.listeners.forEach(function (listener) { return listener(); });
        return this.snapshot;
    };
    SettingsStore.prototype.reset = function () {
        return this.replace(this.createDefaults());
    };
    /**
     * Watches a selected part of the settings and invokes the listener only when
     * that value changes. This is intended for game-side reactions outside
     * React; dispose the returned subscription when its owning object is reset.
     */
    SettingsStore.prototype.watch = function (selector, listener, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var previous = selector(this.snapshot);
        if (options.runImmediately)
            listener(previous, previous);
        return this.subscribe(function () {
            var selected = selector(_this.snapshot);
            if (Object.is(selected, previous))
                return;
            var oldValue = previous;
            previous = selected;
            listener(selected, oldValue);
        });
    };
    SettingsStore.prototype.createDefaults = function () {
        var defaults = typeof this.defaults === "function"
            ? this.defaults()
            : this.defaults;
        return __assign({}, defaults);
    };
    SettingsStore.prototype.freeze = function (settings) {
        return Object.freeze(__assign({}, settings));
    };
    return SettingsStore;
}());

function createJsonSettingsStorage(storageKey, version, migrate) {
    if (version === void 0) { version = 1; }
    var warnCorruptedSettings = function (reason) {
        console.warn("[osrs-sdk] Ignoring corrupted settings in localStorage key \"".concat(storageKey, "\" and using defaults. The stored value has not been removed."), reason);
    };
    return {
        load: function (defaults) {
            var raw = window.localStorage.getItem(storageKey);
            if (!raw)
                return __assign({}, defaults);
            try {
                var parsed = JSON.parse(raw);
                var isEnvelope = parsed
                    && typeof parsed === "object"
                    && "values" in parsed
                    && "version" in parsed;
                var storedVersion = isEnvelope ? Number(parsed.version) : 0;
                var stored = isEnvelope ? parsed.values : parsed;
                var values = migrate ? migrate(stored, storedVersion) : stored;
                if (!values || typeof values !== "object" || Array.isArray(values)) {
                    warnCorruptedSettings("Expected the settings payload to be an object.");
                    return __assign({}, defaults);
                }
                return __assign(__assign({}, defaults), values);
            }
            catch (error) {
                warnCorruptedSettings(error);
                return __assign({}, defaults);
            }
        },
        save: function (settings) {
            window.localStorage.setItem(storageKey, JSON.stringify({ version: version, values: settings }));
        },
    };
}
function createSettingsStore(options) {
    return new SettingsStore(options);
}


/***/ }),

/***/ 6374:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: () => (/* binding */ Trainer)
/* harmony export */ });
/* harmony import */ var _utils_SoundCache__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6018);

// container for globals to prevent circular dependencies. Do NOT import Viewport into this class.
var Trainer = /** @class */ (function () {
    function Trainer() {
    }
    Trainer.setClickController = function (clickController) {
        this._clickController = clickController;
    };
    Trainer.setPlayer = function (player) {
        this._player = player;
        _utils_SoundCache__WEBPACK_IMPORTED_MODULE_0__/* .SoundCache */ .U.setAudioListener(player);
    };
    Object.defineProperty(Trainer, "player", {
        get: function () {
            return this._player;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Trainer, "clickController", {
        get: function () {
            return this._clickController;
        },
        enumerable: false,
        configurable: true
    });
    Trainer.reset = function () {
        Trainer._player.region.reset();
    };
    return Trainer;
}());



/***/ }),

/***/ 3016:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Nf: () => (/* binding */ Unit),
  v5: () => (/* binding */ UnitEquipment),
  eK: () => (/* binding */ UnitTypes)
});

;// CONCATENATED MODULE: ./src/assets/images/hitsplats/heal.png
const heal_namespaceObject = __webpack_require__.p + "6f66afbfcae5a9563001.png";
;// CONCATENATED MODULE: ./src/assets/images/hitsplats/miss.png
const miss_namespaceObject = __webpack_require__.p + "249d7e34a2a593820a90.png";
;// CONCATENATED MODULE: ./src/assets/images/hitsplats/damage.png
const damage_namespaceObject = __webpack_require__.p + "0def8eba418960c4c95c.png";
// EXTERNAL MODULE: ./src/sdk/LineOfSight.ts
var LineOfSight = __webpack_require__(8499);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(2543);
// EXTERNAL MODULE: ./src/sdk/Interpolation.ts
var Interpolation = __webpack_require__(8825);
// EXTERNAL MODULE: ./src/sdk/Pathing.ts
var Pathing = __webpack_require__(5454);
// EXTERNAL MODULE: ./src/sdk/utils/ImageLoader.ts
var ImageLoader = __webpack_require__(2987);
// EXTERNAL MODULE: ./src/sdk/Settings.ts
var Settings = __webpack_require__(8406);
// EXTERNAL MODULE: ./src/sdk/Collision.ts
var Collision = __webpack_require__(5843);
// EXTERNAL MODULE: ./src/sdk/Renderable.ts
var Renderable = __webpack_require__(427);
// EXTERNAL MODULE: ./src/sdk/utils/SoundCache.ts
var SoundCache = __webpack_require__(6018);
// EXTERNAL MODULE: ./src/sdk/DelayedAction.ts
var DelayedAction = __webpack_require__(8239);
// EXTERNAL MODULE: ./src/sdk/utils/Text.ts
var Text = __webpack_require__(3462);
// EXTERNAL MODULE: ./src/sdk/utils/Chunk.ts
var Chunk = __webpack_require__(5164);
;// CONCATENATED MODULE: ./src/sdk/Unit.ts
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};















/* eslint-disable @typescript-eslint/no-explicit-any */
var UnitTypes;
(function (UnitTypes) {
    UnitTypes[UnitTypes["MOB"] = 0] = "MOB";
    UnitTypes[UnitTypes["PLAYER"] = 1] = "PLAYER";
    UnitTypes[UnitTypes["ENTITY"] = 2] = "ENTITY";
})(UnitTypes || (UnitTypes = {}));
var UnitEquipment = /** @class */ (function () {
    function UnitEquipment() {
        this.weapon = null;
        this.offhand = null;
        this.helmet = null;
        this.necklace = null;
        this.chest = null;
        this.legs = null;
        this.feet = null;
        this.gloves = null;
        this.ring = null;
        this.cape = null;
        this.ammo = null;
    }
    return UnitEquipment;
}());

var Unit = /** @class */ (function (_super) {
    __extends(Unit, _super);
    function Unit(region, location, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this) || this;
        _this.unitTargetRotation = 0;
        _this.unitRotation = 0;
        _this.unitRotationFrom = 0;
        _this.unitRotationTimestamp = 0;
        _this.unitRotationDirection = 1;
        _this.renderFromLocation = { x: 0, y: 0 };
        _this.renderPositionTimestamp = 0;
        _this.visualMovementActive = false;
        _this.visualPathLengthAtAnimationStart = 0;
        _this.delayedMovementTicks = 0;
        _this.cacheRenderSpotAnims = [];
        // TODO: Match the real client's maximum actor path queue length.
        _this.visualPath = [];
        _this.attackDelay = 0;
        _this.lastHitAgo = Number.MAX_SAFE_INTEGER;
        _this.hasLOS = false;
        _this.frozen = 0;
        _this.stunned = 0;
        _this.incomingProjectiles = [];
        _this.healHitsplatImage = ImageLoader/* ImageLoader */.$.createImage(heal_namespaceObject);
        _this.missedHitsplatImage = ImageLoader/* ImageLoader */.$.createImage(miss_namespaceObject);
        _this.damageHitsplatImage = ImageLoader/* ImageLoader */.$.createImage(damage_namespaceObject);
        _this.unitImage = ImageLoader/* ImageLoader */.$.createImage(_this.image);
        _this.equipment = new UnitEquipment();
        _this.setEffects = [];
        _this.autoRetaliate = false;
        _this.age = 0;
        _this.lastRotation = 0;
        _this.hasDiedAndAwaitingRemoval = false;
        _this.deathAnimationFinished = false;
        _this.nulledTicks = 0;
        _this.forceMaxDamageRollsOnNextIncomingAttack = false;
        _this.maxIncomingDamageRollsConsumptionQueued = false;
        /** Monotonically increasing sequence assigned when this unit enters a chunk. */
        _this.chunkOrder = -1;
        _this.overheadText = null;
        _this.overheadTextTimer = 0;
        _this.dying = -1;
        _this.region = region;
        _this.aggro = options.aggro || null;
        _this.perceivedLocation = __assign({}, location);
        _this.location = __assign({}, location);
        _this.chunkPosition = Chunk/* ChunkUtils */.N.fromLocation(location);
        _this.renderFromLocation = __assign({}, location);
        _this.renderPositionTimestamp = window.performance.now();
        _this.setStats();
        _this.age = options.spawnDelay || 0;
        _this.autoRetaliate = true;
        _this.currentStats.hitpoint = _this.stats.hitpoint;
        if (options.cooldown) {
            _this.attackDelay = options.cooldown;
        }
        return _this;
    }
    Object.defineProperty(Unit.prototype, "spotAnims", {
        /** Snapshot of the spotanims currently attached to this unit. */
        get: function () {
            return this.cacheRenderSpotAnims.slice();
        },
        enumerable: false,
        configurable: true
    });
    /** Attach or replace a temporary cache-derived graphic without rebuilding the base model. */
    Unit.prototype.addSpotAnim = function (spotAnim) {
        var _a;
        var channel = (_a = spotAnim.channel) !== null && _a !== void 0 ? _a : String(spotAnim.id);
        this.cacheRenderSpotAnims = this.cacheRenderSpotAnims.filter(function (existing) { var _a; return ((_a = existing.channel) !== null && _a !== void 0 ? _a : String(existing.id)) !== channel; });
        this.cacheRenderSpotAnims.push(__assign({}, spotAnim));
        this.notifySpotAnimChanged(this.cacheRenderSpotAnims);
    };
    /** Remove the temporary cache-derived graphic currently occupying a channel. */
    Unit.prototype.clearSpotAnim = function (channel) {
        var next = this.cacheRenderSpotAnims.filter(function (existing) { var _a; return ((_a = existing.channel) !== null && _a !== void 0 ? _a : String(existing.id)) !== channel; });
        if (next.length === this.cacheRenderSpotAnims.length)
            return;
        this.cacheRenderSpotAnims = next;
        this.notifySpotAnimChanged(this.cacheRenderSpotAnims);
    };
    Object.defineProperty(Unit.prototype, "deathAnimationLength", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "completeSetEffects", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "type", {
        get: function () {
            return UnitTypes.MOB;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "isPlayer", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "drawTrueTile", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "xpBonusMultiplier", {
        get: function () {
            return 1.0;
        },
        enumerable: false,
        configurable: true
    });
    Unit.prototype.mobName = function () {
        return null;
    };
    Object.defineProperty(Unit.prototype, "isNulled", {
        get: function () {
            return this.nulledTicks > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "combatLevel", {
        get: function () {
            var base = 0.25 * (this.stats.defence + this.stats.hitpoint + Math.floor((this.stats.prayer || 0) * 0.5));
            var melee = (13 / 40) * (this.stats.attack + this.stats.strength);
            var range = (13 / 40) * Math.floor(this.stats.range * (3 / 2));
            var mage = (13 / 40) * Math.floor(this.stats.magic * (3 / 2));
            return Math.floor(base + Math.max(melee, range, mage));
        },
        enumerable: false,
        configurable: true
    });
    Unit.prototype.combatLevelColor = function (against) {
        // https://oldschool.runescape.wiki/w/Combat_level#Colours
        var colorScale = [
            "#ff0000",
            "#ff3000",
            "#ff3000",
            "#ff3000",
            "#ff7000",
            "#ff7000",
            "#ff7000",
            "#ffb000",
            "#ffb000",
            "#ffb000",
            "#ffff00",
            "#c0ff00",
            "#c0ff00",
            "#c0ff00",
            "#80ff00",
            "#80ff00",
            "#80ff00",
            "#40ff00",
            "#40ff00",
            "#40ff00",
            "#00ff00", // -10
        ];
        var myCombatLevel = this.combatLevel;
        var theirCombatLevel = against.combatLevel;
        var difference = Math.min(10, Math.max(-10, theirCombatLevel - myCombatLevel));
        return colorScale[10 - difference];
    };
    Unit.prototype.contextActions = function (region, x, y) {
        return [];
    };
    Unit.prototype.setAggro = function (mob) {
        this.aggro = mob;
    };
    /** Modifies an attack roll made against this unit. Targets with permanent
     * weaknesses can override this; transient effects use the built-in flag. */
    Unit.prototype.incomingAttackRollModifiers = function (_attack) {
        if (!this.forceMaxDamageRollsOnNextIncomingAttack)
            return {};
        return { guaranteedHit: true, maxDamage: true, consumeAfterDamage: true };
    };
    Unit.prototype.grantMaxDamageRollsOnNextIncomingAttack = function () {
        this.forceMaxDamageRollsOnNextIncomingAttack = true;
    };
    Unit.prototype.consumeMaxDamageRollsOnNextIncomingAttack = function () {
        var _this = this;
        if (this.maxIncomingDamageRollsConsumptionQueued) {
            return;
        }
        this.maxIncomingDamageRollsConsumptionQueued = true;
        DelayedAction/* DelayedAction */.T.registerDelayedAction(new DelayedAction/* DelayedAction */.T(function () {
            _this.forceMaxDamageRollsOnNextIncomingAttack = false;
            _this.maxIncomingDamageRollsConsumptionQueued = false;
        }, 0));
    };
    Unit.prototype.grantXp = function (xpDrop) {
        // Override me
    };
    Unit.prototype.setStats = function () {
        // Override me
    };
    Unit.prototype.timerStep = function () {
        this.attackDelay--;
        this.frozen--;
        this.stunned--;
    };
    /** Resolve damage due on this turn. */
    Unit.prototype.queueStep = function () {
        if (this.dying === 0)
            return;
        this.processIncomingAttacks();
    };
    Unit.prototype.movementStep = function () {
        // Override me
    };
    /** Advance and consume the next step in this unit's client-side visual path. */
    Unit.prototype.advanceVisualPath = function (baseMovementSpeed, movementSpeed, tickTimestamp) {
        var _a;
        if (movementSpeed === void 0) { movementSpeed = baseMovementSpeed; }
        if (tickTimestamp === void 0) { tickTimestamp = window.performance.now(); }
        if (this.visualPath.length === 0) {
            this.delayedMovementTicks = 0;
            return null;
        }
        var animation = this.getActiveAnimationMetadata();
        var movementPrecedence = this.visualPathLengthAtAnimationStart > 0
            ? animation === null || animation === void 0 ? void 0 : animation.precedenceAnimating
            : animation === null || animation === void 0 ? void 0 : animation.priority;
        if (movementPrecedence === 0) {
            this.delayedMovementTicks++;
            return null;
        }
        var recoveringDelayedMovement = this.delayedMovementTicks > 0 && this.visualPath.length > 1;
        var interpolation = Interpolation/* Interpolation */.l.resolvePath(this.perceivedLocation, this.visualPath, baseMovementSpeed, movementSpeed, recoveringDelayedMovement ? baseMovementSpeed * 2 : undefined);
        if (recoveringDelayedMovement)
            this.delayedMovementTicks--;
        this.renderFromLocation = __assign({}, this.perceivedLocation);
        this.perceivedLocation = interpolation.location;
        this.renderPositionTimestamp = tickTimestamp;
        return interpolation.reachedStep ? (_a = this.visualPath.shift()) !== null && _a !== void 0 ? _a : null : null;
    };
    Unit.prototype.playAnimation = function (index, blend) {
        if (blend === void 0) { blend = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.visualPathLengthAtAnimationStart = this.visualPath.length;
                return [2 /*return*/, _super.prototype.playAnimation.call(this, index, blend)];
            });
        });
    };
    Unit.prototype.attackStep = function () {
        // Override me, called after all movement has been resolved
        this.nulledTicks--;
        this.lastRotation = this.getPerceivedRotation(0);
        if (this.overheadTextTimer <= 0) {
            this.overheadText = null;
        }
        this.overheadTextTimer--;
    };
    // called when the unit has attacked
    Unit.prototype.didAttack = function (attackAnimationId) {
        this.attackDelay = this.attackSpeed;
        this.playAttackAnimation(attackAnimationId);
    };
    Unit.prototype.playAttackAnimation = function (attackAnimationId) {
        if (attackAnimationId === void 0) { attackAnimationId = this.attackAnimationId; }
        if (attackAnimationId) {
            // Pass whether this action supports pose composition. Whether the actor
            // is moving is evaluated dynamically while the action is playing.
            this.playAnimation(attackAnimationId, this.canBlendAttackAnimation);
        }
    };
    Object.defineProperty(Unit.prototype, "shouldBlendAnimationWithPose", {
        /** Whether the current pose should be composed beneath an attack sequence. */
        get: function () {
            return this.animationIndex !== this.idlePoseId;
        },
        enumerable: false,
        configurable: true
    });
    Unit.prototype.getPerceivedLocation = function (_tickPercent) {
        var alpha = Math.min(1, Math.max(0, (window.performance.now() - this.renderPositionTimestamp) / 20));
        return {
            x: this.renderFromLocation.x + (this.perceivedLocation.x - this.renderFromLocation.x) * alpha,
            y: this.renderFromLocation.y + (this.perceivedLocation.y - this.renderFromLocation.y) * alpha,
            z: 0,
        };
    };
    Unit.prototype.getTargetRotation = function (tickPercent) {
        if (this.aggro) {
            var perceivedLocation = this.getPerceivedLocation(tickPercent);
            var targetLocation = this.aggro.getPerceivedLocation(tickPercent);
            return -Pathing/* Pathing */.G.angle(perceivedLocation.x + this.size / 2, perceivedLocation.y - this.size / 2, targetLocation.x + this.aggro.size / 2, targetLocation.y - this.aggro.size / 2);
        }
        return this.lastRotation;
    };
    // Client ticks run at 50 Hz, matching the player's 64-JAU turn rate.
    Unit.prototype.clientTick = function (tickPercent, tickTimestamp) {
        if (tickTimestamp === void 0) { tickTimestamp = window.performance.now(); }
        if (this.visualPath.length > 0) {
            var baseMovementSpeed = 1 / (Settings/* Settings */.w.tickMs / 20);
            this.advanceVisualPath(baseMovementSpeed, baseMovementSpeed, tickTimestamp);
        }
        this.unitTargetRotation = this.getTargetRotation(tickPercent);
        this.unitRotationFrom = this.unitRotation;
        this.unitRotationTimestamp = tickTimestamp;
        var rotationDelta = ((this.unitTargetRotation - this.unitRotation + Math.PI * 3) % (Math.PI * 2)) - Math.PI;
        if (Math.abs(Math.abs(rotationDelta) - Math.PI) < 1e-6)
            rotationDelta = this.unitRotationDirection * Math.PI;
        else if (Math.abs(rotationDelta) > 1e-6)
            this.unitRotationDirection = Math.sign(rotationDelta);
        var rotationPerClientTick = 64 / 512;
        if (Math.abs(rotationDelta) <= rotationPerClientTick)
            this.unitRotation = this.unitTargetRotation;
        else
            this.unitRotation += Math.sign(rotationDelta) * rotationPerClientTick;
    };
    Unit.prototype.getPerceivedRotation = function (_tickPercent) {
        var alpha = Math.min(1, Math.max(0, (window.performance.now() - this.unitRotationTimestamp) / 20));
        var rotationDelta = ((this.unitRotation - this.unitRotationFrom + Math.PI * 3) % (Math.PI * 2)) - Math.PI;
        return this.unitRotationFrom + rotationDelta * alpha;
    };
    Unit.prototype.setRotationImmediate = function (rotation) {
        this.unitRotationTimestamp = window.performance.now();
        this.unitRotation = rotation;
        this.unitTargetRotation = rotation;
        this.unitRotationFrom = rotation;
        this.lastRotation = rotation;
    };
    Unit.prototype.addedToWorld = function () {
        // override me
    };
    Unit.prototype.getTrueLocation = function () {
        return this.location;
    };
    Unit.prototype.removedFromWorld = function () {
        // Override me
    };
    Unit.mergeEquipmentBonuses = function (firstBonuses, secondBonuses) {
        return {
            attack: {
                stab: firstBonuses.attack.stab + secondBonuses.attack.stab,
                slash: firstBonuses.attack.slash + secondBonuses.attack.slash,
                crush: firstBonuses.attack.crush + secondBonuses.attack.crush,
                magic: firstBonuses.attack.magic + secondBonuses.attack.magic,
                range: firstBonuses.attack.range + secondBonuses.attack.range,
            },
            defence: {
                stab: firstBonuses.defence.stab + secondBonuses.defence.stab,
                slash: firstBonuses.defence.slash + secondBonuses.defence.slash,
                crush: firstBonuses.defence.crush + secondBonuses.defence.crush,
                magic: firstBonuses.defence.magic + secondBonuses.defence.magic,
                range: firstBonuses.defence.range + secondBonuses.defence.range,
            },
            other: {
                meleeStrength: firstBonuses.other.meleeStrength + secondBonuses.other.meleeStrength,
                rangedStrength: firstBonuses.other.rangedStrength + secondBonuses.other.rangedStrength,
                magicDamage: firstBonuses.other.magicDamage + secondBonuses.other.magicDamage,
                prayer: firstBonuses.other.prayer + secondBonuses.other.prayer,
                crystalAccuracy: (firstBonuses.other.crystalAccuracy || 0) + (secondBonuses.other.crystalAccuracy || 0),
                crystalDamage: (firstBonuses.other.crystalDamage || 0) + (secondBonuses.other.crystalDamage || 0),
            },
            targetSpecific: {
                undead: firstBonuses.targetSpecific.undead + secondBonuses.targetSpecific.undead,
                slayer: firstBonuses.targetSpecific.slayer + secondBonuses.targetSpecific.slayer,
            },
        };
    };
    Unit.emptyBonuses = function () {
        return {
            attack: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            defence: {
                stab: 0,
                slash: 0,
                crush: 0,
                magic: 0,
                range: 0,
            },
            other: {
                meleeStrength: 0,
                rangedStrength: 0,
                magicDamage: 1,
                prayer: 0,
                crystalAccuracy: 1,
                crystalDamage: 1,
            },
            targetSpecific: {
                undead: 0,
                slayer: 0,
            },
        };
    };
    Object.defineProperty(Unit.prototype, "bonuses", {
        get: function () {
            return Unit.emptyBonuses();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "attackSpeed", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "flinchDelay", {
        get: function () {
            return Math.floor(this.attackSpeed / 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "attackRange", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "maxHit", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "image", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "isAnimated", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    // Returns true if the NPC can move towards the unit it is aggro'd against.
    Unit.prototype.canMove = function () {
        return this.currentStats.hitpoint > 0 && !this.hasLOS && !this.isFrozen() && !this.isStunned() && !this.isDying();
    };
    Unit.prototype.canAttack = function () {
        return this.currentStats.hitpoint > 0 && !this.isDying() && !this.isStunned();
    };
    Unit.prototype.freeze = function (ticks) {
        if (ticks < this.frozen) {
            return;
        }
        //this.perceivedLocation = this.location;
        this.frozen = ticks;
    };
    Unit.prototype.isFrozen = function () {
        return this.frozen > 0;
    };
    Unit.prototype.isStunned = function () {
        return this.stunned > 0;
    };
    Object.defineProperty(Unit.prototype, "serialNumber", {
        get: function () {
            if (!this._serialNumber) {
                this._serialNumber = String(Math.random());
            }
            return this._serialNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "size", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "consumesSpace", {
        /** Whether this unit participates in the region's dynamic tile collision flags. */
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Unit.prototype.isDying = function () {
        return this.dying > 0;
    };
    Object.defineProperty(Unit.prototype, "collisionType", {
        get: function () {
            return Collision/* CollisionType */.B.BLOCK_MOVEMENT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "lineOfSight", {
        get: function () {
            return LineOfSight/* LineOfSightMask */.Z.FULL_MASK;
        },
        enumerable: false,
        configurable: true
    });
    // Returns true if this game object is on the specified tile.
    Unit.prototype.isOnTile = function (x, y) {
        return (x >= this.location.x &&
            x <= this.location.x + this.size &&
            y <= this.location.y &&
            y >= this.location.y - this.size);
    };
    // Returns the closest tile on this mob to the specified point.
    Unit.prototype.getClosestTileTo = function (x, y) {
        // We simply clamp the target point to our own boundary box.
        return [
            (0,lodash.clamp)(x, this.location.x, this.location.x + this.size - 1),
            (0,lodash.clamp)(y, this.location.y - this.size + 1, this.location.y),
        ];
    };
    Object.defineProperty(Unit.prototype, "rangeAttackAnimation", {
        // TODO more modular
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    /** Sounds **/
    // sound to play when hit
    Unit.prototype.hitSound = function (damaged) {
        return null;
    };
    Object.defineProperty(Unit.prototype, "color", {
        get: function () {
            return "#FFFFFF00";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "healthScale", {
        get: function () {
            // the server usually only sends hitpoints as a fraction where this is the denominator.
            return Math.min(this.stats.hitpoint, 30);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "healthBarWidth", {
        /** Client-space hitbar width. This is independent of the unit's tile footprint. */
        get: function () {
            return 30;
        },
        enumerable: false,
        configurable: true
    });
    Unit.prototype.shouldDestroy = function () {
        // this is -1 for a living npc.
        return this.dying === 0;
    };
    Unit.prototype.shouldShowAttackAnimation = function () {
        return this.attackDelay === this.attackSpeed && this.dying === -1 && this.isStunned() === false;
    };
    Unit.prototype.setHasLOS = function () {
        if (!this.aggro) {
            this.hasLOS = false;
            return;
        }
        if (this.aggro.type === UnitTypes.PLAYER) {
            this.hasLOS = LineOfSight/* LineOfSight */.V.mobHasLineOfSightOfPlayer(this.region, this.aggro, this.location.x, this.location.y, this.size, this.attackRange, true);
        }
        else if (this.type === UnitTypes.PLAYER) {
            this.hasLOS = LineOfSight/* LineOfSight */.V.playerHasLineOfSightOfMob(this.region, this.location.x, this.location.y, this.aggro, this.attackRange);
        }
        else if (this.type === UnitTypes.MOB && this.aggro.type === UnitTypes.MOB) {
            this.hasLOS = LineOfSight/* LineOfSight */.V.mobHasLineOfSightToMob(this.region, this, this.aggro, this.attackRange);
        }
        else if (this.aggro.type === UnitTypes.MOB) {
            this.hasLOS = LineOfSight/* LineOfSight */.V.playerHasLineOfSightOfMob(this.region, this.location.x, this.location.y, this.aggro, this.attackRange);
        }
        else if (this.aggro.type === UnitTypes.ENTITY) {
            this.hasLOS = false;
        }
    };
    // Returns true if this mob is in melee range of its target.
    Unit.prototype.isWithinMeleeRange = function () {
        var targetX = this.aggro.location.x;
        var targetY = this.aggro.location.y;
        var isWithinMeleeRange = false;
        if (targetX === this.location.x - 1 &&
            targetY <= this.location.y + 1 &&
            targetY > this.location.y - this.size - 1) {
            isWithinMeleeRange = true;
        }
        else if (targetY === this.location.y + 1 && targetX >= this.location.x && targetX < this.location.x + this.size) {
            isWithinMeleeRange = true;
        }
        else if (targetX === this.location.x + this.size &&
            targetY <= this.location.y + 1 &&
            targetY > this.location.y - this.size - 1) {
            isWithinMeleeRange = true;
        }
        else if (targetY === this.location.y - this.size &&
            targetX >= this.location.x &&
            targetX < this.location.x + this.size) {
            isWithinMeleeRange = true;
        }
        return isWithinMeleeRange;
    };
    Unit.prototype.addProjectile = function (projectile) {
        if (this.age > 0 && this.autoRetaliate && !this.aggro) {
            this.setAggro(projectile.from);
        }
        this.incomingProjectiles.push(projectile);
        this.region.addProjectileGraphic(projectile.graphic);
    };
    Unit.prototype.setLocation = function (location) {
        var _a, _b;
        var updateCollisionFlags = ((_a = this.region) === null || _a === void 0 ? void 0 : _a.hasUnit(this)) && this.consumesSpace;
        if (updateCollisionFlags) {
            this.region.clearTileCollisionFlags(this.location.x, this.location.y, this.size);
        }
        this.location = __assign({}, location);
        this.perceivedLocation = __assign({}, location);
        this.renderFromLocation = __assign({}, location);
        this.renderPositionTimestamp = window.performance.now();
        this.visualPath = [];
        this.visualMovementActive = false;
        this.delayedMovementTicks = 0;
        (_b = this.region) === null || _b === void 0 ? void 0 : _b.refreshUnitChunk(this);
        if (updateCollisionFlags) {
            this.region.setTileCollisionFlags(this.location.x, this.location.y, this.size);
        }
    };
    Unit.prototype.attackAnimation = function (tickPercent, context) {
        // override pls
    };
    Unit.prototype.cancelDeath = function () {
        // e.g. when revived
        this.hasDiedAndAwaitingRemoval = false;
        this.deathAnimationFinished = false;
        this.dying = -1;
    };
    Unit.prototype.dead = function () {
        var _this = this;
        this.perceivedLocation = __assign({}, this.location);
        this.renderFromLocation = __assign({}, this.location);
        this.visualPath = [];
        this.visualMovementActive = false;
        this.delayedMovementTicks = 0;
        this.dying = this.deathAnimationLength;
        this.deathAnimationFinished = false;
        this.region.onUnitDeath(this);
        this.region.clearAggroFor(this);
        this.setAggro(null);
        this.hasDiedAndAwaitingRemoval = true;
        if (this.deathAnimationId) {
            DelayedAction/* DelayedAction */.T.registerDelayedAction(new DelayedAction/* DelayedAction */.T(function () {
                return _this.playAnimation(_this.deathAnimationId, false).then(function () {
                    if (_this.hasDiedAndAwaitingRemoval) {
                        // Animation completion is visual-only. The game-tick death
                        // countdown remains the sole authority for logical removal.
                        _this.deathAnimationFinished = true;
                    }
                });
            }, 1));
        }
    };
    Unit.prototype.detectDeath = function () {
        if (this.dying === -1 && this.currentStats.hitpoint <= 0) {
            this.dead();
            return;
        }
        if (this.dying > 0) {
            this.dying--;
        }
        if (this.dying === 0) {
            this.removedFromWorld();
        }
    };
    Unit.prototype.processIncomingAttacks = function () {
        var _this = this;
        this.lastHitAgo++;
        this.incomingProjectiles = (0,lodash.filter)(this.incomingProjectiles, function (projectile) { return !projectile.shouldDestroy(); });
        this.incomingProjectiles.forEach(function (projectile) {
            projectile.onTick();
            if (projectile.remainingDelay === 0) {
                // may override damage etc
                projectile.beforeHit();
                // Some attacks can be nullified if they land after the attackers death.
                if (projectile.options &&
                    projectile.options.cancelOnDeath === true &&
                    projectile.from &&
                    projectile.from.isDying() === true) {
                    return;
                }
                if (projectile.damage < 0) {
                    // subtracting a negative gives a positive
                    if (_this.currentStats.hitpoint < _this.stats.hitpoint) {
                        _this.currentStats.hitpoint -= projectile.damage;
                        _this.currentStats.hitpoint = Math.min(_this.currentStats.hitpoint, _this.stats.hitpoint);
                    }
                }
                else {
                    _this.currentStats.hitpoint -= projectile.damage;
                    var sound = _this.hitSound(projectile.damage > 0);
                    if (sound) {
                        SoundCache/* SoundCache */.U.play(sound);
                    }
                }
                if (projectile.damage > 0 && projectile.options.consumeTargetMaxDamageRoll) {
                    _this.consumeMaxDamageRollsOnNextIncomingAttack();
                }
                _this.damageTaken();
                _this.region.onIncomingHit(_this, projectile);
                _this.lastHitAgo = 0;
                if (_this.shouldChangeAggro(projectile)) {
                    _this.setAggro(projectile.from);
                    // Preserve the effective retaliation delay for player flinches.
                    var delay = _this.flinchDelay + (_this.type === UnitTypes.PLAYER ? 1 : 0);
                    _this.attackDelay = Math.max(_this.attackDelay, delay);
                }
            }
        });
        this.currentStats.hitpoint = Math.max(0, this.currentStats.hitpoint);
        this.postAttacksEvent();
    };
    Unit.prototype.shouldChangeAggro = function (projectile) {
        return !this.aggro && this.autoRetaliate;
    };
    Unit.prototype.postAttacksEvent = function () {
        // Override me
    };
    Unit.prototype.damageTaken = function () {
        // Override me
    };
    Unit.prototype.setOverheadText = function (text) {
        this.overheadText = text;
        this.overheadTextTimer = 8;
    };
    Unit.prototype.drawOverheadText = function (context, scale, alignCenter, prefix) {
        if (alignCenter === void 0) { alignCenter = true; }
        if (prefix === void 0) { prefix = ""; }
        if (!this.overheadText) {
            return;
        }
        var parsedText = (0,Text/* parseText */.r)(this.overheadText);
        var textParts = prefix ? __spreadArray([{ text: prefix }], parsedText, true) : parsedText;
        this.drawText(context, textParts, scale, alignCenter, prefix);
    };
    Unit.prototype.drawText = function (context, textParts, scale, alignCenter, prefix) {
        if (alignCenter === void 0) { alignCenter = true; }
        if (prefix === void 0) { prefix = ""; }
        context.font = "24px OSRS";
        var fullText = textParts.map(function (_a) {
            var text = _a.text;
            return text;
        }).join("");
        var fullWidth = context.measureText(fullText);
        var startX = alignCenter ? -(fullWidth.width / 2) : 0;
        context.fillStyle = "black";
        context.fillText(fullText, startX + 1, -(this.size / 2) * scale - 10 + 1);
        var x = startX;
        for (var i = 0; i < textParts.length; i++) {
            var _a = textParts[i], text = _a.text, color = _a.color;
            context.fillStyle = color ? "#".concat(color) : "yellow";
            context.fillText(text, x, -(this.size / 2) * scale - 10);
            x += context.measureText(text).width;
        }
    };
    Unit.prototype.draw = function (tickPercent, context, offset, scale, drawUnderTile) {
        if (this.isAnimated) {
            this.unitImage = ImageLoader/* ImageLoader */.$.imageCache[this.image];
        }
        _super.prototype.draw.call(this, tickPercent, context, offset, scale, drawUnderTile);
    };
    Unit.prototype.drawHitsplat = function (projectile) {
        return true;
    };
    Unit.prototype.drawHPBar = function (context, scale, verticalOffset) {
        if (verticalOffset === void 0) { verticalOffset = -(this.size / 2) * scale; }
        var width = this.healthBarWidth;
        context.fillStyle = "red";
        context.fillRect(-width / 2, verticalOffset, width, 5);
        var healthRatio = Math.min(1, Math.ceil((this.currentStats.hitpoint / this.stats.hitpoint) * this.healthScale) / this.healthScale);
        context.fillStyle = "lime";
        context.fillRect(-width / 2, verticalOffset, healthRatio * width, 5);
    };
    Unit.prototype.drawHitsplats = function (context, scale, verticalOffset) {
        var _this = this;
        if (verticalOffset === void 0) { verticalOffset = 0; }
        var projectileOffsets = [
            [0, 10],
            [0, 30],
            [-18, 20],
            [18, 20],
        ];
        var projectileCounter = 0;
        this.incomingProjectiles.forEach(function (projectile) {
            if (projectile.remainingDelay > 0) {
                return;
            }
            if (projectileCounter > 3) {
                return;
            }
            projectileCounter++;
            if (_this.drawHitsplat(projectile)) {
                var image = projectile.damage === 0 ? _this.missedHitsplatImage : _this.damageHitsplatImage;
                if (!projectile.offsetX && !projectile.offsetY) {
                    projectile.offsetX = projectileOffsets[0][0];
                    projectile.offsetY = projectileOffsets[0][1];
                }
                projectileOffsets = (0,lodash.remove)(projectileOffsets, function (offset) {
                    return offset[0] !== projectile.offsetX || offset[1] !== projectile.offsetY;
                });
                if (projectile.damage < 0) {
                    image = _this.healHitsplatImage;
                }
                context.drawImage(image, projectile.offsetX - 11, verticalOffset - projectile.offsetY - 1, 24, 23);
                context.font = "16px Stats_11";
                context.textAlign = "center";
                var damageText = String(Math.abs(projectile.damage));
                var damageTextX = projectile.offsetX;
                var damageTextY = verticalOffset - projectile.offsetY + 15;
                context.fillStyle = "#000000";
                context.fillText(damageText, damageTextX + 1, damageTextY + 1);
                context.fillStyle = "#FFFFFF";
                context.fillText(damageText, damageTextX, damageTextY);
                context.textAlign = "left";
            }
        });
    };
    Unit.prototype.drawOverheadPrayers = function (context, scale) {
        if (!this.prayerController) {
            return;
        }
        var overhead = this.prayerController.overhead();
        if (overhead) {
            var overheadImg = overhead.overheadImage();
            if (overheadImg) {
                context.drawImage(overheadImg, -scale / 2, -scale * 2, scale, scale);
            }
        }
    };
    Object.defineProperty(Unit.prototype, "idlePoseId", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "walkingPoseId", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "animationIndex", {
        get: function () {
            var _a;
            // can be overriden by setAnimation
            if (this.visualMovementActive ||
                this.perceivedLocation.x !== this.location.x ||
                this.perceivedLocation.y !== this.location.y) {
                return (_a = this.walkingPoseId) !== null && _a !== void 0 ? _a : this.idlePoseId;
            }
            return this.idlePoseId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "attackAnimationId", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "canBlendAttackAnimation", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Unit.prototype, "deathAnimationId", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    return Unit;
}(Renderable/* Renderable */.l));



/***/ }),

/***/ 3422:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: () => (/* binding */ XpDrop)
/* harmony export */ });
var XpDrop = /** @class */ (function () {
    function XpDrop(skill, xp, damage) {
        this.skill = skill;
        this.xp = xp;
        this.damage = damage;
    }
    return XpDrop;
}());



/***/ }),

/***/ 4133:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  O: () => (/* binding */ XpDropController)
});

// EXTERNAL MODULE: ./src/assets/images/xpdrops/attack.png
var attack = __webpack_require__(2229);
// EXTERNAL MODULE: ./src/assets/images/xpdrops/strength.png
var strength = __webpack_require__(3318);
// EXTERNAL MODULE: ./src/assets/images/xpdrops/defence.png
var defence = __webpack_require__(29);
// EXTERNAL MODULE: ./src/assets/images/xpdrops/range.png
var range = __webpack_require__(4290);
// EXTERNAL MODULE: ./src/assets/images/xpdrops/magic.png
var magic = __webpack_require__(8260);
;// CONCATENATED MODULE: ./src/assets/images/xpdrops/hitpoint.png
const hitpoint_namespaceObject = __webpack_require__.p + "0e781837baf9aa422284.png";
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(2543);
// EXTERNAL MODULE: ./src/sdk/utils/ImageLoader.ts
var ImageLoader = __webpack_require__(2987);
// EXTERNAL MODULE: ./src/sdk/Settings.ts
var Settings = __webpack_require__(8406);
;// CONCATENATED MODULE: ./src/sdk/XpDropController.ts









var XpDropController = /** @class */ (function () {
    function XpDropController() {
        this.canvas = new OffscreenCanvas(110, 200);
        this.ctx = this.canvas.getContext("2d");
        this.drops = [{ abc: "asdf" }, {}, {}, {}];
        this.lastDropSkill = null;
        this.startupTimeout();
    }
    XpDropController.prototype.startupTimeout = function () {
        var _this = this;
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(function () {
            _this.lastDropSkill = null;
        }, 1000 * 16); // Not sure if 16 seconds is correct but good enough for now
    };
    XpDropController.prototype.registerXpDrop = function (drop) {
        this.drops.push(drop);
        if (drop.skill) {
            this.lastDropSkill = drop.skill;
        }
    };
    XpDropController.prototype.tick = function () {
        this.drops.shift();
        if (this.drops.length < 4) {
            this.drops.push({}); // TODO: This is bad
        }
    };
    XpDropController.prototype.draw = function (destinationCanvas, x, y, tickPercent) {
        var _this = this;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        if (!Settings/* Settings */.w.displayXpDrops) {
            return;
        }
        var scale = Settings/* Settings */.w.maxUiScale;
        this.canvas.width = 110 * scale * 2;
        this.canvas.height = 200 * scale * 2;
        var skillInfo = (0,lodash.find)(XpDropController.skills, { type: this.lastDropSkill });
        if (skillInfo && skillInfo.type) {
            // Draw overall XP box at top
            this.ctx.lineWidth = 1;
            this.ctx.strokeStyle = XpDropController.outlineColor;
            this.ctx.strokeRect(0, 0, 110 * scale, 42 * scale);
            this.ctx.strokeStyle = XpDropController.inlineColor;
            this.ctx.strokeRect(1 * scale, 1 * scale, 109 * scale, 41 * scale);
            this.ctx.strokeRect(1 * scale, 30 * scale, 108 * scale, 11 * scale);
            this.ctx.fillStyle = XpDropController.fillColor;
            this.ctx.fillRect(2 * scale, 2 * scale, 108 * scale, 40 * scale);
            this.ctx.fillStyle = "#000000";
            this.ctx.fillRect(2 * scale, 31 * scale, 106 * scale, 9 * scale);
            this.ctx.fillStyle = "#00BF00";
            this.ctx.fillRect(3 * scale, 32 * scale, 90 * scale, 7 * scale);
            this.ctx.fillStyle = "#FFFFFF";
            this.ctx.font = "".concat(Math.floor(16 * scale), "px Stats_11");
            this.ctx.textAlign = "right";
            this.ctx.drawImage(skillInfo.image, 4 * scale, 2 * scale, 26 * scale, 26 * scale);
            this.ctx.fillStyle = "#000000";
            this.ctx.fillText("200,000,000", 106 * scale, 21 * scale);
            this.ctx.fillStyle = "#FFFFFF";
            this.ctx.fillText("200,000,000", 105 * scale, 20 * scale);
        }
        var offsetX = 120;
        var fontSize = Math.max(16 * scale, 24);
        var imageSize = fontSize + 1;
        this.ctx.font = "".concat(fontSize, "px Stats_11");
        this.ctx.textAlign = "right";
        this.ctx.textBaseline = "top";
        this.drops.forEach(function (drop, index) {
            if (!drop.skill) {
                return;
            }
            var offsetY = (index - tickPercent) * imageSize + 85;
            var xpString = String(Math.floor(drop.xp));
            var damageString = Settings/* Settings */.w.showPredictedHit && drop.damage && drop.skill !== 'hitpoint'
                ? " (".concat(drop.damage, ")")
                : '';
            var xpWidth = _this.ctx.measureText(xpString).width;
            var damageWidth = _this.ctx.measureText(damageString).width;
            // left-most: predicted damage string
            if (damageString) {
                _this.ctx.fillStyle = "#FF0000";
                _this.ctx.fillText(damageString, offsetX, offsetY);
            }
            // next: xp drop
            _this.ctx.fillStyle = "#FFFFFF";
            _this.ctx.fillText(xpString, offsetX - damageWidth, offsetY);
            // last: skill icon
            var skillInfo = (0,lodash.find)(XpDropController.skills, { type: drop.skill });
            if (skillInfo.image) {
                _this.ctx.drawImage(skillInfo.image, offsetX - xpWidth - damageWidth - imageSize - (2 * scale), offsetY, imageSize, imageSize);
            }
        });
        destinationCanvas.drawImage(this.canvas, x, y);
    };
    XpDropController.controller = new XpDropController();
    XpDropController.outlineColor = "#3A3021";
    XpDropController.inlineColor = "#5D5344";
    XpDropController.fillColor = "#5D534473"; // guess ATM
    XpDropController.skills = [
        { type: "attack", imgSrc: attack, image: null },
        { type: "strength", imgSrc: strength, image: null },
        { type: "defence", imgSrc: defence, image: null },
        { type: "range", imgSrc: range, image: null },
        { type: "magic", imgSrc: magic, image: null },
        { type: "hitpoint", imgSrc: hitpoint_namespaceObject, image: null },
    ];
    return XpDropController;
}());

XpDropController.skills.forEach(function (skill) {
    skill.image = ImageLoader/* ImageLoader */.$.createImage(skill.imgSrc);
});


/***/ }),

/***/ 5432:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  cp: () => (/* binding */ cacheSound),
  w5: () => (/* binding */ isCacheSound),
  rA: () => (/* binding */ parseSoundEffectPack),
  Uz: () => (/* binding */ synthesizeCacheSound)
});

;// CONCATENATED MODULE: ./src/sdk/audio/SoundEffectSynth.ts
var SOUND_EFFECT_SAMPLE_RATE = 22050;
var SoundInput = /** @class */ (function () {
    function SoundInput(bytes) {
        this.offset = 0;
        this.view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    }
    SoundInput.prototype.require = function (length) {
        if (this.offset + length > this.view.byteLength) {
            throw new RangeError("Truncated sound effect at byte ".concat(this.offset));
        }
    };
    SoundInput.prototype.unsignedByte = function () {
        this.require(1);
        return this.view.getUint8(this.offset++);
    };
    SoundInput.prototype.unsignedShort = function () {
        this.require(2);
        var value = this.view.getUint16(this.offset);
        this.offset += 2;
        return value;
    };
    SoundInput.prototype.int = function () {
        this.require(4);
        var value = this.view.getInt32(this.offset);
        this.offset += 4;
        return value;
    };
    SoundInput.prototype.unsignedShortSmart = function () {
        this.require(1);
        return this.view.getUint8(this.offset) < 128 ? this.unsignedByte() : this.unsignedShort() - 32768;
    };
    SoundInput.prototype.shortSmart = function () {
        this.require(1);
        return this.view.getUint8(this.offset) < 128 ? this.unsignedByte() - 64 : this.unsignedShort() - 49152;
    };
    return SoundInput;
}());
var SoundEnvelope = /** @class */ (function () {
    function SoundEnvelope() {
        this.form = 0;
        this.start = 0;
        this.end = 0;
        this.durations = [0, 65535];
        this.phases = [0, 65535];
        this.ticks = 0;
        this.phaseIndex = 0;
        this.step = 0;
        this.amplitude = 0;
        this.max = 0;
    }
    SoundEnvelope.prototype.decode = function (input) {
        this.form = input.unsignedByte();
        this.start = input.int();
        this.end = input.int();
        this.decodeSegments(input);
    };
    SoundEnvelope.prototype.decodeSegments = function (input) {
        var count = input.unsignedByte();
        this.durations = new Array(count);
        this.phases = new Array(count);
        for (var i = 0; i < count; i++) {
            this.durations[i] = input.unsignedShort();
            this.phases[i] = input.unsignedShort();
        }
    };
    SoundEnvelope.prototype.reset = function () {
        this.ticks = 0;
        this.phaseIndex = 0;
        this.step = 0;
        this.amplitude = 0;
        this.max = 0;
    };
    SoundEnvelope.prototype.stepFor = function (period) {
        if (this.max >= this.ticks) {
            this.amplitude = this.phases[this.phaseIndex++] << 15;
            if (this.phaseIndex >= this.durations.length)
                this.phaseIndex = this.durations.length - 1;
            this.ticks = Math.trunc((this.durations[this.phaseIndex] / 65536) * period);
            if (this.ticks > this.max) {
                this.step = Math.trunc(((this.phases[this.phaseIndex] << 15) - this.amplitude) / (this.ticks - this.max));
            }
        }
        this.amplitude = (this.amplitude + this.step) | 0;
        this.max++;
        return (this.amplitude - this.step) >> 15;
    };
    return SoundEnvelope;
}());
var f32 = Math.fround || (function (value) { return value; });
var SoundFilter = /** @class */ (function () {
    function SoundFilter() {
        this.pairs = [0, 0];
        this.phases = Array.from({ length: 2 }, function () { return Array.from({ length: 2 }, function () { return new Array(4).fill(0); }); });
        this.magnitudes = Array.from({ length: 2 }, function () { return Array.from({ length: 2 }, function () { return new Array(4).fill(0); }); });
        this.unity = [0, 0];
        this.coefficients = [new Int32Array(8), new Int32Array(8)];
        this.minimizedCoefficients = [new Float32Array(8), new Float32Array(8)];
        this.forwardMultiplier = 0;
        this.forwardCoefficientMultiplier = 0;
    }
    SoundFilter.prototype.decode = function (input, envelope) {
        var count = input.unsignedByte();
        this.pairs[0] = count >> 4;
        this.pairs[1] = count & 15;
        if (this.pairs[0] > 4 || this.pairs[1] > 4)
            throw new RangeError("Sound filter has more than four pairs");
        if (count === 0)
            return;
        this.unity[0] = input.unsignedShort();
        this.unity[1] = input.unsignedShort();
        var migrated = input.unsignedByte();
        for (var direction = 0; direction < 2; direction++) {
            for (var pair = 0; pair < this.pairs[direction]; pair++) {
                this.phases[direction][0][pair] = input.unsignedShort();
                this.magnitudes[direction][0][pair] = input.unsignedShort();
            }
        }
        for (var direction = 0; direction < 2; direction++) {
            for (var pair = 0; pair < this.pairs[direction]; pair++) {
                if ((migrated & (1 << (direction * 4 + pair))) !== 0) {
                    this.phases[direction][1][pair] = input.unsignedShort();
                    this.magnitudes[direction][1][pair] = input.unsignedShort();
                }
                else {
                    this.phases[direction][1][pair] = this.phases[direction][0][pair];
                    this.magnitudes[direction][1][pair] = this.magnitudes[direction][0][pair];
                }
            }
        }
        if (migrated !== 0 || this.unity[1] !== this.unity[0])
            envelope.decodeSegments(input);
    };
    SoundFilter.prototype.compute = function (direction, factor) {
        if (direction === 0) {
            var magnitude_1 = f32(f32(this.unity[0]) + f32(f32(this.unity[1] - this.unity[0]) * factor));
            magnitude_1 = f32(magnitude_1 * f32(0.0030517578));
            this.forwardCoefficientMultiplier = f32(Math.pow(0.1, f32(magnitude_1 / f32(20))));
            this.forwardMultiplier = Math.trunc(f32(this.forwardCoefficientMultiplier * f32(65536)));
        }
        if (this.pairs[direction] === 0)
            return 0;
        var magnitude = this.adaptMagnitude(direction, 0, factor);
        var coefficients = this.minimizedCoefficients[direction];
        coefficients[0] = f32(f32(-2 * magnitude) * f32(Math.cos(this.adaptPhase(direction, 0, factor))));
        coefficients[1] = f32(magnitude * magnitude);
        for (var pair = 1; pair < this.pairs[direction]; pair++) {
            magnitude = this.adaptMagnitude(direction, pair, factor);
            var phase = f32(f32(-2 * magnitude) * f32(Math.cos(this.adaptPhase(direction, pair, factor))));
            var coefficient = f32(magnitude * magnitude);
            coefficients[pair * 2 + 1] = f32(coefficients[pair * 2 - 1] * coefficient);
            coefficients[pair * 2] = f32(f32(coefficients[pair * 2 - 1] * phase) + f32(coefficients[pair * 2 - 2] * coefficient));
            for (var other = pair * 2 - 1; other >= 2; other--) {
                coefficients[other] = f32(coefficients[other] +
                    f32(f32(coefficients[other - 1] * phase) + f32(coefficients[other - 2] * coefficient)));
            }
            coefficients[1] = f32(coefficients[1] + f32(f32(coefficients[0] * phase) + coefficient));
            coefficients[0] = f32(coefficients[0] + phase);
        }
        if (direction === 0) {
            for (var pair = 0; pair < this.pairs[0] * 2; pair++) {
                coefficients[pair] = f32(coefficients[pair] * this.forwardCoefficientMultiplier);
            }
        }
        for (var pair = 0; pair < this.pairs[direction] * 2; pair++) {
            this.coefficients[direction][pair] = Math.trunc(f32(coefficients[pair] * f32(65536)));
        }
        return this.pairs[direction] * 2;
    };
    SoundFilter.prototype.adaptMagnitude = function (direction, pair, factor) {
        var alpha = f32(f32(this.magnitudes[direction][0][pair]) +
            f32(factor * f32(this.magnitudes[direction][1][pair] - this.magnitudes[direction][0][pair])));
        alpha = f32(alpha * f32(0.0015258789));
        return f32(f32(1) - f32(Math.pow(10, f32(-alpha / f32(20)))));
    };
    SoundFilter.prototype.adaptPhase = function (direction, pair, factor) {
        var alpha = f32(f32(this.phases[direction][0][pair]) +
            f32(factor * f32(this.phases[direction][1][pair] - this.phases[direction][0][pair])));
        alpha = f32(alpha * f32(1.2207031e-4));
        var frequency = f32(f32(32.703197) * f32(Math.pow(2, alpha)));
        return f32(f32(frequency * f32(3.1415927)) / f32(11025));
    };
    return SoundFilter;
}());
function createNoise() {
    var noise = new Int8Array(32768);
    var low = 0xe66d;
    var middle = 0xdeec;
    var high = 0x0005;
    for (var i = 0; i < noise.length; i++) {
        var product0 = low * 0xe66d + 0xb;
        var nextLow = product0 % 65536;
        var product1 = middle * 0xe66d + low * 0xdeec + Math.floor(product0 / 65536);
        var nextMiddle = product1 % 65536;
        var product2 = high * 0xe66d + middle * 0xdeec + low * 5 + Math.floor(product1 / 65536);
        low = nextLow;
        middle = nextMiddle;
        high = product2 % 65536;
        noise[i] = (middle & 2) - 1;
    }
    return noise;
}
var TONE_NOISE = createNoise();
var TONE_SINE = Int32Array.from({ length: 32768 }, function (_, i) { return Math.trunc(Math.sin(i / 5215.1903) * 16384); });
function shiftedLongProduct(left, right) {
    return Math.floor((left * right) / 65536) | 0;
}
var SoundTone = /** @class */ (function () {
    function SoundTone(input) {
        this.oscillatorVolume = new Int32Array(5);
        this.oscillatorPitch = new Int32Array(5);
        this.oscillatorDelays = new Int32Array(5);
        this.delayTime = 0;
        this.delayDecay = 100;
        this.duration = 500;
        this.offset = 0;
        this.pitch = new SoundEnvelope();
        this.pitch.decode(input);
        this.volume = new SoundEnvelope();
        this.volume.decode(input);
        if (this.optional(input)) {
            this.pitchModifier = new SoundEnvelope();
            this.pitchModifier.decode(input);
            this.pitchModifierAmplitude = new SoundEnvelope();
            this.pitchModifierAmplitude.decode(input);
        }
        if (this.optional(input)) {
            this.volumeMultiplier = new SoundEnvelope();
            this.volumeMultiplier.decode(input);
            this.volumeMultiplierAmplitude = new SoundEnvelope();
            this.volumeMultiplierAmplitude.decode(input);
        }
        if (this.optional(input)) {
            this.release = new SoundEnvelope();
            this.release.decode(input);
            this.attack = new SoundEnvelope();
            this.attack.decode(input);
        }
        for (var oscillator = 0; oscillator < 10; oscillator++) {
            var volume = input.unsignedShortSmart();
            if (volume === 0)
                break;
            if (oscillator >= 5)
                throw new RangeError("Sound effect has more than five oscillators");
            this.oscillatorVolume[oscillator] = volume;
            this.oscillatorPitch[oscillator] = input.shortSmart();
            this.oscillatorDelays[oscillator] = input.unsignedShortSmart();
        }
        this.delayTime = input.unsignedShortSmart();
        this.delayDecay = input.unsignedShortSmart();
        this.duration = input.unsignedShort();
        this.offset = input.unsignedShort();
        this.filter = new SoundFilter();
        this.filterEnvelope = new SoundEnvelope();
        this.filter.decode(input, this.filterEnvelope);
    }
    SoundTone.prototype.optional = function (input) {
        var present = input.unsignedByte() !== 0;
        if (present)
            input.offset--;
        return present;
    };
    SoundTone.prototype.synthesize = function (sampleCount) {
        var samples = new Int32Array(sampleCount);
        if (this.duration < 10)
            return samples;
        var samplesPerMillisecond = sampleCount / this.duration;
        this.pitch.reset();
        this.volume.reset();
        var pitchModulationStep = 0;
        var pitchModulationBaseStep = 0;
        var pitchModulationPhase = 0;
        if (this.pitchModifier) {
            this.pitchModifier.reset();
            this.pitchModifierAmplitude.reset();
            pitchModulationStep = Math.trunc(((this.pitchModifier.end - this.pitchModifier.start) * 32.768) / samplesPerMillisecond);
            pitchModulationBaseStep = Math.trunc((this.pitchModifier.start * 32.768) / samplesPerMillisecond);
        }
        var volumeModulationStep = 0;
        var volumeModulationBaseStep = 0;
        var volumeModulationPhase = 0;
        if (this.volumeMultiplier) {
            this.volumeMultiplier.reset();
            this.volumeMultiplierAmplitude.reset();
            volumeModulationStep = Math.trunc(((this.volumeMultiplier.end - this.volumeMultiplier.start) * 32.768) / samplesPerMillisecond);
            volumeModulationBaseStep = Math.trunc((this.volumeMultiplier.start * 32.768) / samplesPerMillisecond);
        }
        var phases = new Int32Array(5);
        var delays = new Int32Array(5);
        var volumeSteps = new Int32Array(5);
        var pitchSteps = new Int32Array(5);
        var pitchBaseSteps = new Int32Array(5);
        for (var oscillator = 0; oscillator < 5; oscillator++) {
            if (this.oscillatorVolume[oscillator] !== 0) {
                delays[oscillator] = Math.trunc(this.oscillatorDelays[oscillator] * samplesPerMillisecond);
                volumeSteps[oscillator] = Math.trunc((this.oscillatorVolume[oscillator] << 14) / 100);
                pitchSteps[oscillator] = Math.trunc(((this.pitch.end - this.pitch.start) *
                    32.768 *
                    Math.pow(1.0057929410678534, this.oscillatorPitch[oscillator])) /
                    samplesPerMillisecond);
                pitchBaseSteps[oscillator] = Math.trunc((this.pitch.start * 32.768) / samplesPerMillisecond);
            }
        }
        for (var sample = 0; sample < sampleCount; sample++) {
            var pitchChange = this.pitch.stepFor(sampleCount);
            var volumeChange = this.volume.stepFor(sampleCount);
            if (this.pitchModifier) {
                var modulation = this.pitchModifier.stepFor(sampleCount);
                var amplitude = this.pitchModifierAmplitude.stepFor(sampleCount);
                pitchChange =
                    (pitchChange + (this.evaluateWave(pitchModulationPhase, amplitude, this.pitchModifier.form) >> 1)) | 0;
                pitchModulationPhase =
                    (pitchModulationPhase + pitchModulationBaseStep + (Math.imul(modulation, pitchModulationStep) >> 16)) | 0;
            }
            if (this.volumeMultiplier) {
                var modulation = this.volumeMultiplier.stepFor(sampleCount);
                var amplitude = this.volumeMultiplierAmplitude.stepFor(sampleCount);
                volumeChange =
                    Math.imul(volumeChange, (this.evaluateWave(volumeModulationPhase, amplitude, this.volumeMultiplier.form) >> 1) + 32768) >> 15;
                volumeModulationPhase =
                    (volumeModulationPhase + volumeModulationBaseStep + (Math.imul(modulation, volumeModulationStep) >> 16)) | 0;
            }
            for (var oscillator = 0; oscillator < 5; oscillator++) {
                if (this.oscillatorVolume[oscillator] === 0)
                    continue;
                var output = delays[oscillator] + sample;
                if (output < sampleCount) {
                    samples[output] += this.evaluateWave(phases[oscillator], Math.imul(volumeChange, volumeSteps[oscillator]) >> 15, this.pitch.form);
                    phases[oscillator] += (Math.imul(pitchChange, pitchSteps[oscillator]) >> 16) + pitchBaseSteps[oscillator];
                }
            }
        }
        if (this.release) {
            this.release.reset();
            this.attack.reset();
            var counter = 0;
            var muted = true;
            for (var sample = 0; sample < sampleCount; sample++) {
                var release = this.release.stepFor(sampleCount);
                var attack = this.attack.stepFor(sampleCount);
                var threshold = ((Math.imul(muted ? release : attack, this.release.end - this.release.start) >> 8) + this.release.start) | 0;
                counter += 256;
                if (counter >= threshold) {
                    counter = 0;
                    muted = !muted;
                }
                if (muted)
                    samples[sample] = 0;
            }
        }
        if (this.delayTime > 0 && this.delayDecay > 0) {
            var delay = Math.trunc(this.delayTime * samplesPerMillisecond);
            for (var sample = delay; sample < sampleCount; sample++) {
                samples[sample] += Math.trunc(Math.imul(samples[sample - delay], this.delayDecay) / 100);
            }
        }
        this.applyFilter(samples);
        for (var sample = 0; sample < sampleCount; sample++) {
            if (samples[sample] < -32768)
                samples[sample] = -32768;
            else if (samples[sample] > 32767)
                samples[sample] = 32767;
        }
        return samples;
    };
    SoundTone.prototype.applyFilter = function (samples) {
        var sampleCount = samples.length;
        if (this.filter.pairs[0] === 0 && this.filter.pairs[1] === 0)
            return;
        this.filterEnvelope.reset();
        var envelope = this.filterEnvelope.stepFor(sampleCount + 1);
        var forwardOrder = this.filter.compute(0, f32(envelope / 65536));
        var feedbackOrder = this.filter.compute(1, f32(envelope / 65536));
        if (sampleCount < forwardOrder + feedbackOrder)
            return;
        var sample = 0;
        var blockEnd = Math.min(feedbackOrder, sampleCount - forwardOrder);
        while (sample < blockEnd) {
            var value = shiftedLongProduct(samples[sample + forwardOrder], this.filter.forwardMultiplier);
            for (var coefficient = 0; coefficient < forwardOrder; coefficient++) {
                value =
                    (value +
                        shiftedLongProduct(samples[sample + forwardOrder - 1 - coefficient], this.filter.coefficients[0][coefficient])) |
                        0;
            }
            for (var coefficient = 0; coefficient < sample; coefficient++) {
                value =
                    (value - shiftedLongProduct(samples[sample - 1 - coefficient], this.filter.coefficients[1][coefficient])) | 0;
            }
            samples[sample++] = value;
            envelope = this.filterEnvelope.stepFor(sampleCount + 1);
        }
        blockEnd = 128;
        for (;;) {
            blockEnd = Math.min(blockEnd, sampleCount - forwardOrder);
            while (sample < blockEnd) {
                var value = shiftedLongProduct(samples[sample + forwardOrder], this.filter.forwardMultiplier);
                for (var coefficient = 0; coefficient < forwardOrder; coefficient++) {
                    value =
                        (value +
                            shiftedLongProduct(samples[sample + forwardOrder - 1 - coefficient], this.filter.coefficients[0][coefficient])) |
                            0;
                }
                for (var coefficient = 0; coefficient < feedbackOrder; coefficient++) {
                    value =
                        (value - shiftedLongProduct(samples[sample - 1 - coefficient], this.filter.coefficients[1][coefficient])) |
                            0;
                }
                samples[sample++] = value;
                envelope = this.filterEnvelope.stepFor(sampleCount + 1);
            }
            if (sample >= sampleCount - forwardOrder) {
                while (sample < sampleCount) {
                    var value = 0;
                    for (var coefficient = sample + forwardOrder - sampleCount; coefficient < forwardOrder; coefficient++) {
                        value =
                            (value +
                                shiftedLongProduct(samples[sample + forwardOrder - 1 - coefficient], this.filter.coefficients[0][coefficient])) |
                                0;
                    }
                    for (var coefficient = 0; coefficient < feedbackOrder; coefficient++) {
                        value =
                            (value -
                                shiftedLongProduct(samples[sample - 1 - coefficient], this.filter.coefficients[1][coefficient])) |
                                0;
                    }
                    samples[sample++] = value;
                    this.filterEnvelope.stepFor(sampleCount + 1);
                }
                break;
            }
            forwardOrder = this.filter.compute(0, f32(envelope / 65536));
            feedbackOrder = this.filter.compute(1, f32(envelope / 65536));
            blockEnd += 128;
        }
    };
    SoundTone.prototype.evaluateWave = function (phase, amplitude, form) {
        if (form === 1)
            return (phase & 32767) < 16384 ? amplitude : -amplitude;
        if (form === 2)
            return Math.imul(TONE_SINE[phase & 32767], amplitude) >> 14;
        if (form === 3)
            return (Math.imul(amplitude, phase & 32767) >> 14) - amplitude;
        if (form === 4)
            return Math.imul(amplitude, TONE_NOISE[Math.trunc(phase / 2607) & 32767]);
        return 0;
    };
    return SoundTone;
}());
var SoundEffectDefinition = /** @class */ (function () {
    function SoundEffectDefinition(bytes) {
        this.tones = new Array(10);
        var input = new SoundInput(bytes);
        for (var i = 0; i < this.tones.length; i++) {
            var present = input.unsignedByte() !== 0;
            if (present) {
                input.offset--;
                this.tones[i] = new SoundTone(input);
            }
        }
        this.loopStartMilliseconds = input.unsignedShort();
        this.loopEndMilliseconds = input.unsignedShort();
    }
    SoundEffectDefinition.prototype.toRawSound = function () {
        var durationMilliseconds = 0;
        for (var _i = 0, _a = this.tones; _i < _a.length; _i++) {
            var tone = _a[_i];
            if (tone)
                durationMilliseconds = Math.max(durationMilliseconds, tone.duration + tone.offset);
        }
        var mixed = new Int8Array(Math.trunc((durationMilliseconds * SOUND_EFFECT_SAMPLE_RATE) / 1000));
        for (var _b = 0, _c = this.tones; _b < _c.length; _b++) {
            var tone = _c[_b];
            if (!tone)
                continue;
            var sampleCount = Math.trunc((tone.duration * SOUND_EFFECT_SAMPLE_RATE) / 1000);
            var sampleOffset = Math.trunc((tone.offset * SOUND_EFFECT_SAMPLE_RATE) / 1000);
            var samples = tone.synthesize(sampleCount);
            for (var sample = 0; sample < sampleCount; sample++) {
                var value = (samples[sample] >> 8) + mixed[sample + sampleOffset];
                if (((value + 128) & -256) !== 0)
                    value = (value >> 31) ^ 127;
                mixed[sample + sampleOffset] = value;
            }
        }
        return {
            sampleRate: SOUND_EFFECT_SAMPLE_RATE,
            samples: mixed,
            loopStart: Math.trunc((this.loopStartMilliseconds * SOUND_EFFECT_SAMPLE_RATE) / 1000),
            loopEnd: Math.trunc((this.loopEndMilliseconds * SOUND_EFFECT_SAMPLE_RATE) / 1000),
        };
    };
    return SoundEffectDefinition;
}());

function synthesizeSoundEffect(bytes) {
    return new SoundEffectDefinition(bytes).toRawSound();
}

// EXTERNAL MODULE: ./src/sdk/rendering/CacheRenderBundle.ts
var CacheRenderBundle = __webpack_require__(702);
;// CONCATENATED MODULE: ./src/sdk/audio/CacheSoundEffects.ts
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var CACHE_SOUND_PREFIX = "cache-sound:";
var definitionsPromise;
function cacheSound(soundId) {
    return "".concat(CACHE_SOUND_PREFIX).concat(soundId);
}
function isCacheSound(source) {
    return source.startsWith(CACHE_SOUND_PREFIX);
}
function parseSoundEffectPack(bytes) {
    var view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    if (bytes.length < 6 || bytes[0] !== 0x53 || bytes[1] !== 0x46 || bytes[2] !== 0x58 || bytes[3] !== 0x31) {
        throw new Error("Invalid sound-effect pack");
    }
    var count = view.getUint16(4);
    var definitions = new Map();
    var offset = 6;
    for (var i = 0; i < count; i++) {
        if (offset + 4 > bytes.length)
            throw new Error("Truncated sound-effect pack entry");
        var id = view.getUint16(offset);
        var length_1 = view.getUint16(offset + 2);
        offset += 4;
        if (offset + length_1 > bytes.length)
            throw new Error("Truncated sound-effect ".concat(id));
        definitions.set(id, bytes.slice(offset, offset + length_1));
        offset += length_1;
    }
    if (offset !== bytes.length)
        throw new Error("Unexpected trailing sound-effect pack data");
    return definitions;
}
function loadDefinitions() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!definitionsPromise) {
                definitionsPromise = CacheRenderBundle/* CacheRender */.j9.bundle()
                    .then(function (bundle) { return bundle.fetchSoundEffects(); })
                    .then(function (buffer) { return parseSoundEffectPack(new Uint8Array(buffer)); });
            }
            return [2 /*return*/, definitionsPromise];
        });
    });
}
function parseSource(source) {
    if (!isCacheSound(source))
        throw new Error("Not a cache sound source: ".concat(source));
    var id = Number(source.slice(CACHE_SOUND_PREFIX.length));
    if (!Number.isInteger(id) || id < 0)
        throw new Error("Invalid cache sound source: ".concat(source));
    return id;
}
function synthesizeCacheSound(source) {
    return __awaiter(this, void 0, void 0, function () {
        var definitions, id, definition;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadDefinitions()];
                case 1:
                    definitions = _a.sent();
                    id = parseSource(source);
                    definition = definitions.get(id);
                    if (!definition)
                        throw new Error("Sound effect ".concat(id, " is not present in the runtime pack"));
                    return [2 /*return*/, synthesizeSoundEffect(definition)];
            }
        });
    });
}


/***/ }),

/***/ 1977:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: () => (/* binding */ AmmoType),
/* harmony export */   d: () => (/* binding */ Ammo)
/* harmony export */ });
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3107);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AmmoType;
(function (AmmoType) {
    AmmoType[AmmoType["BLESSING"] = 0] = "BLESSING";
    AmmoType[AmmoType["AMMO"] = 1] = "AMMO";
})(AmmoType || (AmmoType = {}));
var Ammo = /** @class */ (function (_super) {
    __extends(Ammo, _super);
    function Ammo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Ammo.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_0__/* .EquipmentTypes */ .WA.AMMO;
        },
        enumerable: false,
        configurable: true
    });
    Ammo.prototype.ammoType = function () {
        return AmmoType.AMMO;
    };
    Ammo.prototype.assignToPlayer = function (player) {
        player.equipment.ammo = this;
    };
    Ammo.prototype.unassignToPlayer = function (player) {
        player.equipment.ammo = null;
    };
    Ammo.prototype.currentEquipment = function (player) {
        return player.equipment.ammo;
    };
    return Ammo;
}(_Equipment__WEBPACK_IMPORTED_MODULE_0__/* .Equipment */ .$i));



/***/ }),

/***/ 1040:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q: () => (/* binding */ Cape)
/* harmony export */ });
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3107);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4655);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Cape = /** @class */ (function (_super) {
    __extends(Cape, _super);
    function Cape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Cape.prototype, "equipSoundId", {
        get: function () {
            return _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__/* .CACHE_ASSETS */ .fc.sounds.equipFun.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cape.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_0__/* .EquipmentTypes */ .WA.BACK;
        },
        enumerable: false,
        configurable: true
    });
    Cape.prototype.assignToPlayer = function (player) {
        player.equipment.cape = this;
    };
    Cape.prototype.unassignToPlayer = function (player) {
        player.equipment.cape = null;
    };
    Cape.prototype.currentEquipment = function (player) {
        return player.equipment.cape;
    };
    return Cape;
}(_Equipment__WEBPACK_IMPORTED_MODULE_0__/* .Equipment */ .$i));



/***/ }),

/***/ 7718:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: () => (/* binding */ Chest)
/* harmony export */ });
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3107);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4655);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Chest = /** @class */ (function (_super) {
    __extends(Chest, _super);
    function Chest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Chest.prototype, "equipSoundId", {
        get: function () {
            return _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__/* .CACHE_ASSETS */ .fc.sounds.equipMetalBody.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Chest.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_0__/* .EquipmentTypes */ .WA.CHEST;
        },
        enumerable: false,
        configurable: true
    });
    Chest.prototype.assignToPlayer = function (player) {
        player.equipment.chest = this;
    };
    Chest.prototype.unassignToPlayer = function (player) {
        player.equipment.chest = null;
    };
    Chest.prototype.currentEquipment = function (player) {
        return player.equipment.chest;
    };
    return Chest;
}(_Equipment__WEBPACK_IMPORTED_MODULE_0__/* .Equipment */ .$i));



/***/ }),

/***/ 9775:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   v: () => (/* binding */ Feet)
/* harmony export */ });
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3107);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4655);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Feet = /** @class */ (function (_super) {
    __extends(Feet, _super);
    function Feet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Feet.prototype, "equipSoundId", {
        get: function () {
            return _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__/* .CACHE_ASSETS */ .fc.sounds.equipFeet.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Feet.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_0__/* .EquipmentTypes */ .WA.FEET;
        },
        enumerable: false,
        configurable: true
    });
    Feet.prototype.assignToPlayer = function (player) {
        player.equipment.feet = this;
    };
    Feet.prototype.unassignToPlayer = function (player) {
        player.equipment.feet = null;
    };
    Feet.prototype.currentEquipment = function (player) {
        return player.equipment.feet;
    };
    return Feet;
}(_Equipment__WEBPACK_IMPORTED_MODULE_0__/* .Equipment */ .$i));



/***/ }),

/***/ 7719:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: () => (/* binding */ Food)
/* harmony export */ });
/* harmony import */ var _Item__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2376);
/* harmony import */ var _utils_ImageLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2987);
/* harmony import */ var _rendering_GLTFAnimationConstants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1708);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var Food = /** @class */ (function (_super) {
    __extends(Food, _super);
    function Food() {
        var _this = _super.call(this) || this;
        _this.healAmount = 0;
        _this.inventorySprite = _utils_ImageLoader__WEBPACK_IMPORTED_MODULE_1__/* .ImageLoader */ .$.createImage(_this.inventoryImage);
        _this.defaultAction = "Eat";
        return _this;
    }
    Food.prototype.eat = function (player) {
        player.interruptCombat();
        player.playAnimation(_rendering_GLTFAnimationConstants__WEBPACK_IMPORTED_MODULE_2__/* .PlayerAnimationIndices */ .L.Eat, false);
        if (player.currentStats.hitpoint < player.stats.hitpoint) {
            player.currentStats.hitpoint += this.healAmount;
            player.currentStats.hitpoint = Math.min(player.currentStats.hitpoint, player.stats.hitpoint);
        }
    };
    Object.defineProperty(Food.prototype, "weight", {
        get: function () {
            return 0.226;
        },
        enumerable: false,
        configurable: true
    });
    Food.prototype.updateInventorySprite = function () {
        // Override me
    };
    Object.defineProperty(Food.prototype, "hasInventoryLeftClick", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Food.prototype.inventoryLeftClick = function (player) {
        player.eats.eatFood(this);
    };
    return Food;
}(_Item__WEBPACK_IMPORTED_MODULE_0__/* .Item */ .q));



/***/ }),

/***/ 1629:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: () => (/* binding */ Gloves)
/* harmony export */ });
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3107);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4655);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Gloves = /** @class */ (function (_super) {
    __extends(Gloves, _super);
    function Gloves() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Gloves.prototype, "equipSoundId", {
        get: function () {
            return _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__/* .CACHE_ASSETS */ .fc.sounds.equipHands.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Gloves.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_0__/* .EquipmentTypes */ .WA.GLOVES;
        },
        enumerable: false,
        configurable: true
    });
    Gloves.prototype.assignToPlayer = function (player) {
        player.equipment.gloves = this;
    };
    Gloves.prototype.unassignToPlayer = function (player) {
        player.equipment.gloves = null;
    };
    Gloves.prototype.currentEquipment = function (player) {
        return player.equipment.gloves;
    };
    return Gloves;
}(_Equipment__WEBPACK_IMPORTED_MODULE_0__/* .Equipment */ .$i));



/***/ }),

/***/ 2282:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   m: () => (/* binding */ Helmet)
/* harmony export */ });
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3107);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4655);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Helmet = /** @class */ (function (_super) {
    __extends(Helmet, _super);
    function Helmet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Helmet.prototype, "equipSoundId", {
        get: function () {
            return _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__/* .CACHE_ASSETS */ .fc.sounds.equipHelmet.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Helmet.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_0__/* .EquipmentTypes */ .WA.HELMET;
        },
        enumerable: false,
        configurable: true
    });
    Helmet.prototype.assignToPlayer = function (player) {
        player.equipment.helmet = this;
    };
    Helmet.prototype.unassignToPlayer = function (player) {
        player.equipment.helmet = null;
    };
    Helmet.prototype.currentEquipment = function (player) {
        return player.equipment.helmet;
    };
    return Helmet;
}(_Equipment__WEBPACK_IMPORTED_MODULE_0__/* .Equipment */ .$i));



/***/ }),

/***/ 2802:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I: () => (/* binding */ Legs)
/* harmony export */ });
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3107);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4655);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Legs = /** @class */ (function (_super) {
    __extends(Legs, _super);
    function Legs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Legs.prototype, "equipSoundId", {
        get: function () {
            return _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__/* .CACHE_ASSETS */ .fc.sounds.equipMetalLegs.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Legs.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_0__/* .EquipmentTypes */ .WA.LEGS;
        },
        enumerable: false,
        configurable: true
    });
    Legs.prototype.assignToPlayer = function (player) {
        player.equipment.legs = this;
    };
    Legs.prototype.unassignToPlayer = function (player) {
        player.equipment.legs = null;
    };
    Legs.prototype.currentEquipment = function (player) {
        return player.equipment.legs;
    };
    return Legs;
}(_Equipment__WEBPACK_IMPORTED_MODULE_0__/* .Equipment */ .$i));



/***/ }),

/***/ 4295:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: () => (/* binding */ Necklace)
/* harmony export */ });
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3107);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4655);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Necklace = /** @class */ (function (_super) {
    __extends(Necklace, _super);
    function Necklace() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Necklace.prototype, "equipSoundId", {
        get: function () {
            return _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__/* .CACHE_ASSETS */ .fc.sounds.equipFun.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Necklace.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_0__/* .EquipmentTypes */ .WA.NECK;
        },
        enumerable: false,
        configurable: true
    });
    Necklace.prototype.assignToPlayer = function (player) {
        player.equipment.necklace = this;
    };
    Necklace.prototype.unassignToPlayer = function (player) {
        player.equipment.necklace = null;
    };
    Necklace.prototype.currentEquipment = function (player) {
        return player.equipment.necklace;
    };
    return Necklace;
}(_Equipment__WEBPACK_IMPORTED_MODULE_0__/* .Equipment */ .$i));



/***/ }),

/***/ 7211:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: () => (/* binding */ Offhand)
/* harmony export */ });
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3107);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4655);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Offhand = /** @class */ (function (_super) {
    __extends(Offhand, _super);
    function Offhand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Offhand.prototype, "equipSoundId", {
        get: function () {
            return _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__/* .CACHE_ASSETS */ .fc.sounds.equipShield.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Offhand.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_0__/* .EquipmentTypes */ .WA.OFFHAND;
        },
        enumerable: false,
        configurable: true
    });
    Offhand.prototype.inventoryLeftClick = function (player) {
        var currentWeapon = player.equipment.weapon || null;
        var currentOffhand = player.equipment.offhand || null;
        var openInventorySlots = player.openInventorySlots();
        openInventorySlots.unshift(player.inventory.indexOf(this));
        var neededInventorySlots = 0;
        if (currentWeapon && currentWeapon.isTwoHander) {
            neededInventorySlots++;
        }
        if (neededInventorySlots > openInventorySlots.length) {
            return;
        }
        this.assignToPlayer(player);
        if (currentOffhand) {
            player.inventory[openInventorySlots.shift()] = currentOffhand;
        }
        else {
            player.inventory[openInventorySlots.shift()] = null;
            openInventorySlots = player.openInventorySlots();
        }
        if (currentWeapon && currentWeapon.isTwoHander) {
            player.inventory[openInventorySlots.shift()] = currentWeapon;
            player.equipment.weapon = null;
        }
        player.equipmentChanged();
        this.scheduleEquipmentSound();
    };
    Offhand.prototype.assignToPlayer = function (player) {
        player.equipment.offhand = this;
    };
    Offhand.prototype.unassignToPlayer = function (player) {
        player.equipment.offhand = null;
    };
    Offhand.prototype.currentEquipment = function (player) {
        return player.equipment.offhand;
    };
    return Offhand;
}(_Equipment__WEBPACK_IMPORTED_MODULE_0__/* .Equipment */ .$i));



/***/ }),

/***/ 6338:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  E: () => (/* binding */ Potion)
});

// EXTERNAL MODULE: ./src/assets/images/potions/Vial.png
var Vial = __webpack_require__(155);
// EXTERNAL MODULE: ./src/sdk/Item.ts
var Item = __webpack_require__(2376);
// EXTERNAL MODULE: ./src/sdk/utils/ImageLoader.ts
var ImageLoader = __webpack_require__(2987);
// EXTERNAL MODULE: ./src/sdk/rendering/GLTFAnimationConstants.ts
var GLTFAnimationConstants = __webpack_require__(1708);
;// CONCATENATED MODULE: ./src/assets/sounds/liquid_2401.ogg
const liquid_2401_namespaceObject = __webpack_require__.p + "ab6db81a3c50eaab57e3.ogg";
// EXTERNAL MODULE: ./src/sdk/utils/SoundCache.ts
var SoundCache = __webpack_require__(6018);
;// CONCATENATED MODULE: ./src/sdk/gear/Potion.ts
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var Potion = /** @class */ (function (_super) {
    __extends(Potion, _super);
    function Potion() {
        var _this = _super.call(this) || this;
        _this.inventorySprite = ImageLoader/* ImageLoader */.$.createImage(_this.inventoryImage);
        _this.vial = ImageLoader/* ImageLoader */.$.createImage(Vial);
        _this.doses = 4;
        _this.defaultAction = "Drink";
        return _this;
    }
    Potion.prototype.drink = function (player) {
        player.interruptCombat();
        player.playAnimation(GLTFAnimationConstants/* PlayerAnimationIndices */.L.Eat, true);
    };
    Object.defineProperty(Potion.prototype, "weight", {
        get: function () {
            if (this.doses === 4) {
                return 0.035;
            }
            else if (this.doses === 3) {
                return 0.03;
            }
            else if (this.doses === 2) {
                return 0.025;
            }
            else if (this.doses === 1) {
                return 0.02;
            }
        },
        enumerable: false,
        configurable: true
    });
    Potion.prototype.updateInventorySprite = function () {
        // Override me
    };
    Object.defineProperty(Potion.prototype, "hasInventoryLeftClick", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Potion.prototype.inventoryLeftClick = function (player) {
        var didDrink = false;
        if (this.doses > 0) {
            didDrink = player.eats.drinkPotion(this);
        }
        if (this.doses === 0) {
            this.consumeItem(player);
        }
        if (didDrink) {
            SoundCache/* SoundCache */.U.play(new SoundCache/* Sound */.A(liquid_2401_namespaceObject, 0.1));
        }
        this.updateInventorySprite();
    };
    return Potion;
}(Item/* Item */.q));



/***/ }),

/***/ 5941:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   J: () => (/* binding */ Ring)
/* harmony export */ });
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3107);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4655);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Ring = /** @class */ (function (_super) {
    __extends(Ring, _super);
    function Ring() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Ring.prototype, "equipSoundId", {
        get: function () {
            return _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__/* .CACHE_ASSETS */ .fc.sounds.equipFun.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ring.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_0__/* .EquipmentTypes */ .WA.RING;
        },
        enumerable: false,
        configurable: true
    });
    Ring.prototype.assignToPlayer = function (player) {
        player.equipment.ring = this;
    };
    Ring.prototype.unassignToPlayer = function (player) {
        player.equipment.ring = null;
    };
    Ring.prototype.currentEquipment = function (player) {
        return player.equipment.ring;
    };
    return Ring;
}(_Equipment__WEBPACK_IMPORTED_MODULE_0__/* .Equipment */ .$i));



/***/ }),

/***/ 6103:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: () => (/* binding */ Weapon)
/* harmony export */ });
/* harmony import */ var _Unit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3016);
/* harmony import */ var _utils_ImageLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2987);
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3107);
/* harmony import */ var _weapons_Projectile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2402);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2543);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _SetEffect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8350);
/* harmony import */ var _ItemName__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(243);
/* harmony import */ var _AttackStylesController__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(186);
/* harmony import */ var _Random__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7212);
/* harmony import */ var _rendering_GLTFAnimationConstants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1708);

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};










var Weapon = /** @class */ (function (_super) {
    __extends(Weapon, _super);
    function Weapon(projectileOptions) {
        if (projectileOptions === void 0) { projectileOptions = {}; }
        var _this = _super.call(this) || this;
        _this.projectileOptions = projectileOptions;
        _this.lastHitHit = false;
        _this.selected = false;
        _this.inventorySprite = _utils_ImageLoader__WEBPACK_IMPORTED_MODULE_1__/* .ImageLoader */ .$.createImage(_this.inventoryImage);
        return _this;
    }
    Weapon.prototype.attackStyles = function () {
        return [];
    };
    Weapon.prototype.compatibleAmmo = function () {
        return [];
    };
    Weapon.prototype.attackStyleCategory = function () {
        return null;
    };
    Weapon.prototype.defaultStyle = function () {
        return _AttackStylesController__WEBPACK_IMPORTED_MODULE_7__/* .AttackStyle */ .aF.RAPID;
    };
    Weapon.prototype.attackStyle = function () {
        return _AttackStylesController__WEBPACK_IMPORTED_MODULE_7__/* .AttackStylesController */ .D2.controller.getAttackStyleForType(this.attackStyleCategory(), this);
    };
    Weapon.prototype.assignToPlayer = function (player) {
        player.equipment.weapon = this;
        player.interruptCombat();
    };
    Weapon.prototype.unassignToPlayer = function (player) {
        player.equipment.weapon = null;
    };
    Weapon.prototype.currentEquipment = function (player) {
        return player.equipment.weapon;
    };
    Weapon.prototype.hasSpecialAttack = function () {
        return false;
    };
    Object.defineProperty(Weapon.prototype, "specialAttackAnimationId", {
        get: function () {
            return this.attackAnimationId;
        },
        enumerable: false,
        configurable: true
    });
    Weapon.prototype.specialAttackDrain = function () {
        return 50;
    };
    Weapon.prototype.specialAttack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        // Override me
        return false;
    };
    Weapon.prototype.inventoryLeftClick = function (player) {
        var currentWeapon = player.equipment.weapon || null;
        var currentOffhand = player.equipment.offhand || null;
        var openInventorySlots = player.openInventorySlots();
        openInventorySlots.unshift(player.inventory.indexOf(this));
        var neededInventorySlots = 0;
        if (this.isTwoHander && currentWeapon) {
            neededInventorySlots++;
        }
        if (this.isTwoHander && currentOffhand) {
            neededInventorySlots++;
        }
        if (currentWeapon) {
            neededInventorySlots--;
        }
        if (neededInventorySlots > openInventorySlots.length) {
            return;
        }
        this.assignToPlayer(player);
        if (currentWeapon) {
            player.inventory[openInventorySlots.shift()] = currentWeapon;
        }
        else {
            player.inventory[openInventorySlots.shift()] = null;
            openInventorySlots = player.openInventorySlots();
        }
        if (this.isTwoHander && currentOffhand) {
            player.inventory[openInventorySlots.shift()] = currentOffhand;
            player.equipment.offhand = null;
        }
        player.equipmentChanged();
        this.scheduleEquipmentSound();
    };
    Weapon.prototype.cast = function (from, to) {
        // Override me
    };
    Weapon.prototype.rollDamage = function (from, to, bonuses) {
        this.damageRoll = Math.floor(this._rollAttack(from, to, bonuses));
        this.damage = Math.min(this.damageRoll, to.currentStats.hitpoint);
    };
    Weapon.prototype.calculateHitDelay = function (distance) {
        return 999;
    };
    Weapon.prototype.getMaxDamageCap = function (bonuses) {
        return 100;
    };
    // Return value: If the attack was performed or not. If the attack was not performed, do not reset timers.
    Weapon.prototype.attack = function (from, to, bonuses, options) {
        var _this = this;
        var _a, _b, _c;
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        this._calculatePrayerEffects(from, to, bonuses);
        bonuses.styleBonus = bonuses.styleBonus || 0;
        bonuses.voidMultiplier = bonuses.voidMultiplier || 1;
        bonuses.gearMeleeMultiplier = bonuses.gearMeleeMultiplier || 1;
        bonuses.gearMageMultiplier = bonuses.gearMageMultiplier || 1;
        bonuses.gearRangeMultiplier = bonuses.gearRangeMultiplier || 1;
        bonuses.overallMultiplier = bonuses.overallMultiplier || 1.0;
        this.rollDamage(from, to, bonuses);
        if (this.damage === -1) {
            return false;
        }
        if (to.setEffects) {
            (0,lodash__WEBPACK_IMPORTED_MODULE_4__.find)(to.setEffects, function (effect) {
                if (effect.effectName() === _SetEffect__WEBPACK_IMPORTED_MODULE_5__/* .SetEffectTypes */ .F.JUSTICIAR) {
                    var tosDefenceBonus = to.bonuses.defence[bonuses.attackStyle];
                    if (tosDefenceBonus !== undefined) {
                        // hack?
                        var justiciarDamageReduction = Math.max(tosDefenceBonus / 3000, 0);
                        _this.damage -= Math.ceil(justiciarDamageReduction * _this.damage);
                    }
                }
            });
        }
        // Protection prayers
        if (this.isBlockable(from, to, bonuses)) {
            this.damage = 0;
        }
        // sanitize damage output
        this.damage = Math.floor(Math.max(Math.min(to.currentStats.hitpoint, this.damage, this.getMaxDamageCap(bonuses)), 0));
        if (to.equipment.ring && to.equipment.ring.itemName === _ItemName__WEBPACK_IMPORTED_MODULE_6__/* .ItemName */ .P.RING_OF_SUFFERING_I && this.damage > 0) {
            from.addProjectile(new _weapons_Projectile__WEBPACK_IMPORTED_MODULE_3__/* .Projectile */ .c6(this, Math.floor(this.damage * 0.1) + 1, to, from, "recoil", {
                reduceDelay: 15,
                visuals: { hidden: true },
            }));
        }
        this.grantXp(from, to);
        var modifiers = to.incomingAttackRollModifiers({ attacker: from, weapon: this, bonuses: bonuses });
        this.registerProjectile(from, to, bonuses, (0,_weapons_Projectile__WEBPACK_IMPORTED_MODULE_3__/* .mergeProjectileOptions */ .K7)(options, {
            consumeTargetMaxDamageRoll: modifiers.maxDamage && modifiers.consumeAfterDamage,
        }));
        var attackSpotAnim = this.attackSpotAnim;
        if (attackSpotAnim) {
            from.addSpotAnim(__assign(__assign({}, attackSpotAnim), { channel: (_a = attackSpotAnim.channel) !== null && _a !== void 0 ? _a : "weapon-attack", animation: (_c = (_b = attackSpotAnim.animation) !== null && _b !== void 0 ? _b : this.attackAnimationId) !== null && _c !== void 0 ? _c : undefined }));
        }
        return true;
    };
    Weapon.prototype._rollAttack = function (from, to, bonuses) {
        this.lastHitHit = false;
        var modifiers = to.incomingAttackRollModifiers({ attacker: from, weapon: this, bonuses: bonuses });
        var didHit = modifiers.guaranteedHit || _Random__WEBPACK_IMPORTED_MODULE_8__/* .Random */ .o.get() <= this._hitChance(from, to, bonuses);
        return didHit ? this._calculateHitDamage(from, to, bonuses) : 0;
    };
    Weapon.prototype._calculateHitDamage = function (from, to, bonuses) {
        this.lastHitHit = true;
        if (to.incomingAttackRollModifiers({ attacker: from, weapon: this, bonuses: bonuses }).maxDamage) {
            return this._maxHit(from, to, bonuses);
        }
        return Math.floor(_Random__WEBPACK_IMPORTED_MODULE_8__/* .Random */ .o.get() * (this._maxHit(from, to, bonuses) + 1));
    };
    Weapon.prototype._attackRoll = function (from, to, bonuses) {
        return 0; // weapons implement this at the type tier
    };
    Weapon.prototype._defenceRoll = function (from, to, bonuses) {
        return 0; // weapons implement this at the type tier
    };
    Weapon.prototype._maxHit = function (from, to, bonuses) {
        return 0; // weapons implement this at the type tier
    };
    Weapon.prototype._hitChance = function (from, to, bonuses) {
        var attackRoll = this._attackRoll(from, to, bonuses);
        var defenceRoll = this._defenceRoll(from, to, bonuses);
        var hitChance = attackRoll > defenceRoll ? 1 - (defenceRoll + 2) / (2 * attackRoll + 1) : attackRoll / (2 * defenceRoll + 1);
        return hitChance;
    };
    Weapon.prototype.isBlockable = function (from, to, bonuses) {
        return false; // weapons implement this at the type tier
    };
    Weapon.prototype.grantXp = function (from, to) {
        if (from.type === _Unit__WEBPACK_IMPORTED_MODULE_0__/* .UnitTypes */ .eK.PLAYER && this.damage > 0) {
            _AttackStylesController__WEBPACK_IMPORTED_MODULE_7__/* .AttackStylesController */ .D2.controller
                .getWeaponXpDrops(this.attackStyle(), this.damage, to.xpBonusMultiplier, this.attackStyleCategory())
                .forEach(function (xpDrop) { return from.grantXp(xpDrop); });
        }
    };
    Weapon.prototype._calculatePrayerEffects = function (from, to, bonuses) {
        // weapons implement this at the type tier
    };
    Weapon.prototype.registerProjectile = function (from, to, bonuses, options) {
        if (options === void 0) { options = {}; }
        to.addProjectile(new _weapons_Projectile__WEBPACK_IMPORTED_MODULE_3__/* .Projectile */ .c6(this, this.damage, from, to, bonuses.attackStyle, (0,_weapons_Projectile__WEBPACK_IMPORTED_MODULE_3__/* .mergeProjectileOptions */ .K7)({ sound: this.attackSound, hitSound: this.attackLandingSound, visuals: { model: this.projectileModel } }, this.projectileOptions, options)));
    };
    Object.defineProperty(Weapon.prototype, "image", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "attackRange", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "attackSpeed", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "aoe", {
        get: function () {
            return [{ x: 0, y: 0 }];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "isAreaAttack", {
        // Returns true if this attack is an area-based attack that doesn't require line of sight to
        // the target (including if the target is underneath).
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "isMeleeAttack", {
        // Returns true if this attack is a melee attack (and therefore cannot attack on corners).
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "isTwoHander", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Weapon.isMeleeAttackStyle = function (style) {
        return style === "crush" || style === "slash" || style === "stab";
    };
    Object.defineProperty(Weapon.prototype, "attackSound", {
        get: function () {
            // Override me
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "specialAttackSound", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "attackLandingSound", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "projectileModel", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "idleAnimationId", {
        get: function () {
            return _rendering_GLTFAnimationConstants__WEBPACK_IMPORTED_MODULE_9__/* .PlayerAnimationIndices */ .L.Idle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "walkAnimationId", {
        get: function () {
            return _rendering_GLTFAnimationConstants__WEBPACK_IMPORTED_MODULE_9__/* .PlayerAnimationIndices */ .L.Walk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "runAnimationId", {
        get: function () {
            return _rendering_GLTFAnimationConstants__WEBPACK_IMPORTED_MODULE_9__/* .PlayerAnimationIndices */ .L.Run;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "walkBackAnimationId", {
        get: function () {
            return _rendering_GLTFAnimationConstants__WEBPACK_IMPORTED_MODULE_9__/* .PlayerAnimationIndices */ .L.WalkBack;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "strafeLeftAnimationId", {
        get: function () {
            return _rendering_GLTFAnimationConstants__WEBPACK_IMPORTED_MODULE_9__/* .PlayerAnimationIndices */ .L.StrafeLeft;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "strafeRightAnimationId", {
        get: function () {
            return _rendering_GLTFAnimationConstants__WEBPACK_IMPORTED_MODULE_9__/* .PlayerAnimationIndices */ .L.StrafeRight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Weapon.prototype, "attackSpotAnim", {
        /** Graphic attached to the wielder when an ordinary attack begins. */
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    return Weapon;
}(_Equipment__WEBPACK_IMPORTED_MODULE_2__/* .Equipment */ .$i));



/***/ }),

/***/ 7657:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   KU: () => (/* binding */ AnimationFrameSoundPlayer),
/* harmony export */   xA: () => (/* binding */ preloadAnimationFrameSounds)
/* harmony export */ });
/* unused harmony exports frameSoundsBetween, chooseFrameSound */
/* harmony import */ var _audio_CacheSoundEffects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5432);
/* harmony import */ var _utils_SoundCache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6018);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9156);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var CACHE_ANIMATION_SOUND_VOLUME = 0.1;
function timedFrameSounds(animation) {
    var _a, _b;
    var byFrame = (_a = animation.frameSounds) !== null && _a !== void 0 ? _a : {};
    var starts = [];
    var elapsed = 0;
    for (var frame = 0; frame < animation.lengths.length; frame++) {
        starts[frame] = elapsed;
        elapsed += ((_b = animation.lengths[frame]) !== null && _b !== void 0 ? _b : 0) / _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .CLIENT_CYCLES_PER_SECOND */ .ZC;
    }
    return Object.entries(byFrame)
        .map(function (_a) {
        var frame = _a[0], sounds = _a[1];
        return ({ at: starts[Number(frame)], sounds: sounds });
    })
        .filter(function (_a) {
        var at = _a.at, sounds = _a.sounds;
        return Number.isFinite(at) && sounds.length;
    })
        .sort(function (a, b) { return a.at - b.at; });
}
/** Return sound groups whose frame boundary was crossed since the last draw. */
function frameSoundsBetween(animation, previousElapsed, elapsed, looping) {
    if (elapsed < 0)
        return [];
    var events = timedFrameSounds(animation);
    if (!events.length)
        return [];
    var total = animation.lengths.reduce(function (sum, length) { return sum + length; }, 0) / _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .CLIENT_CYCLES_PER_SECOND */ .ZC;
    if (total <= 0)
        return [];
    var from = previousElapsed == null || elapsed < previousElapsed ? -Number.EPSILON : previousElapsed;
    if (!looping) {
        var to_1 = Math.min(elapsed, total);
        return events.filter(function (_a) {
            var at = _a.at;
            return at > from && at <= to_1;
        }).map(function (_a) {
            var sounds = _a.sounds;
            return sounds;
        });
    }
    // A suspended browser can advance by many loops in one draw. Replaying that
    // whole backlog produces an audio burst, so retain at most the current loop.
    from = Math.max(from, elapsed - total);
    var crossed = [];
    for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
        var event_1 = events_1[_i];
        var cycle = Math.max(0, Math.floor((from - event_1.at) / total) + 1);
        for (var absoluteTime = cycle * total + event_1.at; absoluteTime <= elapsed; absoluteTime = ++cycle * total + event_1.at) {
            crossed.push(__assign(__assign({}, event_1), { absoluteTime: absoluteTime }));
        }
    }
    return crossed.sort(function (a, b) { return a.absoluteTime - b.absoluteTime; }).map(function (_a) {
        var sounds = _a.sounds;
        return sounds;
    });
}
/** Pick one cache-authored variant. Weight values are relative to siblings. */
function chooseFrameSound(sounds, random) {
    if (random === void 0) { random = Math.random; }
    if (!sounds.length)
        return undefined;
    var weights = sounds.map(function (sound) { return Math.max(0, sound.weight); });
    var total = weights.reduce(function (sum, weight) { return sum + weight; }, 0);
    if (total <= 0)
        return sounds[Math.min(sounds.length - 1, Math.floor(random() * sounds.length))];
    var roll = random() * total;
    for (var index = 0; index < sounds.length; index++) {
        roll -= weights[index];
        if (roll < 0)
            return sounds[index];
    }
    return sounds[sounds.length - 1];
}
/** Pre-synthesise every unique effect owned by a set of cache animations. */
function preloadAnimationFrameSounds(animations) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var ids, _i, animations_1, animation, _b, _c, variants, _d, variants_1, sound;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    ids = new Set();
                    for (_i = 0, animations_1 = animations; _i < animations_1.length; _i++) {
                        animation = animations_1[_i];
                        for (_b = 0, _c = Object.values((_a = animation.frameSounds) !== null && _a !== void 0 ? _a : {}); _b < _c.length; _b++) {
                            variants = _c[_b];
                            for (_d = 0, variants_1 = variants; _d < variants_1.length; _d++) {
                                sound = variants_1[_d];
                                ids.add(sound.id);
                            }
                        }
                    }
                    return [4 /*yield*/, Promise.all(Array.from(ids).map(function (id) { return _utils_SoundCache__WEBPACK_IMPORTED_MODULE_1__/* .SoundCache */ .U.preload((0,_audio_CacheSoundEffects__WEBPACK_IMPORTED_MODULE_0__/* .cacheSound */ .cp)(id)); }))];
                case 1:
                    _e.sent();
                    return [2 /*return*/];
            }
        });
    });
}
var AnimationFrameSoundPlayer = /** @class */ (function () {
    function AnimationFrameSoundPlayer(delayMs) {
        if (delayMs === void 0) { delayMs = 0; }
        this.delayMs = delayMs;
        this.animationId = null;
        this.elapsed = null;
    }
    AnimationFrameSoundPlayer.prototype.reset = function () {
        this.animationId = null;
        this.elapsed = null;
    };
    AnimationFrameSoundPlayer.prototype.advance = function (animationId, animation, elapsed, looping, sourceLocation) {
        var previous = this.animationId === animationId ? this.elapsed : null;
        for (var _i = 0, _a = frameSoundsBetween(animation, previous, elapsed, looping); _i < _a.length; _i++) {
            var variants = _a[_i];
            var sound = chooseFrameSound(variants);
            if (sound) {
                var isAreaSound = (sound.location & 31) > 0;
                var area = isAreaSound && sourceLocation
                    ? { location: sourceLocation, range: sound.location & 255, retain: sound.retain & 31 }
                    : undefined;
                _utils_SoundCache__WEBPACK_IMPORTED_MODULE_1__/* .SoundCache */ .U.play(new _utils_SoundCache__WEBPACK_IMPORTED_MODULE_1__/* .Sound */ .A((0,_audio_CacheSoundEffects__WEBPACK_IMPORTED_MODULE_0__/* .cacheSound */ .cp)(sound.id), CACHE_ANIMATION_SOUND_VOLUME, this.delayMs, area), isAreaSound);
            }
        }
        this.animationId = animationId;
        this.elapsed = elapsed;
    };
    return AnimationFrameSoundPlayer;
}());



/***/ }),

/***/ 4989:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W: () => (/* binding */ BasicModel),
/* harmony export */   f: () => (/* binding */ BasicModelShape)
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9604);
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(three__WEBPACK_IMPORTED_MODULE_0__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var BasicModelShape;
(function (BasicModelShape) {
    BasicModelShape[BasicModelShape["BOX"] = 0] = "BOX";
    BasicModelShape[BasicModelShape["SPHERE"] = 1] = "SPHERE";
})(BasicModelShape || (BasicModelShape = {}));
var BasicModel = /** @class */ (function () {
    function BasicModel(size, height, color, unit, drawOffset, shape) {
        if (drawOffset === void 0) { drawOffset = {}; }
        if (shape === void 0) { shape = BasicModelShape.BOX; }
        this.size = size;
        this.drawOffset = drawOffset;
        this.shape = shape;
        this.geometry =
            shape === BasicModelShape.BOX
                ? new three__WEBPACK_IMPORTED_MODULE_0__.BoxGeometry(size, height, size)
                : new three__WEBPACK_IMPORTED_MODULE_0__.SphereGeometry(size / 2, 8, 8);
        this.material = new three__WEBPACK_IMPORTED_MODULE_0__.MeshStandardMaterial({ color: color });
        this.mesh = new three__WEBPACK_IMPORTED_MODULE_0__.Mesh(this.geometry, this.material);
        this.mesh.userData.clickable = unit !== null && unit.selectable;
        this.mesh.userData.unit = unit;
    }
    BasicModel.forRenderable = function (r) {
        return new BasicModel(r.size, r.height, r.colorHex, r);
    };
    BasicModel.forRenderableCentered = function (r) {
        return new BasicModel(r.size, r.height, r.colorHex, r, {
            x: r.size / 2,
            z: -r.size / 2,
        });
    };
    // centered sphere
    BasicModel.sphereForRenderable = function (r) {
        return new BasicModel(r.size, r.height, r.colorHex, r, { x: r.size / 2, z: -r.size / 2 }, BasicModelShape.SPHERE);
    };
    BasicModel.prototype.draw = function (scene, clockDelta, tickPercent, location, rotation, pitch, visible) {
        if (this.mesh.parent !== scene) {
            scene.add(this.mesh);
        }
        var size = this.size;
        var x = location.x, y = location.y, z = location.z;
        this.mesh.visible = visible;
        // conversion from Location3 to Vector3
        this.mesh.position.x = x + size / 2;
        this.mesh.position.y = z + size / 2;
        this.mesh.position.z = y - size / 2;
        this.mesh.position.add({
            x: this.drawOffset.x || 0,
            y: this.drawOffset.y || 0,
            z: this.drawOffset.z || 0,
        });
        this.mesh.setRotationFromAxisAngle(new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(0, 1, 0), rotation);
    };
    BasicModel.prototype.destroy = function (scene) {
        if (this.mesh.parent === scene) {
            scene.remove(this.mesh);
        }
    };
    BasicModel.prototype.getWorldPosition = function () {
        return this.mesh.getWorldPosition(new three__WEBPACK_IMPORTED_MODULE_0__.Vector3());
    };
    BasicModel.prototype.preload = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // do nothing
                return [2 /*return*/];
            });
        });
    };
    return BasicModel;
}());



/***/ }),

/***/ 702:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bi: () => (/* binding */ CacheRenderBundleError),
/* harmony export */   O0: () => (/* reexport safe */ _cache_render_format__WEBPACK_IMPORTED_MODULE_1__.O0),
/* harmony export */   j9: () => (/* binding */ CacheRender),
/* harmony export */   og: () => (/* binding */ validateCacheRenderBundleManifest),
/* harmony export */   zL: () => (/* binding */ CacheRenderBundle)
/* harmony export */ });
/* harmony import */ var _CacheRenderReference__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7757);
/* harmony import */ var _cache_render_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3648);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var CacheRenderBundleError = /** @class */ (function (_super) {
    __extends(CacheRenderBundleError, _super);
    function CacheRenderBundleError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        return _this;
    }
    return CacheRenderBundleError;
}(Error));

function validateCacheRenderBundleManifest(value) {
    if (!(0,_cache_render_format__WEBPACK_IMPORTED_MODULE_1__/* .isCacheRenderBundleManifest */ .Yt)(value))
        throw new CacheRenderBundleError("manifest", "Invalid cache render bundle manifest or unsupported schema version");
    return value;
}
function referenceKey(reference) {
    if (reference.kind === "npc")
        return "npc:".concat(reference.definitionId);
    if (reference.kind === "model")
        return "model:".concat(reference.modelId);
    if (reference.kind === "spotAnim")
        return "spotAnim";
    if (reference.kind === "player")
        return "player:".concat(reference.loadout.map(_CacheRenderReference__WEBPACK_IMPORTED_MODULE_0__/* .cacheRenderItemKey */ .T).join(","));
    return "asset";
}
var CacheRenderBundle = /** @class */ (function () {
    function CacheRenderBundle(baseUrl, manifest) {
        this.baseUrl = baseUrl;
        this.manifest = manifest;
    }
    CacheRenderBundle.load = function (manifestUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1, manifest, _a, error_2, manifestAbsoluteUrl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(manifestUrl)];
                    case 1:
                        response = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        throw new CacheRenderBundleError("network", "Unable to load cache render manifest: ".concat(error_1.message));
                    case 3:
                        if (!response.ok)
                            throw new CacheRenderBundleError("network", "Unable to load cache render manifest (".concat(response.status, ")"));
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        _a = validateCacheRenderBundleManifest;
                        return [4 /*yield*/, response.json()];
                    case 5:
                        manifest = _a.apply(void 0, [_b.sent()]);
                        return [3 /*break*/, 7];
                    case 6:
                        error_2 = _b.sent();
                        if (error_2 instanceof CacheRenderBundleError)
                            throw error_2;
                        throw new CacheRenderBundleError("manifest", "Cache render manifest is not JSON");
                    case 7:
                        manifestAbsoluteUrl = new URL(manifestUrl, window.location.href);
                        return [2 /*return*/, new CacheRenderBundle(new URL(".", manifestAbsoluteUrl).toString(), manifest)];
                }
            });
        });
    };
    CacheRenderBundle.prototype.assetIds = function (reference) {
        var _this = this;
        if (reference.kind === "spotAnim")
            return [];
        if (reference.kind === "asset")
            return [reference.assetId];
        if (reference.kind === "player" && this.manifest.playerItems) {
            var itemIds_1 = reference.loadout.map(function (item) { return _this.manifest.playerItems[(0,_CacheRenderReference__WEBPACK_IMPORTED_MODULE_0__/* .cacheRenderItemKey */ .T)(item)] || _this.manifest.playerItems[item]; });
            var missing = reference.loadout.filter(function (item, index) { return !itemIds_1[index]; });
            if (!missing.length)
                return itemIds_1.filter(function (id, index) { return itemIds_1.indexOf(id) === index; });
            throw new CacheRenderBundleError("missing-asset", "Bundle has no player item data for ".concat(missing.join(", ")));
        }
        var ids = this.manifest.references[referenceKey(reference)];
        if (ids)
            return ids;
        throw new CacheRenderBundleError("missing-asset", "Bundle has no render data for ".concat(referenceKey(reference)));
    };
    CacheRenderBundle.prototype.spotAnimIds = function (reference) {
        var _this = this;
        var spotAnims = reference.kind === "model" || reference.kind === "asset" ? undefined : reference.spotAnims;
        return (spotAnims !== null && spotAnims !== void 0 ? spotAnims : []).map(function (spotAnim) { var _a; return (_a = _this.manifest.spotAnims) === null || _a === void 0 ? void 0 : _a[String(spotAnim.id)]; }).filter(function (id) { return Boolean(id); });
    };
    CacheRenderBundle.prototype.sharedAssetIds = function (reference) {
        var _a;
        if (reference.kind !== "player")
            return [];
        var id = (_a = this.manifest.sharedAssets) === null || _a === void 0 ? void 0 : _a.playerAnimations;
        return id ? [id] : [];
    };
    CacheRenderBundle.prototype.allSpotAnimIds = function () {
        var _this = this;
        var _a;
        var ids = [];
        Object.keys((_a = this.manifest.spotAnims) !== null && _a !== void 0 ? _a : {}).forEach(function (key) { var _a; var id = (_a = _this.manifest.spotAnims) === null || _a === void 0 ? void 0 : _a[key]; if (id && ids.indexOf(id) < 0)
            ids.push(id); });
        return ids;
    };
    CacheRenderBundle.prototype.fetchAsset = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var asset;
            return __generator(this, function (_a) {
                asset = this.manifest.assets[id];
                if (!asset)
                    throw new CacheRenderBundleError("missing-asset", "Bundle is missing asset ".concat(id));
                return [2 /*return*/, this.fetchManifestAsset(asset, "cache render asset ".concat(id))];
            });
        });
    };
    CacheRenderBundle.prototype.fetchSoundEffects = function () {
        return __awaiter(this, void 0, void 0, function () {
            var asset;
            return __generator(this, function (_a) {
                asset = this.manifest.soundEffects;
                if (!asset)
                    throw new CacheRenderBundleError("missing-asset", "Bundle has no sound-effect pack");
                return [2 /*return*/, this.fetchManifestAsset(asset, "cache sound-effect pack")];
            });
        });
    };
    CacheRenderBundle.prototype.fetchManifestAsset = function (asset, label) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_3, bytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(new URL(asset.file, this.baseUrl).toString())];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        throw new CacheRenderBundleError("network", "Unable to load ".concat(label, ": ").concat(error_3.message));
                    case 3:
                        if (!response.ok)
                            throw new CacheRenderBundleError("missing-asset", "Unable to load ".concat(label, " (").concat(response.status, ")"));
                        return [4 /*yield*/, response.arrayBuffer()];
                    case 4:
                        bytes = _a.sent();
                        if (asset.bytes !== undefined && bytes.byteLength !== asset.bytes)
                            throw new CacheRenderBundleError("integrity", "Invalid length for ".concat(label));
                        if ((0,_cache_render_format__WEBPACK_IMPORTED_MODULE_1__/* .crc32 */ .QR)(new Uint8Array(bytes)) !== asset.crc32.toLowerCase())
                            throw new CacheRenderBundleError("integrity", "Integrity check failed for ".concat(label));
                        return [2 /*return*/, bytes];
                }
            });
        });
    };
    return CacheRenderBundle;
}());

/** Runtime configuration. Set `manifestUrl` to a locally extracted bundle to override the hosted default. */
var CacheRender = /** @class */ (function () {
    function CacheRender() {
    }
    CacheRender.configure = function (manifestUrl) { this.manifestUrl = manifestUrl; this.bundlePromise = null; };
    CacheRender.isConfigured = function () { return this.manifestUrl !== null; };
    CacheRender.bundle = function () {
        var _a;
        if (!this.manifestUrl)
            return Promise.reject(new CacheRenderBundleError("network", "No cache render bundle is configured"));
        return (_a = this.bundlePromise) !== null && _a !== void 0 ? _a : (this.bundlePromise = CacheRenderBundle.load(this.manifestUrl));
    };
    CacheRender.manifestUrl = null;
    CacheRender.bundlePromise = null;
    return CacheRender;
}());



/***/ }),

/***/ 6956:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: () => (/* binding */ CacheRenderInstancedModel)
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9604);
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(three__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _AnimationFrameSounds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7657);
/* harmony import */ var _CacheRenderBundle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(702);
/* harmony import */ var _utils_animations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3787);
/* harmony import */ var _utils_payloadUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4993);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9156);
/* harmony import */ var _utils_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8048);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};







// Animated instances cannot all mutate one shared geometry when their start
// delays differ. A pool therefore owns one pre-posed geometry per cache frame;
// instances move between frame buckets while retaining their own clock.
var DEFAULT_MAX_INSTANCES = 256;
var hiddenMatrixValue;
var hiddenMatrix = function () { return hiddenMatrixValue !== null && hiddenMatrixValue !== void 0 ? hiddenMatrixValue : (hiddenMatrixValue = new three__WEBPACK_IMPORTED_MODULE_0__.Matrix4().makeScale(0, 0, 0)); };
var pools = new Map();
function stableRecolorKey(recolor) {
    return JSON.stringify(Object.entries(recolor !== null && recolor !== void 0 ? recolor : {}).sort(function (_a, _b) {
        var left = _a[0];
        var right = _b[0];
        return left.localeCompare(right);
    }));
}
function poolKey(reference, ids, bundleVersion) {
    var spot = reference.kind === "spotAnim" ? reference.spotAnims[0] : undefined;
    // Placement, rotation, height and animation delay belong to the instance.
    // Recolouring changes shared vertex data and therefore still needs a pool.
    return "".concat(bundleVersion, ":").concat(reference.kind, ":").concat(ids.join(","), ":").concat(stableRecolorKey(spot === null || spot === void 0 ? void 0 : spot.recolor));
}
function posedFrames(positions, baseAlphas, vertexGroups, sourceVertices, alphaGroups, animayaGroups, animayaScales, animation) {
    var _a, _b, _c;
    var rawFrames = (_a = animation === null || animation === void 0 ? void 0 : animation.rawFrames) !== null && _a !== void 0 ? _a : [];
    var mayaFrames = (_b = animation === null || animation === void 0 ? void 0 : animation.mayaFrames) !== null && _b !== void 0 ? _b : [];
    var expandedFrames = (_c = animation === null || animation === void 0 ? void 0 : animation.frames) !== null && _c !== void 0 ? _c : [];
    var frameCount = rawFrames.length || mayaFrames.length || expandedFrames.length || 1;
    return Array.from({ length: frameCount }, function (_, frame) {
        var _a;
        var posedPositions = new Float32Array(positions);
        var posedAlphas = new Float32Array(baseAlphas);
        if (rawFrames[frame]) {
            (0,_utils_animations__WEBPACK_IMPORTED_MODULE_3__/* .applyRawFrame */ .c9)(posedPositions, vertexGroups, sourceVertices, rawFrames[frame], undefined, posedAlphas, alphaGroups);
        }
        else if (mayaFrames[frame]) {
            (0,_utils_animations__WEBPACK_IMPORTED_MODULE_3__/* .applyMayaFrame */ .ii)(posedPositions, mayaFrames[frame], animayaGroups, animayaScales);
        }
        else if (((_a = expandedFrames[frame]) === null || _a === void 0 ? void 0 : _a.length) === posedPositions.length) {
            posedPositions.set(expandedFrames[frame]);
        }
        return { positions: posedPositions, alphas: posedAlphas };
    });
}
var CacheRenderInstancedModel = /** @class */ (function () {
    function CacheRenderInstancedModel(renderable, reference, maxInstances, options) {
        if (maxInstances === void 0) { maxInstances = DEFAULT_MAX_INSTANCES; }
        if (options === void 0) { options = {}; }
        this.renderable = renderable;
        this.reference = reference;
        this.maxInstances = maxInstances;
        this.options = options;
        this.pool = null;
        this.slot = -1;
        this.currentFrame = -1;
        this.elapsed = 0;
        this.started = false;
        this.completionNotified = false;
        this.frameSoundPlayer = new _AnimationFrameSounds__WEBPACK_IMPORTED_MODULE_1__/* .AnimationFrameSoundPlayer */ .KU();
        this.worldPosition = new three__WEBPACK_IMPORTED_MODULE_0__.Vector3();
        this.transform = new three__WEBPACK_IMPORTED_MODULE_0__.Object3D();
        this.destroyed = false;
    }
    CacheRenderInstancedModel.forRenderable = function (renderable, reference, options) {
        return new CacheRenderInstancedModel(renderable, reference, DEFAULT_MAX_INSTANCES, options);
    };
    CacheRenderInstancedModel.prototype.ensurePool = function () {
        return __awaiter(this, void 0, void 0, function () {
            var bundle, ids, key, pool, placement_1, reused;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.pool)
                            return [2 /*return*/, this.pool];
                        return [4 /*yield*/, _CacheRenderBundle__WEBPACK_IMPORTED_MODULE_2__/* .CacheRender */ .j9.bundle()];
                    case 1:
                        bundle = _a.sent();
                        ids = this.reference.kind === "spotAnim"
                            ? bundle.spotAnimIds(this.reference)
                            : __spreadArray(__spreadArray([], bundle.assetIds(this.reference), true), bundle.sharedAssetIds(this.reference), true);
                        key = poolKey(this.reference, ids, bundle.manifest.bundleVersion);
                        pool = pools.get(key);
                        if (!pool) {
                            placement_1 = this.reference.kind === "spotAnim" ? this.reference.spotAnims[0] : undefined;
                            pool = {
                                ready: Promise.resolve(), capacity: this.maxInstances, next: 0, free: [], active: new Set(), frames: [],
                                scaleX: 1, scaleY: 1, animationId: -1, animationTotal: 0, loopElapsed: 0,
                                frameSoundPlayer: new _AnimationFrameSounds__WEBPACK_IMPORTED_MODULE_1__/* .AnimationFrameSoundPlayer */ .KU(), frameSoundsReady: Promise.resolve(),
                            };
                            pool.ready = Promise.all(ids.map(function (id) { return (0,_utils_payloadUtils__WEBPACK_IMPORTED_MODULE_4__/* .cachedPayload */ .Bv)(bundle, id); })).then(function (payloads) {
                                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
                                var payload = (0,_utils_payloadUtils__WEBPACK_IMPORTED_MODULE_4__/* .mergePayloads */ .GE)(payloads);
                                var spotPayload = payloads[0];
                                var metadata = (_b = (_a = spotPayload === null || spotPayload === void 0 ? void 0 : spotPayload.spotAnim) !== null && _a !== void 0 ? _a : payload.spotAnim) !== null && _b !== void 0 ? _b : {};
                                pool.scaleX = ((_c = payload.scale) !== null && _c !== void 0 ? _c : 1) * ((_d = metadata.resizeX) !== null && _d !== void 0 ? _d : 128) / 128;
                                pool.scaleY = ((_e = payload.scale) !== null && _e !== void 0 ? _e : 1) * ((_f = metadata.resizeY) !== null && _f !== void 0 ? _f : 128) / 128;
                                var groups = (_g = payload.vertexGroups) !== null && _g !== void 0 ? _g : [];
                                var sources = (_h = payload.sourceVertices) !== null && _h !== void 0 ? _h : [];
                                var baseAlphas = new Float32Array((_k = (_j = payload.alphas) === null || _j === void 0 ? void 0 : _j.map(_utils_colors__WEBPACK_IMPORTED_MODULE_6__/* .normalizeCacheAlpha */ .Ai)) !== null && _k !== void 0 ? _k : Array(payload.positions.length / 3).fill(0));
                                var alphaGroups = (_l = payload.alphaGroups) !== null && _l !== void 0 ? _l : [];
                                var animationId = _this.reference.kind === "spotAnim" ? metadata.animationId : (_o = (_m = payload.poseMap) === null || _m === void 0 ? void 0 : _m["0"]) !== null && _o !== void 0 ? _o : 0;
                                var animation = (_p = payload.animations) === null || _p === void 0 ? void 0 : _p[String(animationId)];
                                pool.animationId = animationId;
                                pool.animation = animation;
                                pool.animationTotal = animation ? (0,_utils_animations__WEBPACK_IMPORTED_MODULE_3__/* .sampleAnimation */ .D4)(animation, 0, false).total : 0;
                                pool.frameSoundsReady = (0,_AnimationFrameSounds__WEBPACK_IMPORTED_MODULE_1__/* .preloadAnimationFrameSounds */ .xA)(animation ? [animation] : [])
                                    .catch(function (error) { return console.error("[osrs-sdk] Cache animation sound preload failed", error); });
                                var terrain = _this.reference.kind === "asset" && _this.reference.assetId.endsWith("-terrain");
                                var materialOptions = {
                                    color: (_q = payload.color) !== null && _q !== void 0 ? _q : 0xffffff,
                                    vertexColors: Boolean((_r = payload.colors) === null || _r === void 0 ? void 0 : _r.length),
                                    transparent: Boolean((_s = payload.alphas) === null || _s === void 0 ? void 0 : _s.some(function (alpha) { return alpha !== 0; })),
                                    alphaTest: 0.01,
                                    polygonOffset: terrain,
                                    polygonOffsetFactor: terrain ? 1 : 0,
                                    polygonOffsetUnits: terrain ? 1 : 0,
                                };
                                // Cache payload colours already contain the game client's model lighting.
                                var material = new three__WEBPACK_IMPORTED_MODULE_0__.MeshBasicMaterial(materialOptions);
                                var recolor = (_t = placement_1 === null || placement_1 === void 0 ? void 0 : placement_1.recolor) !== null && _t !== void 0 ? _t : {};
                                var frameData = posedFrames(payload.positions, baseAlphas, groups, sources, alphaGroups, (_u = payload.animayaGroups) !== null && _u !== void 0 ? _u : [], (_v = payload.animayaScales) !== null && _v !== void 0 ? _v : [], animation);
                                pool.frames = frameData.map(function (frame) {
                                    var _a;
                                    var geometry = new three__WEBPACK_IMPORTED_MODULE_0__.BufferGeometry();
                                    geometry.setAttribute("position", new three__WEBPACK_IMPORTED_MODULE_0__.Float32BufferAttribute(frame.positions, 3));
                                    if (payload.colors && payload.colors.length * 3 === payload.positions.length) {
                                        var colors = (0,_utils_colors__WEBPACK_IMPORTED_MODULE_6__/* .cacheColorsToRgba */ .E2)(payload.colors, frame.alphas, spotPayload === null || spotPayload === void 0 ? void 0 : spotPayload.faceColors, recolor);
                                        geometry.setAttribute("color", new three__WEBPACK_IMPORTED_MODULE_0__.Float32BufferAttribute(colors, 4));
                                    }
                                    geometry.setIndex((_a = payload.indices) !== null && _a !== void 0 ? _a : []);
                                    geometry.computeVertexNormals();
                                    var mesh = new three__WEBPACK_IMPORTED_MODULE_0__.InstancedMesh(geometry, material, pool.capacity);
                                    mesh.frustumCulled = false;
                                    mesh.count = 0;
                                    for (var index = 0; index < pool.capacity; index++)
                                        mesh.setMatrixAt(index, hiddenMatrix());
                                    mesh.instanceMatrix.needsUpdate = true;
                                    return { mesh: mesh, active: new Set() };
                                });
                            });
                            pools.set(key, pool);
                        }
                        return [4 /*yield*/, pool.ready];
                    case 2:
                        _a.sent();
                        if (this.destroyed)
                            return [2 /*return*/, pool];
                        this.pool = pool;
                        if (this.slot < 0) {
                            if (!pool.active.size) {
                                pool.loopElapsed = 0;
                                pool.frameSoundPlayer.reset();
                            }
                            reused = pool.free.pop();
                            if (reused == null && pool.next >= pool.capacity)
                                throw new Error("Cache render instance capacity exceeded");
                            this.slot = reused !== null && reused !== void 0 ? reused : pool.next++;
                            pool.active.add(this.slot);
                        }
                        return [2 /*return*/, pool];
                }
            });
        });
    };
    CacheRenderInstancedModel.prototype.setFrame = function (scene, pool, frame, matrix) {
        if (this.currentFrame !== frame) {
            if (this.currentFrame >= 0) {
                var previous = pool.frames[this.currentFrame];
                previous.mesh.setMatrixAt(this.slot, hiddenMatrix());
                previous.mesh.instanceMatrix.needsUpdate = true;
                previous.active.delete(this.slot);
                if (!previous.active.size && previous.mesh.parent === scene)
                    scene.remove(previous.mesh);
            }
            this.currentFrame = frame;
            if (frame >= 0)
                pool.frames[frame].active.add(this.slot);
        }
        if (frame < 0)
            return;
        var bucket = pool.frames[frame];
        if (bucket.mesh.parent !== scene)
            scene.add(bucket.mesh);
        bucket.mesh.count = pool.next;
        bucket.mesh.setMatrixAt(this.slot, matrix !== null && matrix !== void 0 ? matrix : hiddenMatrix());
        bucket.mesh.instanceMatrix.needsUpdate = true;
    };
    CacheRenderInstancedModel.prototype.draw = function (scene, clockDelta, _tickPercent, location, rotation, pitch, visible, modelOffsets) {
        var _this = this;
        this.ensurePool().then(function (pool) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if (_this.destroyed || _this.slot < 0 || !pool.frames.length)
                return;
            var oneShot = _this.reference.kind === "spotAnim";
            if (oneShot && visible) {
                if (_this.started)
                    _this.elapsed += Math.max(0, clockDelta);
                else
                    _this.started = true;
            }
            else {
                var leader_1 = pool.capacity;
                pool.active.forEach(function (slot) { leader_1 = Math.min(leader_1, slot); });
                if (_this.slot === leader_1 && visible)
                    pool.loopElapsed += Math.max(0, clockDelta);
            }
            var placement = _this.reference.kind === "spotAnim" ? _this.reference.spotAnims[0] : undefined;
            var animationTime = (oneShot ? _this.elapsed : pool.loopElapsed) - ((_a = placement === null || placement === void 0 ? void 0 : placement.delay) !== null && _a !== void 0 ? _a : 0) / _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .CLIENT_CYCLES_PER_SECOND */ .ZC;
            var hasAnimation = Boolean(pool.animation && (((_b = pool.animation.rawFrames) === null || _b === void 0 ? void 0 : _b.length) || pool.animation.frames.length || ((_c = pool.animation.mayaFrames) === null || _c === void 0 ? void 0 : _c.length)));
            var animationSample = pool.animation ? (0,_utils_animations__WEBPACK_IMPORTED_MODULE_3__/* .sampleAnimation */ .D4)(pool.animation, animationTime, !oneShot) : undefined;
            var animationEnded = oneShot && animationTime >= 0 && (!hasAnimation || pool.animationTotal <= 0 || animationTime >= pool.animationTotal);
            if (animationEnded && !_this.completionNotified) {
                _this.completionNotified = true;
                (_e = (_d = _this.options).onSpotAnimComplete) === null || _e === void 0 ? void 0 : _e.call(_d);
            }
            var soundLocation = {
                x: location.x + (_this.renderable.size - 1) / 2,
                y: location.y - (_this.renderable.size - 1) / 2,
            };
            if (pool.animation && animationTime >= 0) {
                if (oneShot)
                    _this.frameSoundPlayer.advance(pool.animationId, pool.animation, Math.min(animationTime, pool.animationTotal), false, soundLocation);
                else {
                    var leader_2 = pool.capacity;
                    pool.active.forEach(function (slot) { leader_2 = Math.min(leader_2, slot); });
                    if (_this.slot === leader_2)
                        pool.frameSoundPlayer.advance(pool.animationId, pool.animation, pool.loopElapsed, true, soundLocation);
                }
            }
            var offset = modelOffsets[0];
            var size = _this.renderable.size;
            _this.worldPosition.set(location.x + size / 2 + ((_f = offset === null || offset === void 0 ? void 0 : offset.x) !== null && _f !== void 0 ? _f : 0), location.z - 0.49 + ((_g = offset === null || offset === void 0 ? void 0 : offset.z) !== null && _g !== void 0 ? _g : 0), location.y - size / 2 + ((_h = offset === null || offset === void 0 ? void 0 : offset.y) !== null && _h !== void 0 ? _h : 0));
            _this.transform.position.copy(_this.worldPosition);
            _this.transform.position.y += (_j = placement === null || placement === void 0 ? void 0 : placement.height) !== null && _j !== void 0 ? _j : 0;
            _this.transform.rotation.order = "YXZ";
            var basisRotation = oneShot ? 0 : Math.PI / 2;
            _this.transform.rotation.set(pitch, rotation + basisRotation + ((_k = placement === null || placement === void 0 ? void 0 : placement.rotation) !== null && _k !== void 0 ? _k : 0) * Math.PI / 1024, 0);
            _this.transform.scale.set(pool.scaleX, pool.scaleY, pool.scaleX);
            _this.transform.updateMatrix();
            var shown = visible && animationTime >= 0 && !animationEnded;
            var frame = shown
                ? (hasAnimation ? animationSample.frame : 0)
                : -1;
            _this.setFrame(scene, pool, frame, _this.transform.matrix);
        }).catch(function (error) { return console.error("[osrs-sdk] Cache render instance preload failed", error); });
    };
    CacheRenderInstancedModel.prototype.destroy = function (scene) {
        this.destroyed = true;
        if (this.pool && this.slot >= 0) {
            this.setFrame(scene, this.pool, -1);
            this.pool.active.delete(this.slot);
            this.pool.free.push(this.slot);
            this.slot = -1;
        }
    };
    CacheRenderInstancedModel.prototype.getWorldPosition = function () { return this.worldPosition; };
    CacheRenderInstancedModel.prototype.preload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pool;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ensurePool()];
                    case 1:
                        pool = _a.sent();
                        return [4 /*yield*/, pool.frameSoundsReady];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return CacheRenderInstancedModel;
}());



/***/ }),

/***/ 3752:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  q: () => (/* binding */ CacheRenderModel)
});

// EXTERNAL MODULE: external "three"
var external_three_ = __webpack_require__(9604);
// EXTERNAL MODULE: ./src/sdk/Renderable.ts
var Renderable = __webpack_require__(427);
// EXTERNAL MODULE: ./src/sdk/rendering/CacheRenderBundle.ts
var CacheRenderBundle = __webpack_require__(702);
;// CONCATENATED MODULE: ./src/sdk/rendering/utils/clickbox.ts

/** Owns model-space picking topology and reusable world-space clickbox data.
 * Configure after replacing geometry; invalidate after changing its pose or transform.
 * Returned arrays and bounds are borrowed storage, valid until the next update.
 */
var ClickboxController = /** @class */ (function () {
    function ClickboxController(getSize) {
        this.getSize = getSize;
        this.mesh = null;
        this.authoredMesh = null;
        this.clickboxVertexIndices = [];
        this.clickboxTriangleIndices = [];
        this.clickboxVertices = [];
        this.clickboxVerticesDirty = true;
        this.clickboxWorldBounds = new external_three_.Box3();
        this.clickboxBoundsDirty = true;
    }
    ClickboxController.prototype.configure = function (mesh, sourceVertices, authoredMesh) {
        var _a, _b, _c, _d, _e;
        if (authoredMesh === void 0) { authoredMesh = null; }
        this.mesh = mesh;
        this.authoredMesh = authoredMesh;
        var position = mesh.geometry.getAttribute("position");
        var sourceToClickboxIndex = new Map();
        var renderToClickboxIndex = [];
        this.clickboxVertexIndices = [];
        for (var index = 0; index < position.count; index++) {
            var source = (_a = sourceVertices[index]) !== null && _a !== void 0 ? _a : index;
            var uniqueIndex = sourceToClickboxIndex.get(source);
            if (uniqueIndex === undefined) {
                uniqueIndex = this.clickboxVertexIndices.length;
                sourceToClickboxIndex.set(source, uniqueIndex);
                this.clickboxVertexIndices.push(index);
            }
            renderToClickboxIndex[index] = uniqueIndex;
        }
        this.clickboxTriangleIndices = [];
        var indices = (_c = (_b = mesh.geometry.index) === null || _b === void 0 ? void 0 : _b.array) !== null && _c !== void 0 ? _c : [];
        for (var i = 0; i < indices.length; i += 3) {
            var a = renderToClickboxIndex[indices[i]], b = renderToClickboxIndex[indices[i + 1]], c = renderToClickboxIndex[indices[i + 2]];
            // The extractor represents client-hidden type-2 faces as [a, a, a].
            if (a === b && b === c)
                continue;
            this.clickboxTriangleIndices.push(a, b, c);
        }
        this.clickboxVertices = [];
        this.invalidate();
        if (authoredMesh) {
            var offset = this.clickboxVertexIndices.length;
            var authoredIndices = (_e = (_d = authoredMesh.geometry.index) === null || _d === void 0 ? void 0 : _d.array) !== null && _e !== void 0 ? _e : [];
            for (var i = 0; i < authoredIndices.length; i += 3) {
                var a = authoredIndices[i], b = authoredIndices[i + 1], c = authoredIndices[i + 2];
                if (a === b && b === c)
                    continue;
                this.clickboxTriangleIndices.push(offset + a, offset + b, offset + c);
            }
        }
    };
    ClickboxController.prototype.invalidate = function () {
        this.clickboxBoundsDirty = true;
        this.clickboxVerticesDirty = true;
    };
    ClickboxController.prototype.getVertices = function () {
        var _a, _b;
        if (!this.mesh || !this.mesh.visible)
            return [];
        if (!this.clickboxVerticesDirty)
            return this.clickboxVertices;
        this.mesh.updateWorldMatrix(true, false);
        var position = this.mesh.geometry.getAttribute("position");
        if (!position)
            return [];
        for (var i = 0; i < this.clickboxVertexIndices.length; i++) {
            var index = this.clickboxVertexIndices[i];
            var vertex = (_a = this.clickboxVertices[i]) !== null && _a !== void 0 ? _a : (this.clickboxVertices[i] = new external_three_.Vector3());
            vertex.set(position.getX(index), position.getY(index), position.getZ(index)).applyMatrix4(this.mesh.matrixWorld);
        }
        if (this.authoredMesh) {
            this.authoredMesh.updateWorldMatrix(true, false);
            var authored = this.authoredMesh.geometry.getAttribute("position");
            for (var i = 0; i < authored.count; i++) {
                var index = this.clickboxVertexIndices.length + i;
                var vertex = (_b = this.clickboxVertices[index]) !== null && _b !== void 0 ? _b : (this.clickboxVertices[index] = new external_three_.Vector3());
                vertex.set(authored.getX(i), authored.getY(i), authored.getZ(i)).applyMatrix4(this.authoredMesh.matrixWorld);
            }
        }
        this.clickboxVerticesDirty = false;
        return this.clickboxVertices;
    };
    ClickboxController.prototype.getBounds = function () {
        if (!this.mesh || !this.mesh.visible || !this.clickboxVertexIndices.length)
            return null;
        if (!this.clickboxBoundsDirty)
            return this.clickboxWorldBounds;
        this.mesh.updateWorldMatrix(true, false);
        // calculateBoundingBox rotates the actual vertices before taking extrema,
        // includes the origin, enforces 32-unit horizontal half-extents and adds
        // another 8 units for a one-tile model. Rotating a precomputed local box
        // would overestimate slender models, particularly at diagonal headings.
        var e = this.mesh.matrixWorld.elements;
        this.clickboxWorldBounds.min.set(e[12], e[13], e[14]);
        this.clickboxWorldBounds.max.copy(this.clickboxWorldBounds.min);
        this.expandBounds(this.mesh.geometry.getAttribute("position"), this.mesh.matrixWorld, this.clickboxVertexIndices);
        if (this.authoredMesh) {
            this.authoredMesh.updateWorldMatrix(true, false);
            this.expandBounds(this.authoredMesh.geometry.getAttribute("position"), this.authoredMesh.matrixWorld);
        }
        var _a = this.clickboxWorldBounds, min = _a.min, max = _a.max;
        var padding = this.getSize() === 1 ? 8 / 128 : 0;
        for (var _i = 0, _b = ["x", "z"]; _i < _b.length; _i++) {
            var axis = _b[_i];
            var center = (min[axis] + max[axis]) / 2;
            var extent = Math.max(32 / 128, (max[axis] - min[axis] + 1 / 128) / 2) + padding;
            min[axis] = center - extent;
            max[axis] = center + extent;
        }
        min.y -= 1 / 256;
        max.y += 1 / 256;
        this.clickboxBoundsDirty = false;
        return this.clickboxWorldBounds;
    };
    ClickboxController.prototype.expandBounds = function (position, matrix, indices) {
        var _a, _b;
        var e = matrix.elements;
        var _c = this.clickboxWorldBounds, min = _c.min, max = _c.max;
        for (var i = 0; i < ((_a = indices === null || indices === void 0 ? void 0 : indices.length) !== null && _a !== void 0 ? _a : position.count); i++) {
            var index = (_b = indices === null || indices === void 0 ? void 0 : indices[i]) !== null && _b !== void 0 ? _b : i;
            var x = position.getX(index), y = position.getY(index), z = position.getZ(index);
            var wx = e[0] * x + e[4] * y + e[8] * z + e[12];
            var wy = e[1] * x + e[5] * y + e[9] * z + e[13];
            var wz = e[2] * x + e[6] * y + e[10] * z + e[14];
            min.x = Math.min(min.x, wx);
            min.y = Math.min(min.y, wy);
            min.z = Math.min(min.z, wz);
            max.x = Math.max(max.x, wx);
            max.y = Math.max(max.y, wy);
            max.z = Math.max(max.z, wz);
        }
    };
    ClickboxController.prototype.getTriangles = function () { return this.clickboxTriangleIndices; };
    return ClickboxController;
}());


// EXTERNAL MODULE: ./src/sdk/rendering/RenderUtils.ts
var RenderUtils = __webpack_require__(5333);
// EXTERNAL MODULE: ./src/sdk/Settings.ts
var Settings = __webpack_require__(8406);
// EXTERNAL MODULE: ./src/sdk/rendering/AnimationFrameSounds.ts
var AnimationFrameSounds = __webpack_require__(7657);
// EXTERNAL MODULE: ./src/sdk/rendering/utils/animations.ts
var animations = __webpack_require__(3787);
// EXTERNAL MODULE: ./src/sdk/rendering/utils/payloadUtils.ts + 1 modules
var payloadUtils = __webpack_require__(4993);
// EXTERNAL MODULE: ./src/sdk/utils/constants.ts
var constants = __webpack_require__(9156);
// EXTERNAL MODULE: ./src/sdk/rendering/utils/colors.ts
var colors = __webpack_require__(8048);
;// CONCATENATED MODULE: ./src/sdk/rendering/CacheRenderModel.ts
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};











var DRAW_CLICKBOX_DEBUG = false;
var DRAW_CACHE_MODEL_WIREFRAME = false;
function spotAnimChannel(spotAnim) {
    var _a;
    return (_a = spotAnim.channel) !== null && _a !== void 0 ? _a : String(spotAnim.id);
}
function enableVertexAlpha(material) {
    material.transparent = true;
    material.alphaTest = 0.01;
    material.onBeforeCompile = function (shader) {
        shader.vertexShader = "attribute float cacheAlpha; varying float vCacheAlpha;\n".concat(shader.vertexShader)
            .replace("#include <begin_vertex>", "#include <begin_vertex>\n\tvCacheAlpha = cacheAlpha;");
        shader.fragmentShader = "varying float vCacheAlpha;\n".concat(shader.fragmentShader)
            .replace("void main() {", "void main() {\n\tif (vCacheAlpha < 0.01) discard;")
            .replace("#include <alphatest_fragment>", "diffuseColor.a *= vCacheAlpha;\n\t#include <alphatest_fragment>")
            .replace("#include <output_fragment>", "#include <output_fragment>\n\tgl_FragColor.a *= vCacheAlpha;");
    };
}
function needsVertexAlpha(payload) {
    var _a, _b;
    // A model with only opaque faces must stay in Three.js's opaque render
    // queue. Putting it in the transparent queue changes its sorting against
    // effects such as Sol's sand pools, even though cacheAlpha is always one.
    // Include legacy type-5 transforms because they can animate face alpha
    // after an initially-opaque model has loaded.
    return Boolean(((_a = payload.alphas) === null || _a === void 0 ? void 0 : _a.some(function (alpha) { return alpha !== 0; })) ||
        Object.values((_b = payload.animations) !== null && _b !== void 0 ? _b : {}).some(function (animation) { var _a; return (_a = animation.rawFrames) === null || _a === void 0 ? void 0 : _a.some(function (frame) { return frame.types.includes(5); }); }));
}
/** Three.js implementation for decoded cache geometry. Cache extraction owns the conversion from OSRS frames to this payload. */
var CacheRenderModel = /** @class */ (function () {
    function CacheRenderModel(renderable, reference, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        var _a;
        this.renderable = renderable;
        this.reference = reference;
        this.options = options;
        this.root = new external_three_.Group();
        this.mesh = null;
        this.ready = null;
        this.lastPose = -1;
        this.activeAnimation = -1;
        this.animations = {};
        this.poseMap = {};
        this.animationTime = 0;
        this.animationRevision = 0;
        this.presentedAnimationRevision = -1;
        this.presentedAnimationFraction = -1;
        this.interpolatedMayaFrame = [];
        this.animationStartsOnNextCycle = false;
        this.poseAnimationTime = 0;
        this.animationPlaying = false;
        this.animationCanBlendWithPose = false;
        this.animationPromiseResolve = null;
        this.spotFrameSoundPlayers = new Map();
        this.frameSoundsReady = Promise.resolve();
        this.basePositions = null;
        this.posedPositions = new Float32Array(0);
        this.posedAlphas = new Float32Array(0);
        this.rawFrameWorkspace = new animations/* RawFrameWorkspace */.Zb();
        this.interpolatedFrame = { types: [], maps: [], indexFrameIds: [], x: [], y: [], z: [] };
        this.baseAlphas = null;
        this.vertexGroups = [];
        this.alphaGroups = [];
        this.sourceVertices = [];
        this.logicalHeight = null;
        this.animayaGroups = [];
        this.animayaScales = [];
        this.spotAnims = [];
        this.activeSpotAnims = [];
        // Attached spotanims have their own one-shot clock. They follow the actor's
        // world transform, but must not depend on whether the actor is currently
        // playing an idle, walk, or one-shot animation.
        this.spotAnimClock = 0;
        this.spotAnimStarts = new Map();
        this.spotAnimPlacements = new Map();
        this.spotAnimCompletionNotified = false;
        this.outline = null;
        this.clickbox = null;
        this.modelGeneration = 0;
        this.meshGeneration = -1;
        this.clickboxController = new ClickboxController(function () { return _this.renderable.size; });
        this.frameSoundPlayer = new AnimationFrameSounds/* AnimationFrameSoundPlayer */.KU(options.frameSoundDelayMs);
        this.setActiveSpotAnims(this.currentSpotAnims(reference.kind === "model" || reference.kind === "asset" ? undefined : reference.spotAnims));
        // A spotanim-only renderable has no actor animation transition to start
        // playback. Its own graphic timeline begins once geometry is ready.
        if (reference.kind === "spotAnim") {
            this.animationPlaying = true;
            this.animationStartsOnNextCycle = true;
        }
        // Viewport3d filters scene roots before recursively raycasting children.
        // Mark this group as belonging to the renderable so its box hitbox is
        // considered as a click target.
        this.root.userData.clickable = renderable.selectable;
        this.root.userData.unit = renderable;
        var size = renderable.size;
        var points = [
            new external_three_.Vector3(0, 0, 0), new external_three_.Vector3(size, 0, 0),
            new external_three_.Vector3(size, 0, 0), new external_three_.Vector3(size, 0, -size),
            new external_three_.Vector3(size, 0, -size), new external_three_.Vector3(0, 0, -size),
            new external_three_.Vector3(0, 0, -size), new external_three_.Vector3(0, 0, 0),
        ];
        this.trueTile = new external_three_.LineSegments(new external_three_.BufferGeometry().setFromPoints(points), new external_three_.LineBasicMaterial({ color: (_a = Settings/* Settings */.w.trueTileColor) !== null && _a !== void 0 ? _a : "#00FFFF" }));
    }
    CacheRenderModel.forRenderable = function (renderable, reference, options) {
        return new CacheRenderModel(renderable, reference, options);
    };
    CacheRenderModel.prototype.getClickboxVertices = function () { return this.clickboxController.getVertices(); };
    CacheRenderModel.prototype.getClickboxBounds = function () { return this.clickboxController.getBounds(); };
    CacheRenderModel.prototype.getClickboxTriangles = function () { return this.clickboxController.getTriangles(); };
    CacheRenderModel.prototype.spotAnimChanged = function (spotAnims) { this.setActiveSpotAnims(spotAnims); };
    CacheRenderModel.prototype.setActiveSpotAnims = function (spotAnims) {
        var _this = this;
        var starts = new Map();
        var placements = new Map();
        spotAnims.forEach(function (spotAnim) {
            var _a;
            var channel = spotAnimChannel(spotAnim);
            var previous = _this.spotAnimPlacements.get(channel);
            starts.set(channel, previous === spotAnim ? ((_a = _this.spotAnimStarts.get(channel)) !== null && _a !== void 0 ? _a : _this.spotAnimClock) : _this.spotAnimClock + 1 / constants/* CLIENT_CYCLES_PER_SECOND */.ZC);
            placements.set(channel, spotAnim);
        });
        this.activeSpotAnims = spotAnims.slice();
        this.spotAnimStarts = starts;
        this.spotAnimPlacements = placements;
        this.animationRevision++;
    };
    CacheRenderModel.prototype.currentSpotAnims = function (fallback) {
        var attached = this.renderable.spotAnims;
        return attached.length ? attached.slice() : (fallback !== null && fallback !== void 0 ? fallback : []).slice();
    };
    CacheRenderModel.prototype.animationChanged = function (id, blend) {
        var _this = this;
        var _a;
        this.animationRevision++;
        // SDK callers use semantic pose indices (e.g. FireBow = 6), while the
        // bundle is keyed by the actual cache sequence ID (e.g. 426).
        this.activeAnimation = (_a = this.poseMap[String(id)]) !== null && _a !== void 0 ? _a : id;
        this.animationTime = 0;
        this.animationStartsOnNextCycle = true;
        this.animationPlaying = true;
        this.animationCanBlendWithPose = blend;
        this.frameSoundPlayer.reset();
        return new Promise(function (resolve) {
            _this.animationPromiseResolve = resolve;
        });
    };
    CacheRenderModel.prototype.getAnimationMetadata = function (id) {
        var _a;
        var animation = this.animations[String((_a = this.poseMap[String(id)]) !== null && _a !== void 0 ? _a : id)];
        if (!animation)
            return undefined;
        return {
            precedenceAnimating: animation.precedenceAnimating,
            priority: animation.priority,
        };
    };
    CacheRenderModel.prototype.getActiveAnimationMetadata = function () {
        if (!this.animationPlaying)
            return undefined;
        var animation = this.animations[String(this.activeAnimation)];
        if (!animation)
            return undefined;
        return {
            precedenceAnimating: animation.precedenceAnimating,
            priority: animation.priority,
        };
    };
    CacheRenderModel.prototype.modelChanged = function () {
        var _a;
        var next = this.renderable.get3dModel();
        var nextPrimary = (_a = next === null || next === void 0 ? void 0 : next.getPrimaryModel) === null || _a === void 0 ? void 0 : _a.call(next);
        if (next instanceof CacheRenderModel && next !== this)
            this.reference = next.reference;
        else if (nextPrimary instanceof CacheRenderModel)
            this.reference = nextPrimary.reference;
        this.ready = null;
        this.modelGeneration++;
        this.meshGeneration = -1;
        this.animations = {};
        this.poseMap = {};
        this.lastPose = -1;
        this.activeAnimation = -1;
        this.animationTime = 0;
        this.animationStartsOnNextCycle = false;
        this.poseAnimationTime = 0;
        this.animationPlaying = false;
        this.animationCanBlendWithPose = false;
        this.frameSoundPlayer.reset();
        this.spotFrameSoundPlayers.clear();
        this.frameSoundsReady = Promise.resolve();
        this.basePositions = null;
        this.baseAlphas = null;
        this.vertexGroups = [];
        this.alphaGroups = [];
        this.sourceVertices = [];
        this.logicalHeight = null;
        this.animayaGroups = [];
        this.animayaScales = [];
        this.spotAnims = [];
        this.setActiveSpotAnims(this.currentSpotAnims(this.reference.kind === "model" || this.reference.kind === "asset" ? undefined : this.reference.spotAnims));
        this.spotAnimCompletionNotified = false;
    };
    CacheRenderModel.prototype.preload = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ensureLoaded()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.frameSoundsReady];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CacheRenderModel.prototype.ensureLoaded = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.ready)
                    return [2 /*return*/, this.ready];
                this.ready = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var generation, previousChildren, previousOutline, previousClickbox, bundle, assetIds, sharedAssetIds, payloads, spotIds, spotPayloads, payload, geometry, rawAlphas, hasVertexAlpha, alphaValues, materials, textureMaterial, vertex, mesh, modelScale, clickGeometryDebug, clickboxRadius, clickGeometry, hitbox, hitbox, size, outlinePoints, outline;
                    var _this = this;
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
                    return __generator(this, function (_z) {
                        switch (_z.label) {
                            case 0:
                                generation = this.modelGeneration;
                                previousChildren = this.root.children.slice();
                                previousOutline = this.outline;
                                previousClickbox = this.clickbox;
                                return [4 /*yield*/, CacheRenderBundle/* CacheRender */.j9.bundle()];
                            case 1:
                                bundle = _z.sent();
                                assetIds = bundle.assetIds(this.reference);
                                sharedAssetIds = bundle.sharedAssetIds(this.reference);
                                return [4 /*yield*/, Promise.all(__spreadArray(__spreadArray([], assetIds, true), sharedAssetIds, true).map(function (id) { return (0,payloadUtils/* cachedPayload */.Bv)(bundle, id); }))];
                            case 2:
                                payloads = _z.sent();
                                spotIds = this.reference.kind === "spotAnim"
                                    ? bundle.spotAnimIds(this.reference)
                                    : bundle.allSpotAnimIds();
                                return [4 /*yield*/, Promise.all(spotIds.map(function (id) { return (0,payloadUtils/* cachedPayload */.Bv)(bundle, id); }))];
                            case 3:
                                spotPayloads = _z.sent();
                                if (generation !== this.modelGeneration)
                                    return [2 /*return*/];
                                payload = (0,payloadUtils/* mergePayloads */.GE)(payloads);
                                Object.assign(this.animations, (_a = payload.animations) !== null && _a !== void 0 ? _a : {});
                                Object.assign(this.poseMap, (_b = payload.poseMap) !== null && _b !== void 0 ? _b : {});
                                this.frameSoundsReady = (0,AnimationFrameSounds/* preloadAnimationFrameSounds */.xA)(__spreadArray(__spreadArray([], Object.values(this.animations), true), spotPayloads.reduce(function (all, spotPayload) { var _a; return all.concat(Object.values((_a = spotPayload.animations) !== null && _a !== void 0 ? _a : {})); }, []), true)).catch(function (error) { return console.error("[osrs-sdk] Cache animation sound preload failed", error); });
                                if (this.animationPlaying && !this.animations[String(this.activeAnimation)]) {
                                    this.activeAnimation = (_c = this.poseMap[String(this.activeAnimation)]) !== null && _c !== void 0 ? _c : this.activeAnimation;
                                }
                                geometry = new external_three_.BufferGeometry();
                                geometry.setAttribute("position", new external_three_.Float32BufferAttribute(payload.positions, 3));
                                if (((_d = payload.uvs) === null || _d === void 0 ? void 0 : _d.length) === (payload.positions.length / 3) * 2)
                                    geometry.setAttribute("uv", new external_three_.Float32BufferAttribute(payload.uvs, 2));
                                if (payload.colors && payload.colors.length * 3 === payload.positions.length) {
                                    geometry.setAttribute("color", new external_three_.Float32BufferAttribute((0,colors/* cacheColorsToRgb */.ZX)(payload.colors), 3));
                                }
                                rawAlphas = ((_e = payload.alphas) === null || _e === void 0 ? void 0 : _e.length) === payload.positions.length / 3
                                    ? payload.alphas.map(colors/* normalizeCacheAlpha */.Ai)
                                    : Array(payload.positions.length / 3).fill(0);
                                hasVertexAlpha = needsVertexAlpha(payload);
                                alphaValues = rawAlphas.map(colors/* cacheAlphaToOpacity */.Lm);
                                geometry.setAttribute("cacheAlpha", new external_three_.Float32BufferAttribute(alphaValues, 1));
                                geometry.setIndex((_f = payload.indices) !== null && _f !== void 0 ? _f : []);
                                geometry.computeBoundingSphere();
                                materials = [new external_three_.MeshBasicMaterial({ color: (_g = payload.color) !== null && _g !== void 0 ? _g : 0xffffff, vertexColors: Boolean((_h = payload.colors) === null || _h === void 0 ? void 0 : _h.length), wireframe: DRAW_CACHE_MODEL_WIREFRAME })];
                                if (hasVertexAlpha && !DRAW_CACHE_MODEL_WIREFRAME)
                                    enableVertexAlpha(materials[0]);
                                textureMaterial = new Map();
                                Object.entries((_j = payload.textures) !== null && _j !== void 0 ? _j : {}).forEach(function (_a) {
                                    var _b;
                                    var id = _a[0], texture = _a[1];
                                    var rgba = new Uint8Array(texture.pixels.length * 4);
                                    texture.pixels.forEach(function (pixel, index) { var value = pixel >>> 0; rgba[index * 4] = value >> 16 & 255; rgba[index * 4 + 1] = value >> 8 & 255; rgba[index * 4 + 2] = value & 255; rgba[index * 4 + 3] = value >> 24 & 255; });
                                    var image = new external_three_.DataTexture(rgba, texture.width, texture.height, external_three_.RGBAFormat);
                                    image.flipY = false;
                                    image.needsUpdate = true;
                                    textureMaterial.set(Number(id), materials.length);
                                    var textureMaterialInstance = new external_three_.MeshBasicMaterial({ map: image, vertexColors: Boolean((_b = payload.colors) === null || _b === void 0 ? void 0 : _b.length), wireframe: DRAW_CACHE_MODEL_WIREFRAME });
                                    if (hasVertexAlpha && !DRAW_CACHE_MODEL_WIREFRAME)
                                        enableVertexAlpha(textureMaterialInstance);
                                    materials.push(textureMaterialInstance);
                                });
                                if ((_k = payload.textureIds) === null || _k === void 0 ? void 0 : _k.length) {
                                    geometry.clearGroups();
                                    for (vertex = 0; vertex < payload.textureIds.length; vertex += 3)
                                        geometry.addGroup(vertex, 3, (_l = textureMaterial.get(payload.textureIds[vertex])) !== null && _l !== void 0 ? _l : 0);
                                }
                                mesh = new external_three_.Mesh(geometry, materials.length > 1 ? materials : materials[0]);
                                modelScale = (_m = payload.scale) !== null && _m !== void 0 ? _m : 1;
                                this.root.scale.set(modelScale, modelScale, modelScale);
                                this.updateLogicalHeight(geometry.getAttribute("position"));
                                this.basePositions = new Float32Array(payload.positions);
                                this.posedPositions = new Float32Array(payload.positions.length);
                                this.posedAlphas = new Float32Array(rawAlphas.length);
                                this.baseAlphas = new Float32Array(rawAlphas);
                                this.vertexGroups = (_o = payload.vertexGroups) !== null && _o !== void 0 ? _o : [];
                                this.alphaGroups = (_p = payload.alphaGroups) !== null && _p !== void 0 ? _p : [];
                                this.sourceVertices = (_q = payload.sourceVertices) !== null && _q !== void 0 ? _q : Array.from({ length: payload.positions.length / 3 }, function (_, index) { return index; });
                                this.animayaGroups = (_r = payload.animayaGroups) !== null && _r !== void 0 ? _r : [];
                                this.animayaScales = (_s = payload.animayaScales) !== null && _s !== void 0 ? _s : [];
                                mesh.userData.clickable = this.renderable.selectable;
                                mesh.userData.unit = this.renderable;
                                mesh.userData.cacheAnimations = (_t = payload.animations) !== null && _t !== void 0 ? _t : {};
                                this.root.add(mesh);
                                if (DRAW_CLICKBOX_DEBUG) {
                                    clickGeometryDebug = new external_three_.Mesh(geometry, new external_three_.MeshBasicMaterial({ color: 0x00ff00, transparent: true, opacity: 0.7, depthTest: false, depthWrite: false, wireframe: true }));
                                    clickGeometryDebug.renderOrder = 10;
                                    clickGeometryDebug.raycast = function () { };
                                    this.root.add(clickGeometryDebug);
                                }
                                this.clickbox = null;
                                clickboxRadius = this.renderable.clickboxRadius;
                                if (payload.geometryClickbox) {
                                    clickGeometry = new external_three_.BufferGeometry();
                                    clickGeometry.setAttribute("position", new external_three_.Float32BufferAttribute(payload.geometryClickbox.positions, 3));
                                    clickGeometry.setIndex((_u = payload.geometryClickbox.indices) !== null && _u !== void 0 ? _u : []);
                                    hitbox = new external_three_.Mesh(clickGeometry, new external_three_.MeshBasicMaterial({ transparent: true, opacity: 0, depthWrite: false }));
                                    hitbox.userData.cacheGeometryClickbox = true;
                                    hitbox.userData.clickable = this.renderable.selectable;
                                    hitbox.userData.unit = this.renderable;
                                    this.clickbox = hitbox;
                                }
                                else if (clickboxRadius !== null) {
                                    hitbox = new external_three_.Mesh(new external_three_.BoxGeometry(clickboxRadius * 2, (_v = this.renderable.clickboxHeight) !== null && _v !== void 0 ? _v : this.renderable.size, clickboxRadius * 2), new external_three_.MeshBasicMaterial({ color: 0x00ff00, transparent: true, opacity: DRAW_CLICKBOX_DEBUG ? 0.35 : 0, depthWrite: false, wireframe: DRAW_CLICKBOX_DEBUG }));
                                    hitbox.position.y = ((_w = this.renderable.clickboxHeight) !== null && _w !== void 0 ? _w : this.renderable.size) / 2 - 0.49;
                                    hitbox.userData.clickable = this.renderable.selectable;
                                    hitbox.userData.unit = this.renderable;
                                    this.clickbox = hitbox;
                                }
                                if (this.renderable.drawOutline) {
                                    size = this.renderable.size;
                                    outlinePoints = [
                                        new external_three_.Vector3(0, 0, 0), new external_three_.Vector3(size, 0, 0),
                                        new external_three_.Vector3(size, 0, 0), new external_three_.Vector3(size, 0, -size),
                                        new external_three_.Vector3(size, 0, -size), new external_three_.Vector3(0, 0, -size),
                                        new external_three_.Vector3(0, 0, -size), new external_three_.Vector3(0, 0, 0),
                                    ];
                                    outline = new external_three_.LineSegments(new external_three_.BufferGeometry().setFromPoints(outlinePoints), new external_three_.LineBasicMaterial({ color: (_x = Settings/* Settings */.w.entityIndicatorColor) !== null && _x !== void 0 ? _x : "#FFFFFF" }));
                                    if (this.renderable.outlineRenderOrder !== null)
                                        outline.renderOrder = this.renderable.outlineRenderOrder;
                                    this.outline = outline;
                                }
                                this.mesh = mesh;
                                this.clickboxController.configure(mesh, this.sourceVertices, ((_y = this.clickbox) === null || _y === void 0 ? void 0 : _y.userData.cacheGeometryClickbox) ? this.clickbox : null);
                                this.meshGeneration = generation;
                                spotPayloads.forEach(function (spotPayload) {
                                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
                                    var geometry = new external_three_.BufferGeometry();
                                    geometry.setAttribute("position", new external_three_.Float32BufferAttribute(spotPayload.positions, 3));
                                    var spotAlphas = (_b = (_a = spotPayload.alphas) === null || _a === void 0 ? void 0 : _a.map(colors/* normalizeCacheAlpha */.Ai)) !== null && _b !== void 0 ? _b : Array(spotPayload.positions.length / 3).fill(0);
                                    if (spotPayload.colors && spotPayload.colors.length * 3 === spotPayload.positions.length) {
                                        geometry.setAttribute("color", new external_three_.Float32BufferAttribute((0,colors/* cacheColorsToRgba */.E2)(spotPayload.colors, spotAlphas), 4));
                                    }
                                    geometry.setIndex((_c = spotPayload.indices) !== null && _c !== void 0 ? _c : []);
                                    var effect = new external_three_.Mesh(geometry, new external_three_.MeshBasicMaterial({ color: (_d = spotPayload.color) !== null && _d !== void 0 ? _d : 0xffffff, vertexColors: Boolean((_e = spotPayload.colors) === null || _e === void 0 ? void 0 : _e.length), transparent: true, wireframe: DRAW_CACHE_MODEL_WIREFRAME }));
                                    var metadata = (_f = spotPayload.spotAnim) !== null && _f !== void 0 ? _f : {};
                                    var placement = _this.activeSpotAnims[0];
                                    effect.userData.spotAnimId = metadata.id;
                                    effect.userData.cacheBaseColors = (_g = spotPayload.colors) !== null && _g !== void 0 ? _g : [];
                                    effect.userData.cacheFaceColors = (_h = spotPayload.faceColors) !== null && _h !== void 0 ? _h : [];
                                    effect.visible = false;
                                    // Actor roots already carry the NPC definition's model scale. Cache
                                    // spotanim resize values are world-space scales in the client, so
                                    // compensate for the inherited root scale instead of multiplying the
                                    // two definitions together (Sol uses 300 for both).
                                    effect.scale.set(((_j = metadata.resizeX) !== null && _j !== void 0 ? _j : 128) / 128 / _this.root.scale.x, ((_k = metadata.resizeY) !== null && _k !== void 0 ? _k : 128) / 128 / _this.root.scale.y, ((_l = metadata.resizeX) !== null && _l !== void 0 ? _l : 128) / 128 / _this.root.scale.z);
                                    effect.rotation.y = ((_o = ((_m = placement === null || placement === void 0 ? void 0 : placement.rotation) !== null && _m !== void 0 ? _m : metadata.rotation)) !== null && _o !== void 0 ? _o : 0) * Math.PI / 1024;
                                    _this.root.add(effect);
                                    _this.spotAnims.push({ interpolatedMayaFrame: [], animayaGroups: (_p = spotPayload.animayaGroups) !== null && _p !== void 0 ? _p : [], animayaScales: (_q = spotPayload.animayaScales) !== null && _q !== void 0 ? _q : [], posedPositions: new Float32Array(spotPayload.positions.length), posedAlphas: new Float32Array(spotAlphas.length), workspace: new animations/* RawFrameWorkspace */.Zb(), interpolatedFrame: { types: [], maps: [], indexFrameIds: [], x: [], y: [], z: [] }, mesh: effect, basePositions: new Float32Array(spotPayload.positions), vertexGroups: (_r = spotPayload.vertexGroups) !== null && _r !== void 0 ? _r : [], sourceVertices: (_s = spotPayload.sourceVertices) !== null && _s !== void 0 ? _s : [], baseAlphas: new Float32Array(spotAlphas), alphaGroups: (_t = spotPayload.alphaGroups) !== null && _t !== void 0 ? _t : [], animationId: metadata.animationId, animation: metadata.animationId >= 0 ? (_u = spotPayload.animations) === null || _u === void 0 ? void 0 : _u[String(metadata.animationId)] : undefined, scaleX: (_v = metadata.resizeX) !== null && _v !== void 0 ? _v : 128, scaleY: (_w = metadata.resizeY) !== null && _w !== void 0 ? _w : 128, rotation: (_x = metadata.rotation) !== null && _x !== void 0 ? _x : 0, height: (_y = placement === null || placement === void 0 ? void 0 : placement.height) !== null && _y !== void 0 ? _y : 0, delay: (_z = placement === null || placement === void 0 ? void 0 : placement.delay) !== null && _z !== void 0 ? _z : 0 });
                                });
                                // A queued actor animation may have begun while its cache geometry was
                                // loading. Start it once the mesh is ready so short spawn sequences are
                                // not skipped.
                                if (this.animationPlaying || this.reference.kind === "spotAnim") {
                                    this.animationTime = 0;
                                    this.animationStartsOnNextCycle = true;
                                }
                                this.frameSoundPlayer.reset();
                                this.spotFrameSoundPlayers.clear();
                                previousChildren.forEach(function (child) {
                                    if (child.parent === _this.root)
                                        _this.root.remove(child);
                                });
                                if (previousOutline === null || previousOutline === void 0 ? void 0 : previousOutline.parent)
                                    previousOutline.parent.remove(previousOutline);
                                if (previousClickbox === null || previousClickbox === void 0 ? void 0 : previousClickbox.parent)
                                    previousClickbox.parent.remove(previousClickbox);
                                return [2 /*return*/];
                        }
                    });
                }); })();
                return [2 /*return*/, this.ready];
            });
        });
    };
    CacheRenderModel.prototype.draw = function (scene, _clockDelta, _tickPercent, location, rotation, pitch, visible, modelOffsets, clientTickFraction) {
        if (clientTickFraction === void 0) { clientTickFraction = 0; }
        this.clickboxController.invalidate();
        this.startLoading();
        this.updateSceneObjects(scene, location, rotation, pitch, visible, modelOffsets);
        if (!this.mesh || this.meshGeneration !== this.modelGeneration || this.lastPose < 0)
            return;
        var fraction = Settings/* Settings */.w.smoothCacheAnimations ? Math.max(0, Math.min(1, clientTickFraction)) : 0;
        if (this.presentedAnimationRevision === this.animationRevision
            && this.presentedAnimationFraction === fraction
            && this.presentedSmoothAnimations === Settings/* Settings */.w.smoothCacheAnimations)
            return;
        this.presentActorAnimation(this.lastPose, fraction / constants/* CLIENT_CYCLES_PER_SECOND */.ZC);
        this.updateSpotAnimations(0, null, fraction / constants/* CLIENT_CYCLES_PER_SECOND */.ZC);
        this.presentedAnimationRevision = this.animationRevision;
        this.presentedAnimationFraction = fraction;
        this.presentedSmoothAnimations = Settings/* Settings */.w.smoothCacheAnimations;
    };
    CacheRenderModel.prototype.startLoading = function () {
        if (this.ready)
            return;
        this.ensureLoaded().catch(function (error) { return console.error("[osrs-sdk] Cache render preload failed", error); });
    };
    CacheRenderModel.prototype.clientTick = function () {
        this.renderable.setAnimationListener(this);
        this.startLoading();
        // Loading and equipment swaps must not consume animation time on an old mesh.
        if (!this.mesh || this.meshGeneration !== this.modelGeneration)
            return;
        var location = this.renderable.getTrueLocation();
        var size = this.renderable.size;
        var soundLocation = { x: location.x + (size - 1) / 2, y: location.y - (size - 1) / 2 };
        var pose = this.renderable.animationIndex;
        this.updateActorAnimation(1 / constants/* CLIENT_CYCLES_PER_SECOND */.ZC, soundLocation, pose);
        this.updateSpotAnimations(1 / constants/* CLIENT_CYCLES_PER_SECOND */.ZC, soundLocation);
        this.lastPose = pose;
        this.animationRevision++;
        this.clickboxController.invalidate();
    };
    CacheRenderModel.prototype.updateSceneObjects = function (scene, location, rotation, pitch, visible, modelOffsets) {
        var _a, _b, _c, _d, _e;
        if (this.root.parent !== scene) {
            scene.add(this.root);
            this.renderable.setAnimationListener(this);
        }
        var size = this.renderable.size;
        this.root.visible = visible && (this.mesh !== null || this.spotAnims.length > 0);
        var outlineColor = Settings/* Settings */.w.entityIndicatorColor;
        if (this.outline) {
            this.outline.material.color.set(outlineColor);
            this.outline.visible = visible && this.renderable.drawOutline && Settings/* Settings */.w.entityIndicatorEnabled;
        }
        this.root.position.set(location.x + size / 2, location.z - 0.49, location.y - size / 2);
        this.root.rotation.order = "YXZ";
        // The client submits standalone GraphicsObjects to the scene with yaw 0.
        // Actor/model renderables use the SDK's west-zero facing convention and
        // need the quarter-turn cache-basis correction.
        var basisRotation = (_a = this.options.basisRotation) !== null && _a !== void 0 ? _a : (this.reference.kind === "spotAnim" ? 0 : Math.PI / 2);
        this.root.rotation.set(pitch, rotation + basisRotation, 0);
        if (this.outline) {
            if (this.outline.parent !== scene)
                scene.add(this.outline);
            (0,RenderUtils/* drawLineOnTop */.Ho)(this.outline, (_b = this.renderable.outlineRenderOrder) !== null && _b !== void 0 ? _b : RenderUtils/* GroundOverlayRenderOrder */.oC.ENTITY_INDICATOR);
            this.outline.position.set(location.x, -0.49, location.y);
            this.outline.rotation.set(0, 0, 0);
        }
        if (this.clickbox) {
            if (this.clickbox.parent !== scene)
                scene.add(this.clickbox);
            if (this.clickbox.userData.cacheGeometryClickbox) {
                this.clickbox.position.copy(this.root.position);
                this.clickbox.rotation.copy(this.root.rotation);
                this.clickbox.scale.copy(this.root.scale);
            }
            else {
                var clickboxHeight = (_c = this.renderable.clickboxHeight) !== null && _c !== void 0 ? _c : this.renderable.size;
                this.clickbox.position.set(location.x + this.renderable.size / 2, clickboxHeight / 2 - 0.49, location.y - this.renderable.size / 2);
                this.clickbox.rotation.set(0, 0, 0);
            }
            this.clickbox.visible = this.renderable.selectable;
        }
        if (this.trueTile) {
            if (this.trueTile.parent !== scene)
                scene.add(this.trueTile);
            var trueLocation = this.renderable.getTrueLocation();
            (0,RenderUtils/* drawLineOnTop */.Ho)(this.trueTile, (_d = this.renderable.trueTileRenderOrder) !== null && _d !== void 0 ? _d : RenderUtils/* GroundOverlayRenderOrder */.oC.TRUE_TILE);
            this.trueTile.position.set(trueLocation.x, RenderUtils/* GROUND_OVERLAY_Y */.t8, trueLocation.y);
            var highlightColor = Renderable/* Renderable */.l.tileHighlightsEnabled ? this.renderable.highlightColor : null;
            var trueTileColor = highlightColor !== null && highlightColor !== void 0 ? highlightColor : Settings/* Settings */.w.trueTileColor;
            this.trueTile.material.color.set(trueTileColor);
            var indicatorCoversTrueTile = ((_e = this.outline) === null || _e === void 0 ? void 0 : _e.visible)
                && Settings/* Settings */.w.entityIndicatorEnabled
                && location.x === trueLocation.x
                && location.y === trueLocation.y;
            this.trueTile.visible = this.renderable.drawTrueTile
                && visible
                && (highlightColor !== null || (Settings/* Settings */.w.trueTileEnabled && !indicatorCoversTrueTile));
        }
        this.root.children.forEach(function (child, index) {
            var _a, _b, _c;
            var offset = modelOffsets[index];
            child.position.set((_a = offset === null || offset === void 0 ? void 0 : offset.x) !== null && _a !== void 0 ? _a : 0, (_b = offset === null || offset === void 0 ? void 0 : offset.z) !== null && _b !== void 0 ? _b : 0, (_c = offset === null || offset === void 0 ? void 0 : offset.y) !== null && _c !== void 0 ? _c : 0);
        });
    };
    CacheRenderModel.prototype.updateActorAnimation = function (clockDelta, soundLocation, pose) {
        var _a, _b, _c, _d, _e;
        if (pose !== this.lastPose)
            this.poseAnimationTime = 0;
        else
            this.poseAnimationTime = Math.round((this.poseAnimationTime + clockDelta) * constants/* CLIENT_CYCLES_PER_SECOND */.ZC) / constants/* CLIENT_CYCLES_PER_SECOND */.ZC;
        if (!this.animationPlaying && pose !== this.lastPose) {
            this.activeAnimation = (_a = this.poseMap[String(pose)]) !== null && _a !== void 0 ? _a : pose;
            this.animationTime = 0;
            this.animationStartsOnNextCycle = true;
        }
        // A transition can happen between client cycles. Present its first frame
        // at t=0 once before consuming a complete client cycle.
        if (!this.animationStartsOnNextCycle)
            this.animationTime = Math.round((this.animationTime + clockDelta) * constants/* CLIENT_CYCLES_PER_SECOND */.ZC) / constants/* CLIENT_CYCLES_PER_SECOND */.ZC;
        this.animationStartsOnNextCycle = false;
        var animationId = this.activeAnimation;
        var animation = this.animations[String(animationId)];
        if (animation && (animation.frames.length || ((_b = animation.rawFrames) === null || _b === void 0 ? void 0 : _b.length) || ((_c = animation.mayaFrames) === null || _c === void 0 ? void 0 : _c.length)) && this.root.children.length) {
            var sample = (0,animations/* sampleAnimation */.D4)(animation, this.animationTime, !this.animationPlaying);
            if (this.animationPlaying && this.animationTime >= sample.total) {
                this.frameSoundPlayer.advance(animationId, animation, sample.total, false, soundLocation);
                this.frameSoundPlayer.reset();
                this.animationPlaying = false;
                this.animationCanBlendWithPose = false;
                this.activeAnimation = (_d = this.poseMap[String(pose)]) !== null && _d !== void 0 ? _d : pose;
                this.animationTime = 0;
                this.animationStartsOnNextCycle = true;
                (_e = this.animationPromiseResolve) === null || _e === void 0 ? void 0 : _e.call(this);
                this.animationPromiseResolve = null;
                // Presentation reads the new pose directly; its sounds begin on the next tick.
                return;
            }
            this.frameSoundPlayer.advance(animationId, animation, this.animationTime, !this.animationPlaying, soundLocation);
        }
    };
    /** Present a pose without advancing clocks, emitting sounds, or completing animations. */
    CacheRenderModel.prototype.presentActorAnimation = function (pose, renderOffset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var animation = this.animations[String(this.activeAnimation)];
        if (animation && (animation.frames.length || ((_a = animation.rawFrames) === null || _a === void 0 ? void 0 : _a.length) || ((_b = animation.mayaFrames) === null || _b === void 0 ? void 0 : _b.length))) {
            var sample = (0,animations/* sampleAnimation */.D4)(animation, this.animationTime + renderOffset, !this.animationPlaying);
            var frame = sample.frame;
            var blend = sample.blend;
            var vertices = animation.frames[frame];
            var position = (_c = this.mesh) === null || _c === void 0 ? void 0 : _c.geometry.getAttribute("position");
            if (position && this.basePositions) {
                var transformed = this.posedPositions;
                transformed.set(this.basePositions);
                var transformedAlphas = this.baseAlphas ? this.posedAlphas : undefined;
                if (transformedAlphas)
                    transformedAlphas.set(this.baseAlphas);
                if ((_d = animation.mayaFrames) === null || _d === void 0 ? void 0 : _d[frame]) {
                    // Matrix interpolation is an approximation until extraction includes the original curves.
                    var matrices = Settings/* Settings */.w.smoothCacheAnimations
                        ? (0,animations/* interpolateMayaFrames */.sA)(animation.mayaFrames[frame], animation.mayaFrames[sample.nextFrame], blend, this.interpolatedMayaFrame)
                        : animation.mayaFrames[frame];
                    (0,animations/* applyMayaFrame */.ii)(transformed, matrices, this.animayaGroups, this.animayaScales);
                }
                else if ((_e = animation.rawFrames) === null || _e === void 0 ? void 0 : _e[frame]) {
                    var poseSequence = (_f = this.poseMap[String(pose)]) !== null && _f !== void 0 ? _f : pose;
                    var poseAnimation = this.animations[String(poseSequence)];
                    var interleave = (_g = animation.interleaveLeave) !== null && _g !== void 0 ? _g : [];
                    var composePose = this.animationPlaying && this.animationCanBlendWithPose
                        && this.renderable.shouldBlendAnimationWithPose && interleave.some(function (index) { return index !== 9999999; })
                        && ((_h = poseAnimation === null || poseAnimation === void 0 ? void 0 : poseAnimation.rawFrames) === null || _h === void 0 ? void 0 : _h.length);
                    if (composePose) {
                        // RuneLite deliberately retains the native two-pass attack/pose path.
                        var poseFrame = (0,animations/* sampleAnimation */.D4)(poseAnimation, this.poseAnimationTime, true).frame;
                        (0,animations/* applyBlendedRawFrames */.xw)(transformed, this.vertexGroups, this.sourceVertices, animation.rawFrames[frame], (_j = poseAnimation.rawFrames[poseFrame]) !== null && _j !== void 0 ? _j : poseAnimation.rawFrames[0], interleave, transformedAlphas, this.alphaGroups, this.rawFrameWorkspace);
                    }
                    else {
                        var current = animation.rawFrames[frame];
                        // Looping poses interpolate into their first frame; one-shots hold their last pose.
                        var following = animation.rawFrames[sample.nextFrame];
                        var rawFrame = Settings/* Settings */.w.smoothCacheAnimations && following
                            ? (0,animations/* interpolateRawFrames */.a2)(current, following, blend, this.interpolatedFrame, true) : current;
                        (0,animations/* applyRawFrame */.c9)(transformed, this.vertexGroups, this.sourceVertices, rawFrame, undefined, transformedAlphas, this.alphaGroups, this.rawFrameWorkspace, Settings/* Settings */.w.smoothCacheAnimations);
                    }
                }
                else if (vertices && position.count * 3 === vertices.length) {
                    var following = animation.frames[sample.nextFrame];
                    if (Settings/* Settings */.w.smoothCacheAnimations && (following === null || following === void 0 ? void 0 : following.length) === vertices.length) {
                        for (var index = 0; index < transformed.length; index++)
                            transformed[index] = vertices[index] + (following[index] - vertices[index]) * blend;
                    }
                    else
                        transformed.set(vertices);
                }
                position.array.set(transformed);
                position.needsUpdate = true;
                this.updateLogicalHeight(position);
                var cacheAlpha = (_k = this.mesh) === null || _k === void 0 ? void 0 : _k.geometry.getAttribute("cacheAlpha");
                if (cacheAlpha && transformedAlphas) {
                    for (var i = 0; i < transformedAlphas.length; i++)
                        cacheAlpha.array[i] = (0,colors/* cacheAlphaToOpacity */.Lm)(transformedAlphas[i]);
                    cacheAlpha.needsUpdate = true;
                }
                // MeshBasicMaterial uses the cache's baked colours; posed normals are unused.
            }
        }
    };
    CacheRenderModel.prototype.updateSpotAnimations = function (clockDelta, soundLocation, renderOffset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        if (renderOffset === void 0) { renderOffset = 0; }
        if (soundLocation)
            this.spotAnimClock = Math.round((this.spotAnimClock + Math.max(0, clockDelta)) * constants/* CLIENT_CYCLES_PER_SECOND */.ZC) / constants/* CLIENT_CYCLES_PER_SECOND */.ZC;
        var _loop_1 = function (spot) {
            var animation = spot.animation;
            var placement = this_1.activeSpotAnims.filter(function (spotAnim) { return spotAnim.id === spot.mesh.userData.spotAnimId; })[0];
            var delay = (_a = placement === null || placement === void 0 ? void 0 : placement.delay) !== null && _a !== void 0 ? _a : spot.delay;
            var placementStart = placement == null ? this_1.spotAnimClock : (_b = this_1.spotAnimStarts.get(spotAnimChannel(placement))) !== null && _b !== void 0 ? _b : this_1.spotAnimClock;
            var effectTime = (Math.round((this_1.spotAnimClock - placementStart) * constants/* CLIENT_CYCLES_PER_SECOND */.ZC) - delay) / constants/* CLIENT_CYCLES_PER_SECOND */.ZC;
            var activationAnimation = (placement === null || placement === void 0 ? void 0 : placement.animation) == null ? true : ((_c = this_1.poseMap[String(placement.animation)]) !== null && _c !== void 0 ? _c : placement.animation) === this_1.activeAnimation;
            // Attached spotanims are normally one-shot graphics. Projectile
            // spotanims repeat until their owning ProjectileGraphic is destroyed.
            var looping = this_1.options.loopSpotAnims === true;
            var sample = animation ? (0,animations/* sampleAnimation */.D4)(animation, effectTime + (effectTime >= 0 ? renderOffset : 0), looping) : undefined;
            var total = (_d = sample === null || sample === void 0 ? void 0 : sample.total) !== null && _d !== void 0 ? _d : 0;
            var hasFrames = Boolean((animation === null || animation === void 0 ? void 0 : animation.frames.length) || ((_e = animation === null || animation === void 0 ? void 0 : animation.rawFrames) === null || _e === void 0 ? void 0 : _e.length) || ((_f = animation === null || animation === void 0 ? void 0 : animation.mayaFrames) === null || _f === void 0 ? void 0 : _f.length));
            spot.mesh.visible = activationAnimation && Boolean(placement) && effectTime >= 0
                && (looping ? total > 0 : effectTime < total) && hasFrames;
            if (soundLocation) {
                var spotAnimationId = (_g = spot.animationId) !== null && _g !== void 0 ? _g : -1;
                var spotSoundPlayer = this_1.spotFrameSoundPlayers.get(spotAnimationId);
                if (!spotSoundPlayer) {
                    spotSoundPlayer = new AnimationFrameSounds/* AnimationFrameSoundPlayer */.KU(this_1.options.frameSoundDelayMs);
                    this_1.spotFrameSoundPlayers.set(spotAnimationId, spotSoundPlayer);
                }
                if (!looping &&
                    this_1.reference.kind === "spotAnim" &&
                    !this_1.spotAnimCompletionNotified &&
                    effectTime >= 0 &&
                    (!animation || !hasFrames || total <= 0 || effectTime >= total)) {
                    this_1.spotAnimCompletionNotified = true;
                    (_j = (_h = this_1.options).onSpotAnimComplete) === null || _j === void 0 ? void 0 : _j.call(_h);
                }
                if (!spot.mesh.visible || !animation) {
                    spotSoundPlayer.reset();
                    return "continue";
                }
                spotSoundPlayer.advance(spotAnimationId, animation, effectTime, looping, soundLocation);
                return "continue";
            }
            if (!spot.mesh.visible || !animation)
                return "continue";
            var frame = sample.frame;
            var transformed = spot.posedPositions;
            var alphaValues = spot.posedAlphas;
            transformed.set(spot.basePositions);
            alphaValues.set(spot.baseAlphas);
            if ((_k = animation.mayaFrames) === null || _k === void 0 ? void 0 : _k[frame]) {
                var matrices = Settings/* Settings */.w.smoothCacheAnimations
                    ? (0,animations/* interpolateMayaFrames */.sA)(animation.mayaFrames[frame], animation.mayaFrames[sample.nextFrame], sample.blend, spot.interpolatedMayaFrame)
                    : animation.mayaFrames[frame];
                (0,animations/* applyMayaFrame */.ii)(transformed, matrices, spot.animayaGroups, spot.animayaScales);
            }
            else if ((_l = animation.rawFrames) === null || _l === void 0 ? void 0 : _l[frame]) {
                var current = animation.rawFrames[frame], following = animation.rawFrames[sample.nextFrame];
                var rawFrame = Settings/* Settings */.w.smoothCacheAnimations && following
                    ? (0,animations/* interpolateRawFrames */.a2)(current, following, sample.blend, spot.interpolatedFrame, true) : current;
                (0,animations/* applyRawFrame */.c9)(transformed, spot.vertexGroups, spot.sourceVertices, rawFrame, undefined, alphaValues, spot.alphaGroups, spot.workspace, Settings/* Settings */.w.smoothCacheAnimations);
            }
            else if (animation.frames[frame] && transformed.length === animation.frames[frame].length) {
                var current = animation.frames[frame], following = animation.frames[sample.nextFrame];
                if (Settings/* Settings */.w.smoothCacheAnimations && (following === null || following === void 0 ? void 0 : following.length) === current.length) {
                    for (var index = 0; index < transformed.length; index++)
                        transformed[index] = current[index] + (following[index] - current[index]) * sample.blend;
                }
                else
                    transformed.set(current);
            }
            spot.mesh.geometry.getAttribute("position").array.set(transformed);
            spot.mesh.geometry.getAttribute("position").needsUpdate = true;
            var color = spot.mesh.geometry.getAttribute("color");
            if (color && color.itemSize === 4) {
                var recolor = (_m = placement === null || placement === void 0 ? void 0 : placement.recolor) !== null && _m !== void 0 ? _m : {};
                var baseColors = spot.mesh.userData.cacheBaseColors;
                var faceColors = spot.mesh.userData.cacheFaceColors;
                for (var i = 0; i < alphaValues.length; i++) {
                    if (baseColors[i] != null) {
                        var rgb = (0,colors/* cacheColorToRgb */.GS)((0,colors/* resolveCacheColor */.ql)(baseColors[i], faceColors[i], recolor));
                        color.array[i * 4] = rgb[0];
                        color.array[i * 4 + 1] = rgb[1];
                        color.array[i * 4 + 2] = rgb[2];
                    }
                    color.array[i * 4 + 3] = (0,colors/* cacheAlphaToOpacity */.Lm)(alphaValues[i]);
                }
                color.needsUpdate = true;
            }
            // Spotanim height/offset placement is supplied by the actor update,
            // not by the cache definition. Keep it in the actor's local frame so
            // the effect follows the player's facing direction.
            var offset = placement === null || placement === void 0 ? void 0 : placement.offset;
            if (offset) {
                // Convert world tile offset into the player's local frame because
                // the effect remains a child of the rotated player root.
                var yaw = this_1.root.rotation.y;
                var cos = Math.cos(yaw), sin = Math.sin(yaw);
                spot.mesh.position.set(cos * offset.x - sin * offset.y, (_o = placement === null || placement === void 0 ? void 0 : placement.height) !== null && _o !== void 0 ? _o : spot.height, sin * offset.x + cos * offset.y);
            }
            else
                spot.mesh.position.set(0, (_p = placement === null || placement === void 0 ? void 0 : placement.height) !== null && _p !== void 0 ? _p : spot.height, 0);
            // Actor spotanims are merged into the actor model by the client and
            // inherit its yaw. Spotanim-only renderables use the same cache-space
            // basis correction as every other world renderable.
            spot.mesh.rotation.y = ((_q = placement === null || placement === void 0 ? void 0 : placement.rotation) !== null && _q !== void 0 ? _q : spot.rotation) * Math.PI / 1024;
        };
        var this_1 = this;
        for (var _i = 0, _r = this.spotAnims; _i < _r.length; _i++) {
            var spot = _r[_i];
            _loop_1(spot);
        }
    };
    CacheRenderModel.prototype.updateLogicalHeight = function (position) {
        var maxY = -Infinity;
        for (var vertex = 0; vertex < position.count; vertex++)
            maxY = Math.max(maxY, position.getY(vertex));
        this.logicalHeight = Number.isFinite(maxY) ? Math.max(0, maxY * this.root.scale.y) : null;
    };
    CacheRenderModel.prototype.getLogicalHeight = function () { return this.logicalHeight; };
    CacheRenderModel.prototype.destroy = function (scene) {
        var _a, _b, _c;
        if (this.root.parent === scene)
            scene.remove(this.root);
        if (((_a = this.outline) === null || _a === void 0 ? void 0 : _a.parent) === scene)
            scene.remove(this.outline);
        if (((_b = this.trueTile) === null || _b === void 0 ? void 0 : _b.parent) === scene)
            scene.remove(this.trueTile);
        if (((_c = this.clickbox) === null || _c === void 0 ? void 0 : _c.parent) === scene)
            scene.remove(this.clickbox);
        this.renderable.clearAnimationListener();
    };
    CacheRenderModel.prototype.getWorldPosition = function () { return this.root.getWorldPosition(new external_three_.Vector3()); };
    return CacheRenderModel;
}());



/***/ }),

/***/ 7757:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P: () => (/* binding */ CacheRenderReferences),
/* harmony export */   T: () => (/* binding */ cacheRenderItemKey)
/* harmony export */ });
/** Stable semantic key for item references; display-name casing/punctuation is not significant. */
function cacheRenderItemKey(item) {
    return typeof item === "number" ? "item:".concat(item) : item.toLowerCase().replace(/[^a-z0-9]/g, "");
}
var CacheRenderReferences = {
    npc: function (definitionId, spotAnimsOrBundleId, bundleId) {
        var spotAnims = Array.isArray(spotAnimsOrBundleId) ? spotAnimsOrBundleId : undefined;
        var resolvedBundleId = typeof spotAnimsOrBundleId === "string" ? spotAnimsOrBundleId : bundleId;
        return { kind: "npc", definitionId: definitionId, spotAnims: spotAnims, bundleId: resolvedBundleId };
    },
    model: function (modelId, bundleId) {
        return { kind: "model", modelId: modelId, bundleId: bundleId };
    },
    asset: function (assetId, bundleId) {
        return { kind: "asset", assetId: assetId, bundleId: bundleId };
    },
    spotAnim: function (spotAnims, bundleId) {
        return { kind: "spotAnim", spotAnims: spotAnims.slice(), bundleId: bundleId };
    },
    player: function (loadout, poses, spotAnimsOrBundleId, bundleId) {
        // Preserve equipment-slot order. The cache animation groups are merged in
        // this order; sorting IDs changes the correspondence between concatenated
        // vertices and animation frames.
        var spotAnims = Array.isArray(spotAnimsOrBundleId) ? spotAnimsOrBundleId : undefined;
        var resolvedBundleId = typeof spotAnimsOrBundleId === "string" ? spotAnimsOrBundleId : bundleId;
        return { kind: "player", loadout: loadout.slice(), poses: poses, spotAnims: spotAnims, bundleId: resolvedBundleId };
    },
};


/***/ }),

/***/ 5870:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ CanvasSpriteModel)
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9604);
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(three__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8406);
/* harmony import */ var _RenderUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5333);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var CANVAS_TILE_SIZE = 20;
/**
 * Render the model using a sprite derived from the 2d representation of the renderable.
 */
var CanvasSpriteModel = /** @class */ (function () {
    function CanvasSpriteModel(renderable) {
        var _a;
        this.renderable = renderable;
        var size = renderable.size;
        this.canvas = new OffscreenCanvas(size * CANVAS_TILE_SIZE, size * CANVAS_TILE_SIZE);
        this.context = this.canvas.getContext("2d");
        this.texture = new three__WEBPACK_IMPORTED_MODULE_0__.Texture(this.canvas);
        this.texture.needsUpdate = true;
        this.texture.colorSpace = three__WEBPACK_IMPORTED_MODULE_0__.LinearSRGBColorSpace;
        var material = new three__WEBPACK_IMPORTED_MODULE_0__.SpriteMaterial({
            alphaTest: 0.5,
            map: this.texture,
            transparent: true,
            color: 0xffffff,
        });
        this.sprite = new three__WEBPACK_IMPORTED_MODULE_0__.Sprite(material);
        this.sprite.scale.set(size, size, size);
        // trial and error to get the sprite to sit on top of the tile. could probably be set per-mob
        this.sprite.center.y = 0.075;
        this.sprite.userData.clickable = renderable.selectable;
        this.sprite.userData.unit = renderable;
        this.outlineMaterial = new three__WEBPACK_IMPORTED_MODULE_0__.LineBasicMaterial({
            color: (_a = _Settings__WEBPACK_IMPORTED_MODULE_1__/* .Settings */ .w.entityIndicatorColor) !== null && _a !== void 0 ? _a : "#FFFFFF",
        });
        var points = [
            new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(0, 0, 0),
            new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(size, 0, 0),
            new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(size, 0, 0),
            new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(size, 0, -size),
            new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(size, 0, -size),
            new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(0, 0, -size),
            new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(0, 0, -size),
            new three__WEBPACK_IMPORTED_MODULE_0__.Vector3(0, 0, 0),
        ];
        var geometry = new three__WEBPACK_IMPORTED_MODULE_0__.BufferGeometry().setFromPoints(points);
        this.outline = new three__WEBPACK_IMPORTED_MODULE_0__.LineSegments(geometry, this.outlineMaterial);
    }
    CanvasSpriteModel.forRenderable = function (r) {
        return new CanvasSpriteModel(r);
    };
    CanvasSpriteModel.prototype.draw = function (scene, clockDelta, tickPercent, location, rotation, pitch, visible) {
        var _a;
        if (this.sprite.parent !== scene) {
            scene.add(this.sprite);
            scene.add(this.outline);
        }
        var size = this.renderable.size;
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.renderable.draw(tickPercent, this.context, { x: 0, y: size - 1 }, CANVAS_TILE_SIZE, false);
        this.texture.needsUpdate = true;
        var outlineColor = _Settings__WEBPACK_IMPORTED_MODULE_1__/* .Settings */ .w.entityIndicatorColor;
        this.outlineMaterial.color.set(outlineColor);
        (0,_RenderUtils__WEBPACK_IMPORTED_MODULE_2__/* .drawLineOnTop */ .Ho)(this.outline, (_a = this.renderable.outlineRenderOrder) !== null && _a !== void 0 ? _a : _RenderUtils__WEBPACK_IMPORTED_MODULE_2__/* .GroundOverlayRenderOrder */ .oC.ENTITY_INDICATOR);
        this.sprite.visible = visible;
        this.outline.visible = visible && this.renderable.drawOutline && _Settings__WEBPACK_IMPORTED_MODULE_1__/* .Settings */ .w.entityIndicatorEnabled;
        var x = location.x, y = location.y;
        this.outline.position.x = x;
        this.outline.position.y = -0.49;
        this.outline.position.z = y;
        this.sprite.position.x = x + size / 2;
        this.sprite.position.y = -0.5;
        this.sprite.position.z = y - size / 2;
    };
    CanvasSpriteModel.prototype.destroy = function (scene) {
        if (this.sprite.parent === scene) {
            scene.remove(this.sprite);
            scene.remove(this.outline);
        }
    };
    CanvasSpriteModel.prototype.getWorldPosition = function () {
        return this.sprite.getWorldPosition(new three__WEBPACK_IMPORTED_MODULE_0__.Vector3());
    };
    CanvasSpriteModel.prototype.preload = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // do nothing
                return [2 /*return*/];
            });
        });
    };
    return CanvasSpriteModel;
}());



/***/ }),

/***/ 1708:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: () => (/* binding */ PlayerAnimationIndices)
/* harmony export */ });
// this just happens to be the order that we exported the models animations in - see ASSETS.md
var PlayerAnimationIndices;
(function (PlayerAnimationIndices) {
    PlayerAnimationIndices[PlayerAnimationIndices["Idle"] = 0] = "Idle";
    PlayerAnimationIndices[PlayerAnimationIndices["Walk"] = 1] = "Walk";
    PlayerAnimationIndices[PlayerAnimationIndices["Run"] = 2] = "Run";
    PlayerAnimationIndices[PlayerAnimationIndices["WalkBack"] = 3] = "WalkBack";
    PlayerAnimationIndices[PlayerAnimationIndices["StrafeLeft"] = 4] = "StrafeLeft";
    PlayerAnimationIndices[PlayerAnimationIndices["StrafeRight"] = 5] = "StrafeRight";
    PlayerAnimationIndices[PlayerAnimationIndices["FireBow"] = 6] = "FireBow";
    PlayerAnimationIndices[PlayerAnimationIndices["FireBlowpipe"] = 7] = "FireBlowpipe";
    PlayerAnimationIndices[PlayerAnimationIndices["ThrowChinchompa"] = 8] = "ThrowChinchompa";
    PlayerAnimationIndices[PlayerAnimationIndices["ScytheIdle"] = 9] = "ScytheIdle";
    PlayerAnimationIndices[PlayerAnimationIndices["ScytheSwing"] = 10] = "ScytheSwing";
    PlayerAnimationIndices[PlayerAnimationIndices["SwordSlash"] = 11] = "SwordSlash";
    PlayerAnimationIndices[PlayerAnimationIndices["Eat"] = 12] = "Eat";
    PlayerAnimationIndices[PlayerAnimationIndices["Dying"] = 13] = "Dying";
    PlayerAnimationIndices[PlayerAnimationIndices["CastSpell"] = 14] = "CastSpell";
    PlayerAnimationIndices[PlayerAnimationIndices["DragonClawsAttack"] = 15] = "DragonClawsAttack";
    PlayerAnimationIndices[PlayerAnimationIndices["TumekensShadowIdle"] = 16] = "TumekensShadowIdle";
    PlayerAnimationIndices[PlayerAnimationIndices["TumekensShadowWalk"] = 17] = "TumekensShadowWalk";
    PlayerAnimationIndices[PlayerAnimationIndices["TumekensShadowRun"] = 18] = "TumekensShadowRun";
    PlayerAnimationIndices[PlayerAnimationIndices["TumekensShadowAttack"] = 19] = "TumekensShadowAttack";
    PlayerAnimationIndices[PlayerAnimationIndices["VenatorBowIdle"] = 20] = "VenatorBowIdle";
    PlayerAnimationIndices[PlayerAnimationIndices["VenatorBowWalk"] = 21] = "VenatorBowWalk";
    PlayerAnimationIndices[PlayerAnimationIndices["VenatorBowRun"] = 22] = "VenatorBowRun";
    PlayerAnimationIndices[PlayerAnimationIndices["VenatorBowAttack"] = 23] = "VenatorBowAttack";
    PlayerAnimationIndices[PlayerAnimationIndices["ZombieAxeSlash"] = 24] = "ZombieAxeSlash";
    PlayerAnimationIndices[PlayerAnimationIndices["ZombieAxeCrush"] = 25] = "ZombieAxeCrush";
})(PlayerAnimationIndices || (PlayerAnimationIndices = {}));


/***/ }),

/***/ 2313:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  F: () => (/* binding */ GLTFModel)
});

// EXTERNAL MODULE: external "three"
var external_three_ = __webpack_require__(9604);
;// CONCATENATED MODULE: ./node_modules/three/examples/jsm/libs/meshopt_decoder.module.js
// This file is part of meshoptimizer library and is distributed under the terms of MIT License.
// Copyright (C) 2016-2022, by Arseny Kapoulkine (arseny.kapoulkine@gmail.com)
var MeshoptDecoder = (function() {
	"use strict";

	// Built with clang version 14.0.4
	// Built from meshoptimizer 0.18
	var wasm_base = "b9H79Tebbbe8Fv9Gbb9Gvuuuuueu9Giuuub9Geueu9Giuuueuikqbeeedddillviebeoweuec:q;iekr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbeY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVbdE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbiL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtblK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbol79IV9Rbrq:P8Yqdbk;3sezu8Jjjjjbcj;eb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Radz1jjjbhwcj;abad9UhoaicefhldnadTmbaoc;WFbGgocjdaocjd6EhDcbhqinaqae9pmeaDaeaq9RaqaDfae6Egkcsfgocl4cifcd4hxdndndndnaoc9WGgmTmbcbhPcehsawcjdfhzalhHinaraH9Rax6midnaraHaxfgl9RcK6mbczhoinawcj;cbfaogifgoc9WfhOdndndndndnaHaic9WfgAco4fRbbaAci4coG4ciGPlbedibkaO9cb83ibaOcwf9cb83ibxikaOalRblalRbbgAco4gCaCciSgCE86bbaocGfalclfaCfgORbbaAcl4ciGgCaCciSgCE86bbaocVfaOaCfgORbbaAcd4ciGgCaCciSgCE86bbaoc7faOaCfgORbbaAciGgAaAciSgAE86bbaoctfaOaAfgARbbalRbegOco4gCaCciSgCE86bbaoc91faAaCfgARbbaOcl4ciGgCaCciSgCE86bbaoc4faAaCfgARbbaOcd4ciGgCaCciSgCE86bbaoc93faAaCfgARbbaOciGgOaOciSgOE86bbaoc94faAaOfgARbbalRbdgOco4gCaCciSgCE86bbaoc95faAaCfgARbbaOcl4ciGgCaCciSgCE86bbaoc96faAaCfgARbbaOcd4ciGgCaCciSgCE86bbaoc97faAaCfgARbbaOciGgOaOciSgOE86bbaoc98faAaOfgORbbalRbiglco4gAaAciSgAE86bbaoc99faOaAfgORbbalcl4ciGgAaAciSgAE86bbaoc9:faOaAfgORbbalcd4ciGgAaAciSgAE86bbaocufaOaAfgoRbbalciGglalciSglE86bbaoalfhlxdkaOalRbwalRbbgAcl4gCaCcsSgCE86bbaocGfalcwfaCfgORbbaAcsGgAaAcsSgAE86bbaocVfaOaAfgORbbalRbegAcl4gCaCcsSgCE86bbaoc7faOaCfgORbbaAcsGgAaAcsSgAE86bbaoctfaOaAfgORbbalRbdgAcl4gCaCcsSgCE86bbaoc91faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc4faOaAfgORbbalRbigAcl4gCaCcsSgCE86bbaoc93faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc94faOaAfgORbbalRblgAcl4gCaCcsSgCE86bbaoc95faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc96faOaAfgORbbalRbvgAcl4gCaCcsSgCE86bbaoc97faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc98faOaAfgORbbalRbogAcl4gCaCcsSgCE86bbaoc99faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc9:faOaAfgORbbalRbrglcl4gAaAcsSgAE86bbaocufaOaAfgoRbbalcsGglalcsSglE86bbaoalfhlxekaOal8Pbb83bbaOcwfalcwf8Pbb83bbalczfhlkdnaiam9pmbaiczfhoaral9RcL0mekkaiam6mialTmidnakTmbawaPfRbbhOcbhoazhiinaiawcj;cbfaofRbbgAce4cbaAceG9R7aOfgO86bbaiadfhiaocefgoak9hmbkkazcefhzaPcefgPad6hsalhHaPad9hmexvkkcbhlasceGmdxikalaxad2fhCdnakTmbcbhHcehsawcjdfhminaral9Rax6mialTmdalaxfhlawaHfRbbhOcbhoamhiinaiawcj;cbfaofRbbgAce4cbaAceG9R7aOfgO86bbaiadfhiaocefgoak9hmbkamcefhmaHcefgHad6hsaHad9hmbkaChlxikcbhocehsinaral9Rax6mdalTmealaxfhlaocefgoad6hsadao9hmbkaChlxdkcbhlasceGTmekc9:hoxikabaqad2fawcjdfakad2z1jjjb8Aawawcjdfakcufad2fadz1jjjb8Aakaqfhqalmbkc9:hoxekcbc99aral9Radcaadca0ESEhokavcj;ebf8Kjjjjbaok;yzeHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgDce0mbavc;abfcFecjez:jjjjb8AavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhqaicefgwarfhodnaeTmbcmcsaDceSEhkcbhxcbhmcbhDcbhicbhlindnaoaq9nmbc9:hoxikdndnawRbbgrc;Ve0mbavc;abfalarcl4cu7fcsGcitfgPydlhsaPydbhzdnarcsGgPak9pmbavaiarcu7fcsGcdtfydbaxaPEhraPThPdndnadcd9hmbabaDcetfgHaz87ebaHcdfas87ebaHclfar87ebxekabaDcdtfgHazBdbaHclfasBdbaHcwfarBdbkaxaPfhxavc;abfalcitfgHarBdbaHasBdlavaicdtfarBdbavc;abfalcefcsGglcitfgHazBdbaHarBdlaiaPfhialcefhlxdkdndnaPcsSmbamaPfaPc987fcefhmxekaocefhrao8SbbgPcFeGhHdndnaPcu9mmbarhoxekaocvfhoaHcFbGhHcrhPdninar8SbbgOcFbGaPtaHVhHaOcu9kmearcefhraPcrfgPc8J9hmbxdkkarcefhokaHce4cbaHceG9R7amfhmkdndnadcd9hmbabaDcetfgraz87ebarcdfas87ebarclfam87ebxekabaDcdtfgrazBdbarclfasBdbarcwfamBdbkavc;abfalcitfgramBdbarasBdlavaicdtfamBdbavc;abfalcefcsGglcitfgrazBdbaramBdlaicefhialcefhlxekdnarcpe0mbaxcefgOavaiaqarcsGfRbbgPcl49RcsGcdtfydbaPcz6gHEhravaiaP9RcsGcdtfydbaOaHfgsaPcsGgOEhPaOThOdndnadcd9hmbabaDcetfgzax87ebazcdfar87ebazclfaP87ebxekabaDcdtfgzaxBdbazclfarBdbazcwfaPBdbkavaicdtfaxBdbavc;abfalcitfgzarBdbazaxBdlavaicefgicsGcdtfarBdbavc;abfalcefcsGcitfgzaPBdbazarBdlavaiaHfcsGgicdtfaPBdbavc;abfalcdfcsGglcitfgraxBdbaraPBdlalcefhlaiaOfhiasaOfhxxekaxcbaoRbbgzEgAarc;:eSgrfhsazcsGhCazcl4hXdndnazcs0mbascefhOxekashOavaiaX9RcsGcdtfydbhskdndnaCmbaOcefhxxekaOhxavaiaz9RcsGcdtfydbhOkdndnarTmbaocefhrxekaocdfhrao8SbegHcFeGhPdnaHcu9kmbaocofhAaPcFbGhPcrhodninar8SbbgHcFbGaotaPVhPaHcu9kmearcefhraocrfgoc8J9hmbkaAhrxekarcefhrkaPce4cbaPceG9R7amfgmhAkdndnaXcsSmbarhPxekarcefhPar8SbbgocFeGhHdnaocu9kmbarcvfhsaHcFbGhHcrhodninaP8SbbgrcFbGaotaHVhHarcu9kmeaPcefhPaocrfgoc8J9hmbkashPxekaPcefhPkaHce4cbaHceG9R7amfgmhskdndnaCcsSmbaPhoxekaPcefhoaP8SbbgrcFeGhHdnarcu9kmbaPcvfhOaHcFbGhHcrhrdninao8SbbgPcFbGartaHVhHaPcu9kmeaocefhoarcrfgrc8J9hmbkaOhoxekaocefhokaHce4cbaHceG9R7amfgmhOkdndnadcd9hmbabaDcetfgraA87ebarcdfas87ebarclfaO87ebxekabaDcdtfgraABdbarclfasBdbarcwfaOBdbkavc;abfalcitfgrasBdbaraABdlavaicdtfaABdbavc;abfalcefcsGcitfgraOBdbarasBdlavaicefgicsGcdtfasBdbavc;abfalcdfcsGcitfgraABdbaraOBdlavaiazcz6aXcsSVfgicsGcdtfaOBdbaiaCTaCcsSVfhialcifhlkawcefhwalcsGhlaicsGhiaDcifgDae6mbkkcbc99aoaqSEhokavc;aef8Kjjjjbaok:llevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:Lvoeue99dud99eud99dndnadcl9hmbaeTmeindndnabcdfgd8Sbb:Yab8Sbbgi:Ygl:l:tabcefgv8Sbbgo:Ygr:l:tgwJbb;:9cawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai86bbdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad86bbdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad86bbabclfhbaecufgembxdkkaeTmbindndnabclfgd8Ueb:Yab8Uebgi:Ygl:l:tabcdfgv8Uebgo:Ygr:l:tgwJb;:FSawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai87ebdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad87ebdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad87ebabcwfhbaecufgembkkk;siliui99iue99dnaeTmbcbhiabhlindndnJ;Zl81Zalcof8UebgvciV:Y:vgoal8Ueb:YNgrJb;:FSNJbbbZJbbb:;arJbbbb9GEMgw:lJbbb9p9DTmbaw:OhDxekcjjjj94hDkalclf8Uebhqalcdf8UebhkabavcefciGaiVcetfaD87ebdndnaoak:YNgwJb;:FSNJbbbZJbbb:;awJbbbb9GEMgx:lJbbb9p9DTmbax:Ohkxekcjjjj94hkkabavcdfciGaiVcetfak87ebdndnaoaq:YNgoJb;:FSNJbbbZJbbb:;aoJbbbb9GEMgx:lJbbb9p9DTmbax:Ohqxekcjjjj94hqkabavcufciGaiVcetfaq87ebdndnJbbjZararN:tawawN:taoaoN:tgrJbbbbarJbbbb9GE:rJb;:FSNJbbbZMgr:lJbbb9p9DTmbar:Ohqxekcjjjj94hqkabavciGaiVcetfaq87ebalcwfhlaiclfhiaecufgembkkk9mbdnadcd4ae2geTmbinababydbgdcwtcw91:Yadce91cjjj;8ifcjjj98G::NUdbabclfhbaecufgembkkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaik;LeeeudndnaeabVciGTmbabhixekdndnadcz9pmbabhixekabhiinaiaeydbBdbaiclfaeclfydbBdbaicwfaecwfydbBdbaicxfaecxfydbBdbaiczfhiaeczfheadc9Wfgdcs0mbkkadcl6mbinaiaeydbBdbaeclfheaiclfhiadc98fgdci0mbkkdnadTmbinaiaeRbb86bbaicefhiaecefheadcufgdmbkkabk;aeedudndnabciGTmbabhixekaecFeGc:b:c:ew2hldndnadcz9pmbabhixekabhiinaialBdbaicxfalBdbaicwfalBdbaiclfalBdbaiczfhiadc9Wfgdcs0mbkkadcl6mbinaialBdbaiclfhiadc98fgdci0mbkkdnadTmbinaiae86bbaicefhiadcufgdmbkkabkkkebcjwklz9Kbb";
	var wasm_simd = "b9H79TebbbeKl9Gbb9Gvuuuuueu9Giuuub9Geueuikqbbebeedddilve9Weeeviebeoweuec:q;Aekr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbdY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVblE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtboK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbrL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbwl79IV9RbDq;t9tqlbzik9:evu8Jjjjjbcz9Rhbcbheincbhdcbhiinabcwfadfaicjuaead4ceGglE86bbaialfhiadcefgdcw9hmbkaec:q:yjjbfai86bbaecitc:q1jjbfab8Piw83ibaecefgecjd9hmbkk;h8JlHud97euo978Jjjjjbcj;kb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Rad;8qbbcj;abad9UhoaicefhldnadTmbaoc;WFbGgocjdaocjd6EhwcbhDinaDae9pmeawaeaD9RaDawfae6Egqcsfgoc9WGgkci2hxakcethmaocl4cifcd4hPabaDad2fhscbhzdnincehHalhOcbhAdninaraO9RaP6miavcj;cbfaAak2fhCaOaPfhlcbhidnakc;ab6mbaral9Rc;Gb6mbcbhoinaCaofhidndndndndnaOaoco4fRbbgXciGPlbedibkaipxbbbbbbbbbbbbbbbbpklbxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklbalczfhlkdndndndndnaXcd4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklzxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklzalczfhlkdndndndndnaXcl4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklaxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklaalczfhlkdndndndndnaXco4Plbedibkaipxbbbbbbbbbbbbbbbbpkl8WxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WalclfaYpQbfaXc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WalcwfaYpQbfaXc:q:yjjbfRbbfhlxekaialpbbbpkl8Walczfhlkaoc;abfhiaocjefak0meaihoaral9Rc;Fb0mbkkdndnaiak9pmbaici4hoinaral9RcK6mdaCaifhXdndndndndnaOaico4fRbbaocoG4ciGPlbedibkaXpxbbbbbbbbbbbbbbbbpklbxikaXalpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaXalpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaXalpbbbpklbalczfhlkaocdfhoaiczfgiak6mbkkalTmbaAci6hHalhOaAcefgohAaoclSmdxekkcbhlaHceGmdkdnakTmbavcjdfazfhiavazfpbdbhYcbhXinaiavcj;cbfaXfgopblbgLcep9TaLpxeeeeeeeeeeeeeeeegQp9op9Hp9rgLaoakfpblbg8Acep9Ta8AaQp9op9Hp9rg8ApmbzeHdOiAlCvXoQrLgEaoamfpblbg3cep9Ta3aQp9op9Hp9rg3aoaxfpblbg5cep9Ta5aQp9op9Hp9rg5pmbzeHdOiAlCvXoQrLg8EpmbezHdiOAlvCXorQLgQaQpmbedibedibedibediaYp9UgYp9AdbbaiadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaEa8EpmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaLa8ApmwKDYq8AkEx3m5P8Es8FgLa3a5pmwKDYq8AkEx3m5P8Es8Fg8ApmbezHdiOAlvCXorQLgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaLa8ApmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfhiaXczfgXak6mbkkazclfgzad6mbkasavcjdfaqad2;8qbbavavcjdfaqcufad2fad;8qbbaqaDfhDc9:hoalmexikkc9:hoxekcbc99aral9Radcaadca0ESEhokavcj;kbf8Kjjjjbaokwbz:bjjjbk;uzeHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgDce0mbavc;abfcFecje;8kbavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhqaicefgwarfhodnaeTmbcmcsaDceSEhkcbhxcbhmcbhDcbhicbhlindnaoaq9nmbc9:hoxikdndnawRbbgrc;Ve0mbavc;abfalarcl4cu7fcsGcitfgPydlhsaPydbhzdnarcsGgPak9pmbavaiarcu7fcsGcdtfydbaxaPEhraPThPdndnadcd9hmbabaDcetfgHaz87ebaHcdfas87ebaHclfar87ebxekabaDcdtfgHazBdbaHclfasBdbaHcwfarBdbkaxaPfhxavc;abfalcitfgHarBdbaHasBdlavaicdtfarBdbavc;abfalcefcsGglcitfgHazBdbaHarBdlaiaPfhialcefhlxdkdndnaPcsSmbamaPfaPc987fcefhmxekaocefhrao8SbbgPcFeGhHdndnaPcu9mmbarhoxekaocvfhoaHcFbGhHcrhPdninar8SbbgOcFbGaPtaHVhHaOcu9kmearcefhraPcrfgPc8J9hmbxdkkarcefhokaHce4cbaHceG9R7amfhmkdndnadcd9hmbabaDcetfgraz87ebarcdfas87ebarclfam87ebxekabaDcdtfgrazBdbarclfasBdbarcwfamBdbkavc;abfalcitfgramBdbarasBdlavaicdtfamBdbavc;abfalcefcsGglcitfgrazBdbaramBdlaicefhialcefhlxekdnarcpe0mbaxcefgOavaiaqarcsGfRbbgPcl49RcsGcdtfydbaPcz6gHEhravaiaP9RcsGcdtfydbaOaHfgsaPcsGgOEhPaOThOdndnadcd9hmbabaDcetfgzax87ebazcdfar87ebazclfaP87ebxekabaDcdtfgzaxBdbazclfarBdbazcwfaPBdbkavaicdtfaxBdbavc;abfalcitfgzarBdbazaxBdlavaicefgicsGcdtfarBdbavc;abfalcefcsGcitfgzaPBdbazarBdlavaiaHfcsGgicdtfaPBdbavc;abfalcdfcsGglcitfgraxBdbaraPBdlalcefhlaiaOfhiasaOfhxxekaxcbaoRbbgzEgAarc;:eSgrfhsazcsGhCazcl4hXdndnazcs0mbascefhOxekashOavaiaX9RcsGcdtfydbhskdndnaCmbaOcefhxxekaOhxavaiaz9RcsGcdtfydbhOkdndnarTmbaocefhrxekaocdfhrao8SbegHcFeGhPdnaHcu9kmbaocofhAaPcFbGhPcrhodninar8SbbgHcFbGaotaPVhPaHcu9kmearcefhraocrfgoc8J9hmbkaAhrxekarcefhrkaPce4cbaPceG9R7amfgmhAkdndnaXcsSmbarhPxekarcefhPar8SbbgocFeGhHdnaocu9kmbarcvfhsaHcFbGhHcrhodninaP8SbbgrcFbGaotaHVhHarcu9kmeaPcefhPaocrfgoc8J9hmbkashPxekaPcefhPkaHce4cbaHceG9R7amfgmhskdndnaCcsSmbaPhoxekaPcefhoaP8SbbgrcFeGhHdnarcu9kmbaPcvfhOaHcFbGhHcrhrdninao8SbbgPcFbGartaHVhHaPcu9kmeaocefhoarcrfgrc8J9hmbkaOhoxekaocefhokaHce4cbaHceG9R7amfgmhOkdndnadcd9hmbabaDcetfgraA87ebarcdfas87ebarclfaO87ebxekabaDcdtfgraABdbarclfasBdbarcwfaOBdbkavc;abfalcitfgrasBdbaraABdlavaicdtfaABdbavc;abfalcefcsGcitfgraOBdbarasBdlavaicefgicsGcdtfasBdbavc;abfalcdfcsGcitfgraABdbaraOBdlavaiazcz6aXcsSVfgicsGcdtfaOBdbaiaCTaCcsSVfhialcifhlkawcefhwalcsGhlaicsGhiaDcifgDae6mbkkcbc99aoaqSEhokavc;aef8Kjjjjbaok:llevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:EPliuo97eue978Jjjjjbca9Rhidndnadcl9hmbdnaec98GglTmbcbhvabhdinadadpbbbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDpxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpkbbadczfhdavclfgval6mbkkalae9pmeaiaeciGgvcdtgdVcbczad9R;8kbaiabalcdtfglad;8qbbdnavTmbaiaipblbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDpxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpklbkalaiad;8qbbskdnaec98GgxTmbcbhvabhdinadczfglalpbbbgopxbbbbbbFFbbbbbbFFgkp9oadpbbbgDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eaDaopmbediwDqkzHOAKY8AEgoczp:Sep;6egrp;Geaoczp:Reczp:Sep;6egwp;Gep;Kep;Legopxb;:FSb;:FSb;:FSb;:FSawaopxbbbbbbbbbbbbbbbbp:2egqawpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegwawp;Meaoaop;Mearaqaramp9op9rp;Kegoaop;Mep;Kep;Kep;Jep;Negrp;Mepxbbn0bbn0bbn0bbn0gqp;Keczp:Reawarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9op9qgwaoarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogopmwDKYqk8AExm35Ps8E8Fp9qpkbbadaDakp9oawaopmbezHdiOAlvCXorQLp9qpkbbadcafhdavclfgvax6mbkkaxae9pmbaiaeciGgvcitgdfcbcaad9R;8kbaiabaxcitfglad;8qbbdnavTmbaiaipblzgopxbbbbbbFFbbbbbbFFgkp9oaipblbgDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eaDaopmbediwDqkzHOAKY8AEgoczp:Sep;6egrp;Geaoczp:Reczp:Sep;6egwp;Gep;Kep;Legopxb;:FSb;:FSb;:FSb;:FSawaopxbbbbbbbbbbbbbbbbp:2egqawpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegwawp;Meaoaop;Mearaqaramp9op9rp;Kegoaop;Mep;Kep;Kep;Jep;Negrp;Mepxbbn0bbn0bbn0bbn0gqp;Keczp:Reawarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9op9qgwaoarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogopmwDKYqk8AExm35Ps8E8Fp9qpklzaiaDakp9oawaopmbezHdiOAlvCXorQLp9qpklbkalaiad;8qbbkk;4wllue97euv978Jjjjjbc8W9Rhidnaec98GglTmbcbhvabhoinaiaopbbbgraoczfgwpbbbgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklbaopxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaqakp;Mearp;Keczp:ReaDakp;Mearp;Keamp9op9qgkpmbezHdiOAlvCXorQLgrp5baipblbpEb:T:j83ibaocwfarp5eaipblbpEe:T:j83ibawaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblbpEd:T:j83ibaocKfakp5eaipblbpEi:T:j83ibaocafhoavclfgval6mbkkdnalae9pmbaiaeciGgvcitgofcbcaao9R;8kbaiabalcitfgwao;8qbbdnavTmbaiaipblbgraipblzgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklaaipxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaqakp;Mearp;Keczp:ReaDakp;Mearp;Keamp9op9qgkpmbezHdiOAlvCXorQLgrp5baipblapEb:T:j83ibaiarp5eaipblapEe:T:j83iwaiaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblapEd:T:j83izaiakp5eaipblapEi:T:j83iKkawaiao;8qbbkk:Pddiue978Jjjjjbc;ab9Rhidnadcd4ae2glc98GgvTmbcbhdabheinaeaepbbbgocwp:Recwp:Sep;6eaocep:SepxbbjZbbjZbbjZbbjZp:UepxbbjFbbjFbbjFbbjFp9op;Mepkbbaeczfheadclfgdav6mbkkdnaval9pmbaialciGgdcdtgeVcbc;abae9R;8kbaiabavcdtfgvae;8qbbdnadTmbaiaipblbgocwp:Recwp:Sep;6eaocep:SepxbbjZbbjZbbjZbbjZp:UepxbbjFbbjFbbjFbbjFp9op;Mepklbkavaiae;8qbbkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaikkkebcjwklz9Tbb";

	var detector = new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,3,2,0,0,5,3,1,0,1,12,1,0,10,22,2,12,0,65,0,65,0,65,0,252,10,0,0,11,7,0,65,0,253,15,26,11]);
	var wasmpack = new Uint8Array([32,0,65,2,1,106,34,33,3,128,11,4,13,64,6,253,10,7,15,116,127,5,8,12,40,16,19,54,20,9,27,255,113,17,42,67,24,23,146,148,18,14,22,45,70,69,56,114,101,21,25,63,75,136,108,28,118,29,73,115]);

	if (typeof WebAssembly !== 'object') {
		return {
			supported: false,
		};
	}

	var wasm = WebAssembly.validate(detector) ? wasm_simd : wasm_base;

	var instance;

	var ready =
		WebAssembly.instantiate(unpack(wasm), {})
		.then(function(result) {
			instance = result.instance;
			instance.exports.__wasm_call_ctors();
		});

	function unpack(data) {
		var result = new Uint8Array(data.length);
		for (var i = 0; i < data.length; ++i) {
			var ch = data.charCodeAt(i);
			result[i] = ch > 96 ? ch - 97 : ch > 64 ? ch - 39 : ch + 4;
		}
		var write = 0;
		for (var i = 0; i < data.length; ++i) {
			result[write++] = (result[i] < 60) ? wasmpack[result[i]] : (result[i] - 60) * 64 + result[++i];
		}
		return result.buffer.slice(0, write);
	}

	function decode(fun, target, count, size, source, filter) {
		var sbrk = instance.exports.sbrk;
		var count4 = (count + 3) & ~3;
		var tp = sbrk(count4 * size);
		var sp = sbrk(source.length);
		var heap = new Uint8Array(instance.exports.memory.buffer);
		heap.set(source, sp);
		var res = fun(tp, count, size, sp, source.length);
		if (res == 0 && filter) {
			filter(tp, count4, size);
		}
		target.set(heap.subarray(tp, tp + count * size));
		sbrk(tp - sbrk(0));
		if (res != 0) {
			throw new Error("Malformed buffer data: " + res);
		}
	}

	var filters = {
		NONE: "",
		OCTAHEDRAL: "meshopt_decodeFilterOct",
		QUATERNION: "meshopt_decodeFilterQuat",
		EXPONENTIAL: "meshopt_decodeFilterExp",
	};

	var decoders = {
		ATTRIBUTES: "meshopt_decodeVertexBuffer",
		TRIANGLES: "meshopt_decodeIndexBuffer",
		INDICES: "meshopt_decodeIndexSequence",
	};

	var workers = [];
	var requestId = 0;

	function createWorker(url) {
		var worker = {
			object: new Worker(url),
			pending: 0,
			requests: {}
		};

		worker.object.onmessage = function(event) {
			var data = event.data;

			worker.pending -= data.count;
			worker.requests[data.id][data.action](data.value);

			delete worker.requests[data.id];
		};

		return worker;
	}

	function initWorkers(count) {
		var source =
			"var instance; var ready = WebAssembly.instantiate(new Uint8Array([" + new Uint8Array(unpack(wasm)) + "]), {})" +
			".then(function(result) { instance = result.instance; instance.exports.__wasm_call_ctors(); });" +
			"self.onmessage = workerProcess;" +
			decode.toString() + workerProcess.toString();

		var blob = new Blob([source], {type: 'text/javascript'});
		var url = URL.createObjectURL(blob);

		for (var i = 0; i < count; ++i) {
			workers[i] = createWorker(url);
		}

		URL.revokeObjectURL(url);
	}

	function decodeWorker(count, size, source, mode, filter) {
		var worker = workers[0];

		for (var i = 1; i < workers.length; ++i) {
			if (workers[i].pending < worker.pending) {
				worker = workers[i];
			}
		}

		return new Promise(function (resolve, reject) {
			var data = new Uint8Array(source);
			var id = requestId++;

			worker.pending += count;
			worker.requests[id] = { resolve: resolve, reject: reject };
			worker.object.postMessage({ id: id, count: count, size: size, source: data, mode: mode, filter: filter }, [ data.buffer ]);
		});
	}

	function workerProcess(event) {
		ready.then(function() {
			var data = event.data;
			try {
				var target = new Uint8Array(data.count * data.size);
				decode(instance.exports[data.mode], target, data.count, data.size, data.source, instance.exports[data.filter]);
				self.postMessage({ id: data.id, count: data.count, action: "resolve", value: target }, [ target.buffer ]);
			} catch (error) {
				self.postMessage({ id: data.id, count: data.count, action: "reject", value: error });
			}
		});
	}

	return {
		ready: ready,
		supported: true,
		useWorkers: function(count) {
			initWorkers(count);
		},
		decodeVertexBuffer: function(target, count, size, source, filter) {
			decode(instance.exports.meshopt_decodeVertexBuffer, target, count, size, source, instance.exports[filters[filter]]);
		},
		decodeIndexBuffer: function(target, count, size, source) {
			decode(instance.exports.meshopt_decodeIndexBuffer, target, count, size, source);
		},
		decodeIndexSequence: function(target, count, size, source) {
			decode(instance.exports.meshopt_decodeIndexSequence, target, count, size, source);
		},
		decodeGltfBuffer: function(target, count, size, source, mode, filter) {
			decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
		},
		decodeGltfBufferAsync: function(count, size, source, mode, filter) {
			if (workers.length > 0) {
				return decodeWorker(count, size, source, decoders[mode], filters[filter]);
			}

			return ready.then(function() {
				var target = new Uint8Array(count * size);
				decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
				return target;
			});
		}
	};
})();



;// CONCATENATED MODULE: ./node_modules/three/examples/jsm/utils/BufferGeometryUtils.js


function computeMikkTSpaceTangents( geometry, MikkTSpace, negateSign = true ) {

	if ( ! MikkTSpace || ! MikkTSpace.isReady ) {

		throw new Error( 'BufferGeometryUtils: Initialized MikkTSpace library required.' );

	}

	if ( ! geometry.hasAttribute( 'position' ) || ! geometry.hasAttribute( 'normal' ) || ! geometry.hasAttribute( 'uv' ) ) {

		throw new Error( 'BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.' );

	}

	function getAttributeArray( attribute ) {

		if ( attribute.normalized || attribute.isInterleavedBufferAttribute ) {

			const dstArray = new Float32Array( attribute.count * attribute.itemSize );

			for ( let i = 0, j = 0; i < attribute.count; i ++ ) {

				dstArray[ j ++ ] = attribute.getX( i );
				dstArray[ j ++ ] = attribute.getY( i );

				if ( attribute.itemSize > 2 ) {

					dstArray[ j ++ ] = attribute.getZ( i );

				}

			}

			return dstArray;

		}

		if ( attribute.array instanceof Float32Array ) {

			return attribute.array;

		}

		return new Float32Array( attribute.array );

	}

	// MikkTSpace algorithm requires non-indexed input.

	const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;

	// Compute vertex tangents.

	const tangents = MikkTSpace.generateTangents(

		getAttributeArray( _geometry.attributes.position ),
		getAttributeArray( _geometry.attributes.normal ),
		getAttributeArray( _geometry.attributes.uv )

	);

	// Texture coordinate convention of glTF differs from the apparent
	// default of the MikkTSpace library; .w component must be flipped.

	if ( negateSign ) {

		for ( let i = 3; i < tangents.length; i += 4 ) {

			tangents[ i ] *= - 1;

		}

	}

	//

	_geometry.setAttribute( 'tangent', new BufferAttribute( tangents, 4 ) );

	if ( geometry !== _geometry ) {

		geometry.copy( _geometry );

	}

	return geometry;

}

/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */
function mergeGeometries( geometries, useGroups = false ) {

	const isIndexed = geometries[ 0 ].index !== null;

	const attributesUsed = new Set( Object.keys( geometries[ 0 ].attributes ) );
	const morphAttributesUsed = new Set( Object.keys( geometries[ 0 ].morphAttributes ) );

	const attributes = {};
	const morphAttributes = {};

	const morphTargetsRelative = geometries[ 0 ].morphTargetsRelative;

	const mergedGeometry = new BufferGeometry();

	let offset = 0;

	for ( let i = 0; i < geometries.length; ++ i ) {

		const geometry = geometries[ i ];
		let attributesCount = 0;

		// ensure that all geometries are indexed, or none

		if ( isIndexed !== ( geometry.index !== null ) ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.' );
			return null;

		}

		// gather attributes, exit early if they're different

		for ( const name in geometry.attributes ) {

			if ( ! attributesUsed.has( name ) ) {

				console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.' );
				return null;

			}

			if ( attributes[ name ] === undefined ) attributes[ name ] = [];

			attributes[ name ].push( geometry.attributes[ name ] );

			attributesCount ++;

		}

		// ensure geometries have the same number of attributes

		if ( attributesCount !== attributesUsed.size ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. Make sure all geometries have the same number of attributes.' );
			return null;

		}

		// gather morph attributes, exit early if they're different

		if ( morphTargetsRelative !== geometry.morphTargetsRelative ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. .morphTargetsRelative must be consistent throughout all geometries.' );
			return null;

		}

		for ( const name in geometry.morphAttributes ) {

			if ( ! morphAttributesUsed.has( name ) ) {

				console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '.  .morphAttributes must be consistent throughout all geometries.' );
				return null;

			}

			if ( morphAttributes[ name ] === undefined ) morphAttributes[ name ] = [];

			morphAttributes[ name ].push( geometry.morphAttributes[ name ] );

		}

		if ( useGroups ) {

			let count;

			if ( isIndexed ) {

				count = geometry.index.count;

			} else if ( geometry.attributes.position !== undefined ) {

				count = geometry.attributes.position.count;

			} else {

				console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. The geometry must have either an index or a position attribute' );
				return null;

			}

			mergedGeometry.addGroup( offset, count, i );

			offset += count;

		}

	}

	// merge indices

	if ( isIndexed ) {

		let indexOffset = 0;
		const mergedIndex = [];

		for ( let i = 0; i < geometries.length; ++ i ) {

			const index = geometries[ i ].index;

			for ( let j = 0; j < index.count; ++ j ) {

				mergedIndex.push( index.getX( j ) + indexOffset );

			}

			indexOffset += geometries[ i ].attributes.position.count;

		}

		mergedGeometry.setIndex( mergedIndex );

	}

	// merge attributes

	for ( const name in attributes ) {

		const mergedAttribute = mergeAttributes( attributes[ name ] );

		if ( ! mergedAttribute ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' attribute.' );
			return null;

		}

		mergedGeometry.setAttribute( name, mergedAttribute );

	}

	// merge morph attributes

	for ( const name in morphAttributes ) {

		const numMorphTargets = morphAttributes[ name ][ 0 ].length;

		if ( numMorphTargets === 0 ) break;

		mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
		mergedGeometry.morphAttributes[ name ] = [];

		for ( let i = 0; i < numMorphTargets; ++ i ) {

			const morphAttributesToMerge = [];

			for ( let j = 0; j < morphAttributes[ name ].length; ++ j ) {

				morphAttributesToMerge.push( morphAttributes[ name ][ j ][ i ] );

			}

			const mergedMorphAttribute = mergeAttributes( morphAttributesToMerge );

			if ( ! mergedMorphAttribute ) {

				console.error( 'THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' morphAttribute.' );
				return null;

			}

			mergedGeometry.morphAttributes[ name ].push( mergedMorphAttribute );

		}

	}

	return mergedGeometry;

}

/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */
function mergeAttributes( attributes ) {

	let TypedArray;
	let itemSize;
	let normalized;
	let gpuType = - 1;
	let arrayLength = 0;

	for ( let i = 0; i < attributes.length; ++ i ) {

		const attribute = attributes[ i ];

		if ( TypedArray === undefined ) TypedArray = attribute.array.constructor;
		if ( TypedArray !== attribute.array.constructor ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.' );
			return null;

		}

		if ( itemSize === undefined ) itemSize = attribute.itemSize;
		if ( itemSize !== attribute.itemSize ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.' );
			return null;

		}

		if ( normalized === undefined ) normalized = attribute.normalized;
		if ( normalized !== attribute.normalized ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.' );
			return null;

		}

		if ( gpuType === - 1 ) gpuType = attribute.gpuType;
		if ( gpuType !== attribute.gpuType ) {

			console.error( 'THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes.' );
			return null;

		}

		arrayLength += attribute.count * itemSize;

	}

	const array = new TypedArray( arrayLength );
	const result = new BufferAttribute( array, itemSize, normalized );
	let offset = 0;

	for ( let i = 0; i < attributes.length; ++ i ) {

		const attribute = attributes[ i ];
		if ( attribute.isInterleavedBufferAttribute ) {

			const tupleOffset = offset / itemSize;
			for ( let j = 0, l = attribute.count; j < l; j ++ ) {

				for ( let c = 0; c < itemSize; c ++ ) {

					const value = attribute.getComponent( j, c );
					result.setComponent( j + tupleOffset, c, value );

				}

			}

		} else {

			array.set( attribute.array, offset );

		}

		offset += attribute.count * itemSize;

	}

	if ( gpuType !== undefined ) {

		result.gpuType = gpuType;

	}

	return result;

}

/**
 * @param {BufferAttribute}
 * @return {BufferAttribute}
 */
function deepCloneAttribute( attribute ) {

	if ( attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute ) {

		return deinterleaveAttribute( attribute );

	}

	if ( attribute.isInstancedBufferAttribute ) {

		return new InstancedBufferAttribute().copy( attribute );

	}

	return new BufferAttribute().copy( attribute );

}

/**
 * @param {Array<BufferAttribute>} attributes
 * @return {Array<InterleavedBufferAttribute>}
 */
function interleaveAttributes( attributes ) {

	// Interleaves the provided attributes into an InterleavedBuffer and returns
	// a set of InterleavedBufferAttributes for each attribute
	let TypedArray;
	let arrayLength = 0;
	let stride = 0;

	// calculate the length and type of the interleavedBuffer
	for ( let i = 0, l = attributes.length; i < l; ++ i ) {

		const attribute = attributes[ i ];

		if ( TypedArray === undefined ) TypedArray = attribute.array.constructor;
		if ( TypedArray !== attribute.array.constructor ) {

			console.error( 'AttributeBuffers of different types cannot be interleaved' );
			return null;

		}

		arrayLength += attribute.array.length;
		stride += attribute.itemSize;

	}

	// Create the set of buffer attributes
	const interleavedBuffer = new InterleavedBuffer( new TypedArray( arrayLength ), stride );
	let offset = 0;
	const res = [];
	const getters = [ 'getX', 'getY', 'getZ', 'getW' ];
	const setters = [ 'setX', 'setY', 'setZ', 'setW' ];

	for ( let j = 0, l = attributes.length; j < l; j ++ ) {

		const attribute = attributes[ j ];
		const itemSize = attribute.itemSize;
		const count = attribute.count;
		const iba = new InterleavedBufferAttribute( interleavedBuffer, itemSize, offset, attribute.normalized );
		res.push( iba );

		offset += itemSize;

		// Move the data for each attribute into the new interleavedBuffer
		// at the appropriate offset
		for ( let c = 0; c < count; c ++ ) {

			for ( let k = 0; k < itemSize; k ++ ) {

				iba[ setters[ k ] ]( c, attribute[ getters[ k ] ]( c ) );

			}

		}

	}

	return res;

}

// returns a new, non-interleaved version of the provided attribute
function deinterleaveAttribute( attribute ) {

	const cons = attribute.data.array.constructor;
	const count = attribute.count;
	const itemSize = attribute.itemSize;
	const normalized = attribute.normalized;

	const array = new cons( count * itemSize );
	let newAttribute;
	if ( attribute.isInstancedInterleavedBufferAttribute ) {

		newAttribute = new InstancedBufferAttribute( array, itemSize, normalized, attribute.meshPerAttribute );

	} else {

		newAttribute = new BufferAttribute( array, itemSize, normalized );

	}

	for ( let i = 0; i < count; i ++ ) {

		newAttribute.setX( i, attribute.getX( i ) );

		if ( itemSize >= 2 ) {

			newAttribute.setY( i, attribute.getY( i ) );

		}

		if ( itemSize >= 3 ) {

			newAttribute.setZ( i, attribute.getZ( i ) );

		}

		if ( itemSize >= 4 ) {

			newAttribute.setW( i, attribute.getW( i ) );

		}

	}

	return newAttribute;

}

// deinterleaves all attributes on the geometry
function deinterleaveGeometry( geometry ) {

	const attributes = geometry.attributes;
	const morphTargets = geometry.morphTargets;
	const attrMap = new Map();

	for ( const key in attributes ) {

		const attr = attributes[ key ];
		if ( attr.isInterleavedBufferAttribute ) {

			if ( ! attrMap.has( attr ) ) {

				attrMap.set( attr, deinterleaveAttribute( attr ) );

			}

			attributes[ key ] = attrMap.get( attr );

		}

	}

	for ( const key in morphTargets ) {

		const attr = morphTargets[ key ];
		if ( attr.isInterleavedBufferAttribute ) {

			if ( ! attrMap.has( attr ) ) {

				attrMap.set( attr, deinterleaveAttribute( attr ) );

			}

			morphTargets[ key ] = attrMap.get( attr );

		}

	}

}

/**
 * @param {BufferGeometry} geometry
 * @return {number}
 */
function estimateBytesUsed( geometry ) {

	// Return the estimated memory used by this geometry in bytes
	// Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
	// for InterleavedBufferAttributes.
	let mem = 0;
	for ( const name in geometry.attributes ) {

		const attr = geometry.getAttribute( name );
		mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;

	}

	const indices = geometry.getIndex();
	mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
	return mem;

}

/**
 * @param {BufferGeometry} geometry
 * @param {number} tolerance
 * @return {BufferGeometry}
 */
function mergeVertices( geometry, tolerance = 1e-4 ) {

	tolerance = Math.max( tolerance, Number.EPSILON );

	// Generate an index buffer if the geometry doesn't have one, or optimize it
	// if it's already available.
	const hashToIndex = {};
	const indices = geometry.getIndex();
	const positions = geometry.getAttribute( 'position' );
	const vertexCount = indices ? indices.count : positions.count;

	// next value for triangle indices
	let nextIndex = 0;

	// attributes and new attribute arrays
	const attributeNames = Object.keys( geometry.attributes );
	const tmpAttributes = {};
	const tmpMorphAttributes = {};
	const newIndices = [];
	const getters = [ 'getX', 'getY', 'getZ', 'getW' ];
	const setters = [ 'setX', 'setY', 'setZ', 'setW' ];

	// Initialize the arrays, allocating space conservatively. Extra
	// space will be trimmed in the last step.
	for ( let i = 0, l = attributeNames.length; i < l; i ++ ) {

		const name = attributeNames[ i ];
		const attr = geometry.attributes[ name ];

		tmpAttributes[ name ] = new BufferAttribute(
			new attr.array.constructor( attr.count * attr.itemSize ),
			attr.itemSize,
			attr.normalized
		);

		const morphAttr = geometry.morphAttributes[ name ];
		if ( morphAttr ) {

			tmpMorphAttributes[ name ] = new BufferAttribute(
				new morphAttr.array.constructor( morphAttr.count * morphAttr.itemSize ),
				morphAttr.itemSize,
				morphAttr.normalized
			);

		}

	}

	// convert the error tolerance to an amount of decimal places to truncate to
	const halfTolerance = tolerance * 0.5;
	const exponent = Math.log10( 1 / tolerance );
	const hashMultiplier = Math.pow( 10, exponent );
	const hashAdditive = halfTolerance * hashMultiplier;
	for ( let i = 0; i < vertexCount; i ++ ) {

		const index = indices ? indices.getX( i ) : i;

		// Generate a hash for the vertex attributes at the current index 'i'
		let hash = '';
		for ( let j = 0, l = attributeNames.length; j < l; j ++ ) {

			const name = attributeNames[ j ];
			const attribute = geometry.getAttribute( name );
			const itemSize = attribute.itemSize;

			for ( let k = 0; k < itemSize; k ++ ) {

				// double tilde truncates the decimal value
				hash += `${ ~ ~ ( attribute[ getters[ k ] ]( index ) * hashMultiplier + hashAdditive ) },`;

			}

		}

		// Add another reference to the vertex if it's already
		// used by another index
		if ( hash in hashToIndex ) {

			newIndices.push( hashToIndex[ hash ] );

		} else {

			// copy data to the new index in the temporary attributes
			for ( let j = 0, l = attributeNames.length; j < l; j ++ ) {

				const name = attributeNames[ j ];
				const attribute = geometry.getAttribute( name );
				const morphAttr = geometry.morphAttributes[ name ];
				const itemSize = attribute.itemSize;
				const newarray = tmpAttributes[ name ];
				const newMorphArrays = tmpMorphAttributes[ name ];

				for ( let k = 0; k < itemSize; k ++ ) {

					const getterFunc = getters[ k ];
					const setterFunc = setters[ k ];
					newarray[ setterFunc ]( nextIndex, attribute[ getterFunc ]( index ) );

					if ( morphAttr ) {

						for ( let m = 0, ml = morphAttr.length; m < ml; m ++ ) {

							newMorphArrays[ m ][ setterFunc ]( nextIndex, morphAttr[ m ][ getterFunc ]( index ) );

						}

					}

				}

			}

			hashToIndex[ hash ] = nextIndex;
			newIndices.push( nextIndex );
			nextIndex ++;

		}

	}

	// generate result BufferGeometry
	const result = geometry.clone();
	for ( const name in geometry.attributes ) {

		const tmpAttribute = tmpAttributes[ name ];

		result.setAttribute( name, new BufferAttribute(
			tmpAttribute.array.slice( 0, nextIndex * tmpAttribute.itemSize ),
			tmpAttribute.itemSize,
			tmpAttribute.normalized,
		) );

		if ( ! ( name in tmpMorphAttributes ) ) continue;

		for ( let j = 0; j < tmpMorphAttributes[ name ].length; j ++ ) {

			const tmpMorphAttribute = tmpMorphAttributes[ name ][ j ];

			result.morphAttributes[ name ][ j ] = new BufferAttribute(
				tmpMorphAttribute.array.slice( 0, nextIndex * tmpMorphAttribute.itemSize ),
				tmpMorphAttribute.itemSize,
				tmpMorphAttribute.normalized,
			);

		}

	}

	// indices

	result.setIndex( newIndices );

	return result;

}

/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry}
 */
function toTrianglesDrawMode( geometry, drawMode ) {

	if ( drawMode === external_three_.TrianglesDrawMode ) {

		console.warn( 'THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.' );
		return geometry;

	}

	if ( drawMode === external_three_.TriangleFanDrawMode || drawMode === external_three_.TriangleStripDrawMode ) {

		let index = geometry.getIndex();

		// generate index if not present

		if ( index === null ) {

			const indices = [];

			const position = geometry.getAttribute( 'position' );

			if ( position !== undefined ) {

				for ( let i = 0; i < position.count; i ++ ) {

					indices.push( i );

				}

				geometry.setIndex( indices );
				index = geometry.getIndex();

			} else {

				console.error( 'THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.' );
				return geometry;

			}

		}

		//

		const numberOfTriangles = index.count - 2;
		const newIndices = [];

		if ( drawMode === external_three_.TriangleFanDrawMode ) {

			// gl.TRIANGLE_FAN

			for ( let i = 1; i <= numberOfTriangles; i ++ ) {

				newIndices.push( index.getX( 0 ) );
				newIndices.push( index.getX( i ) );
				newIndices.push( index.getX( i + 1 ) );

			}

		} else {

			// gl.TRIANGLE_STRIP

			for ( let i = 0; i < numberOfTriangles; i ++ ) {

				if ( i % 2 === 0 ) {

					newIndices.push( index.getX( i ) );
					newIndices.push( index.getX( i + 1 ) );
					newIndices.push( index.getX( i + 2 ) );

				} else {

					newIndices.push( index.getX( i + 2 ) );
					newIndices.push( index.getX( i + 1 ) );
					newIndices.push( index.getX( i ) );

				}

			}

		}

		if ( ( newIndices.length / 3 ) !== numberOfTriangles ) {

			console.error( 'THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.' );

		}

		// build final geometry

		const newGeometry = geometry.clone();
		newGeometry.setIndex( newIndices );
		newGeometry.clearGroups();

		return newGeometry;

	} else {

		console.error( 'THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:', drawMode );
		return geometry;

	}

}

/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 * Helpful for Raytracing or Decals.
 * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
 * @return {Object} An Object with original position/normal attributes and morphed ones.
 */
function computeMorphedAttributes( object ) {

	const _vA = new Vector3();
	const _vB = new Vector3();
	const _vC = new Vector3();

	const _tempA = new Vector3();
	const _tempB = new Vector3();
	const _tempC = new Vector3();

	const _morphA = new Vector3();
	const _morphB = new Vector3();
	const _morphC = new Vector3();

	function _calculateMorphedAttributeData(
		object,
		attribute,
		morphAttribute,
		morphTargetsRelative,
		a,
		b,
		c,
		modifiedAttributeArray
	) {

		_vA.fromBufferAttribute( attribute, a );
		_vB.fromBufferAttribute( attribute, b );
		_vC.fromBufferAttribute( attribute, c );

		const morphInfluences = object.morphTargetInfluences;

		if ( morphAttribute && morphInfluences ) {

			_morphA.set( 0, 0, 0 );
			_morphB.set( 0, 0, 0 );
			_morphC.set( 0, 0, 0 );

			for ( let i = 0, il = morphAttribute.length; i < il; i ++ ) {

				const influence = morphInfluences[ i ];
				const morph = morphAttribute[ i ];

				if ( influence === 0 ) continue;

				_tempA.fromBufferAttribute( morph, a );
				_tempB.fromBufferAttribute( morph, b );
				_tempC.fromBufferAttribute( morph, c );

				if ( morphTargetsRelative ) {

					_morphA.addScaledVector( _tempA, influence );
					_morphB.addScaledVector( _tempB, influence );
					_morphC.addScaledVector( _tempC, influence );

				} else {

					_morphA.addScaledVector( _tempA.sub( _vA ), influence );
					_morphB.addScaledVector( _tempB.sub( _vB ), influence );
					_morphC.addScaledVector( _tempC.sub( _vC ), influence );

				}

			}

			_vA.add( _morphA );
			_vB.add( _morphB );
			_vC.add( _morphC );

		}

		if ( object.isSkinnedMesh ) {

			object.applyBoneTransform( a, _vA );
			object.applyBoneTransform( b, _vB );
			object.applyBoneTransform( c, _vC );

		}

		modifiedAttributeArray[ a * 3 + 0 ] = _vA.x;
		modifiedAttributeArray[ a * 3 + 1 ] = _vA.y;
		modifiedAttributeArray[ a * 3 + 2 ] = _vA.z;
		modifiedAttributeArray[ b * 3 + 0 ] = _vB.x;
		modifiedAttributeArray[ b * 3 + 1 ] = _vB.y;
		modifiedAttributeArray[ b * 3 + 2 ] = _vB.z;
		modifiedAttributeArray[ c * 3 + 0 ] = _vC.x;
		modifiedAttributeArray[ c * 3 + 1 ] = _vC.y;
		modifiedAttributeArray[ c * 3 + 2 ] = _vC.z;

	}

	const geometry = object.geometry;
	const material = object.material;

	let a, b, c;
	const index = geometry.index;
	const positionAttribute = geometry.attributes.position;
	const morphPosition = geometry.morphAttributes.position;
	const morphTargetsRelative = geometry.morphTargetsRelative;
	const normalAttribute = geometry.attributes.normal;
	const morphNormal = geometry.morphAttributes.position;

	const groups = geometry.groups;
	const drawRange = geometry.drawRange;
	let i, j, il, jl;
	let group;
	let start, end;

	const modifiedPosition = new Float32Array( positionAttribute.count * positionAttribute.itemSize );
	const modifiedNormal = new Float32Array( normalAttribute.count * normalAttribute.itemSize );

	if ( index !== null ) {

		// indexed buffer geometry

		if ( Array.isArray( material ) ) {

			for ( i = 0, il = groups.length; i < il; i ++ ) {

				group = groups[ i ];

				start = Math.max( group.start, drawRange.start );
				end = Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) );

				for ( j = start, jl = end; j < jl; j += 3 ) {

					a = index.getX( j );
					b = index.getX( j + 1 );
					c = index.getX( j + 2 );

					_calculateMorphedAttributeData(
						object,
						positionAttribute,
						morphPosition,
						morphTargetsRelative,
						a, b, c,
						modifiedPosition
					);

					_calculateMorphedAttributeData(
						object,
						normalAttribute,
						morphNormal,
						morphTargetsRelative,
						a, b, c,
						modifiedNormal
					);

				}

			}

		} else {

			start = Math.max( 0, drawRange.start );
			end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

			for ( i = start, il = end; i < il; i += 3 ) {

				a = index.getX( i );
				b = index.getX( i + 1 );
				c = index.getX( i + 2 );

				_calculateMorphedAttributeData(
					object,
					positionAttribute,
					morphPosition,
					morphTargetsRelative,
					a, b, c,
					modifiedPosition
				);

				_calculateMorphedAttributeData(
					object,
					normalAttribute,
					morphNormal,
					morphTargetsRelative,
					a, b, c,
					modifiedNormal
				);

			}

		}

	} else {

		// non-indexed buffer geometry

		if ( Array.isArray( material ) ) {

			for ( i = 0, il = groups.length; i < il; i ++ ) {

				group = groups[ i ];

				start = Math.max( group.start, drawRange.start );
				end = Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) );

				for ( j = start, jl = end; j < jl; j += 3 ) {

					a = j;
					b = j + 1;
					c = j + 2;

					_calculateMorphedAttributeData(
						object,
						positionAttribute,
						morphPosition,
						morphTargetsRelative,
						a, b, c,
						modifiedPosition
					);

					_calculateMorphedAttributeData(
						object,
						normalAttribute,
						morphNormal,
						morphTargetsRelative,
						a, b, c,
						modifiedNormal
					);

				}

			}

		} else {

			start = Math.max( 0, drawRange.start );
			end = Math.min( positionAttribute.count, ( drawRange.start + drawRange.count ) );

			for ( i = start, il = end; i < il; i += 3 ) {

				a = i;
				b = i + 1;
				c = i + 2;

				_calculateMorphedAttributeData(
					object,
					positionAttribute,
					morphPosition,
					morphTargetsRelative,
					a, b, c,
					modifiedPosition
				);

				_calculateMorphedAttributeData(
					object,
					normalAttribute,
					morphNormal,
					morphTargetsRelative,
					a, b, c,
					modifiedNormal
				);

			}

		}

	}

	const morphedPositionAttribute = new Float32BufferAttribute( modifiedPosition, 3 );
	const morphedNormalAttribute = new Float32BufferAttribute( modifiedNormal, 3 );

	return {

		positionAttribute: positionAttribute,
		normalAttribute: normalAttribute,
		morphedPositionAttribute: morphedPositionAttribute,
		morphedNormalAttribute: morphedNormalAttribute

	};

}

function mergeGroups( geometry ) {

	if ( geometry.groups.length === 0 ) {

		console.warn( 'THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.' );
		return geometry;

	}

	let groups = geometry.groups;

	// sort groups by material index

	groups = groups.sort( ( a, b ) => {

		if ( a.materialIndex !== b.materialIndex ) return a.materialIndex - b.materialIndex;

		return a.start - b.start;

	} );

	// create index for non-indexed geometries

	if ( geometry.getIndex() === null ) {

		const positionAttribute = geometry.getAttribute( 'position' );
		const indices = [];

		for ( let i = 0; i < positionAttribute.count; i += 3 ) {

			indices.push( i, i + 1, i + 2 );

		}

		geometry.setIndex( indices );

	}

	// sort index

	const index = geometry.getIndex();

	const newIndices = [];

	for ( let i = 0; i < groups.length; i ++ ) {

		const group = groups[ i ];

		const groupStart = group.start;
		const groupLength = groupStart + group.count;

		for ( let j = groupStart; j < groupLength; j ++ ) {

			newIndices.push( index.getX( j ) );

		}

	}

	geometry.dispose(); // Required to force buffer recreation
	geometry.setIndex( newIndices );

	// update groups indices

	let start = 0;

	for ( let i = 0; i < groups.length; i ++ ) {

		const group = groups[ i ];

		group.start = start;
		start += group.count;

	}

	// merge groups

	let currentGroup = groups[ 0 ];

	geometry.groups = [ currentGroup ];

	for ( let i = 1; i < groups.length; i ++ ) {

		const group = groups[ i ];

		if ( currentGroup.materialIndex === group.materialIndex ) {

			currentGroup.count += group.count;

		} else {

			currentGroup = group;
			geometry.groups.push( currentGroup );

		}

	}

	return geometry;

}


/**
 * Modifies the supplied geometry if it is non-indexed, otherwise creates a new,
 * non-indexed geometry. Returns the geometry with smooth normals everywhere except
 * faces that meet at an angle greater than the crease angle.
 *
 * @param {BufferGeometry} geometry
 * @param {number} [creaseAngle]
 * @return {BufferGeometry}
 */
function toCreasedNormals( geometry, creaseAngle = Math.PI / 3 /* 60 degrees */ ) {

	const creaseDot = Math.cos( creaseAngle );
	const hashMultiplier = ( 1 + 1e-10 ) * 1e2;

	// reusable vectors
	const verts = [ new Vector3(), new Vector3(), new Vector3() ];
	const tempVec1 = new Vector3();
	const tempVec2 = new Vector3();
	const tempNorm = new Vector3();
	const tempNorm2 = new Vector3();

	// hashes a vector
	function hashVertex( v ) {

		const x = ~ ~ ( v.x * hashMultiplier );
		const y = ~ ~ ( v.y * hashMultiplier );
		const z = ~ ~ ( v.z * hashMultiplier );
		return `${x},${y},${z}`;

	}

	// BufferGeometry.toNonIndexed() warns if the geometry is non-indexed
	// and returns the original geometry
	const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
	const posAttr = resultGeometry.attributes.position;
	const vertexMap = {};

	// find all the normals shared by commonly located vertices
	for ( let i = 0, l = posAttr.count / 3; i < l; i ++ ) {

		const i3 = 3 * i;
		const a = verts[ 0 ].fromBufferAttribute( posAttr, i3 + 0 );
		const b = verts[ 1 ].fromBufferAttribute( posAttr, i3 + 1 );
		const c = verts[ 2 ].fromBufferAttribute( posAttr, i3 + 2 );

		tempVec1.subVectors( c, b );
		tempVec2.subVectors( a, b );

		// add the normal to the map for all vertices
		const normal = new Vector3().crossVectors( tempVec1, tempVec2 ).normalize();
		for ( let n = 0; n < 3; n ++ ) {

			const vert = verts[ n ];
			const hash = hashVertex( vert );
			if ( ! ( hash in vertexMap ) ) {

				vertexMap[ hash ] = [];

			}

			vertexMap[ hash ].push( normal );

		}

	}

	// average normals from all vertices that share a common location if they are within the
	// provided crease threshold
	const normalArray = new Float32Array( posAttr.count * 3 );
	const normAttr = new BufferAttribute( normalArray, 3, false );
	for ( let i = 0, l = posAttr.count / 3; i < l; i ++ ) {

		// get the face normal for this vertex
		const i3 = 3 * i;
		const a = verts[ 0 ].fromBufferAttribute( posAttr, i3 + 0 );
		const b = verts[ 1 ].fromBufferAttribute( posAttr, i3 + 1 );
		const c = verts[ 2 ].fromBufferAttribute( posAttr, i3 + 2 );

		tempVec1.subVectors( c, b );
		tempVec2.subVectors( a, b );

		tempNorm.crossVectors( tempVec1, tempVec2 ).normalize();

		// average all normals that meet the threshold and set the normal value
		for ( let n = 0; n < 3; n ++ ) {

			const vert = verts[ n ];
			const hash = hashVertex( vert );
			const otherNormals = vertexMap[ hash ];
			tempNorm2.set( 0, 0, 0 );

			for ( let k = 0, lk = otherNormals.length; k < lk; k ++ ) {

				const otherNorm = otherNormals[ k ];
				if ( tempNorm.dot( otherNorm ) > creaseDot ) {

					tempNorm2.add( otherNorm );

				}

			}

			tempNorm2.normalize();
			normAttr.setXYZ( i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z );

		}

	}

	resultGeometry.setAttribute( 'normal', normAttr );
	return resultGeometry;

}



;// CONCATENATED MODULE: ./node_modules/three/examples/jsm/loaders/GLTFLoader.js



class GLTFLoader extends external_three_.Loader {

	constructor( manager ) {

		super( manager );

		this.dracoLoader = null;
		this.ktx2Loader = null;
		this.meshoptDecoder = null;

		this.pluginCallbacks = [];

		this.register( function ( parser ) {

			return new GLTFMaterialsClearcoatExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFTextureBasisUExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFTextureWebPExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFTextureAVIFExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsSheenExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsTransmissionExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsVolumeExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsIorExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsEmissiveStrengthExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsSpecularExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsIridescenceExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsAnisotropyExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMaterialsBumpExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFLightsExtension( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMeshoptCompression( parser );

		} );

		this.register( function ( parser ) {

			return new GLTFMeshGpuInstancing( parser );

		} );

	}

	load( url, onLoad, onProgress, onError ) {

		const scope = this;

		let resourcePath;

		if ( this.resourcePath !== '' ) {

			resourcePath = this.resourcePath;

		} else if ( this.path !== '' ) {

			// If a base path is set, resources will be relative paths from that plus the relative path of the gltf file
			// Example  path = 'https://my-cnd-server.com/', url = 'assets/models/model.gltf'
			// resourcePath = 'https://my-cnd-server.com/assets/models/'
			// referenced resource 'model.bin' will be loaded from 'https://my-cnd-server.com/assets/models/model.bin'
			// referenced resource '../textures/texture.png' will be loaded from 'https://my-cnd-server.com/assets/textures/texture.png'
			const relativeUrl = external_three_.LoaderUtils.extractUrlBase( url );
			resourcePath = external_three_.LoaderUtils.resolveURL( relativeUrl, this.path );

		} else {

			resourcePath = external_three_.LoaderUtils.extractUrlBase( url );

		}

		// Tells the LoadingManager to track an extra item, which resolves after
		// the model is fully loaded. This means the count of items loaded will
		// be incorrect, but ensures manager.onLoad() does not fire early.
		this.manager.itemStart( url );

		const _onError = function ( e ) {

			if ( onError ) {

				onError( e );

			} else {

				console.error( e );

			}

			scope.manager.itemError( url );
			scope.manager.itemEnd( url );

		};

		const loader = new external_three_.FileLoader( this.manager );

		loader.setPath( this.path );
		loader.setResponseType( 'arraybuffer' );
		loader.setRequestHeader( this.requestHeader );
		loader.setWithCredentials( this.withCredentials );

		loader.load( url, function ( data ) {

			try {

				scope.parse( data, resourcePath, function ( gltf ) {

					onLoad( gltf );

					scope.manager.itemEnd( url );

				}, _onError );

			} catch ( e ) {

				_onError( e );

			}

		}, onProgress, _onError );

	}

	setDRACOLoader( dracoLoader ) {

		this.dracoLoader = dracoLoader;
		return this;

	}

	setDDSLoader() {

		throw new Error(

			'THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".'

		);

	}

	setKTX2Loader( ktx2Loader ) {

		this.ktx2Loader = ktx2Loader;
		return this;

	}

	setMeshoptDecoder( meshoptDecoder ) {

		this.meshoptDecoder = meshoptDecoder;
		return this;

	}

	register( callback ) {

		if ( this.pluginCallbacks.indexOf( callback ) === - 1 ) {

			this.pluginCallbacks.push( callback );

		}

		return this;

	}

	unregister( callback ) {

		if ( this.pluginCallbacks.indexOf( callback ) !== - 1 ) {

			this.pluginCallbacks.splice( this.pluginCallbacks.indexOf( callback ), 1 );

		}

		return this;

	}

	parse( data, path, onLoad, onError ) {

		let json;
		const extensions = {};
		const plugins = {};
		const textDecoder = new TextDecoder();

		if ( typeof data === 'string' ) {

			json = JSON.parse( data );

		} else if ( data instanceof ArrayBuffer ) {

			const magic = textDecoder.decode( new Uint8Array( data, 0, 4 ) );

			if ( magic === BINARY_EXTENSION_HEADER_MAGIC ) {

				try {

					extensions[ EXTENSIONS.KHR_BINARY_GLTF ] = new GLTFBinaryExtension( data );

				} catch ( error ) {

					if ( onError ) onError( error );
					return;

				}

				json = JSON.parse( extensions[ EXTENSIONS.KHR_BINARY_GLTF ].content );

			} else {

				json = JSON.parse( textDecoder.decode( data ) );

			}

		} else {

			json = data;

		}

		if ( json.asset === undefined || json.asset.version[ 0 ] < 2 ) {

			if ( onError ) onError( new Error( 'THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.' ) );
			return;

		}

		const parser = new GLTFParser( json, {

			path: path || this.resourcePath || '',
			crossOrigin: this.crossOrigin,
			requestHeader: this.requestHeader,
			manager: this.manager,
			ktx2Loader: this.ktx2Loader,
			meshoptDecoder: this.meshoptDecoder

		} );

		parser.fileLoader.setRequestHeader( this.requestHeader );

		for ( let i = 0; i < this.pluginCallbacks.length; i ++ ) {

			const plugin = this.pluginCallbacks[ i ]( parser );

			if ( ! plugin.name ) console.error( 'THREE.GLTFLoader: Invalid plugin found: missing name' );

			plugins[ plugin.name ] = plugin;

			// Workaround to avoid determining as unknown extension
			// in addUnknownExtensionsToUserData().
			// Remove this workaround if we move all the existing
			// extension handlers to plugin system
			extensions[ plugin.name ] = true;

		}

		if ( json.extensionsUsed ) {

			for ( let i = 0; i < json.extensionsUsed.length; ++ i ) {

				const extensionName = json.extensionsUsed[ i ];
				const extensionsRequired = json.extensionsRequired || [];

				switch ( extensionName ) {

					case EXTENSIONS.KHR_MATERIALS_UNLIT:
						extensions[ extensionName ] = new GLTFMaterialsUnlitExtension();
						break;

					case EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
						extensions[ extensionName ] = new GLTFDracoMeshCompressionExtension( json, this.dracoLoader );
						break;

					case EXTENSIONS.KHR_TEXTURE_TRANSFORM:
						extensions[ extensionName ] = new GLTFTextureTransformExtension();
						break;

					case EXTENSIONS.KHR_MESH_QUANTIZATION:
						extensions[ extensionName ] = new GLTFMeshQuantizationExtension();
						break;

					default:

						if ( extensionsRequired.indexOf( extensionName ) >= 0 && plugins[ extensionName ] === undefined ) {

							console.warn( 'THREE.GLTFLoader: Unknown extension "' + extensionName + '".' );

						}

				}

			}

		}

		parser.setExtensions( extensions );
		parser.setPlugins( plugins );
		parser.parse( onLoad, onError );

	}

	parseAsync( data, path ) {

		const scope = this;

		return new Promise( function ( resolve, reject ) {

			scope.parse( data, path, resolve, reject );

		} );

	}

}

/* GLTFREGISTRY */

function GLTFRegistry() {

	let objects = {};

	return	{

		get: function ( key ) {

			return objects[ key ];

		},

		add: function ( key, object ) {

			objects[ key ] = object;

		},

		remove: function ( key ) {

			delete objects[ key ];

		},

		removeAll: function () {

			objects = {};

		}

	};

}

/*********************************/
/********** EXTENSIONS ***********/
/*********************************/

const EXTENSIONS = {
	KHR_BINARY_GLTF: 'KHR_binary_glTF',
	KHR_DRACO_MESH_COMPRESSION: 'KHR_draco_mesh_compression',
	KHR_LIGHTS_PUNCTUAL: 'KHR_lights_punctual',
	KHR_MATERIALS_CLEARCOAT: 'KHR_materials_clearcoat',
	KHR_MATERIALS_IOR: 'KHR_materials_ior',
	KHR_MATERIALS_SHEEN: 'KHR_materials_sheen',
	KHR_MATERIALS_SPECULAR: 'KHR_materials_specular',
	KHR_MATERIALS_TRANSMISSION: 'KHR_materials_transmission',
	KHR_MATERIALS_IRIDESCENCE: 'KHR_materials_iridescence',
	KHR_MATERIALS_ANISOTROPY: 'KHR_materials_anisotropy',
	KHR_MATERIALS_UNLIT: 'KHR_materials_unlit',
	KHR_MATERIALS_VOLUME: 'KHR_materials_volume',
	KHR_TEXTURE_BASISU: 'KHR_texture_basisu',
	KHR_TEXTURE_TRANSFORM: 'KHR_texture_transform',
	KHR_MESH_QUANTIZATION: 'KHR_mesh_quantization',
	KHR_MATERIALS_EMISSIVE_STRENGTH: 'KHR_materials_emissive_strength',
	EXT_MATERIALS_BUMP: 'EXT_materials_bump',
	EXT_TEXTURE_WEBP: 'EXT_texture_webp',
	EXT_TEXTURE_AVIF: 'EXT_texture_avif',
	EXT_MESHOPT_COMPRESSION: 'EXT_meshopt_compression',
	EXT_MESH_GPU_INSTANCING: 'EXT_mesh_gpu_instancing'
};

/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 */
class GLTFLightsExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_LIGHTS_PUNCTUAL;

		// Object3D instance caches
		this.cache = { refs: {}, uses: {} };

	}

	_markDefs() {

		const parser = this.parser;
		const nodeDefs = this.parser.json.nodes || [];

		for ( let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex ++ ) {

			const nodeDef = nodeDefs[ nodeIndex ];

			if ( nodeDef.extensions
					&& nodeDef.extensions[ this.name ]
					&& nodeDef.extensions[ this.name ].light !== undefined ) {

				parser._addNodeRef( this.cache, nodeDef.extensions[ this.name ].light );

			}

		}

	}

	_loadLight( lightIndex ) {

		const parser = this.parser;
		const cacheKey = 'light:' + lightIndex;
		let dependency = parser.cache.get( cacheKey );

		if ( dependency ) return dependency;

		const json = parser.json;
		const extensions = ( json.extensions && json.extensions[ this.name ] ) || {};
		const lightDefs = extensions.lights || [];
		const lightDef = lightDefs[ lightIndex ];
		let lightNode;

		const color = new external_three_.Color( 0xffffff );

		if ( lightDef.color !== undefined ) color.setRGB( lightDef.color[ 0 ], lightDef.color[ 1 ], lightDef.color[ 2 ], external_three_.LinearSRGBColorSpace );

		const range = lightDef.range !== undefined ? lightDef.range : 0;

		switch ( lightDef.type ) {

			case 'directional':
				lightNode = new external_three_.DirectionalLight( color );
				lightNode.target.position.set( 0, 0, - 1 );
				lightNode.add( lightNode.target );
				break;

			case 'point':
				lightNode = new external_three_.PointLight( color );
				lightNode.distance = range;
				break;

			case 'spot':
				lightNode = new external_three_.SpotLight( color );
				lightNode.distance = range;
				// Handle spotlight properties.
				lightDef.spot = lightDef.spot || {};
				lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
				lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
				lightNode.angle = lightDef.spot.outerConeAngle;
				lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
				lightNode.target.position.set( 0, 0, - 1 );
				lightNode.add( lightNode.target );
				break;

			default:
				throw new Error( 'THREE.GLTFLoader: Unexpected light type: ' + lightDef.type );

		}

		// Some lights (e.g. spot) default to a position other than the origin. Reset the position
		// here, because node-level parsing will only override position if explicitly specified.
		lightNode.position.set( 0, 0, 0 );

		lightNode.decay = 2;

		assignExtrasToUserData( lightNode, lightDef );

		if ( lightDef.intensity !== undefined ) lightNode.intensity = lightDef.intensity;

		lightNode.name = parser.createUniqueName( lightDef.name || ( 'light_' + lightIndex ) );

		dependency = Promise.resolve( lightNode );

		parser.cache.add( cacheKey, dependency );

		return dependency;

	}

	getDependency( type, index ) {

		if ( type !== 'light' ) return;

		return this._loadLight( index );

	}

	createNodeAttachment( nodeIndex ) {

		const self = this;
		const parser = this.parser;
		const json = parser.json;
		const nodeDef = json.nodes[ nodeIndex ];
		const lightDef = ( nodeDef.extensions && nodeDef.extensions[ this.name ] ) || {};
		const lightIndex = lightDef.light;

		if ( lightIndex === undefined ) return null;

		return this._loadLight( lightIndex ).then( function ( light ) {

			return parser._getNodeRef( self.cache, lightIndex, light );

		} );

	}

}

/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 */
class GLTFMaterialsUnlitExtension {

	constructor() {

		this.name = EXTENSIONS.KHR_MATERIALS_UNLIT;

	}

	getMaterialType() {

		return external_three_.MeshBasicMaterial;

	}

	extendParams( materialParams, materialDef, parser ) {

		const pending = [];

		materialParams.color = new external_three_.Color( 1.0, 1.0, 1.0 );
		materialParams.opacity = 1.0;

		const metallicRoughness = materialDef.pbrMetallicRoughness;

		if ( metallicRoughness ) {

			if ( Array.isArray( metallicRoughness.baseColorFactor ) ) {

				const array = metallicRoughness.baseColorFactor;

				materialParams.color.setRGB( array[ 0 ], array[ 1 ], array[ 2 ], external_three_.LinearSRGBColorSpace );
				materialParams.opacity = array[ 3 ];

			}

			if ( metallicRoughness.baseColorTexture !== undefined ) {

				pending.push( parser.assignTexture( materialParams, 'map', metallicRoughness.baseColorTexture, external_three_.SRGBColorSpace ) );

			}

		}

		return Promise.all( pending );

	}

}

/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 */
class GLTFMaterialsEmissiveStrengthExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const emissiveStrength = materialDef.extensions[ this.name ].emissiveStrength;

		if ( emissiveStrength !== undefined ) {

			materialParams.emissiveIntensity = emissiveStrength;

		}

		return Promise.resolve();

	}

}

/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 */
class GLTFMaterialsClearcoatExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_CLEARCOAT;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		if ( extension.clearcoatFactor !== undefined ) {

			materialParams.clearcoat = extension.clearcoatFactor;

		}

		if ( extension.clearcoatTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'clearcoatMap', extension.clearcoatTexture ) );

		}

		if ( extension.clearcoatRoughnessFactor !== undefined ) {

			materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;

		}

		if ( extension.clearcoatRoughnessTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'clearcoatRoughnessMap', extension.clearcoatRoughnessTexture ) );

		}

		if ( extension.clearcoatNormalTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'clearcoatNormalMap', extension.clearcoatNormalTexture ) );

			if ( extension.clearcoatNormalTexture.scale !== undefined ) {

				const scale = extension.clearcoatNormalTexture.scale;

				materialParams.clearcoatNormalScale = new external_three_.Vector2( scale, scale );

			}

		}

		return Promise.all( pending );

	}

}

/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 */
class GLTFMaterialsIridescenceExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		if ( extension.iridescenceFactor !== undefined ) {

			materialParams.iridescence = extension.iridescenceFactor;

		}

		if ( extension.iridescenceTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'iridescenceMap', extension.iridescenceTexture ) );

		}

		if ( extension.iridescenceIor !== undefined ) {

			materialParams.iridescenceIOR = extension.iridescenceIor;

		}

		if ( materialParams.iridescenceThicknessRange === undefined ) {

			materialParams.iridescenceThicknessRange = [ 100, 400 ];

		}

		if ( extension.iridescenceThicknessMinimum !== undefined ) {

			materialParams.iridescenceThicknessRange[ 0 ] = extension.iridescenceThicknessMinimum;

		}

		if ( extension.iridescenceThicknessMaximum !== undefined ) {

			materialParams.iridescenceThicknessRange[ 1 ] = extension.iridescenceThicknessMaximum;

		}

		if ( extension.iridescenceThicknessTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'iridescenceThicknessMap', extension.iridescenceThicknessTexture ) );

		}

		return Promise.all( pending );

	}

}

/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 */
class GLTFMaterialsSheenExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_SHEEN;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		materialParams.sheenColor = new external_three_.Color( 0, 0, 0 );
		materialParams.sheenRoughness = 0;
		materialParams.sheen = 1;

		const extension = materialDef.extensions[ this.name ];

		if ( extension.sheenColorFactor !== undefined ) {

			const colorFactor = extension.sheenColorFactor;
			materialParams.sheenColor.setRGB( colorFactor[ 0 ], colorFactor[ 1 ], colorFactor[ 2 ], external_three_.LinearSRGBColorSpace );

		}

		if ( extension.sheenRoughnessFactor !== undefined ) {

			materialParams.sheenRoughness = extension.sheenRoughnessFactor;

		}

		if ( extension.sheenColorTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'sheenColorMap', extension.sheenColorTexture, external_three_.SRGBColorSpace ) );

		}

		if ( extension.sheenRoughnessTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'sheenRoughnessMap', extension.sheenRoughnessTexture ) );

		}

		return Promise.all( pending );

	}

}

/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 */
class GLTFMaterialsTransmissionExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_TRANSMISSION;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		if ( extension.transmissionFactor !== undefined ) {

			materialParams.transmission = extension.transmissionFactor;

		}

		if ( extension.transmissionTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'transmissionMap', extension.transmissionTexture ) );

		}

		return Promise.all( pending );

	}

}

/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 */
class GLTFMaterialsVolumeExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_VOLUME;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;

		if ( extension.thicknessTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'thicknessMap', extension.thicknessTexture ) );

		}

		materialParams.attenuationDistance = extension.attenuationDistance || Infinity;

		const colorArray = extension.attenuationColor || [ 1, 1, 1 ];
		materialParams.attenuationColor = new external_three_.Color().setRGB( colorArray[ 0 ], colorArray[ 1 ], colorArray[ 2 ], external_three_.LinearSRGBColorSpace );

		return Promise.all( pending );

	}

}

/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 */
class GLTFMaterialsIorExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_IOR;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const extension = materialDef.extensions[ this.name ];

		materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;

		return Promise.resolve();

	}

}

/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 */
class GLTFMaterialsSpecularExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_SPECULAR;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;

		if ( extension.specularTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'specularIntensityMap', extension.specularTexture ) );

		}

		const colorArray = extension.specularColorFactor || [ 1, 1, 1 ];
		materialParams.specularColor = new external_three_.Color().setRGB( colorArray[ 0 ], colorArray[ 1 ], colorArray[ 2 ], external_three_.LinearSRGBColorSpace );

		if ( extension.specularColorTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'specularColorMap', extension.specularColorTexture, external_three_.SRGBColorSpace ) );

		}

		return Promise.all( pending );

	}

}


/**
 * Materials bump Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/EXT_materials_bump
 */
class GLTFMaterialsBumpExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.EXT_MATERIALS_BUMP;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		materialParams.bumpScale = extension.bumpFactor !== undefined ? extension.bumpFactor : 1.0;

		if ( extension.bumpTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'bumpMap', extension.bumpTexture ) );

		}

		return Promise.all( pending );

	}

}

/**
 * Materials anisotropy Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_anisotropy
 */
class GLTFMaterialsAnisotropyExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_ANISOTROPY;

	}

	getMaterialType( materialIndex ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) return null;

		return external_three_.MeshPhysicalMaterial;

	}

	extendMaterialParams( materialIndex, materialParams ) {

		const parser = this.parser;
		const materialDef = parser.json.materials[ materialIndex ];

		if ( ! materialDef.extensions || ! materialDef.extensions[ this.name ] ) {

			return Promise.resolve();

		}

		const pending = [];

		const extension = materialDef.extensions[ this.name ];

		if ( extension.anisotropyStrength !== undefined ) {

			materialParams.anisotropy = extension.anisotropyStrength;

		}

		if ( extension.anisotropyRotation !== undefined ) {

			materialParams.anisotropyRotation = extension.anisotropyRotation;

		}

		if ( extension.anisotropyTexture !== undefined ) {

			pending.push( parser.assignTexture( materialParams, 'anisotropyMap', extension.anisotropyTexture ) );

		}

		return Promise.all( pending );

	}

}

/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 */
class GLTFTextureBasisUExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.KHR_TEXTURE_BASISU;

	}

	loadTexture( textureIndex ) {

		const parser = this.parser;
		const json = parser.json;

		const textureDef = json.textures[ textureIndex ];

		if ( ! textureDef.extensions || ! textureDef.extensions[ this.name ] ) {

			return null;

		}

		const extension = textureDef.extensions[ this.name ];
		const loader = parser.options.ktx2Loader;

		if ( ! loader ) {

			if ( json.extensionsRequired && json.extensionsRequired.indexOf( this.name ) >= 0 ) {

				throw new Error( 'THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures' );

			} else {

				// Assumes that the extension is optional and that a fallback texture is present
				return null;

			}

		}

		return parser.loadTextureImage( textureIndex, extension.source, loader );

	}

}

/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 */
class GLTFTextureWebPExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.EXT_TEXTURE_WEBP;
		this.isSupported = null;

	}

	loadTexture( textureIndex ) {

		const name = this.name;
		const parser = this.parser;
		const json = parser.json;

		const textureDef = json.textures[ textureIndex ];

		if ( ! textureDef.extensions || ! textureDef.extensions[ name ] ) {

			return null;

		}

		const extension = textureDef.extensions[ name ];
		const source = json.images[ extension.source ];

		let loader = parser.textureLoader;
		if ( source.uri ) {

			const handler = parser.options.manager.getHandler( source.uri );
			if ( handler !== null ) loader = handler;

		}

		return this.detectSupport().then( function ( isSupported ) {

			if ( isSupported ) return parser.loadTextureImage( textureIndex, extension.source, loader );

			if ( json.extensionsRequired && json.extensionsRequired.indexOf( name ) >= 0 ) {

				throw new Error( 'THREE.GLTFLoader: WebP required by asset but unsupported.' );

			}

			// Fall back to PNG or JPEG.
			return parser.loadTexture( textureIndex );

		} );

	}

	detectSupport() {

		if ( ! this.isSupported ) {

			this.isSupported = new Promise( function ( resolve ) {

				const image = new Image();

				// Lossy test image. Support for lossy images doesn't guarantee support for all
				// WebP images, unfortunately.
				image.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';

				image.onload = image.onerror = function () {

					resolve( image.height === 1 );

				};

			} );

		}

		return this.isSupported;

	}

}

/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 */
class GLTFTextureAVIFExtension {

	constructor( parser ) {

		this.parser = parser;
		this.name = EXTENSIONS.EXT_TEXTURE_AVIF;
		this.isSupported = null;

	}

	loadTexture( textureIndex ) {

		const name = this.name;
		const parser = this.parser;
		const json = parser.json;

		const textureDef = json.textures[ textureIndex ];

		if ( ! textureDef.extensions || ! textureDef.extensions[ name ] ) {

			return null;

		}

		const extension = textureDef.extensions[ name ];
		const source = json.images[ extension.source ];

		let loader = parser.textureLoader;
		if ( source.uri ) {

			const handler = parser.options.manager.getHandler( source.uri );
			if ( handler !== null ) loader = handler;

		}

		return this.detectSupport().then( function ( isSupported ) {

			if ( isSupported ) return parser.loadTextureImage( textureIndex, extension.source, loader );

			if ( json.extensionsRequired && json.extensionsRequired.indexOf( name ) >= 0 ) {

				throw new Error( 'THREE.GLTFLoader: AVIF required by asset but unsupported.' );

			}

			// Fall back to PNG or JPEG.
			return parser.loadTexture( textureIndex );

		} );

	}

	detectSupport() {

		if ( ! this.isSupported ) {

			this.isSupported = new Promise( function ( resolve ) {

				const image = new Image();

				// Lossy test image.
				image.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=';
				image.onload = image.onerror = function () {

					resolve( image.height === 1 );

				};

			} );

		}

		return this.isSupported;

	}

}

/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 */
class GLTFMeshoptCompression {

	constructor( parser ) {

		this.name = EXTENSIONS.EXT_MESHOPT_COMPRESSION;
		this.parser = parser;

	}

	loadBufferView( index ) {

		const json = this.parser.json;
		const bufferView = json.bufferViews[ index ];

		if ( bufferView.extensions && bufferView.extensions[ this.name ] ) {

			const extensionDef = bufferView.extensions[ this.name ];

			const buffer = this.parser.getDependency( 'buffer', extensionDef.buffer );
			const decoder = this.parser.options.meshoptDecoder;

			if ( ! decoder || ! decoder.supported ) {

				if ( json.extensionsRequired && json.extensionsRequired.indexOf( this.name ) >= 0 ) {

					throw new Error( 'THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files' );

				} else {

					// Assumes that the extension is optional and that fallback buffer data is present
					return null;

				}

			}

			return buffer.then( function ( res ) {

				const byteOffset = extensionDef.byteOffset || 0;
				const byteLength = extensionDef.byteLength || 0;

				const count = extensionDef.count;
				const stride = extensionDef.byteStride;

				const source = new Uint8Array( res, byteOffset, byteLength );

				if ( decoder.decodeGltfBufferAsync ) {

					return decoder.decodeGltfBufferAsync( count, stride, source, extensionDef.mode, extensionDef.filter ).then( function ( res ) {

						return res.buffer;

					} );

				} else {

					// Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
					return decoder.ready.then( function () {

						const result = new ArrayBuffer( count * stride );
						decoder.decodeGltfBuffer( new Uint8Array( result ), count, stride, source, extensionDef.mode, extensionDef.filter );
						return result;

					} );

				}

			} );

		} else {

			return null;

		}

	}

}

/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 */
class GLTFMeshGpuInstancing {

	constructor( parser ) {

		this.name = EXTENSIONS.EXT_MESH_GPU_INSTANCING;
		this.parser = parser;

	}

	createNodeMesh( nodeIndex ) {

		const json = this.parser.json;
		const nodeDef = json.nodes[ nodeIndex ];

		if ( ! nodeDef.extensions || ! nodeDef.extensions[ this.name ] ||
			nodeDef.mesh === undefined ) {

			return null;

		}

		const meshDef = json.meshes[ nodeDef.mesh ];

		// No Points or Lines + Instancing support yet

		for ( const primitive of meshDef.primitives ) {

			if ( primitive.mode !== WEBGL_CONSTANTS.TRIANGLES &&
				 primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_STRIP &&
				 primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_FAN &&
				 primitive.mode !== undefined ) {

				return null;

			}

		}

		const extensionDef = nodeDef.extensions[ this.name ];
		const attributesDef = extensionDef.attributes;

		// @TODO: Can we support InstancedMesh + SkinnedMesh?

		const pending = [];
		const attributes = {};

		for ( const key in attributesDef ) {

			pending.push( this.parser.getDependency( 'accessor', attributesDef[ key ] ).then( accessor => {

				attributes[ key ] = accessor;
				return attributes[ key ];

			} ) );

		}

		if ( pending.length < 1 ) {

			return null;

		}

		pending.push( this.parser.createNodeMesh( nodeIndex ) );

		return Promise.all( pending ).then( results => {

			const nodeObject = results.pop();
			const meshes = nodeObject.isGroup ? nodeObject.children : [ nodeObject ];
			const count = results[ 0 ].count; // All attribute counts should be same
			const instancedMeshes = [];

			for ( const mesh of meshes ) {

				// Temporal variables
				const m = new external_three_.Matrix4();
				const p = new external_three_.Vector3();
				const q = new external_three_.Quaternion();
				const s = new external_three_.Vector3( 1, 1, 1 );

				const instancedMesh = new external_three_.InstancedMesh( mesh.geometry, mesh.material, count );

				for ( let i = 0; i < count; i ++ ) {

					if ( attributes.TRANSLATION ) {

						p.fromBufferAttribute( attributes.TRANSLATION, i );

					}

					if ( attributes.ROTATION ) {

						q.fromBufferAttribute( attributes.ROTATION, i );

					}

					if ( attributes.SCALE ) {

						s.fromBufferAttribute( attributes.SCALE, i );

					}

					instancedMesh.setMatrixAt( i, m.compose( p, q, s ) );

				}

				// Add instance attributes to the geometry, excluding TRS.
				for ( const attributeName in attributes ) {

					if ( attributeName === '_COLOR_0' ) {

						const attr = attributes[ attributeName ];
						instancedMesh.instanceColor = new external_three_.InstancedBufferAttribute( attr.array, attr.itemSize, attr.normalized );

					} else if ( attributeName !== 'TRANSLATION' &&
						 attributeName !== 'ROTATION' &&
						 attributeName !== 'SCALE' ) {

						mesh.geometry.setAttribute( attributeName, attributes[ attributeName ] );

					}

				}

				// Just in case
				external_three_.Object3D.prototype.copy.call( instancedMesh, mesh );

				this.parser.assignFinalMaterial( instancedMesh );

				instancedMeshes.push( instancedMesh );

			}

			if ( nodeObject.isGroup ) {

				nodeObject.clear();

				nodeObject.add( ... instancedMeshes );

				return nodeObject;

			}

			return instancedMeshes[ 0 ];

		} );

	}

}

/* BINARY EXTENSION */
const BINARY_EXTENSION_HEADER_MAGIC = 'glTF';
const BINARY_EXTENSION_HEADER_LENGTH = 12;
const BINARY_EXTENSION_CHUNK_TYPES = { JSON: 0x4E4F534A, BIN: 0x004E4942 };

class GLTFBinaryExtension {

	constructor( data ) {

		this.name = EXTENSIONS.KHR_BINARY_GLTF;
		this.content = null;
		this.body = null;

		const headerView = new DataView( data, 0, BINARY_EXTENSION_HEADER_LENGTH );
		const textDecoder = new TextDecoder();

		this.header = {
			magic: textDecoder.decode( new Uint8Array( data.slice( 0, 4 ) ) ),
			version: headerView.getUint32( 4, true ),
			length: headerView.getUint32( 8, true )
		};

		if ( this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC ) {

			throw new Error( 'THREE.GLTFLoader: Unsupported glTF-Binary header.' );

		} else if ( this.header.version < 2.0 ) {

			throw new Error( 'THREE.GLTFLoader: Legacy binary file detected.' );

		}

		const chunkContentsLength = this.header.length - BINARY_EXTENSION_HEADER_LENGTH;
		const chunkView = new DataView( data, BINARY_EXTENSION_HEADER_LENGTH );
		let chunkIndex = 0;

		while ( chunkIndex < chunkContentsLength ) {

			const chunkLength = chunkView.getUint32( chunkIndex, true );
			chunkIndex += 4;

			const chunkType = chunkView.getUint32( chunkIndex, true );
			chunkIndex += 4;

			if ( chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON ) {

				const contentArray = new Uint8Array( data, BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength );
				this.content = textDecoder.decode( contentArray );

			} else if ( chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN ) {

				const byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
				this.body = data.slice( byteOffset, byteOffset + chunkLength );

			}

			// Clients must ignore chunks with unknown types.

			chunkIndex += chunkLength;

		}

		if ( this.content === null ) {

			throw new Error( 'THREE.GLTFLoader: JSON content not found.' );

		}

	}

}

/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 */
class GLTFDracoMeshCompressionExtension {

	constructor( json, dracoLoader ) {

		if ( ! dracoLoader ) {

			throw new Error( 'THREE.GLTFLoader: No DRACOLoader instance provided.' );

		}

		this.name = EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
		this.json = json;
		this.dracoLoader = dracoLoader;
		this.dracoLoader.preload();

	}

	decodePrimitive( primitive, parser ) {

		const json = this.json;
		const dracoLoader = this.dracoLoader;
		const bufferViewIndex = primitive.extensions[ this.name ].bufferView;
		const gltfAttributeMap = primitive.extensions[ this.name ].attributes;
		const threeAttributeMap = {};
		const attributeNormalizedMap = {};
		const attributeTypeMap = {};

		for ( const attributeName in gltfAttributeMap ) {

			const threeAttributeName = ATTRIBUTES[ attributeName ] || attributeName.toLowerCase();

			threeAttributeMap[ threeAttributeName ] = gltfAttributeMap[ attributeName ];

		}

		for ( const attributeName in primitive.attributes ) {

			const threeAttributeName = ATTRIBUTES[ attributeName ] || attributeName.toLowerCase();

			if ( gltfAttributeMap[ attributeName ] !== undefined ) {

				const accessorDef = json.accessors[ primitive.attributes[ attributeName ] ];
				const componentType = WEBGL_COMPONENT_TYPES[ accessorDef.componentType ];

				attributeTypeMap[ threeAttributeName ] = componentType.name;
				attributeNormalizedMap[ threeAttributeName ] = accessorDef.normalized === true;

			}

		}

		return parser.getDependency( 'bufferView', bufferViewIndex ).then( function ( bufferView ) {

			return new Promise( function ( resolve, reject ) {

				dracoLoader.decodeDracoFile( bufferView, function ( geometry ) {

					for ( const attributeName in geometry.attributes ) {

						const attribute = geometry.attributes[ attributeName ];
						const normalized = attributeNormalizedMap[ attributeName ];

						if ( normalized !== undefined ) attribute.normalized = normalized;

					}

					resolve( geometry );

				}, threeAttributeMap, attributeTypeMap, external_three_.LinearSRGBColorSpace, reject );

			} );

		} );

	}

}

/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 */
class GLTFTextureTransformExtension {

	constructor() {

		this.name = EXTENSIONS.KHR_TEXTURE_TRANSFORM;

	}

	extendTexture( texture, transform ) {

		if ( ( transform.texCoord === undefined || transform.texCoord === texture.channel )
			&& transform.offset === undefined
			&& transform.rotation === undefined
			&& transform.scale === undefined ) {

			// See https://github.com/mrdoob/three.js/issues/21819.
			return texture;

		}

		texture = texture.clone();

		if ( transform.texCoord !== undefined ) {

			texture.channel = transform.texCoord;

		}

		if ( transform.offset !== undefined ) {

			texture.offset.fromArray( transform.offset );

		}

		if ( transform.rotation !== undefined ) {

			texture.rotation = transform.rotation;

		}

		if ( transform.scale !== undefined ) {

			texture.repeat.fromArray( transform.scale );

		}

		texture.needsUpdate = true;

		return texture;

	}

}

/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 */
class GLTFMeshQuantizationExtension {

	constructor() {

		this.name = EXTENSIONS.KHR_MESH_QUANTIZATION;

	}

}

/*********************************/
/********** INTERPOLATION ********/
/*********************************/

// Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
class GLTFCubicSplineInterpolant extends external_three_.Interpolant {

	constructor( parameterPositions, sampleValues, sampleSize, resultBuffer ) {

		super( parameterPositions, sampleValues, sampleSize, resultBuffer );

	}

	copySampleValue_( index ) {

		// Copies a sample value to the result buffer. See description of glTF
		// CUBICSPLINE values layout in interpolate_() function below.

		const result = this.resultBuffer,
			values = this.sampleValues,
			valueSize = this.valueSize,
			offset = index * valueSize * 3 + valueSize;

		for ( let i = 0; i !== valueSize; i ++ ) {

			result[ i ] = values[ offset + i ];

		}

		return result;

	}

	interpolate_( i1, t0, t, t1 ) {

		const result = this.resultBuffer;
		const values = this.sampleValues;
		const stride = this.valueSize;

		const stride2 = stride * 2;
		const stride3 = stride * 3;

		const td = t1 - t0;

		const p = ( t - t0 ) / td;
		const pp = p * p;
		const ppp = pp * p;

		const offset1 = i1 * stride3;
		const offset0 = offset1 - stride3;

		const s2 = - 2 * ppp + 3 * pp;
		const s3 = ppp - pp;
		const s0 = 1 - s2;
		const s1 = s3 - pp + p;

		// Layout of keyframe output values for CUBICSPLINE animations:
		//   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
		for ( let i = 0; i !== stride; i ++ ) {

			const p0 = values[ offset0 + i + stride ]; // splineVertex_k
			const m0 = values[ offset0 + i + stride2 ] * td; // outTangent_k * (t_k+1 - t_k)
			const p1 = values[ offset1 + i + stride ]; // splineVertex_k+1
			const m1 = values[ offset1 + i ] * td; // inTangent_k+1 * (t_k+1 - t_k)

			result[ i ] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;

		}

		return result;

	}

}

const _q = new external_three_.Quaternion();

class GLTFCubicSplineQuaternionInterpolant extends GLTFCubicSplineInterpolant {

	interpolate_( i1, t0, t, t1 ) {

		const result = super.interpolate_( i1, t0, t, t1 );

		_q.fromArray( result ).normalize().toArray( result );

		return result;

	}

}


/*********************************/
/********** INTERNALS ************/
/*********************************/

/* CONSTANTS */

const WEBGL_CONSTANTS = {
	FLOAT: 5126,
	//FLOAT_MAT2: 35674,
	FLOAT_MAT3: 35675,
	FLOAT_MAT4: 35676,
	FLOAT_VEC2: 35664,
	FLOAT_VEC3: 35665,
	FLOAT_VEC4: 35666,
	LINEAR: 9729,
	REPEAT: 10497,
	SAMPLER_2D: 35678,
	POINTS: 0,
	LINES: 1,
	LINE_LOOP: 2,
	LINE_STRIP: 3,
	TRIANGLES: 4,
	TRIANGLE_STRIP: 5,
	TRIANGLE_FAN: 6,
	UNSIGNED_BYTE: 5121,
	UNSIGNED_SHORT: 5123
};

const WEBGL_COMPONENT_TYPES = {
	5120: Int8Array,
	5121: Uint8Array,
	5122: Int16Array,
	5123: Uint16Array,
	5125: Uint32Array,
	5126: Float32Array
};

const WEBGL_FILTERS = {
	9728: external_three_.NearestFilter,
	9729: external_three_.LinearFilter,
	9984: external_three_.NearestMipmapNearestFilter,
	9985: external_three_.LinearMipmapNearestFilter,
	9986: external_three_.NearestMipmapLinearFilter,
	9987: external_three_.LinearMipmapLinearFilter
};

const WEBGL_WRAPPINGS = {
	33071: external_three_.ClampToEdgeWrapping,
	33648: external_three_.MirroredRepeatWrapping,
	10497: external_three_.RepeatWrapping
};

const WEBGL_TYPE_SIZES = {
	'SCALAR': 1,
	'VEC2': 2,
	'VEC3': 3,
	'VEC4': 4,
	'MAT2': 4,
	'MAT3': 9,
	'MAT4': 16
};

const ATTRIBUTES = {
	POSITION: 'position',
	NORMAL: 'normal',
	TANGENT: 'tangent',
	TEXCOORD_0: 'uv',
	TEXCOORD_1: 'uv1',
	TEXCOORD_2: 'uv2',
	TEXCOORD_3: 'uv3',
	COLOR_0: 'color',
	WEIGHTS_0: 'skinWeight',
	JOINTS_0: 'skinIndex',
};

const PATH_PROPERTIES = {
	scale: 'scale',
	translation: 'position',
	rotation: 'quaternion',
	weights: 'morphTargetInfluences'
};

const INTERPOLATION = {
	CUBICSPLINE: undefined, // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
		                        // keyframe track will be initialized with a default interpolation type, then modified.
	LINEAR: external_three_.InterpolateLinear,
	STEP: external_three_.InterpolateDiscrete
};

const ALPHA_MODES = {
	OPAQUE: 'OPAQUE',
	MASK: 'MASK',
	BLEND: 'BLEND'
};

/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 */
function createDefaultMaterial( cache ) {

	if ( cache[ 'DefaultMaterial' ] === undefined ) {

		cache[ 'DefaultMaterial' ] = new external_three_.MeshStandardMaterial( {
			color: 0xFFFFFF,
			emissive: 0x000000,
			metalness: 1,
			roughness: 1,
			transparent: false,
			depthTest: true,
			side: external_three_.FrontSide
		} );

	}

	return cache[ 'DefaultMaterial' ];

}

function addUnknownExtensionsToUserData( knownExtensions, object, objectDef ) {

	// Add unknown glTF extensions to an object's userData.

	for ( const name in objectDef.extensions ) {

		if ( knownExtensions[ name ] === undefined ) {

			object.userData.gltfExtensions = object.userData.gltfExtensions || {};
			object.userData.gltfExtensions[ name ] = objectDef.extensions[ name ];

		}

	}

}

/**
 * @param {Object3D|Material|BufferGeometry} object
 * @param {GLTF.definition} gltfDef
 */
function assignExtrasToUserData( object, gltfDef ) {

	if ( gltfDef.extras !== undefined ) {

		if ( typeof gltfDef.extras === 'object' ) {

			Object.assign( object.userData, gltfDef.extras );

		} else {

			console.warn( 'THREE.GLTFLoader: Ignoring primitive type .extras, ' + gltfDef.extras );

		}

	}

}

/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */
function addMorphTargets( geometry, targets, parser ) {

	let hasMorphPosition = false;
	let hasMorphNormal = false;
	let hasMorphColor = false;

	for ( let i = 0, il = targets.length; i < il; i ++ ) {

		const target = targets[ i ];

		if ( target.POSITION !== undefined ) hasMorphPosition = true;
		if ( target.NORMAL !== undefined ) hasMorphNormal = true;
		if ( target.COLOR_0 !== undefined ) hasMorphColor = true;

		if ( hasMorphPosition && hasMorphNormal && hasMorphColor ) break;

	}

	if ( ! hasMorphPosition && ! hasMorphNormal && ! hasMorphColor ) return Promise.resolve( geometry );

	const pendingPositionAccessors = [];
	const pendingNormalAccessors = [];
	const pendingColorAccessors = [];

	for ( let i = 0, il = targets.length; i < il; i ++ ) {

		const target = targets[ i ];

		if ( hasMorphPosition ) {

			const pendingAccessor = target.POSITION !== undefined
				? parser.getDependency( 'accessor', target.POSITION )
				: geometry.attributes.position;

			pendingPositionAccessors.push( pendingAccessor );

		}

		if ( hasMorphNormal ) {

			const pendingAccessor = target.NORMAL !== undefined
				? parser.getDependency( 'accessor', target.NORMAL )
				: geometry.attributes.normal;

			pendingNormalAccessors.push( pendingAccessor );

		}

		if ( hasMorphColor ) {

			const pendingAccessor = target.COLOR_0 !== undefined
				? parser.getDependency( 'accessor', target.COLOR_0 )
				: geometry.attributes.color;

			pendingColorAccessors.push( pendingAccessor );

		}

	}

	return Promise.all( [
		Promise.all( pendingPositionAccessors ),
		Promise.all( pendingNormalAccessors ),
		Promise.all( pendingColorAccessors )
	] ).then( function ( accessors ) {

		const morphPositions = accessors[ 0 ];
		const morphNormals = accessors[ 1 ];
		const morphColors = accessors[ 2 ];

		if ( hasMorphPosition ) geometry.morphAttributes.position = morphPositions;
		if ( hasMorphNormal ) geometry.morphAttributes.normal = morphNormals;
		if ( hasMorphColor ) geometry.morphAttributes.color = morphColors;
		geometry.morphTargetsRelative = true;

		return geometry;

	} );

}

/**
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */
function updateMorphTargets( mesh, meshDef ) {

	mesh.updateMorphTargets();

	if ( meshDef.weights !== undefined ) {

		for ( let i = 0, il = meshDef.weights.length; i < il; i ++ ) {

			mesh.morphTargetInfluences[ i ] = meshDef.weights[ i ];

		}

	}

	// .extras has user-defined data, so check that .extras.targetNames is an array.
	if ( meshDef.extras && Array.isArray( meshDef.extras.targetNames ) ) {

		const targetNames = meshDef.extras.targetNames;

		if ( mesh.morphTargetInfluences.length === targetNames.length ) {

			mesh.morphTargetDictionary = {};

			for ( let i = 0, il = targetNames.length; i < il; i ++ ) {

				mesh.morphTargetDictionary[ targetNames[ i ] ] = i;

			}

		} else {

			console.warn( 'THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.' );

		}

	}

}

function createPrimitiveKey( primitiveDef ) {

	let geometryKey;

	const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[ EXTENSIONS.KHR_DRACO_MESH_COMPRESSION ];

	if ( dracoExtension ) {

		geometryKey = 'draco:' + dracoExtension.bufferView
				+ ':' + dracoExtension.indices
				+ ':' + createAttributesKey( dracoExtension.attributes );

	} else {

		geometryKey = primitiveDef.indices + ':' + createAttributesKey( primitiveDef.attributes ) + ':' + primitiveDef.mode;

	}

	if ( primitiveDef.targets !== undefined ) {

		for ( let i = 0, il = primitiveDef.targets.length; i < il; i ++ ) {

			geometryKey += ':' + createAttributesKey( primitiveDef.targets[ i ] );

		}

	}

	return geometryKey;

}

function createAttributesKey( attributes ) {

	let attributesKey = '';

	const keys = Object.keys( attributes ).sort();

	for ( let i = 0, il = keys.length; i < il; i ++ ) {

		attributesKey += keys[ i ] + ':' + attributes[ keys[ i ] ] + ';';

	}

	return attributesKey;

}

function getNormalizedComponentScale( constructor ) {

	// Reference:
	// https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data

	switch ( constructor ) {

		case Int8Array:
			return 1 / 127;

		case Uint8Array:
			return 1 / 255;

		case Int16Array:
			return 1 / 32767;

		case Uint16Array:
			return 1 / 65535;

		default:
			throw new Error( 'THREE.GLTFLoader: Unsupported normalized accessor component type.' );

	}

}

function getImageURIMimeType( uri ) {

	if ( uri.search( /\.jpe?g($|\?)/i ) > 0 || uri.search( /^data\:image\/jpeg/ ) === 0 ) return 'image/jpeg';
	if ( uri.search( /\.webp($|\?)/i ) > 0 || uri.search( /^data\:image\/webp/ ) === 0 ) return 'image/webp';

	return 'image/png';

}

const _identityMatrix = new external_three_.Matrix4();

/* GLTF PARSER */

class GLTFParser {

	constructor( json = {}, options = {} ) {

		this.json = json;
		this.extensions = {};
		this.plugins = {};
		this.options = options;

		// loader object cache
		this.cache = new GLTFRegistry();

		// associations between Three.js objects and glTF elements
		this.associations = new Map();

		// BufferGeometry caching
		this.primitiveCache = {};

		// Node cache
		this.nodeCache = {};

		// Object3D instance caches
		this.meshCache = { refs: {}, uses: {} };
		this.cameraCache = { refs: {}, uses: {} };
		this.lightCache = { refs: {}, uses: {} };

		this.sourceCache = {};
		this.textureCache = {};

		// Track node names, to ensure no duplicates
		this.nodeNamesUsed = {};

		// Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
		// expensive work of uploading a texture to the GPU off the main thread.

		let isSafari = false;
		let isFirefox = false;
		let firefoxVersion = - 1;

		if ( typeof navigator !== 'undefined' ) {

			isSafari = /^((?!chrome|android).)*safari/i.test( navigator.userAgent ) === true;
			isFirefox = navigator.userAgent.indexOf( 'Firefox' ) > - 1;
			firefoxVersion = isFirefox ? navigator.userAgent.match( /Firefox\/([0-9]+)\./ )[ 1 ] : - 1;

		}

		if ( typeof createImageBitmap === 'undefined' || isSafari || ( isFirefox && firefoxVersion < 98 ) ) {

			this.textureLoader = new external_three_.TextureLoader( this.options.manager );

		} else {

			this.textureLoader = new external_three_.ImageBitmapLoader( this.options.manager );

		}

		this.textureLoader.setCrossOrigin( this.options.crossOrigin );
		this.textureLoader.setRequestHeader( this.options.requestHeader );

		this.fileLoader = new external_three_.FileLoader( this.options.manager );
		this.fileLoader.setResponseType( 'arraybuffer' );

		if ( this.options.crossOrigin === 'use-credentials' ) {

			this.fileLoader.setWithCredentials( true );

		}

	}

	setExtensions( extensions ) {

		this.extensions = extensions;

	}

	setPlugins( plugins ) {

		this.plugins = plugins;

	}

	parse( onLoad, onError ) {

		const parser = this;
		const json = this.json;
		const extensions = this.extensions;

		// Clear the loader cache
		this.cache.removeAll();
		this.nodeCache = {};

		// Mark the special nodes/meshes in json for efficient parse
		this._invokeAll( function ( ext ) {

			return ext._markDefs && ext._markDefs();

		} );

		Promise.all( this._invokeAll( function ( ext ) {

			return ext.beforeRoot && ext.beforeRoot();

		} ) ).then( function () {

			return Promise.all( [

				parser.getDependencies( 'scene' ),
				parser.getDependencies( 'animation' ),
				parser.getDependencies( 'camera' ),

			] );

		} ).then( function ( dependencies ) {

			const result = {
				scene: dependencies[ 0 ][ json.scene || 0 ],
				scenes: dependencies[ 0 ],
				animations: dependencies[ 1 ],
				cameras: dependencies[ 2 ],
				asset: json.asset,
				parser: parser,
				userData: {}
			};

			addUnknownExtensionsToUserData( extensions, result, json );

			assignExtrasToUserData( result, json );

			return Promise.all( parser._invokeAll( function ( ext ) {

				return ext.afterRoot && ext.afterRoot( result );

			} ) ).then( function () {

				for ( const scene of result.scenes ) {

					scene.updateMatrixWorld();

				}

				onLoad( result );

			} );

		} ).catch( onError );

	}

	/**
	 * Marks the special nodes/meshes in json for efficient parse.
	 */
	_markDefs() {

		const nodeDefs = this.json.nodes || [];
		const skinDefs = this.json.skins || [];
		const meshDefs = this.json.meshes || [];

		// Nothing in the node definition indicates whether it is a Bone or an
		// Object3D. Use the skins' joint references to mark bones.
		for ( let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex ++ ) {

			const joints = skinDefs[ skinIndex ].joints;

			for ( let i = 0, il = joints.length; i < il; i ++ ) {

				nodeDefs[ joints[ i ] ].isBone = true;

			}

		}

		// Iterate over all nodes, marking references to shared resources,
		// as well as skeleton joints.
		for ( let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex ++ ) {

			const nodeDef = nodeDefs[ nodeIndex ];

			if ( nodeDef.mesh !== undefined ) {

				this._addNodeRef( this.meshCache, nodeDef.mesh );

				// Nothing in the mesh definition indicates whether it is
				// a SkinnedMesh or Mesh. Use the node's mesh reference
				// to mark SkinnedMesh if node has skin.
				if ( nodeDef.skin !== undefined ) {

					meshDefs[ nodeDef.mesh ].isSkinnedMesh = true;

				}

			}

			if ( nodeDef.camera !== undefined ) {

				this._addNodeRef( this.cameraCache, nodeDef.camera );

			}

		}

	}

	/**
	 * Counts references to shared node / Object3D resources. These resources
	 * can be reused, or "instantiated", at multiple nodes in the scene
	 * hierarchy. Mesh, Camera, and Light instances are instantiated and must
	 * be marked. Non-scenegraph resources (like Materials, Geometries, and
	 * Textures) can be reused directly and are not marked here.
	 *
	 * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
	 */
	_addNodeRef( cache, index ) {

		if ( index === undefined ) return;

		if ( cache.refs[ index ] === undefined ) {

			cache.refs[ index ] = cache.uses[ index ] = 0;

		}

		cache.refs[ index ] ++;

	}

	/** Returns a reference to a shared resource, cloning it if necessary. */
	_getNodeRef( cache, index, object ) {

		if ( cache.refs[ index ] <= 1 ) return object;

		const ref = object.clone();

		// Propagates mappings to the cloned object, prevents mappings on the
		// original object from being lost.
		const updateMappings = ( original, clone ) => {

			const mappings = this.associations.get( original );
			if ( mappings != null ) {

				this.associations.set( clone, mappings );

			}

			for ( const [ i, child ] of original.children.entries() ) {

				updateMappings( child, clone.children[ i ] );

			}

		};

		updateMappings( object, ref );

		ref.name += '_instance_' + ( cache.uses[ index ] ++ );

		return ref;

	}

	_invokeOne( func ) {

		const extensions = Object.values( this.plugins );
		extensions.push( this );

		for ( let i = 0; i < extensions.length; i ++ ) {

			const result = func( extensions[ i ] );

			if ( result ) return result;

		}

		return null;

	}

	_invokeAll( func ) {

		const extensions = Object.values( this.plugins );
		extensions.unshift( this );

		const pending = [];

		for ( let i = 0; i < extensions.length; i ++ ) {

			const result = func( extensions[ i ] );

			if ( result ) pending.push( result );

		}

		return pending;

	}

	/**
	 * Requests the specified dependency asynchronously, with caching.
	 * @param {string} type
	 * @param {number} index
	 * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
	 */
	getDependency( type, index ) {

		const cacheKey = type + ':' + index;
		let dependency = this.cache.get( cacheKey );

		if ( ! dependency ) {

			switch ( type ) {

				case 'scene':
					dependency = this.loadScene( index );
					break;

				case 'node':
					dependency = this._invokeOne( function ( ext ) {

						return ext.loadNode && ext.loadNode( index );

					} );
					break;

				case 'mesh':
					dependency = this._invokeOne( function ( ext ) {

						return ext.loadMesh && ext.loadMesh( index );

					} );
					break;

				case 'accessor':
					dependency = this.loadAccessor( index );
					break;

				case 'bufferView':
					dependency = this._invokeOne( function ( ext ) {

						return ext.loadBufferView && ext.loadBufferView( index );

					} );
					break;

				case 'buffer':
					dependency = this.loadBuffer( index );
					break;

				case 'material':
					dependency = this._invokeOne( function ( ext ) {

						return ext.loadMaterial && ext.loadMaterial( index );

					} );
					break;

				case 'texture':
					dependency = this._invokeOne( function ( ext ) {

						return ext.loadTexture && ext.loadTexture( index );

					} );
					break;

				case 'skin':
					dependency = this.loadSkin( index );
					break;

				case 'animation':
					dependency = this._invokeOne( function ( ext ) {

						return ext.loadAnimation && ext.loadAnimation( index );

					} );
					break;

				case 'camera':
					dependency = this.loadCamera( index );
					break;

				default:
					dependency = this._invokeOne( function ( ext ) {

						return ext != this && ext.getDependency && ext.getDependency( type, index );

					} );

					if ( ! dependency ) {

						throw new Error( 'Unknown type: ' + type );

					}

					break;

			}

			this.cache.add( cacheKey, dependency );

		}

		return dependency;

	}

	/**
	 * Requests all dependencies of the specified type asynchronously, with caching.
	 * @param {string} type
	 * @return {Promise<Array<Object>>}
	 */
	getDependencies( type ) {

		let dependencies = this.cache.get( type );

		if ( ! dependencies ) {

			const parser = this;
			const defs = this.json[ type + ( type === 'mesh' ? 'es' : 's' ) ] || [];

			dependencies = Promise.all( defs.map( function ( def, index ) {

				return parser.getDependency( type, index );

			} ) );

			this.cache.add( type, dependencies );

		}

		return dependencies;

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferIndex
	 * @return {Promise<ArrayBuffer>}
	 */
	loadBuffer( bufferIndex ) {

		const bufferDef = this.json.buffers[ bufferIndex ];
		const loader = this.fileLoader;

		if ( bufferDef.type && bufferDef.type !== 'arraybuffer' ) {

			throw new Error( 'THREE.GLTFLoader: ' + bufferDef.type + ' buffer type is not supported.' );

		}

		// If present, GLB container is required to be the first buffer.
		if ( bufferDef.uri === undefined && bufferIndex === 0 ) {

			return Promise.resolve( this.extensions[ EXTENSIONS.KHR_BINARY_GLTF ].body );

		}

		const options = this.options;

		return new Promise( function ( resolve, reject ) {

			loader.load( external_three_.LoaderUtils.resolveURL( bufferDef.uri, options.path ), resolve, undefined, function () {

				reject( new Error( 'THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".' ) );

			} );

		} );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferViewIndex
	 * @return {Promise<ArrayBuffer>}
	 */
	loadBufferView( bufferViewIndex ) {

		const bufferViewDef = this.json.bufferViews[ bufferViewIndex ];

		return this.getDependency( 'buffer', bufferViewDef.buffer ).then( function ( buffer ) {

			const byteLength = bufferViewDef.byteLength || 0;
			const byteOffset = bufferViewDef.byteOffset || 0;
			return buffer.slice( byteOffset, byteOffset + byteLength );

		} );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
	 * @param {number} accessorIndex
	 * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
	 */
	loadAccessor( accessorIndex ) {

		const parser = this;
		const json = this.json;

		const accessorDef = this.json.accessors[ accessorIndex ];

		if ( accessorDef.bufferView === undefined && accessorDef.sparse === undefined ) {

			const itemSize = WEBGL_TYPE_SIZES[ accessorDef.type ];
			const TypedArray = WEBGL_COMPONENT_TYPES[ accessorDef.componentType ];
			const normalized = accessorDef.normalized === true;

			const array = new TypedArray( accessorDef.count * itemSize );
			return Promise.resolve( new external_three_.BufferAttribute( array, itemSize, normalized ) );

		}

		const pendingBufferViews = [];

		if ( accessorDef.bufferView !== undefined ) {

			pendingBufferViews.push( this.getDependency( 'bufferView', accessorDef.bufferView ) );

		} else {

			pendingBufferViews.push( null );

		}

		if ( accessorDef.sparse !== undefined ) {

			pendingBufferViews.push( this.getDependency( 'bufferView', accessorDef.sparse.indices.bufferView ) );
			pendingBufferViews.push( this.getDependency( 'bufferView', accessorDef.sparse.values.bufferView ) );

		}

		return Promise.all( pendingBufferViews ).then( function ( bufferViews ) {

			const bufferView = bufferViews[ 0 ];

			const itemSize = WEBGL_TYPE_SIZES[ accessorDef.type ];
			const TypedArray = WEBGL_COMPONENT_TYPES[ accessorDef.componentType ];

			// For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
			const elementBytes = TypedArray.BYTES_PER_ELEMENT;
			const itemBytes = elementBytes * itemSize;
			const byteOffset = accessorDef.byteOffset || 0;
			const byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[ accessorDef.bufferView ].byteStride : undefined;
			const normalized = accessorDef.normalized === true;
			let array, bufferAttribute;

			// The buffer is not interleaved if the stride is the item size in bytes.
			if ( byteStride && byteStride !== itemBytes ) {

				// Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
				// This makes sure that IBA.count reflects accessor.count properly
				const ibSlice = Math.floor( byteOffset / byteStride );
				const ibCacheKey = 'InterleavedBuffer:' + accessorDef.bufferView + ':' + accessorDef.componentType + ':' + ibSlice + ':' + accessorDef.count;
				let ib = parser.cache.get( ibCacheKey );

				if ( ! ib ) {

					array = new TypedArray( bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes );

					// Integer parameters to IB/IBA are in array elements, not bytes.
					ib = new external_three_.InterleavedBuffer( array, byteStride / elementBytes );

					parser.cache.add( ibCacheKey, ib );

				}

				bufferAttribute = new external_three_.InterleavedBufferAttribute( ib, itemSize, ( byteOffset % byteStride ) / elementBytes, normalized );

			} else {

				if ( bufferView === null ) {

					array = new TypedArray( accessorDef.count * itemSize );

				} else {

					array = new TypedArray( bufferView, byteOffset, accessorDef.count * itemSize );

				}

				bufferAttribute = new external_three_.BufferAttribute( array, itemSize, normalized );

			}

			// https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
			if ( accessorDef.sparse !== undefined ) {

				const itemSizeIndices = WEBGL_TYPE_SIZES.SCALAR;
				const TypedArrayIndices = WEBGL_COMPONENT_TYPES[ accessorDef.sparse.indices.componentType ];

				const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
				const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;

				const sparseIndices = new TypedArrayIndices( bufferViews[ 1 ], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices );
				const sparseValues = new TypedArray( bufferViews[ 2 ], byteOffsetValues, accessorDef.sparse.count * itemSize );

				if ( bufferView !== null ) {

					// Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
					bufferAttribute = new external_three_.BufferAttribute( bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized );

				}

				for ( let i = 0, il = sparseIndices.length; i < il; i ++ ) {

					const index = sparseIndices[ i ];

					bufferAttribute.setX( index, sparseValues[ i * itemSize ] );
					if ( itemSize >= 2 ) bufferAttribute.setY( index, sparseValues[ i * itemSize + 1 ] );
					if ( itemSize >= 3 ) bufferAttribute.setZ( index, sparseValues[ i * itemSize + 2 ] );
					if ( itemSize >= 4 ) bufferAttribute.setW( index, sparseValues[ i * itemSize + 3 ] );
					if ( itemSize >= 5 ) throw new Error( 'THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.' );

				}

			}

			return bufferAttribute;

		} );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
	 * @param {number} textureIndex
	 * @return {Promise<THREE.Texture|null>}
	 */
	loadTexture( textureIndex ) {

		const json = this.json;
		const options = this.options;
		const textureDef = json.textures[ textureIndex ];
		const sourceIndex = textureDef.source;
		const sourceDef = json.images[ sourceIndex ];

		let loader = this.textureLoader;

		if ( sourceDef.uri ) {

			const handler = options.manager.getHandler( sourceDef.uri );
			if ( handler !== null ) loader = handler;

		}

		return this.loadTextureImage( textureIndex, sourceIndex, loader );

	}

	loadTextureImage( textureIndex, sourceIndex, loader ) {

		const parser = this;
		const json = this.json;

		const textureDef = json.textures[ textureIndex ];
		const sourceDef = json.images[ sourceIndex ];

		const cacheKey = ( sourceDef.uri || sourceDef.bufferView ) + ':' + textureDef.sampler;

		if ( this.textureCache[ cacheKey ] ) {

			// See https://github.com/mrdoob/three.js/issues/21559.
			return this.textureCache[ cacheKey ];

		}

		const promise = this.loadImageSource( sourceIndex, loader ).then( function ( texture ) {

			texture.flipY = false;

			texture.name = textureDef.name || sourceDef.name || '';

			if ( texture.name === '' && typeof sourceDef.uri === 'string' && sourceDef.uri.startsWith( 'data:image/' ) === false ) {

				texture.name = sourceDef.uri;

			}

			const samplers = json.samplers || {};
			const sampler = samplers[ textureDef.sampler ] || {};

			texture.magFilter = WEBGL_FILTERS[ sampler.magFilter ] || external_three_.LinearFilter;
			texture.minFilter = WEBGL_FILTERS[ sampler.minFilter ] || external_three_.LinearMipmapLinearFilter;
			texture.wrapS = WEBGL_WRAPPINGS[ sampler.wrapS ] || external_three_.RepeatWrapping;
			texture.wrapT = WEBGL_WRAPPINGS[ sampler.wrapT ] || external_three_.RepeatWrapping;

			parser.associations.set( texture, { textures: textureIndex } );

			return texture;

		} ).catch( function () {

			return null;

		} );

		this.textureCache[ cacheKey ] = promise;

		return promise;

	}

	loadImageSource( sourceIndex, loader ) {

		const parser = this;
		const json = this.json;
		const options = this.options;

		if ( this.sourceCache[ sourceIndex ] !== undefined ) {

			return this.sourceCache[ sourceIndex ].then( ( texture ) => texture.clone() );

		}

		const sourceDef = json.images[ sourceIndex ];

		const URL = self.URL || self.webkitURL;

		let sourceURI = sourceDef.uri || '';
		let isObjectURL = false;

		if ( sourceDef.bufferView !== undefined ) {

			// Load binary image data from bufferView, if provided.

			sourceURI = parser.getDependency( 'bufferView', sourceDef.bufferView ).then( function ( bufferView ) {

				isObjectURL = true;
				const blob = new Blob( [ bufferView ], { type: sourceDef.mimeType } );
				sourceURI = URL.createObjectURL( blob );
				return sourceURI;

			} );

		} else if ( sourceDef.uri === undefined ) {

			throw new Error( 'THREE.GLTFLoader: Image ' + sourceIndex + ' is missing URI and bufferView' );

		}

		const promise = Promise.resolve( sourceURI ).then( function ( sourceURI ) {

			return new Promise( function ( resolve, reject ) {

				let onLoad = resolve;

				if ( loader.isImageBitmapLoader === true ) {

					onLoad = function ( imageBitmap ) {

						const texture = new external_three_.Texture( imageBitmap );
						texture.needsUpdate = true;

						resolve( texture );

					};

				}

				loader.load( external_three_.LoaderUtils.resolveURL( sourceURI, options.path ), onLoad, undefined, reject );

			} );

		} ).then( function ( texture ) {

			// Clean up resources and configure Texture.

			if ( isObjectURL === true ) {

				URL.revokeObjectURL( sourceURI );

			}

			texture.userData.mimeType = sourceDef.mimeType || getImageURIMimeType( sourceDef.uri );

			return texture;

		} ).catch( function ( error ) {

			console.error( 'THREE.GLTFLoader: Couldn\'t load texture', sourceURI );
			throw error;

		} );

		this.sourceCache[ sourceIndex ] = promise;
		return promise;

	}

	/**
	 * Asynchronously assigns a texture to the given material parameters.
	 * @param {Object} materialParams
	 * @param {string} mapName
	 * @param {Object} mapDef
	 * @return {Promise<Texture>}
	 */
	assignTexture( materialParams, mapName, mapDef, colorSpace ) {

		const parser = this;

		return this.getDependency( 'texture', mapDef.index ).then( function ( texture ) {

			if ( ! texture ) return null;

			if ( mapDef.texCoord !== undefined && mapDef.texCoord > 0 ) {

				texture = texture.clone();
				texture.channel = mapDef.texCoord;

			}

			if ( parser.extensions[ EXTENSIONS.KHR_TEXTURE_TRANSFORM ] ) {

				const transform = mapDef.extensions !== undefined ? mapDef.extensions[ EXTENSIONS.KHR_TEXTURE_TRANSFORM ] : undefined;

				if ( transform ) {

					const gltfReference = parser.associations.get( texture );
					texture = parser.extensions[ EXTENSIONS.KHR_TEXTURE_TRANSFORM ].extendTexture( texture, transform );
					parser.associations.set( texture, gltfReference );

				}

			}

			if ( colorSpace !== undefined ) {

				texture.colorSpace = colorSpace;

			}

			materialParams[ mapName ] = texture;

			return texture;

		} );

	}

	/**
	 * Assigns final material to a Mesh, Line, or Points instance. The instance
	 * already has a material (generated from the glTF material options alone)
	 * but reuse of the same glTF material may require multiple threejs materials
	 * to accommodate different primitive types, defines, etc. New materials will
	 * be created if necessary, and reused from a cache.
	 * @param  {Object3D} mesh Mesh, Line, or Points instance.
	 */
	assignFinalMaterial( mesh ) {

		const geometry = mesh.geometry;
		let material = mesh.material;

		const useDerivativeTangents = geometry.attributes.tangent === undefined;
		const useVertexColors = geometry.attributes.color !== undefined;
		const useFlatShading = geometry.attributes.normal === undefined;

		if ( mesh.isPoints ) {

			const cacheKey = 'PointsMaterial:' + material.uuid;

			let pointsMaterial = this.cache.get( cacheKey );

			if ( ! pointsMaterial ) {

				pointsMaterial = new external_three_.PointsMaterial();
				external_three_.Material.prototype.copy.call( pointsMaterial, material );
				pointsMaterial.color.copy( material.color );
				pointsMaterial.map = material.map;
				pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px

				this.cache.add( cacheKey, pointsMaterial );

			}

			material = pointsMaterial;

		} else if ( mesh.isLine ) {

			const cacheKey = 'LineBasicMaterial:' + material.uuid;

			let lineMaterial = this.cache.get( cacheKey );

			if ( ! lineMaterial ) {

				lineMaterial = new external_three_.LineBasicMaterial();
				external_three_.Material.prototype.copy.call( lineMaterial, material );
				lineMaterial.color.copy( material.color );
				lineMaterial.map = material.map;

				this.cache.add( cacheKey, lineMaterial );

			}

			material = lineMaterial;

		}

		// Clone the material if it will be modified
		if ( useDerivativeTangents || useVertexColors || useFlatShading ) {

			let cacheKey = 'ClonedMaterial:' + material.uuid + ':';

			if ( useDerivativeTangents ) cacheKey += 'derivative-tangents:';
			if ( useVertexColors ) cacheKey += 'vertex-colors:';
			if ( useFlatShading ) cacheKey += 'flat-shading:';

			let cachedMaterial = this.cache.get( cacheKey );

			if ( ! cachedMaterial ) {

				cachedMaterial = material.clone();

				if ( useVertexColors ) cachedMaterial.vertexColors = true;
				if ( useFlatShading ) cachedMaterial.flatShading = true;

				if ( useDerivativeTangents ) {

					// https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
					if ( cachedMaterial.normalScale ) cachedMaterial.normalScale.y *= - 1;
					if ( cachedMaterial.clearcoatNormalScale ) cachedMaterial.clearcoatNormalScale.y *= - 1;

				}

				this.cache.add( cacheKey, cachedMaterial );

				this.associations.set( cachedMaterial, this.associations.get( material ) );

			}

			material = cachedMaterial;

		}

		mesh.material = material;

	}

	getMaterialType( /* materialIndex */ ) {

		return external_three_.MeshStandardMaterial;

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
	 * @param {number} materialIndex
	 * @return {Promise<Material>}
	 */
	loadMaterial( materialIndex ) {

		const parser = this;
		const json = this.json;
		const extensions = this.extensions;
		const materialDef = json.materials[ materialIndex ];

		let materialType;
		const materialParams = {};
		const materialExtensions = materialDef.extensions || {};

		const pending = [];

		if ( materialExtensions[ EXTENSIONS.KHR_MATERIALS_UNLIT ] ) {

			const kmuExtension = extensions[ EXTENSIONS.KHR_MATERIALS_UNLIT ];
			materialType = kmuExtension.getMaterialType();
			pending.push( kmuExtension.extendParams( materialParams, materialDef, parser ) );

		} else {

			// Specification:
			// https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material

			const metallicRoughness = materialDef.pbrMetallicRoughness || {};

			materialParams.color = new external_three_.Color( 1.0, 1.0, 1.0 );
			materialParams.opacity = 1.0;

			if ( Array.isArray( metallicRoughness.baseColorFactor ) ) {

				const array = metallicRoughness.baseColorFactor;

				materialParams.color.setRGB( array[ 0 ], array[ 1 ], array[ 2 ], external_three_.LinearSRGBColorSpace );
				materialParams.opacity = array[ 3 ];

			}

			if ( metallicRoughness.baseColorTexture !== undefined ) {

				pending.push( parser.assignTexture( materialParams, 'map', metallicRoughness.baseColorTexture, external_three_.SRGBColorSpace ) );

			}

			materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
			materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;

			if ( metallicRoughness.metallicRoughnessTexture !== undefined ) {

				pending.push( parser.assignTexture( materialParams, 'metalnessMap', metallicRoughness.metallicRoughnessTexture ) );
				pending.push( parser.assignTexture( materialParams, 'roughnessMap', metallicRoughness.metallicRoughnessTexture ) );

			}

			materialType = this._invokeOne( function ( ext ) {

				return ext.getMaterialType && ext.getMaterialType( materialIndex );

			} );

			pending.push( Promise.all( this._invokeAll( function ( ext ) {

				return ext.extendMaterialParams && ext.extendMaterialParams( materialIndex, materialParams );

			} ) ) );

		}

		if ( materialDef.doubleSided === true ) {

			materialParams.side = external_three_.DoubleSide;

		}

		const alphaMode = materialDef.alphaMode || ALPHA_MODES.OPAQUE;

		if ( alphaMode === ALPHA_MODES.BLEND ) {

			materialParams.transparent = true;

			// See: https://github.com/mrdoob/three.js/issues/17706
			materialParams.depthWrite = false;

		} else {

			materialParams.transparent = false;

			if ( alphaMode === ALPHA_MODES.MASK ) {

				materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;

			}

		}

		if ( materialDef.normalTexture !== undefined && materialType !== external_three_.MeshBasicMaterial ) {

			pending.push( parser.assignTexture( materialParams, 'normalMap', materialDef.normalTexture ) );

			materialParams.normalScale = new external_three_.Vector2( 1, 1 );

			if ( materialDef.normalTexture.scale !== undefined ) {

				const scale = materialDef.normalTexture.scale;

				materialParams.normalScale.set( scale, scale );

			}

		}

		if ( materialDef.occlusionTexture !== undefined && materialType !== external_three_.MeshBasicMaterial ) {

			pending.push( parser.assignTexture( materialParams, 'aoMap', materialDef.occlusionTexture ) );

			if ( materialDef.occlusionTexture.strength !== undefined ) {

				materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;

			}

		}

		if ( materialDef.emissiveFactor !== undefined && materialType !== external_three_.MeshBasicMaterial ) {

			const emissiveFactor = materialDef.emissiveFactor;
			materialParams.emissive = new external_three_.Color().setRGB( emissiveFactor[ 0 ], emissiveFactor[ 1 ], emissiveFactor[ 2 ], external_three_.LinearSRGBColorSpace );

		}

		if ( materialDef.emissiveTexture !== undefined && materialType !== external_three_.MeshBasicMaterial ) {

			pending.push( parser.assignTexture( materialParams, 'emissiveMap', materialDef.emissiveTexture, external_three_.SRGBColorSpace ) );

		}

		return Promise.all( pending ).then( function () {

			const material = new materialType( materialParams );

			if ( materialDef.name ) material.name = materialDef.name;

			assignExtrasToUserData( material, materialDef );

			parser.associations.set( material, { materials: materialIndex } );

			if ( materialDef.extensions ) addUnknownExtensionsToUserData( extensions, material, materialDef );

			return material;

		} );

	}

	/** When Object3D instances are targeted by animation, they need unique names. */
	createUniqueName( originalName ) {

		const sanitizedName = external_three_.PropertyBinding.sanitizeNodeName( originalName || '' );

		if ( sanitizedName in this.nodeNamesUsed ) {

			return sanitizedName + '_' + ( ++ this.nodeNamesUsed[ sanitizedName ] );

		} else {

			this.nodeNamesUsed[ sanitizedName ] = 0;

			return sanitizedName;

		}

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
	 *
	 * Creates BufferGeometries from primitives.
	 *
	 * @param {Array<GLTF.Primitive>} primitives
	 * @return {Promise<Array<BufferGeometry>>}
	 */
	loadGeometries( primitives ) {

		const parser = this;
		const extensions = this.extensions;
		const cache = this.primitiveCache;

		function createDracoPrimitive( primitive ) {

			return extensions[ EXTENSIONS.KHR_DRACO_MESH_COMPRESSION ]
				.decodePrimitive( primitive, parser )
				.then( function ( geometry ) {

					return addPrimitiveAttributes( geometry, primitive, parser );

				} );

		}

		const pending = [];

		for ( let i = 0, il = primitives.length; i < il; i ++ ) {

			const primitive = primitives[ i ];
			const cacheKey = createPrimitiveKey( primitive );

			// See if we've already created this geometry
			const cached = cache[ cacheKey ];

			if ( cached ) {

				// Use the cached geometry if it exists
				pending.push( cached.promise );

			} else {

				let geometryPromise;

				if ( primitive.extensions && primitive.extensions[ EXTENSIONS.KHR_DRACO_MESH_COMPRESSION ] ) {

					// Use DRACO geometry if available
					geometryPromise = createDracoPrimitive( primitive );

				} else {

					// Otherwise create a new geometry
					geometryPromise = addPrimitiveAttributes( new external_three_.BufferGeometry(), primitive, parser );

				}

				// Cache this geometry
				cache[ cacheKey ] = { primitive: primitive, promise: geometryPromise };

				pending.push( geometryPromise );

			}

		}

		return Promise.all( pending );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
	 * @param {number} meshIndex
	 * @return {Promise<Group|Mesh|SkinnedMesh>}
	 */
	loadMesh( meshIndex ) {

		const parser = this;
		const json = this.json;
		const extensions = this.extensions;

		const meshDef = json.meshes[ meshIndex ];
		const primitives = meshDef.primitives;

		const pending = [];

		for ( let i = 0, il = primitives.length; i < il; i ++ ) {

			const material = primitives[ i ].material === undefined
				? createDefaultMaterial( this.cache )
				: this.getDependency( 'material', primitives[ i ].material );

			pending.push( material );

		}

		pending.push( parser.loadGeometries( primitives ) );

		return Promise.all( pending ).then( function ( results ) {

			const materials = results.slice( 0, results.length - 1 );
			const geometries = results[ results.length - 1 ];

			const meshes = [];

			for ( let i = 0, il = geometries.length; i < il; i ++ ) {

				const geometry = geometries[ i ];
				const primitive = primitives[ i ];

				// 1. create Mesh

				let mesh;

				const material = materials[ i ];

				if ( primitive.mode === WEBGL_CONSTANTS.TRIANGLES ||
						primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP ||
						primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN ||
						primitive.mode === undefined ) {

					// .isSkinnedMesh isn't in glTF spec. See ._markDefs()
					mesh = meshDef.isSkinnedMesh === true
						? new external_three_.SkinnedMesh( geometry, material )
						: new external_three_.Mesh( geometry, material );

					if ( mesh.isSkinnedMesh === true ) {

						// normalize skin weights to fix malformed assets (see #15319)
						mesh.normalizeSkinWeights();

					}

					if ( primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP ) {

						mesh.geometry = toTrianglesDrawMode( mesh.geometry, external_three_.TriangleStripDrawMode );

					} else if ( primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN ) {

						mesh.geometry = toTrianglesDrawMode( mesh.geometry, external_three_.TriangleFanDrawMode );

					}

				} else if ( primitive.mode === WEBGL_CONSTANTS.LINES ) {

					mesh = new external_three_.LineSegments( geometry, material );

				} else if ( primitive.mode === WEBGL_CONSTANTS.LINE_STRIP ) {

					mesh = new external_three_.Line( geometry, material );

				} else if ( primitive.mode === WEBGL_CONSTANTS.LINE_LOOP ) {

					mesh = new external_three_.LineLoop( geometry, material );

				} else if ( primitive.mode === WEBGL_CONSTANTS.POINTS ) {

					mesh = new external_three_.Points( geometry, material );

				} else {

					throw new Error( 'THREE.GLTFLoader: Primitive mode unsupported: ' + primitive.mode );

				}

				if ( Object.keys( mesh.geometry.morphAttributes ).length > 0 ) {

					updateMorphTargets( mesh, meshDef );

				}

				mesh.name = parser.createUniqueName( meshDef.name || ( 'mesh_' + meshIndex ) );

				assignExtrasToUserData( mesh, meshDef );

				if ( primitive.extensions ) addUnknownExtensionsToUserData( extensions, mesh, primitive );

				parser.assignFinalMaterial( mesh );

				meshes.push( mesh );

			}

			for ( let i = 0, il = meshes.length; i < il; i ++ ) {

				parser.associations.set( meshes[ i ], {
					meshes: meshIndex,
					primitives: i
				} );

			}

			if ( meshes.length === 1 ) {

				if ( meshDef.extensions ) addUnknownExtensionsToUserData( extensions, meshes[ 0 ], meshDef );

				return meshes[ 0 ];

			}

			const group = new external_three_.Group();

			if ( meshDef.extensions ) addUnknownExtensionsToUserData( extensions, group, meshDef );

			parser.associations.set( group, { meshes: meshIndex } );

			for ( let i = 0, il = meshes.length; i < il; i ++ ) {

				group.add( meshes[ i ] );

			}

			return group;

		} );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
	 * @param {number} cameraIndex
	 * @return {Promise<THREE.Camera>}
	 */
	loadCamera( cameraIndex ) {

		let camera;
		const cameraDef = this.json.cameras[ cameraIndex ];
		const params = cameraDef[ cameraDef.type ];

		if ( ! params ) {

			console.warn( 'THREE.GLTFLoader: Missing camera parameters.' );
			return;

		}

		if ( cameraDef.type === 'perspective' ) {

			camera = new external_three_.PerspectiveCamera( external_three_.MathUtils.radToDeg( params.yfov ), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6 );

		} else if ( cameraDef.type === 'orthographic' ) {

			camera = new external_three_.OrthographicCamera( - params.xmag, params.xmag, params.ymag, - params.ymag, params.znear, params.zfar );

		}

		if ( cameraDef.name ) camera.name = this.createUniqueName( cameraDef.name );

		assignExtrasToUserData( camera, cameraDef );

		return Promise.resolve( camera );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
	 * @param {number} skinIndex
	 * @return {Promise<Skeleton>}
	 */
	loadSkin( skinIndex ) {

		const skinDef = this.json.skins[ skinIndex ];

		const pending = [];

		for ( let i = 0, il = skinDef.joints.length; i < il; i ++ ) {

			pending.push( this._loadNodeShallow( skinDef.joints[ i ] ) );

		}

		if ( skinDef.inverseBindMatrices !== undefined ) {

			pending.push( this.getDependency( 'accessor', skinDef.inverseBindMatrices ) );

		} else {

			pending.push( null );

		}

		return Promise.all( pending ).then( function ( results ) {

			const inverseBindMatrices = results.pop();
			const jointNodes = results;

			// Note that bones (joint nodes) may or may not be in the
			// scene graph at this time.

			const bones = [];
			const boneInverses = [];

			for ( let i = 0, il = jointNodes.length; i < il; i ++ ) {

				const jointNode = jointNodes[ i ];

				if ( jointNode ) {

					bones.push( jointNode );

					const mat = new external_three_.Matrix4();

					if ( inverseBindMatrices !== null ) {

						mat.fromArray( inverseBindMatrices.array, i * 16 );

					}

					boneInverses.push( mat );

				} else {

					console.warn( 'THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[ i ] );

				}

			}

			return new external_three_.Skeleton( bones, boneInverses );

		} );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
	 * @param {number} animationIndex
	 * @return {Promise<AnimationClip>}
	 */
	loadAnimation( animationIndex ) {

		const json = this.json;
		const parser = this;

		const animationDef = json.animations[ animationIndex ];
		const animationName = animationDef.name ? animationDef.name : 'animation_' + animationIndex;

		const pendingNodes = [];
		const pendingInputAccessors = [];
		const pendingOutputAccessors = [];
		const pendingSamplers = [];
		const pendingTargets = [];

		for ( let i = 0, il = animationDef.channels.length; i < il; i ++ ) {

			const channel = animationDef.channels[ i ];
			const sampler = animationDef.samplers[ channel.sampler ];
			const target = channel.target;
			const name = target.node;
			const input = animationDef.parameters !== undefined ? animationDef.parameters[ sampler.input ] : sampler.input;
			const output = animationDef.parameters !== undefined ? animationDef.parameters[ sampler.output ] : sampler.output;

			if ( target.node === undefined ) continue;

			pendingNodes.push( this.getDependency( 'node', name ) );
			pendingInputAccessors.push( this.getDependency( 'accessor', input ) );
			pendingOutputAccessors.push( this.getDependency( 'accessor', output ) );
			pendingSamplers.push( sampler );
			pendingTargets.push( target );

		}

		return Promise.all( [

			Promise.all( pendingNodes ),
			Promise.all( pendingInputAccessors ),
			Promise.all( pendingOutputAccessors ),
			Promise.all( pendingSamplers ),
			Promise.all( pendingTargets )

		] ).then( function ( dependencies ) {

			const nodes = dependencies[ 0 ];
			const inputAccessors = dependencies[ 1 ];
			const outputAccessors = dependencies[ 2 ];
			const samplers = dependencies[ 3 ];
			const targets = dependencies[ 4 ];

			const tracks = [];

			for ( let i = 0, il = nodes.length; i < il; i ++ ) {

				const node = nodes[ i ];
				const inputAccessor = inputAccessors[ i ];
				const outputAccessor = outputAccessors[ i ];
				const sampler = samplers[ i ];
				const target = targets[ i ];

				if ( node === undefined ) continue;

				if ( node.updateMatrix ) {

					node.updateMatrix();

				}

				const createdTracks = parser._createAnimationTracks( node, inputAccessor, outputAccessor, sampler, target );

				if ( createdTracks ) {

					for ( let k = 0; k < createdTracks.length; k ++ ) {

						tracks.push( createdTracks[ k ] );

					}

				}

			}

			return new external_three_.AnimationClip( animationName, undefined, tracks );

		} );

	}

	createNodeMesh( nodeIndex ) {

		const json = this.json;
		const parser = this;
		const nodeDef = json.nodes[ nodeIndex ];

		if ( nodeDef.mesh === undefined ) return null;

		return parser.getDependency( 'mesh', nodeDef.mesh ).then( function ( mesh ) {

			const node = parser._getNodeRef( parser.meshCache, nodeDef.mesh, mesh );

			// if weights are provided on the node, override weights on the mesh.
			if ( nodeDef.weights !== undefined ) {

				node.traverse( function ( o ) {

					if ( ! o.isMesh ) return;

					for ( let i = 0, il = nodeDef.weights.length; i < il; i ++ ) {

						o.morphTargetInfluences[ i ] = nodeDef.weights[ i ];

					}

				} );

			}

			return node;

		} );

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
	 * @param {number} nodeIndex
	 * @return {Promise<Object3D>}
	 */
	loadNode( nodeIndex ) {

		const json = this.json;
		const parser = this;

		const nodeDef = json.nodes[ nodeIndex ];

		const nodePending = parser._loadNodeShallow( nodeIndex );

		const childPending = [];
		const childrenDef = nodeDef.children || [];

		for ( let i = 0, il = childrenDef.length; i < il; i ++ ) {

			childPending.push( parser.getDependency( 'node', childrenDef[ i ] ) );

		}

		const skeletonPending = nodeDef.skin === undefined
			? Promise.resolve( null )
			: parser.getDependency( 'skin', nodeDef.skin );

		return Promise.all( [
			nodePending,
			Promise.all( childPending ),
			skeletonPending
		] ).then( function ( results ) {

			const node = results[ 0 ];
			const children = results[ 1 ];
			const skeleton = results[ 2 ];

			if ( skeleton !== null ) {

				// This full traverse should be fine because
				// child glTF nodes have not been added to this node yet.
				node.traverse( function ( mesh ) {

					if ( ! mesh.isSkinnedMesh ) return;

					mesh.bind( skeleton, _identityMatrix );

				} );

			}

			for ( let i = 0, il = children.length; i < il; i ++ ) {

				node.add( children[ i ] );

			}

			return node;

		} );

	}

	// ._loadNodeShallow() parses a single node.
	// skin and child nodes are created and added in .loadNode() (no '_' prefix).
	_loadNodeShallow( nodeIndex ) {

		const json = this.json;
		const extensions = this.extensions;
		const parser = this;

		// This method is called from .loadNode() and .loadSkin().
		// Cache a node to avoid duplication.

		if ( this.nodeCache[ nodeIndex ] !== undefined ) {

			return this.nodeCache[ nodeIndex ];

		}

		const nodeDef = json.nodes[ nodeIndex ];

		// reserve node's name before its dependencies, so the root has the intended name.
		const nodeName = nodeDef.name ? parser.createUniqueName( nodeDef.name ) : '';

		const pending = [];

		const meshPromise = parser._invokeOne( function ( ext ) {

			return ext.createNodeMesh && ext.createNodeMesh( nodeIndex );

		} );

		if ( meshPromise ) {

			pending.push( meshPromise );

		}

		if ( nodeDef.camera !== undefined ) {

			pending.push( parser.getDependency( 'camera', nodeDef.camera ).then( function ( camera ) {

				return parser._getNodeRef( parser.cameraCache, nodeDef.camera, camera );

			} ) );

		}

		parser._invokeAll( function ( ext ) {

			return ext.createNodeAttachment && ext.createNodeAttachment( nodeIndex );

		} ).forEach( function ( promise ) {

			pending.push( promise );

		} );

		this.nodeCache[ nodeIndex ] = Promise.all( pending ).then( function ( objects ) {

			let node;

			// .isBone isn't in glTF spec. See ._markDefs
			if ( nodeDef.isBone === true ) {

				node = new external_three_.Bone();

			} else if ( objects.length > 1 ) {

				node = new external_three_.Group();

			} else if ( objects.length === 1 ) {

				node = objects[ 0 ];

			} else {

				node = new external_three_.Object3D();

			}

			if ( node !== objects[ 0 ] ) {

				for ( let i = 0, il = objects.length; i < il; i ++ ) {

					node.add( objects[ i ] );

				}

			}

			if ( nodeDef.name ) {

				node.userData.name = nodeDef.name;
				node.name = nodeName;

			}

			assignExtrasToUserData( node, nodeDef );

			if ( nodeDef.extensions ) addUnknownExtensionsToUserData( extensions, node, nodeDef );

			if ( nodeDef.matrix !== undefined ) {

				const matrix = new external_three_.Matrix4();
				matrix.fromArray( nodeDef.matrix );
				node.applyMatrix4( matrix );

			} else {

				if ( nodeDef.translation !== undefined ) {

					node.position.fromArray( nodeDef.translation );

				}

				if ( nodeDef.rotation !== undefined ) {

					node.quaternion.fromArray( nodeDef.rotation );

				}

				if ( nodeDef.scale !== undefined ) {

					node.scale.fromArray( nodeDef.scale );

				}

			}

			if ( ! parser.associations.has( node ) ) {

				parser.associations.set( node, {} );

			}

			parser.associations.get( node ).nodes = nodeIndex;

			return node;

		} );

		return this.nodeCache[ nodeIndex ];

	}

	/**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
	 * @param {number} sceneIndex
	 * @return {Promise<Group>}
	 */
	loadScene( sceneIndex ) {

		const extensions = this.extensions;
		const sceneDef = this.json.scenes[ sceneIndex ];
		const parser = this;

		// Loader returns Group, not Scene.
		// See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
		const scene = new external_three_.Group();
		if ( sceneDef.name ) scene.name = parser.createUniqueName( sceneDef.name );

		assignExtrasToUserData( scene, sceneDef );

		if ( sceneDef.extensions ) addUnknownExtensionsToUserData( extensions, scene, sceneDef );

		const nodeIds = sceneDef.nodes || [];

		const pending = [];

		for ( let i = 0, il = nodeIds.length; i < il; i ++ ) {

			pending.push( parser.getDependency( 'node', nodeIds[ i ] ) );

		}

		return Promise.all( pending ).then( function ( nodes ) {

			for ( let i = 0, il = nodes.length; i < il; i ++ ) {

				scene.add( nodes[ i ] );

			}

			// Removes dangling associations, associations that reference a node that
			// didn't make it into the scene.
			const reduceAssociations = ( node ) => {

				const reducedAssociations = new Map();

				for ( const [ key, value ] of parser.associations ) {

					if ( key instanceof external_three_.Material || key instanceof external_three_.Texture ) {

						reducedAssociations.set( key, value );

					}

				}

				node.traverse( ( node ) => {

					const mappings = parser.associations.get( node );

					if ( mappings != null ) {

						reducedAssociations.set( node, mappings );

					}

				} );

				return reducedAssociations;

			};

			parser.associations = reduceAssociations( scene );

			return scene;

		} );

	}

	_createAnimationTracks( node, inputAccessor, outputAccessor, sampler, target ) {

		const tracks = [];

		const targetName = node.name ? node.name : node.uuid;
		const targetNames = [];

		if ( PATH_PROPERTIES[ target.path ] === PATH_PROPERTIES.weights ) {

			node.traverse( function ( object ) {

				if ( object.morphTargetInfluences ) {

					targetNames.push( object.name ? object.name : object.uuid );

				}

			} );

		} else {

			targetNames.push( targetName );

		}

		let TypedKeyframeTrack;

		switch ( PATH_PROPERTIES[ target.path ] ) {

			case PATH_PROPERTIES.weights:

				TypedKeyframeTrack = external_three_.NumberKeyframeTrack;
				break;

			case PATH_PROPERTIES.rotation:

				TypedKeyframeTrack = external_three_.QuaternionKeyframeTrack;
				break;

			case PATH_PROPERTIES.position:
			case PATH_PROPERTIES.scale:

				TypedKeyframeTrack = external_three_.VectorKeyframeTrack;
				break;

			default:

				switch ( outputAccessor.itemSize ) {

					case 1:
						TypedKeyframeTrack = external_three_.NumberKeyframeTrack;
						break;
					case 2:
					case 3:
					default:
						TypedKeyframeTrack = external_three_.VectorKeyframeTrack;
						break;

				}

				break;

		}

		const interpolation = sampler.interpolation !== undefined ? INTERPOLATION[ sampler.interpolation ] : external_three_.InterpolateLinear;


		const outputArray = this._getArrayFromAccessor( outputAccessor );

		for ( let j = 0, jl = targetNames.length; j < jl; j ++ ) {

			const track = new TypedKeyframeTrack(
				targetNames[ j ] + '.' + PATH_PROPERTIES[ target.path ],
				inputAccessor.array,
				outputArray,
				interpolation
			);

			// Override interpolation with custom factory method.
			if ( sampler.interpolation === 'CUBICSPLINE' ) {

				this._createCubicSplineTrackInterpolant( track );

			}

			tracks.push( track );

		}

		return tracks;

	}

	_getArrayFromAccessor( accessor ) {

		let outputArray = accessor.array;

		if ( accessor.normalized ) {

			const scale = getNormalizedComponentScale( outputArray.constructor );
			const scaled = new Float32Array( outputArray.length );

			for ( let j = 0, jl = outputArray.length; j < jl; j ++ ) {

				scaled[ j ] = outputArray[ j ] * scale;

			}

			outputArray = scaled;

		}

		return outputArray;

	}

	_createCubicSplineTrackInterpolant( track ) {

		track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline( result ) {

			// A CUBICSPLINE keyframe in glTF has three output values for each input value,
			// representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
			// must be divided by three to get the interpolant's sampleSize argument.

			const interpolantType = ( this instanceof external_three_.QuaternionKeyframeTrack ) ? GLTFCubicSplineQuaternionInterpolant : GLTFCubicSplineInterpolant;

			return new interpolantType( this.times, this.values, this.getValueSize() / 3, result );

		};

		// Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
		track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;

	}

}

/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */
function computeBounds( geometry, primitiveDef, parser ) {

	const attributes = primitiveDef.attributes;

	const box = new external_three_.Box3();

	if ( attributes.POSITION !== undefined ) {

		const accessor = parser.json.accessors[ attributes.POSITION ];

		const min = accessor.min;
		const max = accessor.max;

		// glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.

		if ( min !== undefined && max !== undefined ) {

			box.set(
				new external_three_.Vector3( min[ 0 ], min[ 1 ], min[ 2 ] ),
				new external_three_.Vector3( max[ 0 ], max[ 1 ], max[ 2 ] )
			);

			if ( accessor.normalized ) {

				const boxScale = getNormalizedComponentScale( WEBGL_COMPONENT_TYPES[ accessor.componentType ] );
				box.min.multiplyScalar( boxScale );
				box.max.multiplyScalar( boxScale );

			}

		} else {

			console.warn( 'THREE.GLTFLoader: Missing min/max properties for accessor POSITION.' );

			return;

		}

	} else {

		return;

	}

	const targets = primitiveDef.targets;

	if ( targets !== undefined ) {

		const maxDisplacement = new external_three_.Vector3();
		const vector = new external_three_.Vector3();

		for ( let i = 0, il = targets.length; i < il; i ++ ) {

			const target = targets[ i ];

			if ( target.POSITION !== undefined ) {

				const accessor = parser.json.accessors[ target.POSITION ];
				const min = accessor.min;
				const max = accessor.max;

				// glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.

				if ( min !== undefined && max !== undefined ) {

					// we need to get max of absolute components because target weight is [-1,1]
					vector.setX( Math.max( Math.abs( min[ 0 ] ), Math.abs( max[ 0 ] ) ) );
					vector.setY( Math.max( Math.abs( min[ 1 ] ), Math.abs( max[ 1 ] ) ) );
					vector.setZ( Math.max( Math.abs( min[ 2 ] ), Math.abs( max[ 2 ] ) ) );


					if ( accessor.normalized ) {

						const boxScale = getNormalizedComponentScale( WEBGL_COMPONENT_TYPES[ accessor.componentType ] );
						vector.multiplyScalar( boxScale );

					}

					// Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
					// to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
					// are used to implement key-frame animations and as such only two are active at a time - this results in very large
					// boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
					maxDisplacement.max( vector );

				} else {

					console.warn( 'THREE.GLTFLoader: Missing min/max properties for accessor POSITION.' );

				}

			}

		}

		// As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
		box.expandByVector( maxDisplacement );

	}

	geometry.boundingBox = box;

	const sphere = new external_three_.Sphere();

	box.getCenter( sphere.center );
	sphere.radius = box.min.distanceTo( box.max ) / 2;

	geometry.boundingSphere = sphere;

}

/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */
function addPrimitiveAttributes( geometry, primitiveDef, parser ) {

	const attributes = primitiveDef.attributes;

	const pending = [];

	function assignAttributeAccessor( accessorIndex, attributeName ) {

		return parser.getDependency( 'accessor', accessorIndex )
			.then( function ( accessor ) {

				geometry.setAttribute( attributeName, accessor );

			} );

	}

	for ( const gltfAttributeName in attributes ) {

		const threeAttributeName = ATTRIBUTES[ gltfAttributeName ] || gltfAttributeName.toLowerCase();

		// Skip attributes already provided by e.g. Draco extension.
		if ( threeAttributeName in geometry.attributes ) continue;

		pending.push( assignAttributeAccessor( attributes[ gltfAttributeName ], threeAttributeName ) );

	}

	if ( primitiveDef.indices !== undefined && ! geometry.index ) {

		const accessor = parser.getDependency( 'accessor', primitiveDef.indices ).then( function ( accessor ) {

			geometry.setIndex( accessor );

		} );

		pending.push( accessor );

	}

	if ( external_three_.ColorManagement.workingColorSpace !== external_three_.LinearSRGBColorSpace && 'COLOR_0' in attributes ) {

		console.warn( `THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${external_three_.ColorManagement.workingColorSpace}" not supported.` );

	}

	assignExtrasToUserData( geometry, primitiveDef );

	computeBounds( geometry, primitiveDef, parser );

	return Promise.all( pending ).then( function () {

		return primitiveDef.targets !== undefined
			? addMorphTargets( geometry, primitiveDef.targets, parser )
			: geometry;

	} );

}



// EXTERNAL MODULE: ./src/sdk/Settings.ts
var Settings = __webpack_require__(8406);
// EXTERNAL MODULE: ./src/sdk/rendering/RenderUtils.ts
var RenderUtils = __webpack_require__(5333);
;// CONCATENATED MODULE: ./src/sdk/rendering/GLTFModel.ts
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





// global loader across models
var loader = new GLTFLoader();
loader.setMeshoptDecoder(MeshoptDecoder);
// cache a copy of each model
var globalModelCache = {};
var DRAW_HITBOX = false;
var DEFAULT_SCALE = 1 / 128;
var DEFAULT_VERTICAL_OFFSET = -0.49;
/**
 * Render the model using one or more GLTF models. If there are multiple models, they are drawn superimposed on the same spot and are expected
 * to have the same animation set.
 */
var GLTFModel = /** @class */ (function () {
    function GLTFModel(renderable, models, options) {
        var _a, _b, _c, _d, _e;
        this.renderable = renderable;
        this.models = models;
        this.options = options;
        // parent object for all models loaded into this
        this.loadedModel = null;
        this.hasInitialisedModel = false;
        this.mixers = [];
        this.lastPoseId = -1;
        this.playingAnimationId = -1;
        this.playingAnimationCanBlend = false;
        this.playingAnimationPromiseResolve = null;
        // first index is the model ID, second index is the animation ID.
        this.animations = [];
        // models are loaded and inserted into `loadedModel` in indeterminate orders, so we save the index of each model
        this.modelOrder = [];
        var size = renderable.size;
        this.scale = (_a = options.scale) !== null && _a !== void 0 ? _a : DEFAULT_SCALE;
        this.verticalOffset = (_b = options.verticalOffset) !== null && _b !== void 0 ? _b : DEFAULT_VERTICAL_OFFSET;
        this.originOffset = (_c = options.originOffset) !== null && _c !== void 0 ? _c : { x: 0, y: 0 };
        this.outlineMaterial = new external_three_.LineBasicMaterial({
            color: (_d = Settings/* Settings */.w.entityIndicatorColor) !== null && _d !== void 0 ? _d : "#FFFFFF",
        });
        var points = [
            new external_three_.Vector3(0, 0, 0),
            new external_three_.Vector3(size, 0, 0),
            new external_three_.Vector3(size, 0, 0),
            new external_three_.Vector3(size, 0, -size),
            new external_three_.Vector3(size, 0, -size),
            new external_three_.Vector3(0, 0, -size),
            new external_three_.Vector3(0, 0, -size),
            new external_three_.Vector3(0, 0, 0),
        ];
        var outlineGeometry = new external_three_.BufferGeometry().setFromPoints(points);
        this.outline = new external_three_.LineSegments(outlineGeometry, this.outlineMaterial);
        this.outline.visible = renderable.drawOutline;
        var trueTileGeometry = new external_three_.BufferGeometry().setFromPoints(points);
        this.trueTile = new external_three_.LineSegments(trueTileGeometry, new external_three_.LineBasicMaterial({
            color: (_e = Settings/* Settings */.w.trueTileColor) !== null && _e !== void 0 ? _e : "#00FFFF",
        }));
        this.trueTile.visible = renderable.drawTrueTile;
        var hullMaterial = new external_three_.MeshBasicMaterial({ color: 0x00000000 });
        hullMaterial.transparent = true;
        // size of hull get set once the model loads
        this.hullGeometry = new external_three_.CylinderGeometry(1, 1, 1, 6);
        this.clickHull = new external_three_.Mesh(this.hullGeometry, hullMaterial);
        this.clickHull.userData.clickable = renderable.selectable;
        this.clickHull.userData.unit = renderable;
        this.clickHull.visible = DRAW_HITBOX;
    }
    GLTFModel.forRenderable = function (r, model, options) {
        if (options === void 0) { options = {}; }
        return new GLTFModel(r, [model], options);
    };
    GLTFModel.forRenderableMulti = function (r, models, options) {
        if (options === void 0) { options = {}; }
        return new GLTFModel(r, models, options);
    };
    GLTFModel.prototype.animationChanged = function (id, blend) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.startPlayingAnimation(id, blend)];
            });
        });
    };
    GLTFModel.prototype.modelChanged = function () {
        var _this = this;
        if (!this.loadedModel) {
            return;
        }
        // TODO: handle model order that gets out of whack
        // TODO: what if get3dModel() now returns something other than GLTFModel? Bad times...
        var newModels = this.renderable.get3dModel().models;
        var toRemove = this.models.filter(function (model) { return !newModels.includes(model); });
        var toAdd = newModels.filter(function (model) { return !_this.models.includes(model); });
        toRemove.forEach(function (name) { return _this.loadedModel.remove(_this.loadedModel.getObjectByName(name)); });
        this.models = newModels;
        // (index is wrong here...)
        toAdd.forEach(function (name, index) { return _this.loadAndAddSingleModel(_this.loadedModel, name, index); });
    };
    GLTFModel.prototype.stopCurrentAnimation = function () {
        // needed otherwise the animations bleed into each other
        this.mixers.forEach(function (mixer) { return mixer.stopAllAction(); });
    };
    /**
     *
     * @param id id (in the animation file) to play
     * @param blend blend the new animation with the pose animation
     */
    GLTFModel.prototype.startPlayingAnimation = function (id, blend) {
        var _this = this;
        if (blend === void 0) { blend = false; }
        if (!blend) {
            this.stopCurrentAnimation();
            this.animations.forEach(function (animationsForModel) {
                animationsForModel.forEach(function (animation) { return animation.setEffectiveWeight(1.0); });
            });
        }
        else {
            this.animations.forEach(function (animationsForModel) {
                animationsForModel.forEach(function (animation) { return animation.setEffectiveWeight(0.5); });
            });
        }
        this.playingAnimationId = id;
        this.playingAnimationCanBlend = blend;
        this.animations.forEach(function (animationsForModel) {
            // play the animation for each part of the body
            var newAnimation = animationsForModel[id];
            newAnimation.setEffectiveWeight(blend ? 1 : 1.0);
            newAnimation.stop().setLoop(external_three_.LoopOnce, 1).play();
        });
        // reset the timer of the mixers because it seems to bug out and show the first frame sometimes
        // suspect that it has to do with the mixer time exceeding the length of the animation?
        this.mixers.forEach(function (mixerForModel) { return mixerForModel.setTime(0); });
        return new Promise(function (resolve) {
            _this.playingAnimationPromiseResolve = resolve;
            return;
        });
    };
    GLTFModel.prototype.onAnimationFinished = function (action) {
        var _this = this;
        this.stopCurrentAnimation();
        var nextAnimIndex = this.renderable.animationIndex;
        this.animations.forEach(function (animationsForModel, i) {
            var newAnimation = animationsForModel[nextAnimIndex];
            if (_this.playingAnimationCanBlend) {
                newAnimation.setEffectiveWeight(1.0);
            }
            // play the fallback/pose animation
            newAnimation.stop().setLoop(external_three_.LoopRepeat, Number.POSITIVE_INFINITY).play();
        });
        this.playingAnimationId = -1;
        this.playingAnimationCanBlend = false;
        if (this.playingAnimationPromiseResolve) {
            this.playingAnimationPromiseResolve();
            this.playingAnimationPromiseResolve = null;
        }
    };
    GLTFModel.prototype.onPoseChanged = function (newPoseId) {
        var _this = this;
        this.animations.forEach(function (animationsForModel, i) {
            var lastAnimation = animationsForModel[_this.lastPoseId];
            if (lastAnimation) {
                lastAnimation.stop();
            }
            if (_this.playingAnimationId >= 0 && !_this.playingAnimationCanBlend) {
                return;
            }
            var newAnimation = animationsForModel[newPoseId];
            // play the fallback/pose animation
            newAnimation.stop().setLoop(external_three_.LoopRepeat, Number.POSITIVE_INFINITY).play();
        });
    };
    GLTFModel.prototype.loadAndAddSingleModel = function (target, model, index) {
        var _this = this;
        var processGltf = function (gltf, clone) {
            var _a, _b;
            if (clone === void 0) { clone = false; }
            var scale = _this.scale;
            gltf.scene.name = model;
            gltf.scene.traverse(function (o) {
                if (o.isMesh) {
                    o.material.name = model;
                }
            });
            // make adjustments
            gltf.scene.scale.set(scale, scale, scale);
            var animations = gltf.animations;
            var scene = gltf.scene;
            if (clone) {
                scene = scene.clone();
            }
            target.add(scene);
            var size = new external_three_.Vector3();
            new external_three_.Box3().setFromObject(scene).getSize(size);
            var clickboxHeight = (_a = _this.renderable.clickboxHeight) !== null && _a !== void 0 ? _a : Math.max(_this.renderable.size, 0.4 * size.y);
            var clickboxRadius = (_b = _this.renderable.clickboxRadius) !== null && _b !== void 0 ? _b : _this.renderable.size * 0.4;
            _this.hullGeometry.scale(clickboxRadius, clickboxHeight, clickboxRadius);
            _this.hullGeometry.translate(0, clickboxHeight / 2 - 0.49, 0);
            // load and start animating
            if (animations.length === 0) {
                return;
            }
            var mixer = new external_three_.AnimationMixer(scene);
            _this.mixers.push(mixer);
            _this.animations.push(animations.map(function (animation) {
                var action = mixer.clipAction(animation);
                action.clampWhenFinished = true;
                action.zeroSlopeAtEnd = false;
                action.zeroSlopeAtStart = false;
                return action;
            }));
            _this.onAnimationFinished();
            // add listener to first mixer only
            if (_this.mixers.length === 1) {
                mixer.addEventListener("finished", function (e) {
                    _this.onAnimationFinished(e.action);
                });
            }
            _this.modelOrder.push(index);
        };
        if (model in globalModelCache) {
            // prevents reloading the model from file
            processGltf(globalModelCache[model], true);
        }
        else {
            loader.load(model, function (gltf) {
                globalModelCache[model] = gltf;
                processGltf(gltf);
            });
        }
    };
    GLTFModel.prototype.initialiseWholeModel = function () {
        var _this = this;
        var preparingMesh = new external_three_.Object3D();
        this.models.forEach(function (model, index) { return _this.loadAndAddSingleModel(preparingMesh, model, index); });
        this.loadedModel = preparingMesh;
    };
    GLTFModel.prototype.draw = function (scene, clockDelta, tickPercent, location, rotation, pitch, visible, modelOffsets) {
        var _this = this;
        var _a, _b;
        if (!this.hasInitialisedModel) {
            this.initialiseWholeModel();
            this.hasInitialisedModel = true;
        }
        if (this.loadedModel && this.loadedModel.parent !== scene) {
            scene.add(this.loadedModel);
            this.renderable.setAnimationListener(this);
        }
        if (this.outline.parent !== scene) {
            scene.add(this.outline);
            scene.add(this.trueTile);
            scene.add(this.clickHull);
        }
        var outlineColor = Settings/* Settings */.w.entityIndicatorColor;
        this.outline.visible = this.renderable.drawOutline && visible && Settings/* Settings */.w.entityIndicatorEnabled;
        if (this.loadedModel) {
            this.loadedModel.visible = visible;
        }
        this.outlineMaterial.color.set(outlineColor);
        (0,RenderUtils/* drawLineOnTop */.Ho)(this.outline, (_a = this.renderable.outlineRenderOrder) !== null && _a !== void 0 ? _a : RenderUtils/* GroundOverlayRenderOrder */.oC.ENTITY_INDICATOR);
        if (this.renderable.animationIndex !== this.lastPoseId) {
            // start a new pose if the pose index changes and we're not currently playing an animation
            this.onPoseChanged(this.renderable.animationIndex);
            this.lastPoseId = this.renderable.animationIndex;
        }
        var x = location.x, y = location.y, z = location.z;
        this.outline.position.x = x;
        this.outline.position.y = -0.49;
        this.outline.position.z = y;
        this.outline.visible = this.renderable.drawOutline && visible && Settings/* Settings */.w.entityIndicatorEnabled;
        var _c = this.renderable.getTrueLocation(), trueX = _c.x, trueY = _c.y;
        if (this.renderable.drawTrueTile) {
            this.trueTile.position.x = trueX;
            this.trueTile.position.y = RenderUtils/* GROUND_OVERLAY_Y */.t8;
            this.trueTile.position.z = trueY;
            (0,RenderUtils/* drawLineOnTop */.Ho)(this.trueTile, (_b = this.renderable.trueTileRenderOrder) !== null && _b !== void 0 ? _b : RenderUtils/* GroundOverlayRenderOrder */.oC.TRUE_TILE);
        }
        var trueTileColor = Settings/* Settings */.w.trueTileColor;
        this.trueTile.material.color.set(trueTileColor);
        var indicatorCoversTrueTile = Settings/* Settings */.w.entityIndicatorEnabled && x === trueX && y === trueY;
        this.trueTile.visible = this.renderable.drawTrueTile && visible && Settings/* Settings */.w.trueTileEnabled && !indicatorCoversTrueTile;
        this.clickHull.position.x = x + this.renderable.size / 2;
        this.clickHull.position.z = y - this.renderable.size / 2;
        if (this.loadedModel) {
            this.mixers.forEach(function (mixer) { return mixer.update(clockDelta); });
            var size = this.renderable.size;
            var adjustedRotation = rotation + Math.PI / 2;
            this.loadedModel.position.x = x + size / 2 + this.originOffset.x;
            this.loadedModel.position.y = z + this.verticalOffset;
            this.loadedModel.position.z = y - size / 2 + this.originOffset.y;
            this.loadedModel.rotation.order = "YXZ";
            this.loadedModel.rotation.set(pitch, adjustedRotation, 0);
            this.loadedModel.children.forEach(function (child, idx) {
                var insertionIdx = _this.modelOrder[idx];
                if (modelOffsets[insertionIdx]) {
                    var offset = modelOffsets[insertionIdx];
                    child.position.set(offset.x, offset.z, offset.y);
                }
                else {
                    child.position.set(0, 0, 0);
                }
            });
        }
    };
    GLTFModel.prototype.destroy = function (scene) {
        if (this.loadedModel && this.loadedModel.parent === scene) {
            scene.remove(this.loadedModel);
            this.renderable.clearAnimationListener();
        }
        if (this.outline.parent === scene) {
            scene.remove(this.outline);
            scene.remove(this.trueTile);
            scene.remove(this.clickHull);
        }
    };
    GLTFModel.prototype.getWorldPosition = function () {
        return this.outline.getWorldPosition(new external_three_.Vector3());
    };
    GLTFModel.until = function (condition) {
        var poll = function (res) {
            if (condition()) {
                res();
            }
            else {
                setTimeout(function () { return poll(res); }, 50);
            }
        };
        return new Promise(poll);
    };
    GLTFModel.prototype.preload = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.models.map(function (model) { return GLTFModel.preload(model); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GLTFModel.preload = function (model) {
        return __awaiter(this, void 0, void 0, function () {
            var scene, gltf, camera, renderer, didRender;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        scene = new external_three_.Scene();
                        return [4 /*yield*/, loader.loadAsync(model)];
                    case 1:
                        gltf = _a.sent();
                        camera = new external_three_.PerspectiveCamera();
                        gltf.scene.scale.set(0.01, 0.01, 0.01);
                        gltf.scene.position.set(20, 0, 20);
                        scene.add(gltf.scene);
                        camera.position.set(10, 10, 10);
                        camera.lookAt(gltf.scene.position);
                        renderer = new external_three_.WebGLRenderer({
                            canvas: new OffscreenCanvas(1, 1),
                        });
                        renderer.setSize(1, 1, false);
                        didRender = false;
                        requestAnimationFrame(function () {
                            renderer.render(scene, camera);
                            didRender = true;
                        });
                        return [4 /*yield*/, GLTFModel.until(function () { return didRender; })];
                    case 2:
                        _a.sent();
                        scene.remove(gltf.scene);
                        renderer.dispose();
                        renderer.forceContextLoss();
                        return [2 /*return*/];
                }
            });
        });
    };
    return GLTFModel;
}());



/***/ }),

/***/ 5333:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ho: () => (/* binding */ drawLineOnTop),
/* harmony export */   Jf: () => (/* binding */ GROUND_OVERLAY_OPACITY),
/* harmony export */   Ov: () => (/* binding */ createTileIndicator),
/* harmony export */   oC: () => (/* binding */ GroundOverlayRenderOrder),
/* harmony export */   t8: () => (/* binding */ GROUND_OVERLAY_Y),
/* harmony export */   zH: () => (/* binding */ drawLineNormally)
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9604);
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(three__WEBPACK_IMPORTED_MODULE_0__);

// Ground overlays all share this clearance above the floor. Their visual
// priority is determined by render order, rather than by stacking them at
// slightly different heights.
var GROUND_OVERLAY_Y = -0.49;
var GROUND_OVERLAY_OPACITY = 0.5;
var GroundOverlayRenderOrder;
(function (GroundOverlayRenderOrder) {
    GroundOverlayRenderOrder[GroundOverlayRenderOrder["MARKED_TILE"] = 100] = "MARKED_TILE";
    GroundOverlayRenderOrder[GroundOverlayRenderOrder["TRUE_TILE"] = 200] = "TRUE_TILE";
    GroundOverlayRenderOrder[GroundOverlayRenderOrder["ENTITY_INDICATOR"] = 300] = "ENTITY_INDICATOR";
    GroundOverlayRenderOrder[GroundOverlayRenderOrder["HOVERED_TILE"] = 400] = "HOVERED_TILE";
})(GroundOverlayRenderOrder || (GroundOverlayRenderOrder = {}));
/** A thin ground-plane frame, rendered as triangles so WebGL MSAA smooths its edges. */
var createTileIndicator = function (size, color, renderOrder, thickness) {
    if (thickness === void 0) { thickness = 0.025; }
    var inner = Math.max(0, size - thickness);
    var shape = new three__WEBPACK_IMPORTED_MODULE_0__.Shape();
    shape.moveTo(0, 0);
    shape.lineTo(size, 0);
    shape.lineTo(size, size);
    shape.lineTo(0, size);
    shape.closePath();
    if (inner > 0) {
        var hole = new three__WEBPACK_IMPORTED_MODULE_0__.Path();
        hole.moveTo(thickness, thickness);
        hole.lineTo(thickness, inner);
        hole.lineTo(inner, inner);
        hole.lineTo(inner, thickness);
        hole.closePath();
        shape.holes.push(hole);
    }
    var geometry = new three__WEBPACK_IMPORTED_MODULE_0__.ShapeGeometry(shape);
    geometry.rotateX(-Math.PI / 2);
    var material = new three__WEBPACK_IMPORTED_MODULE_0__.MeshBasicMaterial({
        color: color,
        opacity: GROUND_OVERLAY_OPACITY,
        side: three__WEBPACK_IMPORTED_MODULE_0__.DoubleSide,
        transparent: true,
    });
    var indicator = new three__WEBPACK_IMPORTED_MODULE_0__.Mesh(geometry, material);
    if (renderOrder !== null) {
        indicator.renderOrder = renderOrder;
        material.depthTest = false;
        material.depthWrite = false;
    }
    return indicator;
};
var drawLineOnTop = function (mesh, renderOrder) {
    mesh.renderOrder = renderOrder;
    mesh.material.depthTest = false;
    mesh.material.depthWrite = false;
    mesh.material.transparent = true;
    mesh.material.opacity = GROUND_OVERLAY_OPACITY;
};
var drawLineNormally = function (mesh) {
    mesh.renderOrder = 0;
    mesh.material.depthTest = true;
    mesh.material.transparent = false;
};


/***/ }),

/***/ 2175:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: () => (/* binding */ TileMarkerModel)
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9604);
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(three__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _RenderUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5333);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var TileMarkerModel = /** @class */ (function () {
    function TileMarkerModel(renderable, renderOrder) {
        this.renderable = renderable;
        var size = renderable.size;
        this.outline = (0,_RenderUtils__WEBPACK_IMPORTED_MODULE_1__/* .createTileIndicator */ .Ov)(size, renderable.colorHex, renderOrder);
        this.material = this.outline.material;
    }
    TileMarkerModel.forRenderable = function (r, renderOrder) {
        if (renderOrder === void 0) { renderOrder = _RenderUtils__WEBPACK_IMPORTED_MODULE_1__/* .GroundOverlayRenderOrder */ .oC.MARKED_TILE; }
        return new TileMarkerModel(r, renderOrder);
    };
    TileMarkerModel.prototype.draw = function (scene, clockDelta, tickPercent, location, angleRadians, pitchRadians, visible, modelOffsets) {
        if (this.outline.parent !== scene) {
            scene.add(this.outline);
        }
        var x = location.x, y = location.y;
        this.outline.visible = this.renderable.visible(tickPercent) && visible;
        this.outline.position.x = x;
        this.outline.position.y = _RenderUtils__WEBPACK_IMPORTED_MODULE_1__/* .GROUND_OVERLAY_Y */ .t8;
        this.outline.position.z = y;
        this.material.color.setHex(this.renderable.colorHex);
    };
    TileMarkerModel.prototype.destroy = function (scene) {
        if (this.outline.parent === scene) {
            scene.remove(this.outline);
        }
    };
    TileMarkerModel.prototype.getWorldPosition = function () {
        return this.outline.getWorldPosition(new three__WEBPACK_IMPORTED_MODULE_0__.Vector3());
    };
    TileMarkerModel.prototype.preload = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // do nothing
                return [2 /*return*/];
            });
        });
    };
    return TileMarkerModel;
}());



/***/ }),

/***/ 3787:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D4: () => (/* binding */ sampleAnimation),
/* harmony export */   Zb: () => (/* binding */ RawFrameWorkspace),
/* harmony export */   a2: () => (/* binding */ interpolateRawFrames),
/* harmony export */   c9: () => (/* binding */ applyRawFrame),
/* harmony export */   ii: () => (/* binding */ applyMayaFrame),
/* harmony export */   sA: () => (/* binding */ interpolateMayaFrames),
/* harmony export */   xw: () => (/* binding */ applyBlendedRawFrames)
/* harmony export */ });
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9156);

/** Resolve elapsed time to the current and next cache animation frames. */
function sampleAnimation(animation, elapsed, looping) {
    var _a, _b;
    var total = animation.lengths.reduce(function (sum, length) { return sum + length; }, 0) / _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLIENT_CYCLES_PER_SECOND */ .ZC;
    var frameCount = ((_a = animation.mayaFrames) === null || _a === void 0 ? void 0 : _a.length) || ((_b = animation.rawFrames) === null || _b === void 0 ? void 0 : _b.length) || animation.frames.length;
    if (frameCount <= 0 || elapsed < 0)
        return { time: elapsed, total: total, frame: -1, nextFrame: -1, blend: 0 };
    var time = total <= 0
        ? 0
        : looping
            ? elapsed % total
            : Math.max(0, Math.min(elapsed, Math.max(0, total - Number.EPSILON)));
    // Compare integral cache-cycle boundaries to avoid accumulated seconds drift.
    var cycles = time * _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLIENT_CYCLES_PER_SECOND */ .ZC;
    var frameStart = 0;
    var frame = 0;
    while (frame < Math.min(animation.lengths.length, frameCount) - 1
        && cycles + 1e-9 >= frameStart + animation.lengths[frame]) {
        frameStart += animation.lengths[frame];
        frame++;
    }
    frame = Math.min(frame, frameCount - 1);
    var nextFrame = looping ? (frame + 1) % frameCount : Math.min(frame + 1, frameCount - 1);
    var frameDuration = animation.lengths[frame];
    var blend = frameDuration ? Math.max(0, Math.min(1, (cycles - frameStart) / frameDuration)) : 0;
    return { time: time, total: total, frame: frame, nextFrame: nextFrame, blend: blend };
}
var FrameType;
(function (FrameType) {
    FrameType[FrameType["Pivot"] = 0] = "Pivot";
    FrameType[FrameType["Translate"] = 1] = "Translate";
    FrameType[FrameType["Rotate"] = 2] = "Rotate";
    FrameType[FrameType["Scale"] = 3] = "Scale";
    FrameType[FrameType["Alpha"] = 5] = "Alpha";
})(FrameType || (FrameType = {}));
/** Reused native-coordinate buffers for legacy deformation. */
var RawFrameWorkspace = /** @class */ (function () {
    function RawFrameWorkspace() {
        this.x = new Float64Array(0);
        this.y = new Float64Array(0);
        this.z = new Float64Array(0);
        this.seen = new Set();
    }
    RawFrameWorkspace.prototype.resize = function (count) {
        if (this.x.length === count)
            return;
        this.x = new Float64Array(count);
        this.y = new Float64Array(count);
        this.z = new Float64Array(count);
    };
    return RawFrameWorkspace;
}());

var rotationSine = Int32Array.from({ length: 256 }, function (_, angle) { return Math.floor(65536 * Math.sin(angle * Math.PI / 128)); });
var rotationCosine = Int32Array.from({ length: 256 }, function (_, angle) { return Math.floor(65536 * Math.cos(angle * Math.PI / 128)); });
/** RuneLite-style transform interpolation: deform once, wrapping rotation deltas. */
function interpolateRawFrames(current, next, blend, output, floatingPoint) {
    var _a, _b;
    if (output === void 0) { output = { types: [], maps: [], indexFrameIds: [], x: [], y: [], z: [] }; }
    if (floatingPoint === void 0) { floatingPoint = false; }
    // Frames from different skeletons cannot be interpolated together.
    if (current.baseId !== next.baseId || blend <= 0)
        return current;
    output.baseId = current.baseId;
    output.types = current.types;
    output.maps = current.maps;
    output.indexFrameIds.length = output.x.length = output.y.length = output.z.length = 0;
    var a = 0, b = 0;
    for (var slot = 0; slot < current.types.length; slot++) {
        var hasCurrent = current.indexFrameIds[a] === slot;
        var hasNext = next.indexFrameIds[b] === slot;
        if (!hasCurrent && !hasNext)
            continue;
        var type = current.types[slot];
        var fallback = type === FrameType.Scale ? 128 : 0;
        output.indexFrameIds.push(slot);
        for (var _i = 0, _c = ["x", "y", "z"]; _i < _c.length; _i++) {
            var axis = _c[_i];
            var from = hasCurrent ? (_a = current[axis][a]) !== null && _a !== void 0 ? _a : fallback : fallback;
            var to = hasNext ? (_b = next[axis][b]) !== null && _b !== void 0 ? _b : fallback : fallback;
            var value = from;
            if (type === FrameType.Rotate) {
                var delta = (to - from) & 255;
                if (delta >= 128)
                    delta -= 256;
                value = floatingPoint ? ((from + delta * blend) % 256 + 256) % 256 : (from + Math.trunc(delta * blend)) & 255;
            }
            else if (type !== FrameType.Alpha)
                value = from + (floatingPoint ? (to - from) * blend : Math.trunc((to - from) * blend));
            else if (axis !== "x")
                value = 0;
            output[axis].push(value);
        }
        if (hasCurrent)
            a++;
        if (hasNext)
            b++;
    }
    return output;
}
/**
 * Apply one legacy cache frame to a composed model in place.
 *
 * `selection` mirrors the client's two-pass animate2 operation: origin slots
 * always run, while other transform slots are selected by the primary
 * sequence's opcode-3 interleave list.
 */
function applyRawFrame(positions, groups, sourceVertices, frame, selection, alphas, alphaGroups, workspace, floatingPoint) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (workspace === void 0) { workspace = new RawFrameWorkspace(); }
    if (floatingPoint === void 0) { floatingPoint = false; }
    workspace.resize(positions.length / 3);
    var x = workspace.x, y = workspace.y, z = workspace.z;
    // Work in the cache's native model units. Besides avoiding accumulating
    // scale error, this lets the fixed-point rotations match the game/client
    // implementation's signed >> 16 arithmetic.
    for (var index = 0; index < x.length; index++) {
        x[index] = positions[index * 3] * 128;
        y[index] = -positions[index * 3 + 1] * 128;
        z[index] = -positions[index * 3 + 2] * 128;
    }
    var pivot = { x: 0, y: 0, z: 0 };
    for (var index = 0; index < frame.indexFrameIds.length; index++) {
        var transform = frame.indexFrameIds[index];
        var type = frame.types[transform];
        var map = (_a = frame.maps[transform]) !== null && _a !== void 0 ? _a : [];
        if (type !== FrameType.Pivot && selection && selection.indices.has(transform) !== selection.include)
            continue;
        var deltaX = (_b = frame.x[index]) !== null && _b !== void 0 ? _b : 0;
        var deltaY = (_c = frame.y[index]) !== null && _c !== void 0 ? _c : 0;
        var deltaZ = (_d = frame.z[index]) !== null && _d !== void 0 ? _d : 0;
        if (type === FrameType.Alpha) {
            if (!alphas)
                continue;
            for (var _i = 0, map_1 = map; _i < map_1.length; _i++) {
                var group = map_1[_i];
                for (var _j = 0, _k = (_e = alphaGroups === null || alphaGroups === void 0 ? void 0 : alphaGroups[group]) !== null && _e !== void 0 ? _e : []; _j < _k.length; _j++) {
                    var vertex = _k[_j];
                    alphas[vertex] = Math.max(0, Math.min(255, alphas[vertex] + deltaX * 8));
                }
            }
            continue;
        }
        if (type === FrameType.Pivot) {
            var count = 0;
            pivot.x = pivot.y = pivot.z = 0;
            var seen = workspace.seen;
            seen.clear();
            for (var _l = 0, map_2 = map; _l < map_2.length; _l++) {
                var group = map_2[_l];
                for (var _m = 0, _o = (_f = groups[group]) !== null && _f !== void 0 ? _f : []; _m < _o.length; _m++) {
                    var vertex = _o[_m];
                    // Textures/flat face colours expand a cache vertex into several
                    // render vertices. Count that source vertex once when calculating a
                    // pivot, but do not weld unrelated vertices from different items.
                    var source = (_g = sourceVertices[vertex]) !== null && _g !== void 0 ? _g : vertex;
                    if (seen.has(source))
                        continue;
                    seen.add(source);
                    pivot.x += x[vertex];
                    pivot.y += y[vertex];
                    pivot.z += z[vertex];
                    count++;
                }
            }
            if (count) {
                pivot.x = deltaX + pivot.x / count;
                pivot.y = deltaY + pivot.y / count;
                pivot.z = deltaZ + pivot.z / count;
            }
            else {
                pivot.x = deltaX;
                pivot.y = deltaY;
                pivot.z = deltaZ;
            }
            continue;
        }
        var sinX = floatingPoint ? Math.sin(deltaX * Math.PI / 128) : rotationSine[deltaX & 255];
        var cosX = floatingPoint ? Math.cos(deltaX * Math.PI / 128) : rotationCosine[deltaX & 255];
        var sinY = floatingPoint ? Math.sin(deltaY * Math.PI / 128) : rotationSine[deltaY & 255];
        var cosY = floatingPoint ? Math.cos(deltaY * Math.PI / 128) : rotationCosine[deltaY & 255];
        var sinZ = floatingPoint ? Math.sin(deltaZ * Math.PI / 128) : rotationSine[deltaZ & 255];
        var cosZ = floatingPoint ? Math.cos(deltaZ * Math.PI / 128) : rotationCosine[deltaZ & 255];
        for (var _p = 0, map_3 = map; _p < map_3.length; _p++) {
            var group = map_3[_p];
            for (var _q = 0, _r = (_h = groups[group]) !== null && _h !== void 0 ? _h : []; _q < _r.length; _q++) {
                var vertex = _r[_q];
                if (type === FrameType.Translate) {
                    x[vertex] += deltaX;
                    y[vertex] += deltaY;
                    z[vertex] += deltaZ;
                    continue;
                }
                x[vertex] -= pivot.x;
                y[vertex] -= pivot.y;
                z[vertex] -= pivot.z;
                if (type === FrameType.Rotate) {
                    if (floatingPoint) {
                        var transformed = sinZ * y[vertex] + cosZ * x[vertex];
                        y[vertex] = cosZ * y[vertex] - sinZ * x[vertex];
                        x[vertex] = transformed;
                        transformed = cosX * y[vertex] - sinX * z[vertex];
                        z[vertex] = sinX * y[vertex] + cosX * z[vertex];
                        y[vertex] = transformed;
                        transformed = sinY * z[vertex] + cosY * x[vertex];
                        z[vertex] = cosY * z[vertex] - sinY * x[vertex];
                        x[vertex] = transformed;
                    }
                    else {
                        var transformed = (sinZ * y[vertex] + cosZ * x[vertex]) >> 16;
                        y[vertex] = (cosZ * y[vertex] - sinZ * x[vertex]) >> 16;
                        x[vertex] = transformed;
                        transformed = (cosX * y[vertex] - sinX * z[vertex]) >> 16;
                        z[vertex] = (sinX * y[vertex] + cosX * z[vertex]) >> 16;
                        y[vertex] = transformed;
                        transformed = (sinY * z[vertex] + cosY * x[vertex]) >> 16;
                        z[vertex] = (cosY * z[vertex] - sinY * x[vertex]) >> 16;
                        x[vertex] = transformed;
                    }
                }
                else if (type === FrameType.Scale) {
                    x[vertex] *= deltaX / 128;
                    y[vertex] *= deltaY / 128;
                    z[vertex] *= deltaZ / 128;
                }
                x[vertex] += pivot.x;
                y[vertex] += pivot.y;
                z[vertex] += pivot.z;
            }
        }
    }
    for (var index = 0; index < x.length; index++) {
        positions[index * 3] = x[index] / 128;
        positions[index * 3 + 1] = -y[index] / 128;
        positions[index * 3 + 2] = -z[index] / 128;
    }
}
/** Approximate fractional Maya poses from the extracted matrix samples, reusing bone buffers. */
function interpolateMayaFrames(current, next, blend, output) {
    var _a, _b;
    if (blend <= 0 || current === next)
        return current;
    output.length = current.length;
    for (var bone = 0; bone < current.length; bone++) {
        var from = current[bone], to = (_a = next[bone]) !== null && _a !== void 0 ? _a : from;
        var matrix = (_b = output[bone]) !== null && _b !== void 0 ? _b : (output[bone] = new Array(16));
        for (var component = 0; component < 16; component++)
            matrix[component] = from[component] + (to[component] - from[component]) * blend;
    }
    return output;
}
/**
 * Blend a one-shot animation with a looping pose using the cache client's
 * two-pass `animate2` behavior.
 *
 * The primary frame is applied to transforms excluded by `interleave`; the
 * pose frame is then applied to transforms included by it. Pivot transforms
 * run in both passes so each pass calculates the correct transform origin.
 * Both frames mutate the supplied positions, and optionally face alphas, in
 * place.
 *
 * @param positions Render-space vertex positions initialized to the bind pose.
 * @param groups Frame-map groups containing render vertex indices.
 * @param sourceVertices Identity mapping used to count expanded render vertices
 *   only once when calculating transform pivots.
 * @param primary The active one-shot frame, such as an attack animation.
 * @param pose The concurrent looping pose frame, such as walk or idle.
 * @param interleave Transform indices assigned to the pose pass. The cache
 *   sentinel value `9999999` is ignored.
 * @param alphas Optional mutable face-alpha values initialized to the bind pose.
 * @param alphaGroups Frame-map groups containing face-alpha indices.
 */
function applyBlendedRawFrames(positions, groups, sourceVertices, primary, pose, interleave, alphas, alphaGroups, workspace) {
    var selection = new Set(interleave.filter(function (index) { return index !== 9999999; }));
    applyRawFrame(positions, groups, sourceVertices, primary, { indices: selection, include: false }, alphas, alphaGroups, workspace);
    applyRawFrame(positions, groups, sourceVertices, pose, { indices: selection, include: true }, alphas, alphaGroups, workspace);
}
/**
 * Apply an Animaya bone frame to a model's positions in place.
 *
 * Animaya weights are byte contributions to an accumulated skin matrix. They
 * are intentionally not normalized because authored weights do not always sum
 * to exactly 255.
 */
function applyMayaFrame(positions, frame, vertexGroups, vertexScales) {
    var _a, _b, _c;
    for (var vertex = 0; vertex < positions.length / 3; vertex++) {
        var bones = (_a = vertexGroups[vertex]) !== null && _a !== void 0 ? _a : [];
        var scales = (_b = vertexScales[vertex]) !== null && _b !== void 0 ? _b : [];
        if (!bones.length)
            continue;
        var x = positions[vertex * 3];
        var y = positions[vertex * 3 + 1];
        var z = positions[vertex * 3 + 2];
        var outputX = 0;
        var outputY = 0;
        var outputZ = 0;
        var hasWeight = false;
        for (var index = 0; index < bones.length; index++) {
            var bone = bones[index];
            var matrix = frame[bone];
            if (!matrix)
                continue;
            var scale = ((_c = scales[index]) !== null && _c !== void 0 ? _c : 255) / 255;
            hasWeight = true;
            outputX += (matrix[0] * x + matrix[4] * y + matrix[8] * z + matrix[12] / 128) * scale;
            outputY += (matrix[1] * x + matrix[5] * y + matrix[9] * z + matrix[13] / 128) * scale;
            outputZ += (matrix[2] * x + matrix[6] * y + matrix[10] * z + matrix[14] / 128) * scale;
        }
        if (hasWeight) {
            positions[vertex * 3] = outputX;
            positions[vertex * 3 + 1] = outputY;
            positions[vertex * 3 + 2] = outputZ;
        }
    }
}


/***/ }),

/***/ 8048:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ai: () => (/* binding */ normalizeCacheAlpha),
/* harmony export */   E2: () => (/* binding */ cacheColorsToRgba),
/* harmony export */   GS: () => (/* binding */ cacheColorToRgb),
/* harmony export */   Lm: () => (/* binding */ cacheAlphaToOpacity),
/* harmony export */   ZX: () => (/* binding */ cacheColorsToRgb),
/* harmony export */   ql: () => (/* binding */ resolveCacheColor)
/* harmony export */ });
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9604);
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(three__WEBPACK_IMPORTED_MODULE_0__);
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

/** Convert a possibly signed cache byte to an unsigned alpha value. */
function normalizeCacheAlpha(alpha) {
    return alpha & 255;
}
/** Convert cache transparency (0 = opaque) to Three.js opacity (1 = opaque). */
function cacheAlphaToOpacity(alpha) {
    return 1 - Math.max(0, Math.min(255, alpha)) / 255;
}
/** Convert a packed cache display/sRGB colour to Three.js working-space RGB. */
function cacheColorToRgb(value) {
    var color = new three__WEBPACK_IMPORTED_MODULE_0__.Color(value);
    return [color.r, color.g, color.b];
}
/** Resolve a spot-animation recolour before colour-space conversion. */
function resolveCacheColor(baseColor, faceColor, recolor) {
    var _a;
    return faceColor == null ? baseColor : (_a = recolor === null || recolor === void 0 ? void 0 : recolor[String(faceColor)]) !== null && _a !== void 0 ? _a : baseColor;
}
function cacheColorsToRgb(colors) {
    var values = [];
    colors.forEach(function (color) { return values.push.apply(values, cacheColorToRgb(color)); });
    return values;
}
/** Build an RGBA attribute from normalized cache alpha values. */
function cacheColorsToRgba(colors, alphas, faceColors, recolor) {
    var values = [];
    colors.forEach(function (baseColor, index) {
        var _a;
        values.push.apply(values, __spreadArray(__spreadArray([], cacheColorToRgb(resolveCacheColor(baseColor, faceColors === null || faceColors === void 0 ? void 0 : faceColors[index], recolor)), false), [cacheAlphaToOpacity((_a = alphas[index]) !== null && _a !== void 0 ? _a : 0)], false));
    });
    return values;
}


/***/ }),

/***/ 4993:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Bv: () => (/* binding */ cachedPayload),
  GE: () => (/* binding */ mergePayloads)
});

// UNUSED EXPORTS: decodeCacheRenderPayload

;// CONCATENATED MODULE: ./node_modules/fflate/esm/browser.js
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var ch2 = {};
var wk = (function (c, id, msg, transfer, cb) {
    var w = new Worker(ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], { type: 'text/javascript' }))));
    w.onmessage = function (e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        }
        else
            cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
});

// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, i32 = Int32Array;
// fixed length extra bits
var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */ 0, 0, /* impossible */ 0]);
// fixed distance extra bits
var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */ 0, 0]);
// code length index map
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
// get base, reverse index map from extra bits
var freb = function (eb, start) {
    var b = new u16(31);
    for (var i = 0; i < 31; ++i) {
        b[i] = start += 1 << eb[i - 1];
    }
    // numbers here are at max 18 bits
    var r = new i32(b[30]);
    for (var i = 1; i < 30; ++i) {
        for (var j = b[i]; j < b[i + 1]; ++j) {
            r[j] = ((j - b[i]) << 5) | i;
        }
    }
    return { b: b, r: r };
};
var _a = freb(fleb, 2), fl = _a.b, revfl = _a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b.b, revfd = _b.r;
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for (var i = 0; i < 32768; ++i) {
    // reverse table algorithm from SO
    var x = ((i & 0xAAAA) >> 1) | ((i & 0x5555) << 1);
    x = ((x & 0xCCCC) >> 2) | ((x & 0x3333) << 2);
    x = ((x & 0xF0F0) >> 4) | ((x & 0x0F0F) << 4);
    rev[i] = (((x & 0xFF00) >> 8) | ((x & 0x00FF) << 8)) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = (function (cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for (; i < s; ++i) {
        if (cd[i])
            ++l[cd[i] - 1];
    }
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for (i = 1; i < mb; ++i) {
        le[i] = (le[i - 1] + l[i - 1]) << 1;
    }
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for (i = 0; i < s; ++i) {
            // ignore 0 lengths
            if (cd[i]) {
                // num encoding both symbol and bits read
                var sv = (i << 4) | cd[i];
                // free bits
                var r_1 = mb - cd[i];
                // start value
                var v = le[cd[i] - 1]++ << r_1;
                // m is end value
                for (var m = v | ((1 << r_1) - 1); v <= m; ++v) {
                    // every 16 bit value starting with the code yields the same result
                    co[rev[v] >> rvb] = sv;
                }
            }
        }
    }
    else {
        co = new u16(s);
        for (i = 0; i < s; ++i) {
            if (cd[i]) {
                co[i] = rev[le[cd[i] - 1]++] >> (15 - cd[i]);
            }
        }
    }
    return co;
});
// fixed length tree
var flt = new u8(288);
for (var i = 0; i < 144; ++i)
    flt[i] = 8;
for (var i = 144; i < 256; ++i)
    flt[i] = 9;
for (var i = 256; i < 280; ++i)
    flt[i] = 7;
for (var i = 280; i < 288; ++i)
    flt[i] = 8;
// fixed distance tree
var fdt = new u8(32);
for (var i = 0; i < 32; ++i)
    fdt[i] = 5;
// fixed length map
var flm = /*#__PURE__*/ (/* unused pure expression or super */ null && (hMap(flt, 9, 0))), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ (/* unused pure expression or super */ null && (hMap(fdt, 5, 0))), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function (a) {
    var m = a[0];
    for (var i = 1; i < a.length; ++i) {
        if (a[i] > m)
            m = a[i];
    }
    return m;
};
// read d, starting at bit p and mask with m
var bits = function (d, p, m) {
    var o = (p / 8) | 0;
    return ((d[o] | (d[o + 1] << 8)) >> (p & 7)) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function (d, p) {
    var o = (p / 8) | 0;
    return ((d[o] | (d[o + 1] << 8) | (d[o + 2] << 16)) >> (p & 7));
};
// get end of byte
var shft = function (p) { return ((p + 7) / 8) | 0; };
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function (v, s, e) {
    if (s == null || s < 0)
        s = 0;
    if (e == null || e > v.length)
        e = v.length;
    // can't use .constructor in case user-supplied
    return new u8(v.subarray(s, e));
};
/**
 * Codes for errors generated within this library
 */
var FlateErrorCode = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
    // determined by unknown compression method
];
;
var err = function (ind, msg, nt) {
    var e = new Error(msg || ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace)
        Error.captureStackTrace(e, err);
    if (!nt)
        throw e;
    return e;
};
// expands raw DEFLATE data
var inflt = function (dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l)
        return buf || new u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf)
        buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function (l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | (dat[s - 3] << 8), t = s + l;
                if (t > sl) {
                    if (noSt)
                        err(0);
                    break;
                }
                // ensure size
                if (resize)
                    cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            }
            else if (type == 1)
                lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for (var i = 0; i < hcLen; ++i) {
                    // use index map to get real code
                    clt[clim[i]] = bits(dat, pos + i * 3, 7);
                }
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for (var i = 0; i < tl;) {
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) {
                        ldt[i++] = s;
                    }
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16)
                            n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17)
                            n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18)
                            n = 11 + bits(dat, pos, 127), pos += 7;
                        while (n--)
                            ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            }
            else
                err(1);
            if (pos > tbts) {
                if (noSt)
                    err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize)
            cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for (;; lpos = pos) {
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt)
                    err(0);
                break;
            }
            if (!c)
                err(2);
            if (sym < 256)
                buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            }
            else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d)
                    err(3);
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt)
                        err(0);
                    break;
                }
                if (resize)
                    cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0)
                        err(3);
                    for (; bt < dend; ++bt)
                        buf[bt] = dict[shift + bt];
                }
                for (; bt < end; ++bt)
                    buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm)
            final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    } while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var hTree = function (d, mb) {
    // Need extra info to make a tree
    var t = [];
    for (var i = 0; i < d.length; ++i) {
        if (d[i])
            t.push({ s: i, f: d[i] });
    }
    var s = t.length;
    var t2 = t.slice();
    if (!s)
        return { t: et, l: 0 };
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return { t: v, l: 1 };
    }
    t.sort(function (a, b) { return a.f - b.f; });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({ s: -1, f: 25001 });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = { s: -1, f: l.f + r.f, l: l, r: r };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while (i1 != s - 1) {
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = { s: -1, f: l.f + r.f, l: l, r: r };
    }
    var maxSym = t2[0].s;
    for (var i = 1; i < s; ++i) {
        if (t2[i].s > maxSym)
            maxSym = t2[i].s;
    }
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function (a, b) { return tr[b.s] - tr[a.s] || a.f - b.f; });
        for (; i < s; ++i) {
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << (mbt - tr[i2_1]));
                tr[i2_1] = mb;
            }
            else
                break;
        }
        dt >>= lft;
        while (dt > 0) {
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb)
                dt -= 1 << (mb - tr[i2_2]++ - 1);
            else
                ++i;
        }
        for (; i >= 0 && dt; --i) {
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return { t: new u8(tr), l: mbt };
};
// get the max length and assign length codes
var ln = function (n, l, d) {
    return n.s == -1
        ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1))
        : (l[n.s] = d);
};
// length codes generation
var lc = function (c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while (s && !c[--s])
        ;
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function (v) { cl[cli++] = v; };
    for (var i = 1; i <= s; ++i) {
        if (c[i] == cln && i != s)
            ++cls;
        else {
            if (!cln && cls > 2) {
                for (; cls > 138; cls -= 138)
                    w(32754);
                if (cls > 2) {
                    w(cls > 10 ? ((cls - 11) << 5) | 28690 : ((cls - 3) << 5) | 12305);
                    cls = 0;
                }
            }
            else if (cls > 3) {
                w(cln), --cls;
                for (; cls > 6; cls -= 6)
                    w(8304);
                if (cls > 2)
                    w(((cls - 3) << 5) | 8208), cls = 0;
            }
            while (cls--)
                w(cln);
            cls = 1;
            cln = c[i];
        }
    }
    return { c: cl.subarray(0, cli), n: s };
};
// calculate the length of output from tree, code lengths
var clen = function (cf, cl) {
    var l = 0;
    for (var i = 0; i < cl.length; ++i)
        l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function (out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for (var i = 0; i < s; ++i)
        out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function (dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new u16(19);
    for (var i = 0; i < lclt.length; ++i)
        ++lcfreq[lclt[i] & 31];
    for (var i = 0; i < lcdt.length; ++i)
        ++lcfreq[lcdt[i] & 31];
    var _e = hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc)
        ;
    var flen = (bl + 5) << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen)
        return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for (var i = 0; i < nlcc; ++i)
            wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [lclt, lcdt];
        for (var it = 0; it < 2; ++it) {
            var clct = lcts[it];
            for (var i = 0; i < clct.length; ++i) {
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15)
                    wbits(out, p, (clct[i] >> 5) & 127), p += clct[i] >> 12;
            }
        }
    }
    else {
        lm = flm, ll = flt, dm = fdm, dl = fdt;
    }
    for (var i = 0; i < li; ++i) {
        var sym = syms[i];
        if (sym > 255) {
            var len = (sym >> 18) & 31;
            wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7)
                wbits(out, p, (sym >> 23) & 31), p += fleb[len];
            var dst = sym & 31;
            wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3)
                wbits16(out, p, (sym >> 5) & 8191), p += fdeb[dst];
        }
        else {
            wbits16(out, p, lm[sym]), p += ll[sym];
        }
    }
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new i32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
// empty
var et = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function (dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos)
            w[0] = st.r >> 3;
        var opt = deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new u16(32768), head = st.h || new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function (i) { return (dat[i] ^ (dat[i + 1] << bs1_1) ^ (dat[i + 2] << bs2_1)) & msk_1; };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new i32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for (; i + 2 < s; ++i) {
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for (var j = 0; j < 286; ++j)
                        lf[j] = 0;
                    for (var j = 0; j < 30; ++j)
                        df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while (dif <= maxd && --ch_1 && imod != pimod) {
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl)
                                ;
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn)
                                    break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for (var j = 0; j < mmd; ++j) {
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md)
                                        md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | (revfl[l] << 18) | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                }
                else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for (i = Math.max(i, wi); i < s; ++i) {
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = (pos & 7) | w[(pos / 8) | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    }
    else {
        for (var i = st.w || 0; i < s + lst; i += 65535) {
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[(pos / 8) | 0] = lst;
                e = s;
            }
            pos = wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// CRC32 table
var crct = /*#__PURE__*/ (/* unused pure expression or super */ null && ((function () {
    var t = new Int32Array(256);
    for (var i = 0; i < 256; ++i) {
        var c = i, k = 9;
        while (--k)
            c = ((c & 1) && -306674912) ^ (c >>> 1);
        t[i] = c;
    }
    return t;
})()));
// CRC32
var crc = function () {
    var c = -1;
    return {
        p: function (d) {
            // closures have awful performance
            var cr = c;
            for (var i = 0; i < d.length; ++i)
                cr = crct[(cr & 255) ^ d[i]] ^ (cr >>> 8);
            c = cr;
        },
        d: function () { return ~c; }
    };
};
// Adler32
var adler = function () {
    var a = 1, b = 0;
    return {
        p: function (d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for (var i = 0; i != l;) {
                var e = Math.min(i + 2655, l);
                for (; i < e; ++i)
                    m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function () {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | (b >> 8);
        }
    };
};
;
// deflate with opts
var dopt = function (dat, opt, pre, post, st) {
    if (!st) {
        st = { l: 1 };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? (st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20) : (12 + opt.mem), pre, post, st);
};
// Walmart object spread
var mrg = function (a, b) {
    var o = {};
    for (var k in a)
        o[k] = a[k];
    for (var k in b)
        o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var wcln = function (fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for (var i = 0; i < dt.length; ++i) {
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                }
                else {
                    fnStr += st_1;
                    for (var t in v.prototype)
                        fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            }
            else
                fnStr += st_1;
        }
        else
            td[k] = v;
    }
    return fnStr;
};
var ch = (/* unused pure expression or super */ null && ([]));
// clone bufs
var cbfs = function (v) {
    var tl = [];
    for (var k in v) {
        if (v[k].buffer) {
            tl.push((v[k] = new v[k].constructor(v[k])).buffer);
        }
    }
    return tl;
};
// use a worker to execute code
var wrkr = function (fns, init, id, cb) {
    if (!ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for (var i = 0; i < m; ++i)
            fnStr = wcln(fns[i], fnStr, td_1);
        ch[id] = { c: wcln(fns[m], fnStr, td_1), e: td_1 };
    }
    var td = mrg({}, ch[id].e);
    return wk(ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, cbfs(td), cb);
};
// base async inflate fn
var bInflt = function () { return [u8, u16, i32, fleb, fdeb, clim, fl, fd, flrm, fdrm, rev, ec, hMap, max, bits, bits16, shft, slc, err, inflt, inflateSync, pbf, gopt]; };
var bDflt = function () { return [u8, u16, i32, fleb, fdeb, clim, revfl, revfd, flm, flt, fdm, fdt, rev, deo, et, hMap, wbits, wbits16, hTree, ln, lc, clen, wfblk, wblk, shft, slc, dflt, dopt, deflateSync, pbf]; };
// gzip extra
var gze = function () { return [gzh, gzhl, wbytes, crc, crct]; };
// gunzip extra
var guze = function () { return [gzs, gzl]; };
// zlib extra
var zle = function () { return [zlh, wbytes, adler]; };
// unzlib extra
var zule = function () { return [zls]; };
// post buf
var pbf = function (msg) { return postMessage(msg, [msg.buffer]); };
// get opts
var gopt = function (o) { return o && {
    out: o.size && new u8(o.size),
    dictionary: o.dictionary
}; };
// async helper
var cbify = function (dat, opts, fns, init, id, cb) {
    var w = wrkr(fns, init, id, function (err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([dat, opts], opts.consume ? [dat.buffer] : []);
    return function () { w.terminate(); };
};
// auto stream
var astrm = function (strm) {
    strm.ondata = function (dat, final) { return postMessage([dat, final], [dat.buffer]); };
    return function (ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([ev.data[0].length]);
        }
        else
            strm.flush();
    };
};
// async stream attach
var astrmify = function (fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = wrkr(fns, init, id, function (err, dat) {
        if (err)
            w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat))
            ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain)
                strm.ondrain(dat[0]);
        }
        else {
            if (dat[1])
                w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function (d, f) {
        if (!strm.ondata)
            err(5);
        if (t)
            strm.ondata(err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([d, t = f], [d.buffer]);
    };
    strm.terminate = function () { w.terminate(); };
    if (flush) {
        strm.flush = function () { w.postMessage([]); };
    }
};
// read 2 bytes
var b2 = function (d, b) { return d[b] | (d[b + 1] << 8); };
// read 4 bytes
var b4 = function (d, b) { return (d[b] | (d[b + 1] << 8) | (d[b + 2] << 16) | (d[b + 3] << 24)) >>> 0; };
var b8 = function (d, b) { return b4(d, b) + (b4(d, b + 4) * 4294967296); };
// write bytes
var wbytes = function (d, b, v) {
    for (; v; ++b)
        d[b] = v, v >>>= 8;
};
// gzip header
var gzh = function (c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0)
        wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for (var i = 0; i <= fn.length; ++i)
            c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var gzs = function (d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8)
        err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4)
        st += (d[10] | d[11] << 8) + 2;
    for (var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++])
        ;
    return st + (flg & 2);
};
// gzip length
var gzl = function (d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var gzhl = function (o) { return 10 + (o.filename ? o.filename.length + 1 : 0); };
// zlib header
var zlh = function (c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = (fl << 6) | (o.dictionary && 32);
    c[1] |= 31 - ((c[0] << 8) | c[1]) % 31;
    if (o.dictionary) {
        var h = adler();
        h.p(o.dictionary);
        wbytes(c, 2, h.d());
    }
};
// zlib start
var zls = function (d, dict) {
    if ((d[0] & 15) != 8 || (d[0] >> 4) > 7 || ((d[0] << 8 | d[1]) % 31))
        err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict)
        err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function StrmOpt(opts, cb) {
    if (typeof opts == 'function')
        cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */
var Deflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function Deflate(opts, cb) {
        if (typeof opts == 'function')
            cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = { l: 0, i: 32768, w: 32768, z: 32768 };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function (c, f) {
        this.ondata(dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Deflate.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        if (this.s.l)
            err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        }
        else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */
    Deflate.prototype.flush = function () {
        if (!this.ondata)
            err(5);
        if (this.s.l)
            err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}())));

/**
 * Asynchronous streaming DEFLATE compression
 */
var AsyncDeflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function AsyncDeflate(opts, cb) {
        astrmify([
            bDflt,
            function () { return [astrm, Deflate]; }
        ], this, StrmOpt.call(this, opts, cb), function (ev) {
            var strm = new Deflate(ev.data);
            onmessage = astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}())));

function deflate(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bDflt,
    ], function (ev) { return pbf(deflateSync(ev.data[0], ev.data[1])); }, 0, cb);
}
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */
function deflateSync(data, opts) {
    return dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */
var Inflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function')
            cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = { i: 0, b: dict ? dict.length : 0 };
        this.o = new u8(32768);
        this.p = new u8(0);
        if (dict)
            this.o.set(dict);
    }
    Inflate.prototype.e = function (c) {
        if (!this.ondata)
            err(5);
        if (this.d)
            err(4);
        if (!this.p.length)
            this.p = c;
        else if (c.length) {
            var n = new u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function (final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = inflt(this.p, this.s, this.o);
        this.ondata(slc(dt, bts, this.s.b), this.d);
        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = slc(this.p, (this.s.p / 8) | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */
    Inflate.prototype.push = function (chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}())));

/**
 * Asynchronous streaming DEFLATE decompression
 */
var AsyncInflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function AsyncInflate(opts, cb) {
        astrmify([
            bInflt,
            function () { return [astrm, Inflate]; }
        ], this, StrmOpt.call(this, opts, cb), function (ev) {
            var strm = new Inflate(ev.data);
            onmessage = astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}())));

function inflate(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bInflt
    ], function (ev) { return pbf(inflateSync(ev.data[0], gopt(ev.data[1]))); }, 1, cb);
}
/**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */
function inflateSync(data, opts) {
    return inflt(data, { i: 2 }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */
var Gzip = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function Gzip(opts, cb) {
        this.c = crc();
        this.l = 0;
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Gzip.prototype.push = function (chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        Deflate.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function (c, f) {
        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, this.s);
        if (this.v)
            gzh(raw, this.o), this.v = 0;
        if (f)
            wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */
    Gzip.prototype.flush = function () {
        Deflate.prototype.flush.call(this);
    };
    return Gzip;
}())));

/**
 * Asynchronous streaming GZIP compression
 */
var AsyncGzip = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function AsyncGzip(opts, cb) {
        astrmify([
            bDflt,
            gze,
            function () { return [astrm, Deflate, Gzip]; }
        ], this, StrmOpt.call(this, opts, cb), function (ev) {
            var strm = new Gzip(ev.data);
            onmessage = astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}())));

function gzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bDflt,
        gze,
        function () { return [gzipSync]; }
    ], function (ev) { return pbf(gzipSync(ev.data[0], ev.data[1])); }, 2, cb);
}
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */
function gzipSync(data, opts) {
    if (!opts)
        opts = {};
    var c = crc(), l = data.length;
    c.p(data);
    var d = dopt(data, opts, gzhl(opts), 8), s = d.length;
    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */
var Gunzip = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        Inflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Gunzip.prototype.push = function (chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? gzs(p) : 4;
            if (s > p.length) {
                if (!final)
                    return;
            }
            else if (this.v > 1 && this.onmember) {
                this.onmember(this.r - p.length);
            }
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = shft(this.s.p) + 9;
            this.s = { i: 0 };
            this.o = new u8(0);
            this.push(new u8(0), final);
        }
    };
    return Gunzip;
}())));

/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */
var AsyncGunzip = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        astrmify([
            bInflt,
            guze,
            function () { return [astrm, Inflate, Gunzip]; }
        ], this, StrmOpt.call(this, opts, cb), function (ev) {
            var strm = new Gunzip(ev.data);
            strm.onmember = function (offset) { return postMessage(offset); };
            onmessage = astrm(strm);
        }, 9, 0, function (offset) { return _this.onmember && _this.onmember(offset); });
    }
    return AsyncGunzip;
}())));

function gunzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bInflt,
        guze,
        function () { return [gunzipSync]; }
    ], function (ev) { return pbf(gunzipSync(ev.data[0], ev.data[1])); }, 3, cb);
}
/**
 * Expands GZIP data
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */
function gunzipSync(data, opts) {
    var st = gzs(data);
    if (st + 8 > data.length)
        err(6, 'invalid gzip data');
    return inflt(data.subarray(st, -8), { i: 2 }, opts && opts.out || new u8(gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */
var Zlib = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function Zlib(opts, cb) {
        this.c = adler();
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Zlib.prototype.push = function (chunk, final) {
        this.c.p(chunk);
        Deflate.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function (c, f) {
        var raw = dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v)
            zlh(raw, this.o), this.v = 0;
        if (f)
            wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */
    Zlib.prototype.flush = function () {
        Deflate.prototype.flush.call(this);
    };
    return Zlib;
}())));

/**
 * Asynchronous streaming Zlib compression
 */
var AsyncZlib = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function AsyncZlib(opts, cb) {
        astrmify([
            bDflt,
            zle,
            function () { return [astrm, Deflate, Zlib]; }
        ], this, StrmOpt.call(this, opts, cb), function (ev) {
            var strm = new Zlib(ev.data);
            onmessage = astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}())));

function zlib(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bDflt,
        zle,
        function () { return [zlibSync]; }
    ], function (ev) { return pbf(zlibSync(ev.data[0], ev.data[1])); }, 4, cb);
}
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */
function zlibSync(data, opts) {
    if (!opts)
        opts = {};
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */
var Unzlib = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function Unzlib(opts, cb) {
        Inflate.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Unzlib.prototype.push = function (chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final)
                return;
            this.p = this.p.subarray(zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4)
                err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Unzlib;
}())));

/**
 * Asynchronous streaming Zlib decompression
 */
var AsyncUnzlib = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function AsyncUnzlib(opts, cb) {
        astrmify([
            bInflt,
            zule,
            function () { return [astrm, Inflate, Unzlib]; }
        ], this, StrmOpt.call(this, opts, cb), function (ev) {
            var strm = new Unzlib(ev.data);
            onmessage = astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}())));

function unzlib(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bInflt,
        zule,
        function () { return [unzlibSync]; }
    ], function (ev) { return pbf(unzlibSync(ev.data[0], gopt(ev.data[1]))); }, 5, cb);
}
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */
function unzlibSync(data, opts) {
    return inflt(data.subarray(zls(data, opts && opts.dictionary), -4), { i: 2 }, opts && opts.out, opts && opts.dictionary);
}
// Default algorithm for compression (used because having a known output size allows faster decompression)


/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */
var Decompress = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function Decompress(opts, cb) {
        this.o = StrmOpt.call(this, opts, cb) || {};
        this.G = Gunzip;
        this.I = Inflate;
        this.Z = Unzlib;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function () {
        var _this = this;
        this.s.ondata = function (dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Decompress.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            }
            else
                this.p = chunk;
            if (this.p.length > 2) {
                this.s = (this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8)
                    ? new this.G(this.o)
                    : ((this.p[0] & 15) != 8 || (this.p[0] >> 4) > 7 || ((this.p[0] << 8 | this.p[1]) % 31))
                        ? new this.I(this.o)
                        : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        }
        else
            this.s.push(chunk, final);
    };
    return Decompress;
}())));

/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */
var AsyncDecompress = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function AsyncDecompress(opts, cb) {
        Decompress.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = AsyncGunzip;
        this.I = AsyncInflate;
        this.Z = AsyncUnzlib;
    }
    AsyncDecompress.prototype.i = function () {
        var _this = this;
        this.s.ondata = function (err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function (size) {
            _this.queuedSize -= size;
            if (_this.ondrain)
                _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    AsyncDecompress.prototype.push = function (chunk, final) {
        this.queuedSize += chunk.length;
        Decompress.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}())));

function decompress(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return (data[0] == 31 && data[1] == 139 && data[2] == 8)
        ? gunzip(data, opts, cb)
        : ((data[0] & 15) != 8 || (data[0] >> 4) > 7 || ((data[0] << 8 | data[1]) % 31))
            ? inflate(data, opts, cb)
            : unzlib(data, opts, cb);
}
/**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */
function decompressSync(data, opts) {
    return (data[0] == 31 && data[1] == 139 && data[2] == 8)
        ? gunzipSync(data, opts)
        : ((data[0] & 15) != 8 || (data[0] >> 4) > 7 || ((data[0] << 8 | data[1]) % 31))
            ? inflateSync(data, opts)
            : unzlibSync(data, opts);
}
// flatten a directory structure
var fltn = function (d, p, t, o) {
    for (var k in d) {
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val))
            op = mrg(o, val[1]), val = val[0];
        if (val instanceof u8)
            t[n] = [val, op];
        else {
            t[n += '/'] = [new u8(0), op];
            fltn(val, n, t, o);
        }
    }
};
// text encoder
var te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var tds = 0;
try {
    td.decode(et, { stream: true });
    tds = 1;
}
catch (e) { }
// decode UTF8
var dutf8 = function (d) {
    for (var r = '', i = 0;;) {
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length)
            return { s: r, r: slc(d, i - 1) };
        if (!eb)
            r += String.fromCharCode(c);
        else if (eb == 3) {
            c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | (d[i++] & 63)) - 65536,
                r += String.fromCharCode(55296 | (c >> 10), 56320 | (c & 1023));
        }
        else if (eb & 1)
            r += String.fromCharCode((c & 31) << 6 | (d[i++] & 63));
        else
            r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | (d[i++] & 63));
    }
};
/**
 * Streaming UTF-8 decoding
 */
var DecodeUTF8 = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */
    function DecodeUTF8(cb) {
        this.ondata = cb;
        if (tds)
            this.t = new TextDecoder();
        else
            this.p = et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    DecodeUTF8.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, { stream: true }), final);
            if (final) {
                if (this.t.decode().length)
                    err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p)
            err(4);
        var dat = new u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length)
                err(8);
            this.p = null;
        }
        else
            this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}())));

/**
 * Streaming UTF-8 encoding
 */
var EncodeUTF8 = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */
    function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */
    EncodeUTF8.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        if (this.d)
            err(4);
        this.ondata(strToU8(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}())));

/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */
function strToU8(str, latin1) {
    if (latin1) {
        var ar_1 = new u8(str.length);
        for (var i = 0; i < str.length; ++i)
            ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if (te)
        return te.encode(str);
    var l = str.length;
    var ar = new u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function (v) { ar[ai++] = v; };
    for (var i = 0; i < l; ++i) {
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + ((l - i) << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1)
            w(c);
        else if (c < 2048)
            w(192 | (c >> 6)), w(128 | (c & 63));
        else if (c > 55295 && c < 57344)
            c = 65536 + (c & 1023 << 10) | (str.charCodeAt(++i) & 1023),
                w(240 | (c >> 18)), w(128 | ((c >> 12) & 63)), w(128 | ((c >> 6) & 63)), w(128 | (c & 63));
        else
            w(224 | (c >> 12)), w(128 | ((c >> 6) & 63)), w(128 | (c & 63));
    }
    return slc(ar, 0, ai);
}
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */
function strFromU8(dat, latin1) {
    if (latin1) {
        var r = '';
        for (var i = 0; i < dat.length; i += 16384)
            r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    }
    else if (td) {
        return td.decode(dat);
    }
    else {
        var _a = dutf8(dat), s = _a.s, r = _a.r;
        if (r.length)
            err(8);
        return s;
    }
}
;
// deflate bit flag
var dbf = function (l) { return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0; };
// skip local zip header
var slzh = function (d, b) { return b + 30 + b2(d, b + 26) + b2(d, b + 28); };
// read zip header
var zh = function (d, b, z) {
    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = b4(d, b + 20);
    var _a = z && bs == 4294967295 ? z64e(d, es) : [bs, b4(d, b + 24), b4(d, b + 42)], sc = _a[0], su = _a[1], off = _a[2];
    return [b2(d, b + 10), sc, su, fn, es + b2(d, b + 30) + b2(d, b + 32), off];
};
// read zip64 extra field
var z64e = function (d, b) {
    for (; b2(d, b) != 1; b += 4 + b2(d, b + 2))
        ;
    return [b8(d, b + 12), b8(d, b + 4), b8(d, b + 20)];
};
// extra field length
var exfl = function (ex) {
    var le = 0;
    if (ex) {
        for (var k in ex) {
            var l = ex[k].length;
            if (l > 65535)
                err(9);
            le += l + 4;
        }
    }
    return le;
};
// write zip header
var wzh = function (d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = exfl(ex);
    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null)
        d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = (f.flag << 1) | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119)
        err(10);
    wbytes(d, b, (y << 25) | ((dt.getMonth() + 1) << 21) | (dt.getDate() << 16) | (dt.getHours() << 11) | (dt.getMinutes() << 5) | (dt.getSeconds() >> 1)), b += 4;
    if (c != -1) {
        wbytes(d, b, f.crc);
        wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        wbytes(d, b + 8, f.size);
    }
    wbytes(d, b + 12, fl);
    wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        wbytes(d, b, col);
        wbytes(d, b + 6, f.attrs);
        wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) {
        for (var k in ex) {
            var exf = ex[k], l = exf.length;
            wbytes(d, b, +k);
            wbytes(d, b + 2, l);
            d.set(exf, b + 4), b += 4 + l;
        }
    }
    if (col)
        d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var wzf = function (o, b, c, d, e) {
    wbytes(o, b, 0x6054B50); // skip disk
    wbytes(o, b + 8, c);
    wbytes(o, b + 10, c);
    wbytes(o, b + 12, d);
    wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */
var ZipPassThrough = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */
    function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */
    ZipPassThrough.prototype.process = function (chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    ZipPassThrough.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final)
            this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}())));

// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */
var ZipDeflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */
    function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts)
            opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new Deflate(opts, function (dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
    }
    ZipDeflate.prototype.process = function (chunk, final) {
        try {
            this.d.push(chunk, final);
        }
        catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    ZipDeflate.prototype.push = function (chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}())));

/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */
var AsyncZipDeflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */
    function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts)
            opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new AsyncDeflate(opts, function (err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function (chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    AsyncZipDeflate.prototype.push = function (chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}())));

// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */
var Zip = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */
    function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */
    Zip.prototype.add = function (file) {
        var _this = this;
        if (!this.ondata)
            err(5);
        // finishing or finished
        if (this.d & 2)
            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = strToU8(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && strToU8(com);
            var u = fl_1 != file.filename.length || (o && (com.length != o.length));
            var hl_1 = fl_1 + exfl(file.extra) + 30;
            if (fl_1 > 65535)
                this.ondata(err(11, 0, 1), null, false);
            var header = new u8(hl_1);
            wzh(header, 0, file, f, u, -1);
            var chks_1 = [header];
            var pAll_1 = function () {
                for (var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++) {
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function () {
                    if (file.terminate)
                        file.terminate();
                },
                r: function () {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt)
                            nxt.r();
                        else
                            _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function (err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                }
                else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new u8(16);
                        wbytes(dd, 0, 0x8074B50);
                        wbytes(dd, 4, file.crc);
                        wbytes(dd, 8, cl_1);
                        wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1)
                            uf_1.r();
                        tr_1 = 1;
                    }
                    else if (tr_1)
                        pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */
    Zip.prototype.end = function () {
        var _this = this;
        if (this.d & 2) {
            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d)
            this.e();
        else
            this.u.push({
                r: function () {
                    if (!(_this.d & 1))
                        return;
                    _this.u.splice(-1, 1);
                    _this.e();
                },
                t: function () { }
            });
        this.d = 3;
    };
    Zip.prototype.e = function () {
        var bt = 0, l = 0, tl = 0;
        for (var _i = 0, _a = this.u; _i < _a.length; _i++) {
            var f = _a[_i];
            tl += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new u8(tl + 22);
        for (var _b = 0, _c = this.u; _b < _c.length; _b++) {
            var f = _c[_b];
            wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */
    Zip.prototype.terminate = function () {
        for (var _i = 0, _a = this.u; _i < _a.length; _i++) {
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}())));

function zip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    var r = {};
    fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function () {
        for (var i = 0; i < term.length; ++i)
            term[i]();
    };
    var cbd = function (a, b) {
        mt(function () { cb(a, b); });
    };
    mt(function () { cbd = cb; });
    var cbf = function () {
        var out = new u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for (var i = 0; i < slft; ++i) {
            var f = files[i];
            try {
                var l = f.c.length;
                wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            }
            catch (e) {
                return cbd(e, null);
            }
        }
        wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft)
        cbf();
    var _loop_1 = function (i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = crc(), size = file.length;
        c.p(file);
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function (e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            }
            else {
                var l = d.length;
                files[i] = mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || (m && (com.length != ms)),
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft)
                    cbf();
            }
        };
        if (s > 65535)
            cbl(err(11, 0, 1), null);
        if (!compression)
            cbl(null, file);
        else if (size < 160000) {
            try {
                cbl(null, deflateSync(file, p));
            }
            catch (e) {
                cbl(e, null);
            }
        }
        else
            term.push(deflate(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for (var i = 0; i < slft; ++i) {
        _loop_1(i);
    }
    return tAll;
}
/**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */
function zipSync(data, opts) {
    if (!opts)
        opts = {};
    var r = {};
    var files = [];
    fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for (var fn in r) {
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        if (s > 65535)
            err(11);
        var d = compression ? deflateSync(file, p) : file, l = d.length;
        var c = crc();
        c.p(file);
        files.push(mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || (m && (com.length != ms)),
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new u8(tot + 22), oe = o, cdl = tot - o;
    for (var i = 0; i < files.length; ++i) {
        var f = files[i];
        wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + exfl(f.extra);
        out.set(f.c, f.o + badd);
        wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */
var UnzipPassThrough = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function UnzipPassThrough() {
    }
    UnzipPassThrough.prototype.push = function (data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}())));

/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */
var UnzipInflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */
    function UnzipInflate() {
        var _this = this;
        this.i = new Inflate(function (dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function (data, final) {
        try {
            this.i.push(data, final);
        }
        catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}())));

/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */
var AsyncUnzipInflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */
    function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) {
            this.i = new Inflate(function (dat, final) {
                _this.ondata(null, dat, final);
            });
        }
        else {
            this.i = new AsyncInflate(function (err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function (data, final) {
        if (this.i.terminate)
            data = slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}())));

/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */
var Unzip = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */
    function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: UnzipPassThrough
        };
        this.p = et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Unzip.prototype.push = function (chunk, final) {
        var _this = this;
        if (!this.onfile)
            err(5);
        if (!this.p)
            err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d)
                this.d.push(toAdd, !this.c);
            else
                this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length)
                return this.push(chunk, final);
        }
        else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length)
                buf = chunk;
            else if (!chunk.length)
                buf = this.p;
            else {
                buf = new u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function () {
                var _a;
                var sig = b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = b2(buf, i + 6), cmp_1 = b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = b2(buf, i + 26), es = b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = b4(buf, i + 18), su_1 = b4(buf, i + 22);
                        var fn_1 = strFromU8(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) {
                            _a = dd ? [-2] : z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        }
                        else if (dd)
                            sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function () {
                                if (!file_1.ondata)
                                    err(5);
                                if (!sc_1)
                                    file_1.ondata(null, et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr)
                                        file_1.ondata(err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function (err, dat, final) { file_1.ondata(err, dat, final); };
                                    for (var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++) {
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c)
                                        _this.d = d_1;
                                    else
                                        d_1.push(et, true);
                                }
                            },
                            terminate: function () {
                                if (d_1 && d_1.terminate)
                                    d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0)
                            file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                }
                else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    }
                    else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for (; i < l - 4; ++i) {
                var state_1 = _loop_2();
                if (state_1 === "break")
                    break;
            }
            this.p = et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - (b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add)
                    add.push(dat, !!f);
                else
                    this.k[+(f == 2)].push(dat);
            }
            if (f & 2)
                return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c)
                err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */
    Unzip.prototype.register = function (decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}())));

var mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function (fn) { fn(); };
function unzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    var term = [];
    var tAll = function () {
        for (var i = 0; i < term.length; ++i)
            term[i]();
    };
    var files = {};
    var cbd = function (a, b) {
        mt(function () { cb(a, b); });
    };
    mt(function () { cbd = cb; });
    var e = data.length - 22;
    for (; b4(data, e) != 0x6054B50; --e) {
        if (!e || data.length - e > 65558) {
            cbd(err(13, 0, 1), null);
            return tAll;
        }
    }
    ;
    var lft = b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = b4(data, e - 12);
            z = b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = b4(data, ze + 32);
                o = b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function (i) {
            var _a = zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
            o = no;
            var cbl = function (e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                }
                else {
                    if (d)
                        files[fn] = d;
                    if (!--lft)
                        cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1)
                    cbl(null, slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) {
                        try {
                            cbl(null, inflateSync(infl, { out: new u8(su) }));
                        }
                        catch (e) {
                            cbl(e, null);
                        }
                    }
                    else
                        term.push(inflate(infl, { size: su }, cbl));
                }
                else
                    cbl(err(14, 'unknown compression type ' + c_1, 1), null);
            }
            else
                cbl(null, null);
        };
        for (var i = 0; i < c; ++i) {
            _loop_3(i);
        }
    }
    else
        cbd(null, {});
    return tAll;
}
/**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @param opts The ZIP extraction options
 * @returns The decompressed files
 */
function unzipSync(data, opts) {
    var files = {};
    var e = data.length - 22;
    for (; b4(data, e) != 0x6054B50; --e) {
        if (!e || data.length - e > 65558)
            err(13);
    }
    ;
    var c = b2(data, e + 8);
    if (!c)
        return {};
    var o = b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = b4(data, e - 12);
        z = b4(data, ze) == 0x6064B50;
        if (z) {
            c = b4(data, ze + 32);
            o = b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for (var i = 0; i < c; ++i) {
        var _a = zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2)
                files[fn] = slc(data, b, b + sc);
            else if (c_2 == 8)
                files[fn] = inflateSync(data.subarray(b, b + sc), { out: new u8(su) });
            else
                err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}

// EXTERNAL MODULE: ./src/cache-render-format/index.ts + 3 modules
var cache_render_format = __webpack_require__(3648);
// EXTERNAL MODULE: ./src/sdk/rendering/CacheRenderBundle.ts
var CacheRenderBundle = __webpack_require__(702);
;// CONCATENATED MODULE: ./src/sdk/rendering/utils/payloadUtils.ts
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};



// Decoded payloads are immutable bundle data, so retain them across model
// invalidations and rapid equipment swaps. Cache promises too, allowing
// concurrent swaps to share one fetch/decode operation. Failed loads are
// evicted so a later attempt can retry.
var decodedPayloadCache = new Map();
function cachedPayload(bundle, assetId) {
    var key = "".concat(bundle.manifest.bundleVersion, ":").concat(assetId);
    var existing = decodedPayloadCache.get(key);
    if (existing)
        return existing;
    var pending = bundle.fetchAsset(assetId).then(decodeCacheRenderPayload);
    decodedPayloadCache.set(key, pending);
    pending.catch(function () {
        if (decodedPayloadCache.get(key) === pending)
            decodedPayloadCache.delete(key);
    });
    return pending;
}
function decodeCacheRenderPayload(bytes) {
    var input = new Uint8Array(bytes);
    if (input.length < 8 || String.fromCharCode(input[0], input[1], input[2], input[3]) !== cache_render_format/* CACHE_RENDER_PAYLOAD_MAGIC */.Pm) {
        throw new CacheRenderBundle/* CacheRenderBundleError */.Bi("manifest", "Invalid cache render binary payload");
    }
    var length = new DataView(bytes).getUint32(4, true);
    if (length !== input.length - 8) {
        throw new CacheRenderBundle/* CacheRenderBundleError */.Bi("manifest", "Truncated cache render binary payload");
    }
    var encoded = input.slice(8);
    // Extracted bundles use gzip for transfer efficiency. Keep accepting raw
    // JSON payloads so existing bundles remain valid.
    if (encoded[0] === 0x1f && encoded[1] === 0x8b)
        encoded = decompressSync(encoded);
    var payload = JSON.parse(new TextDecoder().decode(encoded));
    if (payload.version !== cache_render_format/* CACHE_RENDER_PAYLOAD_VERSION */.o1 || !Array.isArray(payload.positions) || payload.positions.length % 3) {
        throw new CacheRenderBundle/* CacheRenderBundleError */.Bi("manifest", "Unsupported cache render payload schema");
    }
    return payload;
}
function mergePayloads(payloads) {
    var _a, _b, _c;
    var nonEmpty = payloads.filter(function (payload) { var _a, _b; return ((_b = (_a = payload.indices) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 || payload.positions.length > 3; });
    // Mutable references allow concatenation without spread operations, which
    // hit stack limits for large payloads.
    var positions = [];
    var indices = [];
    var vertexGroups = [];
    var alphaGroups = [];
    var sourceVertices = [];
    var animayaGroups = [];
    var animayaScales = [];
    var colors = [];
    var alphas = [];
    var uvs = [];
    var textureIds = [];
    var textures = {};
    var animations = {};
    // Animation metadata may live in a geometry-free shared payload. Collect it
    // independently of the geometry merge so shared player sequences compose
    // with whatever equipment is currently selected.
    payloads.forEach(function (payload) {
        var _a;
        return Object.entries((_a = payload.animations) !== null && _a !== void 0 ? _a : {}).forEach(function (_a) {
            var _b, _c, _d, _e;
            var id = _a[0], animation = _a[1];
            var existing = animations[id];
            if (!existing) {
                animations[id] = { frames: animation.frames.map(function (frame) { return frame.slice(); }), lengths: animation.lengths.slice(), precedenceAnimating: animation.precedenceAnimating, priority: animation.priority, rawFrames: animation.rawFrames, interleaveLeave: animation.interleaveLeave, mayaFrames: animation.mayaFrames, frameSounds: animation.frameSounds, soundsCrossWorldView: animation.soundsCrossWorldView };
            }
            else if (((_b = animation.rawFrames) === null || _b === void 0 ? void 0 : _b.length) && !((_c = existing.rawFrames) === null || _c === void 0 ? void 0 : _c.length)) {
                // Prefer the shared frame-map representation when it is available.
                animations[id] = { frames: animation.frames.map(function (frame) { return frame.slice(); }), lengths: animation.lengths.slice(), precedenceAnimating: animation.precedenceAnimating, priority: animation.priority, rawFrames: animation.rawFrames, interleaveLeave: animation.interleaveLeave, mayaFrames: animation.mayaFrames, frameSounds: animation.frameSounds, soundsCrossWorldView: animation.soundsCrossWorldView };
            }
            else if (!((_d = existing.rawFrames) === null || _d === void 0 ? void 0 : _d.length) && !((_e = animation.rawFrames) === null || _e === void 0 ? void 0 : _e.length)) {
                // Legacy bundles stored baked frames in every item; retain their old
                // composition behavior for those bundles.
                animation.frames.forEach(function (frame, index) {
                    var _a;
                    if (existing.frames[index])
                        (_a = existing.frames[index]).push.apply(_a, frame);
                });
            }
        });
    });
    var vertexOffset = 0;
    var sourceVertexOffset = 0;
    nonEmpty.forEach(function (payload) {
        var _a, _b, _c, _d, _e;
        var localVertexCount = payload.positions.length / 3;
        positions = positions.concat(payload.positions);
        if (payload.colors)
            colors = colors.concat(payload.colors);
        if (payload.alphas)
            alphas = alphas.concat(payload.alphas);
        else
            alphas = alphas.concat(Array(localVertexCount).fill(0));
        if (payload.uvs)
            uvs = uvs.concat(payload.uvs);
        if (payload.textureIds)
            textureIds = textureIds.concat(payload.textureIds);
        Object.assign(textures, (_a = payload.textures) !== null && _a !== void 0 ? _a : {});
        var localSources = ((_b = payload.sourceVertices) === null || _b === void 0 ? void 0 : _b.length) === localVertexCount
            ? payload.sourceVertices
            : (function () {
                // Bundles extracted before sourceVertices existed can only recover
                // identity from bind-pose coordinates. Keep that recovery local to an
                // equipment payload so coincident vertices in separate items are never
                // accidentally treated as one animation vertex.
                var ids = [], byPosition = new Map();
                for (var index = 0; index < localVertexCount; index++) {
                    var key = "".concat(payload.positions[index * 3], ",").concat(payload.positions[index * 3 + 1], ",").concat(payload.positions[index * 3 + 2]);
                    var source = byPosition.get(key);
                    if (source == null) {
                        source = byPosition.size;
                        byPosition.set(key, source);
                    }
                    ids.push(source);
                }
                return ids;
            })();
        sourceVertices = sourceVertices.concat(localSources.map(function (index) { return index + sourceVertexOffset; }));
        animayaGroups = animayaGroups.concat(Array.from({ length: localVertexCount }, function (_, index) { var _a, _b; return (_b = (_a = payload.animayaGroups) === null || _a === void 0 ? void 0 : _a[index]) !== null && _b !== void 0 ? _b : []; }));
        animayaScales = animayaScales.concat(Array.from({ length: localVertexCount }, function (_, index) { var _a, _b; return (_b = (_a = payload.animayaScales) === null || _a === void 0 ? void 0 : _a[index]) !== null && _b !== void 0 ? _b : []; }));
        sourceVertexOffset += Math.max(localVertexCount, localSources.reduce(function (max, index) { return Math.max(max, index + 1); }, 0));
        var localIndices = (_c = payload.indices) !== null && _c !== void 0 ? _c : Array.from({ length: payload.positions.length / 3 }, function (_, index) { return index; });
        indices = indices.concat(localIndices.map(function (index) { return index + vertexOffset; }));
        vertexOffset += payload.positions.length / 3;
        ((_d = payload.vertexGroups) !== null && _d !== void 0 ? _d : []).forEach(function (group, groupIndex) {
            var _a;
            var _b;
            (_b = vertexGroups[groupIndex]) !== null && _b !== void 0 ? _b : (vertexGroups[groupIndex] = []);
            (_a = vertexGroups[groupIndex]).push.apply(_a, group.map(function (index) { return index + vertexOffset - payload.positions.length / 3; }));
        });
        ((_e = payload.alphaGroups) !== null && _e !== void 0 ? _e : []).forEach(function (group, groupIndex) {
            var _a;
            var _b;
            (_b = alphaGroups[groupIndex]) !== null && _b !== void 0 ? _b : (alphaGroups[groupIndex] = []);
            (_a = alphaGroups[groupIndex]).push.apply(_a, group.map(function (index) { return index + vertexOffset - payload.positions.length / 3; }));
        });
    });
    return {
        version: cache_render_format/* CACHE_RENDER_PAYLOAD_VERSION */.o1,
        positions: positions,
        indices: indices,
        vertexGroups: vertexGroups,
        alphaGroups: alphaGroups,
        sourceVertices: sourceVertices,
        animayaGroups: animayaGroups,
        animayaScales: animayaScales,
        colors: colors.length ? colors : undefined,
        alphas: alphas.length ? alphas : undefined,
        uvs: uvs.length ? uvs : undefined,
        textureIds: textureIds.length ? textureIds : undefined,
        textures: Object.keys(textures).length ? textures : undefined,
        color: (_a = nonEmpty[0]) === null || _a === void 0 ? void 0 : _a.color,
        scale: (_b = nonEmpty[0]) === null || _b === void 0 ? void 0 : _b.scale,
        animations: animations,
        poseMap: Object.assign.apply(Object, __spreadArray([{}], payloads.map(function (payload) { var _a; return (_a = payload.poseMap) !== null && _a !== void 0 ? _a : {}; }), false)),
        geometryClickbox: (_c = payloads.find(function (payload) { return payload.geometryClickbox; })) === null || _c === void 0 ? void 0 : _c.geometryClickbox,
    };
}


/***/ }),

/***/ 8648:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: () => (/* binding */ DEFAULT_OSRS_ASSET_BASE_URL),
/* harmony export */   s: () => (/* binding */ Assets)
/* harmony export */ });
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/** Public CDN used by default for GLB and UI assets. Build-time configuration
 * can still override this for a development or self-hosted deployment. */
var DEFAULT_OSRS_ASSET_BASE_URL = "https://assets-soltrainer.netlify.app";
var Assets = /** @class */ (function () {
    function Assets() {
    }
    /**
     * Returns the appropriate URL for an asset and also schedules it for preloading.
     */
    Assets.getAssetUrl = function (asset) {
        var _this = this;
        var configuredBaseUrl =  true
            ? ""
            : 0;
        var baseUrl = configuredBaseUrl || DEFAULT_OSRS_ASSET_BASE_URL;
        var url = "".concat(baseUrl.replace(/\/$/, ""), "/").concat(asset);
        if (Assets.loadedAssets[url]) {
            return url;
        }
        Assets.loadingAssetUrls.push(url);
        Assets.assetCount++;
        Promise.resolve().then(function () { return __awaiter(_this, void 0, void 0, function () {
            var response, bytes;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.debug("Preloading asset: ".concat(url));
                        return [4 /*yield*/, fetch(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.arrayBuffer()];
                    case 2:
                        bytes = _a.sent();
                        console.debug("Preloaded asset: ".concat(url, ", ").concat(response.statusText, ": ").concat(bytes.byteLength));
                        Assets.onProgressFns.forEach(function (onProgressFns) {
                            return onProgressFns(_this.assetCount - _this.loadingAssetUrls.length, _this.assetCount);
                        });
                        Assets.loadingAssetUrls = this.loadingAssetUrls.filter(function (u) { return u !== url; });
                        Assets.loadedAssets[url] = true;
                        return [2 /*return*/];
                }
            });
        }); });
        return url;
    };
    Assets.onAssetProgress = function (progressFn) {
        Assets.onProgressFns.push(progressFn);
        return function () {
            Assets.onProgressFns = Assets.onProgressFns.filter(function (listener) { return listener !== progressFn; });
        };
    };
    Assets.onAllAssetsLoaded = function (loadFn) {
        Assets.onLoadFns.push(loadFn);
        return function () {
            Assets.onLoadFns = Assets.onLoadFns.filter(function (listener) { return listener !== loadFn; });
        };
    };
    Assets.checkAssetsLoaded = function (timer) {
        if (Assets.loadingAssetUrls.length === 0) {
            Assets.onLoadFns.forEach(function (onLoadFunction) { return onLoadFunction(); });
            clearInterval(timer);
        }
    };
    Assets.assetCount = 0;
    Assets.loadingAssetUrls = [];
    Assets.onProgressFns = [];
    Assets.onLoadFns = [];
    Assets.loadedAssets = {};
    return Assets;
}());



/***/ }),

/***/ 5164:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: () => (/* binding */ ChunkUtils),
/* harmony export */   O: () => (/* binding */ CHUNK_SIZE)
/* harmony export */ });
/** Width and height of a RuneScape map chunk in tiles. */
var CHUNK_SIZE = 8;
var ChunkUtils = /** @class */ (function () {
    function ChunkUtils() {
    }
    ChunkUtils.fromLocation = function (location) {
        return {
            x: Math.floor(location.x / CHUNK_SIZE),
            y: Math.floor(location.y / CHUNK_SIZE),
        };
    };
    ChunkUtils.equals = function (first, second) {
        return first.x === second.x && first.y === second.y;
    };
    /**
     * Return the 3x3 chunk search order used by the client for NPC priority.
     *
     * SDK Y coordinates increase southward, so north is y - 1. The resulting
     * order is NE -> SW, column-major: the east column north-to-south, then the
     * centre column, then the west column.
     */
    ChunkUtils.priorityGridOrder = function (center) {
        return [
            { x: center.x + 1, y: center.y - 1 },
            { x: center.x + 1, y: center.y },
            { x: center.x + 1, y: center.y + 1 },
            { x: center.x, y: center.y - 1 },
            { x: center.x, y: center.y },
            { x: center.x, y: center.y + 1 },
            { x: center.x - 1, y: center.y - 1 },
            { x: center.x - 1, y: center.y },
            { x: center.x - 1, y: center.y + 1 },
        ];
    };
    return ChunkUtils;
}());



/***/ }),

/***/ 2987:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: () => (/* binding */ ImageLoader)
/* harmony export */ });
var ImageLoader = /** @class */ (function () {
    function ImageLoader() {
    }
    ImageLoader.createImage = function (src) {
        if (!src) {
            return null;
        }
        if (this.imageCache[src]) {
            return this.imageCache[src];
        }
        ImageLoader.pendingImages++;
        var img = new Image();
        img.src = src;
        img.addEventListener("load", function () {
            ImageLoader.completedImages++;
        });
        img.addEventListener("error", function () {
            ImageLoader.completedImages++;
        });
        this.imageCache[src] = img;
        return img;
    };
    ImageLoader.onAllImagesLoaded = function (loadFn) {
        ImageLoader.onLoadFns.push(loadFn);
        return function () {
            ImageLoader.onLoadFns = ImageLoader.onLoadFns.filter(function (listener) { return listener !== loadFn; });
        };
    };
    ImageLoader.checkImagesLoaded = function (timer) {
        if (ImageLoader.pendingImages === ImageLoader.completedImages) {
            ImageLoader.onLoadFns.forEach(function (onLoadFunction) { return onLoadFunction(); });
            clearInterval(timer);
        }
    };
    ImageLoader.onLoadFns = [];
    ImageLoader.pendingImages = 0;
    ImageLoader.completedImages = 0;
    ImageLoader.hasLoaded = false;
    ImageLoader.imageCache = {};
    return ImageLoader;
}());



/***/ }),

/***/ 6018:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ Sound),
/* harmony export */   U: () => (/* binding */ SoundCache)
/* harmony export */ });
/* harmony import */ var _Settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8406);
/* harmony import */ var _audio_CacheSoundEffects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5432);
/* harmony import */ var _rendering_CacheRenderBundle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(702);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var Sound = /** @class */ (function () {
    function Sound(src, volume, delayMs, area) {
        if (volume === void 0) { volume = 1; }
        if (delayMs === void 0) { delayMs = 0; }
        this.src = src;
        this.volume = volume;
        this.delayMs = delayMs;
        this.area = area;
    }
    return Sound;
}());

var SoundCache = /** @class */ (function () {
    function SoundCache() {
    }
    SoundCache.setAudioListener = function (listener) {
        this.audioListener = listener;
    };
    SoundCache.getCachedSound = function (src) {
        if (!src) {
            return null;
        }
        if (this.soundCache[src]) {
            return this.soundCache[src];
        }
        return (this.soundCache[src] = new Audio(src));
    };
    SoundCache.preload = function (src) {
        return __awaiter(this, void 0, void 0, function () {
            var pending;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!SoundCache.context) {
                            return [2 /*return*/, null];
                        }
                        // Do not try to load cache sounds until the cache renderer is configured.
                        if ((0,_audio_CacheSoundEffects__WEBPACK_IMPORTED_MODULE_1__/* .isCacheSound */ .w5)(src) && !_rendering_CacheRenderBundle__WEBPACK_IMPORTED_MODULE_2__/* .CacheRender */ .j9.isConfigured()) {
                            return [2 /*return*/, null];
                        }
                        if (SoundCache.cachedSounds[src])
                            return [2 /*return*/, SoundCache.cachedSounds[src]];
                        if (SoundCache.loadingSounds[src])
                            return [2 /*return*/, SoundCache.loadingSounds[src]];
                        pending = (function () { return __awaiter(_this, void 0, void 0, function () {
                            var audioBuffer, raw, channel, i, response, buffer;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(0,_audio_CacheSoundEffects__WEBPACK_IMPORTED_MODULE_1__/* .isCacheSound */ .w5)(src)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, (0,_audio_CacheSoundEffects__WEBPACK_IMPORTED_MODULE_1__/* .synthesizeCacheSound */ .Uz)(src)];
                                    case 1:
                                        raw = _a.sent();
                                        audioBuffer = SoundCache.context.createBuffer(1, raw.samples.length, raw.sampleRate);
                                        channel = audioBuffer.getChannelData(0);
                                        for (i = 0; i < raw.samples.length; i++)
                                            channel[i] = raw.samples[i] / 128;
                                        return [3 /*break*/, 6];
                                    case 2: return [4 /*yield*/, window.fetch(src)];
                                    case 3:
                                        response = _a.sent();
                                        return [4 /*yield*/, response.arrayBuffer()];
                                    case 4:
                                        buffer = _a.sent();
                                        return [4 /*yield*/, SoundCache.context.decodeAudioData(buffer)];
                                    case 5:
                                        audioBuffer = _a.sent();
                                        _a.label = 6;
                                    case 6:
                                        SoundCache.cachedSounds[src] = audioBuffer;
                                        return [2 /*return*/, audioBuffer];
                                }
                            });
                        }); })();
                        SoundCache.loadingSounds[src] = pending;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, pending];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        if (SoundCache.loadingSounds[src] === pending)
                            delete SoundCache.loadingSounds[src];
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SoundCache.play = function (sound, isAreaSound) {
        var _this = this;
        if (isAreaSound === void 0) { isAreaSound = Boolean(sound.area); }
        if (!SoundCache.context) {
            return null;
        }
        var src = sound.src, volume = sound.volume, delayMs = sound.delayMs;
        if (this.cachedSounds[src] === undefined) {
            (function () { return __awaiter(_this, void 0, void 0, function () {
                var loadedSound;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.preload(src)];
                        case 1:
                            loadedSound = _a.sent();
                            // play after loading
                            if (loadedSound) {
                                SoundCache.play(new Sound(src, volume, delayMs, sound.area), isAreaSound);
                            }
                            return [2 /*return*/];
                    }
                });
            }); })();
            return;
        }
        if (!this.cachedSounds[src]) {
            return;
        }
        if ((!isAreaSound && !_Settings__WEBPACK_IMPORTED_MODULE_0__/* .Settings */ .w.playsAudio) || (isAreaSound && !_Settings__WEBPACK_IMPORTED_MODULE_0__/* .Settings */ .w.playsAreaAudio)) {
            return;
        }
        if (delayMs > 0) {
            setTimeout(function () {
                SoundCache.play(new Sound(src, volume, 0, sound.area), isAreaSound);
            }, delayMs);
            return;
        }
        var effectiveVolume = isAreaSound ? this.areaVolume(sound) : volume;
        if (effectiveVolume <= 0)
            return;
        var source = SoundCache.context.createBufferSource();
        source.buffer = this.cachedSounds[src];
        var connect = SoundCache.context.destination;
        if (effectiveVolume !== 1) {
            var gainNode = SoundCache.context.createGain();
            gainNode.gain.value = effectiveVolume;
            source.connect(gainNode);
            gainNode.connect(SoundCache.context.destination);
            connect = gainNode;
        }
        source.connect(connect);
        source.start();
    };
    SoundCache.areaVolume = function (sound) {
        var _a;
        var area = sound.area;
        var listener = (_a = this.audioListener) === null || _a === void 0 ? void 0 : _a.location;
        if (!area || !listener)
            return sound.volume;
        // This is the reference client's Manhattan tile-distance calculation in
        // its 128-units-per-tile representation. The source range is inclusive;
        // retain defines the full-volume inner radius.
        var range = Math.max(0, area.range) * 128;
        var retain = Math.max(0, (Math.max(0, area.retain) - 1) * 128);
        var distance = Math.max((Math.abs(area.location.x - listener.x) + Math.abs(area.location.y - listener.y)) * 128 - 128, 0);
        if (distance >= range)
            return 0;
        var denominator = range - retain;
        var attenuation = denominator > 0
            ? Math.min(Math.max((range - distance) / denominator, 0), 1)
            : 1;
        return sound.volume * attenuation;
    };
    SoundCache.soundCache = {};
    // Kept as a reference so movement is reflected automatically. Trainer wires
    // this to Trainer.player when the active viewport player is installed.
    SoundCache.audioListener = null;
    SoundCache.context = window.AudioContext ? new AudioContext() : null;
    SoundCache.cachedSounds = {};
    SoundCache.loadingSounds = {};
    return SoundCache;
}());



/***/ }),

/***/ 3462:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: () => (/* binding */ parseText)
/* harmony export */ });
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var parseText = function (text) {
    var segments = [];
    var currentSegment = { text: "", tag: null, inTag: false };
    for (var i = 0; i < text.length; i++) {
        if (text[i] === "<" && !currentSegment.inTag) {
            if (currentSegment.text) {
                segments.push(currentSegment);
            }
            currentSegment = { text: "", tag: "", inTag: true };
        }
        else if (text[i] === "/") {
            // closing tag
            if (currentSegment.text) {
                segments.push(currentSegment);
            }
        }
        else if (text[i] === ">") {
            currentSegment.inTag = false;
        }
        else if (currentSegment.inTag) {
            currentSegment.tag += text[i];
        }
        else {
            currentSegment.text += text[i];
        }
    }
    if (currentSegment.text) {
        segments.push(currentSegment);
    }
    return segments.map(function (_a) {
        var text = _a.text, tag = _a.tag;
        var color = parseColor(tag);
        return __assign({ text: text }, (color && { color: color }));
    });
};
var parseColor = function (tag) { var _a; return ((tag === null || tag === void 0 ? void 0 : tag.includes("col=")) ? (_a = tag.split("=")) === null || _a === void 0 ? void 0 : _a[1] : null); };


/***/ }),

/***/ 9156:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Om: () => (/* binding */ CLIENT_CYCLE_MS),
/* harmony export */   ZC: () => (/* binding */ CLIENT_CYCLES_PER_SECOND),
/* harmony export */   xZ: () => (/* binding */ CLIENT_UNITS_PER_TILE)
/* harmony export */ });
/** The game client represents one world tile as 128 local coordinate units. */
var CLIENT_UNITS_PER_TILE = 128;
/** Number of client update cycles processed per second. */
var CLIENT_CYCLES_PER_SECOND = 50;
/** Duration of one client update cycle in milliseconds. */
var CLIENT_CYCLE_MS = 1000 / CLIENT_CYCLES_PER_SECOND;


/***/ }),

/***/ 3891:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   v: () => (/* binding */ BarrageSpell)
/* harmony export */ });
/* harmony import */ var _Pathing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5454);
/* harmony import */ var _MagicWeapon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5550);
/* harmony import */ var _XpDrop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3422);
/* harmony import */ var _AttackStylesController__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var BarrageSpell = /** @class */ (function (_super) {
    __extends(BarrageSpell, _super);
    function BarrageSpell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BarrageSpell.prototype, "aoe", {
        get: function () {
            return [
                { x: 0, y: 0 },
                { x: -1, y: -1 },
                { x: -1, y: 0 },
                { x: -1, y: 1 },
                { x: 0, y: -1 },
                { x: 0, y: 1 },
                { x: 1, y: -1 },
                { x: 1, y: 0 },
                { x: 1, y: 1 },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarrageSpell.prototype, "attackRange", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarrageSpell.prototype, "attackSpeed", {
        get: function () {
            return 5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarrageSpell.prototype, "maxConcurrentHits", {
        get: function () {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    BarrageSpell.prototype.attackStyle = function () {
        return _AttackStylesController__WEBPACK_IMPORTED_MODULE_3__/* .AttackStyle */ .aF.AUTOCAST;
    };
    BarrageSpell.prototype.cast = function (from, to) {
        var _this = this;
        from.grantXp(new _XpDrop__WEBPACK_IMPORTED_MODULE_2__/* .XpDrop */ .i("magic", 52));
        // calculate AoE magic effects
        if (this.aoe.length) {
            var alreadyCastedOn_1 = [to];
            this.attack(from, to, { magicBaseSpellDamage: 30, attackStyle: "magic" });
            this.aoe.forEach(function (point) {
                _Pathing__WEBPACK_IMPORTED_MODULE_0__/* .Pathing */ .G.mobsAtAoeOffset(from.region, to, point).forEach(function (mob) {
                    if (alreadyCastedOn_1.length > _this.maxConcurrentHits) {
                        return;
                    }
                    if (alreadyCastedOn_1.indexOf(mob) > -1) {
                        return;
                    }
                    alreadyCastedOn_1.push(mob);
                    _this.attack(from, mob, { magicBaseSpellDamage: 30, attackStyle: "magic" }, {
                        visuals: { hidden: true },
                    });
                });
            });
        }
        else {
            this.attack(from, to, { magicBaseSpellDamage: 30, attackStyle: "magic" });
        }
    };
    BarrageSpell.prototype.attack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        options.forceSWTile = true;
        return _super.prototype.attack.call(this, from, to, bonuses, options);
    };
    return BarrageSpell;
}(_MagicWeapon__WEBPACK_IMPORTED_MODULE_1__/* .MagicWeapon */ .u));



/***/ }),

/***/ 8603:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: () => (/* binding */ BloodBarrageSpell)
/* harmony export */ });
/* harmony import */ var _BarrageSpell__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3891);
/* harmony import */ var _ItemName__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(243);
/* harmony import */ var _utils_SoundCache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6018);
/* harmony import */ var _audio_CacheSoundEffects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5432);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4655);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var BloodBarrageSpell = /** @class */ (function (_super) {
    __extends(BloodBarrageSpell, _super);
    function BloodBarrageSpell(projectileRules) {
        var _this = _super.call(this, projectileRules) || this;
        _utils_SoundCache__WEBPACK_IMPORTED_MODULE_2__/* .SoundCache */ .U.preload(_this.attackSound.src);
        _utils_SoundCache__WEBPACK_IMPORTED_MODULE_2__/* .SoundCache */ .U.preload(_this.attackLandingSound.src);
        return _this;
    }
    Object.defineProperty(BloodBarrageSpell.prototype, "attackSound", {
        get: function () {
            return new _utils_SoundCache__WEBPACK_IMPORTED_MODULE_2__/* .Sound */ .A((0,_audio_CacheSoundEffects__WEBPACK_IMPORTED_MODULE_3__/* .cacheSound */ .cp)(_assets_CacheAssets__WEBPACK_IMPORTED_MODULE_4__/* .CACHE_ASSETS */ .fc.sounds.bloodBarrageCast.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BloodBarrageSpell.prototype, "attackLandingSound", {
        get: function () {
            return new _utils_SoundCache__WEBPACK_IMPORTED_MODULE_2__/* .Sound */ .A((0,_audio_CacheSoundEffects__WEBPACK_IMPORTED_MODULE_3__/* .cacheSound */ .cp)(_assets_CacheAssets__WEBPACK_IMPORTED_MODULE_4__/* .CACHE_ASSETS */ .fc.sounds.bloodBarrageImpact.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BloodBarrageSpell.prototype, "itemName", {
        get: function () {
            return _ItemName__WEBPACK_IMPORTED_MODULE_1__/* .ItemName */ .P.BLOOD_BARRAGE;
        },
        enumerable: false,
        configurable: true
    });
    BloodBarrageSpell.prototype.attack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        _super.prototype.attack.call(this, from, to, bonuses, options);
        if (from.currentStats.hitpoint < from.stats.hitpoint) {
            from.currentStats.hitpoint += Math.floor(this.damageRoll * 0.25);
            from.currentStats.hitpoint = Math.max(Math.min(from.stats.hitpoint, from.currentStats.hitpoint), 0);
        }
        return true;
    };
    return BloodBarrageSpell;
}(_BarrageSpell__WEBPACK_IMPORTED_MODULE_0__/* .BarrageSpell */ .v));



/***/ }),

/***/ 5550:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   u: () => (/* binding */ MagicWeapon)
/* harmony export */ });
/* harmony import */ var _Unit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3016);
/* harmony import */ var _gear_Weapon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6103);
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3107);
/* harmony import */ var _BasePrayer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(165);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var MagicWeapon = /** @class */ (function (_super) {
    __extends(MagicWeapon, _super);
    function MagicWeapon(projectileRules) {
        return _super.call(this, projectileRules) || this;
    }
    Object.defineProperty(MagicWeapon.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_2__/* .EquipmentTypes */ .WA.WEAPON;
        },
        enumerable: false,
        configurable: true
    });
    MagicWeapon.prototype.attack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        return _super.prototype.attack.call(this, from, to, bonuses, options);
    };
    MagicWeapon.prototype.calculateHitDelay = function (distance) {
        return Math.floor((1 + distance) / 3) + 1;
    };
    MagicWeapon.prototype.isBlockable = function (from, to, bonuses) {
        this._calculatePrayerEffects(from, to, bonuses);
        if (bonuses.effectivePrayers.overhead && bonuses.effectivePrayers.overhead.feature() === "magic") {
            return true;
        }
        return false;
    };
    MagicWeapon.prototype._calculatePrayerEffects = function (from, to, bonuses) {
        bonuses.effectivePrayers = {};
        if (from.type !== _Unit__WEBPACK_IMPORTED_MODULE_0__/* .UnitTypes */ .eK.MOB && from.prayerController) {
            var offensiveMagic = from.prayerController.matchGroup(_BasePrayer__WEBPACK_IMPORTED_MODULE_3__/* .PrayerGroups */ .u.ACCURACY);
            if (offensiveMagic) {
                bonuses.effectivePrayers.magic = offensiveMagic;
            }
        }
        if (to.type !== _Unit__WEBPACK_IMPORTED_MODULE_0__/* .UnitTypes */ .eK.MOB && to.prayerController) {
            var defence = to.prayerController.matchGroup(_BasePrayer__WEBPACK_IMPORTED_MODULE_3__/* .PrayerGroups */ .u.DEFENCE);
            if (defence) {
                bonuses.effectivePrayers.defence = defence;
            }
            var overhead = to.prayerController.overhead();
            if (overhead) {
                bonuses.effectivePrayers.overhead = overhead;
            }
        }
    };
    MagicWeapon.prototype._magicLevel = function (from, to, bonuses) {
        var prayerMultiplier = 1;
        var magicPrayer = bonuses.effectivePrayers.magic;
        if (magicPrayer) {
            if (magicPrayer.name === "Mystic Will") {
                prayerMultiplier = 1.05;
            }
            else if (magicPrayer.name === "Mystic Lore") {
                prayerMultiplier = 1.1;
            }
            else if (magicPrayer.name === "Mystic Might") {
                prayerMultiplier = 1.15;
            }
            else if (magicPrayer.name === "Augury") {
                prayerMultiplier = 1.2;
            }
        }
        return Math.floor(Math.floor(from.currentStats.magic * prayerMultiplier) * bonuses.voidMultiplier +
            (bonuses.isAccurate ? 2 : 0) +
            9);
    };
    MagicWeapon.prototype._equipmentBonus = function (from, to, bonuses) {
        return from.bonuses.attack.magic;
    };
    MagicWeapon.prototype._magicDamageBonusMultiplier = function (from, to, bonuses) {
        return from.bonuses.other.magicDamage;
    };
    MagicWeapon.prototype._attackRoll = function (from, to, bonuses) {
        return Math.floor(this._magicLevel(from, to, bonuses) * (this._equipmentBonus(from, to, bonuses) + 64) * bonuses.gearMageMultiplier);
    };
    MagicWeapon.prototype._defenceRoll = function (from, to, bonuses) {
        var prayerMultiplier = 1;
        var defencePrayer = bonuses.effectivePrayers.defence;
        if (defencePrayer) {
            if (defencePrayer.name === "Thick Skin") {
                prayerMultiplier = 1.05;
            }
            else if (defencePrayer.name === "Mystic Will") {
                prayerMultiplier = 1.05;
            }
            else if (defencePrayer.name === "Rock Skin") {
                prayerMultiplier = 1.1;
            }
            else if (defencePrayer.name === "Mystic Lore") {
                prayerMultiplier = 1.1;
            }
            else if (defencePrayer.name === "Steel Skin") {
                prayerMultiplier = 1.15;
            }
            else if (defencePrayer.name === "Mystic Might") {
                prayerMultiplier = 1.15;
            }
            else if (defencePrayer.name === "Chivalry") {
                prayerMultiplier = 1.2;
            }
            else if (defencePrayer.name === "Piety") {
                prayerMultiplier = 1.25;
            }
            else if (defencePrayer.name === "Rigour") {
                prayerMultiplier = 1.25;
            }
            else if (defencePrayer.name === "Augury") {
                prayerMultiplier = 1.25;
            }
        }
        return (9 + to.currentStats.magic * prayerMultiplier) * (to.bonuses.defence.magic + 64);
    };
    MagicWeapon.prototype._maxHit = function (from, to, bonuses) {
        return Math.floor(this._baseSpellDamage(from, to, bonuses) * this._magicDamageBonusMultiplier(from, to, bonuses));
        // TODO: Most of this isn't implemented
        // Spell Base damage +3 if casting bolt spells with chaos gauntlets
        // Answer * (1 + magic damage bonus)
        // Round the answer down to the nearest integer
        // Answer * salve amulet bonus (Salve bonus does not stack with slayer bonus, skip to step 7 if using salve amulet)
        // Round the answer down to the nearest integer
        // Answer * slayer bonus
        // Round the answer down to the nearest integer
        // Answer * Tome of fire bonus
        // Round the answer down to the nearest integer
        // Answer * castle wars bonus
        // Round the answer down to the nearest integer
        // That is the max hit
    };
    MagicWeapon.prototype._baseSpellDamage = function (from, to, bonuses) {
        return bonuses.magicBaseSpellDamage; // Jal-Zek specific number for now.
    };
    return MagicWeapon;
}(_gear_Weapon__WEBPACK_IMPORTED_MODULE_1__/* .Weapon */ .R));



/***/ }),

/***/ 8109:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: () => (/* binding */ MeleeWeapon)
/* harmony export */ });
/* harmony import */ var _AttackStylesController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(186);
/* harmony import */ var _BasePrayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(165);
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3107);
/* harmony import */ var _gear_Weapon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6103);
/* harmony import */ var _Unit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3016);
/* harmony import */ var _Projectile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2402);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4655);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var MeleeWeapon = /** @class */ (function (_super) {
    __extends(MeleeWeapon, _super);
    function MeleeWeapon(projectileOptions) {
        if (projectileOptions === void 0) { projectileOptions = {}; }
        return _super.call(this, (0,_Projectile__WEBPACK_IMPORTED_MODULE_5__/* .mergeProjectileOptions */ .K7)({ visuals: { hidden: true } }, projectileOptions)) || this;
    }
    Object.defineProperty(MeleeWeapon.prototype, "equipSoundId", {
        get: function () {
            return _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_6__/* .CACHE_ASSETS */ .fc.sounds.equipSword.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeleeWeapon.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_2__/* .EquipmentTypes */ .WA.WEAPON;
        },
        enumerable: false,
        configurable: true
    });
    MeleeWeapon.prototype.attack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        bonuses.attackStyle = bonuses.attackStyle || "slash";
        return _super.prototype.attack.call(this, from, to, bonuses, options);
    };
    MeleeWeapon.prototype._calculatePrayerEffects = function (from, to, bonuses) {
        bonuses.effectivePrayers = {};
        if (from.type !== _Unit__WEBPACK_IMPORTED_MODULE_4__/* .UnitTypes */ .eK.MOB && from.prayerController) {
            var offensiveAttack = from.prayerController.matchGroup(_BasePrayer__WEBPACK_IMPORTED_MODULE_1__/* .PrayerGroups */ .u.ACCURACY);
            if (offensiveAttack) {
                bonuses.effectivePrayers.attack = offensiveAttack;
            }
            var offensiveStrength = from.prayerController.matchGroup(_BasePrayer__WEBPACK_IMPORTED_MODULE_1__/* .PrayerGroups */ .u.STRENGTH);
            if (offensiveStrength) {
                bonuses.effectivePrayers.strength = offensiveStrength;
            }
        }
        if (to.type !== _Unit__WEBPACK_IMPORTED_MODULE_4__/* .UnitTypes */ .eK.MOB && to.prayerController) {
            var defence = to.prayerController.matchGroup(_BasePrayer__WEBPACK_IMPORTED_MODULE_1__/* .PrayerGroups */ .u.DEFENCE);
            if (defence) {
                bonuses.effectivePrayers.defence = defence;
            }
            var overhead = to.prayerController.overhead();
            if (overhead) {
                bonuses.effectivePrayers.overhead = overhead;
            }
        }
    };
    MeleeWeapon.prototype.isBlockable = function (from, to, bonuses) {
        this._calculatePrayerEffects(from, to, bonuses);
        var prayerAttackBlockStyle = bonuses.attackStyle;
        if (_gear_Weapon__WEBPACK_IMPORTED_MODULE_3__/* .Weapon */ .R.isMeleeAttackStyle(prayerAttackBlockStyle)) {
            prayerAttackBlockStyle = "melee"; // because protect melee scans for the style as melee, generalize them
        }
        if (bonuses.effectivePrayers.overhead && bonuses.effectivePrayers.overhead.feature() === prayerAttackBlockStyle) {
            return true;
        }
        return false;
    };
    MeleeWeapon.prototype._strengthLevel = function (from, to, bonuses) {
        var prayerMultiplier = 1;
        var strengthPrayer = bonuses.effectivePrayers.strength;
        if (strengthPrayer) {
            if (strengthPrayer.name === "Burst of Strength") {
                prayerMultiplier = 1.05;
            }
            else if (strengthPrayer.name === "Superhuman Strength") {
                prayerMultiplier = 1.1;
            }
            else if (strengthPrayer.name === "Ultimate Strength") {
                prayerMultiplier = 1.15;
            }
            else if (strengthPrayer.name === "Chivalry") {
                prayerMultiplier = 1.18;
            }
            else if (strengthPrayer.name === "Piety") {
                prayerMultiplier = 1.23;
            }
        }
        if (from.type === _Unit__WEBPACK_IMPORTED_MODULE_4__/* .UnitTypes */ .eK.PLAYER) {
            bonuses.styleStrengthBonus = _AttackStylesController__WEBPACK_IMPORTED_MODULE_0__/* .AttackStylesController */ .D2.controller.getWeaponStrengthBonus(this.attackStyle());
        }
        else {
            bonuses.styleStrengthBonus = 0;
        }
        return Math.floor((Math.floor(from.currentStats.strength * prayerMultiplier) + bonuses.styleStrengthBonus + 8) * bonuses.voidMultiplier);
    };
    MeleeWeapon.prototype._maxHit = function (from, to, bonuses) {
        return Math.floor(Math.floor((this._strengthLevel(from, to, bonuses) * (from.bonuses.other.meleeStrength + 64) + 320) / 640) *
            bonuses.gearMeleeMultiplier *
            bonuses.overallMultiplier);
    };
    MeleeWeapon.prototype._attackLevel = function (from, to, bonuses) {
        var attackPrayer = bonuses.effectivePrayers.attack;
        var prayerMultiplier = 1;
        if (attackPrayer) {
            if (attackPrayer.name === "Clarity of Thought") {
                prayerMultiplier = 1.05;
            }
            else if (attackPrayer.name === "Improved Reflexes") {
                prayerMultiplier = 1.1;
            }
            else if (attackPrayer.name === "Incredible Reflexes") {
                prayerMultiplier = 1.15;
            }
            else if (attackPrayer.name === "Chivalry") {
                prayerMultiplier = 1.15;
            }
            else if (attackPrayer.name === "Piety") {
                prayerMultiplier = 1.2;
            }
        }
        return Math.floor((Math.floor(from.currentStats.attack * prayerMultiplier) + bonuses.styleBonus + 8) * bonuses.voidMultiplier);
    };
    MeleeWeapon.prototype._attackRoll = function (from, to, bonuses) {
        return Math.floor(this._attackLevel(from, to, bonuses) *
            (from.bonuses.attack[bonuses.attackStyle] + 64) *
            bonuses.gearMeleeMultiplier);
    };
    MeleeWeapon.prototype._defenceRoll = function (from, to, bonuses) {
        if (to.type === _Unit__WEBPACK_IMPORTED_MODULE_4__/* .UnitTypes */ .eK.MOB || to.type === _Unit__WEBPACK_IMPORTED_MODULE_4__/* .UnitTypes */ .eK.ENTITY) {
            return (to.currentStats.defence + 9) * (to.bonuses.defence[bonuses.attackStyle] + 64);
        }
        else {
            return this._defenceLevel(from, to, bonuses) * (to.bonuses.defence[bonuses.attackStyle] + 64);
        }
    };
    MeleeWeapon.prototype._defenceLevel = function (from, to, bonuses) {
        var defencePrayer = bonuses.effectivePrayers.defence;
        var prayerMultiplier = 1;
        if (defencePrayer) {
            if (defencePrayer.name === "Thick Skin") {
                prayerMultiplier = 1.05;
            }
            else if (defencePrayer.name === "Mystic Will") {
                prayerMultiplier = 1.05;
            }
            else if (defencePrayer.name === "Rock Skin") {
                prayerMultiplier = 1.1;
            }
            else if (defencePrayer.name === "Mystic Lore") {
                prayerMultiplier = 1.1;
            }
            else if (defencePrayer.name === "Steel Skin") {
                prayerMultiplier = 1.15;
            }
            else if (defencePrayer.name === "Mystic Might") {
                prayerMultiplier = 1.15;
            }
            else if (defencePrayer.name === "Chivalry") {
                prayerMultiplier = 1.2;
            }
            else if (defencePrayer.name === "Piety") {
                prayerMultiplier = 1.25;
            }
            else if (defencePrayer.name === "Rigour") {
                prayerMultiplier = 1.25;
            }
            else if (defencePrayer.name === "Augury") {
                prayerMultiplier = 1.25;
            }
        }
        return Math.floor(from.currentStats.defence * prayerMultiplier) + bonuses.styleBonus + 8;
    };
    Object.defineProperty(MeleeWeapon.prototype, "isMeleeAttack", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return MeleeWeapon;
}(_gear_Weapon__WEBPACK_IMPORTED_MODULE_3__/* .Weapon */ .R));



/***/ }),

/***/ 3555:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P: () => (/* binding */ PoweredStaff)
/* harmony export */ });
/* harmony import */ var _AttackStylesController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(186);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4655);
/* harmony import */ var _Unit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3016);
/* harmony import */ var _XpDrop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3422);
/* harmony import */ var _MagicWeapon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5550);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/** Shared combat behaviour for weapons with a built-in powered spell. */
var PoweredStaff = /** @class */ (function (_super) {
    __extends(PoweredStaff, _super);
    function PoweredStaff() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PoweredStaff.prototype, "equipSoundId", {
        get: function () {
            return _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_1__/* .CACHE_ASSETS */ .fc.sounds.equipStaff.id;
        },
        enumerable: false,
        configurable: true
    });
    PoweredStaff.prototype.attackStyles = function () {
        return [_AttackStylesController__WEBPACK_IMPORTED_MODULE_0__/* .AttackStyle */ .aF.ACCURATE, _AttackStylesController__WEBPACK_IMPORTED_MODULE_0__/* .AttackStyle */ .aF.LONGRANGE];
    };
    PoweredStaff.prototype.attackStyleCategory = function () {
        return _AttackStylesController__WEBPACK_IMPORTED_MODULE_0__/* .AttackStyleTypes */ .F5.POWEREDSTAFF;
    };
    PoweredStaff.prototype.defaultStyle = function () {
        return _AttackStylesController__WEBPACK_IMPORTED_MODULE_0__/* .AttackStyle */ .aF.LONGRANGE;
    };
    Object.defineProperty(PoweredStaff.prototype, "baseAttackRange", {
        get: function () {
            return 6;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PoweredStaff.prototype, "attackRange", {
        get: function () {
            return this.baseAttackRange + (this.attackStyle() === _AttackStylesController__WEBPACK_IMPORTED_MODULE_0__/* .AttackStyle */ .aF.LONGRANGE ? 2 : 0);
        },
        enumerable: false,
        configurable: true
    });
    PoweredStaff.prototype.attack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        bonuses.attackStyle = "magic";
        bonuses.isAccurate = this.attackStyle() === _AttackStylesController__WEBPACK_IMPORTED_MODULE_0__/* .AttackStyle */ .aF.ACCURATE;
        return _super.prototype.attack.call(this, from, to, bonuses, options);
    };
    PoweredStaff.prototype._baseSpellDamage = function (from) {
        return Math.max(0, this.poweredSpellMaxHit(from.currentStats.magic));
    };
    PoweredStaff.prototype.grantXp = function (from, to) {
        if (from.type !== _Unit__WEBPACK_IMPORTED_MODULE_2__/* .UnitTypes */ .eK.PLAYER || this.damage <= 0)
            return;
        var multiplier = to.xpBonusMultiplier;
        from.grantXp(new _XpDrop__WEBPACK_IMPORTED_MODULE_3__/* .XpDrop */ .i("magic", this.damage * 2 * multiplier, this.damage));
        if (this.attackStyle() === _AttackStylesController__WEBPACK_IMPORTED_MODULE_0__/* .AttackStyle */ .aF.LONGRANGE) {
            from.grantXp(new _XpDrop__WEBPACK_IMPORTED_MODULE_3__/* .XpDrop */ .i("defence", this.damage * 2 * multiplier, this.damage));
        }
        from.grantXp(new _XpDrop__WEBPACK_IMPORTED_MODULE_3__/* .XpDrop */ .i("hitpoint", this.damage * 1.33 * multiplier, this.damage));
    };
    return PoweredStaff;
}(_MagicWeapon__WEBPACK_IMPORTED_MODULE_4__/* .MagicWeapon */ .u));



/***/ }),

/***/ 2402:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EZ: () => (/* binding */ FollowTargetInterpolator),
/* harmony export */   K7: () => (/* binding */ mergeProjectileOptions),
/* harmony export */   YR: () => (/* binding */ LinearProjectileMotionInterpolator),
/* harmony export */   Yi: () => (/* binding */ ProjectileGraphic),
/* harmony export */   c6: () => (/* binding */ Projectile),
/* harmony export */   dD: () => (/* binding */ ArcProjectileMotionInterpolator)
/* harmony export */ });
/* harmony import */ var chebyshev__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9252);
/* harmony import */ var chebyshev__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(chebyshev__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _gear_Weapon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6103);
/* harmony import */ var _utils_SoundCache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6018);
/* harmony import */ var _Renderable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(427);
/* harmony import */ var _Pathing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5454);
/* harmony import */ var _rendering_BasicModel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4989);
/* harmony import */ var _rendering_GLTFModel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2313);
/* harmony import */ var _rendering_CacheRenderModel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3752);
/* harmony import */ var _rendering_CacheRenderReference__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7757);
/* harmony import */ var _Settings__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8406);
/* harmony import */ var _Trainer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6374);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9156);

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};












function mergeProjectileOptions() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return sources.reduce(function (merged, source) { return (__assign(__assign(__assign({}, merged), source), { visuals: __assign(__assign({}, merged.visuals), source.visuals) })); }, {});
}
var targetIsLocation = function (x) { return x.x !== undefined; };
var Projectile = /** @class */ (function () {
    /*
      This should take the player and mob object, and do chebyshev on the size of them
    */
    function Projectile(weapon, damage, from, to, attackStyle, options) {
        if (options === void 0) { options = {}; }
        this.weapon = weapon;
        this.age = 0;
        this.attackStyle = attackStyle;
        if (Number.isNaN(damage)) {
            throw new Error("invalid damage value ".concat(damage));
        }
        this.damage = Math.floor(damage);
        if (!targetIsLocation(to) && this.damage > to.currentStats.hitpoint) {
            this.damage = to.currentStats.hitpoint;
        }
        this.options = __assign(__assign({ checkPrayerAtHit: false }, options), { visuals: __assign({ modelScale: 1.0, verticalOffset: 0.0, visualDelayTicks: 0, visualHitEarlyTicks: 0 }, options.visuals) });
        this.from = from;
        this.to = to;
        this.distance = 999999;
        if (!weapon || _gear_Weapon__WEBPACK_IMPORTED_MODULE_1__/* .Weapon */ .R.isMeleeAttackStyle(attackStyle)) {
            this.distance = 0;
            this.remainingDelay = 1;
        }
        else if (weapon) {
            if (options.forceSWTile) {
                // Things like ice barrage calculate distance to SW tile only
                var targetSW = targetIsLocation(to) ? to : to.location;
                this.distance = chebyshev__WEBPACK_IMPORTED_MODULE_0___default()([this.from.location.x, this.from.location.y], [targetSW.x, targetSW.y]);
            }
            else if (targetIsLocation(to)) {
                var closestTile = to;
                var closestTileFrom = from.getClosestTileTo(to.x, to.y);
                this.distance = chebyshev__WEBPACK_IMPORTED_MODULE_0___default()([closestTileFrom[0], closestTileFrom[1]], [closestTile[0], closestTile[1]]);
            }
            else {
                var closestTile = to.getClosestTileTo(this.from.location.x, this.from.location.y);
                var closestTileFrom = from.getClosestTileTo(to.location.x, to.location.y);
                this.distance = chebyshev__WEBPACK_IMPORTED_MODULE_0___default()([closestTileFrom[0], closestTileFrom[1]], [closestTile[0], closestTile[1]]);
            }
            this.remainingDelay = weapon.calculateHitDelay(this.distance);
            if (from.isPlayer) {
                this.remainingDelay++;
            }
            if (this.options.reduceDelay) {
                this.remainingDelay -= this.options.reduceDelay;
                if (this.remainingDelay < 1) {
                    this.remainingDelay = 1;
                }
            }
        }
        this.remainingDelay = options.setDelay || this.remainingDelay;
        this.totalDelay = this.remainingDelay;
        this.playSound(this.options.sound);
        this.graphic = new ProjectileGraphic(this);
    }
    Projectile.prototype.isMeleeStyle = function () {
        return this.attackStyle === "slash" || this.attackStyle === "crush" || this.attackStyle === "stab";
    };
    Projectile.prototype.playSound = function (sound) {
        if (_Settings__WEBPACK_IMPORTED_MODULE_9__/* .Settings */ .w.playsAudio && sound) {
            var player = _Trainer__WEBPACK_IMPORTED_MODULE_10__/* .Trainer */ .c.player;
            // projectiles launched at the player always play at full volume
            var volumeRatio = this.from === player || this.to === player
                ? 1.0
                : 1 /
                    _Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.dist(_Trainer__WEBPACK_IMPORTED_MODULE_10__/* .Trainer */ .c.player.location.x, _Trainer__WEBPACK_IMPORTED_MODULE_10__/* .Trainer */ .c.player.location.y, this.from.location.x, this.from.location.y);
            volumeRatio = Math.min(1, Math.max(0, Math.sqrt(volumeRatio)));
            _utils_SoundCache__WEBPACK_IMPORTED_MODULE_2__/* .SoundCache */ .U.play({
                src: sound.src,
                volume: volumeRatio * sound.volume,
                delayMs: 0,
            });
        }
    };
    Projectile.prototype.onTick = function () {
        this.remainingDelay--;
        this.age++;
    };
    // called as the projectile lands but before damage is calculated
    Projectile.prototype.beforeHit = function () {
        var _a;
        if (this.options.hitSound) {
            _utils_SoundCache__WEBPACK_IMPORTED_MODULE_2__/* .SoundCache */ .U.play(this.options.hitSound);
        }
        if (!targetIsLocation(this.to) &&
            this.options.checkPrayerAtHit &&
            ((_a = this.weapon) === null || _a === void 0 ? void 0 : _a.isBlockable(this.from, this.to, { attackStyle: this.attackStyle }))) {
            this.damage = 0;
        }
    };
    Projectile.prototype.shouldDestroy = function () {
        return this.age >= this.totalDelay + 1;
    };
    return Projectile;
}());

/** Client-cycle visual paired with a game-tick combat projectile. */
var ProjectileGraphic = /** @class */ (function (_super) {
    __extends(ProjectileGraphic, _super);
    function ProjectileGraphic(projectile) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        _this = _super.call(this) || this;
        _this.projectile = projectile;
        _this.elapsedCycles = 0;
        _this.projectileSoundPlayed = false;
        _this.startLocation = {
            x: projectile.from.location.x + (projectile.from.size - 1) / 2,
            y: projectile.from.location.y - (projectile.from.size - 1) / 2,
        };
        var visuals = projectile.options.visuals;
        _this.startHeight = projectile.from.height * 0.75 + visuals.verticalOffset;
        _this.interpolator = (_a = visuals.motionInterpolator) !== null && _a !== void 0 ? _a : new LinearProjectileMotionInterpolator();
        _this.image = (_b = projectile.weapon) === null || _b === void 0 ? void 0 : _b.image;
        var clientTicksPerGameTick = Math.max(1, Math.round(_Settings__WEBPACK_IMPORTED_MODULE_9__/* .Settings */ .w.tickMs / _utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .CLIENT_CYCLE_MS */ .Om));
        _this.startCycle = (_c = visuals.startCycleOffset) !== null && _c !== void 0 ? _c : visuals.visualDelayTicks * clientTicksPerGameTick;
        _this.endCycle = (_d = visuals.endCycleOffset) !== null && _d !== void 0 ? _d : projectile.totalDelay * clientTicksPerGameTick
            - ((_e = visuals.hitEarlyCycleOffset) !== null && _e !== void 0 ? _e : visuals.visualHitEarlyTicks * clientTicksPerGameTick);
        _this.playProjectileSound();
        return _this;
    }
    ProjectileGraphic.prototype.clientTick = function () {
        this.elapsedCycles++;
        this.playProjectileSound();
    };
    ProjectileGraphic.prototype.playProjectileSound = function () {
        var sound = this.projectile.options.visuals.projectileSound;
        if (this.projectileSoundPlayed || this.elapsedCycles < this.startCycle || !_Settings__WEBPACK_IMPORTED_MODULE_9__/* .Settings */ .w.playsAudio || !sound)
            return;
        this.projectileSoundPlayed = true;
        var player = _Trainer__WEBPACK_IMPORTED_MODULE_10__/* .Trainer */ .c.player;
        var volumeRatio = this.projectile.from === player || this.projectile.to === player
            ? 1
            : 1 / _Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.dist(player.location.x, player.location.y, this.startLocation.x, this.startLocation.y);
        volumeRatio = Math.min(1, Math.max(0, Math.sqrt(volumeRatio)));
        _utils_SoundCache__WEBPACK_IMPORTED_MODULE_2__/* .SoundCache */ .U.play({ src: sound.src, volume: volumeRatio * sound.volume, delayMs: 0 });
    };
    ProjectileGraphic.prototype.getPercent = function () {
        var duration = this.endCycle - this.startCycle;
        if (duration <= 0)
            return this.elapsedCycles >= this.startCycle ? 1 : 0;
        return (this.elapsedCycles - this.startCycle) / duration;
    };
    ProjectileGraphic.prototype.getTargetDestination = function (tickPercent) {
        if (tickPercent === void 0) { tickPercent = 0; }
        var target = this.projectile.to;
        if (targetIsLocation(target))
            return target;
        var _a = target.getPerceivedLocation(tickPercent), x = _a.x, y = _a.y;
        return {
            x: x + (target.size - 1) / 2,
            y: y - (target.size - 1) / 2,
            z: target.height * 0.5,
        };
    };
    ProjectileGraphic.prototype.getPerceivedLocation = function (tickPercent) {
        return this.interpolator.interpolate(__assign(__assign({}, this.startLocation), { z: this.startHeight }), this.getTargetDestination(tickPercent), this.getPercent());
    };
    ProjectileGraphic.prototype.getPerceivedRotation = function (tickPercent) {
        var destination = this.getTargetDestination(tickPercent);
        return -_Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.angle(this.startLocation.x, this.startLocation.y, destination.x, destination.y);
    };
    ProjectileGraphic.prototype.getPerceivedPitch = function (tickPercent) {
        return this.interpolator.interpolatePitch(__assign(__assign({}, this.startLocation), { z: this.startHeight }), this.getTargetDestination(tickPercent), this.getPercent());
    };
    ProjectileGraphic.prototype.getPerceivedOffsets = function (tickPercent) {
        var offsets = this.projectile.options.visuals.offsetsInterpolator;
        if (!offsets)
            return _super.prototype.getPerceivedOffsets.call(this, tickPercent);
        return offsets.interpolateOffsets(__assign(__assign({}, this.startLocation), { z: this.startHeight }), this.getTargetDestination(tickPercent), this.getPercent());
    };
    ProjectileGraphic.prototype.getTrueLocation = function () { return this.getPerceivedLocation(0); };
    Object.defineProperty(ProjectileGraphic.prototype, "size", {
        get: function () { return this.projectile.options.visuals.size || 0.5; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectileGraphic.prototype, "color", {
        get: function () {
            if (this.projectile.options.visuals.color)
                return this.projectile.options.visuals.color;
            if (this.projectile.isMeleeStyle())
                return "#FF0000";
            if (this.projectile.attackStyle === "range")
                return "#00FF00";
            if (this.projectile.attackStyle === "magic")
                return "#0000FF";
            if (this.projectile.attackStyle === "heal")
                return "#9813aa";
            return "#000000";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectileGraphic.prototype, "drawOutline", {
        get: function () { return false; },
        enumerable: false,
        configurable: true
    });
    ProjectileGraphic.prototype.visible = function () {
        return !this.projectile.options.visuals.hidden
            && this.elapsedCycles > this.startCycle
            && this.elapsedCycles <= this.endCycle;
    };
    ProjectileGraphic.prototype.shouldDestroy = function () { return this.elapsedCycles > Math.max(this.startCycle, this.endCycle); };
    Object.defineProperty(ProjectileGraphic.prototype, "animationIndex", {
        get: function () { return 0; },
        enumerable: false,
        configurable: true
    });
    ProjectileGraphic.prototype.draw = function (_tickPercent, context, location, scale) {
        if (scale === void 0) { scale = _Settings__WEBPACK_IMPORTED_MODULE_9__/* .Settings */ .w.tileSize; }
        if (!this.visible())
            return;
        context.save();
        context.translate(location.x * _Settings__WEBPACK_IMPORTED_MODULE_9__/* .Settings */ .w.tileSize, location.y * _Settings__WEBPACK_IMPORTED_MODULE_9__/* .Settings */ .w.tileSize);
        if (this.image) {
            context.rotate(Math.PI);
            context.drawImage(this.image, -scale / 2, -scale / 2, scale, scale);
        }
        else {
            context.beginPath();
            context.fillStyle = "".concat(this.color, "73");
            context.arc(0, 0, 5, 0, 2 * Math.PI);
            context.fill();
        }
        context.restore();
    };
    ProjectileGraphic.prototype.create3dModel = function () {
        var _a;
        var options = this.projectile.options.visuals;
        if (options.hidden || !this.projectile.attackStyle || this.color === "#000000")
            return null;
        if (options.models)
            return _rendering_GLTFModel__WEBPACK_IMPORTED_MODULE_6__/* .GLTFModel */ .F.forRenderableMulti(this, options.models, { scale: options.modelScale });
        if (options.spotAnim) {
            var spotAnim = __assign(__assign({}, options.spotAnim), { delay: ((_a = options.spotAnim.delay) !== null && _a !== void 0 ? _a : 0) + this.startCycle });
            return _rendering_CacheRenderModel__WEBPACK_IMPORTED_MODULE_7__/* .CacheRenderModel */ .q.forRenderable(this, _rendering_CacheRenderReference__WEBPACK_IMPORTED_MODULE_8__/* .CacheRenderReferences */ .P.spotAnim([spotAnim]), { basisRotation: Math.PI / 2, loopSpotAnims: true });
        }
        if (options.model)
            return _rendering_GLTFModel__WEBPACK_IMPORTED_MODULE_6__/* .GLTFModel */ .F.forRenderable(this, options.model, { scale: options.modelScale });
        return _rendering_BasicModel__WEBPACK_IMPORTED_MODULE_5__/* .BasicModel */ .W.sphereForRenderable(this);
    };
    return ProjectileGraphic;
}(_Renderable__WEBPACK_IMPORTED_MODULE_3__/* .Renderable */ .l));

var LinearProjectileMotionInterpolator = /** @class */ (function () {
    function LinearProjectileMotionInterpolator() {
    }
    LinearProjectileMotionInterpolator.prototype.interpolate = function (from, to, percent) {
        // default linear
        var startX = from.x;
        var startY = from.y;
        var startHeight = from.z;
        var endX = to.x;
        var endY = to.y;
        var endHeight = to.z;
        var perceivedX = _Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.linearInterpolation(startX, endX, percent);
        var perceivedY = _Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.linearInterpolation(startY, endY, percent);
        var perceivedHeight = startHeight === endHeight ? startHeight : _Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.linearInterpolation(startHeight, endHeight, percent);
        return { x: perceivedX, y: perceivedY, z: perceivedHeight };
    };
    LinearProjectileMotionInterpolator.prototype.interpolatePitch = function (from, to, percent) {
        return 0;
    };
    return LinearProjectileMotionInterpolator;
}());

var ArcProjectileMotionInterpolator = /** @class */ (function () {
    function ArcProjectileMotionInterpolator(height) {
        this.height = height;
    }
    ArcProjectileMotionInterpolator.prototype.interpolate = function (from, to, percent) {
        var startX = from.x;
        var startY = from.y;
        var startHeight = from.z;
        var endX = to.x;
        var endY = to.y;
        var endHeight = to.z;
        var perceivedX = _Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.linearInterpolation(startX, endX, percent);
        var perceivedY = _Pathing__WEBPACK_IMPORTED_MODULE_4__/* .Pathing */ .G.linearInterpolation(startY, endY, percent);
        var perceivedHeight = Math.sin(percent * Math.PI) * this.height + (endHeight - startHeight) * percent + startHeight;
        return { x: perceivedX, y: perceivedY, z: perceivedHeight };
    };
    ArcProjectileMotionInterpolator.prototype.interpolatePitch = function (from, to, percent) {
        return Math.sin(-(0.75 + percent * 0.5) * Math.PI);
    };
    return ArcProjectileMotionInterpolator;
}());

// Simply sticks to the target
var FollowTargetInterpolator = /** @class */ (function () {
    function FollowTargetInterpolator() {
    }
    FollowTargetInterpolator.prototype.interpolate = function (from, to, percent) {
        var endX = to.x;
        var endY = to.y;
        var endHeight = to.z;
        return { x: endX, y: endY, z: endHeight };
    };
    FollowTargetInterpolator.prototype.interpolatePitch = function (from, to, percent) {
        return 0;
    };
    return FollowTargetInterpolator;
}());



/***/ }),

/***/ 2022:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I: () => (/* binding */ RangedWeapon)
/* harmony export */ });
/* harmony import */ var _Unit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3016);
/* harmony import */ var _Projectile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2402);
/* harmony import */ var _gear_Weapon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6103);
/* harmony import */ var _Equipment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3107);
/* harmony import */ var _BasePrayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(165);
/* harmony import */ var _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4655);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var RangedWeapon = /** @class */ (function (_super) {
    __extends(RangedWeapon, _super);
    function RangedWeapon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RangedWeapon.prototype, "equipSoundId", {
        get: function () {
            return _assets_CacheAssets__WEBPACK_IMPORTED_MODULE_5__/* .CACHE_ASSETS */ .fc.sounds.equipRanged.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RangedWeapon.prototype, "type", {
        get: function () {
            return _Equipment__WEBPACK_IMPORTED_MODULE_3__/* .EquipmentTypes */ .WA.WEAPON;
        },
        enumerable: false,
        configurable: true
    });
    RangedWeapon.prototype.registerProjectile = function (from, to, bonuses, options) {
        if (options === void 0) { options = {}; }
        to.addProjectile(new _Projectile__WEBPACK_IMPORTED_MODULE_1__/* .Projectile */ .c6(this, this.damage, from, to, "range", (0,_Projectile__WEBPACK_IMPORTED_MODULE_1__/* .mergeProjectileOptions */ .K7)({ sound: this.attackSound, hitSound: this.attackLandingSound, visuals: { model: this.projectileModel } }, this.projectileOptions, options)));
    };
    RangedWeapon.prototype.calculateHitDelay = function (distance) {
        return Math.floor((3 + distance) / 6) + 1;
    };
    RangedWeapon.prototype._calculatePrayerEffects = function (from, to, bonuses) {
        bonuses.effectivePrayers = {};
        if (from.type !== _Unit__WEBPACK_IMPORTED_MODULE_0__/* .UnitTypes */ .eK.MOB && from.prayerController) {
            var offensiveRange = from.prayerController.matchGroup(_BasePrayer__WEBPACK_IMPORTED_MODULE_4__/* .PrayerGroups */ .u.ACCURACY);
            if (offensiveRange) {
                bonuses.effectivePrayers.range = offensiveRange;
            }
        }
        if (to.type !== _Unit__WEBPACK_IMPORTED_MODULE_0__/* .UnitTypes */ .eK.MOB && to.prayerController) {
            var defence = to.prayerController.matchGroup(_BasePrayer__WEBPACK_IMPORTED_MODULE_4__/* .PrayerGroups */ .u.DEFENCE);
            if (defence) {
                bonuses.effectivePrayers.defence = defence;
            }
            var overhead = to.prayerController.overhead();
            if (overhead) {
                bonuses.effectivePrayers.overhead = overhead;
            }
        }
    };
    RangedWeapon.prototype.isBlockable = function (from, to, bonuses) {
        this._calculatePrayerEffects(from, to, bonuses);
        if (bonuses.effectivePrayers.overhead && bonuses.effectivePrayers.overhead.feature() === "range") {
            return true;
        }
        return false;
    };
    RangedWeapon.prototype._rangedAttack = function (from, to, bonuses) {
        var prayerMultiplier = 1;
        var rangePrayer = bonuses.effectivePrayers.range;
        if (rangePrayer) {
            if (rangePrayer.name === "Sharp Eye") {
                prayerMultiplier = 1.05;
            }
            else if (rangePrayer.name === "Hawk Eye") {
                prayerMultiplier = 1.1;
            }
            else if (rangePrayer.name === "Eagle Eye") {
                prayerMultiplier = 1.15;
            }
            else if (rangePrayer.name === "Rigour") {
                prayerMultiplier = 1.2;
            }
        }
        return (Math.floor(Math.floor(from.currentStats.range) * prayerMultiplier + (bonuses.isAccurate ? 3 : 0) + 8) *
            bonuses.voidMultiplier);
    };
    RangedWeapon.prototype._maxHit = function (from, to, bonuses) {
        var _a;
        var prayerMultiplier = 1;
        var rangePrayer = bonuses.effectivePrayers.range;
        if (rangePrayer) {
            if (rangePrayer.name === "Sharp Eye") {
                prayerMultiplier = 1.05;
            }
            else if (rangePrayer.name === "Hawk Eye") {
                prayerMultiplier = 1.1;
            }
            else if (rangePrayer.name === "Eagle Eye") {
                prayerMultiplier = 1.15;
            }
            else if (rangePrayer.name === "Rigour") {
                prayerMultiplier = 1.23;
            }
        }
        var rangedStrength = Math.floor(Math.floor(from.currentStats.range) * prayerMultiplier + (bonuses.isAccurate ? 3 : 0) + 8) *
            bonuses.voidMultiplier;
        var max = Math.floor(Math.floor(0.5 + ((rangedStrength * (from.bonuses.other.rangedStrength + 64)) / 640) * bonuses.gearRangeMultiplier) * this._damageMultiplier(from, to, bonuses));
        return Math.floor(max * ((_a = bonuses.overallMultiplier) !== null && _a !== void 0 ? _a : 1));
    };
    RangedWeapon.prototype._attackRoll = function (from, to, bonuses) {
        return Math.floor(Math.floor(this._rangedAttack(from, to, bonuses) * (from.bonuses.attack.range + 64) * bonuses.gearRangeMultiplier) * this._accuracyMultiplier(from, to, bonuses));
    };
    RangedWeapon.prototype._defenceRoll = function (from, to, bonuses) {
        var prayerMultiplier = 1;
        var defencePrayer = bonuses.effectivePrayers.defence;
        if (defencePrayer) {
            if (defencePrayer.name === "Thick Skin") {
                prayerMultiplier = 1.05;
            }
            else if (defencePrayer.name === "Mystic Will") {
                prayerMultiplier = 1.05;
            }
            else if (defencePrayer.name === "Rock Skin") {
                prayerMultiplier = 1.1;
            }
            else if (defencePrayer.name === "Mystic Lore") {
                prayerMultiplier = 1.1;
            }
            else if (defencePrayer.name === "Steel Skin") {
                prayerMultiplier = 1.15;
            }
            else if (defencePrayer.name === "Mystic Might") {
                prayerMultiplier = 1.15;
            }
            else if (defencePrayer.name === "Chivalry") {
                prayerMultiplier = 1.2;
            }
            else if (defencePrayer.name === "Piety") {
                prayerMultiplier = 1.25;
            }
            else if (defencePrayer.name === "Rigour") {
                prayerMultiplier = 1.25;
            }
            else if (defencePrayer.name === "Augury") {
                prayerMultiplier = 1.25;
            }
        }
        return (to.currentStats.defence * prayerMultiplier + 9) * (to.bonuses.defence.range + 64);
    };
    RangedWeapon.prototype._accuracyMultiplier = function (from, to, bonuses) {
        return 1; // Used for tbow passive effect
    };
    RangedWeapon.prototype._damageMultiplier = function (from, to, bonuses) {
        return 1; // Used for tbow passive effect
    };
    return RangedWeapon;
}(_gear_Weapon__WEBPACK_IMPORTED_MODULE_2__/* .Weapon */ .R));



/***/ }),

/***/ 155:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "ad696066da7b6acbd886.png";

/***/ }),

/***/ 2229:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "a5a3001cb77ef38bd153.png";

/***/ }),

/***/ 29:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "ad69a47f269969a25eb9.png";

/***/ }),

/***/ 8260:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "0b7151b64115c1093479.png";

/***/ }),

/***/ 4290:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "08918c8be0e9b68185a0.png";

/***/ }),

/***/ 3318:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "ef6954ed9e91fed3ca39.png";

/***/ }),

/***/ 9604:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9604__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AbyssalTentacle: () => (/* reexport */ weapons.AbyssalTentacle),
  AccountControls: () => (/* reexport */ AccountControls),
  Actor: () => (/* reexport */ Actor),
  AhrimsRobeskirt: () => (/* reexport */ equipment.AhrimsRobeskirt),
  AhrimsRobetop: () => (/* reexport */ equipment.AhrimsRobetop),
  Ammo: () => (/* reexport */ Ammo/* Ammo */.d),
  AmmoType: () => (/* reexport */ Ammo/* AmmoType */.T),
  AmuletOfBloodFury: () => (/* reexport */ equipment.AmuletOfBloodFury),
  AmuletOfFury: () => (/* reexport */ equipment.AmuletOfFury),
  AmuletOfRancour: () => (/* reexport */ equipment.AmuletOfRancour),
  AmuletOfTorture: () => (/* reexport */ equipment.AmuletOfTorture),
  AncestralRobebottom: () => (/* reexport */ equipment.AncestralRobebottom),
  AncestralRobetop: () => (/* reexport */ equipment.AncestralRobetop),
  AncientStaff: () => (/* reexport */ weapons.AncientStaff),
  AncientsSpellbookControls: () => (/* reexport */ AncientsSpellbookControls),
  AoeRangedWeapon: () => (/* reexport */ AoeRangedWeapon),
  AraneaBoots: () => (/* reexport */ equipment.AraneaBoots),
  ArcProjectileMotionInterpolator: () => (/* reexport */ Projectile/* ArcProjectileMotionInterpolator */.dD),
  ArmadylBrew: () => (/* reexport */ items.ArmadylBrew),
  ArmadylChainskirt: () => (/* reexport */ equipment.ArmadylChainskirt),
  ArmadylChestplate: () => (/* reexport */ equipment.ArmadylChestplate),
  Assets: () => (/* reexport */ Assets/* Assets */.s),
  AttackIndicators: () => (/* reexport */ Mob/* AttackIndicators */.V),
  AttackStyle: () => (/* reexport */ AttackStylesController/* AttackStyle */.aF),
  AttackStyleTypes: () => (/* reexport */ AttackStylesController/* AttackStyleTypes */.F5),
  AttackStylesController: () => (/* reexport */ AttackStylesController/* AttackStylesController */.D2),
  AvasAccumulator: () => (/* reexport */ equipment.AvasAccumulator),
  AvasAssembler: () => (/* reexport */ equipment.AvasAssembler),
  AvernicDefender: () => (/* reexport */ equipment.AvernicDefender),
  AvernicTreadsMax: () => (/* reexport */ equipment.AvernicTreadsMax),
  BarrageSpell: () => (/* reexport */ BarrageSpell/* BarrageSpell */.v),
  BarrowsGloves: () => (/* reexport */ equipment.BarrowsGloves),
  BaseControls: () => (/* reexport */ BaseControls),
  BasePrayer: () => (/* reexport */ BasePrayer/* BasePrayer */.B),
  BasicModel: () => (/* reexport */ BasicModel/* BasicModel */.W),
  BasicModelShape: () => (/* reexport */ BasicModel/* BasicModelShape */.f),
  BastionPotion: () => (/* reexport */ items.BastionPotion),
  BerserkerRing_i: () => (/* reexport */ equipment.BerserkerRing_i),
  BlackChinchompa: () => (/* reexport */ weapons.BlackChinchompa),
  BlackDhideBody: () => (/* reexport */ equipment.BlackDhideBody),
  BlackDhideChaps: () => (/* reexport */ equipment.BlackDhideChaps),
  BlackDhideVambraces: () => (/* reexport */ equipment.BlackDhideVambraces),
  BladeOfSaeldor: () => (/* reexport */ weapons.BladeOfSaeldor),
  BloodBarrageSpell: () => (/* reexport */ BloodBarrageSpell/* BloodBarrageSpell */.h),
  Blowpipe: () => (/* reexport */ weapons.Blowpipe),
  BlueMoonChestplate: () => (/* reexport */ equipment.BlueMoonChestplate),
  BlueMoonHelm: () => (/* reexport */ equipment.BlueMoonHelm),
  BlueMoonSpear: () => (/* reexport */ weapons.BlueMoonSpear),
  BlueMoonTassets: () => (/* reexport */ equipment.BlueMoonTassets),
  BoostPanel: () => (/* reexport */ BoostPanel),
  BowOfFaerdhinen: () => (/* reexport */ weapons.BowOfFaerdhinen),
  BrowserUtils: () => (/* reexport */ BrowserUtils),
  Button: () => (/* reexport */ Button),
  CACHE_ASSETS: () => (/* reexport */ CacheAssets/* CACHE_ASSETS */.fc),
  CACHE_RENDER_BUNDLE_SCHEMA_VERSION: () => (/* reexport */ CacheRenderBundle/* CACHE_RENDER_BUNDLE_SCHEMA_VERSION */.O0),
  CACHE_SOUND_EFFECT_IDS: () => (/* reexport */ CacheAssets/* CACHE_SOUND_EFFECT_IDS */.ke),
  CHUNK_SIZE: () => (/* reexport */ Chunk/* CHUNK_SIZE */.O),
  CacheRender: () => (/* reexport */ CacheRenderBundle/* CacheRender */.j9),
  CacheRenderBundle: () => (/* reexport */ CacheRenderBundle/* CacheRenderBundle */.zL),
  CacheRenderBundleError: () => (/* reexport */ CacheRenderBundle/* CacheRenderBundleError */.Bi),
  CacheRenderInstancedModel: () => (/* reexport */ CacheRenderInstancedModel/* CacheRenderInstancedModel */.H),
  CacheRenderModel: () => (/* reexport */ CacheRenderModel/* CacheRenderModel */.q),
  CacheRenderReferences: () => (/* reexport */ CacheRenderReference/* CacheRenderReferences */.P),
  CacheRenderSceneModel: () => (/* reexport */ CacheRenderSceneModel),
  CanvasSpriteModel: () => (/* reexport */ CanvasSpriteModel/* CanvasSpriteModel */.X),
  Cape: () => (/* reexport */ Cape/* Cape */.Q),
  CardinalDirection: () => (/* reexport */ CardinalDirection),
  Chest: () => (/* reexport */ Chest/* Chest */.k),
  Chrome: () => (/* reexport */ Chrome),
  ChunkUtils: () => (/* reexport */ Chunk/* ChunkUtils */.N),
  ClanChatControls: () => (/* reexport */ ClanChatControls),
  ClickAnimation: () => (/* reexport */ ClickAnimation),
  ClickController: () => (/* reexport */ ClickController),
  Collision: () => (/* reexport */ Collision/* Collision */.F),
  CollisionType: () => (/* reexport */ Collision/* CollisionType */.B),
  CombatControls: () => (/* reexport */ CombatControls),
  ConflictionGauntlets: () => (/* reexport */ equipment.ConflictionGauntlets),
  ContextMenu: () => (/* reexport */ ContextMenu),
  ControlPanelController: () => (/* reexport */ ControlPanelController),
  CrystalBody: () => (/* reexport */ equipment.CrystalBody),
  CrystalHelm: () => (/* reexport */ equipment.CrystalHelm),
  CrystalLegs: () => (/* reexport */ equipment.CrystalLegs),
  CrystalShield: () => (/* reexport */ equipment.CrystalShield),
  DEFAULT_OSRS_ASSET_BASE_URL: () => (/* reexport */ Assets/* DEFAULT_OSRS_ASSET_BASE_URL */.d),
  DagonhaiRobeTop: () => (/* reexport */ equipment.DagonhaiRobeTop),
  DelayedAction: () => (/* reexport */ DelayedAction/* DelayedAction */.T),
  DeserializePlayerStats: () => (/* reexport */ PlayerStats/* DeserializePlayerStats */.Q),
  DevoutBoots: () => (/* reexport */ equipment.DevoutBoots),
  DiamondBoltsE: () => (/* reexport */ equipment.DiamondBoltsE),
  DizanasQuiver: () => (/* reexport */ equipment.DizanasQuiver),
  DragonArrows: () => (/* reexport */ equipment.DragonArrows),
  DragonClaws: () => (/* reexport */ weapons.DragonClaws),
  DragonDefender: () => (/* reexport */ equipment.DragonDefender),
  EQUIPMENT_TYPE_TO_SLOT: () => (/* reexport */ Equipment/* EQUIPMENT_TYPE_TO_SLOT */.Fm),
  Eating: () => (/* reexport */ Eating/* Eating */.B),
  EmotesControls: () => (/* reexport */ EmotesControls),
  EmptyControls: () => (/* reexport */ EmptyControls),
  EmptyModel: () => (/* reexport */ EmptyModel),
  Entity: () => (/* reexport */ Entity/* Entity */.w),
  EntityNames: () => (/* reexport */ EntityName/* EntityNames */.C),
  Equipment: () => (/* reexport */ Equipment/* Equipment */.$i),
  EquipmentControls: () => (/* reexport */ EquipmentControls),
  EquipmentTypes: () => (/* reexport */ Equipment/* EquipmentTypes */.WA),
  EternalBoots: () => (/* reexport */ equipment.EternalBoots),
  EyeOfAyak: () => (/* reexport */ weapons.EyeOfAyak),
  FIXED_BOTTOM_TABS_Y: () => (/* reexport */ FIXED_BOTTOM_TABS_Y),
  FIXED_CHATBOX: () => (/* reexport */ FIXED_CHATBOX),
  FIXED_HEIGHT: () => (/* reexport */ FIXED_HEIGHT),
  FIXED_PANEL: () => (/* reexport */ FIXED_PANEL),
  FIXED_TABS_X: () => (/* reexport */ FIXED_TABS_X),
  FIXED_TOP_TABS_Y: () => (/* reexport */ FIXED_TOP_TABS_Y),
  FIXED_VIEWPORT: () => (/* reexport */ FIXED_VIEWPORT),
  FIXED_WIDTH: () => (/* reexport */ FIXED_WIDTH),
  Feet: () => (/* reexport */ Feet/* Feet */.v),
  FerociousGloves: () => (/* reexport */ equipment.FerociousGloves),
  FireCape: () => (/* reexport */ equipment.FireCape),
  FixedLayout: () => (/* reexport */ FixedLayout),
  FollowTargetInterpolator: () => (/* reexport */ Projectile/* FollowTargetInterpolator */.EZ),
  Food: () => (/* reexport */ Food/* Food */.N),
  FriendsControls: () => (/* reexport */ FriendsControls),
  GLTFModel: () => (/* reexport */ GLTFModel/* GLTFModel */.F),
  GROUND_OVERLAY_OPACITY: () => (/* reexport */ RenderUtils/* GROUND_OVERLAY_OPACITY */.Jf),
  GROUND_OVERLAY_Y: () => (/* reexport */ RenderUtils/* GROUND_OVERLAY_Y */.t8),
  Gloves: () => (/* reexport */ Gloves/* Gloves */.L),
  GraphicsObject: () => (/* reexport */ GraphicsObject/* GraphicsObject */.H),
  GroundOverlayRenderOrder: () => (/* reexport */ RenderUtils/* GroundOverlayRenderOrder */.oC),
  GuthixRobeTop: () => (/* reexport */ equipment.GuthixRobeTop),
  Helmet: () => (/* reexport */ Helmet/* Helmet */.m),
  HolyBlessing: () => (/* reexport */ equipment.HolyBlessing),
  INTERFACE_ASSETS: () => (/* reexport */ INTERFACE_ASSETS),
  IceBarrageSpell: () => (/* reexport */ IceBarrageSpell),
  ImageLoader: () => (/* reexport */ ImageLoader/* ImageLoader */.$),
  InfernalCape: () => (/* reexport */ equipment.InfernalCape),
  InputController: () => (/* reexport */ Input/* InputController */.f),
  Interpolation: () => (/* reexport */ Interpolation/* Interpolation */.l),
  InventoryControls: () => (/* reexport */ InventoryControls),
  InvisibleMovementBlocker: () => (/* reexport */ InvisibleMovementBlocker),
  Item: () => (/* reexport */ Item/* Item */.q),
  ItemName: () => (/* reexport */ ItemName/* ItemName */.P),
  JusticiarChestguard: () => (/* reexport */ equipment.JusticiarChestguard),
  JusticiarFaceguard: () => (/* reexport */ equipment.JusticiarFaceguard),
  JusticiarLegguards: () => (/* reexport */ equipment.JusticiarLegguards),
  Karambwan: () => (/* reexport */ items.Karambwan),
  KeyBindingButton: () => (/* reexport */ KeyBindingButton),
  KodaiWand: () => (/* reexport */ weapons.KodaiWand),
  Legs: () => (/* reexport */ Legs/* Legs */.I),
  LineOfSight: () => (/* reexport */ LineOfSight/* LineOfSight */.V),
  LineOfSightMask: () => (/* reexport */ LineOfSight/* LineOfSightMask */.Z),
  LinearProjectileMotionInterpolator: () => (/* reexport */ Projectile/* LinearProjectileMotionInterpolator */.YR),
  LocationUtils: () => (/* reexport */ Location/* LocationUtils */.J),
  MagesBook: () => (/* reexport */ equipment.MagesBook),
  MagicWeapon: () => (/* reexport */ MagicWeapon/* MagicWeapon */.u),
  Manticore: () => (/* reexport */ Manticore),
  ManticoreAnimations: () => (/* reexport */ ManticoreAnimations),
  MapController: () => (/* reexport */ MapController),
  MasoriBodyF: () => (/* reexport */ equipment.MasoriBodyF),
  MasoriChapsF: () => (/* reexport */ equipment.MasoriChapsF),
  MasoriMaskF: () => (/* reexport */ equipment.MasoriMaskF),
  MeleeWeapon: () => (/* reexport */ MeleeWeapon/* MeleeWeapon */.d),
  Mob: () => (/* reexport */ Mob/* Mob */.B),
  MusicControls: () => (/* reexport */ MusicControls),
  Necklace: () => (/* reexport */ Necklace/* Necklace */.T),
  NecklaceOfAnguish: () => (/* reexport */ equipment.NecklaceOfAnguish),
  NecklaceOfRupture: () => (/* reexport */ equipment.NecklaceOfRupture),
  NoxiousHalberd: () => (/* reexport */ weapons.NoxiousHalberd),
  OathplateChest: () => (/* reexport */ equipment.OathplateChest),
  OathplateHelm: () => (/* reexport */ equipment.OathplateHelm),
  OathplateLegs: () => (/* reexport */ equipment.OathplateLegs),
  OccultNecklace: () => (/* reexport */ equipment.OccultNecklace),
  Offhand: () => (/* reexport */ Offhand/* Offhand */.f),
  Pathing: () => (/* reexport */ Pathing/* Pathing */.G),
  PegasianBoots: () => (/* reexport */ equipment.PegasianBoots),
  Player: () => (/* reexport */ Player/* Player */.a),
  PlayerAnimationIndices: () => (/* reexport */ GLTFAnimationConstants/* PlayerAnimationIndices */.L),
  PlayerRegenTimer: () => (/* reexport */ PlayerRegenTimers/* PlayerRegenTimer */._),
  PointingModel: () => (/* reexport */ PointingModel),
  Potion: () => (/* reexport */ Potion/* Potion */.E),
  PoweredStaff: () => (/* reexport */ PoweredStaff/* PoweredStaff */.P),
  PrayerController: () => (/* reexport */ PrayerController/* PrayerController */.U),
  PrayerControls: () => (/* reexport */ PrayerControls),
  PrayerGroups: () => (/* reexport */ BasePrayer/* PrayerGroups */.u),
  PrayerRegenerationPotion: () => (/* reexport */ items.PrayerRegenerationPotion),
  PrimordialBoots: () => (/* reexport */ equipment.PrimordialBoots),
  Projectile: () => (/* reexport */ Projectile/* Projectile */.c6),
  ProjectileGraphic: () => (/* reexport */ Projectile/* ProjectileGraphic */.Yi),
  QuestsControls: () => (/* reexport */ QuestsControls),
  RadasBlessing4: () => (/* reexport */ equipment.RadasBlessing4),
  Random: () => (/* reexport */ Random/* Random */.o),
  RangedWeapon: () => (/* reexport */ RangedWeapon/* RangedWeapon */.I),
  RangerBoots: () => (/* reexport */ equipment.RangerBoots),
  RangingPotion: () => (/* reexport */ items.RangingPotion),
  Region: () => (/* reexport */ Region),
  Renderable: () => (/* reexport */ Renderable/* Renderable */.l),
  ReplayLog: () => (/* reexport */ Replay/* ReplayLog */.s),
  ReplayPlayback: () => (/* reexport */ ReplayPlayback),
  Ring: () => (/* reexport */ Ring/* Ring */.J),
  RingOfEndurance: () => (/* reexport */ equipment.RingOfEndurance),
  RingOfSufferingImbued: () => (/* reexport */ equipment.RingOfSufferingImbued),
  RobinHoodHat: () => (/* reexport */ equipment.RobinHoodHat),
  RubyBoltsE: () => (/* reexport */ equipment.RubyBoltsE),
  RuneCrossbow: () => (/* reexport */ equipment.RuneCrossbow),
  RuneKiteshield: () => (/* reexport */ equipment.RuneKiteshield),
  SEMANTIC_POSE_MAP: () => (/* reexport */ CacheAssets/* SEMANTIC_POSE_MAP */.Ew),
  SETTINGS_STORAGE_KEY: () => (/* reexport */ Settings/* SETTINGS_STORAGE_KEY */.o),
  SaradominBody: () => (/* reexport */ equipment.SaradominBody),
  SaradominBrew: () => (/* reexport */ items.SaradominBrew),
  SaradominChaps: () => (/* reexport */ equipment.SaradominChaps),
  SaradominCoif: () => (/* reexport */ equipment.SaradominCoif),
  SaradominDhideBoots: () => (/* reexport */ equipment.SaradominDhideBoots),
  SaradominGodsword: () => (/* reexport */ weapons.SaradominGodsword),
  ScytheOfVitur: () => (/* reexport */ weapons.ScytheOfVitur),
  SeekingDragonArrows: () => (/* reexport */ equipment.SeekingDragonArrows),
  SerializePlayerStats: () => (/* reexport */ PlayerStats/* SerializePlayerStats */.H),
  SetEffect: () => (/* reexport */ SetEffect/* SetEffect */.u),
  SetEffectTypes: () => (/* reexport */ SetEffect/* SetEffectTypes */.F),
  Settings: () => (/* reexport */ Settings/* Settings */.w),
  SettingsControls: () => (/* reexport */ SettingsControls),
  SettingsStore: () => (/* reexport */ SettingsStore/* SettingsStore */.rV),
  Shark: () => (/* reexport */ items.Shark),
  SlayerHelmet: () => (/* reexport */ equipment.SlayerHelmet),
  Sound: () => (/* reexport */ SoundCache/* Sound */.A),
  SoundCache: () => (/* reexport */ SoundCache/* SoundCache */.U),
  StaminaPotion: () => (/* reexport */ items.StaminaPotion),
  StandardSpellbookControls: () => (/* reexport */ StandardSpellbookControls),
  StatsControls: () => (/* reexport */ StatsControls),
  SuperCombatPotion: () => (/* reexport */ items.SuperCombatPotion),
  SuperRestore: () => (/* reexport */ items.SuperRestore),
  TestNpc: () => (/* reexport */ TestNpc),
  TestRegion: () => (/* reexport */ TestRegion),
  TileMarker: () => (/* reexport */ TileMarker/* TileMarker */.l),
  TileMarkerModel: () => (/* reexport */ TileMarkerModel/* TileMarkerModel */.U),
  ToggleButton: () => (/* reexport */ ToggleButton),
  TorvaFullhelm: () => (/* reexport */ equipment.TorvaFullhelm),
  TorvaPlatebody: () => (/* reexport */ equipment.TorvaPlatebody),
  TorvaPlatelegs: () => (/* reexport */ equipment.TorvaPlatelegs),
  Trainer: () => (/* reexport */ Trainer/* Trainer */.c),
  TrainerInstance: () => (/* reexport */ TrainerInstance),
  TumekensShadow: () => (/* reexport */ weapons.TumekensShadow),
  TwistedBow: () => (/* reexport */ weapons.TwistedBow),
  UltorRing: () => (/* reexport */ equipment.UltorRing),
  Unit: () => (/* reexport */ Unit/* Unit */.Nf),
  UnitEquipment: () => (/* reexport */ Unit/* UnitEquipment */.v5),
  UnitTypes: () => (/* reexport */ Unit/* UnitTypes */.eK),
  VenatorBow: () => (/* reexport */ weapons.VenatorBow),
  VenatorRing: () => (/* reexport */ equipment.VenatorRing),
  Viewport: () => (/* reexport */ Viewport),
  Viewport2d: () => (/* reexport */ Viewport2d),
  Viewport3d: () => (/* reexport */ Viewport3d),
  Weapon: () => (/* reexport */ Weapon/* Weapon */.R),
  World: () => (/* reexport */ World),
  XpDrop: () => (/* reexport */ XpDrop/* XpDrop */.i),
  XpDropController: () => (/* reexport */ XpDropController/* XpDropController */.O),
  ZaryteVambraces: () => (/* reexport */ equipment.ZaryteVambraces),
  ZombieAxe: () => (/* reexport */ weapons.ZombieAxe),
  __assets_mock: () => (/* reexport */ Assets_namespaceObject),
  __sound_cache_mock: () => (/* reexport */ SoundCache_namespaceObject),
  cacheRenderItemKey: () => (/* reexport */ CacheRenderReference/* cacheRenderItemKey */.T),
  cacheSound: () => (/* reexport */ CacheSoundEffects/* cacheSound */.cp),
  createJsonSettingsStorage: () => (/* reexport */ SettingsStore/* createJsonSettingsStorage */.HC),
  createSettingsStore: () => (/* reexport */ SettingsStore/* createSettingsStore */.JG),
  createTileIndicator: () => (/* reexport */ RenderUtils/* createTileIndicator */.Ov),
  drawLineNormally: () => (/* reexport */ RenderUtils/* drawLineNormally */.zH),
  drawLineOnTop: () => (/* reexport */ RenderUtils/* drawLineOnTop */.Ho),
  isCacheSound: () => (/* reexport */ CacheSoundEffects/* isCacheSound */.w5),
  loadLoadoutRegistry: () => (/* reexport */ loadLoadoutRegistry),
  mergeProjectileOptions: () => (/* reexport */ Projectile/* mergeProjectileOptions */.K7),
  parseSoundEffectPack: () => (/* reexport */ CacheSoundEffects/* parseSoundEffectPack */.rA),
  parseText: () => (/* reexport */ Text/* parseText */.r),
  synthesizeCacheSound: () => (/* reexport */ CacheSoundEffects/* synthesizeCacheSound */.Uz),
  validateCacheRenderBundleManifest: () => (/* reexport */ CacheRenderBundle/* validateCacheRenderBundleManifest */.og)
});

// NAMESPACE OBJECT: ./src/sdk/utils/__mocks__/Assets.ts
var Assets_namespaceObject = {};
__webpack_require__.r(Assets_namespaceObject);
__webpack_require__.d(Assets_namespaceObject, {
  Assets: () => (Assets_Assets)
});

// NAMESPACE OBJECT: ./src/sdk/utils/__mocks__/SoundCache.ts
var SoundCache_namespaceObject = {};
__webpack_require__.r(SoundCache_namespaceObject);
__webpack_require__.d(SoundCache_namespaceObject, {
  Sound: () => (Sound),
  SoundCache: () => (SoundCache_SoundCache)
});

// EXTERNAL MODULE: ./src/sdk/LineOfSight.ts
var LineOfSight = __webpack_require__(8499);
// EXTERNAL MODULE: ./src/sdk/Pathing.ts
var Pathing = __webpack_require__(5454);
// EXTERNAL MODULE: ./src/sdk/Interpolation.ts
var Interpolation = __webpack_require__(8825);
// EXTERNAL MODULE: ./src/sdk/Collision.ts
var Collision = __webpack_require__(5843);
// EXTERNAL MODULE: ./src/sdk/Entity.ts
var Entity = __webpack_require__(1184);
// EXTERNAL MODULE: ./src/sdk/GraphicsObject.ts
var GraphicsObject = __webpack_require__(7245);
// EXTERNAL MODULE: ./src/sdk/Unit.ts + 3 modules
var Unit = __webpack_require__(3016);
// EXTERNAL MODULE: ./src/sdk/Mob.ts
var Mob = __webpack_require__(5397);
// EXTERNAL MODULE: ./src/sdk/Player.ts + 2 modules
var Player = __webpack_require__(2431);
// EXTERNAL MODULE: ./src/sdk/weapons/RangedWeapon.ts
var RangedWeapon = __webpack_require__(2022);
;// CONCATENATED MODULE: ./src/sdk/weapons/AoeRangedWeapon.ts
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

// A Range weapon that can hit any unit in the radius, without requiring direct LOS of the target.
// Example: Dinh's Bulwark, Verzik auto attacks.
var AoeRangedWeapon = /** @class */ (function (_super) {
    __extends(AoeRangedWeapon, _super);
    function AoeRangedWeapon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AoeRangedWeapon.prototype, "isAreaAttack", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return AoeRangedWeapon;
}(RangedWeapon/* RangedWeapon */.I));


// EXTERNAL MODULE: ./src/sdk/weapons/BarrageSpell.ts
var BarrageSpell = __webpack_require__(3891);
// EXTERNAL MODULE: ./src/sdk/weapons/BloodBarrageSpell.ts
var BloodBarrageSpell = __webpack_require__(8603);
// EXTERNAL MODULE: ./src/sdk/ItemName.ts
var ItemName = __webpack_require__(243);
// EXTERNAL MODULE: ./src/sdk/utils/SoundCache.ts
var SoundCache = __webpack_require__(6018);
// EXTERNAL MODULE: ./src/sdk/audio/CacheSoundEffects.ts + 1 modules
var CacheSoundEffects = __webpack_require__(5432);
// EXTERNAL MODULE: ./src/assets/CacheAssets.ts
var CacheAssets = __webpack_require__(4655);
;// CONCATENATED MODULE: ./src/sdk/weapons/IceBarrageSpell.ts
var IceBarrageSpell_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var IceBarrageSpell = /** @class */ (function (_super) {
    IceBarrageSpell_extends(IceBarrageSpell, _super);
    function IceBarrageSpell(projectileRules) {
        var _this = _super.call(this, projectileRules) || this;
        SoundCache/* SoundCache */.U.preload(_this.attackSound.src);
        SoundCache/* SoundCache */.U.preload(_this.attackLandingSound.src);
        return _this;
    }
    Object.defineProperty(IceBarrageSpell.prototype, "attackSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.iceBarrageCast.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IceBarrageSpell.prototype, "attackLandingSound", {
        get: function () {
            return new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(CacheAssets/* CACHE_ASSETS */.fc.sounds.iceBarrageImpact.id), 0.1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IceBarrageSpell.prototype, "itemName", {
        get: function () {
            return ItemName/* ItemName */.P.ICE_BARRAGE;
        },
        enumerable: false,
        configurable: true
    });
    IceBarrageSpell.prototype.attack = function (from, to, bonuses, options) {
        if (bonuses === void 0) { bonuses = {}; }
        if (options === void 0) { options = {}; }
        _super.prototype.attack.call(this, from, to, bonuses, options);
        if (this.lastHitHit) {
            to.freeze(32);
        }
        return true;
    };
    return IceBarrageSpell;
}(BarrageSpell/* BarrageSpell */.v));


// EXTERNAL MODULE: ./src/sdk/weapons/MagicWeapon.ts
var MagicWeapon = __webpack_require__(5550);
// EXTERNAL MODULE: ./src/sdk/weapons/MeleeWeapon.ts
var MeleeWeapon = __webpack_require__(8109);
// EXTERNAL MODULE: ./src/sdk/weapons/Projectile.ts
var Projectile = __webpack_require__(2402);
// EXTERNAL MODULE: ./src/sdk/weapons/PoweredStaff.ts
var PoweredStaff = __webpack_require__(3555);
// EXTERNAL MODULE: ./src/sdk/AttackStylesController.ts + 27 modules
var AttackStylesController = __webpack_require__(186);
// EXTERNAL MODULE: ./src/sdk/BasePrayer.ts
var BasePrayer = __webpack_require__(165);
// EXTERNAL MODULE: ./src/assets/images/xpdrops/attack.png
var attack = __webpack_require__(2229);
// EXTERNAL MODULE: ./src/assets/images/xpdrops/strength.png
var strength = __webpack_require__(3318);
// EXTERNAL MODULE: ./src/assets/images/xpdrops/defence.png
var defence = __webpack_require__(29);
// EXTERNAL MODULE: ./src/assets/images/xpdrops/range.png
var range = __webpack_require__(4290);
// EXTERNAL MODULE: ./src/assets/images/xpdrops/magic.png
var magic = __webpack_require__(8260);
// EXTERNAL MODULE: ./src/sdk/utils/ImageLoader.ts
var ImageLoader = __webpack_require__(2987);
// EXTERNAL MODULE: ./src/sdk/Trainer.ts
var Trainer = __webpack_require__(6374);
;// CONCATENATED MODULE: ./src/sdk/BoostPanel.ts








var BOOST_VISIBLE_STATS = [
    "attack",
    "strength",
    "defence",
    "range",
    "magic",
];
var BOOST_IMAGE_SRC = {
    "attack": attack,
    "strength": strength,
    "defence": defence,
    "range": range,
    "magic": magic,
};
var BOOST_IMAGES = {};
Object.entries(BOOST_IMAGE_SRC).forEach(function (_a) {
    var skill = _a[0], src = _a[1];
    BOOST_IMAGES[skill] = ImageLoader/* ImageLoader */.$.createImage(src);
});
var BoostPanel = /** @class */ (function () {
    function BoostPanel() {
    }
    BoostPanel.prototype.draw = function (context, scale, xLeft, yBottom) {
        var player = Trainer/* Trainer */.c.player;
        if (!player) {
            return;
        }
        context.save();
        var boostedStats = BOOST_VISIBLE_STATS.filter(function (stat) { return player.currentStats[stat] !== player.stats[stat]; });
        context.globalAlpha = 0.5;
        context.fillStyle = "black";
        var CELL_SIZE = 24;
        var width = scale * CELL_SIZE;
        var height = scale * CELL_SIZE * boostedStats.length;
        context.fillRect(xLeft, yBottom - height, width, height);
        context.globalAlpha = 1;
        var y = yBottom - scale * CELL_SIZE;
        context.font = "".concat(scale * 12, "px OSRS");
        context.textAlign = "center";
        context.textBaseline = "middle";
        for (var _i = 0, boostedStats_1 = boostedStats; _i < boostedStats_1.length; _i++) {
            var boostedStat = boostedStats_1[_i];
            var current = player.currentStats[boostedStat];
            var target = player.stats[boostedStat];
            context.drawImage(BOOST_IMAGES[boostedStat], xLeft, y, scale * CELL_SIZE, scale * CELL_SIZE);
            context.fillStyle = "black";
            context.fillText("".concat(current), xLeft + (scale * CELL_SIZE) / 2 + 1, y + (scale * CELL_SIZE) / 2 + 1);
            if (current < target) {
                context.fillStyle = "red";
            }
            else {
                context.fillStyle = "lime";
            }
            context.fillText("".concat(current), xLeft + (scale * CELL_SIZE) / 2, y + (scale * CELL_SIZE) / 2);
            y -= scale * CELL_SIZE;
        }
        context.restore();
    };
    return BoostPanel;
}());


;// CONCATENATED MODULE: ./src/sdk/Chrome.ts
var Chrome = /** @class */ (function () {
    function Chrome() {
    }
    Chrome.size = function () {
        // TODO: this is a 'legacy' hook for UI elements to read the canvas size. Should be removed
        // and they should be reading the size from Viewport instead.
        var canvas = document.getElementById("world");
        var bounds = canvas === null || canvas === void 0 ? void 0 : canvas.getBoundingClientRect();
        var width = (bounds === null || bounds === void 0 ? void 0 : bounds.width) || window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var height = (bounds === null || bounds === void 0 ? void 0 : bounds.height) || window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        return { width: width, height: height };
    };
    return Chrome;
}());


;// CONCATENATED MODULE: ./src/assets/images/interface/yellow_x_1.png
const yellow_x_1_namespaceObject = __webpack_require__.p + "9644628783e3944e683a.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/yellow_x_2.png
const yellow_x_2_namespaceObject = __webpack_require__.p + "459550810d5d6f723b74.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/yellow_x_3.png
const yellow_x_3_namespaceObject = __webpack_require__.p + "e6e38cf37e3ffe37e429.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/yellow_x_4.png
const yellow_x_4_namespaceObject = __webpack_require__.p + "4f4b9d50a01f72e78727.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/red_x_1.png
const red_x_1_namespaceObject = __webpack_require__.p + "19aff667ef7e1ef2dd66.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/red_x_2.png
const red_x_2_namespaceObject = __webpack_require__.p + "546a8577d1f09ae30b64.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/red_x_3.png
const red_x_3_namespaceObject = __webpack_require__.p + "d34bb88817b4743182e3.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/red_x_4.png
const red_x_4_namespaceObject = __webpack_require__.p + "7fa3d703bcb27a25f689.png";
;// CONCATENATED MODULE: ./src/sdk/ClickAnimation.ts









var ClickAnimation = /** @class */ (function () {
    function ClickAnimation(color, x, y) {
        this.color = color;
        this.x = x;
        this.y = y;
        this.ttl = 1;
    }
    ClickAnimation.prototype.draw = function (context, fps) {
        if (this.ttl <= 0) {
            return;
        }
        var frameNumber = Math.floor((1 - this.ttl) * 4);
        var frames = this.color === "red" ? ClickAnimation.frames.red : ClickAnimation.frames.yellow;
        context.drawImage(frames[frameNumber], this.x - 9, this.y - 9);
        this.ttl -= 1.65 / fps;
    };
    ClickAnimation.frames = {
        red: [
            ImageLoader/* ImageLoader */.$.createImage(red_x_1_namespaceObject),
            ImageLoader/* ImageLoader */.$.createImage(red_x_2_namespaceObject),
            ImageLoader/* ImageLoader */.$.createImage(red_x_3_namespaceObject),
            ImageLoader/* ImageLoader */.$.createImage(red_x_4_namespaceObject),
        ],
        yellow: [
            ImageLoader/* ImageLoader */.$.createImage(yellow_x_1_namespaceObject),
            ImageLoader/* ImageLoader */.$.createImage(yellow_x_2_namespaceObject),
            ImageLoader/* ImageLoader */.$.createImage(yellow_x_3_namespaceObject),
            ImageLoader/* ImageLoader */.$.createImage(yellow_x_4_namespaceObject),
        ],
    };
    return ClickAnimation;
}());


// EXTERNAL MODULE: ./src/sdk/Replay.ts
var Replay = __webpack_require__(7036);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(2543);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./src/content/TileMarker.ts
var TileMarker = __webpack_require__(754);
// EXTERNAL MODULE: ./src/sdk/EntityName.ts
var EntityName = __webpack_require__(5275);
// EXTERNAL MODULE: ./src/sdk/Settings.ts
var Settings = __webpack_require__(8406);
;// CONCATENATED MODULE: ./src/sdk/ContextMenu.ts
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};


var ContextMenu = /** @class */ (function () {
    function ContextMenu() {
        this.isActive = false;
        this.location = { x: 0, y: 0 };
        this.cursorPosition = { x: 0, y: 0 };
        this.activatedPosition = { x: 0, y: 0 };
        this.width = 0;
        this.height = 0;
        this.menuOptions = [];
        this.linesOfText = [];
    }
    ContextMenu.prototype.setPosition = function (position) {
        this.location = position;
    };
    ContextMenu.prototype.setActive = function () {
        this.isActive = true;
    };
    ContextMenu.prototype.setInactive = function () {
        this.isActive = false;
    };
    ContextMenu.prototype.setMenuOptions = function (menuOptions) {
        this.menuOptions = menuOptions;
    };
    ContextMenu.prototype.cursorMovedTo = function (x, y) {
        var cRect = Viewport.viewport.canvas.getBoundingClientRect(); // Gets CSS pos, and width/height
        var canvasX = Math.round(x - cRect.left); // Subtract the 'left' of the canvas
        var canvasY = Math.round(y - cRect.top); // from the X/Y positions to make
        this.cursorPosition.x = canvasX;
        this.cursorPosition.y = canvasY;
        // cursor veering too far away, make inactive again
        if (Math.abs(canvasX - this.location.x) > this.width * 0.6) {
            this.setInactive();
        }
        if (canvasY - this.location.y < -10 || canvasY - this.location.y > this.height * 1.2) {
            this.setInactive();
        }
    };
    ContextMenu.prototype.draw = function (context) {
        var _this = this;
        if (this.isActive) {
            this.linesOfText = __spreadArray(__spreadArray([
                {
                    text: [{ text: "Choose Option", fillStyle: "#5f5445" }],
                    action: function () {
                        Trainer/* Trainer */.c.clickController.yellowClick();
                    },
                }
            ], this.menuOptions, true), [
                {
                    text: [{ text: "Cancel", fillStyle: "white" }],
                    action: function () {
                        Trainer/* Trainer */.c.clickController.yellowClick();
                    },
                },
            ], false);
            context.textAlign = "left";
            context.font = "17px OSRS";
            this.width = 0;
            this.linesOfText.forEach(function (line) {
                _this.width = Math.max(_this.width, _this.fillMixedTextWidth(context, line.text) + 10);
            });
            this.height = 22 + (this.linesOfText.length - 1) * 20;
            context.fillStyle = "#5f5445";
            context.fillRect(this.location.x - this.width / 2, this.location.y, this.width, this.height);
            context.fillStyle = "black";
            context.fillRect(this.location.x - this.width / 2 + 1, this.location.y + 1, this.width - 2, 17);
            context.lineWidth = 1;
            context.strokeStyle = "black";
            context.strokeRect(this.location.x - this.width / 2 + 2, this.location.y + 20, this.width - 4, this.height - 22);
            for (var i = 0; i < this.linesOfText.length; i++) {
                this.drawLineOfText(context, this.linesOfText[i].text, this.width, i * 20);
            }
        }
        context.restore();
    };
    ContextMenu.prototype.fillMixedText = function (ctx, text, x, y, inputColor) {
        var defaultFillStyle = ctx.fillStyle;
        var defaultFont = ctx.font;
        ctx.save();
        text.forEach(function (_a) {
            var text = _a.text, fillStyle = _a.fillStyle, font = _a.font;
            ctx.font = font || defaultFont;
            ctx.fillStyle = "black";
            ctx.fillText(text, x + 1, y + 1);
            if (fillStyle === "white") {
                ctx.fillStyle = inputColor;
            }
            else {
                ctx.fillStyle = fillStyle || defaultFillStyle;
            }
            ctx.fillText(text, x, y);
            x += ctx.measureText(text).width;
        });
        ctx.restore();
    };
    ContextMenu.prototype.fillMixedTextWidth = function (ctx, text) {
        var defaultFillStyle = ctx.fillStyle;
        var defaultFont = ctx.font;
        var x = 0;
        text.forEach(function (_a) {
            var text = _a.text, fillStyle = _a.fillStyle, font = _a.font;
            ctx.fillStyle = fillStyle || defaultFillStyle;
            ctx.font = font || defaultFont;
            x += ctx.measureText(text).width;
        });
        return x;
    };
    ContextMenu.prototype.drawLineOfText = function (ctx, text, width, y) {
        var isXAligned = this.cursorPosition.x > this.location.x - width / 2 && this.cursorPosition.x < this.location.x + width / 2;
        var isYAligned = this.cursorPosition.y > this.location.y + y + 2 && this.cursorPosition.y < this.location.y + 21 + y;
        var isHovered = isXAligned && isYAligned;
        this.fillMixedText(ctx, text, this.location.x - width / 2 + 4, this.location.y + 15 + y, isHovered ? "yellow" : "white");
    };
    ContextMenu.prototype.clicked = function (x, y) {
        var index = Math.floor((y - this.location.y) / 20);
        this.linesOfText[index].action();
    };
    return ContextMenu;
}());


;// CONCATENATED MODULE: ./src/assets/images/panels/inventory.png
const inventory_namespaceObject = __webpack_require__.p + "18150e2ac6a8a966226e.png";
;// CONCATENATED MODULE: ./src/assets/images/tabs/account.png
const account_namespaceObject = __webpack_require__.p + "1f12f0ce4e42733b2bf9.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/BaseControls.ts


var BaseControls = /** @class */ (function () {
    function BaseControls() {
        this.panelImage = ImageLoader/* ImageLoader */.$.createImage(this.panelImageReference);
        this.tabImage = ImageLoader/* ImageLoader */.$.createImage(this.tabImageReference);
        this.selected = false;
    }
    Object.defineProperty(BaseControls.prototype, "keyBinding", {
        get: function () {
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseControls.prototype, "isAvailable", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseControls.prototype, "panelImageReference", {
        get: function () {
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseControls.prototype, "tabImageReference", {
        get: function () {
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseControls.prototype, "appearsOnLeftInMobile", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    BaseControls.prototype.cursorMovedto = function (x, y) {
        // Override me
    };
    BaseControls.prototype.hoverAction = function (x, y) {
        return null;
    };
    BaseControls.prototype.panelRightClick = function (x, y) {
        // Override me
    };
    BaseControls.prototype.panelClickDown = function (x, y) {
        //
    };
    BaseControls.prototype.panelClickUp = function (x, y) {
        //
    };
    // called when the mouse is released, even outside the panel
    BaseControls.prototype.onMouseUp = function () {
        //
    };
    BaseControls.prototype.onWorldTick = function () {
        // Override me
    };
    BaseControls.prototype.draw = function (context, ctrl, x, y) {
        var scale = Settings/* Settings */.w.controlPanelScale;
        if (this.panelImage) {
            context.drawImage(this.panelImage, x, y, 204 * scale, 275 * scale);
        }
    };
    return BaseControls;
}());


;// CONCATENATED MODULE: ./src/sdk/controlpanels/AccountControls.ts
var AccountControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var AccountControls = /** @class */ (function (_super) {
    AccountControls_extends(AccountControls, _super);
    function AccountControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AccountControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccountControls.prototype, "tabImageReference", {
        get: function () {
            return account_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return AccountControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/standard_spellbook.png
const standard_spellbook_namespaceObject = __webpack_require__.p + "fb7c82526615db589b4c.png";
;// CONCATENATED MODULE: ./src/assets/images/panels/ancients.png
const ancients_namespaceObject = __webpack_require__.p + "36082bf32dd148238984.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/AncientsSpellbookControls.ts
var AncientsSpellbookControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var AncientsSpellbookControls = /** @class */ (function (_super) {
    AncientsSpellbookControls_extends(AncientsSpellbookControls, _super);
    function AncientsSpellbookControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AncientsSpellbookControls.prototype, "panelImageReference", {
        get: function () {
            return ancients_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientsSpellbookControls.prototype, "tabImageReference", {
        get: function () {
            // Need to extract the other images later
            return standard_spellbook_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientsSpellbookControls.prototype, "keyBinding", {
        get: function () {
            return Settings/* Settings */.w.spellbook_key;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AncientsSpellbookControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    AncientsSpellbookControls.prototype.panelClickDown = function (x, y) {
        Trainer/* Trainer */.c.player.manualSpellCastSelection = null;
        var scale = Settings/* Settings */.w.controlPanelScale;
        x = x / scale;
        y = y / scale;
        if (x >= 21 && x <= 42 && y >= 229 && y <= 249) {
            Trainer/* Trainer */.c.player.manualSpellCastSelection = new IceBarrageSpell();
        }
        else if (x >= 166 && x <= 187 && y >= 194 && y <= 214) {
            Trainer/* Trainer */.c.player.manualSpellCastSelection = new BloodBarrageSpell/* BloodBarrageSpell */.h();
        }
    };
    AncientsSpellbookControls.prototype.draw = function (context, ctrl, x, y) {
        _super.prototype.draw.call(this, context, ctrl, x, y);
        context.fillStyle = "#D1BB7773";
        var scale = Settings/* Settings */.w.controlPanelScale;
        if (Trainer/* Trainer */.c.player.manualSpellCastSelection) {
            if (Trainer/* Trainer */.c.player.manualSpellCastSelection.itemName === ItemName/* ItemName */.P.ICE_BARRAGE) {
                context.fillRect(x + 20 * scale, y + 225 * scale, 21 * scale, 21 * scale);
            }
            else if (Trainer/* Trainer */.c.player.manualSpellCastSelection.itemName === ItemName/* ItemName */.P.BLOOD_BARRAGE) {
                context.fillRect(x + 164 * scale, y + 188 * scale, 21 * scale, 21 * scale);
            }
        }
    };
    return AncientsSpellbookControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/clanchat.png
const clanchat_namespaceObject = __webpack_require__.p + "ef9dfa98c2b20b493684.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/ClanChatControls.ts
var ClanChatControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var ClanChatControls = /** @class */ (function (_super) {
    ClanChatControls_extends(ClanChatControls, _super);
    function ClanChatControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ClanChatControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClanChatControls.prototype, "tabImageReference", {
        get: function () {
            return clanchat_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return ClanChatControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/combat.png
const combat_namespaceObject = __webpack_require__.p + "567618a209a019add02b.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/interface/attack_style_button_highlighted.png
const attack_style_button_highlighted_namespaceObject = __webpack_require__.p + "e9d9d5b457be25fc56bf.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/interface/attack_style_button.png
const attack_style_button_namespaceObject = __webpack_require__.p + "e2d12881d5103270f71a.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/interface/auto_retal_button_highlighted.png
const auto_retal_button_highlighted_namespaceObject = __webpack_require__.p + "b5acb96712bcc3ae2209.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/interface/auto_retal_button.png
const auto_retal_button_namespaceObject = __webpack_require__.p + "e9f0f7bddc48ae1bbe71.png";
;// CONCATENATED MODULE: ./src/assets/images/attackstyles/interface/special_attack_background.png
const special_attack_background_namespaceObject = __webpack_require__.p + "9b389be090818faed9d3.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/CombatControls.ts
var CombatControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














var CombatControls = /** @class */ (function (_super) {
    CombatControls_extends(CombatControls, _super);
    function CombatControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectedCombatStyleButtonImage = ImageLoader/* ImageLoader */.$.createImage(attack_style_button_highlighted_namespaceObject);
        _this.combatStyleButtonImage = ImageLoader/* ImageLoader */.$.createImage(attack_style_button_namespaceObject);
        _this.autoRetailButtonImage = ImageLoader/* ImageLoader */.$.createImage(auto_retal_button_namespaceObject);
        _this.selectedAutoRetailButtonImage = ImageLoader/* ImageLoader */.$.createImage(auto_retal_button_highlighted_namespaceObject);
        _this.specialAttackBarBackground = ImageLoader/* ImageLoader */.$.createImage(special_attack_background_namespaceObject);
        return _this;
    }
    Object.defineProperty(CombatControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombatControls.prototype, "tabImageReference", {
        get: function () {
            return combat_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CombatControls.prototype, "keyBinding", {
        get: function () {
            return Settings/* Settings */.w.combat_key;
        },
        enumerable: false,
        configurable: true
    });
    CombatControls.prototype.updateStats = function (playerStats) {
        this.playerStats = playerStats;
    };
    CombatControls.prototype.panelClickDown = function (x, y) {
        var scale = Settings/* Settings */.w.controlPanelScale;
        x = x / scale;
        y = y / scale;
        var attackStyleOffsets = [
            { x: 25, y: 45 },
            { x: 105, y: 45 },
            { x: 25, y: 100 },
            { x: 105, y: 100 },
        ];
        var weapon = Trainer/* Trainer */.c.player.equipment.weapon;
        var attackStyles = weapon.attackStyles();
        attackStyleOffsets.slice(0, attackStyles.length).forEach(function (offset, index) {
            if (offset.x < x && x < offset.x + 70 && offset.y < y && y < offset.y + 48) {
                AttackStylesController/* AttackStylesController */.D2.controller.setWeaponAttackStyle(weapon, attackStyles[index]);
                Replay/* ReplayLog */.s.recordImmediate({ kind: "attackStyle", index: index });
            }
        });
        if (x > 28 && x < 175 && y > 160 && y < 200) {
            Trainer/* Trainer */.c.player.autoRetaliate = !Trainer/* Trainer */.c.player.autoRetaliate;
            Replay/* ReplayLog */.s.recordImmediate({ kind: "autoRetaliate" });
        }
        if (x > 25 &&
            y > 210 &&
            x < 25 + this.specialAttackBarBackground.width &&
            y < 210 + this.specialAttackBarBackground.height) {
            var canSpec = Trainer/* Trainer */.c.player.equipment.weapon && Trainer/* Trainer */.c.player.equipment.weapon.hasSpecialAttack();
            if (canSpec) {
                Trainer/* Trainer */.c.player.useSpecialAttack = !Trainer/* Trainer */.c.player.useSpecialAttack;
                Replay/* ReplayLog */.s.recordImmediate({ kind: "spec" });
            }
        }
    };
    Object.defineProperty(CombatControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    CombatControls.prototype.drawAttackStyleButton = function (context, weapon, attackStyle, attackStyleImage, x, y) {
        var scale = Settings/* Settings */.w.controlPanelScale;
        var currentAttackStyle = weapon.attackStyle();
        var currentAttackStyleImage = currentAttackStyle === attackStyle ? this.selectedCombatStyleButtonImage : this.combatStyleButtonImage;
        context.drawImage(currentAttackStyleImage, x, y, currentAttackStyleImage.width * scale, currentAttackStyleImage.height * scale);
        context.drawImage(attackStyleImage, x + (35 - Math.floor(attackStyleImage.width / 2)) * scale, y + 5 * scale, attackStyleImage.width * scale, attackStyleImage.height * scale);
        context.font = 16 * scale + "px Stats_11";
        context.textAlign = "center";
        context.fillStyle = "#000";
        context.fillText((0,lodash.startCase)((0,lodash.toLower)(attackStyle)), x + 36 * scale, y + 41 * scale);
        context.fillStyle = "#FF9700";
        context.fillText((0,lodash.startCase)((0,lodash.toLower)(attackStyle)), x + 35 * scale, y + 40 * scale);
    };
    CombatControls.prototype.draw = function (context, ctrl, x, y) {
        var _this = this;
        var _a, _b;
        _super.prototype.draw.call(this, context, ctrl, x, y);
        var scale = Settings/* Settings */.w.controlPanelScale;
        var weapon = Trainer/* Trainer */.c.player.equipment.weapon;
        if (!weapon) {
            return;
        }
        context.font = 21 * scale + "px Stats_11";
        context.textAlign = "center";
        context.fillStyle = "#000";
        context.fillText((0,lodash.startCase)((0,lodash.toLower)(weapon.itemName)), x + 101 * scale, y + 31 * scale);
        context.fillStyle = "#FF9700";
        context.fillText((0,lodash.startCase)((0,lodash.toLower)(weapon.itemName)), x + 100 * scale, y + 30 * scale);
        var attackStyleOffsets = [
            { x: 25, y: 45 },
            { x: 105, y: 45 },
            { x: 25, y: 100 },
            { x: 105, y: 100 },
        ];
        var attackStyles = weapon.attackStyles();
        var imageMap = AttackStylesController/* AttackStylesController */.D2.attackStyleImageMap[weapon.attackStyleCategory()];
        if (imageMap) {
            attackStyles.forEach(function (style, index) {
                var offsets = attackStyleOffsets[index];
                var attackStyleImage = imageMap[weapon.attackStyles()[index]];
                if (attackStyleImage) {
                    _this.drawAttackStyleButton(context, weapon, weapon.attackStyles()[index], attackStyleImage, x + offsets.x * scale, y + offsets.y * scale);
                }
            });
        }
        var autoRetailateImage = Trainer/* Trainer */.c.player.autoRetaliate
            ? this.selectedAutoRetailButtonImage
            : this.autoRetailButtonImage;
        context.drawImage(autoRetailateImage, x + 25 * scale, y + 155 * scale, autoRetailateImage.width * scale, autoRetailateImage.height * scale);
        context.font = 19 * scale + "px Stats_11";
        context.textAlign = "center";
        context.fillStyle = "#000";
        context.fillText("Auto Retaliate", x + 116 * scale, y + 183 * scale);
        context.fillStyle = "#FF9700";
        context.fillText("Auto Retaliate", x + 115 * scale, y + 182 * scale);
        var canSpec = Trainer/* Trainer */.c.player.equipment.weapon && Trainer/* Trainer */.c.player.equipment.weapon.hasSpecialAttack();
        var isUsingSpec = canSpec && Trainer/* Trainer */.c.player.useSpecialAttack;
        if (canSpec) {
            var specAmount = ((_b = (_a = Trainer/* Trainer */.c.player) === null || _a === void 0 ? void 0 : _a.currentStats.specialAttack) !== null && _b !== void 0 ? _b : 0.0) / 100.0;
            context.drawImage(this.specialAttackBarBackground, x + 25 * scale, y + 210 * scale, this.specialAttackBarBackground.width * scale, this.specialAttackBarBackground.height * scale);
            context.fillStyle = "#730606";
            context.fillRect(x + 28 * scale, y + 216 * scale, 144 * scale, 14 * scale);
            context.fillStyle = "#397d3b";
            context.fillRect(x + 28 * scale, y + 216 * scale, 144 * scale * specAmount, 14 * scale);
            context.fillStyle = "#000000";
            context.globalAlpha = 0.5;
            context.strokeRect(x + 28 * scale, y + 216 * scale, 144 * scale, 14 * scale);
            context.globalAlpha = 1;
            context.font = "".concat(16 * scale, "px Stats_11");
            context.textAlign = "center";
            context.fillStyle = isUsingSpec ? "#FFFF00" : "#000000";
            context.fillText("Special Attack: ".concat(Math.round(specAmount * 100), "%"), x + 100 * scale, y + 227 * scale);
        }
    };
    return CombatControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/emotes.png
const emotes_namespaceObject = __webpack_require__.p + "069d85c2fc861db5b1b7.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/EmotesControls.ts
var EmotesControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var EmotesControls = /** @class */ (function (_super) {
    EmotesControls_extends(EmotesControls, _super);
    function EmotesControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EmotesControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmotesControls.prototype, "tabImageReference", {
        get: function () {
            return emotes_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return EmotesControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/empty.png
const empty_namespaceObject = __webpack_require__.p + "8607e94d4d31fd19f38e.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/EmptyControls.ts
var EmptyControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var EmptyControls = /** @class */ (function (_super) {
    EmptyControls_extends(EmptyControls, _super);
    function EmptyControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EmptyControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmptyControls.prototype, "tabImageReference", {
        get: function () {
            return empty_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return EmptyControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/interface/equipment_spot_used.png
const equipment_spot_used_namespaceObject = __webpack_require__.p + "1d10f87534406456a4d1.png";
;// CONCATENATED MODULE: ./src/assets/images/panels/equipment.png
const equipment_namespaceObject = __webpack_require__.p + "8a7b4cacdddf24930d0c.png";
;// CONCATENATED MODULE: ./src/assets/images/tabs/equipment.png
const tabs_equipment_namespaceObject = __webpack_require__.p + "8e048a2727d4c0fed3fa.png";
// EXTERNAL MODULE: ./src/sdk/Equipment.ts
var Equipment = __webpack_require__(3107);
// EXTERNAL MODULE: ./src/sdk/Input.ts
var Input = __webpack_require__(4103);
;// CONCATENATED MODULE: ./src/sdk/controlpanels/EquipmentControls.ts
var EquipmentControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var EquipmentControls_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};









var EquipmentControls = /** @class */ (function (_super) {
    EquipmentControls_extends(EquipmentControls, _super);
    function EquipmentControls() {
        var _this = _super.call(this) || this;
        _this.usedSpotBackground = ImageLoader/* ImageLoader */.$.createImage(equipment_spot_used_namespaceObject);
        _this.DEFAULT_EQUIPMENT_INTERACTIONS = [function (slot) { return _this.unequipItem(slot); }];
        _this.equipmentInteractions = EquipmentControls_spreadArray([], _this.DEFAULT_EQUIPMENT_INTERACTIONS, true);
        _this.clickedSlot = null;
        EquipmentControls.instance = _this;
        return _this;
    }
    EquipmentControls.prototype.resetEquipmentInteractions = function () {
        this.equipmentInteractions = EquipmentControls_spreadArray([], this.DEFAULT_EQUIPMENT_INTERACTIONS, true);
    };
    EquipmentControls.prototype.addEquipmentInteraction = function (interaction) {
        this.equipmentInteractions.unshift(interaction);
    };
    Object.defineProperty(EquipmentControls.prototype, "panelImageReference", {
        get: function () {
            return equipment_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EquipmentControls.prototype, "tabImageReference", {
        get: function () {
            return tabs_equipment_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EquipmentControls.prototype, "keyBinding", {
        get: function () {
            return Settings/* Settings */.w.equipment_key;
        },
        enumerable: false,
        configurable: true
    });
    EquipmentControls.prototype.panelClickDown = function (x, y) {
        var _this = this;
        var scale = Settings/* Settings */.w.controlPanelScale;
        x = x / scale;
        y = y / scale;
        var clicked = null;
        if (x > 84 && y > 11 && x < 84 + 36 && y < 11 + 36) {
            // helmet
            clicked = Equipment/* EquipmentTypes */.WA.HELMET;
        }
        else if (x > 43 && y > 50 && x < 43 + 36 && y < 50 + 36) {
            // cape
            clicked = Equipment/* EquipmentTypes */.WA.BACK;
        }
        else if (x > 84 && y > 50 && x < 84 + 36 && y < 50 + 36) {
            // necklace
            clicked = Equipment/* EquipmentTypes */.WA.NECK;
        }
        else if (x > 124 && y > 50 && x < 124 + 36 && y < 50 + 36) {
            // ammo
            clicked = Equipment/* EquipmentTypes */.WA.AMMO;
        }
        else if (x > 28 && y > 89 && x < 28 + 36 && y < 89 + 36) {
            // weapon
            clicked = Equipment/* EquipmentTypes */.WA.WEAPON;
        }
        else if (x > 84 && y > 89 && x < 84 + 36 && y < 89 + 36) {
            // chest
            clicked = Equipment/* EquipmentTypes */.WA.CHEST;
        }
        else if (x > 140 && y > 89 && x < 140 + 36 && y < 89 + 36) {
            // offhand
            clicked = Equipment/* EquipmentTypes */.WA.OFFHAND;
        }
        else if (x > 84 && y > 129 && x < 84 + 36 && y < 129 + 36) {
            // legs
            clicked = Equipment/* EquipmentTypes */.WA.LEGS;
        }
        else if (x > 28 && y > 169 && x < 28 + 36 && y < 169 + 36) {
            // gloves
            clicked = Equipment/* EquipmentTypes */.WA.GLOVES;
        }
        else if (x > 84 && y > 169 && x < 84 + 36 && y < 169 + 36) {
            // feet
            clicked = Equipment/* EquipmentTypes */.WA.FEET;
        }
        else if (x > 140 && y > 169 && x < 140 + 36 && y < 169 + 36) {
            // ring
            clicked = Equipment/* EquipmentTypes */.WA.RING;
        }
        this.clickedSlot = clicked;
        if (clicked) {
            Input/* InputController */.f.controller.queueAction(function () {
                _this.equipmentInteractions[0](clicked);
            }, function () { return ({ kind: "unequip", slot: clicked }); });
        }
    };
    EquipmentControls.prototype.panelClickUp = function () {
        this.clickedSlot = null;
    };
    EquipmentControls.prototype.unequipItem = function (clicked) {
        var _a;
        var equipmentSlot = Equipment/* EQUIPMENT_TYPE_TO_SLOT */.Fm[clicked];
        (_a = Trainer/* Trainer */.c.player.equipment[equipmentSlot]) === null || _a === void 0 ? void 0 : _a.unequip(Trainer/* Trainer */.c.player);
    };
    Object.defineProperty(EquipmentControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EquipmentControls.prototype, "appearsOnLeftInMobile", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    EquipmentControls.prototype.drawEquipment = function (context, x, y, slotX, slotY, scale, slot) {
        var equipmentSlot = Equipment/* EQUIPMENT_TYPE_TO_SLOT */.Fm[slot];
        if (Trainer/* Trainer */.c.player.equipment[equipmentSlot]) {
            context.drawImage(this.usedSpotBackground, x + slotX * scale, y + slotY * scale, this.usedSpotBackground.width * scale, this.usedSpotBackground.height * scale);
            if (this.clickedSlot === slot) {
                context.globalAlpha = 0.5;
            }
            else {
                context.globalAlpha = 1.0;
            }
            var sprite = Trainer/* Trainer */.c.player.equipment[equipmentSlot].inventorySprite;
            context.drawImage(sprite, x + (slotX + 18 - Math.floor(sprite.width / 2)) * scale, y + (slotY + 18 - Math.floor(sprite.height / 2)) * scale, sprite.width * scale, sprite.height * scale);
            context.globalAlpha = 1.0;
        }
    };
    EquipmentControls.prototype.draw = function (context, ctrl, x, y) {
        _super.prototype.draw.call(this, context, ctrl, x, y);
        var scale = Settings/* Settings */.w.controlPanelScale;
        this.drawEquipment(context, x, y, 84, 11, scale, Equipment/* EquipmentTypes */.WA.HELMET);
        this.drawEquipment(context, x, y, 43, 50, scale, Equipment/* EquipmentTypes */.WA.BACK);
        this.drawEquipment(context, x, y, 84, 50, scale, Equipment/* EquipmentTypes */.WA.NECK);
        this.drawEquipment(context, x, y, 124, 50, scale, Equipment/* EquipmentTypes */.WA.AMMO);
        this.drawEquipment(context, x, y, 28, 89, scale, Equipment/* EquipmentTypes */.WA.WEAPON);
        this.drawEquipment(context, x, y, 84, 89, scale, Equipment/* EquipmentTypes */.WA.CHEST);
        this.drawEquipment(context, x, y, 140, 89, scale, Equipment/* EquipmentTypes */.WA.OFFHAND);
        this.drawEquipment(context, x, y, 84, 129, scale, Equipment/* EquipmentTypes */.WA.LEGS);
        this.drawEquipment(context, x, y, 28, 169, scale, Equipment/* EquipmentTypes */.WA.GLOVES);
        this.drawEquipment(context, x, y, 84, 169, scale, Equipment/* EquipmentTypes */.WA.FEET);
        this.drawEquipment(context, x, y, 140, 169, scale, Equipment/* EquipmentTypes */.WA.RING);
        var weight = "Weight: ".concat(Trainer/* Trainer */.c.player.weight.toFixed(3), "kg");
        context.font = 16 * scale + "px Stats_11";
        context.fillStyle = "#000";
        context.fillText(weight, x + 56 * scale, y + 268 * scale);
        context.fillStyle = "#FFFFff";
        context.fillText(weight, x + 55 * scale, y + 267 * scale);
    };
    EquipmentControls.instance = null;
    return EquipmentControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/friends.png
const friends_namespaceObject = __webpack_require__.p + "2caf18f36771b7339d68.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/FriendsControls.ts
var FriendsControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var FriendsControls = /** @class */ (function (_super) {
    FriendsControls_extends(FriendsControls, _super);
    function FriendsControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FriendsControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FriendsControls.prototype, "tabImageReference", {
        get: function () {
            return friends_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return FriendsControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/inventory.png
const tabs_inventory_namespaceObject = __webpack_require__.p + "a74076e4dc99902386b8.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_border.png
const map_border_namespaceObject = __webpack_require__.p + "f6233406c5f4b2624f9e.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_selected_num_orb.png
const map_selected_num_orb_namespaceObject = __webpack_require__.p + "24b37ff1d1aa49ff05b5.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_num_orb.png
const map_num_orb_namespaceObject = __webpack_require__.p + "ff52384590ff0b4bbd6b.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_border_mask.png
const map_border_mask_namespaceObject = __webpack_require__.p + "837464ad52b85c147d03.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/compass.png
const compass_namespaceObject = __webpack_require__.p + "6f1f3f50786a7bb62326.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_hitpoint_orb.png
const map_hitpoint_orb_namespaceObject = __webpack_require__.p + "9e4649d3b9840fac0bc1.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_prayer_orb.png
const map_prayer_orb_namespaceObject = __webpack_require__.p + "d8d30a814b3800fd65e4.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_prayer_on_orb.png
const map_prayer_on_orb_namespaceObject = __webpack_require__.p + "4ed40104ff4863fa4b08.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_run_orb.png
const map_run_orb_namespaceObject = __webpack_require__.p + "c9e2eaa0b3c8a5458c13.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_no_spec_orb.png
const map_no_spec_orb_namespaceObject = __webpack_require__.p + "73d2ce2fbffbe8a3d373.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_spec_orb.png
const map_spec_orb_namespaceObject = __webpack_require__.p + "f1e8f253f786ced20081.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_spec_on_orb.png
const map_spec_on_orb_namespaceObject = __webpack_require__.p + "8cb11164d4024ea68dcf.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_xp_button.png
const map_xp_button_namespaceObject = __webpack_require__.p + "b33f32c14e429e1d69f6.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_xp_hover_button.png
const map_xp_hover_button_namespaceObject = __webpack_require__.p + "463c5089a8aa627173d3.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_hitpoint_icon.png
const map_hitpoint_icon_namespaceObject = __webpack_require__.p + "c77ddb6ca212487bb2b0.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_prayer_icon.png
const map_prayer_icon_namespaceObject = __webpack_require__.p + "f5f2dbf08f6d63906db2.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_walk_icon.png
const map_walk_icon_namespaceObject = __webpack_require__.p + "5000d13f7684a3400c1e.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_run_icon.png
const map_run_icon_namespaceObject = __webpack_require__.p + "c707d2d8c0bafd1019b8.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_stam_icon.png
const map_stam_icon_namespaceObject = __webpack_require__.p + "5a89bcaea8926d0d7756.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/map_spec_icon.png
const map_spec_icon_namespaceObject = __webpack_require__.p + "37366ee3c2ce9bc12b09.png";
// EXTERNAL MODULE: ./node_modules/color-scales/lib/index.js
var lib = __webpack_require__(5416);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/sdk/FixedLayout.ts


/**
 * Geometry of the classic OSRS fixed-mode client. All values are in fixed-client
 * pixels (765x503) and are multiplied by `scale()` to get canvas pixels, the same
 * way RuneLite's Stretched Mode scales the fixed client to fit the window.
 */
var FIXED_WIDTH = 765;
var FIXED_HEIGHT = 503;
// The 3D scene only occupies the top-left of the fixed client.
var FIXED_VIEWPORT = { x: 4, y: 4, width: 512, height: 334 };
var FIXED_CHATBOX = { x: 0, y: 338, width: 519, height: 165 };
// Side panel: a row of 7 tabs above the panel and a row of 7 tabs below it.
var FIXED_TABS_X = 522;
var FIXED_TOP_TABS_Y = 168;
var FIXED_BOTTOM_TABS_Y = 466;
var FIXED_PANEL = { x: 553, y: 205, width: 190, height: 261 };
var FixedLayout = /** @class */ (function () {
    function FixedLayout() {
    }
    Object.defineProperty(FixedLayout, "enabled", {
        get: function () {
            return Settings/* Settings */.w.fixedMode && !Settings/* Settings */.w.mobileCheck();
        },
        enumerable: false,
        configurable: true
    });
    /** Canvas size for a playable area, letterboxed to the fixed client's aspect ratio. */
    FixedLayout.fit = function (width, height) {
        var scale = Math.min(width / FIXED_WIDTH, height / FIXED_HEIGHT);
        return {
            width: Math.max(1, Math.round(FIXED_WIDTH * scale)),
            height: Math.max(1, Math.round(FIXED_HEIGHT * scale)),
        };
    };
    /** Canvas pixels per fixed-client pixel. */
    FixedLayout.scale = function (canvasWidth) {
        return canvasWidth / FIXED_WIDTH;
    };
    FixedLayout.viewportRect = function (canvasWidth) {
        var k = FixedLayout.scale(canvasWidth);
        return {
            x: Math.round(FIXED_VIEWPORT.x * k),
            y: Math.round(FIXED_VIEWPORT.y * k),
            width: Math.round(FIXED_VIEWPORT.width * k),
            height: Math.round(FIXED_VIEWPORT.height * k),
        };
    };
    /** Draw infoboxes right-aligned at the given position in fixed-client pixels. */
    FixedLayout.drawInfoboxes = function (context, k, rightX, topY) {
        var boxes = FixedLayout.infoboxes.map(function (box) { return box(); }).filter(function (box) { return box !== null; });
        boxes.forEach(function (box, index) {
            var size = 32 * k;
            var x = (rightX - 34 * (index + 1)) * k;
            var y = topY * k;
            context.save();
            context.fillStyle = "rgba(70, 61, 50, 0.85)";
            context.fillRect(x, y, size, size);
            context.strokeStyle = "#1e1912";
            context.lineWidth = Math.max(1, k);
            context.strokeRect(x, y, size, size);
            // Tick indicator square, as in the RuneLite Visual Metronome.
            context.fillStyle = box.active ? "#ffffff" : "#000000";
            context.fillRect(x + 12 * k, y + 8 * k, 8 * k, 8 * k);
            context.font = "".concat(Math.round(16 * k), "px OSRS");
            context.textAlign = "center";
            context.fillStyle = "#000000";
            context.fillText(box.text, x + 17 * k, y + 29 * k);
            context.fillStyle = "#ffffff";
            context.fillText(box.text, x + 16 * k, y + 28 * k);
            context.restore();
        });
    };
    /** Append a game message to the fixed-mode chatbox. */
    FixedLayout.addChatMessage = function (text, color) {
        if (color === void 0) { color = "#000000"; }
        FixedLayout.chatMessages.push({ text: text, color: color });
        if (FixedLayout.chatMessages.length > 8)
            FixedLayout.chatMessages.shift();
    };
    /** Draw the stone frame, side panel backing and chatbox around the 3D viewport. */
    FixedLayout.drawFrame = function (context, canvasWidth, canvasHeight) {
        var k = FixedLayout.scale(canvasWidth);
        var view = FixedLayout.viewportRect(canvasWidth);
        context.save();
        // Stone frame: everything that is not the 3D viewport.
        context.fillStyle = "#3e3529";
        context.fillRect(0, 0, canvasWidth, canvasHeight);
        context.fillStyle = "#2b241b";
        context.fillRect(view.x - 2 * k, view.y - 2 * k, view.width + 4 * k, view.height + 4 * k);
        // Side panel backing between the two tab rows.
        context.fillStyle = "#4b4136";
        context.fillRect((FIXED_TABS_X - 2) * k, (FIXED_TOP_TABS_Y + 36) * k, (7 * 33 + 4) * k, (FIXED_BOTTOM_TABS_Y - FIXED_TOP_TABS_Y - 36) * k);
        // Chatbox parchment.
        var chat = FIXED_CHATBOX;
        context.fillStyle = "#2b241b";
        context.fillRect(chat.x * k, chat.y * k, chat.width * k, chat.height * k);
        context.fillStyle = "#cfc08d";
        context.fillRect((chat.x + 7) * k, (chat.y + 7) * k, (chat.width - 14) * k, (chat.height - 37) * k);
        context.fillStyle = "#94866d";
        context.fillRect((chat.x + 7) * k, (chat.y + chat.height - 47) * k, (chat.width - 14) * k, 1 * k);
        // Chat filter buttons strip.
        context.fillStyle = "#1e1912";
        context.fillRect(chat.x * k, (chat.y + chat.height - 23) * k, chat.width * k, 23 * k);
        context.font = "".concat(Math.round(12 * k), "px OSRS");
        context.textAlign = "center";
        ["All", "Game", "Public", "Private", "Channel", "Clan", "Trade"].forEach(function (label, index) {
            var x = (chat.x + 28 + index * 62) * k;
            context.fillStyle = "#ffffff";
            context.fillText(label, x, (chat.y + chat.height - 8) * k);
        });
        // Messages, newest at the bottom.
        context.textAlign = "left";
        context.font = "".concat(Math.round(16 * k), "px OSRS");
        var lineHeight = 14 * k;
        var bottom = (chat.y + chat.height - 52) * k;
        FixedLayout.chatMessages
            .slice()
            .reverse()
            .forEach(function (message, index) {
            context.fillStyle = message.color;
            context.fillText(message.text, (chat.x + 12) * k, bottom - index * lineHeight);
        });
        context.fillStyle = "#000000";
        context.fillText("Player: *", (chat.x + 12) * k, (chat.y + chat.height - 30) * k);
        context.restore();
    };
    FixedLayout.chatMessages = [];
    /**
     * Infoboxes (like RuneLite's Visual Metronome) drawn as 32x32 boxes. Each returns its text,
     * or null to hide it.
     */
    FixedLayout.infoboxes = [];
    return FixedLayout;
}());


;// CONCATENATED MODULE: ./src/sdk/MapController.ts





























/* eslint-disable @typescript-eslint/no-explicit-any */
var MapHover;
(function (MapHover) {
    MapHover[MapHover["NONE"] = 0] = "NONE";
    MapHover[MapHover["HITPOINT"] = 1] = "HITPOINT";
    MapHover[MapHover["PRAYER"] = 2] = "PRAYER";
    MapHover[MapHover["RUN"] = 3] = "RUN";
    MapHover[MapHover["SPEC"] = 4] = "SPEC";
    MapHover[MapHover["XP"] = 5] = "XP";
})(MapHover || (MapHover = {}));
var INITIAL_WIDTH = 210;
var INITIAL_HEIGHT = 180;
var MapController = /** @class */ (function () {
    function MapController() {
        this.colorScale = new (lib_default())(0, 1, ["#FF0000", "#FF7300", "#00FF00"], 1);
        this.outlineImage = ImageLoader/* ImageLoader */.$.createImage(map_border_namespaceObject);
        this.mapAlphaImage = ImageLoader/* ImageLoader */.$.createImage(map_border_mask_namespaceObject);
        this.mapNumberOrb = ImageLoader/* ImageLoader */.$.createImage(map_num_orb_namespaceObject);
        this.mapSelectedNumberOrb = ImageLoader/* ImageLoader */.$.createImage(map_selected_num_orb_namespaceObject);
        this.mapHitpointOrb = ImageLoader/* ImageLoader */.$.createImage(map_hitpoint_orb_namespaceObject);
        this.mapPrayerOrb = ImageLoader/* ImageLoader */.$.createImage(map_prayer_orb_namespaceObject);
        this.mapPrayerSelectedOrb = ImageLoader/* ImageLoader */.$.createImage(map_prayer_on_orb_namespaceObject);
        this.mapRunOrb = ImageLoader/* ImageLoader */.$.createImage(map_run_orb_namespaceObject);
        this.mapNoSpecOrb = ImageLoader/* ImageLoader */.$.createImage(map_no_spec_orb_namespaceObject);
        this.mapSpecOrb = ImageLoader/* ImageLoader */.$.createImage(map_spec_orb_namespaceObject);
        this.mapSpecOnOrb = ImageLoader/* ImageLoader */.$.createImage(map_spec_on_orb_namespaceObject);
        this.mapHitpointIcon = ImageLoader/* ImageLoader */.$.createImage(map_hitpoint_icon_namespaceObject);
        this.mapPrayerIcon = ImageLoader/* ImageLoader */.$.createImage(map_prayer_icon_namespaceObject);
        this.mapWalkIcon = ImageLoader/* ImageLoader */.$.createImage(map_walk_icon_namespaceObject);
        this.mapRunIcon = ImageLoader/* ImageLoader */.$.createImage(map_run_icon_namespaceObject);
        this.mapStamIcon = ImageLoader/* ImageLoader */.$.createImage(map_stam_icon_namespaceObject);
        this.mapSpecIcon = ImageLoader/* ImageLoader */.$.createImage(map_spec_icon_namespaceObject);
        this.mapXpButton = ImageLoader/* ImageLoader */.$.createImage(map_xp_button_namespaceObject);
        this.mapXpHoverButton = ImageLoader/* ImageLoader */.$.createImage(map_xp_hover_button_namespaceObject);
        this.hovering = null;
        this.width = INITIAL_WIDTH;
        this.height = INITIAL_HEIGHT;
        this.hovering = MapHover.NONE;
        this.loadImages();
    }
    MapController.prototype.updateOrbsMask = function (currentStats, stats) {
        if (currentStats) {
            this.currentStats = currentStats;
        }
        if (stats) {
            this.stats = stats;
        }
        if (!this.mapHitpointOrb || !this.mapPrayerOrb || !this.mapRunOrb || !this.mapSpecOrb) {
            return;
        }
        var hitpointPercentage = this.currentStats.hitpoint / this.stats.hitpoint;
        this.mapHitpointOrbMasked = new OffscreenCanvas(this.mapHitpointOrb.width, this.mapHitpointOrb.height);
        var ctx = this.mapHitpointOrbMasked.getContext("2d");
        ctx.fillStyle = "white";
        ctx.drawImage(this.mapHitpointOrb, 0, 0);
        ctx.globalCompositeOperation = "destination-in";
        ctx.fillRect(0, this.mapHitpointOrb.height * (1 - hitpointPercentage), this.mapHitpointOrb.width, this.mapHitpointOrb.height * hitpointPercentage);
        ctx.globalCompositeOperation = "source-over";
        var prayerPercentage = this.currentStats.prayer / this.stats.prayer;
        this.mapPrayerOrbMasked = new OffscreenCanvas(this.mapPrayerOrb.width, this.mapPrayerOrb.height);
        ctx = this.mapPrayerOrbMasked.getContext("2d");
        ctx.fillStyle = "white";
        ctx.drawImage(ControlPanelController.controls.PRAYER.hasQuickPrayersActivated ? this.mapPrayerSelectedOrb : this.mapPrayerOrb, 0, 0);
        ctx.globalCompositeOperation = "destination-in";
        ctx.fillRect(0, this.mapPrayerOrb.height * (1 - prayerPercentage), this.mapPrayerOrb.width, this.mapPrayerOrb.height * prayerPercentage);
        ctx.globalCompositeOperation = "source-over";
        var runPercentage = this.currentStats.run / 10000;
        this.mapRunOrbMasked = new OffscreenCanvas(this.mapRunOrb.width, this.mapRunOrb.height);
        ctx = this.mapRunOrbMasked.getContext("2d");
        ctx.fillStyle = "white";
        ctx.drawImage(Trainer/* Trainer */.c.player.running ? this.mapRunOrb : this.mapNoSpecOrb, 0, 0);
        ctx.globalCompositeOperation = "destination-in";
        ctx.fillRect(0, this.mapRunOrb.height * (1 - runPercentage), this.mapRunOrb.width, this.mapRunOrb.height * runPercentage);
        ctx.globalCompositeOperation = "source-over";
        var specPercentage = this.currentStats.specialAttack / 100;
        this.mapSpecOrbMasked = new OffscreenCanvas(this.mapSpecOrb.width, this.mapSpecOrb.height);
        ctx = this.mapSpecOrbMasked.getContext("2d");
        ctx.fillStyle = "white";
        var specOrb = this.mapNoSpecOrb;
        if (Trainer/* Trainer */.c.player.equipment.weapon && Trainer/* Trainer */.c.player.equipment.weapon.hasSpecialAttack()) {
            if (Trainer/* Trainer */.c.player.useSpecialAttack) {
                specOrb = this.mapSpecOnOrb;
            }
            else {
                specOrb = this.mapSpecOrb;
            }
        }
        ctx.drawImage(specOrb, 0, 0);
        ctx.globalCompositeOperation = "destination-in";
        ctx.fillRect(0, this.mapSpecOrb.height * (1 - specPercentage), this.mapRunOrb.width, this.mapRunOrb.height * specPercentage);
        ctx.globalCompositeOperation = "source-over";
    };
    MapController.prototype.loadImages = function () {
        var _this = this;
        var compassImage = ImageLoader/* ImageLoader */.$.createImage(compass_namespaceObject);
        compassImage.addEventListener("load", function () {
            _this.compassImage = new OffscreenCanvas(51, 51);
            var context = _this.compassImage.getContext("2d");
            context.drawImage(compassImage, 0, 0);
            // only draw image where mask is
            context.globalCompositeOperation = "destination-in";
            // draw our circle mask
            context.fillStyle = "#000";
            context.beginPath();
            var size = 38;
            context.arc((51 - size) * 0.5 + size * 0.5, // x
            (51 - size) * 0.5 + size * 0.5, // y
            size * 0.5, // radius
            0, // start angle
            2 * Math.PI);
            context.fill();
            // restore to default composite operation (is draw over current image)
            context.globalCompositeOperation = "source-over";
        });
    };
    MapController.prototype.generateMaskedMap = function () {
        this.mapCanvas = new OffscreenCanvas(152, 152);
        var mapContext = this.mapCanvas.getContext("2d");
        mapContext.save();
        mapContext.translate(76, 76);
        mapContext.rotate(Viewport.viewport.getMapRotation());
        mapContext.translate(-76, -76);
        if (Trainer/* Trainer */.c.player.region.mapImage) {
            var compatCtx = mapContext;
            compatCtx.webkitImageSmoothingEnabled = false;
            compatCtx.mozImageSmoothingEnabled = false;
            compatCtx.imageSmoothingEnabled = false;
            mapContext.drawImage(Trainer/* Trainer */.c.player.region.mapImage, 0, 0, 152, 152);
            compatCtx.webkitImageSmoothingEnabled = true;
            compatCtx.mozImageSmoothingEnabled = true;
            compatCtx.imageSmoothingEnabled = true;
        }
        mapContext.globalCompositeOperation = "destination-out";
        mapContext.drawImage(this.mapAlphaImage, 0, 0);
        mapContext.globalCompositeOperation = "source-over";
        mapContext.restore();
    };
    MapController.prototype.cursorMovedTo = function (event) {
        var width = Chrome.size().width;
        var scale = Settings/* Settings */.w.minimapScale;
        var offset = width - this.width;
        var x = (event.offsetX - offset) / scale;
        var y = event.offsetY / scale;
        this.hovering = MapHover.NONE;
        if (x > 4 && x < 28 && y > 31 && y < 56) {
            this.hovering = MapHover.XP;
        }
        else if (x > 4 && x < 53 && y > 53 && y < 81) {
            this.hovering = MapHover.HITPOINT;
        }
        else if (x > 4 && x < 53 && y > 90 && y < 113) {
            this.hovering = MapHover.PRAYER;
        }
        else if (x > 15 && x < 67 && y > 122 && y < 149) {
            this.hovering = MapHover.RUN;
        }
        else if (x > 38 && x < 90 && y > 148 && y < 173) {
            this.hovering = MapHover.SPEC;
        }
    };
    MapController.prototype.rightClick = function (event) {
        var _this = this;
        var menuOptions = [];
        var intercepted = false;
        var width = Chrome.size().width;
        var scale = Settings/* Settings */.w.minimapScale;
        var offset = width - this.width;
        var x = (event.offsetX - offset) / scale;
        var y = event.offsetY / scale;
        if (x > 4 && x < 20 && y > 31 && y < 48) {
            intercepted = true;
            if (Settings/* Settings */.w.displayXpDrops === true) {
                menuOptions = [
                    {
                        text: [
                            { text: "Hide ", fillStyle: "white" },
                            { text: "XP drops", fillStyle: "#FF911F" },
                        ],
                        action: function () {
                            Settings/* Settings */.w.displayXpDrops = false;
                        },
                    },
                ];
            }
            else {
                menuOptions = [
                    {
                        text: [
                            { text: "Show ", fillStyle: "white" },
                            { text: "XP drops", fillStyle: "#FF911F" },
                        ],
                        action: function () {
                            Settings/* Settings */.w.displayXpDrops = true;
                        },
                    },
                ];
            }
        }
        else if (x > 33 && x < 64 && y > 5 && y < 36) {
            intercepted = true;
            menuOptions = [
                {
                    text: [{ text: "Look North", fillStyle: "white" }],
                    action: function () {
                        Viewport.viewport.rotateNorth();
                    },
                },
                {
                    text: [{ text: "Look South", fillStyle: "white" }],
                    action: function () {
                        Viewport.viewport.rotateSouth();
                    },
                },
            ];
        }
        else if (x > 4 && x < 52 && y > 53 && y < 73) {
            // intercepted = true;
            // hitpoint
        }
        else if (x > 4 && x < 53 && y > 90 && y < 113) {
            intercepted = true;
            // prayer
            menuOptions = [
                {
                    text: [{ text: "Activate Quick-prayers", fillStyle: "white" }],
                    action: function () {
                        _this.toggleQuickprayers();
                    },
                },
            ];
        }
        else if (x > 15 && x < 67 && y > 122 && y < 149) {
            intercepted = true;
            // run
            menuOptions = [
                {
                    text: [{ text: "Toggle Run", fillStyle: "white" }],
                    action: function () {
                        Trainer/* Trainer */.c.player.running = !Trainer/* Trainer */.c.player.running;
                        Replay/* ReplayLog */.s.recordImmediate({ kind: "run" });
                    },
                },
            ];
        }
        else if (x > 38 && x < 90 && y > 148 && y < 175) {
            if (this.canSpecialAttack()) {
                intercepted = true;
                // special attack
                menuOptions = [
                    {
                        text: [
                            { text: "Use ", fillStyle: "white" },
                            { text: "Special Attack", fillStyle: "#FF911F" },
                        ],
                        action: function () {
                            _this.toggleSpecialAttack();
                        },
                    },
                ];
            }
        }
        Viewport.viewport.contextMenu.setMenuOptions(menuOptions);
        Viewport.viewport.contextMenu.setActive();
        return intercepted;
    };
    MapController.prototype.leftClickDown = function (event) {
        var intercepted = false;
        var width = Chrome.size().width;
        var scale = Settings/* Settings */.w.minimapScale;
        var offset = width - this.width;
        var x = (event.offsetX - offset) / scale;
        var y = event.offsetY / scale;
        if (x > 4 && x < 20 && y > 31 && y < 48) {
            Settings/* Settings */.w.displayXpDrops = !Settings/* Settings */.w.displayXpDrops;
            intercepted = true;
            Settings/* Settings */.w.persistToStorage();
        }
        else if (x > 33 && x < 64 && y > 5 && y < 36) {
            intercepted = true;
            if (Viewport.viewport.getMapRotation() === 0) {
                Viewport.viewport.rotateSouth();
            }
            else {
                Viewport.viewport.rotateNorth();
            }
            Settings/* Settings */.w.persistToStorage();
        }
        else if (x > 4 && x < 52 && y > 53 && y < 73) {
            intercepted = true;
            // this.hovering = MapHover.HITPOINT;
        }
        else if (x > 4 && x < 53 && y > 90 && y < 113) {
            intercepted = true;
            this.toggleQuickprayers();
        }
        else if (x > 15 && x < 67 && y > 122 && y < 149) {
            intercepted = true;
            Trainer/* Trainer */.c.player.running = !Trainer/* Trainer */.c.player.running;
        }
        else if (x > 38 && x < 90 && y > 148 && y < 175) {
            intercepted = true;
            this.toggleSpecialAttack();
        }
        this.updateOrbsMask(this.currentStats, this.stats);
        return intercepted;
    };
    MapController.prototype.canSpecialAttack = function () {
        return Trainer/* Trainer */.c.player.equipment.weapon && Trainer/* Trainer */.c.player.equipment.weapon.hasSpecialAttack();
    };
    MapController.prototype.toggleSpecialAttack = function (record) {
        if (record === void 0) { record = true; }
        if (this.canSpecialAttack()) {
            Trainer/* Trainer */.c.player.useSpecialAttack = !Trainer/* Trainer */.c.player.useSpecialAttack;
            if (record)
                Replay/* ReplayLog */.s.recordImmediate({ kind: "spec" });
        }
    };
    MapController.prototype.toggleQuickprayers = function (record) {
        if (record === void 0) { record = true; }
        if (record)
            Replay/* ReplayLog */.s.recordImmediate({ kind: "quickPrayers" });
        if (ControlPanelController.controls.PRAYER.hasQuickPrayersActivated) {
            ControlPanelController.controls.PRAYER.deactivateAllPrayers();
            Trainer/* Trainer */.c.player.prayerController.drainCounter = 0;
        }
        else {
            ControlPanelController.controls.PRAYER.activateQuickPrayers();
        }
    };
    MapController.prototype.draw = function (ctx) {
        var width = Chrome.size().width;
        if (FixedLayout.enabled) {
            // The fixed client's minimap scales with the stretched client.
            Settings/* Settings */.w.minimapScale = FixedLayout.scale(width);
        }
        else {
            var gameHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            Settings/* Settings */.w.minimapScale = (gameHeight / 500 > 1 ? 1 : gameHeight / 500) * Settings/* Settings */.w.maxUiScale;
        }
        var scale = Settings/* Settings */.w.minimapScale;
        this.width = INITIAL_WIDTH * scale;
        this.height = INITIAL_HEIGHT * scale;
        var offset = width - this.width;
        ctx.font = 16 * scale + "px Stats_11";
        ctx.textAlign = "center";
        this.generateMaskedMap();
        ctx.drawImage(this.mapCanvas, offset + 52 * scale, 8, 152 * scale, 152 * scale);
        // draw compass
        ctx.save();
        ctx.translate(offset + 50.5 * scale, 23.5 * scale);
        ctx.rotate(Viewport.viewport.getMapRotation());
        ctx.translate(-50.5 * scale, -23.5 * scale);
        if (this.compassImage) {
            ctx.drawImage(this.compassImage, 25 * scale, -2, 51 * scale, 51 * scale);
        }
        ctx.restore();
        ctx.drawImage(this.outlineImage, offset + 28 * scale, 0, 182 * scale, 166 * scale);
        ctx.drawImage(this.hovering == MapHover.XP ? this.mapXpHoverButton : this.mapXpButton, offset, 26, 27 * scale, 27 * scale);
        ctx.drawImage(this.hovering == MapHover.HITPOINT ? this.mapSelectedNumberOrb : this.mapNumberOrb, offset, 47 * scale, 57 * scale, 34 * scale);
        ctx.drawImage(this.hovering == MapHover.PRAYER ? this.mapSelectedNumberOrb : this.mapNumberOrb, offset, 81 * scale, 57 * scale, 34 * scale);
        ctx.drawImage(this.hovering == MapHover.RUN ? this.mapSelectedNumberOrb : this.mapNumberOrb, offset + 10 * scale, 114 * scale, 57 * scale, 34 * scale);
        ctx.drawImage(this.hovering == MapHover.SPEC ? this.mapSelectedNumberOrb : this.mapNumberOrb, offset + 32 * scale, 140 * scale, 57 * scale, 34 * scale);
        ctx.drawImage(this.mapHitpointOrbMasked, offset + 27 * scale, 51 * scale, 26 * scale, 26 * scale);
        ctx.drawImage(this.mapHitpointIcon, offset + 27 * scale, 51 * scale, 26 * scale, 26 * scale);
        ctx.drawImage(this.mapPrayerOrbMasked, offset + 27 * scale, 85 * scale, 26 * scale, 26 * scale);
        ctx.drawImage(this.mapPrayerIcon, offset + 27 * scale, 85 * scale, 26 * scale, 26 * scale);
        ctx.drawImage(this.mapRunOrbMasked, offset + 37 * scale, 118 * scale, 26 * scale, 26 * scale);
        var mapRunIcon = this.mapWalkIcon;
        if (Trainer/* Trainer */.c.player.effects.stamina) {
            mapRunIcon = this.mapStamIcon;
        }
        else if (Trainer/* Trainer */.c.player.running) {
            mapRunIcon = this.mapRunIcon;
        }
        ctx.drawImage(mapRunIcon, offset + 37 * scale, 118 * scale, 26 * scale, 26 * scale);
        ctx.drawImage(this.mapSpecOrbMasked, offset + 59 * scale, 144 * scale, 26 * scale, 26 * scale);
        ctx.drawImage(this.mapSpecIcon, offset + 57 * scale, 142 * scale, 30 * scale, 30 * scale);
        // // hitpoints
        ctx.fillStyle = "black";
        ctx.fillText(String(this.currentStats.hitpoint), offset + 15 * scale, 74 * scale);
        ctx.fillStyle = this.colorScale.getColor(this.currentStats.hitpoint / this.stats.hitpoint).toHexString();
        ctx.fillText(String(this.currentStats.hitpoint), offset + 14 * scale, 73 * scale);
        // prayer
        ctx.fillStyle = "black";
        ctx.fillText(String(this.currentStats.prayer), offset + 15 * scale, 108 * scale);
        ctx.fillStyle = this.colorScale.getColor(this.currentStats.prayer / this.stats.prayer).toHexString();
        ctx.fillText(String(this.currentStats.prayer), offset + 14 * scale, 107 * scale);
        // run
        ctx.fillStyle = "black";
        ctx.fillText(String(Math.floor(this.currentStats.run / 100)), offset + 25 * scale, 140 * scale);
        ctx.fillStyle = this.colorScale.getColor(this.currentStats.run / 10000).toHexString();
        ctx.fillText(String(Math.floor(this.currentStats.run / 100)), offset + 24 * scale, 139 * scale);
        // spec
        ctx.fillStyle = "black";
        ctx.fillText(String(this.currentStats.specialAttack), offset + 47 * scale, 166 * scale);
        ctx.fillStyle = this.colorScale.getColor(this.currentStats.specialAttack / 100).toHexString();
        ctx.fillText(String(this.currentStats.specialAttack), offset + 46 * scale, 165 * scale);
        // Keep the simulated input latency visible without requiring the settings panel.
        var pingLabel = "".concat(Settings/* Settings */.w.inputDelay, "ms");
        ctx.save();
        ctx.font = "".concat(12 * scale, "px Stats_11");
        ctx.textAlign = "right";
        ctx.fillStyle = "black";
        ctx.fillText(pingLabel, offset + this.width - 3 * scale, 13 * scale);
        ctx.fillStyle = "white";
        ctx.fillText(pingLabel, offset + this.width - 4 * scale, 12 * scale);
        ctx.restore();
    };
    MapController.controller = new MapController();
    return MapController;
}());


;// CONCATENATED MODULE: ./src/sdk/controlpanels/InventoryControls.ts
var InventoryControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var InventoryControls_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};











/* eslint-disable @typescript-eslint/no-explicit-any */
var MS_PER_ANTI_DRAG = 20; // per client tick
var DRAG_RADIUS = 5;
var InventoryControls = /** @class */ (function (_super) {
    InventoryControls_extends(InventoryControls, _super);
    function InventoryControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.antiDragTimerAt = 0;
        _this.clickedDownItem = null;
        _this.clickedDownLocation = null;
        _this.draggedItem = false;
        _this.cursorLocation = null;
        // this is the visual representation of the inventory, which updates instantly when items are moved but is refreshed
        // every tick
        _this.inventoryCache = [];
        return _this;
    }
    Object.defineProperty(InventoryControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InventoryControls.prototype, "tabImageReference", {
        get: function () {
            return tabs_inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InventoryControls.prototype, "keyBinding", {
        get: function () {
            return Settings/* Settings */.w.inventory_key;
        },
        enumerable: false,
        configurable: true
    });
    InventoryControls.prototype.cursorMovedto = function (x, y) {
        this.cursorLocation = { x: x, y: y };
        if (!this.clickedDownLocation)
            return;
        this.draggedItem || (this.draggedItem = Pathing/* Pathing */.G.dist(this.cursorLocation.x, this.cursorLocation.y, this.clickedDownLocation.x, this.clickedDownLocation.y) > DRAG_RADIUS && this.canDrag());
    };
    InventoryControls.prototype.hoverAction = function (x, y) {
        var _a, _b;
        var scale = Settings/* Settings */.w.controlPanelScale;
        var hoveredItem = (0,lodash.first)((0,lodash.filter)(this.inventoryCache, function (inventoryItem, index) {
            if (!inventoryItem)
                return false;
            var x2 = index % 4;
            var y2 = Math.floor(index / 4);
            return Collision/* Collision */.F.collisionMath(x, y, 1, (20 + x2 * 43) * scale, (17 + (y2 + 1) * 35) * scale, 32 * scale);
        }));
        return (_b = (_a = hoveredItem === null || hoveredItem === void 0 ? void 0 : hoveredItem.contextActions(Trainer/* Trainer */.c.player)[0]) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : null;
    };
    Object.defineProperty(InventoryControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InventoryControls.prototype, "appearsOnLeftInMobile", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    InventoryControls.prototype.onWorldTick = function () {
        this.inventoryCache = InventoryControls_spreadArray([], Trainer/* Trainer */.c.player.inventory, true);
    };
    InventoryControls.prototype.panelRightClick = function (x, y) {
        var scale = Settings/* Settings */.w.controlPanelScale;
        var menuOptions = [];
        var clickedItem = (0,lodash.first)((0,lodash.filter)(Trainer/* Trainer */.c.player.inventory, function (inventoryItem, index) {
            if (!inventoryItem) {
                return;
            }
            var x2 = index % 4;
            var y2 = Math.floor(index / 4);
            var itemX = 20 + x2 * 43;
            var itemY = 17 + (y2 + 1) * 35;
            return Collision/* Collision */.F.collisionMath(x, y, 1, itemX * scale, itemY * scale, 32 * scale);
        }));
        if (clickedItem) {
            menuOptions = menuOptions.concat(clickedItem.contextActions(Trainer/* Trainer */.c.player));
        }
        Viewport.viewport.contextMenu.setMenuOptions(menuOptions);
        Viewport.viewport.contextMenu.setActive();
    };
    InventoryControls.prototype.onMouseUp = function () {
        this.clickedDownItem = null;
    };
    InventoryControls.prototype.panelClickUp = function (x, y) {
        if (!this.clickedDownItem) {
            return;
        }
        var scale = Settings/* Settings */.w.controlPanelScale;
        var sanitizedInventory = Trainer/* Trainer */.c.player.inventory.map(function (item, index) {
            if (item) {
                return item;
            }
            return {
                inventoryPosition: function () { return index; },
                isPlaceholder: true,
            };
        });
        var clickedDownItem = this.clickedDownItem;
        var isPlaceholder = clickedDownItem && !!clickedDownItem.isPlaceholder;
        if (!isPlaceholder && !this.draggedItem) {
            // clicking an item
            if (clickedDownItem.hasInventoryLeftClick) {
                Input/* InputController */.f.controller.queueAction(function () { return clickedDownItem.inventoryLeftClick(Trainer/* Trainer */.c.player); }, function () { return ({ kind: "inventoryClick", slot: Trainer/* Trainer */.c.player.inventory.indexOf(clickedDownItem) }); });
                MapController.controller.updateOrbsMask(null, null);
            }
            else {
                clickedDownItem.selected = true;
            }
            this.clickedDownItem = null;
            this.cursorLocation = null;
            return;
        }
        // prevent swapping due to anti-drag
        if (!this.canDrag()) {
            this.clickedDownItem = null;
            this.cursorLocation = null;
            return;
        }
        var clickedUpItem = (0,lodash.first)((0,lodash.filter)(sanitizedInventory, function (inventoryItem, index) {
            if (!inventoryItem) {
                return;
            }
            var x2 = index % 4;
            var y2 = Math.floor(index / 4);
            var itemX = 20 + x2 * 43;
            var itemY = 17 + (y2 + 1) * 35;
            return Collision/* Collision */.F.collisionMath(x, y, 1, itemX * scale, itemY * scale, 32 * scale);
        }));
        var clickedUpIsPlaceholder = !!(clickedUpItem === null || clickedUpItem === void 0 ? void 0 : clickedUpItem.isPlaceholder);
        // swapping gear
        if (!clickedUpIsPlaceholder && clickedUpItem) {
            var theItemWereReplacing = clickedUpItem;
            var theItemWereReplacingPosition_1 = clickedUpItem.inventoryPosition(Trainer/* Trainer */.c.player);
            var thisPosition_1 = this.clickedDownItem.inventoryPosition(Trainer/* Trainer */.c.player);
            // update the local cache immediately, but the real position updates upon server tick
            this.inventoryCache[theItemWereReplacingPosition_1] = this.clickedDownItem;
            this.inventoryCache[thisPosition_1] = theItemWereReplacing;
            Input/* InputController */.f.controller.queueAction(function () {
                Trainer/* Trainer */.c.player.swapItemPositions(theItemWereReplacingPosition_1, thisPosition_1);
            }, function () { return ({ kind: "swap", a: theItemWereReplacingPosition_1, b: thisPosition_1 }); });
        }
        else if (clickedUpItem) {
            var thisPosition_2 = this.clickedDownItem.inventoryPosition(Trainer/* Trainer */.c.player);
            var clickedPosition_1 = clickedUpItem.inventoryPosition(Trainer/* Trainer */.c.player);
            this.inventoryCache[clickedPosition_1] = this.clickedDownItem;
            this.inventoryCache[thisPosition_2] = null;
            Input/* InputController */.f.controller.queueAction(function () {
                Trainer/* Trainer */.c.player.swapItemPositions(clickedPosition_1, thisPosition_2);
            }, function () { return ({ kind: "swap", a: clickedPosition_1, b: thisPosition_2 }); });
        }
        this.clickedDownItem = null;
        this.cursorLocation = null;
    };
    InventoryControls.prototype.panelClickDown = function (x, y) {
        this.cursorLocation = { x: x, y: y };
        this.clickedDownLocation = { x: x, y: y };
        this.draggedItem = false;
        var scale = Settings/* Settings */.w.controlPanelScale;
        var clickedItem = (0,lodash.first)((0,lodash.filter)(this.inventoryCache, function (inventoryItem, index) {
            if (!inventoryItem) {
                return;
            }
            var x2 = index % 4;
            var y2 = Math.floor(index / 4);
            var itemX = 20 + x2 * 43;
            var itemY = 17 + (y2 + 1) * 35;
            return Collision/* Collision */.F.collisionMath(x, y, 1, itemX * scale, itemY * scale, 32 * scale);
        }));
        Trainer/* Trainer */.c.player.inventory.forEach(function (inventoryItem) { return inventoryItem && (inventoryItem.selected = false); });
        if (clickedItem) {
            this.clickedDownItem = clickedItem;
            this.antiDragTimerAt = Date.now() + Settings/* Settings */.w.antiDrag * MS_PER_ANTI_DRAG;
        }
    };
    InventoryControls.prototype.canDrag = function () {
        return Date.now() >= this.antiDragTimerAt;
    };
    InventoryControls.prototype.draw = function (context, ctrl, x, y) {
        var _this = this;
        _super.prototype.draw.call(this, context, ctrl, x, y);
        var scale = Settings/* Settings */.w.controlPanelScale;
        this.inventoryCache.forEach(function (inventoryItem, index) {
            var x2 = index % 4;
            var y2 = Math.floor(index / 4);
            var itemX = x + (20 + x2 * 43) * scale;
            var itemY = y + (17 + y2 * 35) * scale;
            if (inventoryItem !== null) {
                context.fillStyle = "#ffffff22";
                // Viewport.viewport.context.fillRect(itemX, itemY, 32, 32)
                var sprite = inventoryItem.inventorySprite;
                var xOff = Math.floor((32 - sprite.width) / 2);
                var yOff = Math.floor((32 - sprite.height) / 2);
                if (inventoryItem === _this.clickedDownItem) {
                    context.globalAlpha = 0.4;
                    if (_this.draggedItem) {
                        context.drawImage(sprite, x + _this.cursorLocation.x - (sprite.width * scale) / 2, y + _this.cursorLocation.y - (sprite.height * scale) / 2, sprite.width * scale, sprite.height * scale);
                    }
                    else {
                        context.drawImage(sprite, itemX + xOff, itemY + yOff, sprite.width * scale, sprite.height * scale);
                    }
                    context.globalAlpha = 1;
                }
                else {
                    context.drawImage(sprite, itemX + xOff, itemY + yOff, sprite.width * scale, sprite.height * scale);
                }
                if (inventoryItem.selected) {
                    context.beginPath();
                    context.fillStyle = "#D1BB7773";
                    context.arc(itemX + 15 * scale, itemY + 17 * scale, 16 * scale, 0, 2 * Math.PI);
                    context.fill();
                }
            }
        });
    };
    return InventoryControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/music.png
const music_namespaceObject = __webpack_require__.p + "025083410fbfe0d5d502.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/MusicControls.ts
var MusicControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var MusicControls = /** @class */ (function (_super) {
    MusicControls_extends(MusicControls, _super);
    function MusicControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MusicControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MusicControls.prototype, "tabImageReference", {
        get: function () {
            return music_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return MusicControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/panels/prayer.png
const prayer_namespaceObject = __webpack_require__.p + "cd1f698745df0f346549.png";
;// CONCATENATED MODULE: ./src/assets/images/tabs/prayer.png
const tabs_prayer_namespaceObject = __webpack_require__.p + "58f1554e26e66ab79f02.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/PrayerControls.ts
var PrayerControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var PrayerControls = /** @class */ (function (_super) {
    PrayerControls_extends(PrayerControls, _super);
    function PrayerControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasQuickPrayersActivated = false;
        return _this;
    }
    Object.defineProperty(PrayerControls.prototype, "panelImageReference", {
        get: function () {
            return prayer_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrayerControls.prototype, "tabImageReference", {
        get: function () {
            return tabs_prayer_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrayerControls.prototype, "keyBinding", {
        get: function () {
            return Settings/* Settings */.w.prayer_key;
        },
        enumerable: false,
        configurable: true
    });
    PrayerControls.prototype.deactivateAllPrayers = function () {
        this.hasQuickPrayersActivated = false;
        Trainer/* Trainer */.c.player.prayerController.prayers.forEach(function (prayer) {
            prayer.deactivate();
        });
    };
    PrayerControls.prototype.activateQuickPrayers = function () {
        this.hasQuickPrayersActivated = true;
        Trainer/* Trainer */.c.player.prayerController.prayers.forEach(function (prayer) {
            if (prayer.name === "Protect from Magic") {
                prayer.activate(Trainer/* Trainer */.c.player);
            }
            if (prayer.name === "Rigour") {
                prayer.activate(Trainer/* Trainer */.c.player);
            }
        });
    };
    PrayerControls.prototype.panelClickDown = function (x, y) {
        var _this = this;
        var scale = Settings/* Settings */.w.controlPanelScale;
        x = x / scale;
        y = y / scale;
        var gridX = x - 14;
        var gridY = y - 22;
        var clickedPrayer = Trainer/* Trainer */.c.player.prayerController.prayers[Math.floor(gridY / 35) * 5 + Math.floor(gridX / 35)];
        if (clickedPrayer && Trainer/* Trainer */.c.player.currentStats.prayer > 0) {
            Input/* InputController */.f.controller.queueClientAction(function () {
                if (Trainer/* Trainer */.c.player.currentStats.prayer <= 0 || !clickedPrayer.toggleClient(Trainer/* Trainer */.c.player))
                    return;
                Input/* InputController */.f.controller.queueAction(function () {
                    clickedPrayer.toggleServer(Trainer/* Trainer */.c.player);
                    if (_this.hasQuickPrayersActivated && Trainer/* Trainer */.c.player.prayerController.activePrayers().length === 0) {
                        ControlPanelController.controls.PRAYER.hasQuickPrayersActivated = false;
                    }
                }, function () { return ({ kind: "prayer", index: Trainer/* Trainer */.c.player.prayerController.prayers.indexOf(clickedPrayer) }); });
            });
        }
    };
    PrayerControls.prototype.hoverAction = function (x, y) {
        var scale = Settings/* Settings */.w.controlPanelScale;
        var gridX = x / scale - 14;
        var gridY = y / scale - 22;
        var prayer = Trainer/* Trainer */.c.player.prayerController.prayers[Math.floor(gridY / 35) * 5 + Math.floor(gridX / 35)];
        if (!prayer)
            return null;
        return [
            { text: prayer.isLit ? "Deactivate " : "Activate ", fillStyle: "white" },
            { text: prayer.name, fillStyle: "yellow" },
        ];
    };
    Object.defineProperty(PrayerControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    PrayerControls.prototype.draw = function (context, ctrl, x, y) {
        _super.prototype.draw.call(this, context, ctrl, x, y);
        var scale = Settings/* Settings */.w.controlPanelScale;
        Trainer/* Trainer */.c.player.prayerController.prayers.forEach(function (prayer, index) {
            var x2 = index % 5;
            var y2 = Math.floor(index / 5);
            if (prayer.isLit) {
                context.beginPath();
                context.fillStyle = "#D1BB7773";
                context.arc(x + 10 * scale + (x2 + 0.5) * 36.8 * scale, y + (16 + (y2 + 0.5) * 37) * scale, 18 * scale, 0, 2 * Math.PI);
                context.fill();
            }
            if (Trainer/* Trainer */.c.player.stats.prayer < prayer.levelRequirement()) {
                context.beginPath();
                context.fillStyle = "#00000073";
                context.arc(x + 10 * scale + (x2 + 0.5) * 36.8 * scale, y + (16 + (y2 + 0.5) * 37) * scale, 18 * scale, 0, 2 * Math.PI);
                context.fill();
            }
        });
    };
    return PrayerControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/quests.png
const quests_namespaceObject = __webpack_require__.p + "bc106c524270af1a8fb0.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/QuestsControls.ts
var QuestsControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var QuestsControls = /** @class */ (function (_super) {
    QuestsControls_extends(QuestsControls, _super);
    function QuestsControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(QuestsControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestsControls.prototype, "tabImageReference", {
        get: function () {
            return quests_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return QuestsControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/tabs/settings.png
const settings_namespaceObject = __webpack_require__.p + "4eddceb9b3276d1d9d05.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/sound_effect_volume.png
const sound_effect_volume_namespaceObject = __webpack_require__.p + "40937a29a5183bbcb15d.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/area_sound_volume.png
const area_sound_volume_namespaceObject = __webpack_require__.p + "6100d0aa77486ff1ddb1.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/disabled_option_overlay.png
const disabled_option_overlay_namespaceObject = __webpack_require__.p + "7babad158bacf9b7fa8c.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/button_red_up.png
const button_red_up_namespaceObject = __webpack_require__.p + "897905b6a68aab206528.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/button_green_down.png
const button_green_down_namespaceObject = __webpack_require__.p + "1e1e5bdc45303a02b71a.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/button_active.png
const button_active_namespaceObject = __webpack_require__.p + "87854f595bea4412f7db.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/button_inactive.png
const button_inactive_namespaceObject = __webpack_require__.p + "ca097d23e59046bc81d0.png";
;// CONCATENATED MODULE: ./src/assets/images/controlTabs/inventory.png
const controlTabs_inventory_namespaceObject = __webpack_require__.p + "2c56a14077c7c5d569ea.png";
;// CONCATENATED MODULE: ./src/assets/images/controlTabs/spellbook.png
const spellbook_namespaceObject = __webpack_require__.p + "b6bba618e2163708b0a2.png";
;// CONCATENATED MODULE: ./src/assets/images/controlTabs/prayer.png
const controlTabs_prayer_namespaceObject = __webpack_require__.p + "c5193e506916cfbfc1ed.png";
;// CONCATENATED MODULE: ./src/assets/images/controlTabs/equipment.png
const controlTabs_equipment_namespaceObject = __webpack_require__.p + "8c54f0224843596d75c4.png";
;// CONCATENATED MODULE: ./src/assets/images/controlTabs/style.png
const style_namespaceObject = __webpack_require__.p + "37366ee3c2ce9bc12b09.png";
;// CONCATENATED MODULE: ./src/sdk/utils/BrowserUtils.ts
var BrowserUtils = /** @class */ (function () {
    function BrowserUtils() {
    }
    BrowserUtils.getQueryVar = function (varName) {
        // Grab and unescape the query string - appending an '&' keeps the RegExp simple
        // for the sake of this example.
        var queryStr = unescape(window.location.search) + "&";
        // Dynamic replacement RegExp
        var regex = new RegExp(".*?[&\\?]" + varName + "=(.*?)&.*");
        // Apply RegExp to the query string
        var val = queryStr.replace(regex, "$1");
        // If the string is the same, we didn't find a match - return false
        return val === queryStr ? "" : val;
    };
    return BrowserUtils;
}());


;// CONCATENATED MODULE: ./src/sdk/ui/ToggleButton.ts



var ACTIVE_BUTTON_IMAGE = ImageLoader/* ImageLoader */.$.createImage(button_active_namespaceObject);
var INACTIVE_BUTTON_IMAGE = ImageLoader/* ImageLoader */.$.createImage(button_inactive_namespaceObject);
var ToggleButton = /** @class */ (function () {
    function ToggleButton(label, xOffset, yOffset, isActive, onClick, activeButtonImage, inactiveButtonImage, overlayInactive) {
        if (activeButtonImage === void 0) { activeButtonImage = ACTIVE_BUTTON_IMAGE; }
        if (inactiveButtonImage === void 0) { inactiveButtonImage = INACTIVE_BUTTON_IMAGE; }
        if (overlayInactive === void 0) { overlayInactive = false; }
        this.label = label;
        this.xOffset = xOffset;
        this.yOffset = yOffset;
        this.isActive = isActive;
        this.onClick = onClick;
        this.activeButtonImage = activeButtonImage;
        this.inactiveButtonImage = inactiveButtonImage;
        this.overlayInactive = overlayInactive;
    }
    ToggleButton.prototype.draw = function (context, scale, panelX, panelY) {
        var active = this.isActive();
        context.drawImage(active || this.overlayInactive ? this.activeButtonImage : this.inactiveButtonImage, panelX + this.xOffset * scale, panelY + this.yOffset * scale, this.activeButtonImage.width * scale, this.activeButtonImage.height * scale);
        if (this.overlayInactive && !active) {
            context.drawImage(this.inactiveButtonImage, panelX + this.xOffset * scale, panelY + this.yOffset * scale, this.inactiveButtonImage.width * scale, this.inactiveButtonImage.height * scale);
        }
        context.save();
        context.fillStyle = "#FFFF00";
        context.font = 16 * scale + "px OSRS";
        context.textBaseline = "middle";
        context.textAlign = "center";
        context.fillText(this.label, panelX + (this.xOffset + this.activeButtonImage.width / 2) * scale, panelY + (this.yOffset + ACTIVE_BUTTON_IMAGE.height / 2) * scale);
        context.restore();
    };
    ToggleButton.prototype.onPanelClick = function (x, y) {
        if (x >= this.xOffset &&
            x <= this.xOffset + this.activeButtonImage.width &&
            y >= this.yOffset &&
            y <= this.yOffset + this.activeButtonImage.height) {
            this.onClick();
            return true;
        }
        return false;
    };
    ToggleButton.prototype.onMouseMove = function (x, y) {
        return false;
    };
    return ToggleButton;
}());


;// CONCATENATED MODULE: ./src/sdk/ui/KeyBindingButton.ts



var KeyBindingButton_ACTIVE_BUTTON_IMAGE = ImageLoader/* ImageLoader */.$.createImage(button_active_namespaceObject);
var KeyBindingButton_INACTIVE_BUTTON_IMAGE = ImageLoader/* ImageLoader */.$.createImage(button_inactive_namespaceObject);
var KeyBindingButton = /** @class */ (function () {
    function KeyBindingButton(label, xOffset, yOffset, isActive, onClick, overlay) {
        this.label = label;
        this.xOffset = xOffset;
        this.yOffset = yOffset;
        this.isActive = isActive;
        this.onClick = onClick;
        this.overlay = overlay;
    }
    KeyBindingButton.prototype.draw = function (context, scale, panelX, panelY) {
        var active = this.isActive();
        context.drawImage(active ? KeyBindingButton_ACTIVE_BUTTON_IMAGE : KeyBindingButton_INACTIVE_BUTTON_IMAGE, panelX + this.xOffset * scale, panelY + this.yOffset * scale, KeyBindingButton_ACTIVE_BUTTON_IMAGE.width * scale, KeyBindingButton_ACTIVE_BUTTON_IMAGE.height * scale);
        context.drawImage(this.overlay, panelX + this.xOffset * scale + 3, panelY + this.yOffset * scale + 2, this.overlay.width * scale, this.overlay.height * scale);
        context.save();
        context.fillStyle = "#FFFF00";
        context.font = 16 * scale + "px OSRS";
        context.textBaseline = "middle";
        context.textAlign = "center";
        context.fillText(this.label(), panelX + (this.xOffset + 30) * scale, panelY + (this.yOffset + 30) * scale);
        context.restore();
    };
    KeyBindingButton.prototype.onPanelClick = function (x, y) {
        if (x >= this.xOffset &&
            x <= this.xOffset + KeyBindingButton_ACTIVE_BUTTON_IMAGE.width &&
            y >= this.yOffset &&
            y <= this.yOffset + KeyBindingButton_ACTIVE_BUTTON_IMAGE.height) {
            this.onClick();
            return true;
        }
        return false;
    };
    KeyBindingButton.prototype.onMouseMove = function (x, y) {
        return false;
    };
    return KeyBindingButton;
}());


;// CONCATENATED MODULE: ./src/sdk/controlpanels/SettingsControls.ts
var SettingsControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




















var SettingsControls = /** @class */ (function (_super) {
    SettingsControls_extends(SettingsControls, _super);
    function SettingsControls() {
        var _this = _super.call(this) || this;
        _this.soundImage = ImageLoader/* ImageLoader */.$.createImage(sound_effect_volume_namespaceObject);
        _this.areaSoundImage = ImageLoader/* ImageLoader */.$.createImage(area_sound_volume_namespaceObject);
        _this.disabledOverlay = ImageLoader/* ImageLoader */.$.createImage(disabled_option_overlay_namespaceObject);
        _this.redUpImage = ImageLoader/* ImageLoader */.$.createImage(button_red_up_namespaceObject);
        _this.greenDownImage = ImageLoader/* ImageLoader */.$.createImage(button_green_down_namespaceObject);
        _this.activeButtonImage = ImageLoader/* ImageLoader */.$.createImage(button_active_namespaceObject);
        _this.inactiveButtonImage = ImageLoader/* ImageLoader */.$.createImage(button_inactive_namespaceObject);
        _this.inventoryImage = ImageLoader/* ImageLoader */.$.createImage(controlTabs_inventory_namespaceObject);
        _this.spellbookImage = ImageLoader/* ImageLoader */.$.createImage(spellbook_namespaceObject);
        _this.prayerImage = ImageLoader/* ImageLoader */.$.createImage(controlTabs_prayer_namespaceObject);
        _this.equipmentImage = ImageLoader/* ImageLoader */.$.createImage(controlTabs_equipment_namespaceObject);
        _this.combatImage = ImageLoader/* ImageLoader */.$.createImage(style_namespaceObject);
        _this.components = [
            // Sound
            new ToggleButton("", 20, 20, function () { return Settings/* Settings */.w.playsAudio; }, function () { return (Settings/* Settings */.w.playsAudio = !Settings/* Settings */.w.playsAudio); }, _this.soundImage, _this.disabledOverlay, true),
            // Area Sound
            new ToggleButton("", 20, 60, function () { return Settings/* Settings */.w.playsAreaAudio; }, function () { return (Settings/* Settings */.w.playsAreaAudio = !Settings/* Settings */.w.playsAreaAudio); }, _this.areaSoundImage, _this.disabledOverlay, true),
            new ToggleButton("Metronome", 140, 20, function () { return Settings/* Settings */.w.metronome; }, function () { return (Settings/* Settings */.w.metronome = !Settings/* Settings */.w.metronome); }),
            // Key bindings
            new KeyBindingButton(function () { return Settings/* Settings */.w.inventory_key; }, 22, 170, function () { return _this.bindingKey === "inventory"; }, function () { return _this.startKeyBinding("inventory"); }, _this.inventoryImage),
            new KeyBindingButton(function () { return Settings/* Settings */.w.spellbook_key; }, 82, 170, function () { return _this.bindingKey === "spellbook"; }, function () { return _this.startKeyBinding("spellbook"); }, _this.spellbookImage),
            new KeyBindingButton(function () { return Settings/* Settings */.w.prayer_key; }, 142, 170, function () { return _this.bindingKey === "prayer"; }, function () { return _this.startKeyBinding("prayer"); }, _this.prayerImage),
            new KeyBindingButton(function () { return Settings/* Settings */.w.equipment_key; }, 22, 220, function () { return _this.bindingKey === "equipment"; }, function () { return _this.startKeyBinding("equipment"); }, _this.equipmentImage),
            new KeyBindingButton(function () { return Settings/* Settings */.w.combat_key; }, 82, 220, function () { return _this.bindingKey === "combat"; }, function () { return _this.startKeyBinding("combat"); }, _this.combatImage),
            // Menu   
            new ToggleButton("Menu", 142, 220, function () { return Settings/* Settings */.w.menuVisible; }, function () {
                Settings/* Settings */.w.setMenuVisible(!Settings/* Settings */.w.menuVisible);
            }),
        ];
        SettingsControls.instance = _this;
        _this.bindingKey = null;
        document.addEventListener("keydown", function (event) {
            var key = event.key;
            if (_this.bindingKey) {
                event.preventDefault();
                if (_this.bindingKey === "inventory") {
                    Settings/* Settings */.w.inventory_key = key;
                }
                else if (_this.bindingKey === "spellbook") {
                    Settings/* Settings */.w.spellbook_key = key;
                }
                else if (_this.bindingKey === "prayer") {
                    Settings/* Settings */.w.prayer_key = key;
                }
                else if (_this.bindingKey === "equipment") {
                    Settings/* Settings */.w.equipment_key = key;
                }
                else if (_this.bindingKey === "combat") {
                    Settings/* Settings */.w.combat_key = key;
                }
                _this.bindingKey = null;
                setTimeout(function () {
                    Settings/* Settings */.w.is_keybinding = false;
                }, 20);
                Settings/* Settings */.w.persistToStorage();
            }
            else if (key.match(/F\d+/)) {
                // prevent browser actions from all F-keys
                event.preventDefault();
            }
        });
        return _this;
    }
    Object.defineProperty(SettingsControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SettingsControls.prototype, "tabImageReference", {
        get: function () {
            return settings_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    SettingsControls.prototype.addComponent = function (component) {
        this.components.push(component);
    };
    Object.defineProperty(SettingsControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SettingsControls.prototype, "appearsOnLeftInMobile", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    SettingsControls.prototype.startKeyBinding = function (key) {
        Settings/* Settings */.w.is_keybinding = true;
        this.bindingKey = key;
    };
    Object.defineProperty(SettingsControls.prototype, "keyBinding", {
        get: function () {
            return BrowserUtils.getQueryVar("settings_key");
        },
        enumerable: false,
        configurable: true
    });
    SettingsControls.prototype.panelClickDown = function (x, y) {
        var scale = Settings/* Settings */.w.controlPanelScale;
        x = x / scale;
        y = y / scale;
        if (x > 74 && x < 89 && y > 20 && y < 36) {
            Settings/* Settings */.w.maxUiScale += 0.05;
        }
        else if (x > 75 && x < 89 && y > 51 && y < 67) {
            Settings/* Settings */.w.maxUiScale -= 0.05;
        }
        else if (x > 100 && x < 115 && y > 20 && y < 36) {
            Settings/* Settings */.w.inputDelay += 20;
        }
        else if (x > 100 && x < 115 && y > 51 && y < 67) {
            Settings/* Settings */.w.inputDelay -= 20;
        }
        else {
            this.components.forEach(function (component) {
                component.onPanelClick(x, y);
            });
        }
        Settings/* Settings */.w.inputDelay = Math.max(0, Settings/* Settings */.w.inputDelay);
        Settings/* Settings */.w.maxUiScale = Math.max(0.5, Math.min(2.0, Settings/* Settings */.w.maxUiScale));
        Settings/* Settings */.w.persistToStorage();
    };
    SettingsControls.prototype.draw = function (context, ctrl, x, y) {
        _super.prototype.draw.call(this, context, ctrl, x, y);
        var scale = Settings/* Settings */.w.controlPanelScale;
        context.drawImage(this.redUpImage, x + 74 * scale, y + 20 * scale, this.redUpImage.width * scale, this.redUpImage.height * scale);
        context.fillStyle = "#FFFF00";
        context.font = 16 * scale + "px OSRS";
        context.textAlign = "center";
        context.fillText(String(Math.round((Settings/* Settings */.w.maxUiScale - 1.0) * 100)) + "%", x + 79 * scale, y + 48 * scale);
        context.drawImage(this.greenDownImage, x + 74 * scale, y + 51 * scale, this.greenDownImage.width * scale, this.greenDownImage.height * scale);
        context.fillText("UI", x + 80 * scale, y + 81 * scale);
        context.drawImage(this.redUpImage, x + 100 * scale, y + 20 * scale, this.redUpImage.width * scale, this.redUpImage.height * scale);
        context.fillStyle = "#FFFF00";
        context.font = 16 * scale + "px OSRS";
        context.textAlign = "center";
        context.fillText(String(Settings/* Settings */.w.inputDelay), x + 106 * scale, y + 48 * scale);
        context.drawImage(this.greenDownImage, x + 100 * scale, y + 51 * scale, this.greenDownImage.width * scale, this.greenDownImage.height * scale);
        context.fillText("Ping", x + 107 * scale, y + 81 * scale);
        if (this.bindingKey === null) {
            context.fillText("Key Bindings", x + 100 * scale, y + (133 + 30) * scale);
        }
        else {
            context.fillText("Press Key To Bind", x + 100 * scale, y + (133 + 30) * scale);
        }
        this.components.forEach(function (component) {
            component.draw(context, scale, x, y);
        });
    };
    SettingsControls.instance = null;
    return SettingsControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/assets/images/panels/stats.png
const stats_namespaceObject = __webpack_require__.p + "9e44221bcc08b6b42e12.png";
;// CONCATENATED MODULE: ./src/assets/images/tabs/stats.png
const tabs_stats_namespaceObject = __webpack_require__.p + "b1a7dadcea3162ff59f3.png";
;// CONCATENATED MODULE: ./src/sdk/controlpanels/StatsControls.ts
var StatsControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var StatsControls = /** @class */ (function (_super) {
    StatsControls_extends(StatsControls, _super);
    function StatsControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StatsControls.prototype, "panelImageReference", {
        get: function () {
            return stats_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatsControls.prototype, "tabImageReference", {
        get: function () {
            return tabs_stats_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatsControls.prototype, "isAvailable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    StatsControls.prototype.levelPrompt = function (skill) {
        var newLvl = parseInt(prompt("What level would you like to set your " + skill + "?", "99"));
        if (isNaN(newLvl)) {
            return -1;
        }
        if (newLvl > 0 && newLvl < 100) {
            return newLvl;
        }
        return -1;
    };
    StatsControls.prototype.panelClickUp = function (x, y) {
        var scale = Settings/* Settings */.w.controlPanelScale;
        x = x / scale;
        y = y / scale;
        if (x > 9 && x < 73) {
            if (y > 12 && y < 44) {
                var newLvl = this.levelPrompt("attack");
                if (newLvl > 0) {
                    Trainer/* Trainer */.c.player.stats.attack = newLvl;
                    Trainer/* Trainer */.c.player.currentStats.attack = newLvl;
                    Settings/* Settings */.w.player_stats = Trainer/* Trainer */.c.player.stats;
                    Settings/* Settings */.w.persistToStorage();
                }
            }
            else if (y > 44 && y < 76) {
                // str
                var newLvl = this.levelPrompt("strength");
                if (newLvl > 0) {
                    Trainer/* Trainer */.c.player.stats.strength = newLvl;
                    Trainer/* Trainer */.c.player.currentStats.strength = newLvl;
                    Settings/* Settings */.w.player_stats = Trainer/* Trainer */.c.player.stats;
                    Settings/* Settings */.w.persistToStorage();
                }
            }
            else if (y > 76 && y < 108) {
                // def
                var newLvl = this.levelPrompt("defence");
                if (newLvl > 0) {
                    Trainer/* Trainer */.c.player.stats.defence = newLvl;
                    Trainer/* Trainer */.c.player.currentStats.defence = newLvl;
                    Settings/* Settings */.w.player_stats = Trainer/* Trainer */.c.player.stats;
                    Settings/* Settings */.w.persistToStorage();
                }
            }
            else if (y > 108 && y < 140) {
                // ranged
                var newLvl = this.levelPrompt("range");
                if (newLvl > 0) {
                    Trainer/* Trainer */.c.player.stats.range = newLvl;
                    Trainer/* Trainer */.c.player.currentStats.range = newLvl;
                    Settings/* Settings */.w.player_stats = Trainer/* Trainer */.c.player.stats;
                    Settings/* Settings */.w.persistToStorage();
                }
            }
            else if (y > 140 && y < 172) {
                //prayer
                var newLvl = this.levelPrompt("prayer");
                if (newLvl > 0) {
                    Trainer/* Trainer */.c.player.stats.prayer = newLvl;
                    Trainer/* Trainer */.c.player.currentStats.prayer = newLvl;
                    Settings/* Settings */.w.player_stats = Trainer/* Trainer */.c.player.stats;
                    Settings/* Settings */.w.persistToStorage();
                }
            }
            else if (y > 172 && y < 204) {
                //magic
                var newLvl = this.levelPrompt("magic");
                if (newLvl > 0) {
                    Trainer/* Trainer */.c.player.stats.magic = newLvl;
                    Trainer/* Trainer */.c.player.currentStats.magic = newLvl;
                    Settings/* Settings */.w.player_stats = Trainer/* Trainer */.c.player.stats;
                    Settings/* Settings */.w.persistToStorage();
                }
            }
        }
        else if (x > 74 && x < 138) {
            if (y > 12 && y < 44) {
                // hp
                var newLvl = this.levelPrompt("hitpoint");
                if (newLvl > 0) {
                    Trainer/* Trainer */.c.player.stats.hitpoint = newLvl;
                    Trainer/* Trainer */.c.player.currentStats.hitpoint = newLvl;
                    Settings/* Settings */.w.player_stats = Trainer/* Trainer */.c.player.stats;
                    Settings/* Settings */.w.persistToStorage();
                }
            }
            else if (y > 44 && y < 76) {
                // agility
                var newLvl = this.levelPrompt("agility");
                if (newLvl > 0) {
                    Trainer/* Trainer */.c.player.stats.agility = newLvl;
                    Trainer/* Trainer */.c.player.currentStats.agility = newLvl;
                    Settings/* Settings */.w.player_stats = Trainer/* Trainer */.c.player.stats;
                    Settings/* Settings */.w.persistToStorage();
                }
            }
        }
    };
    Object.defineProperty(StatsControls.prototype, "appearsOnLeftInMobile", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    StatsControls.prototype.draw = function (context, ctrl, x, y) {
        _super.prototype.draw.call(this, context, ctrl, x, y);
        var scale = Settings/* Settings */.w.controlPanelScale;
        context.font = 16 * scale + "px Stats_11";
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.attack), x + 49 * scale, y + 22 * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.attack), x + 48 * scale, y + 21 * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.attack), x + 61 * scale, y + 36 * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.attack), x + 60 * scale, y + 35 * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.strength), x + 49 * scale, y + (22 + 32) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.strength), x + 48 * scale, y + (21 + 32) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.strength), x + 61 * scale, y + (36 + 32) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.strength), x + 60 * scale, y + (35 + 32) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.defence), x + 49 * scale, y + (22 + 64) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.defence), x + 48 * scale, y + (21 + 64) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.defence), x + 61 * scale, y + (36 + 64) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.defence), x + 60 * scale, y + (35 + 64) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.range), x + 49 * scale, y + (22 + 96) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.range), x + 48 * scale, y + (21 + 96) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.range), x + 61 * scale, y + (36 + 96) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.range), x + 60 * scale, y + (35 + 96) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.prayer), x + 49 * scale, y + (22 + 128) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.prayer), x + 48 * scale, y + (21 + 128) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.prayer), x + 61 * scale, y + (36 + 128) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.prayer), x + 60 * scale, y + (35 + 128) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.magic), x + 49 * scale, y + (22 + 160) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.magic), x + 48 * scale, y + (21 + 160) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.magic), x + 61 * scale, y + (36 + 160) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.magic), x + 60 * scale, y + (35 + 160) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.hitpoint), x + (49 + 63) * scale, y + 22 * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.hitpoint), x + (48 + 63) * scale, y + 21 * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.hitpoint), x + (61 + 63) * scale, y + 36 * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.hitpoint), x + (60 + 63) * scale, y + 35 * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.agility), x + (49 + 63) * scale, y + (22 + 32) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.currentStats.agility), x + (48 + 63) * scale, y + (21 + 32) * scale);
        context.fillStyle = "#000";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.agility), x + (61 + 63) * scale, y + (36 + 32) * scale);
        context.fillStyle = "#FFFF00";
        context.fillText(String(Trainer/* Trainer */.c.player.stats.agility), x + (60 + 63) * scale, y + (35 + 32) * scale);
    };
    return StatsControls;
}(BaseControls));


;// CONCATENATED MODULE: ./src/sdk/ControlPanelController.ts




















var BASE_WIDTH = 33 * 7;
var BASE_HEIGHT = 36 * 2 + 275;
var ControlPanelController = /** @class */ (function () {
    function ControlPanelController() {
        var _this = this;
        this.boostPanel = new BoostPanel();
        this.isUsingExternalUI = false;
        this.width = BASE_WIDTH;
        this.height = BASE_HEIGHT;
        this.desktopControls = [
            ControlPanelController.controls.COMBAT,
            ControlPanelController.controls.STATS,
            new QuestsControls(),
            ControlPanelController.controls.INVENTORY,
            ControlPanelController.controls.EQUIPMENT,
            ControlPanelController.controls.PRAYER,
            ControlPanelController.controls.ANCIENTSSPELLBOOK,
            new EmptyControls(),
            new FriendsControls(),
            new AccountControls(),
            new ClanChatControls(),
            ControlPanelController.controls.SETTINGS,
            new EmotesControls(),
            new MusicControls(),
        ];
        this.mobileControls = [
            ControlPanelController.controls.COMBAT,
            ControlPanelController.controls.PRAYER,
            ControlPanelController.controls.ANCIENTSSPELLBOOK,
            new EmotesControls(),
            new ClanChatControls(),
            new FriendsControls(),
            new AccountControls(),
            // break
            ControlPanelController.controls.INVENTORY,
            ControlPanelController.controls.EQUIPMENT,
            ControlPanelController.controls.STATS,
            new QuestsControls(),
            new MusicControls(),
            ControlPanelController.controls.SETTINGS,
            new EmptyControls(),
        ];
        this.controls = Settings/* Settings */.w.mobileCheck() ? this.mobileControls : this.desktopControls;
        this.selectedControl = ControlPanelController.controls.PRAYER;
        document.addEventListener("keydown", function (event) {
            if (Settings/* Settings */.w.is_keybinding) {
                return;
            }
            if (_this.isUsingExternalUI) {
                return;
            }
            _this.controls.forEach(function (control) {
                if (control.keyBinding === event.key) {
                    _this.selectedControl = control;
                    event.preventDefault();
                }
            });
        });
    }
    ControlPanelController.prototype.getTabScale = function () {
        var _a = Chrome.size(), width = _a.width, height = _a.height;
        if (FixedLayout.enabled) {
            var k = FixedLayout.scale(width);
            // The 204x275 panel art is drawn into the fixed client's 190x261 panel.
            Settings/* Settings */.w.controlPanelScale = (k * FIXED_PANEL.width) / 204;
            this.width = BASE_WIDTH * k;
            this.height = BASE_HEIGHT * k;
            return k;
        }
        var controlAreaHeight = height - MapController.controller.height;
        var scaleRatio = controlAreaHeight / 7 / 36;
        var maxScaleRatio = Settings/* Settings */.w.maxUiScale;
        if (Settings/* Settings */.w.mobileCheck() && width > 600) {
            maxScaleRatio = Settings/* Settings */.w.maxUiScale * 1.1;
        }
        if (scaleRatio > maxScaleRatio) {
            scaleRatio = maxScaleRatio;
        }
        // not the best place for these setters...
        Settings/* Settings */.w.controlPanelScale = scaleRatio * 0.915;
        this.width = BASE_WIDTH * scaleRatio;
        this.height = BASE_HEIGHT * scaleRatio;
        return scaleRatio;
    };
    ControlPanelController.prototype.boostPosition = function () {
        var _a = Chrome.size(), width = _a.width, height = _a.height;
        var scale = this.getTabScale();
        if (FixedLayout.enabled) {
            // bottom-left of the 3D scene, like an infobox column
            return { x: (FIXED_VIEWPORT.x + 4) * scale, y: (FIXED_VIEWPORT.y + FIXED_VIEWPORT.height - 4) * scale };
        }
        if (Settings/* Settings */.w.mobileCheck()) {
            var mapHeight = 170 * Settings/* Settings */.w.minimapScale;
            var spacer = (height - mapHeight - 36 * scale * 7) / 2;
            return { x: 15, y: mapHeight + spacer };
        }
        else {
            return {
                x: width - 231 * scale + 28,
                y: height - 72 * scale,
            };
        }
    };
    ControlPanelController.prototype.tabPosition = function (i) {
        // let scale = Settings.controlPanelScale
        var _a = Chrome.size(), width = _a.width, height = _a.height;
        var scale = this.getTabScale();
        if (FixedLayout.enabled) {
            return {
                x: (FIXED_TABS_X + (i % 7) * 33) * scale,
                y: (i < 7 ? FIXED_TOP_TABS_Y : FIXED_BOTTOM_TABS_Y) * scale,
            };
        }
        if (Settings/* Settings */.w.mobileCheck()) {
            var mapHeight = 170 * Settings/* Settings */.w.minimapScale;
            var spacer = (height - mapHeight - 36 * scale * 7) / 2;
            if (i < 7) {
                return { x: 15, y: mapHeight + spacer + i * 36 * scale };
            }
            else {
                return {
                    x: width - 33 * scale - 15,
                    y: mapHeight + spacer + (i - 7) * 36 * scale,
                };
            }
        }
        else {
            var x = i % 7;
            var y = Math.floor(i / 7);
            return {
                x: width - 231 * scale + x * 33 * scale,
                y: height - 72 * scale + y * 36 * scale,
            };
        }
    };
    ControlPanelController.prototype.cursorMovedTo = function (e) {
        var scale = Settings/* Settings */.w.controlPanelScale;
        if (this.selectedControl) {
            var x = e.offsetX;
            var y = e.offsetY;
            var panelWidth = 204 * scale;
            var panelHeight = 275 * scale;
            var panelPosition = this.controlPosition(this.selectedControl);
            var panelX = panelPosition.x;
            var panelY = panelPosition.y;
            if (panelX < x && x < panelX + panelWidth) {
                if (panelY < y && y < panelY + panelHeight) {
                    var relativeX = x - panelX;
                    var relativeY = y - panelY;
                    this.selectedControl.cursorMovedto(relativeX, relativeY);
                }
            }
        }
    };
    ControlPanelController.prototype.hoverAction = function (e) {
        if (!this.selectedControl)
            return null;
        var scale = Settings/* Settings */.w.controlPanelScale;
        var panelPosition = this.controlPosition(this.selectedControl);
        var panelWidth = 204 * scale;
        var panelHeight = 275 * scale;
        if (e.offsetX < panelPosition.x ||
            e.offsetX >= panelPosition.x + panelWidth ||
            e.offsetY < panelPosition.y ||
            e.offsetY >= panelPosition.y + panelHeight) {
            return null;
        }
        return this.selectedControl.hoverAction(e.offsetX - panelPosition.x, e.offsetY - panelPosition.y);
    };
    ControlPanelController.prototype.controlPanelRightClick = function (e) {
        var intercepted = false;
        var scale = Settings/* Settings */.w.controlPanelScale;
        var x = e.offsetX;
        var y = e.offsetY;
        var panelWidth = 204 * scale;
        var panelHeight = 275 * scale;
        var panelPosition = this.controlPosition(this.selectedControl);
        var panelX = panelPosition.x;
        var panelY = panelPosition.y;
        if (panelX < x && x < panelX + panelWidth) {
            if (panelY < y && y < panelY + panelHeight) {
                var relativeX = x - panelX;
                var relativeY = y - panelY;
                intercepted = true;
                this.selectedControl.panelRightClick(relativeX, relativeY);
            }
        }
        return intercepted;
    };
    ControlPanelController.prototype.controlPanelClickUp = function (e) {
        var scale = Settings/* Settings */.w.controlPanelScale;
        if (!this.selectedControl) {
            return false;
        }
        var intercepted = false;
        var x = e.offsetX;
        var y = e.offsetY;
        var panelWidth = 204 * scale;
        var panelHeight = 275 * scale;
        var panelPosition = this.controlPosition(this.selectedControl);
        var panelX = panelPosition.x;
        var panelY = panelPosition.y;
        if (panelX < x && x < panelX + panelWidth) {
            if (panelY < y && y < panelY + panelHeight) {
                var relativeX = x - panelX;
                var relativeY = y - panelY;
                intercepted = true;
                this.selectedControl.panelClickUp(relativeX, relativeY);
            }
        }
        this.selectedControl.onMouseUp();
        return intercepted;
    };
    ControlPanelController.prototype.setActiveControl = function (index) {
        this.selectedControl = ControlPanelController.controls[index];
    };
    ControlPanelController.prototype.controlPanelClickDown = function (e) {
        var _this = this;
        var intercepted = false;
        var scale = this.getTabScale();
        var x = e.offsetX;
        var y = e.offsetY;
        this.controls.forEach(function (control, index) {
            var tabPosition = _this.tabPosition(index);
            if (tabPosition.x <= x && x < tabPosition.x + 33 * scale) {
                if (tabPosition.y <= y && y < tabPosition.y + 36 * scale) {
                    intercepted = true;
                    if (_this.controls[index] === _this.selectedControl) {
                        _this.selectedControl = null;
                        return;
                    }
                    _this.selectedControl = _this.controls[index];
                }
            }
        });
        if (!this.selectedControl) {
            return intercepted;
        }
        var panelWidth = 204 * scale;
        var panelHeight = 275 * scale;
        var panelPosition = this.controlPosition(this.selectedControl);
        var panelX = panelPosition.x;
        var panelY = panelPosition.y;
        if (panelX < x && x < panelX + panelWidth) {
            if (panelY < y && y < panelY + panelHeight) {
                var relativeX = x - panelX;
                var relativeY = y - panelY;
                intercepted = true;
                this.selectedControl.panelClickDown(relativeX, relativeY);
            }
        }
        return intercepted;
    };
    ControlPanelController.prototype.controlPosition = function (control) {
        var scale = this.getTabScale();
        var _a = Chrome.size(), width = _a.width, height = _a.height;
        if (FixedLayout.enabled) {
            return { x: FIXED_PANEL.x * scale, y: FIXED_PANEL.y * scale };
        }
        if (Settings/* Settings */.w.mobileCheck()) {
            var mapHeight = 170 * Settings/* Settings */.w.minimapScale;
            var spacer = (height - mapHeight - 36 * scale * 7) / 2;
            if (this.selectedControl.appearsOnLeftInMobile) {
                // left side mobile
                return { x: 33 * scale + 15, y: mapHeight + spacer };
            }
            else {
                // right side mobile
                return {
                    x: width - 33 * scale - 15 - 200 * Settings/* Settings */.w.controlPanelScale,
                    y: mapHeight + spacer,
                };
            }
        }
        else {
            // desktop compact
            return {
                x: width - 188 * scale,
                y: height - 72 * scale - 251 * scale,
            };
        }
    };
    ControlPanelController.prototype.onWorldTick = function () {
        this.controls.forEach(function (control) {
            control.onWorldTick();
        });
    };
    ControlPanelController.prototype.draw = function (context) {
        var _this = this;
        context.fillStyle = "#000";
        var scale = this.getTabScale();
        if (this.selectedControl && this.selectedControl.draw) {
            var position = this.controlPosition(this.selectedControl);
            this.selectedControl.draw(context, this, position.x, position.y);
        }
        // TODO: make this rendering configurable
        var boostPosition = this.boostPosition();
        this.boostPanel.draw(context, scale, boostPosition.x, boostPosition.y);
        var selectedPosition = null;
        this.controls.forEach(function (control, index) {
            var tabPosition = _this.tabPosition(index);
            if (control.tabImage) {
                context.drawImage(control.tabImage, tabPosition.x, tabPosition.y, control.tabImage.width * scale, control.tabImage.height * scale);
            }
            if (control.isAvailable === false) {
                context.fillStyle = "#00000099";
                context.fillRect(tabPosition.x, tabPosition.y, 33 * scale, 36 * scale);
            }
            if (control === _this.selectedControl) {
                selectedPosition = tabPosition;
            }
        });
        if (selectedPosition) {
            context.strokeStyle = "#00FF0073";
            context.lineWidth = 3;
            context.strokeRect(selectedPosition.x, selectedPosition.y, 33 * scale, 36 * scale);
        }
    };
    ControlPanelController.controls = Object.freeze({
        COMBAT: new CombatControls(),
        INVENTORY: new InventoryControls(),
        PRAYER: new PrayerControls(),
        EQUIPMENT: new EquipmentControls(),
        STATS: new StatsControls(),
        ANCIENTSSPELLBOOK: new AncientsSpellbookControls(),
        SETTINGS: new SettingsControls(),
    });
    ControlPanelController.controller = new ControlPanelController();
    return ControlPanelController;
}());


// EXTERNAL MODULE: ./src/sdk/XpDropController.ts + 1 modules
var XpDropController = __webpack_require__(4133);
// EXTERNAL MODULE: ./src/sdk/DelayedAction.ts
var DelayedAction = __webpack_require__(8239);
// EXTERNAL MODULE: external "three"
var external_three_ = __webpack_require__(9604);
;// CONCATENATED MODULE: ./src/sdk/rendering/EmptyModel.ts
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var EmptyModel = /** @class */ (function () {
    function EmptyModel() {
    }
    EmptyModel.forRenderable = function (r) {
        return new EmptyModel();
    };
    EmptyModel.prototype.draw = function (scene, clockDelta, tickPercent, location, angleRadians, pitchRadians, visible, modelOffsets) {
        // do nothing
    };
    EmptyModel.prototype.destroy = function (scene) {
        // do nothing
    };
    EmptyModel.prototype.getWorldPosition = function () {
        return new external_three_.Vector3(0, 0, 0);
    };
    EmptyModel.prototype.preload = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // do nothing
                return [2 /*return*/];
            });
        });
    };
    return EmptyModel;
}());


;// CONCATENATED MODULE: ./src/content/MovementBlocker.ts

var MovementBlocker_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var InvisibleMovementBlocker = /** @class */ (function (_super) {
    MovementBlocker_extends(InvisibleMovementBlocker, _super);
    function InvisibleMovementBlocker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InvisibleMovementBlocker.prototype, "lineOfSight", {
        get: function () {
            return LineOfSight/* LineOfSightMask */.Z.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InvisibleMovementBlocker.prototype, "collisionType", {
        get: function () {
            return Collision/* CollisionType */.B.BLOCK_MOVEMENT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InvisibleMovementBlocker.prototype, "size", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    InvisibleMovementBlocker.prototype.draw = function () {
        // force empty draw
    };
    InvisibleMovementBlocker.prototype.create3dModel = function () {
        return new EmptyModel();
    };
    return InvisibleMovementBlocker;
}(Entity/* Entity */.w));


// EXTERNAL MODULE: ./src/content/equipment/index.ts + 151 modules
var equipment = __webpack_require__(7876);
// EXTERNAL MODULE: ./src/content/items/index.ts + 44 modules
var items = __webpack_require__(2202);
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/icon/checkmark_green.png
const checkmark_green_namespaceObject = __webpack_require__.p + "5952df12e6e4b72a5de5.png";
// EXTERNAL MODULE: ./src/sdk/rendering/CacheRenderModel.ts + 1 modules
var CacheRenderModel = __webpack_require__(3752);
// EXTERNAL MODULE: ./src/sdk/rendering/CacheRenderReference.ts
var CacheRenderReference = __webpack_require__(7757);
// EXTERNAL MODULE: ./src/sdk/Random.ts
var Random = __webpack_require__(7212);
;// CONCATENATED MODULE: ./src/content/mobs/Manticore.ts
var Manticore_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Manticore_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;












/** Semantic pose indices mapped to the cache sequences extracted for NPC 12818. */
var ManticoreAnimations;
(function (ManticoreAnimations) {
    ManticoreAnimations[ManticoreAnimations["Idle"] = 0] = "Idle";
    ManticoreAnimations[ManticoreAnimations["Walk"] = 1] = "Walk";
    ManticoreAnimations[ManticoreAnimations["TripleCharge"] = 2] = "TripleCharge";
    ManticoreAnimations[ManticoreAnimations["TripleThrow"] = 3] = "TripleThrow";
    ManticoreAnimations[ManticoreAnimations["Death"] = 4] = "Death";
})(ManticoreAnimations || (ManticoreAnimations = {}));
var Orbs;
(function (Orbs) {
    Orbs[Orbs["Range"] = 0] = "Range";
    Orbs[Orbs["Mage"] = 1] = "Mage";
    Orbs[Orbs["Melee"] = 2] = "Melee";
})(Orbs || (Orbs = {}));
;
var ORB_TO_SPOTANIM = (_a = {},
    _a[Orbs.Range] = 2683,
    _a[Orbs.Mage] = 2681,
    _a[Orbs.Melee] = 2685,
    _a);
// dunno if these change
var TRIPLE_THROW_PROJECTILE_SOUND = 8382;
var ORB_TO_PROJECTILE_SOUND = (_b = {},
    _b[Orbs.Range] = 8382,
    _b[Orbs.Mage] = 8382,
    _b[Orbs.Melee] = 8382,
    _b);
var ORB_HEIGHT_1 = 7;
var ORB_HEIGHT_2 = 9;
var ORB_HEIGHT_3 = 11;
var PROJECTILE_FLIGHT_CLIENT_CYCLES = 30;
/**
 * The Fortis Colosseum manticore (NPC definition 12818).
 *
 * This is a reference implementation of the Manticore's combat and visuals.
 * Consumers are responsible for declaring NPC 12818, its sequences, and the
 * three orb spotanims, and projectile sounds 8406, 8400, and 8383 in their
 * own cache asset manifest.
 */
var Manticore = /** @class */ (function (_super) {
    Manticore_extends(Manticore, _super);
    function Manticore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.attackReadyImage = ImageLoader/* ImageLoader */.$.createImage(checkmark_green_namespaceObject);
        _this.attackStyles = null;
        _this.preselectedAttackStyles = null;
        _this.hasAttacked = false;
        return _this;
    }
    Manticore.prototype.mobName = function () {
        return "Manticore";
    };
    Object.defineProperty(Manticore.prototype, "combatLevel", {
        get: function () {
            return 320;
        },
        enumerable: false,
        configurable: true
    });
    Manticore.prototype.setStats = function () {
        this.weapons = {
            crush: new MeleeWeapon/* MeleeWeapon */.d({ visuals: { hidden: false } }),
            range: new RangedWeapon/* RangedWeapon */.I(),
            magic: new MagicWeapon/* MagicWeapon */.u(),
        };
        this.stats = {
            attack: 300,
            strength: 300,
            defence: 250,
            range: 350,
            magic: 300,
            hitpoint: 250,
        };
        this.currentStats = JSON.parse(JSON.stringify(this.stats));
    };
    Object.defineProperty(Manticore.prototype, "bonuses", {
        get: function () {
            return {
                attack: {
                    stab: 0,
                    slash: 0,
                    crush: 0,
                    magic: 0,
                    range: 0,
                },
                defence: {
                    stab: 0,
                    slash: 0,
                    crush: 0,
                    magic: 10,
                    range: 25,
                },
                other: {
                    meleeStrength: 0,
                    rangedStrength: 0,
                    // The SDK represents the NPC's unmodified magic damage multiplier as 1.
                    magicDamage: 1,
                    prayer: 0,
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Manticore.prototype, "attackSpeed", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Manticore.prototype, "attackRange", {
        get: function () {
            return 15;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Manticore.prototype, "size", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Manticore.prototype, "flinchDelay", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Manticore.prototype.attackStyleForNewAttack = function () {
        // not used
        return "range";
    };
    Manticore.prototype.attack = function () {
        if (!this.attackStyles) {
            this.selectAttackStyle();
            this.attackDelay = 10;
            return false;
        }
        return true;
    };
    Manticore.prototype.didAttack = function () {
        var _this = this;
        if (!this.attackStyles) {
            // shouldn't happen
            return;
        }
        // override default behaviour
        this.attackDelay = 10;
        this.region.mobs.forEach(function (mob) {
            if (!(mob instanceof Manticore) || mob === _this || mob.attackStyles === null)
                return;
            if (mob.attackDelay <= 0)
                mob.attackDelay = 5;
        });
        this.playAnimation(ManticoreAnimations.TripleThrow);
        // The first projectile is launched on the attack tick.
        this.fireProjectile(0);
        this.clearSpotAnim("first-orb");
        DelayedAction/* DelayedAction */.T.registerDelayedNpcAction(new DelayedAction/* DelayedAction */.T(function () {
            _this.fireProjectile(1);
            _this.clearSpotAnim("second-orb");
        }, 1));
        DelayedAction/* DelayedAction */.T.registerDelayedNpcAction(new DelayedAction/* DelayedAction */.T(function () {
            _this.fireProjectile(2);
            _this.clearSpotAnim("third-orb");
        }, 2));
        this.hasAttacked = true;
    };
    Manticore.prototype.selectKnownAttackStyle = function () {
        var _this = this;
        if (this.attackStyles) {
            return this.attackStyles;
        }
        if (this.preselectedAttackStyles) {
            this.attackStyles = Manticore_spreadArray([], this.preselectedAttackStyles, true);
            return this.attackStyles;
        }
        var coordinatedManticore = this.region.mobs.find(function (mob) {
            return mob instanceof Manticore
                && mob !== _this
                && mob.dying < 0
                && mob.currentStats.hitpoint > 0
                && mob.attackStyles !== null;
        });
        if (coordinatedManticore === null || coordinatedManticore === void 0 ? void 0 : coordinatedManticore.attackStyles) {
            this.attackStyles = Manticore_spreadArray([], coordinatedManticore.attackStyles, true);
            return this.attackStyles;
        }
        return null;
    };
    Manticore.prototype.selectAttackStyle = function () {
        var _a;
        var knownAttackStyles = this.selectKnownAttackStyle();
        if (knownAttackStyles) {
            return knownAttackStyles;
        }
        if (Manticore.mayhemLevel >= 3) {
            // Mantimayhem III: any permutation, melee no longer has to be last.
            var orbs = [Orbs.Range, Orbs.Mage, Orbs.Melee];
            for (var index = orbs.length - 1; index > 0; index--) {
                var swapIndex = Math.floor(Random/* Random */.o.get() * (index + 1));
                _a = [orbs[swapIndex], orbs[index]], orbs[index] = _a[0], orbs[swapIndex] = _a[1];
            }
            this.attackStyles = orbs;
            return this.attackStyles;
        }
        this.attackStyles = [];
        // 50% chance of range or mage first
        var firstStyle = Random/* Random */.o.get() < 0.5 ? Orbs.Range : Orbs.Mage;
        this.attackStyles.push(firstStyle);
        if (firstStyle === Orbs.Range) {
            this.attackStyles.push(Orbs.Mage, Orbs.Melee);
        }
        else {
            this.attackStyles.push(Orbs.Range, Orbs.Melee);
        }
        return this.attackStyles;
    };
    Manticore.prototype.attackStep = function () {
        var _a;
        _super.prototype.attackStep.call(this);
        if (this.aggro && this.hasLOS && !this.attackStyles) {
            this.selectAttackStyle();
            this.attackDelay = 10;
        }
        if (((_a = this.attackStyles) === null || _a === void 0 ? void 0 : _a.length) === 3) {
            if (this.attackDelay === 6) {
                this.playAnimation(ManticoreAnimations.TripleCharge);
            }
            if (this.attackDelay <= 5) {
                this.playChargedOrb(0, ORB_HEIGHT_1, "first-orb");
            }
            if (this.attackDelay <= 4 || (this.hasAttacked && this.attackDelay >= 10)) {
                this.playChargedOrb(1, ORB_HEIGHT_2, "second-orb");
            }
            if (this.attackDelay <= 3 || (this.hasAttacked && this.attackDelay >= 9)) {
                this.playChargedOrb(2, ORB_HEIGHT_3, "third-orb");
            }
        }
    };
    /** Show the coloured orb charging above the Manticore's head. */
    Manticore.prototype.playChargedOrb = function (index, height, channel) {
        var _a;
        var orb = (_a = this.attackStyles) === null || _a === void 0 ? void 0 : _a[index];
        if (orb === undefined)
            return;
        this.addSpotAnim({ id: ORB_TO_SPOTANIM[orb], channel: channel, height: height });
    };
    /** Launch the coloured orb as a projectile. */
    Manticore.prototype.fireProjectile = function (index) {
        if (!this.attackStyles) {
            return;
        }
        var orb = this.attackStyles[index];
        var target = this.aggro;
        if (orb === undefined || !target)
            return;
        var spotAnimId = ORB_TO_SPOTANIM[orb];
        var attackStyle = orb === Orbs.Range ? "range" : orb === Orbs.Mage ? "magic" : "crush";
        var weapon = this.weapons[attackStyle];
        // Mantimayhem I+: each orb hits twice on the same tick.
        var hits = Manticore.mayhemLevel >= 1 ? 2 : 1;
        for (var hit = 0; hit < hits; hit++)
            this.fireOrbHit(weapon, attackStyle, target, spotAnimId, orb);
    };
    Manticore.prototype.fireOrbHit = function (weapon, attackStyle, target, spotAnimId, orb) {
        weapon.attack(this, target, {
            attackStyle: attackStyle,
            magicBaseSpellDamage: attackStyle === "magic" ? this.magicMaxHit() : undefined,
        }, {
            // Projectiles added during attackStep are processed once immediately
            // by World.tickRegion, so delay 2 means one full tick after spawning.
            setDelay: 2,
            visuals: {
                spotAnim: { id: spotAnimId },
                projectileSound: new SoundCache/* Sound */.A((0,CacheSoundEffects/* cacheSound */.cp)(ORB_TO_PROJECTILE_SOUND[orb]), 0.1),
                // Every orb visually reaches its target one game tick after launch,
                // regardless of the distance-derived combat hit delay.
                endCycleOffset: PROJECTILE_FLIGHT_CLIENT_CYCLES,
            },
        });
    };
    /**
     * Apply a specific attack sequence by string: (r)ange/(m)age/(M)elee. TODO: should just pass
     * an array in instead of decoding strings here.
     */
    Manticore.prototype.setAttackPattern = function (pattern) {
        var startsUncharged = pattern.startsWith("u");
        var normalized = startsUncharged ? pattern.slice(1) : pattern;
        var expanded = normalized === "r" ? "rmM" : normalized === "m" ? "mrM" : normalized;
        var orbByCode = { r: Orbs.Range, m: Orbs.Mage, M: Orbs.Melee };
        var decoded = expanded.split("").map(function (code) { return orbByCode[code]; });
        if (decoded.length === 3 && decoded.every(function (orb) { return orb !== undefined; })) {
            if (startsUncharged) {
                this.preselectedAttackStyles = decoded;
                this.attackDelay = 10;
            }
            else {
                this.attackStyles = decoded;
            }
        }
    };
    Object.defineProperty(Manticore.prototype, "idlePoseId", {
        get: function () {
            return ManticoreAnimations.Idle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Manticore.prototype, "walkingPoseId", {
        get: function () {
            return ManticoreAnimations.Walk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Manticore.prototype, "tripleChargeAnimationId", {
        /** Semantic index for the charge-up phase of the triple attack. */
        get: function () {
            return ManticoreAnimations.TripleCharge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Manticore.prototype, "tripleThrowAnimationId", {
        /** Semantic index for the projectile throw phase of the triple attack. */
        get: function () {
            return ManticoreAnimations.TripleThrow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Manticore.prototype, "deathAnimationId", {
        get: function () {
            return ManticoreAnimations.Death;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Manticore.prototype, "deathAnimationLength", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Manticore.prototype.canMeleeIfClose = function () {
        return "crush";
    };
    Manticore.prototype.magicMaxHit = function () {
        return 31;
    };
    Object.defineProperty(Manticore.prototype, "maxHit", {
        /** Highest of the manticore's three style max hits (ranged). */
        get: function () {
            return 36;
        },
        enumerable: false,
        configurable: true
    });
    Manticore.prototype.create3dModel = function () {
        return CacheRenderModel/* CacheRenderModel */.q.forRenderable(this, CacheRenderReference/* CacheRenderReferences */.P.npc(Manticore.NPC_ID));
    };
    Manticore.prototype.drawUILayer = function (tickPercent, projector, context, scale) {
        _super.prototype.drawUILayer.call(this, tickPercent, projector, context, scale);
        if (!projector.visible || !Manticore.showAttackTimer)
            return;
        // draw attack delay
        var hitsplatPosition = projector.atHeight(projector.logicalHeight * 0.5);
        context.save();
        context.translate(hitsplatPosition.x, hitsplatPosition.y);
        if (!this.attackStyles && !this.preselectedAttackStyles) {
            context.font = "18px Stats_11";
            context.textAlign = "center";
            context.lineWidth = 3;
            context.strokeStyle = "#000000";
            context.strokeText("?", 0, 42);
            context.fillStyle = "#FFFF00";
            context.fillText("?", 0, 42);
        }
        else if (this.attackDelay <= 0) {
            context.drawImage(this.attackReadyImage, -6, 28);
        }
        else {
            context.font = "18px Stats_11";
            context.textAlign = "center";
            context.lineWidth = 3;
            context.strokeStyle = "#000000";
            context.strokeText(String(this.attackDelay), 0, 42);
            context.fillStyle = "#FFFF00";
            context.fillText(String(this.attackDelay), 0, 42);
        }
        context.restore();
    };
    Manticore.NPC_ID = 12818;
    /**
     * Colosseum Mantimayhem modifier level (0 = off). I: every orb hits twice.
     * II: unprotected hits also venom (applied by the region). III: any orb order.
     */
    Manticore.mayhemLevel = 0;
    /** Trainer aid (not in the real client): draw the charge countdown above the head. */
    Manticore.showAttackTimer = true;
    return Manticore;
}(Mob/* Mob */.B));


;// CONCATENATED MODULE: ./src/content/mobs/index.ts


// EXTERNAL MODULE: ./src/content/weapons/index.ts + 35 modules
var weapons = __webpack_require__(1618);
;// CONCATENATED MODULE: ./src/content/index.ts
var content_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var content_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






function loadLoadoutRegistry() {
    return content_awaiter(this, void 0, void 0, function () {
        var LoadoutRegistry;
        return content_generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 613))];
                case 1:
                    LoadoutRegistry = (_a.sent()).LoadoutRegistry;
                    return [2 /*return*/, LoadoutRegistry];
            }
        });
    });
}

// EXTERNAL MODULE: ./src/content/LoadoutRegistry.ts
var LoadoutRegistry = __webpack_require__(613);
;// CONCATENATED MODULE: ./src/sdk/ui/Button.ts



var Button_ACTIVE_BUTTON_IMAGE = ImageLoader/* ImageLoader */.$.createImage(button_active_namespaceObject);
var Button_INACTIVE_BUTTON_IMAGE = ImageLoader/* ImageLoader */.$.createImage(button_inactive_namespaceObject);
var Button = /** @class */ (function () {
    function Button(label, xOffset, yOffset, onClick, activeButtonImage, inactiveButtonImage, overlayInactive) {
        if (activeButtonImage === void 0) { activeButtonImage = Button_ACTIVE_BUTTON_IMAGE; }
        if (inactiveButtonImage === void 0) { inactiveButtonImage = Button_INACTIVE_BUTTON_IMAGE; }
        if (overlayInactive === void 0) { overlayInactive = false; }
        this.label = label;
        this.xOffset = xOffset;
        this.yOffset = yOffset;
        this.onClick = onClick;
        this.activeButtonImage = activeButtonImage;
        this.inactiveButtonImage = inactiveButtonImage;
        this.overlayInactive = overlayInactive;
        this.hovered = false;
    }
    Button.prototype.draw = function (context, scale, panelX, panelY) {
        context.drawImage(this.hovered || this.overlayInactive ? this.activeButtonImage : this.inactiveButtonImage, panelX + this.xOffset * scale, panelY + this.yOffset * scale, this.activeButtonImage.width * scale, this.activeButtonImage.height * scale);
        if (this.overlayInactive && !this.hovered) {
            context.drawImage(this.inactiveButtonImage, panelX + this.xOffset * scale, panelY + this.yOffset * scale, this.inactiveButtonImage.width * scale, this.inactiveButtonImage.height * scale);
        }
        context.save();
        context.fillStyle = "#FFFF00";
        context.font = 16 * scale + "px OSRS";
        context.textBaseline = "middle";
        context.textAlign = "center";
        context.fillText(this.label, panelX + (this.xOffset + this.activeButtonImage.width / 2) * scale, panelY + (this.yOffset + Button_ACTIVE_BUTTON_IMAGE.height / 2) * scale);
        context.restore();
    };
    Button.prototype._isMouseOver = function (x, y) {
        return (x >= this.xOffset &&
            x <= this.xOffset + this.activeButtonImage.width &&
            y >= this.yOffset &&
            y <= this.yOffset + this.activeButtonImage.height);
    };
    Button.prototype.onPanelClick = function (x, y) {
        if (this._isMouseOver(x, y)) {
            this.onClick();
            return true;
        }
        return false;
    };
    Button.prototype.onMouseMove = function (x, y) {
        this.hovered = this._isMouseOver(x, y);
        return this.hovered;
    };
    return Button;
}());


// EXTERNAL MODULE: ./src/sdk/utils/Chunk.ts
var Chunk = __webpack_require__(5164);
;// CONCATENATED MODULE: ./src/sdk/Region.ts

var Region_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Region_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Region_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};









var CardinalDirection;
(function (CardinalDirection) {
    CardinalDirection[CardinalDirection["NORTH"] = 0] = "NORTH";
    CardinalDirection[CardinalDirection["SOUTH"] = 1] = "SOUTH";
    CardinalDirection[CardinalDirection["EAST"] = 2] = "EAST";
    CardinalDirection[CardinalDirection["WEST"] = 3] = "WEST";
})(CardinalDirection || (CardinalDirection = {}));
// Base class for any trainer region.
var Region = /** @class */ (function () {
    function Region(loadoutTemplates) {
        if (loadoutTemplates === void 0) { loadoutTemplates = []; }
        this.loadoutTemplates = loadoutTemplates;
        this.players = [];
        this.newMobs = [];
        this.mobs = [];
        this.primaryBoss = null;
        this.nextChunkOrder = 0;
        this.tileCollisionFlags = null;
        this.entities = [];
        // Combat projectiles aimed at locations rather than units.
        this.projectiles = [];
        // Client-cycle visuals are region-owned and expire independently of hits.
        this.projectileGraphics = [];
        this.groundItems = {};
    }
    Object.defineProperty(Region.prototype, "initialFacing", {
        get: function () {
            return CardinalDirection.SOUTH;
        },
        enumerable: false,
        configurable: true
    });
    Region.prototype.midTick = function () {
        // Override me
    };
    Region.prototype.postTick = function () {
        // Override me
    };
    /** Called after a projectile's damage has been applied to a unit in this region. */
    Region.prototype.onIncomingHit = function (unit, projectile) {
        // Override me
    };
    Region.prototype.addPlayer = function (player) {
        if (player.consumesSpace)
            this.setTileCollisionFlags(player.location.x, player.location.y, player.size);
        this.players.push(player);
        this.refreshUnitChunk(player);
        player.addedToWorld();
    };
    Region.prototype.rightClickActions = function () {
        return [];
    };
    Object.defineProperty(Region.prototype, "context", {
        get: function () {
            if (!this.canvas) {
                if (Settings/* Settings */.w.mobileCheck()) {
                    this.canvas = new OffscreenCanvas(2000, 2000);
                }
                else {
                    this.canvas = new OffscreenCanvas(10000, 10000);
                }
            }
            return this.canvas.getContext("2d");
        },
        enumerable: false,
        configurable: true
    });
    Region.prototype.addEntity = function (entity) {
        this.entities.push(entity);
    };
    Region.prototype.removeEntity = function (entity) {
        (0,lodash.remove)(this.entities, entity);
    };
    Region.prototype.addMob = function (mob) {
        if (mob.consumesSpace)
            this.setTileCollisionFlags(mob.location.x, mob.location.y, mob.size);
        if (!mob.region.world) {
            this.mobs.push(mob);
            this.refreshUnitChunk(mob);
            mob.addedToWorld();
        }
        else {
            this.newMobs.push(mob);
            this.refreshUnitChunk(mob);
        }
    };
    Region.prototype.hasUnit = function (unit) {
        return this.players.some(function (player) { return player === unit; })
            || this.mobs.some(function (mob) { return mob === unit; })
            || this.newMobs.some(function (mob) { return mob === unit; });
    };
    /** Assign a fresh order when a unit first appears or crosses a chunk boundary. */
    Region.prototype.refreshUnitChunk = function (unit) {
        var chunkPosition = Chunk/* ChunkUtils */.N.fromLocation(unit.location);
        if (unit.chunkOrder >= 0 && Chunk/* ChunkUtils */.N.equals(unit.chunkPosition, chunkPosition))
            return;
        unit.chunkPosition = chunkPosition;
        unit.chunkOrder = this.nextChunkOrder++;
    };
    /** Return NPCs in this chunk, with the most recent entrant first. */
    Region.prototype.getNpcsInChunk = function (chunkX, chunkY) {
        return Region_spreadArray(Region_spreadArray([], this.mobs, true), this.newMobs, true).filter(function (mob) { return mob.chunkPosition.x === chunkX && mob.chunkPosition.y === chunkY; })
            .sort(function (first, second) { return second.chunkOrder - first.chunkOrder; });
    };
    /** One-based position in the order NPCs in this chunk will be considered. */
    Region.prototype.getNpcChunkPriority = function (mob) {
        var priority = this.getNpcsInChunk(mob.chunkPosition.x, mob.chunkPosition.y).indexOf(mob);
        return priority < 0 ? null : priority + 1;
    };
    /**
     * Sets or clears the "boss" for the region, which is the NPC for which we'll render the boss health bar.
     */
    Region.prototype.setBoss = function (mob) {
        this.primaryBoss = mob;
    };
    Region.prototype.removeMob = function (mob) {
        if (mob.consumesSpace)
            this.clearTileCollisionFlags(mob.location.x, mob.location.y, mob.size);
        (0,lodash.remove)(this.mobs, mob);
        (0,lodash.remove)(this.newMobs, mob);
        if (this.primaryBoss === mob)
            this.primaryBoss = null;
    };
    /**
     * Tile collision flags are persistent client state. They are deliberately
     * not rebuilt from current unit positions each tick. NPC and player movement
     * explicitly clear and restore the flags affected by their path.
     */
    Region.prototype.getTileCollisionFlags = function () {
        var length = this.width * this.height;
        if (!this.tileCollisionFlags || this.tileCollisionFlags.length !== length) {
            this.tileCollisionFlags = new Uint8Array(length);
        }
        return this.tileCollisionFlags;
    };
    Region.prototype.tileCollisionFlagIndex = function (x, y) {
        if (x < 0 || x >= this.width || y < 0 || y >= this.height)
            return -1;
        return y * this.width + x;
    };
    Region.prototype.hasTileCollisionFlags = function (x, y, size) {
        var flags = this.getTileCollisionFlags();
        for (var xx = x; xx < x + size; xx++) {
            for (var yy = y; yy > y - size; yy--) {
                var index = this.tileCollisionFlagIndex(xx, yy);
                if (index >= 0 && flags[index] !== 0)
                    return true;
            }
        }
        return false;
    };
    Region.prototype.setTileCollisionFlags = function (x, y, size) {
        var flags = this.getTileCollisionFlags();
        for (var xx = x; xx < x + size; xx++) {
            for (var yy = y; yy > y - size; yy--) {
                var index = this.tileCollisionFlagIndex(xx, yy);
                if (index >= 0)
                    flags[index] = 1;
            }
        }
    };
    Region.prototype.clearTileCollisionFlags = function (x, y, size) {
        var flags = this.getTileCollisionFlags();
        for (var xx = x; xx < x + size; xx++) {
            for (var yy = y; yy > y - size; yy--) {
                var index = this.tileCollisionFlagIndex(xx, yy);
                if (index >= 0)
                    flags[index] = 0;
            }
        }
    };
    Region.prototype.getTileCollisionFlagLocations = function () {
        var locations = [];
        var flags = this.getTileCollisionFlags();
        for (var y = 0; y < this.height; y++) {
            for (var x = 0; x < this.width; x++) {
                if (flags[this.tileCollisionFlagIndex(x, y)] !== 0)
                    locations.push({ x: x, y: y });
            }
        }
        return locations;
    };
    Region.prototype.removePlayer = function (player) {
        if (player.consumesSpace)
            this.clearTileCollisionFlags(player.location.x, player.location.y, player.size);
        (0,lodash.remove)(this.players, player);
        if (this.players.length === 0) {
            this.onGameOver();
        }
    };
    Region.prototype.clearAggroFor = function (target) {
        Region_spreadArray(Region_spreadArray(Region_spreadArray([], this.players, true), this.mobs, true), this.newMobs, true).forEach(function (unit) {
            if (unit.aggro === target) {
                unit.setAggro(null);
            }
        });
    };
    Region.prototype.onUnitDeath = function (unit) {
        // Override in encounter regions that need to react to a unit dying.
    };
    Region.prototype.addGroundItem = function (player, item, x, y) {
        if (!this.groundItems[x]) {
            this.groundItems[x] = {};
        }
        if (!this.groundItems[x][y]) {
            this.groundItems[x][y] = [];
        }
        item.groundLocation = { x: player.location.x, y: player.location.y };
        this.groundItems[x][y].push(item);
    };
    Region.prototype.addProjectile = function (projectile) {
        this.projectiles.push(projectile);
        this.addProjectileGraphic(projectile.graphic);
    };
    Region.prototype.removeProjectile = function (projectile) {
        (0,lodash.remove)(this.projectiles, projectile);
    };
    Region.prototype.addProjectileGraphic = function (graphic) {
        if (!this.projectileGraphics.includes(graphic))
            this.projectileGraphics.push(graphic);
    };
    Region.prototype.getName = function () {
        return "My Region";
    };
    Object.defineProperty(Region.prototype, "width", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Region.prototype, "height", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Region.prototype.mapImagePath = function () {
        return "";
    };
    Region.prototype.drawWorldBackground = function (context, scale) {
        // Override me
    };
    Region.prototype.drawDefaultFloor = function () {
        return true;
    };
    Region.prototype.groundItemsAtLocation = function (x, y) {
        return (this.groundItems[x] ? this.groundItems[x][y] : []) || [];
    };
    Region.prototype.removeGroundItem = function (item, x, y) {
        if (this.groundItems[x]) {
            if (this.groundItems[x][y]) {
                (0,lodash.remove)(this.groundItems[x][y], item);
            }
        }
    };
    Region.prototype.drawGroundItems = function (ctx) {
        var _this = this;
        Object.entries(this.groundItems).forEach(function (scope1) {
            var x = parseInt(scope1[0]);
            Object.entries(_this.groundItems[x]).forEach(function (scope2) {
                var y = parseInt(scope2[0]);
                var items = _this.groundItems[x][y];
                items.forEach(function (item) {
                    ctx.drawImage(item.inventorySprite, x * Settings/* Settings */.w.tileSize, y * Settings/* Settings */.w.tileSize, Settings/* Settings */.w.tileSize, Settings/* Settings */.w.tileSize);
                });
            });
        });
    };
    Region.prototype.createLoadoutItem = function (itemId) {
        if (itemId === null)
            return null;
        var registeredItem = LoadoutRegistry.LoadoutRegistry.get(itemId);
        if (!registeredItem)
            return null;
        var ItemType = registeredItem.constructor;
        return new ItemType();
    };
    Region.prototype.constructLoadout = function (loadout) {
        var _this = this;
        var equipment = {};
        Object.keys(loadout.equipment).forEach(function (slot) {
            equipment[slot] = _this.createLoadoutItem(loadout.equipment[slot]);
        });
        return {
            equipment: equipment,
            inventory: loadout.inventory.map(function (itemId) { return _this.createLoadoutItem(itemId); }),
        };
    };
    Region.prototype.applyConfiguredLoadout = function (player) {
        var _a, _b;
        if (this.loadoutTemplates.length === 0)
            return;
        var selectedLoadout = this.loadoutTemplates.find(function (_a) {
            var name = _a.name;
            return name === Settings/* Settings */.w.loadout;
        });
        var customLoadout = ((_a = Settings/* Settings */.w.customLoadout) === null || _a === void 0 ? void 0 : _a.name) === (selectedLoadout === null || selectedLoadout === void 0 ? void 0 : selectedLoadout.name)
            ? Settings/* Settings */.w.customLoadout
            : null;
        var loadout = (_b = customLoadout !== null && customLoadout !== void 0 ? customLoadout : selectedLoadout) !== null && _b !== void 0 ? _b : this.loadoutTemplates[0];
        if (loadout)
            player.setUnitOptions(this.constructLoadout(loadout));
    };
    Region.prototype.reset = function (startWorld) {
        var _a;
        if (startWorld === void 0) { startWorld = true; }
        if (!this.world.isPaused) {
            this.world.stopTicking();
        }
        DelayedAction/* DelayedAction */.T.reset();
        this.players = [];
        this.mobs = [];
        this.newMobs = [];
        this.nextChunkOrder = 0;
        (_a = this.tileCollisionFlags) === null || _a === void 0 ? void 0 : _a.fill(0);
        this.entities = [];
        this.projectiles = [];
        this.groundItems = {};
        TileMarker/* TileMarker */.l.loadAll(this);
        Viewport.viewport.reset(this);
        // Set countdown timer like on page load
        this.world.getReadyTimer = 6;
        var reset = this.initialiseRegion();
        this.applyConfiguredLoadout(reset.player);
        for (var _i = 0, _b = Region_spreadArray(Region_spreadArray([], this.players, true), this.mobs, true); _i < _b.length; _i++) {
            var unit = _b[_i];
            unit.setStats();
        }
        Viewport.viewport.setPlayer(reset.player);
        if (startWorld)
            this.world.startTicking();
        return reset;
    };
    Region.prototype.onGameOver = function () {
        // Override me
        Viewport.viewport.components.push(new Button("Reset", 120, 60, function () { return Trainer/* Trainer */.c.reset(); }));
        this.world.stopTicking();
    };
    // calls preload on all renderable children
    Region.prototype.preload = function () {
        return Region_awaiter(this, void 0, void 0, function () {
            return Region_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.entities.map(function (entity) { return entity.preload(); }))];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(this.mobs.map(function (mob) { return mob.preload(); }))];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(this.newMobs.map(function (mob) { return mob.preload(); }))];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(this.players.map(function (players) { return players.preload(); }))];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Region.prototype.getRenderables = function () {
        var units = Region_spreadArray(Region_spreadArray(Region_spreadArray([], this.players, true), this.mobs, true), this.newMobs, true);
        return Region_spreadArray(Region_spreadArray(Region_spreadArray([], this.entities, true), units, true), this.projectileGraphics, true);
    };
    return Region;
}());


;// CONCATENATED MODULE: ./node_modules/three/examples/jsm/libs/stats.module.js
var Stats = function () {

	var mode = 0;

	var container = document.createElement( 'div' );
	container.style.cssText = 'position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000';
	container.addEventListener( 'click', function ( event ) {

		event.preventDefault();
		showPanel( ++ mode % container.children.length );

	}, false );

	//

	function addPanel( panel ) {

		container.appendChild( panel.dom );
		return panel;

	}

	function showPanel( id ) {

		for ( var i = 0; i < container.children.length; i ++ ) {

			container.children[ i ].style.display = i === id ? 'block' : 'none';

		}

		mode = id;

	}

	//

	var beginTime = ( performance || Date ).now(), prevTime = beginTime, frames = 0;

	var fpsPanel = addPanel( new Stats.Panel( 'FPS', '#0ff', '#002' ) );
	var msPanel = addPanel( new Stats.Panel( 'MS', '#0f0', '#020' ) );

	if ( self.performance && self.performance.memory ) {

		var memPanel = addPanel( new Stats.Panel( 'MB', '#f08', '#201' ) );

	}

	showPanel( 0 );

	return {

		REVISION: 16,

		dom: container,

		addPanel: addPanel,
		showPanel: showPanel,

		begin: function () {

			beginTime = ( performance || Date ).now();

		},

		end: function () {

			frames ++;

			var time = ( performance || Date ).now();

			msPanel.update( time - beginTime, 200 );

			if ( time >= prevTime + 1000 ) {

				fpsPanel.update( ( frames * 1000 ) / ( time - prevTime ), 100 );

				prevTime = time;
				frames = 0;

				if ( memPanel ) {

					var memory = performance.memory;
					memPanel.update( memory.usedJSHeapSize / 1048576, memory.jsHeapSizeLimit / 1048576 );

				}

			}

			return time;

		},

		update: function () {

			beginTime = this.end();

		},

		// Backwards Compatibility

		domElement: container,
		setMode: showPanel

	};

};

Stats.Panel = function ( name, fg, bg ) {

	var min = Infinity, max = 0, round = Math.round;
	var PR = round( window.devicePixelRatio || 1 );

	var WIDTH = 80 * PR, HEIGHT = 48 * PR,
		TEXT_X = 3 * PR, TEXT_Y = 2 * PR,
		GRAPH_X = 3 * PR, GRAPH_Y = 15 * PR,
		GRAPH_WIDTH = 74 * PR, GRAPH_HEIGHT = 30 * PR;

	var canvas = document.createElement( 'canvas' );
	canvas.width = WIDTH;
	canvas.height = HEIGHT;
	canvas.style.cssText = 'width:80px;height:48px';

	var context = canvas.getContext( '2d' );
	context.font = 'bold ' + ( 9 * PR ) + 'px Helvetica,Arial,sans-serif';
	context.textBaseline = 'top';

	context.fillStyle = bg;
	context.fillRect( 0, 0, WIDTH, HEIGHT );

	context.fillStyle = fg;
	context.fillText( name, TEXT_X, TEXT_Y );
	context.fillRect( GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT );

	context.fillStyle = bg;
	context.globalAlpha = 0.9;
	context.fillRect( GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT );

	return {

		dom: canvas,

		update: function ( value, maxValue ) {

			min = Math.min( min, value );
			max = Math.max( max, value );

			context.fillStyle = bg;
			context.globalAlpha = 1;
			context.fillRect( 0, 0, WIDTH, GRAPH_Y );
			context.fillStyle = fg;
			context.fillText( round( value ) + ' ' + name + ' (' + round( min ) + '-' + round( max ) + ')', TEXT_X, TEXT_Y );

			context.drawImage( canvas, GRAPH_X + PR, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT, GRAPH_X, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT );

			context.fillRect( GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT );

			context.fillStyle = bg;
			context.globalAlpha = 0.9;
			context.fillRect( GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, round( ( 1 - ( value / maxValue ) ) * GRAPH_HEIGHT ) );

		}

	};

};

/* harmony default export */ const stats_module = (Stats);

;// CONCATENATED MODULE: ./src/sdk/rendering/Actor.ts
var Actor = /** @class */ (function () {
    function Actor(unit) {
        this.unit = unit;
        this.model = unit.get3dModel();
    }
    Actor.prototype.draw = function (scene, clockDelta, tickPercent, clientTickFraction) {
        if (clientTickFraction === void 0) { clientTickFraction = 0; }
        if (!this.model) {
            return;
        }
        var worldLocation = this.unit.getPerceivedLocation(tickPercent);
        var rotationRadians = this.unit.getPerceivedRotation(tickPercent);
        var pitchRadians = this.unit.getPerceivedPitch(tickPercent);
        var modelOffsets = this.unit.getPerceivedOffsets(tickPercent);
        this.model.draw(scene, clockDelta, tickPercent, worldLocation, rotationRadians, pitchRadians, this.unit.visible(tickPercent), modelOffsets, clientTickFraction);
    };
    Actor.prototype.clientTick = function () {
        var _a, _b;
        (_b = (_a = this.model) === null || _a === void 0 ? void 0 : _a.clientTick) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    Actor.prototype.shouldRemove = function () {
        return this.unit.shouldDestroy();
    };
    Actor.prototype.getModel = function () {
        return this.model;
    };
    Actor.prototype.destroy = function (scene) {
        var _a;
        (_a = this.model) === null || _a === void 0 ? void 0 : _a.destroy(scene);
    };
    return Actor;
}());


// EXTERNAL MODULE: ./src/sdk/rendering/RenderUtils.ts
var RenderUtils = __webpack_require__(5333);
;// CONCATENATED MODULE: ./src/sdk/rendering/utils/projectedClickbox.ts
var projectedClickbox_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function screenBoundsContain(bounds, point, tolerance) {
    if (tolerance === void 0) { tolerance = 0; }
    return point.x >= bounds.minX - tolerance && point.x <= bounds.maxX + tolerance
        && point.y >= bounds.minY - tolerance && point.y <= bounds.maxY + tolerance;
}
/** The client's fine hit test is a padded triangle rectangle, not its interior. */
function projectedTriangleBounds(a, b, c) {
    return { minX: Math.min(a.x, b.x, c.x), maxX: Math.max(a.x, b.x, c.x),
        minY: Math.min(a.y, b.y, c.y), maxY: Math.max(a.y, b.y, c.y) };
}
function projectedTrianglesContain(vertices, indices, point, tolerance) {
    if (tolerance === void 0) { tolerance = 5; }
    for (var i = 0; i < indices.length; i += 3) {
        var a = vertices[indices[i]], b = vertices[indices[i + 1]], c = vertices[indices[i + 2]];
        if (!a || !b || !c)
            continue;
        // Inline the deob's rejection checks: no allocation and stop on the first hit.
        if (point.y + tolerance < a.y && point.y + tolerance < b.y && point.y + tolerance < c.y)
            continue;
        if (point.y - tolerance > a.y && point.y - tolerance > b.y && point.y - tolerance > c.y)
            continue;
        if (point.x + tolerance < a.x && point.x + tolerance < b.x && point.x + tolerance < c.x)
            continue;
        if (point.x - tolerance > a.x && point.x - tolerance > b.x && point.x - tolerance > c.x)
            continue;
        return true;
    }
    return false;
}
/** Camera-space depth range of a world AABB, without allocating corner vectors. */
function boundsDepthRange(bounds, cameraInverse) {
    var e = cameraInverse.elements;
    var min = bounds.min, max = bounds.max;
    return {
        min: e[14] + e[2] * (e[2] >= 0 ? min.x : max.x)
            + e[6] * (e[6] >= 0 ? min.y : max.y) + e[10] * (e[10] >= 0 ? min.z : max.z),
        max: e[14] + e[2] * (e[2] >= 0 ? max.x : min.x)
            + e[6] * (e[6] >= 0 ? max.y : min.y) + e[10] * (e[10] >= 0 ? max.z : min.z),
    };
}
/** Perspective projection is undefined for points on or behind the near plane. */
function isInFrontOfNearPlane(cameraSpaceZ, near) {
    return cameraSpaceZ <= -near;
}
var cross = function (origin, a, b) {
    return (a.x - origin.x) * (b.y - origin.y) - (a.y - origin.y) * (b.x - origin.x);
};
function convexHull(points) {
    var sorted = projectedClickbox_spreadArray([], points, true).sort(function (a, b) { return a.x - b.x || a.y - b.y; });
    if (sorted.length <= 2)
        return sorted;
    var lower = [];
    for (var _i = 0, sorted_1 = sorted; _i < sorted_1.length; _i++) {
        var point = sorted_1[_i];
        while (lower.length >= 2 && cross(lower[lower.length - 2], lower[lower.length - 1], point) <= 0)
            lower.pop();
        lower.push(point);
    }
    var upper = [];
    for (var index = sorted.length - 1; index >= 0; index--) {
        var point = sorted[index];
        while (upper.length >= 2 && cross(upper[upper.length - 2], upper[upper.length - 1], point) <= 0)
            upper.pop();
        upper.push(point);
    }
    lower.pop();
    upper.pop();
    return lower.concat(upper);
}
function distanceToSegment(point, a, b) {
    var dx = b.x - a.x, dy = b.y - a.y;
    var lengthSquared = dx * dx + dy * dy;
    var amount = lengthSquared === 0 ? 0 : Math.max(0, Math.min(1, ((point.x - a.x) * dx + (point.y - a.y) * dy) / lengthSquared));
    return Math.hypot(point.x - (a.x + amount * dx), point.y - (a.y + amount * dy));
}
function projectedHullContains(hull, point, tolerance) {
    if (tolerance === void 0) { tolerance = 0; }
    if (hull.length < 3)
        return hull.some(function (vertex) { return Math.hypot(vertex.x - point.x, vertex.y - point.y) <= tolerance; });
    var inside = false;
    for (var index = 0, previous = hull.length - 1; index < hull.length; previous = index++) {
        var a = hull[index], b = hull[previous];
        if (distanceToSegment(point, a, b) <= tolerance)
            return true;
        if ((a.y > point.y) !== (b.y > point.y)
            && point.x < ((b.x - a.x) * (point.y - a.y)) / (b.y - a.y) + a.x)
            inside = !inside;
    }
    return inside;
}

;// CONCATENATED MODULE: ./src/sdk/utils/camera/CameraRotation.ts
var CLIENT_ANGLE_RADIANS = Math.PI / 1024;
var MIN_CAMERA_PITCH = -383 * CLIENT_ANGLE_RADIANS;
var RELAXED_MIN_CAMERA_PITCH = -512 * CLIENT_ANGLE_RADIANS;
var MAX_CAMERA_PITCH = -128 * CLIENT_ANGLE_RADIANS;
var RELAXED_MAX_CAMERA_PITCH = 0;
/**
 * Samples browser pointer state using the camera rotation state machine from
 * the client. Pointer events only update the latest position; rotation is
 * applied once per 20 ms client cycle.
 */
var ClientCameraRotation = /** @class */ (function () {
    function ClientCameraRotation() {
        this.mouseX = 0;
        this.mouseY = 0;
        this.anchorX = 0;
        this.anchorY = 0;
        this.middleMouseDown = false;
        this.yawVelocity = 0;
        this.pitchVelocity = 0;
    }
    ClientCameraRotation.prototype.setPointerPosition = function (x, y) {
        // The desktop client samples integer canvas coordinates.
        this.mouseX = Math.trunc(x);
        this.mouseY = Math.trunc(y);
    };
    ClientCameraRotation.prototype.setMiddleMouseDown = function (down) {
        this.middleMouseDown = down;
    };
    ClientCameraRotation.prototype.clientTick = function () {
        if (this.middleMouseDown) {
            var pitchDelta = this.mouseY - this.anchorY;
            this.pitchVelocity = pitchDelta * 2;
            this.anchorY = pitchDelta !== -1 && pitchDelta !== 1
                ? Math.trunc((this.anchorY + this.mouseY) / 2)
                : this.mouseY;
            var yawDelta = this.anchorX - this.mouseX;
            this.yawVelocity = yawDelta * 2;
            this.anchorX = yawDelta !== -1 && yawDelta !== 1
                ? Math.trunc((this.anchorX + this.mouseX) / 2)
                : this.mouseX;
        }
        else {
            this.yawVelocity = Math.trunc(this.yawVelocity / 2);
            this.pitchVelocity = Math.trunc(this.pitchVelocity / 2);
            this.anchorX = this.mouseX;
            this.anchorY = this.mouseY;
        }
    };
    /** Integrate the sampled velocity at the unlocked render rate. */
    ClientCameraRotation.prototype.frame = function (_a, deltaSeconds, relaxPitch) {
        var yaw = _a.yaw, pitch = _a.pitch;
        if (relaxPitch === void 0) { relaxPitch = false; }
        var clientCycles = deltaSeconds / 0.02;
        yaw += (this.yawVelocity / 2) * CLIENT_ANGLE_RADIANS * clientCycles;
        pitch -= (this.pitchVelocity / 2) * CLIENT_ANGLE_RADIANS * clientCycles;
        var minimumPitch = relaxPitch ? RELAXED_MIN_CAMERA_PITCH : MIN_CAMERA_PITCH;
        var maximumPitch = relaxPitch ? RELAXED_MAX_CAMERA_PITCH : MAX_CAMERA_PITCH;
        pitch = Math.max(minimumPitch, Math.min(maximumPitch, pitch));
        return { yaw: yaw, pitch: pitch };
    };
    return ClientCameraRotation;
}());


// EXTERNAL MODULE: ./src/sdk/utils/constants.ts
var constants = __webpack_require__(9156);
;// CONCATENATED MODULE: ./src/sdk/utils/camera/CameraFocalPoint.ts

var CAMERA_FOCAL_SNAP_DISTANCE = 500;
/** Client-cycle camera focus following, retained internally in client units. */
var CameraFocalPoint = /** @class */ (function () {
    function CameraFocalPoint() {
        this.clientX = null;
        this.clientY = null;
        this.renderFromX = null;
        this.renderFromY = null;
        this.renderTimestamp = 0;
    }
    CameraFocalPoint.prototype.reset = function () {
        this.clientX = null;
        this.clientY = null;
        this.renderFromX = null;
        this.renderFromY = null;
        this.renderTimestamp = 0;
    };
    CameraFocalPoint.prototype.initialise = function (location, timestamp) {
        if (timestamp === void 0) { timestamp = window.performance.now(); }
        if (this.clientX === null || this.clientY === null)
            return this.follow(location, timestamp);
        return this.position;
    };
    CameraFocalPoint.prototype.follow = function (location, timestamp) {
        if (timestamp === void 0) { timestamp = window.performance.now(); }
        var targetX = Math.round((location.x + 0.5) * constants/* CLIENT_UNITS_PER_TILE */.xZ);
        var targetY = Math.round((location.y - 0.5) * constants/* CLIENT_UNITS_PER_TILE */.xZ);
        if (this.clientX === null || this.clientY === null) {
            this.clientX = targetX;
            this.clientY = targetY;
            this.renderFromX = targetX;
            this.renderFromY = targetY;
        }
        else {
            this.renderFromX = this.clientX;
            this.renderFromY = this.clientY;
            var deltaX = targetX - this.clientX;
            var deltaY = targetY - this.clientY;
            if (Math.abs(deltaX) > CAMERA_FOCAL_SNAP_DISTANCE || Math.abs(deltaY) > CAMERA_FOCAL_SNAP_DISTANCE) {
                this.clientX = targetX;
                this.clientY = targetY;
                this.renderFromX = targetX;
                this.renderFromY = targetY;
            }
            else {
                this.clientX += Math.trunc(deltaX / 16);
                this.clientY += Math.trunc(deltaY / 16);
            }
        }
        this.renderTimestamp = timestamp;
        return this.position;
    };
    CameraFocalPoint.prototype.getPerceivedPosition = function (timestamp) {
        if (timestamp === void 0) { timestamp = window.performance.now(); }
        if (this.clientX === null || this.clientY === null || this.renderFromX === null || this.renderFromY === null) {
            throw new Error("Camera focal point has not been initialised");
        }
        var alpha = Math.min(1, Math.max(0, (timestamp - this.renderTimestamp) / 20));
        return {
            x: (this.renderFromX + (this.clientX - this.renderFromX) * alpha) / constants/* CLIENT_UNITS_PER_TILE */.xZ,
            y: (this.renderFromY + (this.clientY - this.renderFromY) * alpha) / constants/* CLIENT_UNITS_PER_TILE */.xZ,
        };
    };
    Object.defineProperty(CameraFocalPoint.prototype, "position", {
        get: function () {
            return {
                x: this.clientX / constants/* CLIENT_UNITS_PER_TILE */.xZ,
                y: this.clientY / constants/* CLIENT_UNITS_PER_TILE */.xZ,
            };
        },
        enumerable: false,
        configurable: true
    });
    return CameraFocalPoint;
}());


;// CONCATENATED MODULE: ./src/sdk/utils/camera/CameraOrbit.ts


var CAMERA_ORBIT_BASE_CLIENT_UNITS = 600;
var CAMERA_ORBIT_CLIENT_UNITS_PER_PITCH = 3;
/** Base client orbit distance before viewport-height zoom scaling. */
function cameraOrbitDistance(pitchRadians) {
    var pitchClientUnits = -pitchRadians / CLIENT_ANGLE_RADIANS;
    return (CAMERA_ORBIT_BASE_CLIENT_UNITS + pitchClientUnits * CAMERA_ORBIT_CLIENT_UNITS_PER_PITCH) / constants/* CLIENT_UNITS_PER_TILE */.xZ;
}

;// CONCATENATED MODULE: ./src/sdk/Viewport3d.ts

var Viewport3d_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Viewport3d_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Viewport3d_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};















// how many pixels wide should 2d elements be scaled to
var SPRITE_SCALE = 32;
var FLOOR_Y_POS = -0.5;
var ROTATE_MULT = 0.006;
var ZOOM_MULT = 0.005;
var TOUCH_MULT = 2;
var Viewport3d = /** @class */ (function () {
    function Viewport3d(faceCameraSouth, worldCanvas) {
        var _this = this;
        var _a, _b;
        this.canvasDimensions = { width: 1, height: 1 };
        this.lastRenderTime = 0;
        this.nextRenderTime = 0;
        this.pivot = new external_three_.Object3D();
        this.yaw = new external_three_.Object3D();
        this.pitch = new external_three_.Object3D();
        this.yawDelta = 0;
        this.pitchDelta = 0;
        this.clientCameraRotation = new ClientCameraRotation();
        this.cameraFocalPoint = new CameraFocalPoint();
        this.orbitZoomOffset = 0;
        this.touchStart = null;
        this.touchStart2 = null;
        this.stats = new stats_module();
        this.knownActors = new Map();
        this.projectedClickboxes = new Map();
        this.pickingPointer = null;
        this.selectedTile = null;
        this.chunkDebugLines = null;
        this.tileCollisionDebugMesh = null;
        this.tileCollisionDebugMatrix = new external_three_.Matrix4();
        this.clock = new external_three_.Clock();
        this.renderingSuspended = false;
        this.renderFailureLogged = false;
        this.scene = new external_three_.Scene();
        this.canvas = new OffscreenCanvas(this.canvasDimensions.width, this.canvasDimensions.height);
        this.uiCanvas = new OffscreenCanvas(this.canvasDimensions.width, this.canvasDimensions.height);
        this.uiCanvasContext = this.uiCanvas.getContext("2d");
        this.checkGpu();
        this.camera = new external_three_.PerspectiveCamera(70, this.canvasDimensions.width / this.canvasDimensions.height, 0.1, 50);
        this.raycaster = new external_three_.Raycaster();
        this.raycaster.params.Points.threshold = 0.1;
        this.raycaster.params.Line.threshold = 0.1;
        this.initCameraEvents(worldCanvas);
        document.addEventListener("visibilitychange", function () {
            if (document.visibilityState === "hidden") {
                _this.renderingSuspended = true;
                if (_this.animateHandle !== undefined)
                    cancelAnimationFrame(_this.animateHandle);
            }
            else if (_this.renderingSuspended) {
                _this.renderingSuspended = false;
                _this.nextRenderTime = 0;
                _this.animate();
            }
        });
        this.renderer = new external_three_.WebGLRenderer({
            canvas: this.canvas,
            logarithmicDepthBuffer: true,
            antialias: true,
            //precision: "lowp", // is this making everything purple on mobile?
        });
        var webglCanvas = this.renderer.domElement;
        (_a = webglCanvas.addEventListener) === null || _a === void 0 ? void 0 : _a.call(webglCanvas, "webglcontextlost", function (event) {
            event.preventDefault();
            console.error("[osrs-sdk] WebGL context lost while rendering the 3D viewport", {
                visibility: typeof document !== "undefined" ? document.visibilityState : "unknown",
            });
        });
        (_b = webglCanvas.addEventListener) === null || _b === void 0 ? void 0 : _b.call(webglCanvas, "webglcontextrestored", function () {
            console.warn("[osrs-sdk] WebGL context restored; Three.js resources may need rebuilding");
            _this.nextRenderTime = 0;
        });
        // Set up camera positioning
        this.camera.position.set(0, 0, 0);
        this.pivot.position.set(0, 0, 0);
        // Face south
        if (faceCameraSouth) {
            this.yaw.rotation.y = Math.PI;
        }
        // Pitch down slightly
        this.pitch.rotation.x = -0.7;
        this.camera.position.z = cameraOrbitDistance(this.pitch.rotation.x);
        this.scene.add(this.pivot);
        this.pivot.add(this.yaw);
        this.yaw.add(this.pitch);
        this.pitch.add(this.camera);
        this.selectedTileMesh = (0,RenderUtils/* createTileIndicator */.Ov)(1, "#FFFFFF", RenderUtils/* GroundOverlayRenderOrder */.oC.HOVERED_TILE);
        this.scene.add(this.selectedTileMesh);
        this.animate();
    }
    Viewport3d.prototype.checkGpu = function () {
        var _a, _b;
        // TODO: this can become a react element
        try {
            var canvas = document.createElement("canvas");
            var gl = canvas.getContext("webgl");
            var debugInfo = gl === null || gl === void 0 ? void 0 : gl.getExtension("WEBGL_debug_renderer_info");
            var gpuInfo = (_b = (_a = gl === null || gl === void 0 ? void 0 : gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "none";
            if (gpuInfo.includes("nvidia") ||
                gpuInfo.includes("gpu") ||
                gpuInfo.includes("geforce") ||
                gpuInfo.includes("amd") ||
                gpuInfo.includes("radeon")) {
                return;
            }
            if (gpuInfo === "none" || gpuInfo.includes("google") || gpuInfo.includes("apple") || gpuInfo.includes("intel")) {
                var warning = document.getElementById("gpu_warning");
                if (warning)
                    warning.innerHTML =
                        "<span style=\"color: #FF6666\">Software rendering detected. Framerate may be low. Turn on Hardware Acceleration in your browser if you have a GPU.<br />".concat(gpuInfo, "</span>");
            }
        }
        catch (err) {
            console.warn("error trying to detect gpu", err);
        }
    };
    // implementation from https://codepen.io/seanwasere/pen/BaMBoPd
    Viewport3d.prototype.onDocumentMouseMove = function (e) {
        this.clientCameraRotation.setPointerPosition(e.clientX, e.clientY);
    };
    Viewport3d.prototype.onDocumentMouseDown = function (e) {
        this.clientCameraRotation.setPointerPosition(e.clientX, e.clientY);
        if (e.button === 1)
            this.clientCameraRotation.setMiddleMouseDown(true);
    };
    Viewport3d.prototype.onDocumentMouseUp = function (e) {
        this.clientCameraRotation.setPointerPosition(e.clientX, e.clientY);
        if (e.button === 1)
            this.clientCameraRotation.setMiddleMouseDown(false);
    };
    Viewport3d.prototype.onWindowBlur = function () {
        this.clientCameraRotation.setMiddleMouseDown(false);
    };
    Viewport3d.prototype.onDocumentMouseWheel = function (e) {
        var v = this.camera.position.z + e.deltaY * ZOOM_MULT;
        if (v >= 2 && v <= 20) {
            this.camera.position.z = v;
            this.orbitZoomOffset = v - cameraOrbitDistance(this.pitch.rotation.x);
        }
        e.preventDefault();
        return false;
    };
    Viewport3d.prototype.onDocumentTouchStart = function (e) {
        if (e.touches.length >= 1) {
            this.touchStart = e.touches[0];
        }
        if (e.touches.length === 2) {
            this.touchStart2 = e.touches[1];
        }
    };
    Viewport3d.prototype.onDocumentTouchMove = function (e) {
        if (!this.touchStart) {
            return;
        }
        if (e.touches.length === 1) {
            // drag - rotate
            var deltaX = (e.touches[0].clientX - this.touchStart.clientX) * TOUCH_MULT;
            var deltaY = (e.touches[0].clientY - this.touchStart.clientY) * TOUCH_MULT;
            this.yaw.rotation.y -= deltaX * ROTATE_MULT;
            var v = this.pitch.rotation.x - deltaY * ROTATE_MULT;
            this.pitch.rotation.x = Math.max(this.minimumCameraPitch, Math.min(this.maximumCameraPitch, v));
            this.touchStart = e.touches[0];
        }
        else if (e.touches.length === 2 && this.touchStart2 !== null) {
            // pinch - zoom
            var oldDist = Pathing/* Pathing */.G.dist(this.touchStart.clientX, this.touchStart.clientY, this.touchStart2.clientX, this.touchStart2.clientY);
            var currentDist = Pathing/* Pathing */.G.dist(e.touches[0].clientX, e.touches[0].clientY, e.touches[1].clientX, e.touches[1].clientY);
            var delta = (oldDist - currentDist) * TOUCH_MULT;
            var v = this.camera.position.z + delta * ZOOM_MULT;
            if (v >= 2 && v <= 20) {
                this.camera.position.z = v;
                this.orbitZoomOffset = v - cameraOrbitDistance(this.pitch.rotation.x);
            }
            this.touchStart = e.touches[0];
            this.touchStart2 = e.touches[1];
        }
        e.preventDefault();
        return false;
    };
    Viewport3d.prototype.onDocumentTouchEnd = function (e) {
        this.touchStart = null;
        this.touchStart2 = null;
    };
    Viewport3d.prototype.onKeyDown = function (e) {
        var allowWasd = !Settings/* Settings */.w.isUsingWasdKeybind;
        if (!allowWasd && ["w", "a", "s", "d"].includes(e.key.toLowerCase())) {
            return;
        }
        // values are desired change per second
        switch (e.key) {
            case "ArrowLeft":
            case "a":
            case "A":
                this.yawDelta = -2;
                break;
            case "ArrowRight":
            case "d":
            case "D":
                this.yawDelta = 2;
                break;
            case "ArrowUp":
            case "w":
            case "W":
                this.pitchDelta = -1;
                break;
            case "ArrowDown":
            case "s":
            case "S":
                this.pitchDelta = 1;
                break;
        }
    };
    Viewport3d.prototype.onKeyUp = function (e) {
        var allowWasd = !Settings/* Settings */.w.isUsingWasdKeybind;
        if (!allowWasd && ["w", "a", "s", "d"].includes(e.key.toLowerCase())) {
            return;
        }
        switch (e.key) {
            case "ArrowLeft":
            case "ArrowRight":
            case "a":
            case "d":
            case "A":
            case "D":
                this.yawDelta = 0;
                break;
            case "ArrowUp":
            case "ArrowDown":
            case "w":
            case "s":
            case "W":
            case "S":
                this.pitchDelta = 0;
                break;
        }
    };
    Viewport3d.prototype.initCameraEvents = function (canvas) {
        var _this = this;
        canvas.addEventListener("mousemove", this.onDocumentMouseMove.bind(this), false);
        canvas.addEventListener("mouseleave", function () { _this.pickingPointer = null; }, false);
        canvas.addEventListener("mousedown", this.onDocumentMouseDown.bind(this), false);
        window.addEventListener("mouseup", this.onDocumentMouseUp.bind(this), false);
        window.addEventListener("blur", this.onWindowBlur.bind(this), false);
        canvas.addEventListener("wheel", this.onDocumentMouseWheel.bind(this), false);
        canvas.addEventListener("touchstart", this.onDocumentTouchStart.bind(this), false);
        canvas.addEventListener("touchmove", this.onDocumentTouchMove.bind(this), false);
        canvas.addEventListener("touchend", this.onDocumentTouchEnd.bind(this), false);
        window.addEventListener("keydown", this.onKeyDown.bind(this), false);
        window.addEventListener("keyup", this.onKeyUp.bind(this), false);
    };
    Viewport3d.prototype.resize = function (width, height) {
        if (width === this.canvasDimensions.width && height === this.canvasDimensions.height)
            return;
        this.canvas.width = width;
        this.canvas.height = height;
        this.uiCanvas.width = width;
        this.uiCanvas.height = height;
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(width, height, false);
        this.canvasDimensions = { width: width, height: height };
    };
    Viewport3d.prototype.render = function () {
        try {
            this.renderer.render(this.scene, this.camera);
        }
        catch (error) {
            if (!this.renderFailureLogged) {
                this.renderFailureLogged = true;
                console.error("[osrs-sdk] WebGL render failed", error);
            }
        }
    };
    Viewport3d.prototype.animate = function () {
        var _this = this;
        if (this.renderingSuspended)
            return;
        this.animateHandle = requestAnimationFrame(function () { return _this.animate(); });
        var now = window.performance.now();
        var frameInterval = Settings/* Settings */.w.renderFps > 0 ? 1000 / Settings/* Settings */.w.renderFps : 0;
        if (frameInterval === 0 || now >= this.nextRenderTime) {
            this.render();
            this.stats.update();
            this.lastRenderTime = now;
            this.nextRenderTime = frameInterval === 0 ? now : (this.nextRenderTime > 0 ? this.nextRenderTime + frameInterval : now + frameInterval);
            if (this.nextRenderTime < now - frameInterval * 2)
                this.nextRenderTime = now + frameInterval;
        }
    };
    Viewport3d.prototype.initialise = function (world, region) {
        return Viewport3d_awaiter(this, void 0, void 0, function () {
            var hemiLight, ambientLight, floorCanvas, floorContext, floorTexture, floorGeometry, floorMaterial, plane, collisionTileGeometry, collisionTileMaterial, chunkBoundaryVertices, x, y, floorY, chunkBoundaryGeometry, chunkBoundaryMaterial;
            return Viewport3d_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        document.body.appendChild(this.stats.dom);
                        hemiLight = new external_three_.HemisphereLight(0xffffff, 0x000000, 1.0);
                        hemiLight.position.set(0, 100, 0);
                        this.scene.add(hemiLight);
                        ambientLight = new external_three_.AmbientLight(0xffffff, 0.75);
                        this.scene.add(ambientLight);
                        floorCanvas = new OffscreenCanvas(region.width * SPRITE_SCALE, region.height * SPRITE_SCALE);
                        floorContext = floorCanvas.getContext("2d");
                        region.drawWorldBackground(floorContext, SPRITE_SCALE);
                        floorTexture = new external_three_.Texture(floorCanvas);
                        floorTexture.needsUpdate = true;
                        floorGeometry = new external_three_.PlaneGeometry(region.width, region.height, 1, 1);
                        floorMaterial = new external_three_.MeshStandardMaterial({
                            map: floorTexture,
                            transparent: true,
                            color: 0xffffff,
                            side: external_three_.FrontSide,
                        });
                        floorGeometry.rotateX(-Math.PI / 2);
                        floorGeometry.translate(region.width / 2, FLOOR_Y_POS, region.height / 2 - 1);
                        plane = new external_three_.Mesh(floorGeometry, floorMaterial);
                        plane.userData.clickable = true;
                        // used for right-click walk here
                        plane.userData.isFloor = true;
                        plane.visible = Trainer/* Trainer */.c.player.region.drawDefaultFloor();
                        this.scene.add(plane);
                        collisionTileGeometry = new external_three_.PlaneGeometry(0.9, 0.9);
                        collisionTileGeometry.rotateX(-Math.PI / 2);
                        collisionTileMaterial = new external_three_.MeshBasicMaterial({
                            color: 0xff0000,
                            depthTest: false,
                            depthWrite: false,
                            opacity: 0.25,
                            side: external_three_.DoubleSide,
                            transparent: true,
                        });
                        this.tileCollisionDebugMesh = new external_three_.InstancedMesh(collisionTileGeometry, collisionTileMaterial, region.width * region.height);
                        this.tileCollisionDebugMesh.count = 0;
                        this.tileCollisionDebugMesh.frustumCulled = false;
                        this.tileCollisionDebugMesh.renderOrder = RenderUtils/* GroundOverlayRenderOrder */.oC.HOVERED_TILE + 2;
                        this.scene.add(this.tileCollisionDebugMesh);
                        chunkBoundaryVertices = [];
                        for (x = 0; x <= region.width; x += Chunk/* CHUNK_SIZE */.O) {
                            chunkBoundaryVertices.push(x, RenderUtils/* GROUND_OVERLAY_Y */.t8, -1, x, RenderUtils/* GROUND_OVERLAY_Y */.t8, region.height - 1);
                        }
                        for (y = 0; y <= region.height; y += Chunk/* CHUNK_SIZE */.O) {
                            floorY = y - 1;
                            chunkBoundaryVertices.push(0, RenderUtils/* GROUND_OVERLAY_Y */.t8, floorY, region.width, RenderUtils/* GROUND_OVERLAY_Y */.t8, floorY);
                        }
                        chunkBoundaryGeometry = new external_three_.BufferGeometry();
                        chunkBoundaryGeometry.setAttribute("position", new external_three_.Float32BufferAttribute(chunkBoundaryVertices, 3));
                        chunkBoundaryMaterial = new external_three_.LineBasicMaterial({
                            color: 0x00ffff,
                            depthTest: false,
                            depthWrite: false,
                            opacity: 0.8,
                            transparent: true,
                        });
                        this.chunkDebugLines = new external_three_.LineSegments(chunkBoundaryGeometry, chunkBoundaryMaterial);
                        this.chunkDebugLines.renderOrder = RenderUtils/* GroundOverlayRenderOrder */.oC.HOVERED_TILE + 1;
                        this.chunkDebugLines.visible = Settings/* Settings */.w.chunkDebug;
                        this.scene.add(this.chunkDebugLines);
                        this.scene.add(this.selectedTileMesh);
                        // preload by adding a bunch of models to the scene but out of sight
                        return [4 /*yield*/, Trainer/* Trainer */.c.player.region.preload()];
                    case 1:
                        // preload by adding a bunch of models to the scene but out of sight
                        _a.sent();
                        return [4 /*yield*/, this.renderer.compileAsync(this.scene, this.camera)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Viewport3d.prototype.reset = function () {
        var _this = this;
        this.knownActors.forEach(function (actor) { return actor.destroy(_this.scene); });
        this.knownActors = new Map();
        this.projectedClickboxes.clear();
        this.pickingPointer = null;
        this.cameraFocalPoint.reset();
    };
    Viewport3d.prototype.draw = function (world, region) {
        this.draw3dScene(world, region);
        this.draw2dScene(world, region);
        return {
            canvas: this.canvas,
            uiCanvas: this.uiCanvas,
            flip: false,
            offsetX: 0,
            offsetY: 0,
        };
    };
    Viewport3d.prototype.updateCamera = function (delta) {
        this.yaw.rotation.y += this.yawDelta * delta;
        this.pitch.rotation.x = Math.max(Math.min(this.pitch.rotation.x + this.pitchDelta * delta, this.maximumCameraPitch), this.minimumCameraPitch);
        var angles = this.clientCameraRotation.frame({
            yaw: this.yaw.rotation.y,
            pitch: this.pitch.rotation.x,
        }, delta, Settings/* Settings */.w.relaxCameraPitch);
        this.yaw.rotation.y = angles.yaw;
        this.pitch.rotation.x = angles.pitch;
        this.camera.position.z = Math.max(2, Math.min(20, cameraOrbitDistance(this.pitch.rotation.x) + this.orbitZoomOffset));
    };
    Viewport3d.prototype.clientTick = function (region, timestamp) {
        if (timestamp === void 0) { timestamp = window.performance.now(); }
        this.reconcileActors(region);
        this.knownActors.forEach(function (actor) { return actor.clientTick(); });
        this.clientCameraRotation.clientTick();
        if (Trainer/* Trainer */.c.player) {
            this.cameraFocalPoint.follow(Trainer/* Trainer */.c.player.perceivedLocation, timestamp);
        }
    };
    Object.defineProperty(Viewport3d.prototype, "minimumCameraPitch", {
        get: function () {
            return Settings/* Settings */.w.relaxCameraPitch ? RELAXED_MIN_CAMERA_PITCH : MIN_CAMERA_PITCH;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Viewport3d.prototype, "maximumCameraPitch", {
        get: function () {
            return Settings/* Settings */.w.relaxCameraPitch ? RELAXED_MAX_CAMERA_PITCH : MAX_CAMERA_PITCH;
        },
        enumerable: false,
        configurable: true
    });
    Viewport3d.prototype.applyCameraFocalPosition = function (_a) {
        var x = _a.x, y = _a.y;
        this.pivot.position.set(x, 0, y);
    };
    Viewport3d.prototype.draw3dScene = function (world, region) {
        var _this = this;
        this.reconcileActors(region);
        var delta = this.clock.getDelta();
        if (Trainer/* Trainer */.c.player) {
            // Seed a newly constructed/reset viewport without flying in from the origin.
            var now = window.performance.now();
            this.cameraFocalPoint.initialise(Trainer/* Trainer */.c.player.perceivedLocation, now);
            this.applyCameraFocalPosition(this.cameraFocalPoint.getPerceivedPosition(now));
        }
        this.updateCamera(delta);
        // Projection helpers run before renderer.render(), so update the camera
        // matrices here instead of relying on Three.js to do it during rendering.
        this.camera.updateWorldMatrix(true, false);
        if (this.chunkDebugLines)
            this.chunkDebugLines.visible = Settings/* Settings */.w.chunkDebug;
        if (this.tileCollisionDebugMesh) {
            this.tileCollisionDebugMesh.visible = Settings/* Settings */.w.tileCollisionDebug;
            if (Settings/* Settings */.w.tileCollisionDebug) {
                var flaggedTiles = region.getTileCollisionFlagLocations();
                flaggedTiles.forEach(function (_a, index) {
                    var x = _a.x, y = _a.y;
                    _this.tileCollisionDebugMatrix.makeTranslation(x + 0.5, RenderUtils/* GROUND_OVERLAY_Y */.t8, y - 0.5);
                    _this.tileCollisionDebugMesh.setMatrixAt(index, _this.tileCollisionDebugMatrix);
                });
                this.tileCollisionDebugMesh.count = flaggedTiles.length;
                this.tileCollisionDebugMesh.instanceMatrix.needsUpdate = true;
            }
        }
        this.knownActors.forEach(function (actor) { var _a; return actor.draw(_this.scene, delta, world.tickPercent, (_a = world.clientTickPercent) !== null && _a !== void 0 ? _a : 0); });
        this.refreshProjectedClickboxes();
        // highlight selected tile
        if (this.selectedTile) {
            this.selectedTileMesh.position.x = this.selectedTile.x - 0.5;
            this.selectedTileMesh.position.y = RenderUtils/* GROUND_OVERLAY_Y */.t8;
            this.selectedTileMesh.position.z = this.selectedTile.y - 0.5;
            var hoveredTileColor = Settings/* Settings */.w.hoveredTileColor;
            this.selectedTileMesh.material.color.set(hoveredTileColor);
            this.selectedTileMesh.visible = Settings/* Settings */.w.hoveredTileEnabled;
        }
    };
    Viewport3d.prototype.refreshProjectedClickboxes = function () {
        var _this = this;
        // Bounds follow the rendered pose/camera. Only pointer candidates need
        // projected triangle vertices; debugging must not force that work.
        this.projectedClickboxes.clear();
        this.knownActors.forEach(function (actor, renderable) {
            var _a;
            if (!(renderable instanceof Mob/* Mob */.B) || !renderable.selectable)
                return;
            var model = actor.getModel();
            if (!(model === null || model === void 0 ? void 0 : model.getClickboxVertices))
                return;
            var bounds = (_a = model.getClickboxBounds) === null || _a === void 0 ? void 0 : _a.call(model);
            var depth = bounds ? boundsDepthRange(bounds, _this.camera.matrixWorldInverse) : null;
            if (depth && !isInFrontOfNearPlane(depth.min, _this.camera.near))
                return;
            // Project a broad rectangle only when all box corners are in front.
            // Fine triangle picking individually rejects near-clipped triangles.
            var screenBounds;
            if (bounds && depth && isInFrontOfNearPlane(depth.max, _this.camera.near)) {
                screenBounds = _this.projectBoundsToScreen(bounds);
            }
            else if (!model.getClickboxTriangles) {
                var vertices = model.getClickboxVertices();
                if (!vertices.length || !vertices.every(function (vertex) { return _this.isInFrontOfCameraNearPlane(vertex); }))
                    return;
            }
            _this.projectedClickboxes.set(renderable, {
                model: model,
                worldBounds: bounds !== null && bounds !== void 0 ? bounds : undefined, bounds: screenBounds,
                tolerance: renderable.size === 1 && model.getClickboxTriangles ? 0 : renderable.size === 1 ? 20 : 5,
            });
        });
        // A mouse event's projections were invalidated above. Refine candidates at
        // the current pointer so picking/debugging use this draw's animated pose,
        // including when the pointer stays still and an actor moves underneath it.
        if (this.pickingPointer)
            this.getProjectedMobsAt(this.pickingPointer);
    };
    Viewport3d.prototype.getProjectedMobsAt = function (point) {
        var _this = this;
        var mobs = [];
        var _a = this.canvasDimensions, width = _a.width, height = _a.height;
        this.raycaster.setFromCamera(new external_three_.Vector2(point.x / width * 2 - 1, 1 - point.y / height * 2), this.camera);
        this.projectedClickboxes.forEach(function (clickbox, mob) {
            var _a, _b;
            var bounds = clickbox.bounds, tolerance = clickbox.tolerance, worldBounds = clickbox.worldBounds, model = clickbox.model;
            if (bounds && !screenBoundsContain(bounds, point, tolerance + 1))
                return;
            if (model.getClickboxTriangles && worldBounds) {
                var boxHit = _this.raycaster.ray.intersectsBox(worldBounds);
                if (mob.size === 1) {
                    clickbox.refined = true;
                    if (!clickbox.hull && bounds)
                        clickbox.hull = convexHull(_this.projectBoxCorners(worldBounds));
                    if (boxHit)
                        mobs.push(mob);
                    return;
                }
                if (!boxHit)
                    return;
            }
            if (model.getClickboxTriangles) {
                if (!clickbox.vertices) {
                    clickbox.vertices = ((_b = (_a = model.getClickboxVertices) === null || _a === void 0 ? void 0 : _a.call(model)) !== null && _b !== void 0 ? _b : []).map(function (vertex) {
                        return _this.isInFrontOfCameraNearPlane(vertex) ? _this.projectToClientScreen(vertex) : null;
                    });
                    clickbox.triangles = model.getClickboxTriangles();
                }
                clickbox.refined = true;
                if (projectedTrianglesContain(clickbox.vertices, clickbox.triangles, point, 5))
                    mobs.push(mob);
            }
            else {
                // Custom renderers without triangle data retain their previous hull path.
                var hull = _this.getProjectedClickboxHull(mob);
                clickbox.refined = true;
                if (hull.length >= 3 && projectedHullContains(hull, point, tolerance))
                    mobs.push(mob);
            }
        });
        return mobs;
    };
    Viewport3d.prototype.getProjectedClickboxHull = function (mob) {
        var _this = this;
        var _a, _b, _c;
        var clickbox = this.projectedClickboxes.get(mob);
        if (!clickbox)
            return [];
        if (!clickbox.hull) {
            clickbox.hull = convexHull(((_c = (_b = (_a = clickbox.model).getClickboxVertices) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : [])
                .map(function (vertex) { return _this.projectToScreen(vertex); }));
            if (clickbox.hull.length < 3)
                this.projectedClickboxes.delete(mob);
        }
        return clickbox.hull;
    };
    Viewport3d.prototype.projectBoundsToScreen = function (bounds) {
        var result = { minX: Infinity, minY: Infinity, maxX: -Infinity, maxY: -Infinity };
        for (var _i = 0, _a = this.projectBoxCorners(bounds); _i < _a.length; _i++) {
            var point = _a[_i];
            result.minX = Math.min(result.minX, point.x);
            result.maxX = Math.max(result.maxX, point.x);
            result.minY = Math.min(result.minY, point.y);
            result.maxY = Math.max(result.maxY, point.y);
        }
        return result;
    };
    Viewport3d.prototype.projectBoxCorners = function (bounds) {
        var points = [];
        var corner = new external_three_.Vector3();
        for (var i = 0; i < 8; i++) {
            corner.set(i & 1 ? bounds.max.x : bounds.min.x, i & 2 ? bounds.max.y : bounds.min.y, i & 4 ? bounds.max.z : bounds.min.z);
            points.push(this.projectToScreen(corner));
        }
        return points;
    };
    Viewport3d.prototype.reconcileActors = function (region) {
        var _this = this;
        var activeRenderables = new Set(region.getRenderables());
        this.knownActors.forEach(function (actor, renderable) {
            if (!activeRenderables.has(renderable) || actor.shouldRemove()) {
                actor.destroy(_this.scene);
                _this.knownActors.delete(renderable);
            }
        });
        activeRenderables.forEach(function (renderable) {
            if (!renderable.shouldDestroy() && !_this.knownActors.has(renderable)) {
                _this.knownActors.set(renderable, new Actor(renderable));
            }
        });
    };
    Viewport3d.prototype.draw2dScene = function (world, region) {
        var _this = this;
        // draw UI elements into a separate canvas that gets drawn over the 3d canvas
        this.uiCanvasContext.clearRect(0, 0, this.uiCanvas.width, this.uiCanvas.height);
        var translator = function (pos, z) {
            if (z === void 0) { z = 0; }
            return _this.projectToScreen(new external_three_.Vector3(pos.x, z, pos.y));
        };
        var getUILayerProjector = function (r) {
            var _a, _b, _c, _d, _e;
            var perceivedLocation = r.getPerceivedLocation(world.tickPercent);
            var model = (_a = _this.knownActors.get(r)) === null || _a === void 0 ? void 0 : _a.getModel();
            var modelLogicalHeight = (_b = model === null || model === void 0 ? void 0 : model.getLogicalHeight) === null || _b === void 0 ? void 0 : _b.call(model);
            var logicalHeight = modelLogicalHeight !== null && modelLogicalHeight !== void 0 ? modelLogicalHeight : r.logicalHeight;
            var center = {
                x: perceivedLocation.x + r.size / 2,
                y: perceivedLocation.y - r.size / 2,
            };
            var bounds = (_c = model === null || model === void 0 ? void 0 : model.getClickboxBounds) === null || _c === void 0 ? void 0 : _c.call(model);
            var depth = bounds ? boundsDepthRange(bounds, _this.camera.matrixWorldInverse) : null;
            // Most actors are wholly in front of the near plane. Use their cached
            // bounds instead of transforming every model vertex again for UI.
            var boundsVisible = depth && isInFrontOfNearPlane(depth.max, _this.camera.near);
            var boundsHidden = depth && !isInFrontOfNearPlane(depth.min, _this.camera.near);
            var modelVertices = boundsVisible || boundsHidden ? [] : (_e = (_d = model === null || model === void 0 ? void 0 : model.getClickboxVertices) === null || _d === void 0 ? void 0 : _d.call(model)) !== null && _e !== void 0 ? _e : [];
            var visibilityPoints = modelVertices.length > 0
                ? modelVertices
                : [
                    new external_three_.Vector3(center.x, perceivedLocation.z, center.y),
                    new external_three_.Vector3(center.x, perceivedLocation.z + logicalHeight, center.y),
                ];
            return {
                logicalHeight: logicalHeight,
                visible: boundsVisible ? true : boundsHidden ? false
                    : visibilityPoints.every(function (point) { return _this.isInFrontOfCameraNearPlane(point); }),
                atHeight: function (height) { return translator(center, perceivedLocation.z + height); },
            };
        };
        var units = Viewport3d_spreadArray(Viewport3d_spreadArray([], region.players, true), (world.getReadyTimer <= 0 ? region.mobs : []), true);
        var renderables = units.concat(region.entities);
        renderables.forEach(function (r) {
            r.drawUILayer(world.tickPercent, getUILayerProjector(r), _this.uiCanvasContext, SPRITE_SCALE);
        });
        if (Settings/* Settings */.w.displayClickboxes) {
            this.projectedClickboxes.forEach(function (_a) {
                var hull = _a.hull, bounds = _a.bounds, tolerance = _a.tolerance, refined = _a.refined, vertices = _a.vertices, triangles = _a.triangles;
                if (!refined && !bounds)
                    return;
                if (refined && !vertices && !hull && !bounds)
                    return;
                _this.uiCanvasContext.save();
                _this.uiCanvasContext.beginPath();
                if (refined && vertices && triangles) {
                    // Display the union of the actual padded face rectangles. These
                    // projections already exist from picking; never project for debug.
                    for (var i = 0; i < triangles.length; i += 3) {
                        var a = vertices[triangles[i]], b = vertices[triangles[i + 1]], c = vertices[triangles[i + 2]];
                        if (!a || !b || !c)
                            continue;
                        var face = projectedTriangleBounds(a, b, c);
                        _this.uiCanvasContext.rect(face.minX - 5, face.minY - 5, face.maxX - face.minX + 10, face.maxY - face.minY + 10);
                    }
                }
                else if (refined && hull && hull.length >= 3) {
                    _this.uiCanvasContext.moveTo(hull[0].x, hull[0].y);
                    hull.slice(1).forEach(function (point) { return _this.uiCanvasContext.lineTo(point.x, point.y); });
                }
                else {
                    // Amber is the conservative pointer-rejection rectangle.
                    _this.uiCanvasContext.rect(bounds.minX, bounds.minY, bounds.maxX - bounds.minX, bounds.maxY - bounds.minY);
                }
                _this.uiCanvasContext.closePath();
                _this.uiCanvasContext.fillStyle = refined ? "rgba(0, 255, 255, 0.12)" : "rgba(255, 180, 0, 0.08)";
                _this.uiCanvasContext.fill();
                // Triangle padding is already included in each rectangle above.
                _this.uiCanvasContext.lineJoin = "round";
                _this.uiCanvasContext.lineWidth = Math.max(1, vertices ? 1 : tolerance * 2);
                _this.uiCanvasContext.strokeStyle = refined ? "rgba(0, 255, 255, 0.25)" : "rgba(255, 180, 0, 0.20)";
                _this.uiCanvasContext.stroke();
                _this.uiCanvasContext.lineWidth = 1;
                _this.uiCanvasContext.strokeStyle = refined ? "#00ffff" : "#ffb400";
                _this.uiCanvasContext.stroke();
                _this.uiCanvasContext.restore();
            });
        }
    };
    // return canvas coordinates from world coordinates
    Viewport3d.prototype.isInFrontOfCameraNearPlane = function (vector) {
        var cameraSpaceZ = vector.clone().applyMatrix4(this.camera.matrixWorldInverse).z;
        return isInFrontOfNearPlane(cameraSpaceZ, this.camera.near);
    };
    Viewport3d.prototype.projectToScreen = function (vector) {
        var newVector = vector.clone();
        newVector.project(this.camera);
        var _a = this.canvasDimensions, width = _a.width, height = _a.height;
        return {
            x: Math.round((newVector.x + 1) * (width / 2)),
            y: Math.round((-newVector.y + 1) * (height / 2)),
        };
    };
    Viewport3d.prototype.projectToClientScreen = function (vector) {
        var projected = vector.clone().project(this.camera);
        var _a = this.canvasDimensions, width = _a.width, height = _a.height;
        // The client adds an integer viewport centre to an integer-divided offset.
        // Truncate the offset toward zero, rather than rounding the final pixel.
        return { x: Math.floor(width / 2) + Math.trunc(projected.x * width / 2),
            y: Math.floor(height / 2) + Math.trunc(-projected.y * height / 2) };
    };
    // return intersection with world object or world coordinates from canvas coordinates
    Viewport3d.prototype.translateClick = function (offsetX, offsetY, world, viewport) {
        var _this = this;
        var _a = this.canvasDimensions, width = _a.width, height = _a.height;
        var rayX = (offsetX / width) * 2 - 1;
        var rayY = -(offsetY / height) * 2 + 1;
        this.raycaster.setFromCamera(new external_three_.Vector2(rayX, rayY), this.camera);
        // check intersection of the ray and the flor plane
        var floorPlane = new external_three_.Plane(new external_three_.Vector3(0, -1, 0), FLOOR_Y_POS);
        var floor = new external_three_.Vector3(0, 0, 0);
        this.raycaster.ray.intersectPlane(floorPlane, floor);
        this.selectedTile = {
            x: Math.floor(floor.x) + 0.5,
            y: Math.floor(floor.z) + 1.5,
        };
        var point = { x: offsetX, y: offsetY };
        this.pickingPointer = point;
        var projectedMobs = this.getProjectedMobsAt(point);
        var intersections = this.raycaster.intersectObjects(this.scene.children.filter(function (child) {
            return child.userData.clickable === true && !_this.projectedClickboxes.has(child.userData.unit);
        }), true);
        // Non-cache models retain the existing Three.js raycast fallback.
        var raycastMobs = intersections
            .filter(function (i) { return i.object.userData.unit instanceof Mob/* Mob */.B; })
            .map(function (i) { return i.object.userData.unit; });
        var mobs = lodash_default().uniq(projectedMobs.concat(raycastMobs));
        // Note: we currently only handle clicking on mobs
        if (mobs.length > 0) {
            return {
                type: "entities",
                mobs: mobs,
                players: [],
                groundItems: [],
                location: {
                    x: this.selectedTile.x,
                    y: this.selectedTile.y,
                },
            };
        }
        return {
            type: "coordinate",
            location: {
                x: this.selectedTile.x,
                y: this.selectedTile.y,
            },
        };
    };
    Viewport3d.prototype.setMapRotation = function (direction) {
        if (direction === CardinalDirection.SOUTH) {
            this.yaw.rotation.y = Math.PI;
        }
        else if (direction === CardinalDirection.NORTH) {
            this.yaw.rotation.y = 0;
        }
        else if (direction === CardinalDirection.EAST) {
            this.yaw.rotation.y = -Math.PI / 2;
        }
        else if (direction === CardinalDirection.WEST) {
            this.yaw.rotation.y = Math.PI / 2;
        }
    };
    Viewport3d.prototype.getMapRotation = function () {
        return this.yaw.rotation.y;
    };
    return Viewport3d;
}());


;// CONCATENATED MODULE: ./src/sdk/Viewport2d.ts

var Viewport2d_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Viewport2d_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Viewport2d_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};







var Viewport2d = /** @class */ (function () {
    function Viewport2d() {
        this.selectedTile = null;
    }
    Viewport2d.prototype.initialise = function (world, region) {
        return Viewport2d_awaiter(this, void 0, void 0, function () {
            return Viewport2d_generator(this, function (_a) {
                // do nothing, but maybe we should buffer the world background
                return [2 /*return*/];
            });
        });
    };
    Viewport2d.prototype.reset = function () {
        // do nothing
    };
    Viewport2d.prototype.draw = function (world, region) {
        region.context.save();
        region.drawWorldBackground(region.context, Settings/* Settings */.w.tileSize);
        region.drawGroundItems(region.context);
        if (Settings/* Settings */.w.chunkDebug) {
            region.context.save();
            region.context.beginPath();
            for (var x = 0; x <= region.width; x += Chunk/* CHUNK_SIZE */.O) {
                region.context.moveTo(x * Settings/* Settings */.w.tileSize, 0);
                region.context.lineTo(x * Settings/* Settings */.w.tileSize, region.height * Settings/* Settings */.w.tileSize);
            }
            for (var y = 0; y <= region.height; y += Chunk/* CHUNK_SIZE */.O) {
                region.context.moveTo(0, y * Settings/* Settings */.w.tileSize);
                region.context.lineTo(region.width * Settings/* Settings */.w.tileSize, y * Settings/* Settings */.w.tileSize);
            }
            region.context.lineWidth = 2;
            region.context.strokeStyle = "rgba(0, 255, 255, 0.8)";
            region.context.stroke();
            region.context.restore();
        }
        if (Settings/* Settings */.w.tileCollisionDebug) {
            region.context.save();
            region.context.fillStyle = "rgba(255, 0, 0, 0.25)";
            region.getTileCollisionFlagLocations().forEach(function (_a) {
                var x = _a.x, y = _a.y;
                region.context.fillRect(x * Settings/* Settings */.w.tileSize, y * Settings/* Settings */.w.tileSize, Settings/* Settings */.w.tileSize, Settings/* Settings */.w.tileSize);
            });
            region.context.restore();
        }
        // Draw all things on the map
        var renderables = Viewport2d_spreadArray(Viewport2d_spreadArray([], region.entities, true), region.projectileGraphics, true);
        var units = [];
        if (world.getReadyTimer <= 0) {
            units.push.apply(units, region.mobs);
            units.push.apply(units, region.newMobs);
        }
        units.push.apply(units, region.players);
        renderables.concat(units).forEach(function (r) {
            var location = r.getPerceivedLocation(world.tickPercent);
            r.draw(world.tickPercent, region.context, location, Settings/* Settings */.w.tileSize);
        });
        var getOffset = function (r) {
            var perceivedLocation = r.getPerceivedLocation(world.tickPercent);
            var perceivedX = perceivedLocation.x;
            var perceivedY = perceivedLocation.y;
            return {
                x: perceivedX * Settings/* Settings */.w.tileSize + (r.size * Settings/* Settings */.w.tileSize) / 2,
                y: (perceivedY - r.size + 1) * Settings/* Settings */.w.tileSize + (r.size * Settings/* Settings */.w.tileSize) / 2,
            };
        };
        // The legacy top-down viewport has no elevation projection. Keep its UI
        // anchored to the top of the renderable's footprint for compatibility.
        var getUILayerProjector = function (r) {
            var offset = getOffset(r);
            var screenPosition = {
                x: offset.x,
                y: offset.y - (r.size * Settings/* Settings */.w.tileSize) / 2,
            };
            return {
                logicalHeight: r.logicalHeight,
                visible: true,
                atHeight: function () { return screenPosition; },
            };
        };
        region.entities.forEach(function (entity) {
            return entity.drawUILayer(world.tickPercent, getUILayerProjector(entity), entity.region.context, Settings/* Settings */.w.tileSize);
        });
        if (world.getReadyTimer <= 0) {
            region.mobs.forEach(function (mob) {
                return mob.drawUILayer(world.tickPercent, getUILayerProjector(mob), mob.region.context, Settings/* Settings */.w.tileSize);
            });
            region.players.forEach(function (player) {
                player.drawUILayer(world.tickPercent, getUILayerProjector(player), player.region.context, Settings/* Settings */.w.tileSize);
            });
        }
        if (this.selectedTile && Settings/* Settings */.w.hoveredTileEnabled) {
            region.context.save();
            region.context.globalAlpha *= 0.5;
            region.context.lineWidth = 2;
            region.context.strokeStyle = Settings/* Settings */.w.hoveredTileColor;
            region.context.strokeRect(Math.floor(this.selectedTile.x) * Settings/* Settings */.w.tileSize, Math.floor(this.selectedTile.y) * Settings/* Settings */.w.tileSize, Settings/* Settings */.w.tileSize, Settings/* Settings */.w.tileSize);
            region.context.restore();
        }
        region.context.restore();
        var _a = Viewport.viewport.getViewport(world.tickPercent), viewportX = _a.viewportX, viewportY = _a.viewportY;
        return {
            canvas: region.canvas,
            uiCanvas: null,
            flip: Settings/* Settings */.w.rotated === "south",
            offsetX: -viewportX * Settings/* Settings */.w.tileSize,
            offsetY: -viewportY * Settings/* Settings */.w.tileSize,
        };
    };
    Viewport2d.prototype.translateClick = function (offsetX, offsetY, world, viewport) {
        var _a = viewport.getViewport(world.tickPercent), viewportX = _a.viewportX, viewportY = _a.viewportY;
        var x = offsetX + viewportX * Settings/* Settings */.w.tileSize;
        var y = offsetY + viewportY * Settings/* Settings */.w.tileSize;
        if (Settings/* Settings */.w.rotated === "south") {
            x = viewport.width * Settings/* Settings */.w.tileSize - offsetX + viewportX * Settings/* Settings */.w.tileSize;
            y = viewport.height * Settings/* Settings */.w.tileSize - offsetY + viewportY * Settings/* Settings */.w.tileSize;
        }
        var adjustedX = x / Settings/* Settings */.w.tileSize;
        var adjustedY = y / Settings/* Settings */.w.tileSize;
        this.selectedTile = { x: Math.floor(adjustedX), y: Math.floor(adjustedY) };
        var mobs = [];
        var players = [];
        var groundItems = [];
        var region = Trainer/* Trainer */.c.player.region;
        mobs.push.apply(mobs, Collision/* Collision */.F.collidesWithAnyMobsAtPerceivedDisplayLocation(region, adjustedX, adjustedY, world.tickPercent));
        players.push.apply(players, Collision/* Collision */.F.collidesWithAnyPlayersAtPerceivedDisplayLocation(region, adjustedX, adjustedY, world.tickPercent).filter(function (player) { return player !== Trainer/* Trainer */.c.player; }));
        groundItems.push.apply(groundItems, region.groundItemsAtLocation(Math.floor(adjustedX), Math.floor(adjustedY)));
        if (mobs.length > 0 || players.length > 0 || groundItems.length > 0) {
            return {
                type: "entities",
                mobs: lodash_default().uniq(mobs),
                players: players,
                groundItems: groundItems,
                location: {
                    x: adjustedX,
                    y: adjustedY,
                },
            };
        }
        return {
            type: "coordinate",
            location: {
                x: adjustedX,
                y: adjustedY,
            },
        };
    };
    Viewport2d.prototype.setMapRotation = function (direction) {
        if (direction === CardinalDirection.SOUTH) {
            Settings/* Settings */.w.rotated = "south";
        }
        else if (direction === CardinalDirection.NORTH) {
            Settings/* Settings */.w.rotated = "north";
        }
    };
    Viewport2d.prototype.getMapRotation = function () {
        return Settings/* Settings */.w.rotated === "south" ? Math.PI : 0;
    };
    return Viewport2d;
}());


;// CONCATENATED MODULE: ./src/sdk/Viewport.ts

var Viewport_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Viewport_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};













var BOSS_BAR_WIDTH = 300;
var BOSS_BAR_HEIGHT = 50;
var BOSS_BAR_TOP = 36;
var BOSS_BAR_HORIZONTAL_OFFSET = -60;
var BOSS_BAR_INNER_PADDING = 2;
var Viewport = /** @class */ (function () {
    function Viewport(delegate, canvas, resizeTarget) {
        var _this = this;
        this.delegate = delegate;
        this.canvas = canvas;
        this.resizeTarget = resizeTarget;
        this.activeButtonImage = ImageLoader/* ImageLoader */.$.createImage(button_active_namespaceObject);
        this.contextMenu = new ContextMenu();
        this.resizeObserver = null;
        this.components = [];
        /** Recalculate viewport and backing-canvas dimensions from the playable area. */
        this.containerSize = null;
        if (typeof ResizeObserver === "undefined") {
            throw new Error("ResizeObserver is required to mount a viewport");
        }
        this.resizeObserver = new ResizeObserver(function (_a) {
            var entry = _a[0];
            _this.resize(entry.contentRect.width, entry.contentRect.height);
        });
        this.resizeObserver.observe(this.resizeTarget);
    }
    Viewport.setupViewport = function (region, canvas, resizeTarget, force2d) {
        if (force2d === void 0) { force2d = false; }
        var faceInitialSouth = region.initialFacing === CardinalDirection.SOUTH;
        // called after Settings have been initialized
        Viewport.viewport = new Viewport(Settings/* Settings */.w.use3dView && !force2d ? new Viewport3d(faceInitialSouth, canvas) : new Viewport2d(), canvas, resizeTarget);
    };
    /**
     * Return all objects or world coordinates at the given position (relative to the top-left of the viewport).
     */
    Viewport.prototype.translateClick = function (offsetX, offsetY, world) {
        if (FixedLayout.enabled) {
            // Only the 512x334 scene area is the game world in fixed mode.
            var rect = FixedLayout.viewportRect(this.canvas.width);
            offsetX -= rect.x;
            offsetY -= rect.y;
            if (offsetX < 0 || offsetY < 0 || offsetX >= rect.width || offsetY >= rect.height)
                return null;
        }
        return this.delegate.translateClick(offsetX, offsetY, world, this);
    };
    Object.defineProperty(Viewport.prototype, "context", {
        get: function () {
            return this.canvas.getContext("2d");
        },
        enumerable: false,
        configurable: true
    });
    Viewport.prototype.setPlayer = function (player) {
        Trainer/* Trainer */.c.setPlayer(player);
        if (!this.clickController) {
            this.clickController = new ClickController(this);
            this.clickController.registerClickActions();
        }
        Trainer/* Trainer */.c.setClickController(this.clickController);
    };
    /** Re-run layout for the last known container size, e.g. after toggling fixed mode. */
    Viewport.prototype.refreshLayout = function () {
        if (this.containerSize)
            this.resize(this.containerSize.width, this.containerSize.height);
    };
    Viewport.prototype.resize = function (width, height) {
        var _a, _b, _c, _d, _e;
        width = Math.max(1, Math.round(width));
        height = Math.max(1, Math.round(height));
        this.containerSize = { width: width, height: height };
        if (!((_a = Trainer/* Trainer */.c.player) === null || _a === void 0 ? void 0 : _a.region))
            return;
        if (FixedLayout.enabled) {
            var fitted = FixedLayout.fit(width, height);
            // Letterbox the canvas, centred in the playable area.
            this.canvas.style.width = "".concat(fitted.width, "px");
            this.canvas.style.height = "".concat(fitted.height, "px");
            this.canvas.style.left = "".concat(Math.floor((width - fitted.width) / 2), "px");
            this.canvas.style.top = "".concat(Math.floor((height - fitted.height) / 2), "px");
            if (fitted.width !== this.canvas.width || fitted.height !== this.canvas.height) {
                this.canvas.width = fitted.width;
                this.canvas.height = fitted.height;
            }
            var rect = FixedLayout.viewportRect(fitted.width);
            Settings/* Settings */.w._tileSize = rect.width / Trainer/* Trainer */.c.player.region.width;
            this.width = rect.width / Settings/* Settings */.w.tileSize;
            this.height = rect.height / Settings/* Settings */.w.tileSize;
            (_c = (_b = this.delegate).resize) === null || _c === void 0 ? void 0 : _c.call(_b, rect.width, rect.height);
            return;
        }
        this.canvas.style.width = "100%";
        this.canvas.style.height = "100%";
        this.canvas.style.left = "0px";
        this.canvas.style.top = "0px";
        Settings/* Settings */.w._tileSize = width / Trainer/* Trainer */.c.player.region.width;
        this.width = width / Settings/* Settings */.w.tileSize;
        this.height = height / Settings/* Settings */.w.tileSize;
        if (width !== this.canvas.width || height !== this.canvas.height) {
            this.canvas.width = width;
            this.canvas.height = height;
        }
        (_e = (_d = this.delegate).resize) === null || _e === void 0 ? void 0 : _e.call(_d, width, height);
    };
    // called after all graphics have loaded
    Viewport.prototype.initialise = function () {
        return Viewport_awaiter(this, void 0, void 0, function () {
            return Viewport_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegate.initialise(Trainer/* Trainer */.c.player.region.world, Trainer/* Trainer */.c.player.region)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Viewport.prototype.reset = function (region) {
        this.delegate.reset();
        this.delegate.setMapRotation(region.initialFacing);
        this.components = [];
    };
    Viewport.prototype.dispose = function () {
        var _a;
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        this.resizeObserver = null;
    };
    Viewport.prototype.getViewport = function (tickPercent) {
        if (Trainer/* Trainer */.c.player.dying > -1) {
            tickPercent = 0;
        }
        var _a = Trainer/* Trainer */.c.player.getPerceivedLocation(tickPercent), x = _a.x, y = _a.y;
        var viewportX = x + 0.5 - this.width / 2;
        var viewportY = y + 0.5 - this.height / 2;
        return { viewportX: viewportX, viewportY: viewportY };
    };
    Viewport.prototype.drawText = function (text, x, y) {
        x = Math.floor(x);
        y = Math.floor(y);
        this.context.fillStyle = "#000";
        this.context.fillText(text, x - 2, y - 2);
        this.context.fillText(text, x + 2, y - 2);
        this.context.fillText(text, x, y);
        this.context.fillText(text, x, y - 4);
        this.context.fillStyle = "#FFFFFF";
        this.context.fillText(text, x, y - 2);
    };
    Viewport.prototype.tick = function () {
        if (MapController.controller && Trainer/* Trainer */.c.player) {
            MapController.controller.updateOrbsMask(Trainer/* Trainer */.c.player.currentStats, Trainer/* Trainer */.c.player.stats);
        }
    };
    Viewport.prototype.clientTick = function (timestamp) {
        var _a, _b;
        if (Trainer/* Trainer */.c.player) {
            (_b = (_a = this.delegate).clientTick) === null || _b === void 0 ? void 0 : _b.call(_a, Trainer/* Trainer */.c.player.region, timestamp);
        }
    };
    Viewport.prototype.getMapRotation = function () {
        return this.delegate.getMapRotation();
    };
    Viewport.prototype.rotateSouth = function () {
        this.delegate.setMapRotation(CardinalDirection.SOUTH);
    };
    Viewport.prototype.rotateNorth = function () {
        this.delegate.setMapRotation(CardinalDirection.NORTH);
    };
    Viewport.prototype.rotateEast = function () {
        this.delegate.setMapRotation(CardinalDirection.EAST);
    };
    Viewport.prototype.rotateWest = function () {
        this.delegate.setMapRotation(CardinalDirection.WEST);
    };
    Viewport.prototype.getDelegate = function () {
        return this.delegate;
    };
    Viewport.prototype.draw = function (world) {
        var _this = this;
        this.context.globalAlpha = 1;
        this.context.fillStyle = "#3B3224";
        this.context.restore();
        this.context.save();
        this.context.fillStyle = "black";
        var _a = this.canvas, width = _a.width, height = _a.height;
        this.context.fillRect(0, 0, width, height);
        var drawn = this.delegate.draw(world, Trainer/* Trainer */.c.player.region);
        var canvas = drawn.canvas, uiCanvas = drawn.uiCanvas, flip = drawn.flip;
        var offsetX = drawn.offsetX, offsetY = drawn.offsetY;
        if (FixedLayout.enabled) {
            FixedLayout.drawFrame(this.context, width, height);
            var rect = FixedLayout.viewportRect(width);
            this.context.beginPath();
            this.context.rect(rect.x, rect.y, rect.width, rect.height);
            this.context.clip();
            offsetX += rect.x;
            offsetY += rect.y;
        }
        if (flip) {
            this.context.rotate(Math.PI);
            this.context.translate(-width, -height);
        }
        this.context.drawImage(canvas, offsetX, offsetY);
        if (uiCanvas) {
            this.context.drawImage(uiCanvas, offsetX, offsetY);
        }
        this.context.restore();
        this.context.save();
        this.drawBossHealthBar(Trainer/* Trainer */.c.player.region, width);
        if (FixedLayout.enabled) {
            // Bottom-right of the chatbox, where RuneLite stacks infoboxes in fixed mode.
            FixedLayout.drawInfoboxes(this.context, FixedLayout.scale(width), 450, 426);
        }
        else {
            FixedLayout.drawInfoboxes(this.context, Settings/* Settings */.w.maxUiScale, width / Settings/* Settings */.w.maxUiScale - 250, height / Settings/* Settings */.w.maxUiScale - 40);
        }
        // draw control panel
        ControlPanelController.controller.draw(this.context);
        XpDropController/* XpDropController */.O.controller.draw(this.context, width - 140 - MapController.controller.width, 0, world.tickPercent);
        MapController.controller.draw(this.context);
        this.clickController.drawHoverTooltip(this.context);
        this.contextMenu.draw(this.context);
        this.components.forEach(function (component) { return component.draw(_this.context, Settings/* Settings */.w.maxUiScale, 0, 0); });
        if (this.clickController.clickAnimation) {
            this.clickController.clickAnimation.draw(this.context, world.fps);
        }
        this.context.restore();
        this.context.save();
        this.context.textAlign = "left";
        if (world.getReadyTimer > 0) {
            this.context.font = "72px OSRS";
            this.context.textAlign = "center";
            this.drawText("GET READY...".concat(world.getReadyTimer), width / 2, height / 2 - 50);
        }
        this.context.restore();
    };
    Viewport.prototype.drawBossHealthBar = function (region, viewportWidth) {
        var boss = region.primaryBoss;
        if (!boss || !Settings/* Settings */.w.displayBossHealthBar)
            return;
        var width = Math.min(BOSS_BAR_WIDTH, viewportWidth - 16);
        var centeredX = (viewportWidth - width) / 2 + BOSS_BAR_HORIZONTAL_OFFSET;
        var x = Math.round(Math.max(8, Math.min(centeredX, viewportWidth - width - 8)));
        var y = BOSS_BAR_TOP;
        var current = Math.max(0, boss.currentStats.hitpoint);
        var maximum = Math.max(1, boss.stats.hitpoint);
        var healthRatio = Math.min(1, current / maximum);
        this.context.save();
        this.context.fillStyle = "#090806";
        this.context.fillRect(x, y, width, BOSS_BAR_HEIGHT);
        this.context.fillStyle = "#211e18";
        this.context.fillRect(x + 4, y + 4, width - 8, BOSS_BAR_HEIGHT - 8);
        this.context.font = "18px Stats_11";
        this.context.textAlign = "center";
        this.context.fillStyle = "black";
        this.context.fillText(boss.mobName(), x + width / 2 + 1, y + 18 + 1);
        this.context.fillStyle = "#d87532";
        this.context.fillText(boss.mobName(), x + width / 2, y + 18);
        var barX = x + BOSS_BAR_INNER_PADDING;
        var barY = y + 24;
        var barWidth = width - BOSS_BAR_INNER_PADDING * 2;
        var barHeight = 24;
        this.context.fillStyle = "#050403";
        this.context.fillRect(barX, barY, barWidth, barHeight);
        this.context.fillStyle = "#e00000";
        this.context.fillRect(barX + BOSS_BAR_INNER_PADDING, barY + BOSS_BAR_INNER_PADDING, barWidth - BOSS_BAR_INNER_PADDING * 2, barHeight - BOSS_BAR_INNER_PADDING * 2);
        this.context.fillStyle = "#00d900";
        this.context.fillRect(barX + BOSS_BAR_INNER_PADDING, barY + BOSS_BAR_INNER_PADDING, Math.round((barWidth - BOSS_BAR_INNER_PADDING * 2) * healthRatio), barHeight - BOSS_BAR_INNER_PADDING * 2);
        var textX = x + width / 2;
        var textY = barY + 17;
        this.context.fillStyle = "black";
        this.context.fillText("".concat(current, " / ").concat(maximum, " (").concat((healthRatio * 100).toFixed(1), "%)"), textX + 1, textY + 1);
        this.context.fillStyle = "white";
        this.context.fillText("".concat(current, " / ").concat(maximum, " (").concat((healthRatio * 100).toFixed(1), "%)"), textX, textY);
        this.context.restore();
    };
    return Viewport;
}());


;// CONCATENATED MODULE: ./src/sdk/ClickController.ts
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};













var ClickController = /** @class */ (function () {
    function ClickController(viewport) {
        this.clickAnimation = null;
        this.eventListeners = [];
        this.pendingMouseMove = null;
        this.mouseMoveFrame = null;
        this.recentlySelectedMobs = [];
        this.hoverTooltip = null;
        this.viewport = viewport;
    }
    ClickController.prototype.unload = function () {
        this.viewport.canvas.removeEventListener("mousedown", this.eventListeners[0]);
        this.viewport.canvas.removeEventListener("mouseup", this.eventListeners[1]);
        this.viewport.canvas.removeEventListener("mousemove", this.eventListeners[2]);
        if (this.mouseMoveFrame !== null)
            cancelAnimationFrame(this.mouseMoveFrame);
        this.mouseMoveFrame = null;
        this.pendingMouseMove = null;
        this.viewport.canvas.removeEventListener("wheel", this.eventListeners[6]);
    };
    ClickController.prototype.registerClickActions = function () {
        this.viewport.canvas.addEventListener("mousedown", (this.eventListeners[0] = this.clickDown.bind(this)));
        this.viewport.canvas.addEventListener("mouseup", (this.eventListeners[1] = this.leftClickUp.bind(this)));
        this.viewport.canvas.addEventListener("mousemove", (this.eventListeners[2] = this.queueMouseMoved.bind(this)));
        this.viewport.canvas.addEventListener("wheel", (this.eventListeners[6] = this.wheel.bind(this)));
    };
    ClickController.prototype.queueMouseMoved = function (e) {
        var _this = this;
        if (this.mouseMoveFrame !== null) {
            this.pendingMouseMove = e;
            return;
        }
        this.processMouseMoved(e);
        this.mouseMoveFrame = requestAnimationFrame(function () {
            _this.mouseMoveFrame = null;
            var latest = _this.pendingMouseMove;
            _this.pendingMouseMove = null;
            if (latest)
                _this.queueMouseMoved(latest);
        });
    };
    ClickController.prototype.processMouseMoved = function (e) {
        ControlPanelController.controller.cursorMovedTo(e);
        MapController.controller.cursorMovedTo(e);
        Viewport.viewport.contextMenu.cursorMovedTo(e.clientX, e.clientY);
        this.mouseMoved(e);
    };
    ClickController.prototype.wheel = function (e) {
        Settings/* Settings */.w.zoomScale -= e.deltaY / 500;
        if (Settings/* Settings */.w.zoomScale < 0.5) {
            Settings/* Settings */.w.zoomScale = 0.5;
        }
        if (Settings/* Settings */.w.zoomScale > 2) {
            Settings/* Settings */.w.zoomScale = 2;
        }
        Settings/* Settings */.w.persistToStorage();
    };
    ClickController.prototype.leftClickUp = function (e) {
        if (e.button !== 0) {
            return;
        }
        var intercepted = ControlPanelController.controller.controlPanelClickUp(e);
        if (intercepted) {
            return;
        }
    };
    ClickController.prototype.hasSelectedMob = function () {
        return this.recentlySelectedMobs.length > 0;
    };
    ClickController.prototype.mouseMoved = function (e) {
        var scale = Settings/* Settings */.w.maxUiScale;
        if (this.viewport.components.some(function (component) { return component.onMouseMove(e.offsetX / scale, e.offsetY / scale); })) {
            this.hoverTooltip = null;
            return;
        }
        var panelHoverAction = ControlPanelController.controller.hoverAction(e);
        if (panelHoverAction) {
            this.recentlySelectedMobs.forEach(function (mob) {
                mob.selected = false;
            });
            this.recentlySelectedMobs = [];
            this.hoverTooltip = { text: panelHoverAction, x: e.offsetX, y: e.offsetY + 10 };
            return;
        }
        var world = Trainer/* Trainer */.c.player.region.world;
        var hoveredOn = Viewport.viewport.translateClick(e.offsetX, e.offsetY, world);
        this.recentlySelectedMobs.forEach(function (mob) {
            mob.selected = false;
        });
        this.recentlySelectedMobs = [];
        if (hoveredOn && hoveredOn.type === "entities") {
            var visibleMobs = hoveredOn.mobs.filter(function (mob) { return mob.visible(); });
            var firstMob = visibleMobs.find(function () { return true; });
            if (firstMob) {
                firstMob.selected = true;
                this.recentlySelectedMobs.push(firstMob);
            }
            var firstAction = this.contextActionsFor(Trainer/* Trainer */.c.player.region, visibleMobs, hoveredOn.players, hoveredOn.groundItems, hoveredOn.location.x, hoveredOn.location.y)[0];
            this.hoverTooltip = firstAction
                ? { text: firstAction.text, x: e.offsetX, y: e.offsetY + 10 }
                : null;
        }
        else {
            this.hoverTooltip = null;
        }
    };
    ClickController.prototype.drawHoverTooltip = function (context) {
        if (!this.hoverTooltip || Viewport.viewport.contextMenu.isActive)
            return;
        var _a = this.hoverTooltip, text = _a.text, x = _a.x, y = _a.y;
        context.save();
        context.font = "16px Stats_11";
        context.textAlign = "left";
        context.textBaseline = "top";
        var textX = x + 12;
        var textY = y + 12;
        var textWidth = text.reduce(function (width, block) { return width + context.measureText(block.text).width; }, 0);
        context.fillStyle = "rgba(64, 64, 64, 0.5)";
        context.fillRect(textX - 4, textY - 3, textWidth + 8, 21);
        context.lineWidth = 1;
        context.strokeStyle = "rgba(64, 64, 64, 0.75)";
        context.strokeRect(textX - 3.5, textY - 2.5, textWidth + 7, 20);
        text.forEach(function (block) {
            context.fillStyle = "black";
            context.fillText(block.text, textX + 1, textY + 1);
            context.fillStyle = block.fillStyle || "white";
            context.fillText(block.text, textX, textY);
            textX += context.measureText(block.text).width;
        });
        context.restore();
    };
    ClickController.prototype.contextActionsFor = function (region, mobs, players, groundItems, x, y) {
        var menuOptions = [];
        mobs.filter(function (mob) { return mob.visible(); }).forEach(function (mob) {
            menuOptions = menuOptions.concat(mob.contextActions(region, x, y));
        });
        players.forEach(function (player) {
            if (player !== Trainer/* Trainer */.c.player) {
                menuOptions = menuOptions.concat(player.contextActions(region, x, y));
            }
        });
        groundItems.forEach(function (item) {
            menuOptions.push({
                text: [
                    { text: "Take ", fillStyle: "white" },
                    { text: item.itemName, fillStyle: "#FF911F" },
                ],
                action: function () { return Input/* InputController */.f.controller.queueAction(function () { return Trainer/* Trainer */.c.player.setSeekingItem(item); }); },
            });
        });
        return menuOptions;
    };
    ClickController.prototype.getClickedOn = function (e, world, region) {
        var xAlign = Viewport.viewport.contextMenu.location.x - Viewport.viewport.contextMenu.width / 2 < e.offsetX &&
            e.offsetX < Viewport.viewport.contextMenu.location.x + Viewport.viewport.contextMenu.width / 2;
        var yAlign = Viewport.viewport.contextMenu.location.y < e.offsetY &&
            e.offsetY < Viewport.viewport.contextMenu.location.y + Viewport.viewport.contextMenu.height;
        if (Viewport.viewport.contextMenu.isActive && xAlign && yAlign) {
            Viewport.viewport.contextMenu.clicked(e.offsetX, e.offsetY);
            Viewport.viewport.contextMenu.setInactive();
            return;
        }
        var intercepted = MapController.controller.leftClickDown(e);
        if (intercepted) {
            return;
        }
        var controlPanelIntercepted = ControlPanelController.controller.controlPanelClickDown(e);
        if (controlPanelIntercepted) {
            return;
        }
        var scale = Settings/* Settings */.w.maxUiScale;
        if (this.viewport.components.some(function (component) { return component.onPanelClick(e.offsetX / scale, e.offsetY / scale); })) {
            return;
        }
        var clickedOn = Viewport.viewport.translateClick(e.offsetX, e.offsetY, world);
        if (!clickedOn) {
            return null;
        }
        var _a = clickedOn.location, x = _a.x, y = _a.y;
        var mobs = [];
        var players = [];
        var groundItems = [];
        if (clickedOn.type === "entities") {
            mobs.push.apply(mobs, clickedOn.mobs.filter(function (mob) { return mob.visible(); }));
            players.push.apply(players, clickedOn.players);
            groundItems.push.apply(groundItems, clickedOn.groundItems);
        }
        return { mobs: mobs, players: players, groundItems: groundItems, x: x, y: y };
    };
    ClickController.prototype.clickDown = function (e) {
        var _this = this;
        if (e.button === 2) {
            this.rightClickDown(e);
        }
        if (e.button === 1) {
            e.preventDefault(); // prevent autoscroll on middle click
            return;
        }
        if (e.button !== 0) {
            return;
        }
        var region = Trainer/* Trainer */.c.player.region;
        var world = Trainer/* Trainer */.c.player.region.world;
        var player = Trainer/* Trainer */.c.player;
        Viewport.viewport.contextMenu.cursorMovedTo(e.clientX, e.clientY);
        var clickedOn = this.getClickedOn(e, world, region);
        if (!clickedOn) {
            return;
        }
        var mobs = clickedOn.mobs, players = clickedOn.players, groundItems = clickedOn.groundItems, x = clickedOn.x, y = clickedOn.y;
        Trainer/* Trainer */.c.player.interruptCombat();
        Replay/* ReplayLog */.s.recordImmediate({ kind: "interrupt" });
        var inputController = Input/* InputController */.f.controller;
        if (!e.shiftKey && mobs.length && mobs[0].canBeAttacked()) {
            this.redClick();
            inputController.queueAction(function () { return _this.playerAttackClick(mobs[0]); }, function () { return ({ kind: "attackMob", mob: Replay/* ReplayLog */.s.mobIndex(mobs[0]) }); });
        }
        else if (!e.shiftKey && players.length) {
            this.redClick();
            inputController.queueAction(function () { return _this.playerAttackClick(players[0]); });
        }
        else if (!e.shiftKey && groundItems.length) {
            this.redClick();
            inputController.queueAction(function () { return player.setSeekingItem(groundItems[0]); });
        }
        else if (x !== null && y !== null) {
            this.yellowClick();
            player.showTargetMarker({ x: Math.floor(x), y: Math.floor(y) });
            // Ctrl+click walks (or runs, if run is off) for this click only, as in the OSRS client.
            var invertRun_1 = e.ctrlKey;
            inputController.queueAction(function () { return _this.playerWalkClick(x, y, invertRun_1); }, function () { return (__assign({ kind: "walk", x: x, y: y }, (invertRun_1 ? { invertRun: invertRun_1 } : {}))); });
        }
        Viewport.viewport.contextMenu.setInactive();
    };
    ClickController.prototype.rightClickDown = function (e) {
        var _this = this;
        var region = Trainer/* Trainer */.c.player.region;
        var world = Trainer/* Trainer */.c.player.region.world;
        Viewport.viewport.contextMenu.setPosition({ x: e.offsetX, y: e.offsetY });
        if (ControlPanelController.controller.controlPanelRightClick(e)) {
            return;
        }
        if (MapController.controller.rightClick(e)) {
            return;
        }
        var clickedOn = this.getClickedOn(e, world, region);
        if (!clickedOn) {
            return;
        }
        var mobs = clickedOn.mobs, players = clickedOn.players, groundItems = clickedOn.groundItems, x = clickedOn.x, y = clickedOn.y;
        Viewport.viewport.contextMenu.destinationLocation = {
            x: Math.floor(x),
            y: Math.floor(y),
        };
        var menuOptions = this.contextActionsFor(region, mobs, players, groundItems, x, y);
        menuOptions.push({
            text: [{ text: "Walk Here", fillStyle: "white" }],
            action: function () {
                _this.yellowClick();
                var x = Viewport.viewport.contextMenu.destinationLocation.x;
                var y = Viewport.viewport.contextMenu.destinationLocation.y;
                Input/* InputController */.f.controller.queueAction(function () { return _this.playerWalkClick(x, y); }, function () { return ({ kind: "walk", x: x, y: y }); });
            },
        }, {
            text: [{ text: "Mark / Unmark Tile", fillStyle: "white" }],
            action: function () {
                _this.yellowClick();
                var x = Viewport.viewport.contextMenu.destinationLocation.x;
                var y = Viewport.viewport.contextMenu.destinationLocation.y;
                var removed = false;
                var entitiesAtPoint = Pathing/* Pathing */.G.entitiesAtPoint(region, x, y, 1);
                entitiesAtPoint.forEach(function (entity) {
                    if (entity.entityName() === EntityName/* EntityNames */.C.TILE_MARKER && entity.saveable) {
                        region.removeEntity(entity);
                        removed = true;
                    }
                });
                if (!removed) {
                    region.addEntity(new TileMarker/* TileMarker */.l(Trainer/* Trainer */.c.player.region, { x: x, y: y }, "#FF0000"));
                }
                Settings/* Settings */.w.tile_markers = (0,lodash.filter)((0,lodash.filter)(region.entities, function (entity) { return entity.entityName() === EntityName/* EntityNames */.C.TILE_MARKER; }), function (tileMarker) { return tileMarker.saveable; }).map(function (entity) { return entity.location; });
                Settings/* Settings */.w.persistToStorage();
            },
        });
        menuOptions = menuOptions.concat(region.rightClickActions());
        Viewport.viewport.contextMenu.setMenuOptions(menuOptions);
        Viewport.viewport.contextMenu.setActive();
    };
    ClickController.prototype.playerAttackClick = function (mob) {
        if (mob instanceof Mob/* Mob */.B && !mob.visible())
            return;
        Trainer/* Trainer */.c.player.setAggro(mob);
    };
    ClickController.prototype.playerWalkClick = function (x, y, invertRun) {
        if (invertRun === void 0) { invertRun = false; }
        Trainer/* Trainer */.c.player.moveTo(Math.floor(x), Math.floor(y), invertRun);
    };
    ClickController.prototype.redClick = function () {
        this.clickAnimation = new ClickAnimation("red", Viewport.viewport.contextMenu.cursorPosition.x, Viewport.viewport.contextMenu.cursorPosition.y);
    };
    ClickController.prototype.yellowClick = function () {
        this.clickAnimation = new ClickAnimation("yellow", Viewport.viewport.contextMenu.cursorPosition.x, Viewport.viewport.contextMenu.cursorPosition.y);
    };
    return ClickController;
}());


;// CONCATENATED MODULE: ./src/sdk/controlpanels/StandardSpellbookControls.ts
var StandardSpellbookControls_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var StandardSpellbookControls = /** @class */ (function (_super) {
    StandardSpellbookControls_extends(StandardSpellbookControls, _super);
    function StandardSpellbookControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StandardSpellbookControls.prototype, "panelImageReference", {
        get: function () {
            return inventory_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StandardSpellbookControls.prototype, "tabImageReference", {
        get: function () {
            return standard_spellbook_namespaceObject;
        },
        enumerable: false,
        configurable: true
    });
    return StandardSpellbookControls;
}(BaseControls));


// EXTERNAL MODULE: ./src/sdk/Eating.ts
var Eating = __webpack_require__(681);
// EXTERNAL MODULE: ./src/sdk/gear/Ammo.ts
var Ammo = __webpack_require__(1977);
// EXTERNAL MODULE: ./src/sdk/gear/Cape.ts
var Cape = __webpack_require__(1040);
// EXTERNAL MODULE: ./src/sdk/gear/Chest.ts
var Chest = __webpack_require__(7718);
// EXTERNAL MODULE: ./src/sdk/gear/Feet.ts
var Feet = __webpack_require__(9775);
// EXTERNAL MODULE: ./src/sdk/gear/Food.ts
var Food = __webpack_require__(7719);
// EXTERNAL MODULE: ./src/sdk/gear/Gloves.ts
var Gloves = __webpack_require__(1629);
// EXTERNAL MODULE: ./src/sdk/gear/Helmet.ts
var Helmet = __webpack_require__(2282);
// EXTERNAL MODULE: ./src/sdk/gear/Legs.ts
var Legs = __webpack_require__(2802);
// EXTERNAL MODULE: ./src/sdk/gear/Necklace.ts
var Necklace = __webpack_require__(4295);
// EXTERNAL MODULE: ./src/sdk/gear/Offhand.ts
var Offhand = __webpack_require__(7211);
// EXTERNAL MODULE: ./src/sdk/gear/Potion.ts + 1 modules
var Potion = __webpack_require__(6338);
// EXTERNAL MODULE: ./src/sdk/gear/Ring.ts
var Ring = __webpack_require__(5941);
// EXTERNAL MODULE: ./src/sdk/gear/Weapon.ts
var Weapon = __webpack_require__(6103);
// EXTERNAL MODULE: ./src/sdk/Item.ts
var Item = __webpack_require__(2376);
// EXTERNAL MODULE: ./src/sdk/Location.ts
var Location = __webpack_require__(4176);
// EXTERNAL MODULE: ./src/sdk/PlayerRegenTimers.ts
var PlayerRegenTimers = __webpack_require__(1167);
// EXTERNAL MODULE: ./src/sdk/PlayerStats.ts
var PlayerStats = __webpack_require__(2455);
// EXTERNAL MODULE: ./src/sdk/PrayerController.ts + 41 modules
var PrayerController = __webpack_require__(4590);
;// CONCATENATED MODULE: ./src/sdk/ReplayPlayback.ts

var ReplayPlayback_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};





/** Applies recorded inputs. Kept apart from ReplayLog, which the input code imports. */
var ReplayPlayback = /** @class */ (function () {
    function ReplayPlayback() {
    }
    /** Re-apply a recorded input against the current (re-simulated) world. */
    ReplayPlayback.apply = function (action) {
        var _a, _b, _c;
        var player = Trainer/* Trainer */.c.player;
        if (!player)
            return;
        switch (action.kind) {
            case "walk":
                Trainer/* Trainer */.c.clickController.playerWalkClick(action.x, action.y, action.invertRun === true);
                break;
            case "attackMob": {
                var region = player.region;
                var mob = ReplayPlayback_spreadArray(ReplayPlayback_spreadArray([], region.mobs, true), region.newMobs, true)[action.mob];
                if (mob)
                    Trainer/* Trainer */.c.clickController.playerAttackClick(mob);
                break;
            }
            case "interrupt":
                player.interruptCombat();
                break;
            case "unequip":
                ControlPanelController.controls.EQUIPMENT.equipmentInteractions[0](action.slot);
                break;
            case "inventoryClick":
                (_a = player.inventory[action.slot]) === null || _a === void 0 ? void 0 : _a.inventoryLeftClick(player);
                break;
            case "swap":
                player.swapItemPositions(action.a, action.b);
                break;
            case "prayer": {
                var prayer = player.prayerController.prayers[action.index];
                if (prayer && player.currentStats.prayer > 0 && prayer.toggleClient(player)) {
                    prayer.toggleServer(player);
                    var controls = ControlPanelController.controls.PRAYER;
                    if (controls.hasQuickPrayersActivated && player.prayerController.activePrayers().length === 0) {
                        controls.hasQuickPrayersActivated = false;
                    }
                }
                break;
            }
            case "quickPrayers":
                MapController.controller.toggleQuickprayers(false);
                break;
            case "run":
                player.running = !player.running;
                break;
            case "spec":
                MapController.controller.toggleSpecialAttack(false);
                break;
            case "attackStyle": {
                var weapon = player.equipment.weapon;
                var style = weapon === null || weapon === void 0 ? void 0 : weapon.attackStyles()[action.index];
                if (weapon && style)
                    AttackStylesController/* AttackStylesController */.D2.controller.setWeaponAttackStyle(weapon, style);
                break;
            }
            case "autoRetaliate":
                player.autoRetaliate = !player.autoRetaliate;
                break;
            case "custom":
                (_c = (_b = Replay/* ReplayLog */.s.customHandlers)[action.name]) === null || _c === void 0 ? void 0 : _c.call(_b, action.data);
                break;
        }
    };
    return ReplayPlayback;
}());


// EXTERNAL MODULE: ./src/sdk/Renderable.ts
var Renderable = __webpack_require__(427);
// EXTERNAL MODULE: ./src/sdk/SetEffect.ts
var SetEffect = __webpack_require__(8350);
// EXTERNAL MODULE: ./src/sdk/SettingsStore.ts
var SettingsStore = __webpack_require__(1609);
// EXTERNAL MODULE: ./src/sdk/utils/Assets.ts
var Assets = __webpack_require__(8648);
;// CONCATENATED MODULE: ./src/assets/sounds/bonk.ogg
const bonk_namespaceObject = __webpack_require__.p + "5e4bdd862b2d716855cd.ogg";
;// CONCATENATED MODULE: ./src/sdk/World.ts










var World = /** @class */ (function () {
    function World() {
        this.regions = [];
        this.globalTickCounter = 0;
        this._clientTickCounter = 0;
        this.isPaused = true;
        this.clientTickPercent = 0;
        this.getReadyTimer = 0;
        this.deltaTimeSincePause = -1;
        this.deltaTimeSinceLastTick = -1;
        this.frameCount = 0;
        this.tickTimer = 0;
        this.nextTickTimer = 0;
        this.clientTickTimer = 0;
        this.clientTickAccumulator = 0;
        this.fps = 50; // updates to track realtime framerate
        this.browserLoopStarted = false;
    }
    Object.defineProperty(World.prototype, "clientTickCounter", {
        get: function () { return this._clientTickCounter; },
        enumerable: false,
        configurable: true
    });
    World.prototype.addRegion = function (region) {
        this.regions.push(region);
    };
    World.prototype.startTicking = function () {
        this.isPaused = false;
        var now = window.performance.now();
        // Anchor accounting to this frame, preserving fractional progress on
        // resume so animation poses do not jump backwards after a pause.
        this.clientTickTimer = now;
        if (this.deltaTimeSincePause === -1) {
            this.clientTickAccumulator = 0;
            this.clientTickPercent = 0;
            this.tickTimer = now;
            this.then = now;
        }
        else {
            this.clientTickAccumulator = this.clientTickPercent * constants/* CLIENT_CYCLE_MS */.Om;
            this.then = now - this.deltaTimeSincePause;
            this.tickTimer = now - this.deltaTimeSinceLastTick;
            this.deltaTimeSincePause = -1;
        }
        this.nextTickTimer = this.tickTimer + Settings/* Settings */.w.tickMs;
        ControlPanelController.controller.onWorldTick();
        if (!this.browserLoopStarted) {
            this.browserLoopStarted = true;
            this.browserLoop(window.performance.now());
        }
    };
    World.prototype.stopTicking = function () {
        this.deltaTimeSincePause = window.performance.now() - this.then;
        this.deltaTimeSinceLastTick = window.performance.now() - this.tickTimer;
        this.isPaused = true;
    };
    World.prototype.doClientTick = function (now) {
        if (now === void 0) { now = window.performance.now(); }
        this.clientTickAccumulator += Math.max(0, now - this.clientTickTimer);
        this.clientTickTimer = now;
        // Keep the client simulation on a fixed 20 ms cadence instead of
        // re-anchoring movement to an imprecise setInterval callback.
        // Avoid unbounded catch-up after a timer stall; visibility handling also
        // prevents background accumulation.
        var maxCatchupMs = constants/* CLIENT_CYCLE_MS */.Om * constants/* CLIENT_CYCLES_PER_SECOND */.ZC;
        if (this.clientTickAccumulator > maxCatchupMs)
            this.clientTickAccumulator = maxCatchupMs;
        while (this.clientTickAccumulator >= constants/* CLIENT_CYCLE_MS */.Om) {
            var tickPercent = Math.min(1, Math.max(0, (now - this.tickTimer) / Settings/* Settings */.w.tickMs));
            var tickTimestamp = now - Math.max(0, this.clientTickAccumulator - constants/* CLIENT_CYCLE_MS */.Om);
            this.tickClient(tickPercent, tickTimestamp);
            this.clientTickAccumulator -= constants/* CLIENT_CYCLE_MS */.Om;
        }
        this.clientTickPercent = this.clientTickAccumulator / constants/* CLIENT_CYCLE_MS */.Om;
    };
    World.prototype.browserLoop = function (now) {
        window.requestAnimationFrame(this.browserLoop.bind(this));
        if (this.isPaused) {
            return;
        }
        var elapsed = now - this.then;
        this.fps = Math.floor(1000 / elapsed);
        if (now > this.nextTickTimer) {
            this.nextTickTimer += Settings/* Settings */.w.tickMs;
            this.tickTimer = now;
            this.tickPercent = 0;
            if (this.getReadyTimer > 0) {
                this.getReadyTimer--;
            }
            this.tickWorld();
        }
        // Server movement must enqueue its step before the client-cycle movement
        // consumes the path when both boundaries occur in the same render frame.
        // A separate setInterval made that ordering dependent on browser timing.
        this.doClientTick(now);
        this.tickPercent = Math.min(1, Math.max(0, (now - this.tickTimer) / Settings/* Settings */.w.tickMs));
        Viewport.viewport.draw(this);
        this.then = now;
        this.frameCount++;
    };
    World.prototype.tickWorld = function (n) {
        var _this = this;
        if (n === void 0) { n = 1; }
        this.globalTickCounter++;
        Input/* InputController */.f.controller.onWorldTick(this.globalTickCounter);
        ControlPanelController.controller.onWorldTick();
        this.regions.forEach(function (region) { return _this.tickRegion(region); });
        if (n > 1) {
            return this.tickWorld(n - 1);
        }
    };
    World.prototype.tickClient = function (tickPercent, timestamp) {
        var _this = this;
        var _a;
        Input/* InputController */.f.controller.onClientTick();
        this.regions.forEach(function (region) { return _this.clientTick(region, tickPercent, timestamp); });
        (_a = Viewport.viewport) === null || _a === void 0 ? void 0 : _a.clientTick(timestamp);
        this._clientTickCounter++;
    };
    World.prototype.tickRegion = function (region) {
        var _a;
        var _this = this;
        if (Settings/* Settings */.w.metronome) {
            new Audio(bonk_namespaceObject).play();
        }
        // TODO: Clean up this since its now region based
        if (region.newMobs.length) {
            (_a = region.mobs).unshift.apply(_a, region.newMobs);
            region.newMobs = [];
        }
        region.players.forEach(function (player) { return player.pretick(); });
        region.entities.forEach(function (entity) { return entity.tick(); });
        if (this.getReadyTimer == 0) {
            region.mobs.forEach(function (mob) {
                mob.timerStep();
            });
            region.mobs.forEach(function (mob) {
                mob.queueStep();
                mob.movementStep();
                region.refreshUnitChunk(mob);
            });
            region.mobs.forEach(function (mob) { return mob.attackStep(); });
            region.newMobs.forEach(function (mob) {
                mob.timerStep();
            });
            region.newMobs.forEach(function (mob) {
                mob.queueStep();
                mob.movementStep();
                region.refreshUnitChunk(mob);
            });
            region.newMobs.forEach(function (mob) { return mob.attackStep(); });
        }
        DelayedAction/* DelayedAction */.T.afterNpcTick();
        region.projectiles = (0,lodash.filter)(region.projectiles, function (projectile) { return !projectile.shouldDestroy(); });
        region.projectiles.forEach(function (projectile) {
            projectile.onTick();
            if (projectile.remainingDelay === 0) {
                projectile.beforeHit();
            }
        });
        region.players.forEach(function (player) {
            if (_this.getReadyTimer <= 0)
                player.queueStep();
            player.timerStep();
            player.movementStep();
            region.refreshUnitChunk(player);
            if (_this.getReadyTimer <= 0) {
                player.attackStep();
            }
        });
        region.midTick();
        DelayedAction/* DelayedAction */.T.tick();
        XpDropController/* XpDropController */.O.controller.tick();
        Viewport.viewport.tick();
        region.postTick();
        // Safely remove the dead stuff from the world. If we do it while iterating we can cause ticks to be stole'd
        var deadPlayers = region.players.filter(function (player) { return player.dying === 0; });
        var deadMobs = region.mobs.filter(function (mob) { return mob.dying === 0; });
        var deadEntities = region.entities.filter(function (entity) { return entity.dying === 0; });
        deadPlayers.forEach(function (player) { return region.removePlayer(player); });
        deadMobs.forEach(function (mob) { return region.removeMob(mob); });
        deadEntities.forEach(function (entity) { return region.removeEntity(entity); });
    };
    World.prototype.clientTick = function (region, tickPercent, timestamp) {
        region.projectileGraphics = region.projectileGraphics.filter(function (graphic) { return !graphic.shouldDestroy(); });
        region.projectileGraphics.forEach(function (graphic) { return graphic.clientTick(); });
        region.players.forEach(function (player) {
            player.clientTick(tickPercent, timestamp);
        });
        region.mobs.forEach(function (mob) {
            mob.clientTick(tickPercent, timestamp);
        });
    };
    return World;
}());


;// CONCATENATED MODULE: ./src/sdk/TrainerInstance.ts
var TrainerInstance_assign = (undefined && undefined.__assign) || function () {
    TrainerInstance_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return TrainerInstance_assign.apply(this, arguments);
};
var TrainerInstance_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var TrainerInstance_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};








/**
 * Owns the lifecycle and services for one trainer instance.
 * The engine still has legacy singletons internally, so only one instance may
 * be active at a time for now.
 */
var TrainerInstance = /** @class */ (function () {
    function TrainerInstance(region, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        var _a;
        this.region = region;
        this.options = options;
        this.world = new World();
        this.player = null;
        this.canvas = null;
        this.listeners = new Set();
        this.loadPromise = null;
        this.loadingListeners = new Set();
        this.loadingState = Object.freeze({
            assetProgress: 0,
            assetsLoaded: 0,
            assetsReady: false,
            assetsTotal: 0,
            imagesReady: false,
            status: "idle",
            viewportReady: false,
        });
        this.subscribe = function (listener) {
            _this.listeners.add(listener);
            return function () {
                _this.listeners.delete(listener);
            };
        };
        this.getSnapshot = function () { return _this.snapshot; };
        this.world.getReadyTimer = (_a = options.readyTimer) !== null && _a !== void 0 ? _a : 6;
        region.world = this.world;
        this.world.addRegion(region);
        this.snapshot = this.createSnapshot();
        this.unsubscribeSettings = Settings/* Settings */.w.subscribe(function () { return _this.notifyChanged(); });
    }
    TrainerInstance.prototype.mount = function (canvas, resizeTarget) {
        var _a;
        if (this.canvas && this.canvas !== canvas)
            throw new Error("TrainerInstance is already mounted to another canvas");
        if (this.player)
            return this.player;
        this.canvas = canvas;
        Viewport.setupViewport(this.region, canvas, resizeTarget, (_a = this.options.force2d) !== null && _a !== void 0 ? _a : false);
        this.player = this.region.reset(false).player;
        this.player.perceivedLocation = this.player.location;
        this.player.destinationLocation = this.player.location;
        this.notifyChanged();
        return this.player;
    };
    TrainerInstance.prototype.initialiseViewport = function () {
        return TrainerInstance_awaiter(this, void 0, void 0, function () {
            return TrainerInstance_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.player)
                            throw new Error("Mount the TrainerInstance before initialising its viewport");
                        return [4 /*yield*/, Viewport.viewport.initialise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TrainerInstance.prototype.load = function (options) {
        var _a;
        if (options === void 0) { options = {}; }
        return TrainerInstance_awaiter(this, void 0, void 0, function () {
            var listener;
            return TrainerInstance_generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.player)
                            throw new Error("Mount the TrainerInstance before loading its assets");
                        listener = options.onStateChange;
                        if (listener) {
                            this.loadingListeners.add(listener);
                            listener(this.loadingState);
                        }
                        (_a = this.loadPromise) !== null && _a !== void 0 ? _a : (this.loadPromise = this.performLoad());
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.loadPromise];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (listener)
                            this.loadingListeners.delete(listener);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TrainerInstance.prototype.start = function () {
        this.world.startTicking();
        this.notifyChanged();
    };
    TrainerInstance.prototype.stop = function () {
        this.world.stopTicking();
        this.notifyChanged();
    };
    TrainerInstance.prototype.reset = function () {
        Trainer/* Trainer */.c.reset();
        this.player = Trainer/* Trainer */.c.player;
        this.notifyChanged();
        return this.player;
    };
    TrainerInstance.prototype.setSettings = function (patch) {
        var settings = Settings/* Settings */.w.set(patch);
        if (patch.tileMarkerColor !== undefined) {
            TileMarker/* TileMarker */.l.onSetColor(settings.tileMarkerColor);
        }
        return settings;
    };
    TrainerInstance.prototype.dispose = function () {
        var _a;
        if (!this.world.isPaused)
            this.world.stopTicking();
        (_a = Viewport.viewport) === null || _a === void 0 ? void 0 : _a.dispose();
        this.unsubscribeSettings();
        this.listeners.clear();
        this.loadingListeners.clear();
    };
    TrainerInstance.prototype.createSnapshot = function () {
        return Object.freeze({
            player: this.player,
            region: this.region,
            settings: Settings/* Settings */.w.getSnapshot(),
            world: this.world,
        });
    };
    TrainerInstance.prototype.notifyChanged = function () {
        this.snapshot = this.createSnapshot();
        this.listeners.forEach(function (listener) { return listener(); });
    };
    TrainerInstance.prototype.performLoad = function () {
        return TrainerInstance_awaiter(this, void 0, void 0, function () {
            var assetsTotal, assetsLoaded, error_1, loadingError;
            return TrainerInstance_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assetsTotal = Assets/* Assets */.s.assetCount;
                        assetsLoaded = assetsTotal - Assets/* Assets */.s.loadingAssetUrls.length;
                        this.setLoadingState({
                            assetProgress: assetsTotal === 0 ? 1 : assetsLoaded / assetsTotal,
                            assetsLoaded: assetsLoaded,
                            assetsReady: Assets/* Assets */.s.loadingAssetUrls.length === 0,
                            assetsTotal: assetsTotal,
                            error: undefined,
                            imagesReady: ImageLoader/* ImageLoader */.$.pendingImages === ImageLoader/* ImageLoader */.$.completedImages,
                            status: "loading",
                            viewportReady: false,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, Promise.all([this.waitForImages(), this.waitForAssets()])];
                    case 2:
                        _a.sent();
                        this.setLoadingState({ status: "initialising-viewport" });
                        return [4 /*yield*/, this.initialiseViewport()];
                    case 3:
                        _a.sent();
                        this.setLoadingState({ status: "ready", viewportReady: true });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        loadingError = error_1 instanceof Error ? error_1 : new Error(String(error_1));
                        this.setLoadingState({ error: loadingError, status: "error" });
                        throw loadingError;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    TrainerInstance.prototype.waitForImages = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var interval;
            var onLoaded = function () {
                unsubscribe();
                if (interval)
                    clearInterval(interval);
                MapController.controller.updateOrbsMask(_this.player.currentStats, _this.player.stats);
                _this.setLoadingState({ imagesReady: true });
                resolve();
            };
            var unsubscribe = ImageLoader/* ImageLoader */.$.onAllImagesLoaded(onLoaded);
            interval = setInterval(function () { return ImageLoader/* ImageLoader */.$.checkImagesLoaded(interval); }, 50);
        });
    };
    TrainerInstance.prototype.waitForAssets = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var interval;
            var unsubscribeProgress = Assets/* Assets */.s.onAssetProgress(function (loaded, total) {
                _this.setLoadingState({
                    assetProgress: total === 0 ? 1 : loaded / total,
                    assetsLoaded: loaded,
                    assetsTotal: total,
                });
            });
            var onLoaded = function () {
                unsubscribeLoaded();
                unsubscribeProgress();
                if (interval)
                    clearInterval(interval);
                var total = Assets/* Assets */.s.assetCount;
                _this.setLoadingState({
                    assetProgress: 1,
                    assetsLoaded: total,
                    assetsReady: true,
                    assetsTotal: total,
                });
                resolve();
            };
            var unsubscribeLoaded = Assets/* Assets */.s.onAllAssetsLoaded(onLoaded);
            interval = setInterval(function () { return Assets/* Assets */.s.checkAssetsLoaded(interval); }, 50);
        });
    };
    TrainerInstance.prototype.setLoadingState = function (patch) {
        var _this = this;
        this.loadingState = Object.freeze(TrainerInstance_assign(TrainerInstance_assign({}, this.loadingState), patch));
        this.loadingListeners.forEach(function (listener) { return listener(_this.loadingState); });
    };
    return TrainerInstance;
}());


// EXTERNAL MODULE: ./src/sdk/utils/Text.ts
var Text = __webpack_require__(3462);
// EXTERNAL MODULE: ./src/sdk/XpDrop.ts
var XpDrop = __webpack_require__(3422);
;// CONCATENATED MODULE: ./src/sdk/testing/TestNpc.ts
var TestNpc_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



// this is a JalXil in all but name, from the old test
var TestNpc = /** @class */ (function (_super) {
    TestNpc_extends(TestNpc, _super);
    function TestNpc(region, location, options) {
        return _super.call(this, region, location, options) || this;
    }
    TestNpc.prototype.setStats = function () {
        // One-turn startup stun.
        this.stunned = 2;
        this.weapons = {
            crush: new MeleeWeapon/* MeleeWeapon */.d(),
            range: new RangedWeapon/* RangedWeapon */.I(),
        };
        // non boosted numbers
        this.stats = {
            attack: 140,
            strength: 180,
            defence: 60,
            range: 250,
            magic: 90,
            hitpoint: 125,
        };
        // with boosts
        this.currentStats = JSON.parse(JSON.stringify(this.stats));
    };
    Object.defineProperty(TestNpc.prototype, "bonuses", {
        get: function () {
            return {
                attack: {
                    stab: 0,
                    slash: 0,
                    crush: 0,
                    magic: 0,
                    range: 40,
                },
                defence: {
                    stab: 0,
                    slash: 0,
                    crush: 0,
                    magic: 0,
                    range: 0,
                },
                other: {
                    meleeStrength: 0,
                    rangedStrength: 50,
                    magicDamage: 0,
                    prayer: 0,
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TestNpc.prototype, "attackSpeed", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TestNpc.prototype, "attackRange", {
        get: function () {
            return 15;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TestNpc.prototype, "size", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    TestNpc.prototype.attackStyleForNewAttack = function () {
        return "range";
    };
    TestNpc.prototype.canMeleeIfClose = function () {
        return "crush";
    };
    return TestNpc;
}(Mob/* Mob */.B));


;// CONCATENATED MODULE: ./src/sdk/testing/TestRegion.ts
var TestRegion_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var TestRegion = /** @class */ (function (_super) {
    TestRegion_extends(TestRegion, _super);
    function TestRegion(_width, _height) {
        var _this = _super.call(this) || this;
        _this._width = _width;
        _this._height = _height;
        return _this;
    }
    Object.defineProperty(TestRegion.prototype, "width", {
        get: function () {
            return this._width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TestRegion.prototype, "height", {
        get: function () {
            return this._height;
        },
        enumerable: false,
        configurable: true
    });
    TestRegion.prototype.initialiseRegion = function () {
        return null;
    };
    return TestRegion;
}(Region));


;// CONCATENATED MODULE: ./src/sdk/utils/__mocks__/Assets.ts
var Assets_Assets = /** @class */ (function () {
    function Assets() {
    }
    Assets.getAssetUrl = function (x) {
        return x;
    };
    return Assets;
}());


;// CONCATENATED MODULE: ./src/sdk/utils/__mocks__/SoundCache.ts
var Sound = /** @class */ (function () {
    function Sound(src, volume, delayMs, area) {
        if (volume === void 0) { volume = 1; }
        if (delayMs === void 0) { delayMs = 0; }
        this.src = src;
        this.volume = volume;
        this.delayMs = delayMs;
        this.area = area;
    }
    return Sound;
}());

var SoundCache_SoundCache = /** @class */ (function () {
    function SoundCache() {
    }
    SoundCache.setAudioListener = function () {
        return;
    };
    SoundCache.preload = function () {
        return;
    };
    SoundCache.play = function () {
        return;
    };
    return SoundCache;
}());


;// CONCATENATED MODULE: ./src/sdk/index.ts
// generated using Generate Index https://marketplace.visualstudio.com/items?itemName=JayFong.generate-index
// @index('./**/*.ts', f => `export * from '${f.path}';`)







































































































// EXTERNAL MODULE: ./src/sdk/rendering/BasicModel.ts
var BasicModel = __webpack_require__(4989);
// EXTERNAL MODULE: ./src/sdk/rendering/CanvasSpriteModel.ts
var CanvasSpriteModel = __webpack_require__(5870);
// EXTERNAL MODULE: ./src/sdk/rendering/GLTFAnimationConstants.ts
var GLTFAnimationConstants = __webpack_require__(1708);
// EXTERNAL MODULE: ./src/sdk/rendering/GLTFModel.ts + 3 modules
var GLTFModel = __webpack_require__(2313);
// EXTERNAL MODULE: ./src/sdk/rendering/CacheRenderBundle.ts
var CacheRenderBundle = __webpack_require__(702);
// EXTERNAL MODULE: ./src/sdk/rendering/CacheRenderInstancedModel.ts
var CacheRenderInstancedModel = __webpack_require__(6956);
// EXTERNAL MODULE: ./src/sdk/rendering/utils/payloadUtils.ts + 1 modules
var payloadUtils = __webpack_require__(4993);
// EXTERNAL MODULE: ./src/sdk/rendering/utils/colors.ts
var utils_colors = __webpack_require__(8048);
;// CONCATENATED MODULE: ./src/sdk/rendering/CacheRenderSceneModel.ts
var CacheRenderSceneModel_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CacheRenderSceneModel_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var CacheRenderSceneModel = /** @class */ (function () {
    function CacheRenderSceneModel(sceneId, options) {
        if (options === void 0) { options = {}; }
        this.sceneId = sceneId;
        this.options = options;
        this.ready = null;
        this.root = new external_three_.Group();
        this.worldPosition = new external_three_.Vector3();
        this.destroyed = false;
    }
    CacheRenderSceneModel.prototype.ensureLoaded = function () {
        return CacheRenderSceneModel_awaiter(this, void 0, void 0, function () {
            var _this = this;
            return CacheRenderSceneModel_generator(this, function (_a) {
                if (this.ready)
                    return [2 /*return*/, this.ready];
                this.ready = (function () { return CacheRenderSceneModel_awaiter(_this, void 0, void 0, function () {
                    var bundle, recipe, _loop_1, _i, _a, _b, kind, assetId;
                    var _this = this;
                    var _c, _d;
                    return CacheRenderSceneModel_generator(this, function (_e) {
                        switch (_e.label) {
                            case 0: return [4 /*yield*/, CacheRenderBundle/* CacheRender */.j9.bundle()];
                            case 1:
                                bundle = _e.sent();
                                recipe = (_c = bundle.manifest.scenes) === null || _c === void 0 ? void 0 : _c[this.sceneId];
                                if (!recipe)
                                    throw new Error("Bundle has no static scene recipe for ".concat(this.sceneId));
                                _loop_1 = function (kind, assetId) {
                                    var chunks, material;
                                    return CacheRenderSceneModel_generator(this, function (_f) {
                                        switch (_f.label) {
                                            case 0:
                                                if (!assetId)
                                                    return [2 /*return*/, "continue"];
                                                return [4 /*yield*/, (0,payloadUtils/* cachedPayload */.Bv)(bundle, assetId)];
                                            case 1:
                                                chunks = (_d = (_f.sent()).chunks) !== null && _d !== void 0 ? _d : [];
                                                if (!chunks.length)
                                                    throw new Error("Compiled scene asset ".concat(assetId, " has no chunks"));
                                                material = new external_three_.MeshBasicMaterial({
                                                    color: 0xffffff,
                                                    vertexColors: true,
                                                    transparent: kind === "transparent",
                                                    alphaTest: 0.01,
                                                });
                                                chunks.forEach(function (chunk) {
                                                    var geometry = new external_three_.BufferGeometry();
                                                    geometry.setAttribute("position", new external_three_.Float32BufferAttribute(chunk.positions, 3));
                                                    // The Kotlin scene exporter writes its terrain palette bytes directly
                                                    // into glTF vertex colours. Retain that convention so compiled terrain
                                                    // matches the static arena GLBs.
                                                    var alphas = chunk.alphas.map(utils_colors/* normalizeCacheAlpha */.Ai);
                                                    var colors = (0,utils_colors/* cacheColorsToRgba */.E2)(chunk.colors, alphas);
                                                    geometry.setAttribute("color", new external_three_.Float32BufferAttribute(colors, 4));
                                                    geometry.setIndex(chunk.indices);
                                                    geometry.computeVertexNormals();
                                                    _this.root.add(new external_three_.Mesh(geometry, material));
                                                });
                                                return [2 /*return*/];
                                        }
                                    });
                                };
                                _i = 0, _a = Object.entries(recipe.compiledAssets);
                                _e.label = 2;
                            case 2:
                                if (!(_i < _a.length)) return [3 /*break*/, 5];
                                _b = _a[_i], kind = _b[0], assetId = _b[1];
                                return [5 /*yield**/, _loop_1(kind, assetId)];
                            case 3:
                                _e.sent();
                                _e.label = 4;
                            case 4:
                                _i++;
                                return [3 /*break*/, 2];
                            case 5: return [2 /*return*/];
                        }
                    });
                }); })();
                return [2 /*return*/, this.ready];
            });
        });
    };
    CacheRenderSceneModel.prototype.draw = function (scene, _clockDelta, _tickPercent, location, _angleRadians, _pitchRadians, visible, _modelOffsets) {
        var _this = this;
        this.ensureLoaded().then(function () { var _a, _b, _c, _d, _e; if (_this.destroyed)
            return; if (_this.root.parent !== scene)
            scene.add(_this.root); _this.root.position.set(location.x + .5 + ((_b = (_a = _this.options.originOffset) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : 0), location.z - .49 + ((_c = _this.options.elevation) !== null && _c !== void 0 ? _c : 0), location.y - .5 + ((_e = (_d = _this.options.originOffset) === null || _d === void 0 ? void 0 : _d.y) !== null && _e !== void 0 ? _e : 0)); _this.root.visible = visible; _this.worldPosition.set(location.x, location.z, location.y); }).catch(function (error) { return console.error("[osrs-sdk] Compiled cache scene failed", error); });
    };
    CacheRenderSceneModel.prototype.destroy = function (scene) { this.destroyed = true; scene.remove(this.root); this.root.traverse(function (object) { if (object.isMesh) {
        object.geometry.dispose();
        object.material.dispose();
    } }); };
    CacheRenderSceneModel.prototype.getWorldPosition = function () { return this.worldPosition; };
    CacheRenderSceneModel.prototype.preload = function () {
        return CacheRenderSceneModel_awaiter(this, void 0, void 0, function () { return CacheRenderSceneModel_generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.ensureLoaded()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        }); });
    };
    return CacheRenderSceneModel;
}());


;// CONCATENATED MODULE: ./src/sdk/rendering/PointingModel.ts
var PointingModel_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var PointingModel_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var PointingModel = /** @class */ (function () {
    function PointingModel(size, height, color, unit, drawOffset) {
        if (drawOffset === void 0) { drawOffset = {}; }
        this.size = size;
        this.drawOffset = drawOffset;
        this.geometry = new external_three_.BoxGeometry(size * 0.6, height, size * 0.6);
        this.material = new external_three_.MeshStandardMaterial({ color: color });
        this.mainMesh = new external_three_.Mesh(this.geometry, this.material);
        this.mainMesh.userData.clickable = unit !== null && unit.selectable;
        this.mainMesh.userData.unit = unit;
        // west is 0 degrees
        this.arrowHelper = new external_three_.ArrowHelper(new external_three_.Vector3(1, 0, 0), new external_three_.Vector3(0, 0, 0), 1, color);
        this.mainMesh.add(this.arrowHelper);
    }
    PointingModel.forRenderable = function (r) {
        return new PointingModel(r.size, r.height, r.colorHex, r);
    };
    PointingModel.prototype.draw = function (scene, clockDelta, tickPercent, location, rotation, pitch, visible, modelOffsets) {
        if (this.mainMesh.parent !== scene) {
            scene.add(this.mainMesh);
        }
        var size = this.size;
        var x = location.x, y = location.y, z = location.z;
        this.mainMesh.visible = visible;
        // conversion from Location3 to Vector3
        // lerp because we only move the perceived location in client ticks
        var targetPosition = new external_three_.Vector3(x + size / 2, z, y - size / 2).add({
            x: this.drawOffset.x || 0,
            y: this.drawOffset.y || 0,
            z: this.drawOffset.z || 0,
        });
        this.mainMesh.position.lerp(targetPosition, 0.25);
        this.mainMesh.setRotationFromAxisAngle(new external_three_.Vector3(0, 1, 0), rotation);
    };
    PointingModel.prototype.destroy = function (scene) {
        if (this.mainMesh.parent === scene) {
            scene.remove(this.mainMesh);
        }
    };
    PointingModel.prototype.getWorldPosition = function () {
        return this.mainMesh.getWorldPosition(new external_three_.Vector3());
    };
    PointingModel.prototype.preload = function () {
        return PointingModel_awaiter(this, void 0, void 0, function () {
            return PointingModel_generator(this, function (_a) {
                // do nothing
                return [2 /*return*/];
            });
        });
    };
    return PointingModel;
}());


// EXTERNAL MODULE: ./src/sdk/rendering/TileMarkerModel.ts
var TileMarkerModel = __webpack_require__(2175);
;// CONCATENATED MODULE: ./src/sdk/rendering/index.ts
// generated using Generate Index https://marketplace.visualstudio.com/items?itemName=JayFong.generate-index
// @index('./**/*.ts', f => `export * from '${f.path}';`)
















;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/middle.png
const middle_namespaceObject = __webpack_require__.p + "f4bae3f3a31886955b3f.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/middle_selected.png
const middle_selected_namespaceObject = __webpack_require__.p + "90e236ace7951ad7f131.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/edge_top.png
const edge_top_namespaceObject = __webpack_require__.p + "7551516dbf5a2d978de6.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/edge_top_selected.png
const edge_top_selected_namespaceObject = __webpack_require__.p + "4cbe67749cd49f068bf2.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/edge_bottom.png
const edge_bottom_namespaceObject = __webpack_require__.p + "d74971fb207ce67c38e3.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/edge_bottom_selected.png
const edge_bottom_selected_namespaceObject = __webpack_require__.p + "7acb6fca27f2d5ada747.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/edge_left.png
const edge_left_namespaceObject = __webpack_require__.p + "bed0a253cdb27ab99777.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/edge_left_selected.png
const edge_left_selected_namespaceObject = __webpack_require__.p + "fd67923ee5135e1de8b8.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/edge_right.png
const edge_right_namespaceObject = __webpack_require__.p + "eaf604782cb25243e343.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/edge_right_selected.png
const edge_right_selected_namespaceObject = __webpack_require__.p + "7f8eec3cdc96fe79524b.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/corner_top_left.png
const corner_top_left_namespaceObject = __webpack_require__.p + "1bc32122f831a7ca858c.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/corner_top_left_selected.png
const corner_top_left_selected_namespaceObject = __webpack_require__.p + "96e1ce8b259934208593.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/corner_top_right.png
const corner_top_right_namespaceObject = __webpack_require__.p + "d24eeda26ceeebd65be3.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/corner_top_right_selected.png
const corner_top_right_selected_namespaceObject = __webpack_require__.p + "3b0eb1727174456088a1.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/corner_bottom_left.png
const corner_bottom_left_namespaceObject = __webpack_require__.p + "b3260d85191faaa1c854.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/corner_bottom_left_selected.png
const corner_bottom_left_selected_namespaceObject = __webpack_require__.p + "9df5e9e95eb9a2ad8606.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/corner_bottom_right.png
const corner_bottom_right_namespaceObject = __webpack_require__.p + "b818485267abf545b225.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/button/corner_bottom_right_selected.png
const corner_bottom_right_selected_namespaceObject = __webpack_require__.p + "174e6493349e8d144436.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/dialog/background.png
const background_namespaceObject = __webpack_require__.p + "847e9c0ae13786ba8ee6.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/dialog/bottom_line_mode_side_panel_corner_top_left.png
const bottom_line_mode_side_panel_corner_top_left_namespaceObject = __webpack_require__.p + "c16f5af93dcfca2466ac.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/dialog/bottom_line_mode_side_panel_corner_top_right.png
const bottom_line_mode_side_panel_corner_top_right_namespaceObject = __webpack_require__.p + "13632937038135b892db.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/dialog/bottom_line_mode_side_panel_corner_bottom_left.png
const bottom_line_mode_side_panel_corner_bottom_left_namespaceObject = __webpack_require__.p + "8cf7196a9acf33591fe1.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/dialog/bottom_line_mode_side_panel_corner_bottom_right.png
const bottom_line_mode_side_panel_corner_bottom_right_namespaceObject = __webpack_require__.p + "0933ae6193327b724f3b.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/dialog/bottom_line_mode_side_panel_edge_top.png
const bottom_line_mode_side_panel_edge_top_namespaceObject = __webpack_require__.p + "fe6ea19af53f2271ef1c.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/dialog/bottom_line_mode_side_panel_edge_bottom.png
const bottom_line_mode_side_panel_edge_bottom_namespaceObject = __webpack_require__.p + "933088a17c73941bd0f2.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/dialog/bottom_line_mode_side_panel_edge_left.png
const bottom_line_mode_side_panel_edge_left_namespaceObject = __webpack_require__.p + "a06dd2ff20b13871db5c.png";
;// CONCATENATED MODULE: ./src/assets/images/interface/resource-pack/dialog/bottom_line_mode_side_panel_edge_right.png
const bottom_line_mode_side_panel_edge_right_namespaceObject = __webpack_require__.p + "36db3caeacdfe6f2ab27.png";
;// CONCATENATED MODULE: ./src/assets/InterfaceAssets.ts



























var INTERFACE_ASSETS = {
    button: {
        normal: {
            middle: middle_namespaceObject, top: edge_top_namespaceObject, bottom: edge_bottom_namespaceObject,
            left: edge_left_namespaceObject, right: edge_right_namespaceObject,
            topLeft: corner_top_left_namespaceObject, topRight: corner_top_right_namespaceObject,
            bottomLeft: corner_bottom_left_namespaceObject, bottomRight: corner_bottom_right_namespaceObject,
        },
        selected: {
            middle: middle_selected_namespaceObject, top: edge_top_selected_namespaceObject, bottom: edge_bottom_selected_namespaceObject,
            left: edge_left_selected_namespaceObject, right: edge_right_selected_namespaceObject,
            topLeft: corner_top_left_selected_namespaceObject, topRight: corner_top_right_selected_namespaceObject,
            bottomLeft: corner_bottom_left_selected_namespaceObject, bottomRight: corner_bottom_right_selected_namespaceObject,
        },
    },
    dialog: {
        background: background_namespaceObject,
        top: bottom_line_mode_side_panel_edge_top_namespaceObject, bottom: bottom_line_mode_side_panel_edge_bottom_namespaceObject, left: bottom_line_mode_side_panel_edge_left_namespaceObject, right: bottom_line_mode_side_panel_edge_right_namespaceObject,
        topLeft: bottom_line_mode_side_panel_corner_top_left_namespaceObject, topRight: bottom_line_mode_side_panel_corner_top_right_namespaceObject,
        bottomLeft: bottom_line_mode_side_panel_corner_bottom_left_namespaceObject, bottomRight: bottom_line_mode_side_panel_corner_bottom_right_namespaceObject,
    },
};

;// CONCATENATED MODULE: ./src/index.ts





})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=main.js.map